export const bboxByCodeByDeployment = {
  nl: {
    '0214': [
      5.241921632509203, 51.87339498499149, 5.586616662930258,
      51.98594763315502,
    ],
    '0755': [
      5.626568576891281, 51.582360194471704, 5.758614667093563,
      51.62906095836148,
    ],
    '0175': [
      6.323412589236394, 52.428144524501654, 6.609643620091393,
      52.592584127574014,
    ],
    1735: [
      6.416313233062183, 52.163166308487966, 6.752959593139884,
      52.3086660187104,
    ],
    '0984': [
      5.838238544727365, 51.446557719387386, 6.141094126447129,
      51.570243516868445,
    ],
    '0873': [
      4.263732326876892, 51.35435188611156, 4.43169174290664,
      51.466800890122066,
    ],
    '0928': [
      6.000568536720309, 50.843676347690696, 6.088102386510639,
      50.90577028131039,
    ],
    1641: [
      5.807668965356885, 51.09946976985112, 5.955477588059281,
      51.21602527474536,
    ],
    '0342': [
      5.243172699989223, 52.11027146453064, 5.349925507819525,
      52.20456119775857,
    ],
    1924: [
      3.773675409461632, 51.64377788232158, 4.423549796722082,
      51.85859789459392,
    ],
    '0632': [
      4.792040368407709, 52.06494998654595, 5.00501133092293,
      52.162050777349485,
    ],
    '0627': [
      4.591089495991046, 52.0116798996594, 4.706039358368582, 52.07704971396603,
    ],
    1729: [
      5.819409637685796, 50.750367484696426, 5.983518481985121,
      50.848889405389045,
    ],
    1721: [
      5.423389877263624, 51.62668597605315, 5.600605638641616,
      51.740606801380316,
    ],
    '0534': [
      4.542282291454907, 52.27124001887879, 4.611701360872751,
      52.31839505025585,
    ],
    '0358': [
      4.670293461271338, 52.21635386526831, 4.823860490467681,
      52.30577610082595,
    ],
    '0888': [
      5.754766041396754, 50.89855495763709, 5.856929744803723,
      50.95514325512376,
    ],
    '0668': [
      5.400633290989015, 51.809535973547234, 5.609857606120027,
      51.89475336679385,
    ],
    '0944': [
      5.864468921821136, 51.717671498730155, 5.938298685873225,
      51.77862729191275,
    ],
    '0244': [
      6.000788474381065, 52.44376558337965, 6.10354600486454, 52.50960620404827,
    ],
    '0090': [
      5.870312657805836, 53.07078528183261, 6.185716766035934,
      53.159504524474805,
    ],
    '0344': [
      4.970096051947255, 52.02628198426504, 5.195155042329031,
      52.14205059836869,
    ],
    '0050': [
      5.301244569904476, 52.24952707085864, 5.623021253767905,
      52.442656258151054,
    ],
    '0355': [
      5.192752129636187, 52.058486804031844, 5.33261134247881,
      52.17125091183322,
    ],
    '0637': [
      4.415230953470687, 52.03128057436773, 4.557686425559341,
      52.093290330487235,
    ],
    '0451': [
      4.723655247014372, 52.20651642040826, 4.852187275598475,
      52.26101558242062,
    ],
    '0203': [
      5.472433377570189, 52.100482302011926, 5.811932405582697,
      52.242503063990036,
    ],
    '0297': [
      5.000363980164141, 51.737607140141336, 5.28843674693361,
      51.826851290535295,
    ],
    1884: [
      4.538147707858331, 52.15224831670421, 4.729703235351344,
      52.23384336369214,
    ],
    '0569': [
      4.681209439655733, 52.106484746654466, 4.892272689610232,
      52.2287618731964,
    ],
    '0106': [
      6.483947742810601, 52.932514826988005, 6.632646256884124,
      53.06192060192432,
    ],
    '0268': [
      5.757620635033959, 51.79058910766373, 5.908346975872266,
      51.894620924043934,
    ],
    '0098': [
      5.818108957165331, 52.80071841744546, 6.247258762593685,
      52.943013663715526,
    ],
    1960: [
      4.993854744551292, 51.80396261164345, 5.415234252898892,
      51.93548253913169,
    ],
    '0794': [
      5.570156117419671, 51.43802998492768, 5.736093702338414,
      51.50921735497299,
    ],
    '0034': [
      5.060428205379767, 52.302392175070395, 5.379211120127141,
      52.58368170116214,
    ],
    1640: [
      5.745619628854537, 51.15130385569139, 6.011014707870546,
      51.316577690339514,
    ],
    1706: [
      5.51577396516463, 51.220909401802416, 5.672110862804143,
      51.35387728216831,
    ],
    '0014': [
      6.46274568771544, 53.10619874106916, 6.77252686558787, 53.31296374309502,
    ],
    '0400': [
      4.629450718274295, 52.878626229478385, 4.925838026140233,
      53.02197818202843,
    ],
    '0448': [
      4.613000662149414, 52.94106928749547, 5.14428144539137, 53.21427480059697,
    ],
    1771: [
      5.525166899552563, 51.403136353166865, 5.656509351671874,
      51.460509014954965,
    ],
    '0664': [
      3.705536385158043, 51.47912157235094, 3.971449288211027,
      51.553417114700586,
    ],
    '0743': [
      5.693983532120045, 51.33380458505483, 5.870359647095207,
      51.440066898172084,
    ],
    1970: [
      5.702682794320213, 53.24350248769925, 6.294361198088017,
      53.49257747644532,
    ],
    '0184': [
      5.361146921448071, 52.63478080676003, 5.655379217018095,
      52.76480520877621,
    ],
    '0441': [
      4.634478643955724, 52.69140378927618, 4.850374530535386,
      52.88447262509001,
    ],
    '0362': [
      4.794545569307737, 52.24186783734697, 4.909151280682634,
      52.330569907406115,
    ],
    1891: [
      5.882244659536473, 53.2276976509319, 6.07775275403914, 53.3256304191922,
    ],
    1900: [
      5.164249079102024, 52.79595506347107, 5.788229324742015,
      53.15381403403212,
    ],
    1859: [
      6.400538930512337, 52.02060098935892, 6.760572414170953,
      52.182487841292556,
    ],
    1901: [
      4.659967798718078, 52.01324180860534, 4.873200481755069,
      52.12228737906615,
    ],
    '0828': [
      5.353514438136346, 51.7258662739761, 5.711230023589208,
      51.830750955946904,
    ],
    '0482': [
      4.626391123509044, 51.83865032614419, 4.7002397738684, 51.881212150324096,
    ],
    '0376': [
      5.203822047296329, 52.25466278607805, 5.335461511194046,
      52.30763117840567,
    ],
    1911: [
      4.758855323620145, 52.70680565690013, 5.215067021601229,
      53.04428857971112,
    ],
    '0431': [
      4.842951014445188, 52.42446134177641, 4.906469709302765,
      52.47982647741096,
    ],
    '0766': [
      4.904279284225279, 51.60709305124276, 5.004496668989576,
      51.67891799592099,
    ],
    '0547': [
      4.514691592552691, 52.13190333182122, 4.57148097690038, 52.18211625809935,
    ],
    '0074': [
      5.795507948211175, 52.9117404487515, 6.205423712023771, 53.08520791916361,
    ],
    '0505': [
      4.620403952618219, 51.71412354821405, 4.884642583979452,
      51.82335827508566,
    ],
    '0823': [
      5.191024955170428, 51.4250827875311, 5.391186965781834, 51.55282079062975,
    ],
    '0855': [
      4.947846024221746, 51.52950150794784, 5.210711452703898,
      51.641661422255794,
    ],
    '0269': [
      5.840256109631511, 52.391392945596856, 6.036944852275781,
      52.52202502557984,
    ],
    '0858': [
      5.387803704956482, 51.2622857247335, 5.52718061419862, 51.37833550989377,
    ],
    '0335': [
      4.868225108698213, 52.01001400077405, 5.018010578440935,
      52.07992033095834,
    ],
    '0093': [
      5.087068987015954, 53.21561365230381, 5.612830854556972,
      53.471584867976695,
    ],
    '0603': [
      4.290951755393736, 52.01277857025051, 4.35785338672339, 52.06180589283972,
    ],
    '0373': [
      4.594074494213869, 52.57369992840822, 4.752464759847014,
      52.75832885186332,
    ],
    '0059': [
      6.019789039587869, 53.14499340987926, 6.235100749244866,
      53.27003653182018,
    ],
    '0397': [
      4.590186182269623, 52.322204580487615, 4.641033733392852,
      52.363404858000116,
    ],
    1783: [
      4.110164141122343, 51.94138345806375, 4.309819327990657,
      52.061450716626766,
    ],
    '0085': [
      6.084847768519509, 52.90635607504152, 6.427614782917278,
      53.07527938970196,
    ],
    1883: [
      5.758002406576181, 50.9463983266985, 5.905517501038557, 51.07260985626141,
    ],
    '0060': [
      5.552855867628431, 53.31874308138936, 6.004928577355714,
      53.493948571967294,
    ],
    '0353': [
      4.978379188350332, 51.99123307695884, 5.077717623845952,
      52.06114287182499,
    ],
    '0622': [
      4.267571277507173, 51.894039902511395, 4.370622752164108,
      51.95150651792259,
    ],
    '0279': [
      5.459242996537713, 52.06961949167626, 5.539160255972826,
      52.11109726470586,
    ],
    '0375': [
      4.566312401127053, 52.45552040941977, 4.707982431709252,
      52.502035789229154,
    ],
    1876: [
      6.110812909642047, 51.967978820116116, 6.475772945827903,
      52.13771236574425,
    ],
    1731: [
      6.359556815679701, 52.73568986953095, 6.72862877684065, 53.0054052910877,
    ],
    '0406': [
      5.184702895182412, 52.267115090371384, 5.305455336624934,
      52.32576153468134,
    ],
    '0450': [
      4.690494383790232, 52.494953914593694, 4.782476523739211,
      52.55164250776378,
    ],
    '0590': [
      4.669159393773224, 51.82039426969987, 4.743514427404717,
      51.849093261215195,
    ],
    '0331': [
      4.834101755631296, 51.938030674196085, 5.062638187262243,
      52.02562706838113,
    ],
    '0173': [
      6.859781459090129, 52.28216814530556, 6.950389339096426,
      52.333460198982195,
    ],
    1719: [
      4.645136655551981, 51.628862558864654, 4.853126241787854,
      51.766568300834344,
    ],
    '0986': [
      5.861490745886198, 50.83965974154972, 5.969362418257518,
      50.90484428082313,
    ],
    '0610': [
      4.729638741852925, 51.815132610190894, 4.811415903788252,
      51.84664321899951,
    ],
    '0981': [
      5.920541177921329, 50.75275997205964, 6.027930913623473,
      50.80344034258658,
    ],
    '0758': [
      4.657981333497149, 51.485548201543224, 4.871684575951648,
      51.643198033575665,
    ],
    1916: [
      4.335213257567182, 52.05625439073444, 4.493018140943937,
      52.128979892944194,
    ],
    '0498': [
      5.091752371099029, 52.60393719600457, 5.262266083155086,
      52.70745180490155,
    ],
    '0285': [
      6.024800666255589, 52.14393807759705, 6.194369806439372,
      52.33090729068294,
    ],
    '0553': [
      4.51352302870825, 52.22220541828157, 4.57274910107545, 52.28664415888423,
    ],
    '0437': [
      4.870121334892399, 52.25074263481034, 4.955240593948781,
      52.33863824917663,
    ],
    1773: [
      6.066083366051185, 52.297627143782655, 6.23584260256108,
      52.453541037159845,
    ],
    1742: [
      6.326529933093632, 52.24214646949193, 6.554008726618212,
      52.326462251499365,
    ],
    '0363': [
      4.728758927718665, 52.277976609132836, 5.107693332999837,
      52.43106382971274,
    ],
    1978: [
      4.619248914180282, 51.831993665553185, 5.02751214704374,
      51.950927943088836,
    ],
    1676: [
      3.678928025508114, 51.59367070546305, 4.202700681186946,
      51.78152048213048,
    ],
    '0189': [
      6.46818956817129, 52.26911618143151, 6.631782412302973, 52.41751350515812,
    ],
    '0415': [
      4.893034894952897, 52.411607583489776, 4.950879454216625,
      52.49043447942631,
    ],
    '0289': [
      5.605823943327533, 51.93640548782033, 5.724362688515328,
      52.00070833149014,
    ],
    1723: [
      4.746995214628549, 51.45679034047225, 5.01667254977776, 51.55726955342276,
    ],
    '0339': [
      5.495554639171221, 52.03946881358384, 5.562746268480129,
      52.10541954408825,
    ],
    '0263': [
      5.173672434051097, 51.73358070475124, 5.416223003362996,
      51.83765876971913,
    ],
    1959: [
      4.676304294289294, 51.71081337202074, 5.142713891041348,
      51.82852918866178,
    ],
    '0453': [
      4.517549812271866, 52.41082018810661, 4.721983160290254,
      52.49274412073021,
    ],
    '0626': [
      4.401159131584874, 52.10147024233987, 4.469299924455105,
      52.14988053838646,
    ],
    '0171': [
      5.37725983726796, 52.60733122988141, 6.01730144117532, 52.84398224871387,
    ],
    '0880': [
      4.788692885933956, 52.46844416395826, 4.934724281962839,
      52.542689310525226,
    ],
    '0502': [
      4.537160429127884, 51.90620455476207, 4.619488693566413,
      51.96550383926284,
    ],
    '0718': [
      3.307952615747958, 51.37297676509772, 3.738035002900756,
      51.616407748183846,
    ],
    '0785': [
      4.962572820037418, 51.471108145014604, 5.110645407964211,
      51.540132861589846,
    ],
    1728: [
      5.183203569179373, 51.30566500564133, 5.313650171889307,
      51.43650053921047,
    ],
    1674: [
      4.306808968433563, 51.45148725644688, 4.523191632503747,
      51.56923481776432,
    ],
    1659: [
      5.533083128499178, 51.49488315887237, 5.686005090961348,
      51.569678521220325,
    ],
    '0168': [
      6.934325004760237, 52.22073699295295, 7.072763362145606,
      52.379859561847404,
    ],
    1734: [
      5.646322779974434, 51.87026538375353, 5.89803445407971, 51.97364867168397,
    ],
    '0599': [
      3.940749587511343, 51.842118251864534, 4.601808332774063,
      52.00452762371312,
    ],
    1966: [
      6.16743182005068, 53.24944790563233, 6.911786068857161, 53.57642328662697,
    ],
    1740: [
      5.453376569561035, 51.88900894724572, 5.711021610811946,
      51.95400932829523,
    ],
    '0642': [
      4.55360876984192, 51.80075997625398, 4.671708759810248, 51.84711677218853,
    ],
    1942: [
      5.012793922476526, 52.25579580126568, 5.230356735346321, 52.3886541190811,
    ],
    '0351': [
      5.298300783418982, 52.04312322315015, 5.497876037282433,
      52.11742618169183,
    ],
    '0147': [
      6.68948139232064, 52.28311348606065, 6.802135686052262,
      52.341207542794905,
    ],
    '0037': [
      6.861287523113604, 52.919037023685014, 7.10007727249069,
      53.07370171259116,
    ],
    '0784': [
      4.82908473721916, 51.510081280253466, 4.979565221961288,
      51.61629452579618,
    ],
    '0772': [
      5.3567185242749, 51.40004748297475, 5.54885288585735, 51.49707786464661,
    ],
    '0361': [
      4.708275756623361, 52.51916417633149, 4.926925536600978,
      52.68247524934715,
    ],
    '0965': [
      5.953252863144456, 50.80146244532134, 6.02502898229189, 50.86022771146569,
    ],
    1714: [
      3.358378253017131, 51.24149250769966, 3.712408774908541,
      51.40906915197771,
    ],
    1652: [
      5.651357330310808, 51.484083847839436, 5.852573783724697,
      51.598208375142214,
    ],
    1681: [
      6.724175268566277, 52.80463395654916, 7.045571091287635,
      52.99335255802957,
    ],
    '0995': [
      5.074623647521978, 52.384377413625, 5.605870635597377, 52.692844719419014,
    ],
    '0798': [
      5.048791851493401, 51.42824021445042, 5.251249881242237,
      51.54591897100702,
    ],
    1598: [
      4.862700408236497, 52.59528534632943, 5.039042968376112,
      52.699911790827336,
    ],
    '0779': [
      4.823610483103352, 51.67183545801144, 4.933169494260575,
      51.72014879074293,
    ],
    '0946': [
      5.643996789033944, 51.236924737273576, 5.87782345246325,
      51.346877060292606,
    ],
    1700: [
      6.447450143417721, 52.38362776960811, 6.717706766424709,
      52.49498074113591,
    ],
    '0232': [
      5.840830999319374, 52.25580705757677, 6.094857509991708,
      52.398437125105936,
    ],
    '0503': [
      4.320217809554831, 51.96631631205433, 4.407910943703032,
      52.032598806563264,
    ],
    1940: [
      5.33784168825177, 52.76480520877742, 5.937846998348294, 53.05883927519368,
    ],
    1655: [
      4.426674870510342, 51.54923749041279, 4.613891694164928,
      51.630406725750284,
    ],
    '0233': [
      5.545167949288571, 52.23932509784331, 5.761448750209692,
      52.332389085143355,
    ],
    '0907': [
      5.919469627269011, 51.643783110859076, 6.044939227493752,
      51.74802415871573,
    ],
    '0385': [
      4.949346047324048, 52.48456840436201, 5.112987840276817,
      52.61260604775818,
    ],
    1711: [
      5.795107146952613, 51.02833835904624, 6.036490743294993,
      51.13596212837258,
    ],
    '0606': [
      4.350671426005881, 51.896678711329066, 4.41771299465607,
      51.96340662438565,
    ],
    1955: [
      6.089514517466707, 51.867626205725664, 6.332279253119382,
      51.98051869907856,
    ],
    '0202': [
      5.802960636168883, 51.93346419832774, 5.990340117891819,
      52.077890532551216,
    ],
    '0394': [
      4.550455159443354, 52.21446840512267, 4.819158766091426,
      52.43333617014941,
    ],
    1948: [
      5.3709475786462, 51.52129623672465, 5.656555892250174, 51.65570260569092,
    ],
    '0687': [
      3.575296361903173, 51.46813936882897, 3.746943542428353,
      51.53530334522415,
    ],
    '0629': [
      4.290063252478363, 52.09477259283313, 4.443939377899825,
      52.19267739465258,
    ],
    '0225': [
      5.530981412961546, 51.836273844909705, 5.685013858385873,
      51.901803557683365,
    ],
    1669: [
      5.913748679264518, 51.09653142679457, 6.180724338525611,
      51.194414116891856,
    ],
    '0313': [
      5.310456423615208, 52.205527709064775, 5.40464338601561,
      52.28773172540302,
    ],
    '0994': [
      5.74928688173454, 50.82954880103368, 5.888009369851117,
      50.892208862545765,
    ],
    '0119': [
      6.120063733014733, 52.667987750695275, 6.286700237232867,
      52.77305426389119,
    ],
    '0770': [
      5.237597814514564, 51.31823745615023, 5.388907108345012,
      51.468536682869775,
    ],
    '0479': [
      4.674848086878976, 52.41666216918941, 4.862805083980295,
      52.521253640335836,
    ],
    '0294': [
      6.629071355769335, 51.896063339984764, 6.832801702827627,
      52.04006471355439,
    ],
    '0716': [
      3.924760580816975, 51.47955528093906, 4.242786270634194,
      51.66076431007441,
    ],
    '0252': [
      5.72974545338, 51.752100593849875, 5.893409337849443, 51.81009627391707,
    ],
    '0537': [
      4.360001838886606, 52.15565298291022, 4.466519686324997,
      52.22524368777871,
    ],
    '0847': [
      5.637854936441779, 51.31509400880806, 5.770448694285646, 51.457809890611,
    ],
    '0777': [
      4.59042061148065, 51.51720523498649, 4.694634105403334, 51.63475471313392,
    ],
    '0882': [
      5.990627228815014, 50.87021987179451, 6.094183956580347,
      50.93470139002052,
    ],
    '0484': [
      4.530103588630906, 52.05856937815117, 4.760076038337779,
      52.16750422722324,
    ],
    '0677': [
      3.924362392690125, 51.24111343716654, 4.23680534271233, 51.42201009697278,
    ],
    1903: [
      5.681970532175464, 50.75476499942106, 5.864135614610983,
      50.85529058339248,
    ],
    '0420': [
      4.971888209103066, 52.66440296768956, 5.281178970032589,
      52.91610234792677,
    ],
    '0321': [
      5.119563282174026, 51.959432482636345, 5.271446670871295,
      52.05675729620611,
    ],
    '0158': [
      6.624347427182716, 52.118069494785125, 6.889750344425829,
      52.20633143849096,
    ],
    '0262': [
      6.156078785918185, 52.09690799222475, 6.494372909249996,
      52.24611281119967,
    ],
    '0163': [
      6.333501944084968, 52.31821879906749, 6.59814765881895,
      52.461702471047545,
    ],
    '0748': [
      4.218747777113867, 51.43966697641496, 4.372798230826633,
      51.57066126133408,
    ],
    '0345': [
      5.51259224832678, 51.996958357192376, 5.590242176106738,
      52.04937330777093,
    ],
    '0845': [
      5.303797296557159, 51.600223876281774, 5.456872804658362,
      51.701500359272494,
    ],
    '0957': [
      5.916652599933734, 51.15875268967128, 6.086024933496248,
      51.258682991134314,
    ],
    1945: [
      5.879067265669811, 51.74102861120208, 6.063485648039433,
      51.88167200649899,
    ],
    1895: [
      6.903300156581589, 53.11083107379944, 7.227498451308611,
      53.333206418417056,
    ],
    '0579': [
      4.43494689964979, 52.16205195579929, 4.497592295484023, 52.20479892537132,
    ],
    '0744': [
      4.766569763011827, 51.39368697722859, 5.010996429679869,
      51.480929565294915,
    ],
    '0086': [
      5.927580593189923, 52.964363648722276, 6.332055391037408,
      53.12921346052374,
    ],
    '0542': [
      4.549238504076758, 51.90236749285934, 4.643019176800682,
      51.931050139662275,
    ],
    1774: [
      6.759035434369261, 52.272961765449445, 7.072204791916251,
      52.469766803342615,
    ],
    '0396': [
      4.571494511035275, 52.486332287005254, 4.720367158289169,
      52.533892071283745,
    ],
    1699: [
      6.30527383325499, 52.98552293800819, 6.540087016677345, 53.20383229261856,
    ],
    '0080': [
      5.63199320162004, 53.0458492347725, 5.949656660799151, 53.29472100732801,
    ],
    1894: [
      5.832075736910754, 51.26575905315706, 6.123254036724471,
      51.39572924087911,
    ],
    '0879': [
      4.52989653524391, 51.422014440799614, 4.744059817234981, 51.5497985377748,
    ],
    '0820': [
      5.505408806211745, 51.433911708417874, 5.605231780302415,
      51.53807588125627,
    ],
    '0762': [
      5.717186518243577, 51.35253496269487, 5.931287598178677,
      51.504144422511146,
    ],
    '0717': [
      3.432062335101896, 51.46224613781476, 3.748885449885481,
      51.650363341318766,
    ],
    '0150': [
      6.101320455781913, 52.217438308096966, 6.38191182490453,
      52.32112186010022,
    ],
    '0356': [
      5.062511547730813, 51.997451831552475, 5.130993349703093,
      52.06225556576857,
    ],
    '0096': [
      4.818375780076682, 53.087105152861284, 5.163222116559472,
      53.3230724925706,
    ],
    '0796': [
      5.206494262573893, 51.66399663874801, 5.499656145647512,
      51.76503027678013,
    ],
    '0826': [
      4.781071393316704, 51.578441897522, 4.934410376342724, 51.68601744985851,
    ],
    '0275': [
      5.951526399963452, 51.974406093522774, 6.137469310302331,
      52.08824704664859,
    ],
    '0281': [
      5.328030053213329, 51.851801018930175, 5.472451111172915,
      51.92276135857841,
    ],
    1581: [
      5.246989895449137, 51.97073019689493, 5.529381339283105,
      52.08656772257152,
    ],
    '0848': [
      5.423796291707433, 51.49392721278024, 5.546272863235086,
      51.54184836786849,
    ],
    '0737': [
      5.829642814910275, 53.12160799623197, 6.114593490770592,
      53.28864912739545,
    ],
    '0243': [
      5.565863666279405, 52.30153805870257, 5.712847690325963,
      52.37884126280062,
    ],
    '0518': [
      4.184998485109444, 52.01484843040601, 4.42248972121535, 52.13503621990332,
    ],
    '0166': [
      5.777750068127078, 52.47405758246343, 6.033037613881902,
      52.628302263205484,
    ],
    '0613': [
      4.383228782049525, 51.83164541946252, 4.492227226769404,
      51.87319820258595,
    ],
    '0160': [
      6.303063762773827, 52.46560325528851, 6.766693989378059,
      52.674049280336334,
    ],
    1954: [
      5.796557055180865, 50.880639450457, 6.026894542816303, 50.988416992081845,
    ],
    '0861': [
      5.315808116574273, 51.37646009935872, 5.429856256356882,
      51.438908793212796,
    ],
    1507: [
      5.87496597491246, 51.37804988701061, 6.178979718008928, 51.52477734429113,
    ],
    '0402': [
      5.102013382549322, 52.17768072240244, 5.218960393739485, 52.2855451867081,
    ],
    '0340': [
      5.477664574427498, 51.94312478509547, 5.627314537224701,
      52.018516097977205,
    ],
    '0384': [
      4.942693623161102, 52.31397885185522, 5.039969224626953,
      52.35610168000842,
    ],
    '0299': [
      5.987062649549568, 51.840721642057574, 6.167913122977045,
      52.015024452616814,
    ],
    '0277': [
      5.937098935272583, 51.99963780833093, 6.008992659651403,
      52.079164181265114,
    ],
    '0327': [
      5.310919873708932, 52.08933353432964, 5.514079464360291,
      52.16152009163653,
    ],
    1952: [
      6.639468142904809, 53.07097159579394, 6.965855434809987,
      53.29835233166226,
    ],
    1930: [
      4.185272594218937, 51.78277160841863, 4.432482404599629,
      51.872985907570964,
    ],
    1621: [
      4.424221593187225, 51.960286283288, 4.565201504261666, 52.06174116160723,
    ],
    '0307': [
      5.306458708383394, 52.10838438823703, 5.484329737863708,
      52.21915384988352,
    ],
    '0317': [
      5.222901318114247, 52.21927339981917, 5.339563659264061,
      52.29021841661105,
    ],
    1509: [
      6.289653177812857, 51.827262655286034, 6.532829065195942,
      51.97821891255573,
    ],
    '0417': [
      5.188852928951467, 52.21212871590352, 5.245093194539189,
      52.27290887445002,
    ],
    1842: [
      4.233583288017998, 51.92123631685221, 4.40303800365673,
      52.019921679947764,
    ],
    '0273': [
      5.47419209304096, 52.20233624234903, 5.683642169917135, 52.29330274760944,
    ],
    1695: [
      3.630163725370023, 51.52235216329528, 3.960959024734861,
      51.60786084939039,
    ],
    '0867': [
      4.917991224893485, 51.65153188120801, 5.111506201798753,
      51.723061889684985,
    ],
    1708: [
      5.795177104753999, 52.641363281102954, 6.201730816111653,
      52.85421495197516,
    ],
    '0589': [
      4.798700277785325, 51.98614301935237, 4.926687768165583,
      52.06344633219606,
    ],
    1961: [
      4.926301362332156, 51.85736068241161, 5.18022672890933,
      52.003035128049696,
    ],
    '0405': [
      5.013536713721525, 52.578936134322305, 5.135305730421728,
      52.684365484616116,
    ],
    '0715': [
      3.644149067493294, 51.20016211275375, 4.005693038140833,
      51.39761638712316,
    ],
    '0197': [
      6.464335119889097, 51.853823022487546, 6.668733473314511,
      51.974368359743536,
    ],
    '0399': [
      4.670615457595683, 52.57873712329028, 4.752138689641293,
      52.62502542573883,
    ],
    '0983': [
      6.071780736455769, 51.277061016051654, 6.226769353796719,
      51.50781766979428,
    ],
    '0971': [
      5.719630351829833, 50.92792793434064, 5.789247230588055,
      51.019166503075155,
    ],
    1709: [
      4.361821659220372, 51.606743674093266, 4.709879160574562,
      51.71906732151611,
    ],
    1926: [
      4.372640497544376, 51.96819860342766, 4.476790321242193,
      52.05405389896174,
    ],
    '0938': [
      5.712476188101482, 50.86597243517493, 5.803481208739807,
      50.943411014582985,
    ],
    '0352': [
      5.242355179144443, 51.95491916978727, 5.415277338741859,
      52.027001472696504,
    ],
    '0473': [
      4.477649500525647, 52.31399659853122, 4.591659031779113,
      52.40516737111805,
    ],
    '0222': [
      6.144688414114086, 51.92278202590827, 6.416081947778329,
      51.99426071406792,
    ],
    '0575': [
      4.390975657379869, 52.20735558278994, 4.563707498587194,
      52.33251094784661,
    ],
    '0296': [
      5.597976692088266, 51.77285104782119, 5.800948743437154,
      51.867449439080474,
    ],
    '0153': [
      6.755892793147529, 52.161205923773444, 6.981100137294578,
      52.285505754457596,
    ],
    '0114': [
      6.826360854695812, 52.63270575112158, 7.092739745839745,
      52.87301203796558,
    ],
    1963: [
      4.213246911718683, 51.692473556315676, 4.631633379189113,
      51.83704614359731,
    ],
    '0308': [
      5.212075635949247, 52.165379577759545, 5.335808863469474,
      52.23282883155047,
    ],
    '0228': [
      5.546744852324758, 51.99095145763928, 5.951465820177541,
      52.15222847303791,
    ],
    '0183': [
      6.669671796182378, 52.32966535406885, 6.949224076962157,
      52.47813155812772,
    ],
    '0556': [
      4.212717758360989, 51.90533503948825, 4.292611075546862, 51.9479914992892,
    ],
    '0047': [
      6.801674028203625, 53.03240649110231, 6.961913904663716,
      53.12883974338893,
    ],
    '0141': [
      6.597704879492126, 52.28997395371698, 6.721168032380362, 52.3991227541871,
    ],
    '0523': [
      4.803378620340337, 51.816471395640605, 4.926986651733371,
      51.86073466923792,
    ],
    '0230': [
      5.75629189703148, 52.357872772175064, 5.924338687275774,
      52.473401577762765,
    ],
    '0209': [
      5.66784724697427, 51.83227185805486, 5.825695408830049, 51.89567265326552,
    ],
    '0088': [
      6.050124764465447, 53.41328882077028, 6.418680968366183,
      53.539713430497045,
    ],
    '0988': [
      5.566045382853948, 51.18042068896068, 5.79177008773055, 51.29057548541476,
    ],
    1690: [
      6.216319881524311, 52.6121955206128, 6.530555892820023, 52.79897898512264,
    ],
    1904: [
      4.909638030916239, 52.11671591981597, 5.120529021768022,
      52.28932013470982,
    ],
    '0193': [
      6.003619080515191, 52.440530733582484, 6.210810751056923,
      52.587940369099194,
    ],
    '0221': [
      6.109590612348112, 51.99556605536545, 6.177299104879929,
      52.04211280570133,
    ],
    '0489': [
      4.479871635350352, 51.82985423810511, 4.571412375498532,
      51.87402722808016,
    ],
    '0824': [
      5.130196194677288, 51.50740864633935, 5.27874359580635, 51.62492842233503,
    ],
    '0293': [
      5.949249439069859, 51.93867536699385, 6.003187955740587,
      51.980650006707855,
    ],
    1896: [
      5.971341302499298, 52.55184064159241, 6.166814320538563,
      52.667936875378025,
    ],
    '0840': [
      4.485380626978177, 51.47331258894313, 4.640110146558888,
      51.56856188692696,
    ],
    1680: [
      6.561504876843922, 52.868158827454664, 6.935684881494123,
      53.0947606762106,
    ],
    '0753': [
      5.349361901469032, 51.471756400529486, 5.447507770136998,
      51.54835326515255,
    ],
    '0703': [
      3.935351596181998, 51.34975544172578, 4.277423168802465, 51.538244240824,
    ],
    '0865': [
      5.154451962814059, 51.61253775186058, 5.321190794634189,
      51.690030805203925,
    ],
    '0383': [
      4.583320938478581, 52.52672755808313, 4.781622911071806,
      52.59258472683043,
    ],
    1949: [
      5.432116414135349, 53.124149105422035, 5.749301164857709,
      53.36795842695951,
    ],
    '0512': [
      4.921688093817346, 51.81885673805091, 5.031415074191863,
      51.863629358494094,
    ],
    '0597': [
      4.549253370796552, 51.83873007562211, 4.647330812450648,
      51.90303171802359,
    ],
    '0797': [
      5.081760315134479, 51.635360427748616, 5.251611849002784,
      51.743091743062905,
    ],
    '0638': [
      4.470825853276892, 52.080510731119666, 4.550733115545123,
      52.147397866718556,
    ],
    1931: [
      4.576328523027843, 51.88935456624005, 4.877792991018089,
      52.02227172706755,
    ],
    1586: [
      6.459186902247388, 51.962547016222295, 6.687981260831572,
      52.068040320445455,
    ],
    '0216': [
      5.142432947972022, 51.91963012036745, 5.270373677227278,
      51.97893962954027,
    ],
    '0654': [
      3.695678150007799, 51.35574550350405, 3.963208623075666,
      51.50245590168573,
    ],
    '0148': [
      6.162495534345194, 52.424440678949615, 6.384150125916356,
      52.59917108182128,
    ],
    '0392': [
      4.599515653176973, 52.33890607800995, 4.686921202532774,
      52.428569663297665,
    ],
    '0852': [
      4.946865612867377, 52.3886541190811, 5.185490079189554,
      52.497886065244764,
    ],
    '0532': [
      5.185373470852319, 52.676829321326544, 5.26896217688725,
      52.717697190602834,
    ],
    '0303': [
      5.51129422417486, 52.36412960980178, 5.864502350118688, 52.66355611129787,
    ],
    '0164': [
      6.702039219740207, 52.191064903772606, 6.852527425694122,
      52.3135860866908,
    ],
    1950: [
      7.014799354237951, 52.83819614756878, 7.217445436425489,
      53.160773684647204,
    ],
    1705: [
      5.856874323668753, 51.85444929800605, 6.046284773455486,
      51.960415662358386,
    ],
    '0213': [
      6.006084955331009, 52.05918111131649, 6.21838066375661, 52.16205944004018,
    ],
    1730: [
      6.480299627534018, 53.02577314715521, 6.77650945111941, 53.19830816222313,
    ],
    1658: [
      5.473603563328806, 51.295202501912975, 5.654707231867753,
      51.422456480880925,
    ],
    '0180': [
      6.095916733191991, 52.581246299989964, 6.32929019765224,
      52.692183330914055,
    ],
    1979: [
      6.592563466115452, 53.236952468888028, 7.13486048084138,
      53.459428266378872,
    ],
    1992: [
      3.955580378742973, 51.791113312092321, 4.239383150977878,
      51.936141607769144,
    ],
    '0809': [
      4.987262128750915, 51.6056809499144, 5.106137047054621, 51.67683469012158,
    ],
    '0899': [
      5.928470065960697, 50.926439481376015, 6.018201745132624,
      50.962529606789424,
    ],
    '0377': [
      4.526045163762028, 52.309298008420136, 4.631647661910028,
      52.43930240711496,
    ],
    1525: [
      4.455648647184423, 52.17969462971325, 4.561704786939823, 52.2550674267744,
    ],
    '0177': [
      6.144145823197065, 52.3005215213028, 6.405169579936246, 52.47438835987397,
    ],
    '0531': [
      4.600154973069484, 51.823589116157436, 4.672702443996429,
      51.86984692370121,
    ],
    '0118': [
      6.403598921109111, 52.65450732028272, 6.632412604029169,
      52.80055650479076,
    ],
    '0889': [
      6.00528546525331, 51.24256008813551, 6.124757988605956, 51.29745436937513,
    ],
    '0851': [
      4.190124167488729, 51.54372140231321, 4.443999310199302,
      51.662979058981385,
    ],
    '0513': [
      4.659454627990816, 51.99625804068981, 4.75732987712614,
      52.040119697706494,
    ],
    '0546': [
      4.438865223329895, 52.11895160964979, 4.524037748068717,
      52.184626246337736,
    ],
    1892: [
      4.546339343469277, 51.93349227519387, 4.688684552956848,
      52.06554090810235,
    ],
    '0917': [
      5.895409302751053, 50.818403166700314, 6.026379433298999,
      50.93661220990217,
    ],
    '0200': [
      5.726388941033364, 52.073338553365595, 6.078484195029166,
      52.285669414522395,
    ],
    1667: [
      5.071181770690767, 51.31031660002596, 5.204697843303088,
      51.43217424731079,
    ],
    '0388': [
      5.211337581267218, 52.67572642718134, 5.37725983726796, 52.84063143053888,
    ],
    '0432': [
      4.898669474216472, 52.67176547898516, 5.011163623905528,
      52.75529633726459,
    ],
    '0678': [
      3.907727440565531, 51.447012778475376, 4.017388188492236,
      51.5514773129369,
    ],
    '0866': [
      5.417439304583078, 51.3660131011423, 5.516417681572127, 51.40534964062136,
    ],
    '0935': [
      5.638866139452907, 50.80380526812155, 5.762924863342771,
      50.91200277246024,
    ],
    '0267': [
      5.393209787524283, 52.16576178055902, 5.634862096317884,
      52.26392405343091,
    ],
    '0736': [
      4.794419112605543, 52.161460797627505, 5.021926235449557,
      52.30367703722391,
    ],
    1724: [
      5.225972020347506, 51.261353143091135, 5.433922751905057,
      51.3839050047442,
    ],
    '0765': [
      6.905497812165789, 53.01386066981118, 7.042657912486935,
      53.119196220981195,
    ],
    '0072': [
      5.095778159318643, 53.0010036964444, 5.496393579632159, 53.25132515840416,
    ],
    1969: [
      6.175234940818549, 53.08713493118852, 6.51144249426235, 53.34138176598391,
    ],
    1696: [
      5.021293029989701, 52.16592898899302, 5.145769253292128,
      52.28521548198096,
    ],
    '0757': [
      5.246177747531141, 51.54348863206187, 5.405201380286896,
      51.634633932694285,
    ],
    '0312': [
      5.153030697409061, 51.997742062689646, 5.280153305483418,
      52.08056268615348,
    ],
    '0246': [
      5.951004878916065, 52.35651244373552, 6.13055294937323,
      52.454806446353786,
    ],
    '0226': [
      5.965775545604169, 51.91233396035801, 6.068852566128004,
      51.981859318027574,
    ],
    '0109': [
      6.576428585383126, 52.626760438809754, 6.861875294764338,
      52.878691299564494,
    ],
    1701: [
      6.119819962534502, 52.729306850061086, 6.480026205269665,
      52.92764124267174,
    ],
    '0893': [
      5.976607018682194, 51.503081655039736, 6.213361347965454,
      51.67616520221261,
    ],
    '0302': [
      5.678921660210269, 52.26714586422627, 5.880951404540972,
      52.407426492068275,
    ],
    '0274': [
      5.713608280150249, 51.9589907785659, 5.870860324363396, 52.02407058455587,
    ],
    '0310': [
      5.09488978547204, 52.084895590817176, 5.230930458122319,
      52.20427342691703,
    ],
    '0301': [
      6.14038701142097, 52.08873301169249, 6.328314448528984, 52.16980127667893,
    ],
    9000: [
      5.690858248146925, 51.632667978838136, 5.934518732587673,
      51.77503386190299,
    ],
    9001: [
      4.818375780076682, 53.087105152861284, 6.418680968366183,
      53.539713430497045,
    ],
    9002: [
      4.746995214628549, 51.39368697722859, 5.01667254977776, 51.61629452579618,
    ],
    9003: [
      5.071181770690767, 51.261353143091135, 5.433922751905057,
      51.55282079062975,
    ],
    9004: [
      5.246177747531141, 51.54348863206187, 5.456872804658362,
      51.701500359272494,
    ],
    9005: [
      5.060428205379767, 52.24952707085864, 6.01730144117532, 52.84398224871387,
    ],
    9006: [
      5.566045382853948, 50.750367484696426, 6.226769353796719,
      51.77862729191275,
    ],
    9008: [
      6.119819962534502, 52.6121955206128, 7.092739745839745, 53.20383229261856,
    ],
    9009: [
      4.993854744551292, 51.73358070475124, 6.832801702827627,
      52.52202502557984,
    ],
    9010: [
      4.477649500525647, 52.16592898899302, 5.37725983726796, 53.21427480059697,
    ],
    9011: [
      4.792040368407709, 51.85736068241161, 5.627314537224701,
      52.30367703722391,
    ],
    9012: [
      5.777750068127078, 52.118069494785125, 7.072763362145606,
      52.85421495197516,
    ],
    9013: [
      3.307952615747958, 51.20016211275375, 4.277423168802465,
      51.78152048213048,
    ],
    9014: [
      3.773675409461632, 51.64377788232158, 5.031415074191863,
      52.33251094784661,
    ],
    9015: [
      4.818375780076682, 52.76480520877742, 6.427614782917278,
      53.539713430497045,
    ],
    9016: [
      6.16743182005068, 52.83819614756878, 7.227498451308611, 53.57642328662697,
    ],
    9017: [
      4.383228782049525, 51.82985423810511, 4.647330812450648,
      51.90303171802359,
    ],
    1980: [
      4.728853884940338, 52.63267786297678, 4.899897717009308, 52.7313468818704,
    ],
    '0439': [
      4.833910451402412, 52.47034854165207, 5.024700124910907,
      52.614107526972155,
    ],
    1991: [
      5.561966469350273, 51.62249637499118, 5.750478321572682,
      51.76804588992493,
    ],
    1982: [
      5.690858248146925, 51.552030865633405, 6.048120780938219,
      51.77503386190299,
    ],
    9007: [
      4.190124167488729, 51.220909401802416, 6.048120780938219,
      51.830750955946904,
    ],
    9019: [
      3.307952615747958, 51.20016211275375, 5.031415074191863,
      52.33251094784661,
    ],
    9020: [3.50, 51.35, 4.25, 51.65],
    9021: [4.55, 51.75, 4.85, 51.90],
    9022: [4.57, 51.95, 4.83, 52.05],
    9023: [3.90, 51.90, 5.00, 52.10],
    9024: [4.40, 52.10, 4.70, 52.25]
  },
  be: {
    11001: [
      4.35246884982063, 51.1100326231339, 4.40746088866893, 51.1516130437549,
    ],
    11002: [4.217576738127646, 51.14332014346224, 4.509074910538003, 51.377639412761383],
    11004: [
      4.47864086898914, 51.1301513578633, 4.56381705801698, 51.1910383599308,
    ],
    11005: [
      4.3389630579638, 51.0811910434094, 4.40496151230473, 51.1067476434011,
    ],
    // 11007: [
    //   4.46873706352233, 51.1811073591352, 4.50776143818812, 51.2043651848585,
    // ],
    11008: [
      4.43894587668128, 51.2691705477059, 4.5574622610736, 51.3514349186066,
    ],
    11009: [
      4.53958410709811, 51.27615827815, 4.72225538580018, 51.3828608630607,
    ],
    11013: [
      4.39563215733028, 51.1452621434181, 4.4624510327586, 51.1737445237128,
    ],
    11016: [
      4.37805261953636, 51.4160156780886, 4.54688016607779, 51.4829242147564,
    ],
    11018: [
      4.32129270539654, 51.1298709040332, 4.35714634098057, 51.1623653997994,
    ],
    11021: [
      4.45684985201496, 51.1310389021832, 4.5090475133334, 51.1639475758964,
    ],
    11022: [
      4.38234992224247, 51.3530094924816, 4.53412869169902, 51.4543688300989,
    ],
    11023: [
      4.39044074466844, 51.2931650795807, 4.51766055549813, 51.3649353235183,
    ],
    11024: [
      4.39515030708608, 51.0935615121704, 4.48524355925714, 51.1503622981045,
    ],
    11025: [
      4.47091263209227, 51.1161814478875, 4.52608626233288, 51.1429067701296,
    ],
    11029: [
      4.43167702055352, 51.161614366218, 4.48276381048618, 51.1900863395792,
    ],
    11030: [
      4.30682303222955, 51.095637129313, 4.36192020600475, 51.1166534983842,
    ],
    11035: [
      4.52880282240208, 51.1488972403542, 4.64265788175803, 51.2366459130661,
    ],
    11037: [
      4.35809958848893, 51.0720864172797, 4.46944634603281, 51.1195337435579,
    ],
    11038: [
      4.30556302858959, 51.1132560134906, 4.37535754226892, 51.1352542187587,
    ],
    11039: [
      4.52809571964061, 51.2202979231293, 4.631861619688, 51.296190238835,
    ],
    11040: [
      4.45401256168763, 51.235792662523, 4.55168599073565, 51.3046545821513,
    ],
    11044: [
      4.32489281111806, 51.2977240620519, 4.41588101117302, 51.357212762384,
    ],
    11050: [
      4.47997414286172, 51.2163564348629, 4.55181421996278, 51.2428382472099,
    ],
    11052: [
      4.48102407250687, 51.1871972818202, 4.56101188897457, 51.2234924611375,
    ],
    11053: [
      4.50537591240164, 51.338069506343, 4.71568700494583, 51.4333770557024,
    ],
    11054: [
      4.62116282872495, 51.1758315027112, 4.74129188780467, 51.2491048231809,
    ],
    11055: [
      4.60640729352439, 51.2194449884779, 4.74206525369228, 51.294402810673,
    ],
    // 11056: [
    //   4.28882896137824, 51.1860690445582, 4.35602701898333, 51.2629054165971,
    // ],
    11057: [
      4.63274546185146, 51.2429844656259, 4.7753036270599, 51.3273727475159,
    ],
    12002: [
      4.60378517977478, 51.0757456015967, 4.69921075593432, 51.1357460155109,
    ],
    12005: [
      4.50153865852963, 50.9906957332741, 4.6335161958106, 51.0474414243765,
    ],
    12007: [
      4.17110998149775, 51.0582673991881, 4.32654026622162, 51.1253318942552,
    ],
    12009: [
      4.4634925477321, 51.0730824918363, 4.57392415549081, 51.1174385404978,
    ],
    12014: [
      4.657747987276, 50.9991495608406, 4.81694893322519, 51.127783359939,
    ],
    12021: [
      4.50460532568859, 51.0732528571162, 4.64162604722979, 51.166274554564,
    ],
    12025: [
      4.36883012917561, 50.9915105938279, 4.54777122116593, 51.0791795458583,
    ],
    12026: [
      4.595958780302, 51.1229877595953, 4.71899705991139, 51.1816814266281,
    ],
    12029: [
      4.56224290283383, 51.0177439900307, 4.68799748229211, 51.0874384906391,
    ],
    12035: [
      4.46144792945709, 51.03517936311, 4.60759847689477, 51.0903302420774,
    ],
    12040: [
      4.32157942998346, 51.0169276401471, 4.4242153531907, 51.0849506285524,
    ],
    12041: [
      4.18572606154185, 51.027227351029, 4.35899523111476, 51.1021207062288,
    ],
    13001: [
      5.0281744556742, 51.2917886358688, 5.13911593332292, 51.3940190220309,
    ],
    13002: [
      4.82516194650558, 51.393330818892, 4.95146585938037, 51.4561602080737,
    ],
    13003: [
      5.08742683835547, 51.1166842617401, 5.26095296573924, 51.2119489766888,
    ],
    13004: [
      4.7642025819761, 51.2736834070547, 4.89467160468438, 51.3451012095774,
    ],
    13006: [
      5.04855717389228, 51.2191854884982, 5.18425541479234, 51.2702576477352,
    ],
    13008: [
      4.8934444363021, 51.0898068140458, 5.07597101017956, 51.243144949367,
    ],
    13010: [
      4.6910955733076, 51.1500886733893, 4.79179037312499, 51.2167885394027,
    ],
    13011: [
      4.77434520669464, 51.103523516926, 4.88132983167056, 51.2165058320801,
    ],
    13012: [
      4.71281800571445, 51.1122830592702, 4.80918393092395, 51.1651647758559,
    ],
    13013: [
      4.79772922751491, 51.0110211107361, 4.96762249916486, 51.0917862657862,
    ],
    13014: [
      4.66530229844161, 51.3762443800901, 4.84959683148788, 51.5056412219734,
    ],
    13016: [
      4.76558118447807, 51.0288528726675, 4.86760421400697, 51.0891123625423,
    ],
    13017: [
      4.86041673206111, 51.1951981228632, 5.03095890458421, 51.2874370740262,
    ],
    13019: [
      4.76002650505351, 51.2074785857777, 4.90619441654296, 51.2995281039886,
    ],
    13021: [
      5.01000264808147, 51.0942905816562, 5.12894191374847, 51.1600884840087,
    ],
    13023: [
      4.80717459699535, 51.3370168496434, 4.93189561297707, 51.4127574680272,
    ],
    13025: [
      5.03406709449923, 51.1540210241759, 5.24089217701093, 51.3231954262799,
    ],
    13029: [
      4.8388576223059, 51.1363665202085, 4.92541345747654, 51.1974081992446,
    ],
    13031: [
      4.96088549851873, 51.276567800874, 5.05654718623481, 51.3643203582069,
    ],
    13035: [
      4.92661150955001, 51.3532611112535, 5.10331352982094, 51.4879220776927,
    ],
    13036: [
      5.01498687221503, 51.2187256589105, 5.15777502038147, 51.2981369378935,
    ],
    13037: [
      4.71596992532677, 51.3131723784214, 4.82648871396225, 51.3931743616258,
    ],
    13040: [
      4.88743834559823, 51.2629393694782, 4.98355747644168, 51.3959866956742,
    ],
    13044: [
      4.7248482583559, 51.1834479170639, 4.83455932676108, 51.2517343294302,
    ],
    13046: [
      4.83581168100868, 51.2855566441987, 4.91307350685465, 51.327689676452,
    ],
    13049: [
      4.81033220774608, 51.0643466700268, 4.94900653004853, 51.1484600962381,
    ],
    13053: [
      4.92723332319017, 51.0354265204029, 5.09908684564352, 51.1165126464963,
    ],
    21001: [
      4.24250331250646, 50.8076056146758, 4.3388478910444, 50.8508627032655,
    ],
    21002: [
      4.39299870771597, 50.790309012133, 4.48100296327247, 50.8275718160394,
    ],
    21003: [
      4.27793176353522, 50.8558952741207, 4.3127996337016, 50.8758321738314,
    ],
    21004: [
      4.3125032352127, 50.7968894307732, 4.43579671941615, 50.9144443241438,
    ],
    21005: [
      4.37785577104348, 50.823056667389, 4.41094606422669, 50.8452144032093,
    ],
    21006: [
      4.38604334955452, 50.852653252942, 4.42537139606517, 50.8864777124004,
    ],
    21007: [
      4.30076026276944, 50.798056715903, 4.35232510595633, 50.831302464969,
    ],
    21008: [
      4.2902637342968, 50.865768472863, 4.32482464377268, 50.8826435979928,
    ],
    21009: [
      4.34602640552602, 50.8012393511317, 4.40213105189755, 50.8411738309921,
    ],
    21010: [
      4.29249698161034, 50.8650379179878, 4.33928167544109, 50.8946616639931,
    ],
    21011: [
      4.30566525410176, 50.8573199378762, 4.33647168817927, 50.8681305101048,
    ],
    21012: [
      4.281848679533, 50.8444150775959, 4.34712695706465, 50.8719262272123,
    ],
    21013: [
      4.32517597384268, 50.8210927074737, 4.35729371404759, 50.8407848655982,
    ],
    21014: [
      4.35394917827779, 50.8476728109388, 4.38281704629895, 50.8608575362395,
    ],
    21015: [
      4.35592034807114, 50.8439664171222, 4.4118192538436, 50.8816089229887,
    ],
    21016: [
      4.31053434560409, 50.7642272553148, 4.41134721285499, 50.8174812314692,
    ],
    21017: [
      4.39097143410678, 50.7728696641853, 4.46900547167964, 50.8155769888312,
    ],
    21018: [
      4.39872045350812, 50.8343243438663, 4.46050678022701, 50.8635793532148,
    ],
    21019: [
      4.40305639324464, 50.8189679704945, 4.47546368174222, 50.8494879577657,
    ],
    23002: [
      4.13773712932076, 50.8739856800302, 4.29987533512919, 50.9450167798657,
    ],
    23003: [
      4.25543709751413, 50.7139647678335, 4.35472820410648, 50.7826629973646,
    ],
    23009: [
      3.88748245796679, 50.6895302310997, 3.972918839578, 50.7335786109648,
    ],
    23016: [
      4.16474460680703, 50.8131942312954, 4.28857724989382, 50.8913018547541,
    ],
    // 23023: [
    //   3.92975746500023, 50.7195977911116, 4.05074654010481, 50.7825545335506,
    // ],
    23024: [
      4.03381567637228, 50.7459302664043, 4.15111300958439, 50.816974505587,
    ],
    23025: [
      4.31707665087774, 50.9014582614661, 4.42512521857321, 50.9909434032954,
    ],
    23027: [
      4.17083177188802, 50.6900678010335, 4.31068019797176, 50.7786661353837,
    ],
    // 23032: [
    //   3.95756143747385, 50.6880393880042, 4.11519950300048, 50.7587465477987,
    // ],
    23033: [
      4.40380327414397, 50.7356808944834, 4.51026234686815, 50.7832322075075,
    ],
    23038: [
      4.51175469576566, 50.9098502720246, 4.61757198604762, 50.971126852063,
    ],
    23039: [
      4.31823767221614, 50.9691543757438, 4.38908677827659, 51.0314381409317,
    ],
    23044: [
      4.0577187654244, 50.8502310718461, 4.12508699234639, 50.8894501187931,
    ],
    23045: [
      4.2199176697591, 50.9744661876298, 4.33217672510684, 51.0437440858085,
    ],
    23047: [
      4.41445076089314, 50.8793250691366, 4.46845545079613, 50.9248463938269,
    ],
    23050: [
      4.26918830858488, 50.9212766436408, 4.3522548881307, 51.004922568703,
    ],
    23052: [
      4.1802267570157, 50.9094856416997, 4.30053410113746, 50.9990677510459,
    ],
    23060: [
      4.14156760242973, 50.9324910517777, 4.22404093450398, 50.9896630505304,
    ],
    23062: [
      4.45037638609746, 50.7278811221023, 4.61213292556466, 50.8093202794311,
    ],
    23064: [
      4.07081511935521, 50.7060504433201, 4.20120785025845, 50.7903839266072,
    ],
    23077: [
      4.1723510798077, 50.7500390348091, 4.31217794045287, 50.8280594431333,
    ],
    23081: [
      4.4565616755239, 50.8896268943712, 4.53286389544596, 50.9599616168745,
    ],
    23086: [
      4.10485722509752, 50.8412632030335, 4.2055390268281, 50.8902802447562,
    ],
    23088: [
      4.35919689830937, 50.897530270781, 4.48580948133236, 50.9598279004839,
    ],
    23094: [
      4.41960030410235, 50.8348440235644, 4.53511803779168, 50.9029160588291,
    ],
    23096: [
      4.36813564747926, 50.947067711656, 4.52743080756506, 51.0098885956283,
    ],
    23097: [
      4.03940762831943, 50.812040576882, 4.14933410297529, 50.8591362112665,
    ],
    23098: [
      4.28737017484338, 50.7802482089825, 4.32450065406621, 50.8135966779259,
    ],
    23099: [
      4.44765010086559, 50.8188513214934, 4.49164202186203, 50.8677194197217,
    ],
    23100: [
      4.32041144556764, 50.7568046856703, 4.36622758146699, 50.7804495150398,
    ],
    23101: [
      4.31993638771019, 50.7156494925644, 4.42271488279951, 50.7739158240336,
    ],
    23102: [
      4.27654421311716, 50.8909324152443, 4.337698198211, 50.9286222508752,
    ],
    23103: [
      4.46914206508334, 50.826567969591, 4.51609798532636, 50.8625424596169,
    ],
    23104: [
      4.10781914293832, 50.7802109023765, 4.21068695500107, 50.8437544003868,
    ],
    23105: [
      4.07298605279294, 50.8837744045086, 4.14923140700543, 50.9330030193872,
    ],
    23106: [3.931013500547929, 50.687492334560318, 4.152371603765016, 50.81642069623063],
    24001: [
      4.77268580606201, 50.9538574474435, 4.93516625228174, 51.0381104223658,
    ],
    24007: [
      4.75184529510782, 50.9785574762266, 4.8105953943966, 51.0394913735893,
    ],
    24008: [
      4.91812250650639, 50.8934150528834, 5.0440172597041, 50.9698595236693,
    ],
    24009: [
      4.54490709870419, 50.8189345979431, 4.65869477937277, 50.8915054867463,
    ],
    24011: [
      4.68995666888044, 50.7886903657705, 4.81817258793846, 50.8761956423814,
    ],
    24014: [
      4.51120356862035, 50.9587408489357, 4.61161451783371, 51.0039750212631,
    ],
    24016: [
      4.79475210487413, 50.7909278917651, 4.8981568603225, 50.8728395820878,
    ],
    24020: [
      4.99346766449569, 50.9433167456265, 5.15842798411456, 51.0503676218518,
    ],
    24028: [
      5.06417314982508, 50.8584343648424, 5.18674626679136, 50.9220865451446,
    ],
    24033: [
      4.58440486931272, 50.925061502205, 4.68818921602029, 50.9950551025402,
    ],
    24038: [
      4.59703131485111, 50.8789981483796, 4.70135018443369, 50.9471140216545,
    ],
    24041: [
      4.79925029946835, 50.7432437975247, 4.95253850321908, 50.8140602505348,
    ],
    24043: [
      4.71439776962548, 50.8974291806043, 4.8707509059605, 50.9637892502445,
    ],
    24045: [
      4.55387489815804, 50.7415800597385, 4.65415305024593, 50.83575347751,
    ],
    24048: [
      4.59734054355666, 50.9859300718552, 4.70821480481363, 51.0246499919247,
    ],
    24054: [
      4.96782188364886, 50.8460750433207, 5.09074572718183, 50.9331318836387,
    ],
    24055: [
      4.51379045816268, 50.8563262251067, 4.61340114765001, 50.9354159252245,
    ],
    24059: [
      4.98265401392049, 50.7038992963958, 5.12016116139733, 50.7953363018527,
    ],
    24062: [
      4.63903348583781, 50.8247551686496, 4.76914790192722, 50.9446173916289,
    ],
    24066: [
      4.74671718609442, 50.8522371046437, 4.90983681385523, 50.9123032016198,
    ],
    24086: [
      4.63079312928791, 50.7914111053006, 4.74532501331456, 50.8528072760711,
    ],
    24094: [
      4.66866222163826, 50.9289617104016, 4.80203758664597, 50.9868241863993,
    ],
    24104: [
      4.4459086726856, 50.7944271639951, 4.5852958777892, 50.8683809282538,
    ],
    24107: [
      4.85044171121277, 50.7526455806196, 5.01858736873723, 50.8648728613783,
    ],
    24109: [
      4.65158462976741, 50.9797566008241, 4.77307280584733, 51.0273564132342,
    ],
    24130: [
      5.0420943290531, 50.7796057295398, 5.15106088042632, 50.8852211192977,
    ],
    24133: [
      4.99089869458242, 50.7765791689295, 5.09250180826444, 50.868892209359,
    ],
    24134: [
      4.90103258124434, 50.9534869862236, 5.02093825971601, 51.0466624890535,
    ],
    24135: [
      4.84162675246281, 50.8808041702871, 4.95059653492928, 50.963642197546,
    ],
    24137: [
      4.90424490887336, 50.8317580390712, 4.99216404764422, 50.9017736445157,
    ],
    25005: [
      4.69616054777203, 50.7404165101222, 4.83726809292827, 50.8077683588617,
    ],
    25014: [
      4.29905760486216, 50.6264835216827, 4.41082903266826, 50.7349390366845,
    ],
    25015: [
      4.23622606476732, 50.6593766098771, 4.33236676949838, 50.7009811796317,
    ],
    25018: [
      4.62383700842079, 50.6528499561325, 4.76883304817473, 50.7240249979141,
    ],
    25023: [
      4.51099011161841, 50.5965540472313, 4.61041386039133, 50.6587331014743,
    ],
    25031: [
      4.37439033404657, 50.5546297990637, 4.54049387087462, 50.6592290422213,
    ],
    25037: [
      4.61901338734978, 50.70111476446, 4.74904918095756, 50.7999097685235,
    ],
    25043: [
      4.73030000045954, 50.6542701928572, 4.85039646626369, 50.7502559745101,
    ],
    25044: [
      4.19572106962402, 50.6140112366908, 4.32302374080012, 50.6796894305993,
    ],
    25048: [
      4.77164097526964, 50.67825656963, 4.94758535441568, 50.7740195656274,
    ],
    25050: [
      4.422456789118, 50.7161578549058, 4.51136611776401, 50.7576493012505,
    ],
    25068: [
      4.58793894399221, 50.6073085749155, 4.66501478043745, 50.6635628683261,
    ],
    25072: [
      4.24431262145106, 50.5439658782355, 4.40476181031167, 50.6359319934336,
    ],
    25084: [
      4.7322384657811, 50.5893994592125, 4.85114988221818, 50.6803733086318,
    ],
    25091: [
      4.47602322118997, 50.6955315696397, 4.56554940388757, 50.749334213302,
    ],
    25105: [
      4.12968119124224, 50.6528207173663, 4.24502931189858, 50.729621517774,
    ],
    25107: [
      4.45204189661781, 50.5259593277889, 4.58751492638384, 50.6025258707165,
    ],
    25110: [
      4.35379890749072, 50.6714907982789, 4.44004935709781, 50.7364195499711,
    ],
    25112: [
      4.52842188514633, 50.6831705163513, 4.64566488785079, 50.7643414157478,
    ],
    25117: [
      4.57203219192009, 50.5607586396005, 4.67184737507466, 50.6318110690499,
    ],
    25118: [
      4.92436626696098, 50.7240305852639, 5.01917950130929, 50.7703316915419,
    ],
    25119: [
      4.393405935549, 50.644530293968, 4.52509989439192, 50.7246959274554,
    ],
    25120: [
      4.90998040128452, 50.6401149312231, 5.01604648394795, 50.7422856932096,
    ],
    25121: [
      4.49062336810346, 50.6498177953545, 4.64682032219656, 50.6969903564932,
    ],
    25122: [
      4.82976852334003, 50.6159416915473, 4.93983554903819, 50.7043747584264,
    ],
    25123: [
      4.09004343966202, 50.6298661386965, 4.18004921269069, 50.7175161078892,
    ],
    25124: [
      4.62573347090396, 50.5947797500036, 4.74512629181602, 50.665576386949,
    ],
    31003: [
      3.27163647093504, 51.099408483523, 3.40974260766639, 51.2011846676152,
    ],
    31004: [
      3.10312309777414, 51.2769521581968, 3.17579189466687, 51.3286402920515,
    ],
    31005: [
      3.13294141370715, 51.1587234271678, 3.3088001717574, 51.3639025304276,
    ],
    31006: [
      3.24485395802382, 51.1924114357985, 3.39803986888562, 51.3086500510076,
    ],
    31012: [
      3.0388356742096, 51.1447792565662, 3.16132993837271, 51.2387185882447,
    ],
    31022: [
      3.149148239172, 51.0567815390858, 3.30091893726702, 51.1869662521792,
    ],
    31033: [
      3.04231943892276, 51.014064900961, 3.15654976667523, 51.1045332681312,
    ],
    31040: [
      3.05650334161048, 51.0844246789287, 3.21390734601195, 51.167939668619,
    ],
    31042: [
      3.06038728566654, 51.2131140288922, 3.19236012669744, 51.2913720539552,
    ],
    31043: [
      3.22384266470376, 51.2966516611354, 3.38410015037878, 51.3735248900185,
    ],
    32003: [
      2.74188431683111, 50.9751585449102, 2.95003433420426, 51.1167442043634,
    ],
    32006: [
      2.80465216040085, 50.9317244110319, 2.97249740906412, 51.0089521192994,
    ],
    32010: [
      2.89812156824365, 51.0423249037931, 3.01330278157542, 51.134263609275,
    ],
    32011: [
      2.92732373843326, 50.9845542401974, 3.06917525448641, 51.0708965318895,
    ],
    32030: [
      2.69522086535495, 50.9040753368153, 2.85523411435116, 51.0176585650573,
    ],
    33011: [
      2.76783782099785, 50.7941462458417, 2.97527254598956, 50.9392405852365,
    ],
    33016: [
      2.86840810951911, 50.7531939803764, 2.92132198066961, 50.767579511452,
    ],
    33021: [
      2.5974229545267, 50.795348840714, 2.80218656516699, 50.9377850700482,
    ],
    33029: [
      2.99733912898222, 50.7703386035711, 3.10562598468491, 50.8545737026299,
    ],
    33037: [
      2.93704762212382, 50.8006459628686, 3.06832793219961, 50.9294192516787,
    ],
    33039: [
      2.71180159457849, 50.7088235425772, 2.95924564711543, 50.8278551874078,
    ],
    33040: [
      2.84234513672704, 50.8688477068167, 2.98863429240837, 50.9578473876274,
    ],
    33041: [
      2.68881687396855, 50.8826551091435, 2.80917511094187, 50.957269274541,
    ],
    34002: [
      3.38255731421892, 50.7930640891479, 3.51339440650318, 50.866660111541,
    ],
    34003: [
      3.38902283971028, 50.7408926003139, 3.52210874146385, 50.8151827734997,
    ],
    34009: [
      3.32362632455004, 50.8118721331059, 3.39262372389351, 50.8678578474698,
    ],
    34013: [
      3.26605626310919, 50.8185225322851, 3.34801878525166, 50.9078790949592,
    ],
    34022: [
      3.19952503483562, 50.7315727481708, 3.35784060658625, 50.8751755070725,
    ],
    34023: [
      3.23920434242896, 50.8400988670467, 3.30027898810486, 50.8804493576592,
    ],
    34025: [
      3.18697296269228, 50.8718974860688, 3.27138298388353, 50.8999141551157,
    ],
    34027: [
      3.0793603995529, 50.7558597759779, 3.21841987595518, 50.8327299711846,
    ],
    34040: [
      3.31854072751053, 50.8455586948885, 3.47523642820615, 50.9119228813669,
    ],
    34041: [
      3.10113692596546, 50.7944634240868, 3.22168604652331, 50.8662548315777,
    ],
    34042: [
      3.30367185985918, 50.7380220537615, 3.45656491518176, 50.8286928602091,
    ],
    34043: [
      3.32252552032823, 50.710117237215, 3.40304455809526, 50.7486846802157,
    ],
    35002: [
      2.93874718764807, 51.2148984891939, 3.0112951100092, 51.2641115298725,
    ],
    35005: [
      2.87248672898947, 51.1109678577894, 2.9992436788032, 51.1977183837132,
    ],
    35006: [
      2.98076351687052, 51.0554000862192, 3.07733500004576, 51.1652803097688,
    ],
    35011: [
      2.74488776214091, 51.0952262140681, 2.92252248371606, 51.202721784435,
    ],
    35013: [
      2.83723008775729, 51.1851148862011, 3.00307571707917, 51.2463495963069,
    ],
    35014: [
      2.93508515931468, 51.1449892072913, 3.05684341188065, 51.224990567742,
    ],
    35029: [
      2.98304103697663, 51.2201915300765, 3.1140127043546, 51.3155533521385,
    ],
    36006: [
      3.01719111757329, 50.9578029706494, 3.14935036114313, 51.0195711839443,
    ],
    36007: [
      3.2286356586145, 50.8968679560422, 3.29625253985384, 50.9477817496427,
    ],
    36008: [
      3.1712192684126, 50.891359687461, 3.2428099200782, 50.9549784935712,
    ],
    36010: [
      3.09329177851008, 50.8481616534037, 3.20758295663695, 50.8931955648429,
    ],
    36011: [
      3.09650911301991, 50.9921243521174, 3.18238174179864, 51.0697314598766,
    ],
    36012: [
      3.02624992922427, 50.8375855802684, 3.13392412715013, 50.9284912193307,
    ],
    36015: [
      3.060691560637, 50.8875503179691, 3.17724176147486, 50.9944886525041,
    ],
    36019: [
      2.95777570344513, 50.9166270509896, 3.08708017807379, 50.999910373219,
    ],
    37002: [
      3.35956648262226, 50.9196553578932, 3.46021887372064, 50.9822035284649,
    ],
    // 37007: [
    //   3.2278003427562, 50.9196598369154, 3.35147847795829, 50.9785486210128,
    // ],
    37010: [
      3.28488648675413, 50.9048187011468, 3.3750001987167, 50.9649415881195,
    ],
    37011: [
      3.22069579204032, 50.9649753321031, 3.31096202015649, 51.0380878106558,
    ],
    // 37012: [
    //   3.32562130487403, 51.0246790293518, 3.44477960914878, 51.1015355363043,
    // ],
    // 37015: [
    //   3.28516873585471, 50.9616498683421, 3.45131507823749, 51.0541081826906,
    // ],
    37017: [
      3.30893251443134, 50.8809260420975, 3.43272544628067, 50.9462310972273,
    ],
    // 37018: [
    //   3.15646996470384, 51.0166346698646, 3.34825636385436, 51.1048017873184,
    // ],
    37020: [
      3.16304233290131, 50.944880291524, 3.24300134088775, 51.0268946141814,
    ],
    37021: [3.157693144929735, 51.01607563305254, 3.446022025769644, 51.1042674811930],
    37022: [3.229009588699241, 50.919123339247349, 3.452557095569048, 51.053584675735863],
    38002: [
      2.58895537032568, 50.9072154800758, 2.76934233673442, 51.0448253209066,
    ],
    38008: [
      2.54011213940164, 51.0466681886156, 2.63332228437006, 51.114293503543,
    ],
    38014: [
      2.60057639363945, 51.0818098729216, 2.75598208793852, 51.1503158115502,
    ],
    38016: [
      2.69807377953835, 51.0872497232674, 2.82357615641427, 51.1654993992395,
    ],
    38025: [
      2.5646707314205, 50.9858597582856, 2.77564830964055, 51.0983000203527,
    ],
    41002: [
      3.98118993288385, 50.8999389429486, 4.16219229513798, 50.9953811753353,
    ],
    41011: [
      4.02735159415027, 50.8650968265892, 4.08834413391286, 50.9117109369107,
    ],
    41018: [
      3.80238010522247, 50.72806401284, 4.00269300851665, 50.8375208364213,
    ],
    41024: [
      3.93570953371243, 50.8590848773277, 4.04034872658292, 50.9169033387003,
    ],
    41027: [
      3.83646850748262, 50.8221738828767, 3.94800697594524, 50.9186875493856,
    ],
    41034: [
      3.8663349250355, 50.9480669504185, 4.02280034202825, 50.9877091760801,
    ],
    41048: [
      3.91698045896918, 50.7717188433881, 4.07421631086128, 50.8723530233938,
    ],
    41063: [
      3.82218249846088, 50.9030715913354, 3.93652141905456, 50.9553711803842,
    ],
    41081: [
      3.74558792019675, 50.8104732256543, 3.86601408531362, 50.9190193568864,
    ],
    41082: [
      3.8914774052071, 50.8745815723225, 4.00999380056827, 50.9565234166689,
    ],
    42003: [
      3.92689063936776, 51.0046447865917, 4.04053956424331, 51.0744678664729,
    ],
    42004: [
      4.15308702543351, 50.9827446365576, 4.23982785383307, 51.0438091090177,
    ],
    42006: [
      3.99536263476159, 50.9856389038241, 4.19279804654391, 51.0729803313375,
    ],
    42008: [
      4.05742720942217, 51.0326163138125, 4.19803558704199, 51.1120931743311,
    ],
    42010: [
      3.82187956308204, 51.0178171697734, 3.93701331147341, 51.0765456692027,
    ],
    42011: [
      4.06987442082329, 50.9675532290277, 4.16769580737233, 51.0222360384934,
    ],
    42023: [
      4.01093900765812, 51.0914909609985, 4.14043005033494, 51.1464249872531,
    ],
    42025: [
      3.81942896238669, 50.9517492376041, 3.92199358806405, 51.0288857473048,
    ],
    42026: [
      3.91012953303031, 50.9718595191577, 4.00508439224699, 51.0347976291892,
    ],
    42028: [
      3.97025113280619, 51.032800484681, 4.09126829779886, 51.1023263529638,
    ],
    43002: [
      3.6112519724572, 51.1682935737835, 3.79421946949904, 51.2813577154234,
    ],
    43005: [
      3.50714868051334, 51.1628119345043, 3.60775789326356, 51.2193058329274,
    ],
    43007: [
      3.57418908958667, 51.1686312417284, 3.6638307382956, 51.2499893052948,
    ],
    43010: [
      3.35900269579195, 51.147384321314, 3.54381563936713, 51.2749681187096,
    ],
    43014: [
      3.47452392439073, 51.2159766037795, 3.68573774015837, 51.3064792565885,
    ],
    43018: [
      3.76339350471289, 51.1825232308531, 3.85499667237243, 51.2147916304392,
    ],
    // 44012: [
    //   3.6223786190743, 50.9546227962205, 3.7098514998912, 51.0148478138405,
    // ],
    44013: [
      3.75479179894689, 50.993581850564, 3.84323250969729, 51.082997549321,
    ],
    44019: [
      3.63110684261027, 51.0876946913786, 3.79813133688189, 51.199205685055,
    ],
    44020: [
      3.6227179527137, 50.9029212820744, 3.75442231627987, 50.956974500199,
    ],
    44021: [
      3.57853562013978, 50.9800754575348, 3.84808593154718, 51.189422519119,
    ],
    // 44034: [
    //   3.7853516048589, 51.0507738974492, 3.92202065895293, 51.1500070679678,
    // ],
    // 44040: [
    //   3.76164341757769, 50.9718931285248, 3.83498026055393, 51.0314780688459,
    // ],
    // 44043: [3.6816289839907, 50.9342766041608, 3.78975743941, 51.0277947006698],
    // 44045: [
    //   3.90053197795333, 51.1372599578888, 3.99742448656438, 51.2258936022191,
    // ],
    44086: [3.538548987326388, 50.928512030050662, 3.711100517177707, 51.014311988243485],
    // 44048: [
    //   3.5373053708128, 50.9290501169525, 3.67728259059282, 50.9888115675856,
    // ],
    44052: [
      3.72689595218805, 50.8952845154628, 3.84979724589673, 50.9781968408949,
    ],
    44064: [
      3.58988107840728, 50.9822555210791, 3.65383984422427, 51.035892808861,
    ],
    // 44073: [
    //   3.82776112576097, 51.1445876278656, 3.92090996789268, 51.2235496975652,
    // ],
    44081: [
      3.41409023950318, 50.8973480274941, 3.52658541498649, 50.9841217412131,
    ],
    44083: [
      3.41216429258891, 50.9476779231781, 3.61197119213646, 51.1016077508241,
    ],
    44084: [
      3.33011936658152, 51.0169940246447, 3.52442353899945, 51.1603931511891,
    ],
    44085: [
      3.5086317538611, 51.0746723502136, 3.66596038829778, 51.1760744444966,
    ],
    44087: [3.78660458303054, 51.050212361042718, 3.923277120786929, 51.223018606307306],
    44088: [3.682876846154903, 50.933737999641778, 3.836232921274054, 51.030942010530147],
    45035: [
      3.53984919867891, 50.7905798807325, 3.69646760904072, 50.9044228664738,
    ],
    45041: [
      3.53664522677643, 50.721556231539, 3.67635051054967, 50.7847694745438,
    ],
    45059: [
      3.69792423270412, 50.7480328252992, 3.81866525044254, 50.8478401954296,
    ],
    45060: [
      3.45781503892337, 50.7581116340763, 3.58655966427731, 50.8118358803374,
    ],
    45061: [
      3.45007792633145, 50.8058816752112, 3.5880700665883, 50.8872551137868,
    ],
    45062: [
      3.67093423104851, 50.7989487617046, 3.71483008618501, 50.8628124603711,
    ],
    45063: [
      3.78222405970561, 50.7752598730323, 3.88056168464616, 50.8387748605483,
    ],
    45064: [
      3.57685595568538, 50.765354961822, 3.710810182573, 50.8305945728954,
    ],
    45065: [
      3.6665074862702, 50.8337022062202, 3.76612925840766, 50.9125874876373,
    ],
    45068: [
      3.46549004512997, 50.8703551250213, 3.68552281760491, 50.9535507334479,
    ],
    // 46003: [
    //   4.15123478817081, 51.1669727287693, 4.31829571424538, 51.3544960992408,
    // ],
    // 46013: [
    //   4.23072304872078, 51.1240086369198, 4.32898911605678, 51.1985603377814,
    // ],
    // 46014: [
    //   3.89536585959542, 51.0718276568853, 4.03268949297798, 51.1652017038017,
    // ],
    46020: [
      4.05781775170703, 51.1759745226219, 4.16536531728666, 51.2933510409543,
    ],
    46021: [
      3.98406579578375, 51.1302138723123, 4.22070255403494, 51.2083342265077,
    ],
    46024: [
      3.96986375149542, 51.1693331971665, 4.09224831446666, 51.2504680073225,
    ],
    46025: [
      4.1269564857543, 51.1017056613385, 4.28464863227162, 51.1761227380055,
    ],
    46029: [3.896622406492985, 51.071291949030922, 4.034052504192, 51.225362066684291],
    46030: [4.152499816946851, 51.123472316066525, 4.357297715681366, 51.353966741512856],
    51004: [
      3.65380006661549, 50.5630308933394, 3.91204600288716, 50.6979904602198,
    ],
    51008: [
      3.60725437173009, 50.481506802631, 3.75932375488869, 50.5822762131625,
    ],
    51009: [
      3.61377463246082, 50.4428763241732, 3.75255862535918, 50.5151740896879,
    ],
    51012: [
      3.81760414604025, 50.5699400484793, 3.91045867774124, 50.6348107728682,
    ],
    51014: [
      3.71264291702371, 50.5270976312052, 3.83663213568686, 50.6140451921917,
    ],
    51017: [
      3.63647198067493, 50.6843960081377, 3.76537799638849, 50.774085675068,
    ],
    51019: [
      3.68415480213443, 50.7299165812308, 3.77581713377285, 50.7824036649132,
    ],
    51065: [
      3.48594959037966, 50.62633910061, 3.73018205234193, 50.7352758825864,
    ],
    51067: [
      3.95967325117017, 50.631087863501, 4.11237358142899, 50.7140532736007,
    ],
    51068: [
      3.87522688760432, 50.5906963163477, 4.06538739843183, 50.6960382101779,
    ],
    51069: [
      3.74360744116427, 50.6698995763166, 3.9122243063843, 50.7521860244365,
    ],
    52010: [
      4.26075341560335, 50.425093586976, 4.32560324708031, 50.507608029856,
    ],
    52011: [
      4.34680500828817, 50.353305021241, 4.50635450131524, 50.4932636413892,
    ],
    52012: [
      4.48143432472782, 50.3686159212003, 4.56193647199999, 50.4442193188,
    ],
    52015: [
      4.28567653181676, 50.4279629800435, 4.40369161827315, 50.524379612837,
    ],
    52018: [
      4.51625599286836, 50.414253212285, 4.57917425848002, 50.4516935809527,
    ],
    52021: [
      4.47693735280731, 50.4386183852316, 4.59947274377261, 50.5429099571313,
    ],
    52022: [
      4.28878398103946, 50.3668798127643, 4.3551592984727, 50.4478273442196,
    ],
    52025: [
      4.45634167025731, 50.3155256701173, 4.59303105995057, 50.3797878601535,
    ],
    52048: [
      4.3336649693752, 50.3555813417105, 4.41604919999739, 50.405028503976,
    ],
    52055: [
      4.3061136027587, 50.4684949357306, 4.45507433107671, 50.5634969620035,
    ],
    52074: [
      4.52947968954593, 50.3671705722484, 4.61600120448138, 50.4392524155064,
    ],
    52075: [
      4.37173115045899, 50.4768457691621, 4.51183094186182, 50.5651898323748,
    ],
    53014: [
      3.75740707526164, 50.3954669000047, 3.84215928371823, 50.452793094125,
    ],
    53020: [
      3.72372748809037, 50.3537491437398, 3.85116062401651, 50.4210130694315,
    ],
    53028: [
      3.83669579881803, 50.3427916423807, 3.94798747238393, 50.4248544838058,
    ],
    53039: [
      3.65395425832877, 50.4127048472074, 3.77991870104952, 50.4647132329797,
    ],
    53044: [
      3.79839563480399, 50.4892925229569, 3.99535979353456, 50.5557430041723,
    ],
    53046: [
      3.82541663777628, 50.5391863974959, 3.97813473536736, 50.6177388832428,
    ],
    53053: [
      3.85324699369591, 50.3782633675679, 4.08392052057168, 50.5143701775993,
    ],
    53065: [
      3.82751929457506, 50.4119360676725, 3.88326926312632, 50.4598561583156,
    ],
    53068: [
      3.66732295920249, 50.3704336507836, 3.74275169520164, 50.4229910428941,
    ],
    53070: [
      3.73502720429541, 50.4387000091555, 3.87820420551497, 50.5420622102476,
    ],
    53082: [
      3.81268302804104, 50.3797630133909, 3.8705818435607, 50.4350675570393,
    ],
    53083: [
      3.65584984118168, 50.303744738406, 3.83829418406204, 50.3847341311424,
    ],
    53084: [
      3.85955914113982, 50.3275056299493, 4.05379060340979, 50.4092848657952,
    ],
    55004: [
      4.02529875882339, 50.5650989671141, 4.2523931331452, 50.6695947175195,
    ],
    55035: [
      4.03777570850204, 50.4634184203554, 4.1851493366529, 50.547351666898,
    ],
    55040: [
      3.95100182634698, 50.5010138737526, 4.12943771644941, 50.6342951721764,
    ],
    55050: [
      4.12209825466822, 50.525505023071, 4.22819627763265, 50.5972021577134,
    ],
    55085: [
      4.18484299536502, 50.4968486766668, 4.33520235697486, 50.6021301864742,
    ],
    55086: [
      4.20293413092213, 50.4655114214175, 4.280439295758, 50.5219629419868,
    ],
    56001: [
      4.22657076388026, 50.3804593525472, 4.29270846731543, 50.4285775575866,
    ],
    56005: [
      4.16385909304485, 50.1594576234281, 4.34460149685338, 50.295464547964,
    ],
    56016: [
      4.19544471025057, 49.9423730240486, 4.44465959541055, 50.1293413653052,
    ],
    56022: [
      4.04151404579745, 50.256940267731, 4.21870100992393, 50.3502497373202,
    ],
    56029: [
      4.28072966806645, 50.083391310188, 4.39988490851172, 50.2439859329252,
    ],
    56044: [
      4.18194989541435, 50.3195210336099, 4.3026746147798, 50.3894107517231,
    ],
    56049: [
      4.13131202533026, 50.2817340052332, 4.26624570733291, 50.3673076049306,
    ],
    56051: [
      4.13411796870856, 49.9551589155839, 4.31338680853054, 50.0632533859156,
    ],
    56078: [
      4.22547869081299, 50.2678123305985, 4.39330664521136, 50.377176501812,
    ],
    56086: [
      4.3451390035706, 50.2900980781287, 4.47539673624443, 50.3625472925387,
    ],
    56088: [
      4.12579924448669, 50.1210793451381, 4.30302428667345, 50.2161730022636,
    ],
    57003: [
      3.40668777454195, 50.5281818769621, 3.52742325930761, 50.5881543309973,
    ],
    57018: [
      3.3641857580441, 50.6525217265238, 3.53206604960091, 50.7593230206095,
    ],
    57027: [
      3.23877506867514, 50.6531858093456, 3.33857382954223, 50.7229420462639,
    ],
    57062: [
      3.30187891505774, 50.647946227185, 3.39807530245464, 50.7232935871332,
    ],
    57064: [
      3.49500593393622, 50.4872337289228, 3.6280567199045, 50.5804924199191,
    ],
    57072: [
      3.27702844678041, 50.5131119150657, 3.36363200270168, 50.5731413731166,
    ],
    57081: [
      3.24288576690886, 50.5530193318879, 3.57564526233709, 50.6893231400013,
    ],
    57093: [
      3.32012168793058, 50.4915474268265, 3.4693898041599, 50.5680022761762,
    ],
    57094: [
      3.54721456033527, 50.5483119978431, 3.71246164747078, 50.6463146744943,
    ],
    57095: [
      3.45182947795925, 50.7040170474069, 3.54654472732693, 50.771860899725,
    ],
    57096: [
      3.17701494647317, 50.7103985396952, 3.32782208148343, 50.7664505299328,
    ],
    57097: [
      2.84089827367113, 50.6929793244811, 3.02861184788174, 50.8113309592991,
    ],
    58001: [
      4.06868884501131, 50.4338299337635, 4.2286077070899, 50.5254468703032,
    ],
    58002: [
      4.05460008708578, 50.349850664448, 4.25118358829257, 50.4474840382564,
    ],
    58003: [
      4.02613134352226, 50.3303431646678, 4.18443509740802, 50.4310446304395,
    ],
    58004: [
      4.19566754674757, 50.4224904090514, 4.28193962456646, 50.4753214746308,
    ],
    61003: [
      5.2606022603945, 50.5168681669675, 5.34895684558413, 50.5924456649514,
    ],
    61010: [
      5.02617523770793, 50.5559028329752, 5.16563156281682, 50.6087582197305,
    ],
    61012: [
      5.219816318847, 50.3655195792742, 5.42812506949575, 50.4620196395145,
    ],
    61019: [
      5.51735846004344, 50.3659152348442, 5.70804119751343, 50.460733917459,
    ],
    61024: [
      5.50346664999789, 50.4078609077965, 5.62179079145491, 50.46552966255,
    ],
    61028: [
      5.03349400318447, 50.5040783498008, 5.17123338543596, 50.5797441926973,
    ],
    61031: [
      5.12778222378583, 50.4681654134944, 5.32245886117549, 50.5395962824261,
    ],
    61039: [
      5.1955312243785, 50.427633113197, 5.28338997003951, 50.5083466467914,
    ],
    61041: [
      5.23385521268045, 50.4184900939194, 5.35349656542072, 50.5258982273264,
    ],
    61043: [
      5.33294233790187, 50.4890157513135, 5.47564196588483, 50.5445477784196,
    ],
    61048: [
      5.38297988452827, 50.4080998241652, 5.53557346587175, 50.4833153843334,
    ],
    61063: [
      5.24940697444588, 50.5746890900354, 5.34816738285781, 50.6377245531411,
    ],
    61068: [
      5.18832710755595, 50.5519046345254, 5.29600578651428, 50.6303090619315,
    ],
    61072: [
      5.13073514345464, 50.5090973397101, 5.26459130236338, 50.5831698725423,
    ],
    61079: [
      5.43649440055685, 50.4581426010316, 5.55255059752831, 50.5236322204978,
    ],
    61080: [
      5.33268905188753, 50.532474897034, 5.43938503959608, 50.593588734661,
    ],
    61081: [
      5.30680802376072, 50.4472057139811, 5.44419099524062, 50.5067787929793,
    ],
    62003: [
      5.45920423985609, 50.6496326643829, 5.5512841915363, 50.723400611717,
    ],
    62006: [
      5.41941878561678, 50.6589931339831, 5.49024566713412, 50.7396580662658,
    ],
    62009: [
      5.62249087405213, 50.3960638633703, 5.79192450457845, 50.5218553254227,
    ],
    62011: [
      5.51798180873929, 50.7311059918214, 5.68589043430489, 50.8083110603756,
    ],
    62015: [5.63464132115275, 50.6116722470178, 5.692300584798, 50.651473539],
    62022: [
      5.58792494479605, 50.5500552613171, 5.67899333023723, 50.6155748997361,
    ],
    62026: [
      5.53427606241106, 50.4598321729368, 5.63436966058437, 50.5123978526376,
    ],
    62027: [
      5.70017240947276, 50.6814552538728, 5.81745031784063, 50.7560266238503,
    ],
    62032: [
      5.49606591737059, 50.5040213313816, 5.61538153030564, 50.5816137353568,
    ],
    62038: [
      5.6428346280075, 50.590539864403, 5.71359237744272, 50.6454691478032,
    ],
    62051: [
      5.55424556110996, 50.6553308613997, 5.65613486528359, 50.7032184039226,
    ],
    62060: [
      5.47723213102813, 50.6791001696827, 5.59826352369593, 50.7499323995329,
    ],
    62063: [
      5.52197408947732, 50.5615764259884, 5.6739849748818, 50.6887430490498,
    ],
    62079: [
      5.59184341823281, 50.6819204250926, 5.69066457159729, 50.7537126916399,
    ],
    62093: [
      5.50510054382682, 50.6130317769795, 5.54804671578942, 50.6519283953169,
    ],
    62096: [
      5.46860253040657, 50.5477715323683, 5.56425091498433, 50.6291366541194,
    ],
    62099: [
      5.68796249320261, 50.5998466083084, 5.76761796713581, 50.6670910296365,
    ],
    62100: [
      5.58175349156981, 50.4769623498387, 5.76192294211658, 50.5563687047527,
    ],
    62108: [
      5.64672602281728, 50.6717199055742, 5.72394559275143, 50.8126731167579,
    ],
    62118: [
      5.34816917710518, 50.6144384641405, 5.51148093325451, 50.6613326677397,
    ],
    62119: [
      5.64105653761357, 50.6384759726491, 5.77373635792276, 50.7078875884213,
    ],
    62120: [
      5.379194277112, 50.5576324067813, 5.48770771214442, 50.6299497684811,
    ],
    62121: [
      5.4214420171816, 50.520779202308, 5.55342755372296, 50.5722855423381,
    ],
    62122: [
      5.63955540005527, 50.5472195098715, 5.7722862348697, 50.5961178408101,
    ],
    63001: [
      6.06842412703024, 50.2850939759061, 6.28474194883061, 50.4056249193162,
    ],
    63003: [
      5.79708116821987, 50.6768084940499, 5.92103182714784, 50.7180637160934,
    ],
    63004: [
      5.9327701842217, 50.520298093346, 6.13838154011084, 50.6505050073733,
    ],
    63012: [
      6.21408951353024, 50.3059660707831, 6.4067852385002, 50.5020442205645,
    ],
    63013: [
      6.12951404668385, 50.3946381787392, 6.30055030099342, 50.5225935917599,
    ],
    63020: [
      5.83689015752415, 50.597267591607, 5.91293687528978, 50.6344224178389,
    ],
    63023: [
      5.99929502665066, 50.5485852686861, 6.26816769030621, 50.6734638492943,
    ],
    63035: [
      5.72871860409792, 50.5955844980825, 5.85943418272804, 50.7039576893116,
    ],
    63038: [
      5.87654249259705, 50.4671171883844, 6.07157059418828, 50.594436665039,
    ],
    63040: [
      5.98042505252945, 50.6920759082263, 6.06119609075466, 50.7548429783999,
    ],
    63045: [
      5.70152198964797, 50.2547728407019, 5.88008014706678, 50.3652672565444,
    ],
    63046: [
      5.8970291108706, 50.5768492527173, 5.98260639115229, 50.6536997236941,
    ],
    63048: [
      5.95333099017706, 50.6501544932401, 6.07147569954464, 50.7041885299245,
    ],
    63049: [
      5.96830269537489, 50.3508835916568, 6.11236118884124, 50.5195304115976,
    ],
    63057: [
      5.69175038790313, 50.5641421812895, 5.7706525682081, 50.6109592034835,
    ],
    63058: [
      5.75000462566471, 50.5394885583033, 5.85373344978896, 50.6038944237277,
    ],
    63061: [
      6.03618551185782, 50.6010735586469, 6.27279916099394, 50.7242754759199,
    ],
    63067: [
      5.97736109081565, 50.2305589587806, 6.30663613380023, 50.3534067147274,
    ],
    63072: [
      5.81406218174325, 50.4341850833789, 5.93044773007772, 50.512687511957,
    ],
    63073: [
      5.84973680325622, 50.3360695411134, 6.02917849312737, 50.4968887382652,
    ],
    63075: [
      5.66886960576085, 50.356811115191, 5.92957686754993, 50.4646719217812,
    ],
    63076: [
      5.73741665871442, 50.4342007692224, 5.91985235965903, 50.5681932539466,
    ],
    63079: [
      5.81169117653393, 50.5498196650992, 5.92422532775712, 50.6265201296857,
    ],
    63080: [
      6.06126881403631, 50.3747363205144, 6.23315094433528, 50.5709318449068,
    ],
    63084: [
      5.88311259592427, 50.6269774312835, 5.99929502665066, 50.7000616473158,
    ],
    63086: [
      5.75893543201494, 50.3203151468838, 6.00073691575943, 50.3916099129888,
    ],
    63087: [
      6.00739097732753, 50.1301361383449, 6.19120209210028, 50.2651932244698,
    ],
    63088: [
      5.8820603400235, 50.6790702071811, 6.01969409486299, 50.7630309668126,
    ],
    63089: [
      5.82373031568463, 50.6270291461028, 5.91749610198331, 50.698818011608,
    ],
    64008: [
      5.16334475465278, 50.6841534674477, 5.23407667499568, 50.7242073630725,
    ],
    64015: [
      5.07931938443224, 50.5713219003727, 5.2085832540299, 50.649826163835,
    ],
    64021: [
      5.36174774721891, 50.6856410201136, 5.43044191860479, 50.7360132848401,
    ],
    64023: [
      5.28009836154318, 50.62577424751, 5.37528179967822, 50.675963458839,
    ],
    64025: [
      5.34709726848361, 50.6397406845888, 5.43947469160418, 50.6927289203516,
    ],
    64029: [
      5.1385198488156, 50.643906246777, 5.22563168628267, 50.6988770516376,
    ],
    64034: [
      4.9858602455367, 50.5990396728991, 5.16091849937085, 50.7167002197755,
    ],
    64047: [
      4.99124361213118, 50.6990321850945, 5.05957498333216, 50.7513166738266,
    ],
    64056: [
      5.30269606216561, 50.6999660114629, 5.39317367268781, 50.7485231291973,
    ],
    64063: [
      5.28713381660439, 50.665997001883, 5.39547884494719, 50.7045937001213,
    ],
    64065: [
      5.32483054433419, 50.5613893949969, 5.39313610599362, 50.633924291683,
    ],
    64074: [
      5.21246550512082, 50.6559968149133, 5.31198171245933, 50.72958832145,
    ],
    64075: [
      4.97802035922281, 50.5885807678472, 5.06052364529117, 50.6470309237302,
    ],
    64076: [
      5.19095752374519, 50.6163100084675, 5.28547817243164, 50.678547627099,
    ],
    71002: [
      5.52759542128952, 50.9778490156877, 5.64172907350314, 51.0380145302621,
    ],
    71004: [
      5.12024012521656, 51.0169104198741, 5.34289736935924, 51.106335764927,
    ],
    71011: [
      5.3638220336948, 50.8746445251891, 5.47796208765595, 50.9512560442435,
    ],
    71016: [
      5.38350171633192, 50.9135758774722, 5.59385868463794, 51.0213204821954,
    ],
    71017: [
      5.10024673684646, 50.6959875930749, 5.2426660167855, 50.770792326735,
    ],
    71020: [
      5.0402206904103, 50.9095269580999, 5.13809396236843, 50.9992954973351,
    ],
    // 71022: [
    //   5.21094684729353, 50.8681043420646, 5.41365528383031, 50.9821404551698,
    // ],
    71024: [
      5.11539092035396, 50.8930311232121, 5.22867280902502, 50.9718043642798,
    ],
    71034: [
      5.20019343869079, 51.0964108884349, 5.29962967111544, 51.1476711970833,
    ],
    71037: [
      5.1071694637379, 50.9566682844307, 5.25166126181733, 51.0419688791575,
    ],
    71045: [
      5.14714433961228, 50.8523111873784, 5.26229680882189, 50.9108736120388,
    ],
    71053: [
      5.10530073134083, 50.7494458944848, 5.28558042992885, 50.8778714840947,
    ],
    // 71057: [
    //   4.97879454068647, 51.0159958155742, 5.18262102738843, 51.0860087255481,
    // ],
    71066: [
      5.29974716874911, 50.9634297180725, 5.46434112355802, 51.0130134843183,
    ],
    71067: [
      5.52683990771792, 50.8956292479255, 5.61231041179588, 50.9778904782447,
    ],
    // 71069: [
    //   5.09363933157699, 51.074245156301, 5.22906813716204, 51.1411494362038,
    // ],
    71070: [
      5.22298289729853, 50.9757276616079, 5.35065813826825, 51.0732119160622,
    ],
    71071: [4.980080346070526, 51.015451797241155, 5.23035011596046, 51.140592207444783],
    71072: [5.212146669571512, 50.807773678193186, 5.450136331695584, 50.981593928155704],
    72003: [
      5.4761412308109, 51.1310988061981, 5.65815286014329, 51.223448345464,
    ],
    72004: [
      5.54517947243143, 51.1030613901936, 5.71717617140632, 51.1852854802961,
    ],
    72018: [
      5.65673440753447, 51.1204083129105, 5.85446222165692, 51.1900396617154,
    ],
    72020: [
      5.21333608574353, 51.1581677439845, 5.4161087604029, 51.2763015944826,
    ],
    72021: [
      5.60603954222061, 51.0193252825735, 5.83250905683099, 51.1305566446631,
    ],
    72030: [
      5.38791053841382, 51.0555393048656, 5.54631421520642, 51.1900398709393,
    ],
    72037: [
      5.43706009175007, 51.2105681406892, 5.55900309092572, 51.3006995006879,
    ],
    72038: [
      5.25969368532168, 51.0882910084063, 5.43628261582499, 51.1824255118541,
    ],
    72039: [
      5.33422267020809, 51.0015545011515, 5.52087329015308, 51.1045607792893,
    ],
    72041: [
      5.62115811829513, 50.996399416412, 5.79985297687097, 51.0828979252698,
    ],
    72042: [
      5.45308454218721, 51.0193142330123, 5.66476058176456, 51.1468906973153,
    ],
    72043: [
      5.31884314523465, 51.1648033198424, 5.52775254712675, 51.2769387994535,
    ],
    73001: [
      5.24083234282785, 50.8542153657341, 5.35071176773048, 50.910931858483,
    ],
    // 73006: [
    //   5.43911383783181, 50.8168965899988, 5.62373337233901, 50.9231716619394,
    // ],
    // '73009': [
    //   5.24908666812451,
    //   50.7700099192991,
    //   5.40635971497156,
    //   50.845971750561,
    // ],
    73022: [
      5.23306781702946, 50.7156527561482, 5.40091113604706, 50.7924248680799,
    ],
    73028: [5.4141434854215, 50.7186559479028, 5.43498119590361, 50.7359857555],
    // 73032: [
    //   5.42781386417102, 50.8142890635453, 5.51227926176831, 50.8889812951245,
    // ],
    // 73040: [
    //   5.35116547392538, 50.8083257743514, 5.44884008366794, 50.8840052788667,
    // ],
    73042: [
      5.56983239468595, 50.8338003904636, 5.72324054591196, 50.9450669818337,
    ],
    73066: [
      5.51227926176831, 50.7641122641772, 5.68685780815381, 50.8439379645145,
    ],
    // '73083': [
    //   5.38768155263566,
    //   50.7207129415888,
    //   5.55165763371361,
    //   50.822907100864,
    // ],
    73098: [
      5.2634967798772, 50.8123348104213, 5.37096291428768, 50.868144281726,
    ],
    73107: [
      5.59401653587321, 50.9109571647631, 5.76636127481148, 51.0128214371497,
    ],
    73109: [
      5.68086955269347, 50.7104228064137, 5.90980206948496, 50.7837993188882,
    ],
    73110: [5.429109071594002, 50.813736821861461, 5.625029830849205, 50.922622413910631],
    73111: [
      5.250376655557812, 50.720158117801134, 5.552955425959436,
      50.845420893057046,
    ],
    81001: [
      5.6771772097276, 49.6224449651698, 5.90938467457842, 49.7278363560584,
    ],
    81003: [
      5.67513414080349, 49.6972207209642, 5.83138505338844, 49.7972261340728,
    ],
    81004: [
      5.70224387132183, 49.5392926050337, 5.87198588377189, 49.6123442542202,
    ],
    81013: [
      5.68340204843577, 49.7726339635333, 5.75708895848472, 49.8583579965441,
    ],
    81015: [
      5.72730470379629, 49.5724841773729, 5.87883632196812, 49.6606511337284,
    ],
    // 82003: [
    //   5.63705855799317, 49.9098659273749, 5.86859867431925, 50.1178075902099,
    // ],
    // 82005: [
    //   5.53708930978782, 50.007197776248, 5.73136286532124, 50.1171112220602,
    // ],
    82009: [
      5.61288023232755, 49.8201799112941, 5.78269821199431, 49.9425972292528,
    ],
    82014: [
      5.65060902387022, 50.062182933652, 5.8941620120229, 50.2367148900241,
    ],
    82032: [
      5.70837024970509, 50.2194232764633, 6.01598145785667, 50.3488629712986,
    ],
    82036: [
      5.49388969283524, 49.8675706549119, 5.71218744513621, 50.0123974323969,
    ],
    82037: [
      5.78676966936628, 50.1107554596318, 6.03308631048983, 50.2709107375424,
    ],
    82038: [
      5.41351166669853, 49.9559814278661, 5.62842113339161, 50.0782963997259,
    ],
    82039: [5.538376148598505, 49.909286619800852, 5.869894367623403, 50.117233804303083],
    83012: [
      5.34011125588375, 50.2995501714668, 5.63599919787945, 50.4311751278737,
    ],
    83013: [
      5.43973328497215, 50.2475000737823, 5.65360798576382, 50.3427685994974,
    ],
    83028: [
      5.36824610585773, 50.216878806463, 5.50212295165267, 50.3196010178203,
    ],
    83031: [
      5.45835340991807, 50.0904165583842, 5.7430589280701, 50.2311934140774,
    ],
    83034: [
      5.20525248524492, 50.1579043934632, 5.47186511171042, 50.2795048992825,
    ],
    83040: [
      5.2409543200179, 50.0790876491167, 5.46528076445076, 50.2004056273344,
    ],
    83044: [
      5.44069477263077, 50.1642104991322, 5.61086325957585, 50.265643544621,
    ],
    83049: [
      5.38895882099694, 50.0483743746888, 5.59606866333108, 50.1520321491506,
    ],
    83055: [
      5.57262684019816, 50.2205806215568, 5.74752380974546, 50.3726045377862,
    ],
    84009: [
      5.15680444434154, 49.772133086641, 5.36663051152018, 49.9324463439016,
    ],
    84010: [
      4.96721726127291, 49.7097147086209, 5.1883193298146, 49.8842607386502,
    ],
    84016: [
      4.97158341318464, 49.9615563391109, 5.15078572207585, 50.0459968934341,
    ],
    84029: [
      5.21406472080491, 49.759986869204, 5.3952421168072, 49.8321231746903,
    ],
    84033: [
      5.41030310436093, 49.7349322961166, 5.70407768418719, 49.9014584243671,
    ],
    84035: [
      5.12264240373487, 49.908433868751, 5.32892540564827, 50.0463072043375,
    ],
    84043: [
      5.31372392874823, 49.779444077846, 5.52810221961328, 49.9036135254776,
    ],
    84050: [
      5.04104877712733, 49.8259569509718, 5.20028583585442, 49.993762515247,
    ],
    84059: [
      5.22789233495412, 49.980335804241, 5.45905551164235, 50.0964114864168,
    ],
    84068: [
      5.15114232990992, 50.0263775713971, 5.31533663851467, 50.1108130226817,
    ],
    84075: [
      5.0097043874352, 50.016614596259, 5.17690790664986, 50.1233545139374,
    ],
    84077: [
      5.29023219530436, 49.8757317337175, 5.55215725370288, 50.0257588549051,
    ],
    85007: [
      5.30765463883267, 49.6529397347693, 5.48079934356341, 49.7908498264058,
    ],
    85009: [
      5.52629743373646, 49.6215707317674, 5.69802410253281, 49.7120480160743,
    ],
    85011: [
      5.14574494620487, 49.6113661869144, 5.423594689258, 49.7817808601553,
    ],
    85024: [
      5.37466697788951, 49.5642641473327, 5.53201849342758, 49.6405025789162,
    ],
    85026: [
      5.61527297291376, 49.5394442933897, 5.73336774610397, 49.6081537564499,
    ],
    85034: [
      5.61415943801306, 49.5870798103672, 5.74184515542198, 49.6467962660051,
    ],
    85039: [
      5.41513287248853, 49.6199452794513, 5.55547403447691, 49.7839779936681,
    ],
    85045: [
      5.49946423772669, 49.5065549390113, 5.64266735565801, 49.6399219443412,
    ],
    85046: [
      5.49943003872872, 49.6878293894299, 5.71205946057163, 49.7845473851466,
    ],
    85047: [
      5.44011307568525, 49.4975444768668, 5.5322499158146, 49.575511553949,
    ],
    91005: [
      4.72515263589117, 50.2808363805377, 4.8955926617932, 50.3618147076338,
    ],
    91013: [
      4.81769541612548, 50.0182637805022, 5.07956030763483, 50.1658144757999,
    ],
    91015: [
      4.9291881118124, 49.8433819085029, 5.11839200040587, 50.0168341617328,
    ],
    91030: [
      5.0012000225259, 50.2091234114311, 5.26025182508614, 50.3409380365696,
    ],
    91034: [
      4.85314629018228, 50.1810255435373, 5.04666868044733, 50.3050883550935,
    ],
    91054: [
      4.78902682724563, 49.9175584086651, 5.00797098423686, 50.0522186037757,
    ],
    91059: [
      5.02341990270124, 50.2911199092631, 5.23711150831964, 50.384075755259,
    ],
    91064: [
      5.1286890380289, 50.2946461730365, 5.36193922552705, 50.4178411679415,
    ],
    91072: [
      4.8512876624866, 50.1327091698882, 5.11858721960121, 50.2519402121395,
    ],
    91103: [
      4.73517237799859, 50.21531319139, 4.89234049223253, 50.3116232272615,
    ],
    91114: [
      5.05403890879984, 50.0941444369702, 5.28273841803979, 50.2390274408785,
    ],
    91120: [
      5.21265132745541, 50.2395734320335, 5.40165415424637, 50.3889471778104,
    ],
    91141: [
      4.85250076237904, 50.281469024531, 5.02346206787256, 50.3646671232802,
    ],
    91142: [
      4.75109216511604, 50.1488656099811, 4.89928592130165, 50.247665111648,
    ],
    91143: [
      4.84618645310125, 49.7860854739456, 4.98934020108645, 49.9317061955134,
    ],
    92003: [
      4.9605865455213, 50.4480496791151, 5.16267133720881, 50.5324033104051,
    ],
    92006: [
      4.89439048668699, 50.3333791953497, 5.09960601085267, 50.4191032879243,
    ],
    92035: [
      4.78526961705383, 50.526613812932, 4.9884989972509, 50.6489986600229,
    ],
    92045: [
      4.69399880629213, 50.3936563459246, 4.82811554857138, 50.472482188649,
    ],
    92048: [
      4.58253415459373, 50.3588855215633, 4.79791300277223, 50.4286931372569,
    ],
    92054: [
      4.95720469521746, 50.3738632753534, 5.14416135152561, 50.4629626715914,
    ],
    92087: [
      4.58063384526998, 50.2619830267585, 4.76675271422263, 50.3803736633528,
    ],
    92094: [
      4.72169619700936, 50.3878838609539, 4.98307539354835, 50.5316636872878,
    ],
    92097: [
      5.07494117036411, 50.398812858813, 5.23585982587179, 50.4794934167048,
    ],
    92101: [
      4.73968443242449, 50.3433139646961, 4.91800502609999, 50.4116824106933,
    ],
    92114: [
      4.55609504570116, 50.4847610303776, 4.64381687718173, 50.5701257825243,
    ],
    92137: [
      4.57138225242594, 50.4009077548575, 4.66901481492958, 50.4931684216771,
    ],
    92138: [
      4.91565508048677, 50.5054699568451, 5.05295263688023, 50.6191496272872,
    ],
    92140: [
      4.61929265833483, 50.421534196688, 4.73176712506445, 50.513646046411,
    ],
    92141: [
      4.74333803281923, 50.4877002534577, 4.8973914932227, 50.5736191586481,
    ],
    92142: [
      4.62397838641995, 50.4963721932167, 4.80579480190137, 50.6119659055216,
    ],
    93010: [
      4.36032675534656, 50.1223321933182, 4.51760757100594, 50.2412337770617,
    ],
    93014: [
      4.38435937862632, 49.9378102110407, 4.60411439142955, 50.1401644693433,
    ],
    93018: [
      4.58068718838279, 50.0926771945049, 4.79827370294917, 50.2105771855468,
    ],
    93022: [
      4.50328645167565, 50.1981245416284, 4.78672735388727, 50.323523530391,
    ],
    93056: [
      4.47496127614681, 50.0917436048026, 4.72806635377687, 50.2316104742298,
    ],
    93088: [
      4.28456498581936, 50.2165673362868, 4.54408648491179, 50.3296095071515,
    ],
    93090: [
      4.52496871728792, 49.9861668535262, 4.72122862090996, 50.1146396784226,
    ],
    0o2000: [2.55651, 50.6741, 5.92, 51.4957],
  },
  uk: {
    'E06000060': [
      -1.14075388125809, 51.4854707874074, -0.476594525775733, 52.0815336222521,
    ],
    'E06000064': [
      -3.32481919123459, 54.0401525746704, -2.15899719522345, 54.8564544841115,
    ],
    'E06000059': [
      -2.96160031150341, 50.5128503500712, -1.79061492044422, 51.0809944694542,
    ],
    'E06000062': [
      -1.3323324978671, 51.9772776034959, -0.705043858850979, 52.4774625079581,
    ],
    'E08000038': [
      -1.82258927530432, 53.4383149312165, -1.27571203128746, 53.6127388206827,
    ],
    'E08000025': [
      -2.03364061279039, 52.3810440321797, -1.72885044838865, 52.6087219886757,
    ],
    'E08000001': [
      -2.62861435038086, 53.5228826546469, -2.33699025719107, 53.6460720343122,
    ],
    'E08000032': [
      -2.06125057169733, 53.7243564465797, -1.64033405308677, 53.9631653206383,
    ],
    'E08000002': [
      -2.38345547886356, 53.5120211683573, -2.23415847548089, 53.667080654493,
    ],
    'E08000033': [
      -2.17329132180093, 53.6153184570457, -1.72722486311416, 53.8256202153325,
    ],
    'E08000031': [
      -2.20687697905067, 52.54394488066, -2.0480217334804, 52.637910521259,
    ],
    'E08000026': [
      -1.61445000065458, 52.3638920750157, -1.42392898231888, 52.4648024789896,
    ],
    'E08000017': [
      -1.34873341137308, 53.4057598373729, -0.865338726025611, 53.6612232816087,
    ],
    'E08000027': [
      -2.19194273238093, 52.4260142968737, -2.01150484508758, 52.5582232421637,
    ],
    'E08000037': [
      -1.85272713603503, 54.8777701487896, -1.51036490770694, 54.9844195429243,
    ],
    'E08000034': [
      -2.00947078713106, 53.5197458043211, -1.5708089363966, 53.7648483550099,
    ],
    'E08000011': [
      -2.92261510760143, 53.3466508515403, -2.74339554539956, 53.5039228805927,
    ],
    'E08000035': [
      -1.80042422664219, 53.698983710792, -1.2903553375559, 53.9458881880291,
    ],
    'E08000012': [
      -3.01917840088497, 53.3115687462067, -2.81805678679928, 53.4749832157279,
    ],
    'E08000003': [
      -2.31991901980795, 53.340120620359, -2.14682778417064, 53.5446085369161,
    ],
    'E08000021': [
      -1.77568505202114, 54.9590389191309, -1.52921303495831, 55.07938870152,
    ],
    'E08000022': [
      -1.63975943117304, 54.9829318621012, -1.4027522971198, 55.0759473847121,
    ],
    'E08000004': [
      -2.18601421381712, 53.4911282644553, -1.90962083195551, 53.6241671461057,
    ],
    'E08000005': [
      -2.28258512131777, 53.5290593985386, -2.02681574056412, 53.6857340290757,
    ],
    'E08000018': [
      -1.45678991086165, 53.301569792195, -1.11513724955129, 53.5153272951616,
    ],
    'E08000006': [
      -2.48973034134074, 53.4158914442799, -2.24510394851182, 53.5422534894246,
    ],
    'E08000028': [
      -2.09710836796544, 52.4607327763577, -1.91815749708244, 52.569085323176,
    ],
    'E08000014': [
      -3.1319404026703, 53.4361762554123, -2.88123224397646, 53.704348364795,
    ],
    'E08000039': [
      -1.80147063244941, 53.3045326528304, -1.32459110191372, 53.5031209760333,
    ],
    'E08000029': [
      -1.87202017377615, 52.3477398329617, -1.59284561870792, 52.5144953535475,
    ],
    'E08000023': [
      -1.53552528994903, 54.9283688788392, -1.35181208457895, 55.0113456470697,
    ],
    'E08000007': [
      -2.24682802957703, 53.3271993974914, -1.99232947055908, 53.4549368626877,
    ],
    'E08000013': [
      -2.82504300651466, 53.3853882195736, -2.57666478059629, 53.5314301969823,
    ],
    'E08000024': [
      -1.56889133560984, 54.7990519128126, -1.34613513803856, 54.9445299692841,
    ],
    'E08000008': [
      -2.16966351247207, 53.4259723650252, -1.96338598926022, 53.5313929556254,
    ],
    'E08000009': [
      -2.47843960282684, 53.3574246421479, -2.25302232692278, 53.4803738002721,
    ],
    'E08000036': [
      -1.62490150410721, 53.5753669707637, -1.19876646275588, 53.7417627286214,
    ],
    'E08000030': [
      -2.07782393325462, 52.5473065302947, -1.87251154038685, 52.6627798772614,
    ],
    'E08000010': [
      -2.73041764234418, 53.4460164017257, -2.41453919482293, 53.6083658613154,
    ],
    'E08000015': [
      -3.26375659568226, 53.2863771115722, -2.90315388304666, 53.4494957901131,
    ],
    'E06000022': [
      -2.70789213030415, 51.273096744002, -2.27853647762857, 51.4395334928121,
    ],
    'E06000055': [
      -0.668756729853352, 52.0545431786636, -0.240723002820836, 52.3229532812371,
    ],
    'E06000008': [
      -2.56476819788326, 53.6165589114011, -2.36264954975664, 53.7818188747229,
    ],
    'E06000009': [
      -3.07637002484337, 53.7731167798034, -2.98335722276106, 53.8758846260528,
    ],
    'W06000019': [
      -3.31009487268817, 51.6812782856969, -3.10601554595748, 51.825488658471,
    ],
    'E06000058': [
      -2.04263597068468, 50.6814606947288, -1.68165652199454, 50.8096386567636,
    ],
    'E06000036': [
      -0.837373716901633, 51.3319330708864, -0.630552938632746, 51.4687339898807,
    ],
    'W06000014': [
      -3.64767998060806, 51.3787777088916, -3.15970764786348, 51.5153807912122,
    ],
    'W06000018': [
      -3.33447027982823, 51.5456379840242, -3.06369879859041, 51.7989763046678,
    ],
    'W06000012': [
      -3.93650461617364, 51.5271657980179, -3.56177411714798, 51.8103611118252,
    ],
    'E06000056': [
      -0.702156753865155, 51.8050953620297, -0.14398550393289, 52.1909257732246,
    ],
    'E06000049': [
      -2.7529286634929, 52.9471648775005, -1.97479093734383, 53.3874615169358,
    ],
    'E06000050': [
      -3.1282775470863, 52.9829301019161, -2.34635313770005, 53.3446995052415,
    ],
    'E06000023': [
      -3.11782412623722, 51.3416234593735, -2.51041953845727, 51.5444310619551,
    ],
    'E06000015': [
      -1.5568346800686, 52.8610550407951, -1.38307440746764, 52.9681536283292,
    ],
    'E06000016': [
      -1.215980784602, 52.5806687575261, -1.04620430743156, 52.6915230260726,
    ],
    'E06000018': [
      -1.24695293783229, 52.8889945279328, -1.08611507246246, 53.0187264329587,
    ],
    'E06000031': [
      -0.497651443767072, 52.5061130640139, -0.012751835145391, 52.6752330946213,
    ],
    'E06000045': [
      -1.47898951396717, 50.8714984168908, -1.32197756217243, 50.9561274536544,
    ],
    'E06000021': [
      -2.23876135172224, 52.9461581579688, -2.07923858928417, 53.0927331685879,
    ],
    'S12000005': [
      -3.88508318224873, 56.0724892931039, -3.57140719879531, 56.2172271306542,
    ],
    'W06000003': [
      -4.03133767240668, 52.9493718381519, -3.45459142321376, 53.3428699328381,
    ],
    'E06000019': [
      -3.14192072484887, 51.8259503795045, -2.33796261565779, 52.3954961323873,
    ],
    'E06000005': [
      -1.70976414983484, 54.4511376094983, -1.40729171028139, 54.6193656809116,
    ],
    'S12000042': [
      -3.09804101236186, 56.4445443965309, -2.83219719729372, 56.5039815975032,
    ],
    'S12000008': [
      -4.63859175587832, 55.1378741753372, -3.95704646931223, 55.7637801830316,
    ],
    'S12000045': [
      -4.4020374738936, 55.896083820634, -4.04686210998606, 56.0302911902834,
    ],
    'S12000011': [
      -4.55091898431573, 55.675788971783, -4.21867801616292, 55.8231478436573,
    ],
    'S12000014': [
      -4.0303411431556, 55.8954198156673, -3.50120547632817, 56.1086550318425,
    ],
    'S12000049': [
      -4.39318534807638, 55.7812748892724, -4.07170515706163, 55.9296353593474,
    ],
    'E06000006': [
      -2.83233934882774, 53.3050347970597, -2.5952211411125, 53.4025532307433,
    ],
    'S12000018': [
      -4.89893315450323, 55.8379700528209, -4.59728864265038, 55.9721487448661,
    ],
    'E06000032': [
      -0.505923085960359, 51.8544812644456, -0.349836724804763, 51.9277474618813,
    ],
    'E06000035': [
      0.397346296008141, 51.3278964123716, 0.740110753017262, 51.5036827084522,
    ],
    'W06000024': [
      -3.4531499878985, 51.6446826458831, -3.27393042083335, 51.8350609919734,
    ],
    'E06000002': [
      -1.28543724133293, 54.5011253146045, -1.13731937218486, 54.5915298068587,
    ],
    'S12000019': [
      -3.36903649137681, 55.7103470908584, -2.84624367983483, 55.9320190380809,
    ],
    'E06000042': [
      -0.887350872324669, 51.9692289650499, -0.591810331121503, 52.1963550749163,
    ],
    'E06000012': [
      -0.29211512919743, 53.4335649233719, 0.028001439729266, 53.6402152414119,
    ],
    'S12000050': [
      -4.19448955472014, 55.7347161722012, -3.71112703754746, 56.0313623598227,
    ],
    'E06000013': [
      -0.950009087300711, 53.4550644469113, -0.200405862102551, 53.7226958776135,
    ],
    'W06000013': [
      -3.76994282824957, 51.4683424764121, -3.46302487947318, 51.6458383815691,
    ],
    'S12000048': [
      -4.72043295812877, 56.1324148685314, -3.03342445599374, 56.9486205187259,
    ],
    'W06000023': [
      -3.92936203001251, 51.7527514735792, -2.94962136496068, 52.9015755450781,
    ],
    'E06000038': [
      -1.05297452901207, 51.409753890114, -0.928560000159745, 51.4930919083031,
    ],
    'E06000003': [
      -1.20174302467608, 54.4878486173683, -0.788308774961511, 54.647965612826,
    ],
    'S12000038': [
      -4.78399177576579, 55.7595196890611, -4.35309172398026, 55.936290289178,
    ],
    'W06000016': [
      -3.5937174835239, 51.4989630794801, -3.23632041166166, 51.8301292509159,
    ],
    'E06000017': [
      -0.821752864472965, 52.5247372199499, -0.428364699911486, 52.7598408822972,
    ],
    'S12000026': [
      -3.53979849445201, 55.108348804226, -2.03320103392792, 55.9466236547096,
    ],
    'E06000051': [
      -3.23555870572831, 52.3062772785268, -2.23289449572097, 52.9984110622549,
    ],
    'W06000004': [
      -3.60200858906778, 52.8619394449995, -3.09029519615975, 53.3573521782406,
    ],
    'W06000005': [
      -3.40059901446516, 53.0721415225011, -2.92027710423941, 53.3608049943159,
    ],
    'E06000039': [
      -0.660146561343318, 51.467984948416, -0.490024731164425, 51.5388952073441,
    ],
    'E06000033': [
      0.622945951640881, 51.504460184338, 0.848956267863126, 51.5768010714265,
    ],
    'E06000025': [
      -2.71069993596632, 51.4159018061483, -2.25213125341167, 51.6823970971399,
    ],
    'S12000029': [
      -4.28255884217727, 55.2907710979967, -3.39644240823105, 55.8444346539702,
    ],
    'S12000030': [
      -4.85447699803646, 55.9572216257834, -3.79789901853576, 56.5470912768095,
    ],
    'E06000004': [
      -1.45264121897064, 54.4641506390909, -1.15356261355329, 54.6452507844201,
    ],
    'E06000030': [
      -1.86512822557399, 51.4824545734086, -1.60282488305727, 51.6926580083977,
    ],
    'E06000020': [
      -2.6673621378111, 52.6145683443583, -2.31220797845677, 52.8283871797426,
    ],
    'E06000043': [
      -0.24504978694712, 50.7982099802651, -0.016002358369668, 50.8923794447914,
    ],
    'E06000034': [
      0.210335342771636, 51.4482791853102, 0.551656660191196, 51.56782140518,
    ],
    'W06000020': [
      -3.14392394952362, 51.6066749442671, -2.95889207220455, 51.7962320285536,
    ],
    'E06000027': [
      -3.62841211871871, 50.3734426023727, -3.45632280415079, 50.5184936925094,
    ],
    'E06000007': [
      -2.69772482754663, 53.3223303510826, -2.425380621562, 53.4809294219504,
    ],
    'E06000037': [
      -1.5880874456075, 51.3289603653114, -0.981700070875653, 51.5637124135033,
    ],
    'S12000039': [
      -4.6598902591745, 55.8891456242368, -4.37547456512933, 56.0842262154959,
    ],
    'S12000040': [
      -3.83124850637463, 55.7707148482205, -3.38662559636482, 56.0055107082107,
    ],
    'E06000054': [
      -2.36559678699086, 50.9449793576782, -1.48561782031052, 51.7031238925381,
    ],
    'E06000040': [
      -0.853907491772685, 51.3828005282468, -0.522777872600698, 51.5778285832504,
    ],
    'E06000041': [
      -1.01188405929674, 51.3520705024913, -0.788839993914029, 51.5621275783588,
    ],
    'W06000006': [
      -3.37552478500583, 52.8666086181746, -2.72413332413793, 53.1343258788144,
    ],
    'E06000014': [
      -1.22371908740097, 53.8746106755461, -0.91958074660491, 54.0568828853467,
    ],
    'E06000046': [
      -1.59204335444871, 50.5747107787024, -1.06293727996852, 50.7675558324552,
    ],
    'W06000001': [
      -4.7006903388905, 53.1261423431201, -4.01868331089932, 53.4358164489299,
    ],
    'W06000002': [
      -4.80438744086665, 52.5337690281257, -3.43678549411509, 53.2790911558775,
    ],
    'W06000008': [
      -4.69724127452133, 52.0267561327686, -3.65816741122617, 52.5624205207917,
    ],
    'W06000009': [
      -5.66932862445889, 51.5959329205194, -4.48561364040918, 52.1179671852459,
    ],
    'E06000044': [
      -1.17494520635836, 50.7498759283192, -1.01776918385845, 50.8592996552133,
    ],
    'E06000026': [
      -4.20554209198275, 50.3327281946421, -4.01963425625447, 50.4441538016389,
    ],
    'E06000057': [
      -2.68979023468094, 54.7823773837281, -1.46017353564779, 55.8116641911427,
    ],
    'E06000053': [
      -6.41901095937542, 49.8646317714512, -6.24410195443599, 49.9814584695712,
    ],
    'E06000061': [
      -0.906250314691577, 52.1915707007857, -0.341590492473876, 52.6435943394717,
    ],
    'W06000010': [
      -4.7231034056339, 51.6444452523022, -3.64713650260716, 52.1424075748023,
    ],
    'S12000020': [
      -3.76579783461056, 57.0684406458242, -2.64982470171258, 57.7306613063496,
    ],
    'S12000028': [
      -5.12469945648004, 54.9976555108558, -4.39885661385345, 55.6018696580548,
    ],
    'S12000041': [
      -3.40702154650928, 56.4338846200438, -2.38441220469901, 56.9868040921257,
    ],
    'S12000034': [
      -3.80164622664352, 56.7471285365992, -1.76439247202929, 57.7017420196347,
    ],
    'S12000047': [
      -3.73991275526143, 56.0057209652165, -2.54424338385316, 56.4534896181324,
    ],
    'S12000033': [
      -2.36092443915212, 57.0761748772513, -2.01615966035446, 57.2353376284174,
    ],
    'S12000036': [
      -3.44952924107955, 55.818791345111, -3.07495657182891, 56.0126238536894,
    ],
    'S12000010': [
      -3.08928393595174, 55.8173173470177, -2.36327812087034, 56.079307974158,
    ],
    'S12000021': [
      -5.39782882550735, 55.423568998296, -4.49245474105347, 55.8926081111344,
    ],
    'S12000006': [
      -5.18762487606129, 54.6332196102286, -2.85733651418674, 55.4640518758031,
    ],
    'S12000013': [
      -8.64999583330431, 56.7779199915863, -5.81038441274624, 59.1346710696584,
    ],
    'S12000027': [
      -2.11754636317171, 59.5067976464145, -0.72445004960577, 60.8608667561475,
    ],
    'S12000023': [
      -4.50783259735309, 58.6729807700618, -2.36801790704826, 59.3997320406489,
    ],
    'E06000065': [
      -2.56474222741882, 53.6211015738222, -0.21231315559879, 54.5621697606197,
    ],
    'E06000066': [
      -3.83982066625529, 50.8208538038476, -2.24439816478264, 51.3329995512005,
    ],
    'W06000011': [
      -4.33380535779627, 51.5349892278571, -3.84274318431454, 51.7741949732821,
    ],
    'W06000022': [
      -3.1241920442001, 51.4949251535878, -2.80301106787193, 51.6494706648247,
    ],
    'E06000010': [
      -0.42257985113171, 53.7115875148494, -0.241453823958227, 53.8132701672882,
    ],
    'E06000047': [
      -2.35574349125271, 54.4514863636621, -1.23887005004445, 54.9186889783122,
    ],
    'E06000011': [
      -1.10335931463428, 53.5704281751492, 0.148810955938276, 54.1765400827641,
    ],
    'E06000001': [
      -1.38376723660419, 54.6216702716847, -1.14754877810444, 54.727168687781,
    ],
    'W06000015': [
      -3.34377712509382, 51.3745402420792, -3.06891000794599, 51.5605050149904,
    ],
    'W06000021': [
      -3.15735167770916, 51.5172095318528, -2.64986721904377, 51.9831362974613,
    ],
    'E06000024': [
      -3.11533785081796, 51.2906145791208, -2.58720161761044, 51.5026666701013,
    ],
    'E06000052': [
      -5.74716494510321, 49.9563793812002, -4.16510223584134, 50.9312684886808,
    ],
    'E06000063': [
      -3.64060718211114, 54.1678279124833, -2.48233944919166, 55.1889832491643,
    ],
    'S12000017': [
      -6.78968956940273, 56.4970741098359, -3.02396644246199, 58.6975076943506,
    ],
    'S12000035': [
      -7.11348533226884, 55.2744828749286, -4.55983966622687, 56.7050611391621,
    ],
    'E07000081': [
      -2.30135325369926, 51.80758040165, -2.17725789160801, 51.8852241000915,
    ],
    'E07000103': [
      -0.439543240235569, 51.637117243535, -0.368766140427457, 51.7019427464431,
    ],
    'E07000135': [
      -1.14451244826743, 52.5561689578573, -1.04135762765073, 52.6180668313852,
    ],
    'E07000138': [
      -0.622616974304759, 53.1863260710722, -0.493914707716645, 53.2545749922524,
    ],
    'E07000175': [
      -1.17789116216515, 52.956994397329, -0.666262020635388, 53.2610356927715,
    ],
    'E07000178': [
      -1.30422964072168, 51.7109837159491, -1.1757937183455, 51.7962718701282,
    ],
    'E07000072': [
      -0.019743117773443, 51.6044152926275, 0.347595797499802, 51.8221540085985,
    ],
    'E07000068': [
      0.175702646497488, 51.5642993932384, 0.412560206765404, 51.7170130529691,
    ],
    'E07000062': [
      0.500641043247489, 50.8410936596538, 0.659429412304273, 50.8948246030523,
    ],
    'E07000061': [
      0.209381082631183, 50.7334847394501, 0.339691354347268, 50.813073201165,
    ],
    'E07000073': [
      0.054068810963473, 51.7346870732877, 0.168018960489515, 51.797233006516,
    ],
    'E07000042': [
      -3.9259298618892, 50.7031832610266, -3.14237089952179, 51.0338685829916,
    ],
    'E07000047': [
      -4.33522645925439, 50.4294008391217, -3.7322467927287, 50.8746132849403,
    ],
    'E07000045': [
      -3.88282414982757, 50.4611272323981, -3.42209699212031, 50.7639969289984,
    ],
    'E07000084': [
      -1.46015235805229, 51.133540146428, -0.974796238369647, 51.3839112051256,
    ],
    'E07000034': [
      -1.48416816009004, 53.2124654665163, -1.30130161259842, 53.2990039261294,
    ],
    'E07000086': [
      -1.39973385225782, 50.8420068624885, -1.25815427373225, 51.0043613192758,
    ],
    'E07000033': [
      -1.37824733610585, 53.0809878876668, -1.1664875414478, 53.3129491235298,
    ],
    'E07000032': [
      -1.61009488331144, 52.9242077388049, -1.30742618330068, 53.1339645595524,
    ],
    'E07000036': [
      -1.47987741936354, 52.8723578783783, -1.23839765593724, 53.0036246084852,
    ],
    'E07000088': [
      -1.21446985626163, 50.7731279237942, -1.11176086753437, 50.8400605385728,
    ],
    'E07000076': [
      0.931164559877733, 51.7675298784442, 1.29674621780299, 51.9596458319512,
    ],
    'E07000096': [
      -0.745850818776215, 51.679834158485, -0.404858806630098, 51.8581573404529,
    ],
    'E07000071': [
      0.699531426356406, 51.7657133533927, 1.02683354149244, 51.9771656610416,
    ],
    'E07000240': [
      -0.44058423783946, 51.6875908514074, -0.241581155478973, 51.8496055510724,
    ],
    'E07000241': [
      -0.277542611055781, 51.6855093693943, -0.092141320835119, 51.860443867016,
    ],
    'E07000066': [
      0.375126917595192, 51.5298296194431, 0.568795260839047, 51.6512419575078,
    ],
    'E07000080': [
      -2.68754079798265, 51.5947048282295, -2.26753675939118, 52.0238900050318,
    ],
    'E07000041': [
      -3.57013788954439, 50.6731915051072, -3.45110268623978, 50.7614550781156,
    ],
    'E07000082': [
      -2.54081319713281, 51.5898340409186, -2.06862413773313, 51.8504631424275,
    ],
    'E07000083': [
      -2.35274776228366, 51.8193099744553, -1.80167920800798, 52.050598910736,
    ],
    'E07000078': [
      -2.14301431485322, 51.8583412596567, -2.01021519154428, 51.9388870760226,
    ],
    'E07000094': [
      -1.45650350398392, 50.8550832437244, -1.03389467972924, 51.1970344714627,
    ],
    'E07000109': [
      0.310685334757213, 51.3250060447047, 0.491196227907712, 51.4693402911553,
    ],
    'E07000038': [
      -1.59930007238949, 53.1033600954658, -1.28201141324174, 53.341992492071,
    ],
    'E07000242': [
      -0.183598135116009, 51.7342715993096, 0.195613946593584, 51.9971696634496,
    ],
    'E07000243': [
      -0.234371697047689, 51.8692676944124, -0.146817430268182, 51.9324133792184,
    ],
    'E07000112': [
      0.776870855211829, 50.9105478358631, 1.22126808619974, 51.2050041949687,
    ],
    'E07000114': [
      1.21078174878976, 51.3079727866563, 1.45152432213536, 51.3978980759976,
    ],
    'E07000106': [
      0.937239766991506, 51.1771736385723, 1.25009821652181, 51.3818801153756,
    ],
    'E07000108': [
      1.1427753690613, 51.0971917698531, 1.40622134765192, 51.3323869927071,
    ],
    'E07000107': [
      0.149159930322975, 51.38653982156, 0.344626764730069, 51.4822727917385,
    ],
    'E07000087': [
      -1.31293000320094, 50.8089299221002, -1.11228753129536, 50.8990110983745,
    ],
    'E07000102': [
      -0.539260817248429, 51.5995908742148, -0.362621257698241, 51.7408368511604,
    ],
    'E07000098': [
      -0.386831198305677, 51.623504817498, -0.163118088645696, 51.7381452538131,
    ],
    'E07000095': [
      -0.114148403497219, 51.6808778155788, 0.014553926406978, 51.7806080633279,
    ],
    'E07000128': [
      -3.06937050972247, 53.819987299716, -2.61346369041862, 53.9802440537051,
    ],
    'E07000142': [
      -0.820654448801815, 53.1788371561448, -0.131844979439125, 53.6163880602418,
    ],
    'E07000140': [
      -0.30680987858175, 52.6515074247825, 0.272997728831414, 52.9730992570136,
    ],
    'E07000136': [
      -0.246700235672091, 52.8628301048608, 0.237402365541289, 53.0867413509631,
    ],
    'E07000139': [
      -0.764141500639807, 52.8869959783769, -0.189776225218982, 53.2580135174553,
    ],
    'E07000137': [
      -0.317479244654575, 53.00112044826, 0.357975526354258, 53.5331261546794,
    ],
    'E07000171': [
      -1.21302650313245, 53.1963979236758, -0.747138182399111, 53.5025165293909,
    ],
    'E07000173': [
      -1.23128870787785, 52.9481811898795, -1.00708600519626, 53.1039601611064,
    ],
    'E07000170': [
      -1.34459026764461, 53.0080803433272, -1.16425148277133, 53.1714705792147,
    ],
    'E07000172': [
      -1.33639245011107, 52.8922892374961, -1.1823012510609, 53.0544834267596,
    ],
    'E07000174': [
      -1.26006786057334, 53.1148104411525, -1.09476360068258, 53.2356354068621,
    ],
    'E07000179': [
      -1.29022497489805, 51.459414233515, -0.870025174755948, 51.8137775288111,
    ],
    'E07000181': [
      -1.71948863302901, 51.68381068006, -1.2861370266748, 51.9968565673043,
    ],
    'E07000200': [
      0.626886372153874, 51.9446470433216, 1.28758872234273, 52.1813160127578,
    ],
    'E07000202': [
      1.10727569557284, 52.0201739462892, 1.22361032387657, 52.0944696524962,
    ],
    'E07000235': [
      -2.66320847345991, 51.9665649342157, -2.14874241594222, 52.3685470248294,
    ],
    'E07000238': [
      -2.27604676993057, 51.9994154033037, -1.75739824866764, 52.3612318654663,
    ],
    'E07000237': [
      -2.2632049947519, 52.1616475389051, -2.15674518581966, 52.2314054157501,
    ],
    'E07000236': [
      -2.01892882131527, 52.235261331702, -1.87520703557667, 52.3242122369594,
    ],
    'E07000229': [
      -0.446531773483826, 50.8003586261559, -0.331217405441285, 50.8632519060736,
    ],
    'E09000018': [
      -0.46148169282775, 51.4206290165035, -0.243366811301174, 51.502847528294,
    ],
    'E09000009': [
      -0.419602534853399, 51.4904761558315, -0.245134655699555, 51.5596573963232,
    ],
    'E09000016': [
      0.138184235471144, 51.4841543162352, 0.334044063437149, 51.6317377623678,
    ],
    'E09000005': [
      -0.335555531666752, 51.5276386365623, -0.191467608561554, 51.6003719685842,
    ],
    'E09000003': [
      -0.305573663802058, 51.5551909329255, -0.129093931888576, 51.6701702737025,
    ],
    'E09000022': [
      -0.151211614592545, 51.4109912658389, -0.078287681880069, 51.509874369998,
    ],
    'E09000028': [
      -0.111466570920131, 51.4206047143525, -0.029361562844983, 51.5099088402223,
    ],
    'E09000023': [
      -0.075085492971336, 51.4135347104259, 0.039067801957852, 51.4935338213072,
    ],
    'E09000011': [
      -0.026372833724831, 51.4237003708481, 0.12419108741121, 51.5135780956906,
    ],
    'E07000010': [
      -0.197873350783597, 52.3857499512989, 0.236319141863767, 52.7400005596077,
    ],
    'E07000012': [
      -0.234804043652189, 52.005763096481, 0.420886391436469, 52.3535311550687,
    ],
    'E07000009': [
      0.034420786781512, 52.1563999647373, 0.514484042486228, 52.5136222736722,
    ],
    'E07000011': [
      -0.499890992452227, 52.1587665256199, 0.051346857173934, 52.5832956965298,
    ],
    'E07000008': [
      0.068638841385944, 52.1579417014909, 0.184552035598734, 52.2372898804823,
    ],
    'E07000039': [
      -1.74965218944041, 52.6965009705607, -1.31902284313031, 52.9481623126299,
    ],
    'E07000035': [
      -1.91849652236219, 52.8686931604978, -1.49536574441841, 53.3919108271105,
    ],
    'E07000063': [
      -0.135857511781896, 50.7543269147946, 0.154538948130836, 51.0025138340307,
    ],
    'E07000064': [
      0.321585740673586, 50.8199003515002, 0.867891381774926, 51.0836452272886,
    ],
    'E07000075': [
      0.54903494812593, 51.5091714693742, 1.08389117388862, 51.6582381067184,
    ],
    'E07000077': [
      0.068156072556951, 51.767318510819, 0.519283395743268, 52.0926741553906,
    ],
    'E07000070': [
      0.332191422515801, 51.6166773394353, 0.648850135362967, 51.8574913522599,
    ],
    'E07000067': [
      0.379612827815692, 51.7504160873722, 0.782289933329653, 52.0870401677281,
    ],
    'E07000085': [
      -1.13178977908392, 50.8672523792294, -0.744587902767519, 51.2127367564152,
    ],
    'E07000093': [
      -1.69410720996231, 50.9282102622825, -1.30882299401137, 51.3393521221222,
    ],
    'E07000099': [
      -0.406299599690257, 51.8332340598732, 0.074321848151726, 52.0804409513694,
    ],
    'E07000111': [
      0.033546182249693, 51.1318045049806, 0.344726181966788, 51.4179768318443,
    ],
    'E07000105': [
      0.590330190794803, 50.9894920251371, 1.029240945946, 51.2702458933181,
    ],
    'E07000110': [
      0.37813185237855, 51.1339445383835, 0.796469114922585, 51.3387431250211,
    ],
    'E07000113': [
      0.600980219755268, 51.224347697565, 1.01710120719194, 51.4491208723973,
    ],
    'E07000127': [
      -3.08453968747921, 53.4827816885128, -2.68945573934377, 53.7375448897721,
    ],
    'E07000121': [
      -2.97745735762053, 53.9180797323255, -2.4587382202994, 54.2395684104832,
    ],
    'E07000118': [
      -2.82425882081878, 53.5936009506964, -2.51132292934796, 53.7513640648945,
    ],
    'E09000004': [
      0.074668079800111, 51.4084291289347, 0.223704303030081, 51.5157693633045,
    ],
    'E09000010': [
      -0.185893323219588, 51.6056467853338, -0.008922103472904, 51.6918756451179,
    ],
    'E09000031': [
      -0.062222978598206, 51.5499066882953, 0.025738664606171, 51.6465278478357,
    ],
    'E09000026': [
      0.00869444540429, 51.5435618414325, 0.149510112602879, 51.6290181021025,
    ],
    'E09000032': [
      -0.259111198831886, 51.4177517059903, -0.12630848820243, 51.4858909438919,
    ],
    'E09000013': [
      -0.255064221072407, 51.4639156529124, -0.177579670548771, 51.5327375103472,
    ],
    'E09000020': [
      -0.228730175524929, 51.4772333907183, -0.149806087718761, 51.5303191572033,
    ],
    'E09000033': [
      -0.216066490837136, 51.4838070641767, -0.111057012329661, 51.5398141593737,
    ],
    'E09000007': [
      -0.213486677002519, 51.5126606829041, -0.105290341558648, 51.5729628336939,
    ],
    'E09000030': [
      -0.080182948054445, 51.4844938066359, 0.009854979455204, 51.5446874669901,
    ],
    'E09000019': [
      -0.142482591057135, 51.5185548587508, -0.076304951541696, 51.5755067662442,
    ],
    'E09000012': [
      -0.104483220665044, 51.5198188248555, -0.016508048209857, 51.5777860371156,
    ],
    'E09000017': [
      -0.510306927066975, 51.4532905922729, -0.375918843631766, 51.6317692056353,
    ],
    'E09000015': [
      -0.404003977890064, 51.553084604915, -0.267113115479641, 51.6405355675681,
    ],
    'E09000002': [
      0.066676001291753, 51.5087722598847, 0.190222134044087, 51.5994359408699,
    ],
    'E09000001': [
      -0.113803703413632, 51.5068722658641, -0.072735598345549, 51.5233140396699,
    ],
    'E07000044': [
      -4.19785119310802, 50.2018041496927, -3.50753464345882, 50.542619066034,
    ],
    'E07000046': [
      -4.68099571415924, 50.6465405363165, -3.88384632533369, 51.2026630086541,
    ],
    'E09000014': [
      -0.17123183297214, 51.5646473489419, -0.041390716789704, 51.6112183462889,
    ],
    'E09000025': [
      -0.021269184611892, 51.4960042692299, 0.099807240486326, 51.5640217712285,
    ],
    'E07000126': [
      -2.8709140560302, 53.6713341284435, -2.54552871324723, 53.7828439936988,
    ],
    'E07000125': [
      -2.41100664469002, 53.6144780087313, -2.14514650166405, 53.7550449889071,
    ],
    'E07000119': [
      -3.07101157080022, 53.7217495742737, -2.78049059979349, 53.8648458448533,
    ],
    'E07000123': [
      -2.82599421787706, 53.7480082197954, -2.59548594674367, 53.8961527918449,
    ],
    'E07000122': [
      -2.33362325046648, 53.8057083891249, -2.04507530403921, 53.9522113899003,
    ],
    'E07000124': [
      -2.65083208213507, 53.7561996897178, -2.18446422707568, 54.0490890614635,
    ],
    'E07000120': [
      -2.46580771374763, 53.7047330061155, -2.31372441355751, 53.8166191916107,
    ],
    'E07000117': [
      -2.3423059086941, 53.7229850475233, -2.11227899052983, 53.8252766069024,
    ],
    'E07000132': [
      -1.57135993877814, 52.5010544845768, -1.19968163037784, 52.7152889033589,
    ],
    'E07000134': [
      -1.59765689569831, 52.6639580217486, -1.24714069691699, 52.8770804463604,
    ],
    'E07000131': [
      -1.30594754120562, 52.3921717367682, -0.713283742057328, 52.6849514564235,
    ],
    'E07000129': [
      -1.3391283279794, 52.4932134381993, -1.05939219116329, 52.6644018183087,
    ],
    'E07000130': [
      -1.33506626371415, 52.6538661474147, -0.947237799575772, 52.8247266344066,
    ],
    'E07000141': [
      -0.804315967166995, 52.6402363852471, -0.212500265341941, 53.0599718209467,
    ],
    'E07000145': [
      1.54470230497806, 52.5260245799128, 1.74651240578324, 52.7426618870661,
    ],
    'E07000149': [
      0.947028051906419, 52.3553552572144, 1.68265179336108, 52.6785176715788,
    ],
    'E07000146': [
      0.153570700388405, 52.4364525839507, 0.821569075850233, 52.9893362106238,
    ],
    'E07000143': [
      0.530520987316443, 52.3695193799926, 1.10832230213001, 52.8111265219668,
    ],
    'E07000148': [
      1.20389047148497, 52.5554008933987, 1.54080918373269, 52.6849122842598,
    ],
    'E07000176': [
      -1.27528282314089, 52.7894115471348, -0.815158220785605, 53.0359284297717,
    ],
    'E07000196': [
      -2.32547507277904, 52.4232580756115, -1.98375589790156, 52.7864326579289,
    ],
    'E07000194': [
      -1.96322524496663, 52.58491212247, -1.58639414261275, 52.807809408498,
    ],
    'E07000197': [
      -2.41634660240013, 52.7150475065369, -1.93328950295548, 52.9805750697944,
    ],
    'E07000193': [
      -2.04359043077471, 52.7298805831025, -1.58538036585949, 53.0459993044682,
    ],
    'E07000192': [
      -2.05463221958658, 52.6396953734293, -1.91080679278257, 52.7741967349443,
    ],
    'E07000199': [
      -1.7358367339896, 52.5886539158903, -1.63298182844691, 52.6574900038479,
    ],
    'E07000244': [
      1.15783883919243, 51.9317455708316, 1.76897527530873, 52.5502584781908,
    ],
    'E07000216': [
      -0.84892972737272, 51.0714916867383, -0.413236600134928, 51.2450647475977,
    ],
    'E07000215': [
      -0.155051415842584, 51.1367655212928, 0.058242830201613, 51.3387247442131,
    ],
    'E07000217': [
      -0.649961674973826, 51.2654861134023, -0.460963863965282, 51.3496301567285,
    ],
    'E07000214': [
      -0.775466206963731, 51.2792835238098, -0.548491682088978, 51.3924588428026,
    ],
    'E07000212': [
      -0.619634818010671, 51.3388579994845, -0.457885893491634, 51.451007631736,
    ],
    'E07000209': [
      -0.748336015847959, 51.1732178124203, -0.387124037906654, 51.3315135971617,
    ],
    'E07000210': [
      -0.438436754321913, 51.1051476216347, -0.17659046298367, 51.3350844126725,
    ],
    'E07000207': [
      -0.481185717452966, 51.2948524375411, -0.307365443633207, 51.412050818527,
    ],
    'E07000213': [
      -0.54061316396913, 51.3784086086375, -0.383350026681253, 51.4715651296222,
    ],
    'E07000218': [
      -1.78846071184577, 52.4354715665142, -1.45999402369308, 52.6872608081784,
    ],
    'E07000220': [
      -1.46509215196856, 52.2527318966475, -1.17212636579044, 52.5344864311728,
    ],
    'E07000222': [
      -1.780126883137, 52.2137189111782, -1.40607766791026, 52.3892994855589,
    ],
    'E07000221': [
      -1.96199927454645, 51.9554034171782, -1.23169963071516, 52.3681096061345,
    ],
    'E07000219': [
      -1.55618044552742, 52.4500680663581, -1.40281154869425, 52.5519783440298,
    ],
    'E07000224': [
      -0.764807632552036, 50.7563278194471, -0.363491468340713, 50.9058708994232,
    ],
    'E07000223': [
      -0.371517018515527, 50.8164384014371, -0.215294488990349, 50.8747381452188,
    ],
    'E07000225': [
      -0.957585094925949, 50.7217691115733, -0.473153442260804, 51.0944841769189,
    ],
    'E07000228': [
      -0.249081348544969, 50.8678855967986, 0.044536960768229, 51.1427668399436,
    ],
    'E07000227': [
      -0.568956178607153, 50.8621551938147, -0.199999558110664, 51.1431317175381,
    ],
    'E07000226': [
      -0.255607356566176, 51.0848057281517, -0.132952086272834, 51.1673002891983,
    ],
    'E07000239': [
      -2.43650998244075, 52.3148509529162, -2.11921321829335, 52.4553169285039,
    ],
    'E07000234': [
      -2.16777834528713, 52.2780600047739, -1.84547409706993, 52.4452835394779,
    ],
    'E09000021': [
      -0.330732916145702, 51.3262940086094, -0.238730295207436, 51.4372878651698,
    ],
    'E09000008': [
      -0.161879752207213, 51.2867903196393, 0.003315240725427, 51.4232442695196,
    ],
    'E09000006': [
      -0.081087689298542, 51.2893537136896, 0.162384150043184, 51.4443279483964,
    ],
    'E07000147': [
      0.707938541626203, 52.6796337683427, 1.67513325040273, 52.9915569214113,
    ],
    'E07000037': [
      -2.03413245806883, 53.1947156946477, -1.65381782187416, 53.5404681760807,
    ],
    'E07000198': [
      -2.21131492476988, 52.9166465532316, -1.77564415425255, 53.2262417356404,
    ],
    'E07000195': [
      -2.47078916929654, 52.8739991626498, -2.18108615815399, 53.1158244641257,
    ],
    'E07000040': [
      -3.58557372868623, 50.6057893240339, -2.88664434482201, 50.9087424081833,
    ],
    'E07000133': [
      -1.04662334791221, 52.6458257656294, -0.664101453534753, 52.9776791173126,
    ],
    'E07000079': [
      -2.32356890393657, 51.5775574063977, -1.61518893058729, 52.1125783283983,
    ],
    'E07000245': [
      0.339943777893116, 52.0538142818942, 0.967471013134576, 52.4625416477789,
    ],
    'E07000203': [
      0.797577110916504, 52.0651379318819, 1.4095085144785, 52.4044243835646,
    ],
    'E07000091': [
      -1.95726958215592, 50.7059581330915, -1.30299192048895, 51.0094733419781,
    ],
    'E07000180': [
      -1.70028207355629, 51.5182939240412, -1.20220879160645, 51.7901381921407,
    ],
    'E07000177': [
      -1.52282569381325, 51.7809626915752, -1.0471229362899, 52.168485056197,
    ],
    'E07000074': [
      0.589128957004079, 51.6184488097504, 0.982219094907167, 51.8291268110924,
    ],
    'E07000069': [
      0.515763002267105, 51.5006447177548, 0.704133442179554, 51.5882717795873,
    ],
    'E07000089': [
      -1.00227767688334, 51.1860036088581, -0.76290312001552, 51.3663170663636,
    ],
    'E07000092': [
      -0.80752379242497, 51.2304556185928, -0.729325031346628, 51.3200843382103,
    ],
    'E07000211': [
      -0.272234355213241, 51.1595843412691, -0.124292859195443, 51.3435951607866,
    ],
    'E09000027': [
      -0.392912348231466, 51.3914306048966, -0.221737464202912, 51.4896887301858,
    ],
    'E09000024': [
      -0.254238567069917, 51.380182375519, -0.124139637510634, 51.4414645849425,
    ],
    'E07000065': [
      -0.036213376436162, 50.7369193601826, 0.450159515881868, 51.1474540323236,
    ],
    'E07000116': [
      0.150026056891697, 51.0034320703817, 0.646674841425981, 51.2016169643177,
    ],
    'E07000090': [
      -1.05488331890077, 50.7711632255033, -0.926450186989275, 50.9096500803222,
    ],
    'E07000208': [
      -0.30618917299884, 51.2923303488632, -0.217264425534208, 51.380221787637,
    ],
    'E07000115': [
      0.2005423369464, 51.1746934858577, 0.526777175865602, 51.3687628438094,
    ],
    'E09000029': [
      -0.245382434157475, 51.3214852871721, -0.116842029977448, 51.3934129467947,
    ],
    'E07000144': [
      0.990368407777722, 52.5552395283621, 1.67804170895319, 52.8306138134714,
    ],
    'E07000043': [
      -4.26215236810162, 50.8763721224904, -3.59443007948347, 51.2468473368251,
    ],

  },
  // DE-LOKALBEHOERDE-START (generated by scripts/generate-de-lokalbehoerden.js from a BKG Gemeinde GeoJSON; code = 12-digit ARS)
  de: {
    '010010000000': [
      9.357602962443597, 54.75190183162364, 9.505956311339451, 54.82532243986243,
    ],
    '010020000000': [
      10.031097521919893, 54.25149150017379, 10.219131682720013, 54.4327791724031,
    ],
    '010030000000': [
      10.554574174726367, 53.76830187089972, 10.963860272303846, 53.99272298632269,
    ],
    '010040000000': [
      9.928820438717372, 54.01915117753047, 10.058256120119582, 54.15003915648935,
    ],
    '010510011011': [
      9.017503517160069, 53.8880997569695, 9.213495447529368, 53.94786404543892,
    ],
    '010510044044': [
      9.051951864302673, 54.161384789163115, 9.210051768451715, 54.21831954170202,
    ],
    '010515163003': [
      9.163193914035103, 53.91926153658687, 9.230029009082607, 53.958933779302676,
    ],
    '010515163010': [
      9.20512781478814, 53.99760814299865, 9.278350051885925, 54.021610980038716,
    ],
    '010515163012': [
      9.182763177449829, 53.952396880833724, 9.272555138225206, 53.99953005487524,
    ],
    '010515163016': [
      9.241966248228005, 53.97559860544588, 9.297795668864554, 54.014641661924934,
    ],
    '010515163022': [
      9.083707401997614, 53.9449977129963, 9.166991766917787, 53.980380630004454,
    ],
    '010515163024': [
      9.104149523611417, 53.92982801216333, 9.188734088177448, 53.96653792473555,
    ],
    '010515163026': [
      9.23386866587238, 54.03450612161381, 9.29028048555561, 54.07851378336427,
    ],
    '010515163032': [
      9.152770327543246, 54.00654216919354, 9.204122212159463, 54.055560518807575,
    ],
    '010515163037': [
      9.202594020952784, 54.01371880815292, 9.278350051885925, 54.04322973793913,
    ],
    '010515163051': [
      9.2659021184422, 53.99730889433964, 9.30102009929385, 54.03804569515787,
    ],
    '010515163064': [
      9.159540378898871, 53.944044875640486, 9.244006720084478, 53.99227935072188,
    ],
    '010515163089': [
      9.159436481246248, 53.980380630004454, 9.218556323297653, 54.01797151670936,
    ],
    '010515163097': [
      9.079662405955952, 53.965457128139846, 9.166991766917787, 54.01779296396509,
    ],
    '010515163110': [
      9.163621675168638, 54.02836236024688, 9.245083701753943, 54.07728198238342,
    ],
    '010515166021': [
      9.00100723546459, 53.92402095966529, 9.063320644039777, 53.957087073792565,
    ],
    '010515166034': [
      8.677237467228917, 53.95185737411913, 8.976698441644775, 54.07009771707879,
    ],
    '010515166046': [
      8.983588635907292, 53.95627737345164, 9.055531106947164, 53.991209378710785,
    ],
    '010515166057': [
      8.893535206265705, 53.91128789473163, 8.973437636118176, 53.95694385982331,
    ],
    '010515166062': [
      8.93950860087343, 53.91837031740366, 9.005287404191883, 54.0353547349906,
    ],
    '010515166072': [
      8.994916179178054, 53.943361454462135, 9.045005622618007, 53.9648224987461,
    ],
    '010515166073': [
      8.983588635907292, 53.941371510278195, 9.00100723546459, 53.95737963943718,
    ],
    '010515166076': [
      8.976520614135204, 53.904067683126, 9.084132750030202, 53.94423999144206,
    ],
    '010515166077': [
      8.942652578083917, 53.890952752491316, 9.018480906793359, 53.92080640414389,
    ],
    '010515166090': [
      9.063320644039777, 53.92873768195252, 9.109118958419124, 53.951083079904244,
    ],
    '010515166103': [
      9.011135580773905, 53.91184579715033, 9.071949513301865, 53.94615983536899,
    ],
    '010515166118': [
      8.994374007163323, 53.986590416633554, 9.046427475770447, 54.02485849303072,
    ],
    '010515166119': [
      9.037308365161888, 53.94615983536899, 9.114679395783764, 53.99783891300942,
    ],
    '010515169005': [
      9.162477498497104, 54.21237330614837, 9.201217679815594, 54.24486951354084,
    ],
    '010515169008': [
      9.1927795383363, 54.31023323840704, 9.226336917052047, 54.32627544758182,
    ],
    '010515169019': [
      9.335827951502173, 54.22148036102151, 9.443926105576745, 54.26609797635175,
    ],
    '010515169020': [
      9.219494212405534, 54.27793393926276, 9.282690338798014, 54.34687942247835,
    ],
    '010515169023': [
      9.285752623752728, 54.24544940370123, 9.348350196705423, 54.273923214223345,
    ],
    '010515169030': [
      9.079609363775475, 54.26278201960933, 9.160273880090562, 54.297294456366195,
    ],
    '010515169035': [
      9.191393498167065, 54.17785249130988, 9.24232423966079, 54.21622597780823,
    ],
    '010515169036': [
      9.201042468830721, 54.25634450567573, 9.250434420846805, 54.278985352619095,
    ],
    '010515169038': [
      8.97964856706443, 54.29452830123257, 9.021781030859811, 54.33577795531767,
    ],
    '010515169047': [
      8.946821766512112, 54.248520994852846, 9.045104167730454, 54.30080797497823,
    ],
    '010515169049': [
      9.14448101001774, 54.2661651890995, 9.205787886105439, 54.334543453220874,
    ],
    '010515169052': [
      9.277819671159303, 54.231728808007134, 9.309386851741856, 54.24976199109079,
    ],
    '010515169053': [
      9.199309998291268, 54.27824098326531, 9.245171899708756, 54.32715124466316,
    ],
    '010515169058': [
      8.907043660133747, 54.26528532396381, 8.983477978896127, 54.32430726000675,
    ],
    '010515169060': [
      9.109385104183529, 54.2873081529259, 9.157016880376208, 54.351697314550144,
    ],
    '010515169061': [
      9.007365272257854, 54.30850984474109, 9.067928989176712, 54.326033584973466,
    ],
    '010515169065': [
      8.981589483444615, 54.33356462860563, 9.064090529138198, 54.37750336955964,
    ],
    '010515169068': [
      9.160273880090562, 54.23509717091329, 9.233376023084283, 54.26956601579652,
    ],
    '010515169071': [
      9.017138802335792, 54.320167331064745, 9.064281157777144, 54.3375818005337,
    ],
    '010515169080': [
      9.108608541668929, 54.23932805005082, 9.166556436299336, 54.25955864155379,
    ],
    '010515169088': [
      9.251946508407904, 54.24875395408815, 9.342043910088522, 54.28764995432629,
    ],
    '010515169092': [
      9.00839514614589, 54.27281406250447, 9.08165968851722, 54.311333974728,
    ],
    '010515169096': [
      9.044508558213984, 54.31895206946688, 9.124016364251876, 54.370022236296364,
    ],
    '010515169100': [
      9.210836779291531, 54.22543705368849, 9.279654159041515, 54.27793393926276,
    ],
    '010515169102': [
      9.065801079094538, 54.29020474642295, 9.11991397273716, 54.33781502986668,
    ],
    '010515169114': [
      9.184974334466645, 54.18939303151427, 9.33873918699169, 54.24583209435201,
    ],
    '010515169117': [
      9.341247259502982, 54.24791090273609, 9.404041202857211, 54.29391068339509,
    ],
    '010515169120': [
      9.250434420846805, 54.2742848916661, 9.282690338798014, 54.28764995432629,
    ],
    '010515169125': [
      9.201217679815594, 54.18719100679568, 9.289668358481224, 54.21898029064747,
    ],
    '010515169131': [
      9.22413002226562, 54.208396449932394, 9.267620007892654, 54.22876527340005,
    ],
    '010515169133': [
      9.09456657377029, 54.255572182021965, 9.147109266952732, 54.27744790260047,
    ],
    '010515169136': [
      9.35904053116912, 54.201408268010674, 9.442891271128584, 54.23150458334828,
    ],
    '010515169139': [
      9.289668358481224, 54.18868023146313, 9.434951914458285, 54.23795613393487,
    ],
    '010515169141': [
      9.122676053009735, 54.21814693338841, 9.172123064039956, 54.2661651890995,
    ],
    '010515172048': [
      9.042940894648595, 54.13136638219241, 9.131663618840093, 54.17480031281432,
    ],
    '010515172067': [
      9.042940894648595, 54.14545731653798, 9.081843840150109, 54.16839482519847,
    ],
    '010515172069': [
      9.055811847115516, 54.16835070943316, 9.081970049731412, 54.199655314337285,
    ],
    '010515172075': [
      8.95191463278929, 54.20724784544699, 9.051951864302673, 54.26071669929615,
    ],
    '010515172081': [
      8.949816564559656, 54.16940206311246, 9.056228695113779, 54.21068478585984,
    ],
    '010515172082': [
      9.127456087549888, 54.12531521156886, 9.24640636030559, 54.19379489304832,
    ],
    '010515172087': [
      9.109600325198786, 54.202911534595, 9.158725355658696, 54.23272441149095,
    ],
    '010515172107': [
      9.032812535849278, 54.2364084285418, 9.09456657377029, 54.27921253646761,
    ],
    '010515172113': [
      8.947524695098014, 54.1356338299569, 9.059082742233837, 54.18233105668109,
    ],
    '010515172122': [
      9.047796926628816, 54.20781336848304, 9.125348699138815, 54.271178560286586,
    ],
    '010515172130': [
      9.047796926628816, 54.20318686616085, 9.085990930087249, 54.227244251261624,
    ],
    '010515175001': [
      9.242695226884667, 54.110969073732875, 9.314065770801525, 54.15933116420405,
    ],
    '010515175002': [
      9.228582617831533, 54.1447030204682, 9.283813187628128, 54.17785249130988,
    ],
    '010515175004': [
      9.107417579187786, 54.081400186561865, 9.205607575540085, 54.11117559563173,
    ],
    '010515175006': [
      8.961202054003904, 53.99686491985414, 9.119585707631868, 54.043453683024936,
    ],
    '010515175015': [
      9.27264021066977, 54.14573776868139, 9.389044351171243, 54.1737791093811,
    ],
    '010515175017': [
      8.978467550850242, 54.02694407325746, 9.085290387268607, 54.05450852458621,
    ],
    '010515175027': [
      8.952593721773297, 54.03925186785702, 9.094192900945572, 54.09402183915707,
    ],
    '010515175028': [
      9.036576383723968, 54.100469317155785, 9.142750836348185, 54.13822051441568,
    ],
    '010515175039': [
      9.077705258750319, 54.01168441848046, 9.157829593919976, 54.03925186785702,
    ],
    '010515175054': [
      9.289668358481224, 54.16818827032382, 9.313372778524226, 54.18939303151427,
    ],
    '010515175063': [
      9.126169171791789, 54.05547292707336, 9.255236454141826, 54.09431291086485,
    ],
    '010515175074': [
      8.94752728211598, 54.07287347111702, 9.143296085606451, 54.13264051557573,
    ],
    '010515175078': [
      9.097858912031901, 54.06363698040499, 9.164136685496581, 54.106930382301535,
    ],
    '010515175083': [
      9.157255522117774, 54.12704900452355, 9.228582617831533, 54.15772034831955,
    ],
    '010515175085': [
      9.340047334456159, 54.157292986277334, 9.443501002732535, 54.18447605961806,
    ],
    '010515175086': [
      9.31213361231307, 54.17258856820899, 9.439753109283256, 54.210283356486386,
    ],
    '010515175098': [
      9.129886941662566, 54.103056087061674, 9.223356638179801, 54.1362083055253,
    ],
    '010515175099': [
      9.251346643743906, 54.04235063769891, 9.313366928129069, 54.1138127263141,
    ],
    '010515175104': [
      9.239853354662278, 54.17194476751873, 9.2913413350266, 54.18939303151427,
    ],
    '010515175126': [
      9.301284074054955, 54.128764618570855, 9.360240143323963, 54.151826306439645,
    ],
    '010515175134': [
      9.085290387268607, 54.02142844517748, 9.169141121958715, 54.066117173413424,
    ],
    '010515175135': [
      9.085151410028356, 54.05848700952234, 9.129124304028375, 54.084629573458066,
    ],
    '010515175137': [
      8.92815445347191, 54.09234717290745, 9.062502303854338, 54.15099834081837,
    ],
    '010515175138': [
      9.193836749949156, 54.08730000945217, 9.279309630931493, 54.151440560628174,
    ],
    '010515178013': [
      8.825044092143592, 54.118482354760154, 8.89015461537134, 54.1549850701409,
    ],
    '010515178014': [
      8.87702517800033, 54.130387857458345, 8.911309087328071, 54.148949615432706,
    ],
    '010515178033': [
      8.921516011821373, 54.135862560415816, 8.973477728647048, 54.173900500257,
    ],
    '010515178043': [
      8.80643803523848, 54.16057982137234, 8.888650290041081, 54.205090883354266,
    ],
    '010515178045': [
      8.818819823022789, 54.181608407635466, 8.89123696080895, 54.21612861985875,
    ],
    '010515178050': [
      8.847367180108458, 54.21154863275575, 8.894690476147769, 54.2363153786774,
    ],
    '010515178079': [
      8.869481160294182, 54.20592241600473, 8.926430722898871, 54.244744716044885,
    ],
    '010515178084': [
      8.879832262478445, 54.14799917026931, 8.922486381588575, 54.173544721883076,
    ],
    '010515178093': [
      8.883016228309984, 54.16172915386259, 8.932127853637043, 54.19040453177431,
    ],
    '010515178105': [
      8.90366476612107, 54.22988307217434, 8.959115971001008, 54.26528532396381,
    ],
    '010515178108': [
      8.932184634345683, 54.25300170108952, 9.004584019957916, 54.268541732446195,
    ],
    '010515178109': [
      8.874322760027754, 54.18719034753644, 8.937038088797493, 54.211535157265814,
    ],
    '010515178121': [
      8.908401939525616, 54.125702220789584, 8.951501105529115, 54.15687543252823,
    ],
    '010515178127': [
      8.910313731754144, 54.19818136942862, 8.948185137408927, 54.230774897585974,
    ],
    '010515178128': [
      8.929665744190952, 54.16567544319238, 8.959397593337876, 54.19818136942862,
    ],
    '010515178129': [
      8.83246444378196, 54.21358555117418, 8.932184634345683, 54.287639203658536,
    ],
    '010515178132': [
      8.816376900982123, 54.14524750832771, 8.89015461537134, 54.1693883823522,
    ],
    '010515178140': [
      8.93439889884862, 54.18720371786102, 9.012420312363824, 54.23438263359529,
    ],
    '010530032032': [
      10.314000439382335, 53.398589026909974, 10.466429093530374, 53.46023841917041,
    ],
    '010530083083': [
      10.516904642695014, 53.36107364863529, 10.588566723074726, 53.39278427502821,
    ],
    '010530090090': [
      10.652202079536487, 53.57427687104724, 10.75396619098852, 53.65459500451055,
    ],
    '010530100100': [
      10.727562711016086, 53.67036384571435, 10.826873900136187, 53.780750011147404,
    ],
    '010530116116': [
      10.445321950861619, 53.48337931011892, 10.510500261340052, 53.51732164603451,
    ],
    '010530129129': [
      10.236715326604724, 53.481020385885444, 10.28536419927647, 53.50859570555736,
    ],
    '010535308008': [
      10.630263880819518, 53.67770445389239, 10.692019132500587, 53.72374031848967,
    ],
    '010535308009': [
      10.612875706788499, 53.714993782558075, 10.682404164062078, 53.75388509683761,
    ],
    '010535308011': [
      10.552997386207574, 53.754649718027245, 10.627080620603998, 53.790326621853936,
    ],
    '010535308024': [
      10.556270885092278, 53.724076200208785, 10.591932011525449, 53.745091302195235,
    ],
    '010535308034': [
      10.597986982448441, 53.70841653101776, 10.644967950236216, 53.73472272077408,
    ],
    '010535308061': [
      10.542863689595302, 53.729191648714014, 10.58733375943961, 53.765329738547,
    ],
    '010535308067': [
      10.639720466526095, 53.752098697793436, 10.701639702451077, 53.785906701665425,
    ],
    '010535308075': [
      10.635047073575835, 53.77424307244362, 10.669108933287994, 53.79584307266011,
    ],
    '010535308094': [
      10.600471848896456, 53.693165402025436, 10.644967950236216, 53.715368897670466,
    ],
    '010535308103': [
      10.585609832098037, 53.736400253010025, 10.648955840342152, 53.76978937583521,
    ],
    '010535308120': [
      10.58198778049386, 53.716644776516134, 10.619765780836762, 53.749098746741275,
    ],
    '010535313002': [
      10.639942724564609, 53.60218748973215, 10.674218701145362, 53.64482700689828,
    ],
    '010535313005': [
      10.581245541069665, 53.61144690763256, 10.644742052561087, 53.629619862768294,
    ],
    '010535313013': [
      10.521041942296614, 53.5939135293855, 10.581515641179513, 53.6261321964215,
    ],
    '010535313014': [
      10.566509553371281, 53.58481747175459, 10.66647515139829, 53.614745920686644,
    ],
    '010535313037': [
      10.666375448298172, 53.542007775372184, 10.71826898583673, 53.59027641518056,
    ],
    '010535313056': [
      10.629388886020678, 53.542138274225564, 10.681225065942302, 53.56647807874516,
    ],
    '010535313084': [
      10.709657626232906, 53.5620315163396, 10.76648989681153, 53.60311666084943,
    ],
    '010535313095': [
      10.571440832794593, 53.57302384298685, 10.629956070100464, 53.60291309543508,
    ],
    '010535313113': [
      10.506880334820327, 53.57454470734567, 10.577604640926886, 53.604599116758784,
    ],
    '010535313125': [
      10.549132834173665, 53.558815305006384, 10.587639711149185, 53.58622723623485,
    ],
    '010535313134': [
      10.627801897584579, 53.561312707891815, 10.678322949919794, 53.58789177821486,
    ],
    '010535318010': [
      10.690654079597483, 53.513614863070394, 10.75714485628459, 53.574461129823746,
    ],
    '010535318015': [
      10.634290261451445, 53.454458917411145, 10.70295908603927, 53.4924717882224,
    ],
    '010535318020': [
      10.575251160327925, 53.46586555187612, 10.678428259478359, 53.50317872066618,
    ],
    '010535318029': [
      10.626282224680487, 53.49283970333512, 10.678428259478359, 53.51836528116673,
    ],
    '010535318035': [
      10.687321418569681, 53.52090800518178, 10.724846581018538, 53.54630610045145,
    ],
    '010535318046': [
      10.73451413897296, 53.50756964296622, 10.831002464111736, 53.60478743536365,
    ],
    '010535318048': [
      10.655225328834764, 53.517222520398015, 10.690654079597483, 53.55254828315591,
    ],
    '010535318064': [
      10.561409040991164, 53.50284806124654, 10.601708529181671, 53.523391956637404,
    ],
    '010535318080': [
      10.676420068345186, 53.45546182265817, 10.784644515763441, 53.52118872126542,
    ],
    '010535318092': [
      10.500104163533898, 53.48195112516361, 10.580178049370929, 53.514838541999765,
    ],
    '010535318104': [
      10.56932303409191, 53.517610670019195, 10.65724997791039, 53.55441722863655,
    ],
    '010535318115': [
      10.507682319161594, 53.46213552669554, 10.595017903271197, 53.48797795932777,
    ],
    '010535318119': [
      10.599660168965164, 53.497455863259056, 10.631867612244994, 53.52456865140064,
    ],
    '010535318126': [
      10.586354492526166, 53.54628164534529, 10.63412214515711, 53.57510540307513,
    ],
    '010535318132': [
      10.558153480160438, 53.44411839896534, 10.634909387993734, 53.47091535294011,
    ],
    '010535323003': [
      10.299973021039193, 53.511317941575726, 10.34478920248044, 53.53253866118182,
    ],
    '010535323012': [
      10.250989882324955, 53.45451168131606, 10.305796177324599, 53.49763948755201,
    ],
    '010535323023': [
      10.343243387432215, 53.480591141437564, 10.40058755243177, 53.506615996779544,
    ],
    '010535323028': [
      10.291123615728848, 53.442048606541974, 10.345540033950074, 53.48149350554215,
    ],
    '010535323050': [
      10.402216023437314, 53.4348018936908, 10.448325468035058, 53.46702518993048,
    ],
    '010535323053': [
      10.351190146232621, 53.459833496615936, 10.39289626900582, 53.486589015342474,
    ],
    '010535323072': [
      10.298461781939656, 53.46003604508696, 10.357226047140047, 53.49768214499949,
    ],
    '010535323131': [
      10.425311903567287, 53.42684570885806, 10.469246332083918, 53.45435904837233,
    ],
    '010535323133': [
      10.269044838548648, 53.49763948755201, 10.313302613949556, 53.526293136884924,
    ],
    '010535323135': [
      10.391404427262954, 53.45504390753112, 10.434989318026908, 53.485183354191676,
    ],
    '010535343006': [
      10.561413567133158, 53.39746528768837, 10.601767874837082, 53.446220679839044,
    ],
    '010535343019': [
      10.55369027094229, 53.37659001177272, 10.588566723074726, 53.406799435448384,
    ],
    '010535343022': [
      10.593190614294299, 53.41686791505367, 10.626347476303652, 53.446220679839044,
    ],
    '010535343058': [
      10.49436784561887, 53.400239124199786, 10.53060476221621, 53.43509097087991,
    ],
    '010535343073': [
      10.51010076309611, 53.38974281676753, 10.561413567133158, 53.42766943078775,
    ],
    '010535343074': [
      10.447116288360206, 53.399299258798, 10.506028581401413, 53.43509097087991,
    ],
    '010535343082': [
      10.584712016568728, 53.36107364863529, 10.619579762311883, 53.41803325585729,
    ],
    '010535343087': [
      10.50919678622108, 53.406799435448384, 10.582245383003524, 53.44947147242697,
    ],
    '010535343111': [
      10.430100185323152, 53.37167733941688, 10.526456081284255, 53.410557725187495,
    ],
    '010535343128': [
      10.511185086601154, 53.44135775112769, 10.572650916206825, 53.46371598001784,
    ],
    '010535358001': [
      10.68110900363535, 53.67027550209044, 10.717431114044198, 53.69307277357264,
    ],
    '010535358004': [
      10.778007756505806, 53.70335834110909, 10.806746989192934, 53.744149828209764,
    ],
    '010535358016': [
      10.713427178052958, 53.602494622158815, 10.760341248683032, 53.62331474763944,
    ],
    '010535358018': [
      10.719563568750237, 53.719644540194835, 10.749297699213592, 53.74148116766395,
    ],
    '010535358026': [
      10.702930728700302, 53.709147423034544, 10.739313402322558, 53.73098220234678,
    ],
    '010535358030': [
      10.697766834937616, 53.6319251775025, 10.754512034868629, 53.67873485381017,
    ],
    '010535358033': [
      10.701473022860188, 53.67466597896426, 10.728204918402225, 53.699516648995406,
    ],
    '010535358040': [
      10.669293286330804, 53.721376793361756, 10.707938991493375, 53.75351907294778,
    ],
    '010535358041': [
      10.719468687037372, 53.79405681593104, 10.77018047008154, 53.827024001704665,
    ],
    '010535358043': [
      10.67610780732632, 53.743972014822106, 10.773743146464478, 53.80076243977615,
    ],
    '010535358051': [
      10.705239292162982, 53.69144629988884, 10.736362698000754, 53.721376793361756,
    ],
    '010535358054': [
      10.801993968652928, 53.57338493881777, 10.84345268096363, 53.603460100485854,
    ],
    '010535358057': [
      10.743563398988606, 53.596135861235574, 10.799457433014208, 53.644166252739105,
    ],
    '010535358062': [
      10.887663090739231, 53.636237750725506, 10.954434905259372, 53.69929550870185,
    ],
    '010535358066': [
      10.842372203922293, 53.564864529202524, 10.9117380591469, 53.594786834341384,
    ],
    '010535358078': [
      10.66681361794552, 53.69245466479768, 10.711116917957375, 53.7230825737567,
    ],
    '010535358088': [
      10.787026573899082, 53.70218333384522, 10.832538452427041, 53.740454539171274,
    ],
    '010535358093': [
      10.848606739340244, 53.663247840325866, 10.916715643756302, 53.70585081682501,
    ],
    '010535358098': [
      10.70170476462207, 53.72405499660959, 10.736886587247872, 53.75399700292783,
    ],
    '010535358102': [
      10.761268816551032, 53.705933175608806, 10.791553345422859, 53.74743059952826,
    ],
    '010535358107': [
      10.782987850041687, 53.621205242210856, 10.937272883958283, 53.68043338229767,
    ],
    '010535358110': [
      10.739375198440987, 53.641081465117914, 10.798147162171484, 53.68093428421887,
    ],
    '010535358117': [
      10.836088039565398, 53.572212911125945, 10.927820362776343, 53.639737540261095,
    ],
    '010535358123': [
      10.774768110979386, 53.59926761363057, 10.868428536860188, 53.660863061879816,
    ],
    '010535358136': [
      10.800627624313766, 53.67103942290451, 10.871069816148458, 53.710822424988535,
    ],
    '010535373007': [
      10.437183733334624, 53.55526223706278, 10.517824154725059, 53.592985500347744,
    ],
    '010535373017': [
      10.39289626900582, 53.464003464601234, 10.457235270092065, 53.52259081223763,
    ],
    '010535373021': [
      10.433972905375096, 53.57307218579718, 10.45682998231357, 53.592985500347744,
    ],
    '010535373027': [
      10.490564366205609, 53.5278890983848, 10.56725440945274, 53.56544599846003,
    ],
    '010535373031': [
      10.505292516214025, 53.559132738555554, 10.556602299461598, 53.58846608610555,
    ],
    '010535373036': [
      10.496306044521413, 53.49970169734389, 10.54000557541817, 53.5278890983848,
    ],
    '010535373042': [
      10.546242370120813, 53.512665269573716, 10.589316859481164, 53.538168165096124,
    ],
    '010535373045': [
      10.46566028091323, 53.51658075047574, 10.506213374446876, 53.54573991935264,
    ],
    '010535373047': [
      10.461066292139503, 53.43178727698152, 10.528878313135156, 53.49449400741152,
    ],
    '010535373049': [
      10.418212656357525, 53.58954960907073, 10.472422535227693, 53.60527426225419,
    ],
    '010535373052': [
      10.437924655350741, 53.52370662679934, 10.496894645161374, 53.55526223706278,
    ],
    '010535373059': [
      10.55394240079934, 53.535621253482205, 10.591959355720316, 53.5627000245521,
    ],
    '010535373060': [
      10.388636100591897, 53.545481430170256, 10.438811242147287, 53.57741543352725,
    ],
    '010535373070': [
      10.495349463057991, 53.60314077598825, 10.525475256572216, 53.618965729334924,
    ],
    '010535373071': [
      10.43942849373608, 53.44692787575706, 10.49215719697205, 53.485078382259815,
    ],
    '010535373076': [
      10.371731560321988, 53.56201612271722, 10.437183733334624, 53.597089561734336,
    ],
    '010535373089': [
      10.437183733334624, 53.54806916753674, 10.496894645161374, 53.57307218579718,
    ],
    '010535373091': [
      10.46749915534796, 53.58273815346258, 10.513188622241547, 53.604599116758784,
    ],
    '010535373106': [
      10.506213374446876, 53.50313181018192, 10.558539721515338, 53.53970475939844,
    ],
    '010535391025': [
      10.532965886826839, 53.67661506153972, 10.612788707084746, 53.71920795850881,
    ],
    '010535391038': [
      10.5333373052623, 53.76474649960733, 10.561900410563123, 53.7828090272559,
    ],
    '010535391039': [
      10.443274827471152, 53.74305410110664, 10.4801269541061, 53.758983763702346,
    ],
    '010535391044': [
      10.541087369412994, 53.77934769536913, 10.60287517742288, 53.81364159624159,
    ],
    '010535391068': [
      10.53125359878129, 53.70365346841108, 10.589278985838908, 53.73613429314991,
    ],
    '010535391069': [
      10.498158047263875, 53.613070991548845, 10.555786370256769, 53.657996623858985,
    ],
    '010535391077': [
      10.591170664249947, 53.66930278654384, 10.635493031778903, 53.699799520113146,
    ],
    '010535391079': [
      10.497141679989378, 53.69852131402581, 10.546429923988539, 53.72620561287642,
    ],
    '010535391081': [
      10.630263880819518, 53.640703035878325, 10.711499745154347, 53.693165402025436,
    ],
    '010535391085': [
      10.437869087033048, 53.633064539571784, 10.505453007813705, 53.661112079479196,
    ],
    '010535391086': [
      10.504252253367929, 53.67661506153972, 10.546079674572093, 53.70496865310163,
    ],
    '010535391096': [
      10.552256995427904, 53.64501642231251, 10.606641707926102, 53.68554833249118,
    ],
    '010535391097': [
      10.597535393194345, 53.62663683834892, 10.653602254192702, 53.67097925717988,
    ],
    '010535391099': [
      10.543952065018887, 53.61950601158073, 10.599237270714468, 53.64962937115407,
    ],
    '010535391101': [
      10.521040165410952, 53.65090826223314, 10.590028609515773, 53.68554833249118,
    ],
    '010535391108': [
      10.468622058573064, 53.676938062314214, 10.516711789243017, 53.705996346561726,
    ],
    '010535391109': [
      10.441834024275702, 53.68559944453579, 10.4827509558475, 53.728322503167654,
    ],
    '010535391112': [
      10.403766626669553, 53.645581032098086, 10.466703293702603, 53.703033508851505,
    ],
    '010535391114': [
      10.45746529292952, 53.74979076366114, 10.496837756005688, 53.766905675180965,
    ],
    '010535391118': [
      10.493133365120844, 53.73164895974193, 10.552997386207574, 53.765329738547,
    ],
    '010535391121': [
      10.468187904371982, 53.64375613196922, 10.532965886826839, 53.6771809223395,
    ],
    '010535391122': [
      10.452108757303762, 53.69732839328257, 10.53546961208874, 53.75559147344159,
    ],
    '010535391124': [
      10.397263624182862, 53.7235419375413, 10.457321539346855, 53.74704101939942,
    ],
    '010535391127': [
      10.554706653114684, 53.618545088236885, 10.58781185526539, 53.63987852941875,
    ],
    '010535391130': [
      10.448103129043913, 53.6606065824153, 10.490754048541886, 53.6866279058773,
    ],
    '010540033033': [
      9.07125776800468, 54.36413093007022, 9.115563748491626, 54.38704936150172,
    ],
    '010540056056': [
      8.991730928495265, 54.45863052204384, 9.1016513889682, 54.52099487021353,
    ],
    '010540108108': [
      8.832756887097291, 54.55364594895511, 8.969515826078084, 54.65521112644726,
    ],
    '010540138138': [
      8.82215067381077, 54.26338238210073, 8.964998320175258, 54.34243915176479,
    ],
    '010540168168': [
      8.279655395539203, 54.79381076071371, 8.491278611480192, 54.93350876090329,
    ],
    '010545417035': [
      8.74255296293504, 54.3041161561303, 8.818721168023352, 54.34925930502938,
    ],
    '010545417036': [
      8.76081448945884, 54.32551142940957, 8.801364985708785, 54.338452998042385,
    ],
    '010545417040': [
      8.734945785464028, 54.288360926533635, 8.768784025016418, 54.30842822038138,
    ],
    '010545417063': [
      8.808432929544747, 54.31658292177666, 8.87201439002774, 54.34714404750993,
    ],
    '010545417072': [
      8.866434356693947, 54.31786169644057, 8.922757236236185, 54.35201139859612,
    ],
    '010545417090': [
      8.87689255698217, 54.38842438215161, 8.91510048987033, 54.417054642260325,
    ],
    '010545417095': [
      8.869073753561008, 54.315947959046355, 9.001626664015383, 54.40453158524225,
    ],
    '010545417100': [
      8.699445084825152, 54.37126159506018, 8.808676987779252, 54.408350520303365,
    ],
    '010545417104': [
      8.689940759939292, 54.34041811483568, 8.796317850107856, 54.377512947369105,
    ],
    '010545417113': [
      8.598792873624461, 54.27849602564563, 8.706493806690593, 54.34059392340088,
    ],
    '010545417134': [
      8.652347924996919, 54.28873263185126, 8.7489140364703, 54.35386314545124,
    ],
    '010545417135': [
      8.784096698084502, 54.345363561656576, 8.888441494193954, 54.40895665108593,
    ],
    '010545417140': [
      8.643503058416972, 54.336004412271826, 8.713171579679063, 54.36761731189564,
    ],
    '010545417145': [
      8.76758277209736, 54.280281515716, 8.82625871279649, 54.30092834977075,
    ],
    '010545417148': [
      8.764460026340371, 54.29347775192175, 8.843918876726972, 54.32164128454355,
    ],
    '010545417150': [
      8.649252329183618, 54.3713852541542, 8.732693508974041, 54.39952087870899,
    ],
    '010545439046': [
      8.276512251985782, 54.73931110995556, 8.30097284672454, 54.79622436619614,
    ],
    '010545439061': [
      8.32087408968323, 54.940617164629735, 8.371404028414512, 54.99240481606559,
    ],
    '010545439078': [
      8.350540929593583, 54.98868614263047, 8.463613969738322, 55.0570603355132,
    ],
    '010545439149': [
      8.309027758029726, 54.9244346134837, 8.362966033722778, 54.95259616543639,
    ],
    '010545453003': [
      9.175812663656306, 54.51645644862643, 9.25031560440006, 54.54813103954314,
    ],
    '010545453004': [
      9.248025261897627, 54.519532541867896, 9.304526068242977, 54.54697192018777,
    ],
    '010545453011': [
      9.192639870843072, 54.54049605449762, 9.262144716407006, 54.58717634696087,
    ],
    '010545453013': [
      9.255943639225018, 54.536140922832196, 9.310633100438626, 54.57493441786724,
    ],
    '010545453041': [
      9.146295032012143, 54.57990146207921, 9.22190183765751, 54.615139156020156,
    ],
    '010545453057': [
      9.129481179104891, 54.51490354393528, 9.209457209879206, 54.55999596552332,
    ],
    '010545453079': [
      9.128339469971513, 54.60866164624437, 9.223048200313919, 54.65832922985995,
    ],
    '010545453092': [
      9.100180143062687, 54.57135436801178, 9.154149758709599, 54.62053753172331,
    ],
    '010545453101': [
      9.204101319738108, 54.49571229756824, 9.290724300392482, 54.52396950498596,
    ],
    '010545453118': [
      9.093580586231994, 54.48064169822604, 9.171113418633826, 54.5178458046901,
    ],
    '010545453123': [
      9.207071475808796, 54.57891586049365, 9.269055086309015, 54.62821045501408,
    ],
    '010545453144': [
      9.093658440820587, 54.543159272813064, 9.207071475808796, 54.58940733564778,
    ],
    '010545453152': [
      9.157684886609868, 54.47819693413686, 9.309072351945307, 54.5184304613293,
    ],
    '010545459039': [
      8.715114351068724, 54.62853067104981, 8.736490404031095, 54.644099135811544,
    ],
    '010545459050': [
      8.508646222697788, 54.55745657743559, 8.572875451991637, 54.579430500414674,
    ],
    '010545459074': [
      8.528675754974293, 54.61755555086222, 8.713057162356519, 54.680598676297286,
    ],
    '010545459103': [
      8.587974307407922, 54.48863417443981, 8.70508751563286, 54.557538250804406,
    ],
    '010545488005': [
      8.478917398832335, 54.693496010447035, 8.517563615039865, 54.74446812227221,
    ],
    '010545488015': [
      8.429576839390075, 54.69236132354579, 8.484194651433997, 54.72162255688852,
    ],
    '010545488025': [
      8.403627553598607, 54.723814690742735, 8.437409799960596, 54.748256247267065,
    ],
    '010545488083': [
      8.503761953448745, 54.69705830084368, 8.542446463340154, 54.75563640443259,
    ],
    '010545488085': [
      8.29280510642933, 54.62720745054965, 8.382274328882152, 54.6755201892759,
    ],
    '010545488087': [
      8.453540004067206, 54.68052162851765, 8.527694903007234, 54.708769531573736,
    ],
    '010545488089': [
      8.29280510642933, 54.667327800969, 8.356166411701913, 54.71157415472397,
    ],
    '010545488094': [
      8.515962566078858, 54.6934203424412, 8.585019062389957, 54.75563640443259,
    ],
    '010545488098': [
      8.41676526817275, 54.70640916756635, 8.505597062631585, 54.75199296026836,
    ],
    '010545488129': [
      8.42446446609583, 54.7132959108849, 8.459714712055112, 54.73022816364091,
    ],
    '010545488143': [
      8.39666432869197, 54.69493562300042, 8.429576839390075, 54.730232778944625,
    ],
    '010545488158': [
      8.425205706481048, 54.692530227707906, 8.453278712330622, 54.70640916756635,
    ],
    '010545488160': [
      8.336450568166807, 54.60972679744831, 8.401948084995047, 54.63637084030663,
    ],
    '010545488163': [
      8.527233887455754, 54.6864786358833, 8.583586458955061, 54.72857315588752,
    ],
    '010545488164': [
      8.525088790792942, 54.67983510309645, 8.597494323721705, 54.72857315588752,
    ],
    '010545489001': [
      8.979067104044791, 54.77410812946607, 9.120087610366985, 54.8163810117313,
    ],
    '010545489009': [
      8.733853145436942, 54.86879730168292, 8.849396264335017, 54.90665374210193,
    ],
    '010545489016': [
      8.811029148660486, 54.80615769059849, 8.872521074866526, 54.83073117981701,
    ],
    '010545489017': [
      8.869986938229687, 54.817370470261565, 8.944842849017492, 54.858401854662,
    ],
    '010545489018': [
      9.059455787033706, 54.819226194427145, 9.11732197930433, 54.874313864432615,
    ],
    '010545489022': [
      8.687118533076916, 54.68224494561615, 8.86080933392463, 54.752899952930015,
    ],
    '010545489027': [
      8.879642023001391, 54.87435501380092, 8.972662273587973, 54.902254109718854,
    ],
    '010545489034': [
      8.60957156993618, 54.81940165132852, 8.646838538575578, 54.886842824495815,
    ],
    '010545489048': [
      8.79899138567181, 54.82344551588506, 8.872521074866526, 54.83746215256847,
    ],
    '010545489055': [
      8.801311237184635, 54.84543144851512, 8.895931103714725, 54.901977723489765,
    ],
    '010545489062': [
      8.951034509660124, 54.79283775273487, 9.02518904475122, 54.84128605172685,
    ],
    '010545489065': [
      8.64188027915072, 54.84997817796873, 8.698493226382956, 54.87900307437804,
    ],
    '010545489068': [
      8.843380475852443, 54.77747568262428, 8.942744831754233, 54.82286010299407,
    ],
    '010545489073': [
      8.994408761647597, 54.81202202842044, 9.082416438073688, 54.8756667092275,
    ],
    '010545489076': [
      8.914189205795642, 54.740196639083734, 9.014908678304604, 54.80237481129278,
    ],
    '010545489077': [
      8.91886053054964, 54.82050048575372, 8.969018552590832, 54.8454425583928,
    ],
    '010545489086': [
      8.691177257808214, 54.83965831051775, 8.816112550807064, 54.88775103701016,
    ],
    '010545489088': [
      8.750656236825233, 54.75927602249828, 8.860913470425645, 54.84126987276407,
    ],
    '010545489109': [
      8.790402353092196, 54.71576239843698, 8.92329449847725, 54.79635000107071,
    ],
    '010545489110': [
      8.613534199107773, 54.87545539570521, 8.744130713744092, 54.91124348788884,
    ],
    '010545489124': [
      9.003810075106166, 54.75486927223164, 9.11081049107601, 54.78420140177609,
    ],
    '010545489125': [
      9.003810075106166, 54.714278191197096, 9.08053062476143, 54.76841195074384,
    ],
    '010545489126': [
      8.840632081965254, 54.7107571664122, 8.939185448828294, 54.76369841217108,
    ],
    '010545489131': [
      8.829741158323415, 54.84480416635318, 8.96710437125183, 54.8964425433243,
    ],
    '010545489136': [
      8.913067219994108, 54.794792869312964, 8.969189756494924, 54.82632478184665,
    ],
    '010545489142': [
      8.79125287089773, 54.836440026521686, 8.874554459949358, 54.85467034310682,
    ],
    '010545489154': [
      8.956165876260066, 54.84074111217499, 9.036379868564113, 54.89670402751399,
    ],
    '010545489165': [
      8.68252851008919, 54.72234073664547, 8.818746613510797, 54.81020683911182,
    ],
    '010545489166': [
      8.64188027915072, 54.7924235102538, 8.766195805227946, 54.852123667475574,
    ],
    '010545489167': [
      8.92890871663657, 54.69461572784787, 9.081582358589227, 54.74411708295346,
    ],
    '010545492007': [
      9.042472081483067, 54.52691252646095, 9.101045598057942, 54.554805768392306,
    ],
    '010545492023': [
      9.100049609754548, 54.317479702916714, 9.187631676562319, 54.37821233510075,
    ],
    '010545492026': [
      8.853854970951796, 54.49544758696387, 8.894530139667156, 54.52359017410343,
    ],
    '010545492032': [
      9.225054928592153, 54.38288216662665, 9.265443886956378, 54.40160044939654,
    ],
    '010545492042': [
      9.006437074546755, 54.505726173911285, 9.049379564958059, 54.5335333614237,
    ],
    '010545492043': [
      8.873359963393398, 54.5120630191174, 9.060303312059864, 54.56659931910148,
    ],
    '010545492052': [
      9.04715176442464, 54.50109609712358, 9.104899737150621, 54.54237525625838,
    ],
    '010545492054': [
      9.207605632139614, 54.37602563275416, 9.234038996233961, 54.40387116229444,
    ],
    '010545492070': [
      9.023182440143904, 54.36413093007022, 9.138065335089149, 54.42736256185222,
    ],
    '010545492084': [
      9.084873589374183, 54.44798406046511, 9.148844019938604, 54.481641577408226,
    ],
    '010545492091': [
      8.789096268223282, 54.45922717304587, 8.948371489652168, 54.55420166867623,
    ],
    '010545492096': [
      9.141920345190538, 54.41847210546048, 9.194761034204971, 54.46498804430822,
    ],
    '010545492097': [
      9.09215344055759, 54.5161454063356, 9.140647744911622, 54.55376261163066,
    ],
    '010545492099': [
      9.19201081675324, 54.42163205661687, 9.32605147744391, 54.4762114684228,
    ],
    '010545492105': [
      9.145350872545462, 54.38525105732586, 9.194355395702985, 54.421672043811924,
    ],
    '010545492106': [
      9.114222071045328, 54.41967369928918, 9.171113418633826, 54.48598745522803,
    ],
    '010545492116': [
      9.109280697062129, 54.381965671357825, 9.276013051263567, 54.42249553502009,
    ],
    '010545492119': [
      9.111537248218015, 54.35602490955561, 9.207500903392257, 54.39108930542752,
    ],
    '010545492120': [
      8.931229026637217, 54.428151984615184, 9.029747610162437, 54.4751663420515,
    ],
    '010545492130': [
      9.230213619559457, 54.37203706244344, 9.263836291417046, 54.391302083801534,
    ],
    '010545492132': [
      9.00856587131438, 54.40892430184052, 9.141920345190538, 54.470705688434165,
    ],
    '010545492141': [
      8.912342999394799, 54.39116890894665, 8.97488862159266, 54.43130423155672,
    ],
    '010545492156': [
      9.182731501803648, 54.41288947761277, 9.289667235581895, 54.448301201142456,
    ],
    '010545492157': [
      9.141920345190538, 54.40442343158395, 9.174877725372578, 54.421672043811924,
    ],
    '010545492159': [
      9.170809383152768, 54.461764399406874, 9.318474591835134, 54.49180555956459,
    ],
    '010545492161': [
      8.951284301386787, 54.374303537178584, 9.05953870753687, 54.434424156571765,
    ],
    '010545492162': [
      8.987833297634234, 54.518894617008115, 9.007554057078742, 54.53479646734093,
    ],
    '010545494002': [
      9.040072818779315, 54.54833994991586, 9.118494082469923, 54.57224169403081,
    ],
    '010545494006': [
      8.98871424694235, 54.56608818590439, 9.029473443747904, 54.60151436190898,
    ],
    '010545494010': [
      8.905564921111996, 54.67584215497839, 9.027438211805052, 54.72956577059772,
    ],
    '010545494012': [
      9.012511934129153, 54.564099309331645, 9.103622024528281, 54.59687292861909,
    ],
    '010545494014': [
      8.856933660876198, 54.61558419068068, 9.03109804143779, 54.67920286227057,
    ],
    '010545494019': [
      8.935271621366228, 54.59692104883595, 8.99376168963464, 54.64843932067472,
    ],
    '010545494020': [
      8.958066181425066, 54.58731254686795, 9.023620577933304, 54.62803515702698,
    ],
    '010545494024': [
      9.017178940041594, 54.59179083755381, 9.119678731450476, 54.62648325590356,
    ],
    '010545494037': [
      9.121542036401662, 54.66484913272585, 9.178116975820924, 54.701166222011125,
    ],
    '010545494038': [
      9.067885270023579, 54.65635633711475, 9.12660779044473, 54.69843691398348,
    ],
    '010545494045': [
      9.028261793106209, 54.622414218554795, 9.100961468034868, 54.66933104527778,
    ],
    '010545494059': [
      9.084148500218165, 54.622001798871636, 9.193126266829037, 54.669652307485926,
    ],
    '010545494071': [
      9.111555896439459, 54.61868358378119, 9.141332270659102, 54.63449867550366,
    ],
    '010545494075': [
      8.839333995984804, 54.652021134582036, 9.000193988991487, 54.723529525060826,
    ],
    '010545494080': [
      9.014219361322297, 54.666374309427006, 9.073076108235568, 54.70090628131416,
    ],
    '010545494093': [
      8.753367159488306, 54.65166807234149, 8.86214523470292, 54.69305397899307,
    ],
    '010545494121': [
      8.985606554132538, 54.62232536612671, 9.033681151354019, 54.644016040603034,
    ],
    '010545494128': [
      8.955330376145694, 54.55891967729005, 9.017178940041594, 54.60151436190898,
    ],
    '010545494146': [
      9.017332374374348, 54.61623171533328, 9.074967976699263, 54.64081122670827,
    ],
    '010550001001': [
      10.451319116883747, 53.93643413144977, 10.650851048747112, 54.07495155841385,
    ],
    '010550004004': [
      10.645648070271088, 53.901361155912255, 10.730387594818193, 53.95317121390051,
    ],
    '010550007007': [
      10.41589622971162, 54.058743776290726, 10.598873873557308, 54.13388048025756,
    ],
    '010550010010': [
      11.049833045941927, 54.19577953769909, 11.09428518610828, 54.246452883708486,
    ],
    '010550012012': [
      10.54367563376994, 54.11291428469119, 10.690021719733346, 54.1919818488509,
    ],
    '010550016016': [
      10.887046413012483, 54.13346911729487, 11.047342023243985, 54.221688905175554,
    ],
    '010550018018': [
      10.992400839365727, 54.207011569397515, 11.084798690693788, 54.27643801471532,
    ],
    '010550021021': [
      10.921984894347428, 54.348996668501904, 11.022197006211673, 54.38466838847461,
    ],
    '010550025025': [
      11.021675468542885, 54.17688203210829, 11.078447506179005, 54.213983962660336,
    ],
    '010550028028': [
      10.483513256816416, 54.13388048025756, 10.674920200835428, 54.23446170587404,
    ],
    '010550032032': [
      10.786884051756243, 54.084052043476646, 10.898712170033983, 54.131614134625984,
    ],
    '010550033033': [
      10.798810106843709, 54.257275376442294, 10.932627495251088, 54.3391447999189,
    ],
    '010550035035': [
      10.66239857983464, 53.91400574930864, 10.849203780596397, 54.01799762061249,
    ],
    '010550040040': [
      10.534207421590406, 53.88013956267495, 10.684406471426303, 53.98204907925073,
    ],
    '010550041041': [
      10.591165574446293, 54.04618717757747, 10.760863477163914, 54.146828523257895,
    ],
    '010550042042': [
      10.740186462645763, 53.94352090689356, 10.849203780596397, 54.01007087644044,
    ],
    '010550044044': [
      10.610465787125687, 53.97700463020502, 10.77342808136753, 54.06088255815536,
    ],
    '010550046046': [
      11.007234188327548, 54.401223977267605, 11.312330269695964, 54.53562455975523,
    ],
    '010555543014': [
      10.917385367265231, 54.2499859333254, 11.01610306659013, 54.30805331821332,
    ],
    '010555543015': [
      10.841779156686936, 54.302079006412285, 11.007717430797664, 54.37784979060034,
    ],
    '010555543017': [
      10.998600700923422, 54.34320870027606, 11.13147754107705, 54.39619573437448,
    ],
    '010555543022': [
      10.960436703700164, 54.24672881807448, 11.084798690693788, 54.314117206173954,
    ],
    '010555543031': [
      10.970548838725106, 54.29438294840539, 11.07690101753424, 54.35549309943139,
    ],
    '010555543043': [
      10.698780458390704, 54.21812503846681, 10.865119736912954, 54.3161430766917,
    ],
    '010555546006': [
      10.851955933898981, 54.172993742835395, 10.900495133652536, 54.21419150410319,
    ],
    '010555546011': [
      10.881731197996377, 54.22968560543717, 10.931948875094786, 54.270522515005176,
    ],
    '010555546020': [
      10.780133868326095, 54.19708317198344, 10.858402436686426, 54.262874143907055,
    ],
    '010555546023': [
      10.910715512897173, 54.20491791756435, 10.946644085904946, 54.24057283619311,
    ],
    '010555546027': [
      10.814728367202985, 54.18664979907698, 10.918536906848768, 54.26317555840024,
    ],
    '010555546029': [
      10.891020494586996, 54.172993742835395, 10.946803304446956, 54.20759568408273,
    ],
    '010555546036': [
      10.920903682307234, 54.206554438493185, 11.030728396662777, 54.266431591285475,
    ],
    '010555591002': [
      10.723709430713448, 54.10138372000468, 10.846216953383765, 54.17325529929476,
    ],
    '010555591024': [
      10.651457688890233, 54.116547889703874, 10.777035962012926, 54.201808637035406,
    ],
    '010555591037': [
      10.811662655355448, 54.10095813825104, 10.944207750343768, 54.18668757926048,
    ],
    '010555591038': [
      10.699377521667698, 54.155402283430774, 10.833862047304235, 54.23484775958097,
    ],
    '010555591039': [
      10.71261522661045, 54.05257522011403, 10.80042878032225, 54.11109246954851,
    ],
    '010560002002': [
      9.736091432028186, 53.77169135612527, 9.832465042732318, 53.82626337795316,
    ],
    '010560005005': [
      9.878507440540194, 53.65212990962176, 9.944484027623034, 53.69557370292343,
    ],
    '010560015015': [
      9.624031814954582, 53.727967461740455, 9.72162185539766, 53.7813630924613,
    ],
    '010560018018': [
      9.80258648645589, 53.60926026104153, 9.884054421622373, 53.64631556823969,
    ],
    '010560021021': [
      9.884919597644641, 53.67709619298384, 9.951338412170516, 53.716506443590625,
    ],
    '010560025025': [
      7.869403516227764, 54.17225190096552, 7.919221003431671, 54.18953435411133,
    ],
    '010560039039': [
      9.763802764343914, 53.610161790175376, 9.828386017945231, 53.684389371234076,
    ],
    '010560041041': [
      9.829636948243488, 53.70365058765351, 9.979885464591046, 53.76738823390249,
    ],
    '010560043043': [
      9.811341969584332, 53.62120731194478, 9.896436659926998, 53.67482823565403,
    ],
    '010560044044': [
      9.792061414351819, 53.584395692128, 9.868765579298623, 53.61471284564223,
    ],
    '010560048048': [
      9.699733979942694, 53.67276601181605, 9.780866100993531, 53.72490317089966,
    ],
    '010560049049': [
      9.612293825538915, 53.67091639669587, 9.705907369854588, 53.70286806219958,
    ],
    '010560050050': [
      9.646053939110486, 53.56690265830785, 9.756926613896882, 53.61809531069068,
    ],
    '010565616029': [
      9.629837526367984, 53.70852052052199, 9.716699187966615, 53.73777972517783,
    ],
    '010565616030': [
      9.64936878074596, 53.77522298814182, 9.716916825524939, 53.83428372607681,
    ],
    '010565616031': [
      9.682002395440808, 53.74413001235915, 9.738704997675809, 53.77082191017159,
    ],
    '010565616033': [
      9.575534483218888, 53.70047949285756, 9.642131946966531, 53.743893920630235,
    ],
    '010565616042': [
      9.564210706145792, 53.722561892411626, 9.643281163316486, 53.77386305440906,
    ],
    '010565616045': [
      9.51779701783535, 53.66935513341379, 9.585317208154478, 53.717664841467695,
    ],
    '010565616046': [
      9.711925283193615, 53.72386556885991, 9.76691201964386, 53.752209950458756,
    ],
    '010565636006': [
      9.70771931903187, 53.845000431510684, 9.792129227109722, 53.89277528790433,
    ],
    '010565636010': [
      9.672207132207179, 53.82378558070712, 9.749385752438863, 53.869031008340954,
    ],
    '010565636038': [
      9.671031045561637, 53.859299694334, 9.720075096214634, 53.89120606772643,
    ],
    '010565636051': [
      9.646344107878663, 53.84638855643687, 9.699946722453879, 53.889367015254294,
    ],
    '010565660003': [
      9.728585951375763, 53.73840049329425, 9.798492878958376, 53.766919126107396,
    ],
    '010565660004': [
      9.85993466149483, 53.750120249190964, 9.903188885275075, 53.781599505349966,
    ],
    '010565660008': [
      9.680059489304249, 53.767891191127326, 9.742811697325548, 53.79711317391592,
    ],
    '010565660011': [
      9.724084008519531, 53.757480792435835, 9.771900877696167, 53.77753870296095,
    ],
    '010565660014': [
      9.742017668487597, 53.707025809357376, 9.817636388177029, 53.74562604470751,
    ],
    '010565660017': [
      9.696575099256313, 53.795045644671646, 9.753140534459185, 53.83228037519515,
    ],
    '010565660022': [
      9.766367022025937, 53.75999681873948, 9.845852514930064, 53.824920670916974,
    ],
    '010565660026': [
      9.791333022859174, 53.72817799128595, 9.867796251356038, 53.78581148845745,
    ],
    '010565660034': [
      9.830304997155373, 53.780227789227716, 9.883511390828735, 53.82776328163598,
    ],
    '010565660035': [
      9.74655481446319, 53.804417775299314, 9.829928274415655, 53.86021953596531,
    ],
    '010565687009': [
      9.795140438774132, 53.67482823565403, 9.854182342263803, 53.74188500029627,
    ],
    '010565687013': [
      9.84803114832259, 53.63404567793323, 9.906674478097624, 53.67960726137073,
    ],
    '010565687032': [
      9.767410006714597, 53.684084432, 9.80676776897311, 53.72383297314067,
    ],
    '010565687040': [
      9.745850294893842, 53.66324588079658, 9.777228070173246, 53.69530293192148,
    ],
    '010565687047': [
      9.819088279136475, 53.663272672859634, 9.888651780985414, 53.708994797170035,
    ],
    '010565690001': [
      9.692131539751529, 53.61809531069068, 9.772362093891418, 53.68008536619387,
    ],
    '010565690016': [
      9.596775420702796, 53.68899518364506, 9.658791840761742, 53.709015606010176,
    ],
    '010565690019': [
      9.537030012479649, 53.63523991706549, 9.640669322726861, 53.674873112552795,
    ],
    '010565690020': [
      9.561606565003393, 53.6100458180035, 9.650860700763882, 53.660045664310765,
    ],
    '010565690023': [
      9.654816114611194, 53.69628520399762, 9.702242834542787, 53.71606993051461,
    ],
    '010565690024': [
      9.640669322726861, 53.63369875745403, 9.714916094332475, 53.66536879201628,
    ],
    '010565690027': [
      9.54812787669355, 53.58801847114189, 9.661182998647167, 53.640432539665426,
    ],
    '010565690028': [
      9.650860700763882, 53.606923957123165, 9.756926613896882, 53.64133855453182,
    ],
    '010565690036': [
      9.583349760672162, 53.65370226325854, 9.70082395762563, 53.67822249018086,
    ],
    '010565690037': [
      9.57238287884614, 53.67290777804909, 9.646221415191192, 53.701064433356756,
    ],
    '010570001001': [
      10.279493569857701, 54.11835490079379, 10.37685326448076, 54.177473267747445,
    ],
    '010570008008': [
      10.015772855764812, 54.05755109442826, 10.121949235078224, 54.09663271621374,
    ],
    '010570009009': [
      10.4318135302431, 54.10475516753575, 10.54367563376994, 54.16381450978687,
    ],
    '010570057057': [
      10.362430102108446, 54.08245017551034, 10.490534972697374, 54.17833157707224,
    ],
    '010570062062': [
      10.231726142740827, 54.2039526830571, 10.312383000245383, 54.25804652618985,
    ],
    '010570091091': [
      10.18881355910485, 54.248810370980244, 10.292462906406369, 54.31766514400735,
    ],
    '010575727004': [
      10.57238551948988, 54.306003337927294, 10.649095697404226, 54.36471999258496,
    ],
    '010575727007': [
      10.605144684070552, 54.24311192805247, 10.728763183400401, 54.31669310166092,
    ],
    '010575727013': [
      10.530113598162835, 54.227950377211336, 10.608986174434396, 54.252533038711974,
    ],
    '010575727021': [
      10.428337616905031, 54.248629279865796, 10.56396116018314, 54.343371660202315,
    ],
    '010575727026': [
      10.550930290256181, 54.24735866174172, 10.622474817917002, 54.291774053996676,
    ],
    '010575727027': [
      10.596681592191525, 54.21534366462759, 10.663287244841833, 54.26995808301227,
    ],
    '010575727029': [
      10.475072067658298, 54.34986800526365, 10.541141802783823, 54.38932910339503,
    ],
    '010575727030': [
      10.601731332407004, 54.281642902478005, 10.679561408555593, 54.33699988571259,
    ],
    '010575727034': [
      10.65081354371792, 54.191347563818816, 10.715783282183434, 54.235834903275155,
    ],
    '010575727035': [
      10.5203698974568, 54.26721508423416, 10.580579743987721, 54.30144795239662,
    ],
    '010575727038': [
      10.623896149650992, 54.21812503846681, 10.71761383617721, 54.26302092364207,
    ],
    '010575727048': [
      10.55169076150523, 54.28302587412568, 10.614800384292506, 54.309116317887046,
    ],
    '010575727055': [
      10.519476049771102, 54.30377928007648, 10.596891966732008, 54.37957344546109,
    ],
    '010575727076': [
      10.434416770602256, 54.35122634351768, 10.494926374739565, 54.40311174984442,
    ],
    '010575727082': [
      10.4857698816082, 54.32621704565514, 10.548218094653125, 54.35710308248103,
    ],
    '010575739015': [
      10.292106901827085, 54.100367489551026, 10.35470761170378, 54.129916825979606,
    ],
    '010575739017': [
      10.319356179574688, 54.152357208895715, 10.394343042463293, 54.177473267747445,
    ],
    '010575739022': [
      10.450728212433615, 54.17289894448103, 10.538900936988165, 54.25905614596386,
    ],
    '010575739032': [
      10.243746127154921, 54.11155341162485, 10.323632470846947, 54.14624617514598,
    ],
    '010575739045': [
      10.391077203500595, 54.18140482925391, 10.474797741915715, 54.24332501616671,
    ],
    '010575739053': [
      10.345386243090216, 54.07092714130977, 10.418668073144321, 54.137653251779724,
    ],
    '010575739065': [
      10.480923515502816, 54.20510392467639, 10.548070349421481, 54.26795730426882,
    ],
    '010575739067': [
      10.370057816198859, 54.16678899225729, 10.457776567351633, 54.1983936789045,
    ],
    '010575739089': [
      10.330019456858786, 54.162970081584696, 10.381729085307889, 54.19010912353437,
    ],
    '010575747002': [
      10.147406012997926, 54.184785725816546, 10.185673833370123, 54.21936467801053,
    ],
    '010575747010': [
      10.096991416132582, 54.233758257971864, 10.151825364446111, 54.256693880367536,
    ],
    '010575747011': [
      10.118199064957375, 54.14459761768578, 10.166310864974573, 54.213216298665145,
    ],
    '010575747023': [
      10.150833930532494, 54.212320709706646, 10.183029003271734, 54.2311928400503,
    ],
    '010575747031': [
      10.144438059279745, 54.213893646406035, 10.207415308606075, 54.25926035355303,
    ],
    '010575747033': [
      10.133693022201271, 54.1998099373481, 10.160973223870286, 54.21777017776629,
    ],
    '010575747037': [
      10.125294104428615, 54.21298098223651, 10.15719165464578, 54.23883311704357,
    ],
    '010575747042': [
      10.231726142740827, 54.1582824675397, 10.292867703559688, 54.21188910044766,
    ],
    '010575747046': [
      10.288706098906907, 54.18796063929095, 10.406717645489685, 54.26730544013781,
    ],
    '010575747047': [
      10.200778319459205, 54.16203445606224, 10.244753931226082, 54.21106631712193,
    ],
    '010575747054': [
      10.164174241970562, 54.157118336587494, 10.208451114270378, 54.18522171906891,
    ],
    '010575747058': [
      10.175392258141189, 54.21106631712193, 10.27314034721476, 54.28234677442588,
    ],
    '010575747059': [
      10.181251570909062, 54.184785725816546, 10.231726142740827, 54.221989868415726,
    ],
    '010575747066': [
      10.24119465136422, 54.2600488272312, 10.372482288591517, 54.303456188777304,
    ],
    '010575747070': [
      10.284761330429564, 54.20356314565615, 10.360758348683264, 54.23936550506044,
    ],
    '010575747084': [
      10.28042508937182, 54.16866239007168, 10.35182794477905, 54.21523662789898,
    ],
    '010575747086': [
      10.138462163979264, 54.17789657537202, 10.181251570909062, 54.19994123785695,
    ],
    '010575755003': [
      10.292060299616134, 54.37851185171146, 10.334290706990165, 54.427322467110564,
    ],
    '010575755006': [
      10.40578887685431, 54.34650521508136, 10.434429487166804, 54.374943497470504,
    ],
    '010575755012': [
      10.22941576165711, 54.379416321003156, 10.266128288788211, 54.403730748964456,
    ],
    '010575755018': [
      10.320138551489858, 54.34515020279573, 10.355479031050622, 54.3656564628196,
    ],
    '010575755020': [
      10.32873677662359, 54.35976206046612, 10.366082896508063, 54.389799147041856,
    ],
    '010575755028': [
      10.354463554512087, 54.35037190044107, 10.395472528559951, 54.38382025356973,
    ],
    '010575755039': [
      10.418302432073173, 54.31847633375593, 10.492344711602144, 54.36526015459104,
    ],
    '010575755040': [
      10.318123970068067, 54.37980131281635, 10.367726633291893, 54.40730508580096,
    ],
    '010575755041': [
      10.380515475585481, 54.352700836846225, 10.415562185859185, 54.397489105196094,
    ],
    '010575755043': [
      10.210192924715965, 54.387100460070876, 10.252794276248084, 54.41584394114334,
    ],
    '010575755049': [
      10.263280045906889, 54.3803457824959, 10.300007407102225, 54.40124711460964,
    ],
    '010575755056': [
      10.30017865443445, 54.33685962970734, 10.336331635258267, 54.3809930870593,
    ],
    '010575755060': [
      10.27833749597701, 54.36513932312411, 10.31119391459072, 54.393795192880965,
    ],
    '010575755063': [
      10.237273218830781, 54.33660992110449, 10.309618163221526, 54.38734076502867,
    ],
    '010575755073': [
      10.353878259373332, 54.38220639136448, 10.422426485505186, 54.43237459776995,
    ],
    '010575755078': [
      10.40214161008748, 54.37225267046029, 10.444801569970485, 54.41303979988431,
    ],
    '010575755079': [
      10.240950222626234, 54.39805894376484, 10.285027909831784, 54.419986702778836,
    ],
    '010575755081': [
      10.316391620322076, 54.327301244375626, 10.391465007130352, 54.35350871330766,
    ],
    '010575755087': [
      10.272352741974917, 54.398684268809525, 10.308581276710925, 54.433355319337906,
    ],
    '010575755088': [
      10.302717940619713, 54.400400294448964, 10.375222388869114, 54.433355319337906,
    ],
    '010575775016': [
      10.250730045774624, 54.28177707621807, 10.327667982193171, 54.35278918352242,
    ],
    '010575775044': [
      10.401873387112794, 54.25702519072679, 10.511014280817873, 54.3189377974671,
    ],
    '010575775050': [
      10.349340693842679, 54.24332501616671, 10.43111976982948, 54.3189377974671,
    ],
    '010575775052': [
      10.406098623504334, 54.21652272223347, 10.471023285058005, 54.26505239577067,
    ],
    '010575775072': [
      10.303593173113947, 54.29490114935303, 10.353005459468209, 54.34102121927457,
    ],
    '010575775077': [
      10.399796334285611, 54.275101167288135, 10.443609427972449, 54.29948084538622,
    ],
    '010575775090': [
      10.327194117307984, 54.29065491959566, 10.434601673414972, 54.36123685101114,
    ],
    '010575782025': [
      10.177954770072809, 54.34749189987352, 10.2538415219832, 54.39307297489633,
    ],
    '010575782051': [
      10.174091308614008, 54.340790371569945, 10.214711487374773, 54.355104885660566,
    ],
    '010575782074': [
      10.199588910381411, 54.29726926411512, 10.269379950324437, 54.34780084479604,
    ],
    '010575785005': [
      10.21831780898003, 54.08778655461924, 10.301640623411819, 54.140031618006134,
    ],
    '010575785024': [
      10.019098771785307, 54.10331361387399, 10.115443415838676, 54.13455362721862,
    ],
    '010575785068': [
      10.088343998230181, 54.05546400257375, 10.197871257939454, 54.09961757363556,
    ],
    '010575785069': [
      10.168112428152348, 54.07171221634626, 10.246713581420114, 54.10490729106601,
    ],
    '010575785071': [
      10.065454024187686, 54.08400126328124, 10.171084289790315, 54.15062403554902,
    ],
    '010575785080': [
      10.179154027908996, 54.115481809804464, 10.290686464407631, 54.17398463148736,
    ],
    '010575785083': [
      10.02013372565914, 54.088707197444265, 10.08421312596458, 54.10779528231618,
    ],
    '010575785085': [
      10.152946430376801, 54.10452745894732, 10.225369742682725, 54.158021454963524,
    ],
    '010580005005': [
      10.071131507112817, 54.369235648334666, 10.136347133853086, 54.42449983204655,
    ],
    '010580034034': [
      9.65603104180502, 54.30851016970163, 9.717388250142218, 54.32736971476791,
    ],
    '010580043043': [
      9.775553120425922, 54.44266803423713, 9.875162552031503, 54.499888937804435,
    ],
    '010580092092': [
      10.055917772245103, 54.32551159210727, 10.102986831951254, 54.348510750672915,
    ],
    '010580135135': [
      9.60854075466265, 54.25502788318586, 9.708346007278527, 54.33728712032724,
    ],
    '010580169169': [
      9.851772352066885, 54.058141183917314, 9.930163366456538, 54.11028815009496,
    ],
    '010585803001': [
      9.911871118668484, 54.279345901941284, 10.044332106605673, 54.32147284004574,
    ],
    '010585803028': [
      9.805776884179568, 54.297048022823105, 9.910233937938692, 54.3323732386924,
    ],
    '010585803050': [
      9.88150208861009, 54.289022099692865, 9.963311438372346, 54.32544603049088,
    ],
    '010585803093': [
      9.864441441575684, 54.32092460840206, 9.969235968041117, 54.35416114433149,
    ],
    '010585803104': [
      10.000181156898421, 54.29473413721402, 10.054265214601653, 54.33041061774277,
    ],
    '010585803126': [
      10.033638682259276, 54.328992579045426, 10.069838176098319, 54.34847298532948,
    ],
    '010585803130': [
      9.951017332078974, 54.31653951457263, 10.040442680251747, 54.360776307662086,
    ],
    '010585803171': [
      9.829189433415438, 54.239315139941, 9.970897228729262, 54.30769514723947,
    ],
    '010585822037': [
      10.064089694528523, 54.41097077090958, 10.157812575727435, 54.45176655800468,
    ],
    '010585822116': [
      9.935452083829194, 54.44451096073824, 10.036783145557266, 54.475391420223886,
    ],
    '010585822150': [
      10.025239496404332, 54.4284395904628, 10.159296570971314, 54.484794469309016,
    ],
    '010585822157': [
      10.118206157381902, 54.42898754726353, 10.199111788178012, 54.47475824300409,
    ],
    '010585824051': [
      10.013461759150989, 54.371038976681255, 10.086474924797903, 54.4284395904628,
    ],
    '010585824058': [
      9.944436089035435, 54.3956858017172, 10.013461759150989, 54.42697672774342,
    ],
    '010585824096': [
      9.87029868993644, 54.346005496900645, 9.961642966889402, 54.4109583032368,
    ],
    '010585824110': [
      9.894190820958553, 54.401564471358974, 9.968640854047402, 54.451633058581386,
    ],
    '010585824112': [
      9.969235968041117, 54.34283527223197, 10.071131507112817, 54.37917214105458,
    ],
    '010585824121': [
      9.958406677146737, 54.40990407017654, 10.068914334908445, 54.45611730611889,
    ],
    '010585824142': [
      9.914730703338194, 54.34098672455431, 9.972926953426098, 54.37382414384897,
    ],
    '010585824165': [
      9.93661508460528, 54.35162548508488, 10.046730505940547, 54.41139075669823,
    ],
    '010585833003': [
      9.554727295503925, 54.333439282117524, 9.683098793128803, 54.383490083378746,
    ],
    '010585833054': [
      9.542998620128891, 54.276760237523625, 9.627915406993436, 54.34407047005519,
    ],
    '010585833118': [
      9.569676945796454, 54.23904068026213, 9.633937160020219, 54.28726966887884,
    ],
    '010585833136': [
      9.599337927929627, 54.32625507356823, 9.688976868347678, 54.3518774102832,
    ],
    '010585847010': [
      9.421635453410419, 54.25438206922675, 9.479981333293562, 54.269447284779964,
    ],
    '010585847029': [
      9.468162937686003, 54.183056658444244, 9.585895098092077, 54.223678758598375,
    ],
    '010585847036': [
      9.391877751021863, 54.306645174044036, 9.45228584000484, 54.341372038287126,
    ],
    '010585847047': [
      9.432751273290053, 54.234259577574555, 9.586542294535425, 54.291646874752935,
    ],
    '010585847055': [
      9.395365395279098, 54.26098251954852, 9.441202114777656, 54.29061682851924,
    ],
    '010585847056': [
      9.398517487796537, 54.29727437321249, 9.467863549508175, 54.321005510860836,
    ],
    '010585847070': [
      9.433795946699654, 54.195555490383235, 9.578076979915938, 54.24952709952463,
    ],
    '010585847078': [
      9.395365395279098, 54.26809660279639, 9.566431399770943, 54.331276981606926,
    ],
    '010585847089': [
      9.41012632600353, 54.31724711832843, 9.486510585446148, 54.34621949193145,
    ],
    '010585847097': [
      9.466226142513104, 54.32065060616606, 9.574127359906763, 54.35724013473959,
    ],
    '010585847129': [
      9.432454098108854, 54.20088302768023, 9.465235039118923, 54.23580382324045,
    ],
    '010585847154': [
      9.421635453410419, 54.264586879833374, 9.477689798099373, 54.28830716770538,
    ],
    '010585853031': [
      9.608318235956055, 54.15179441036874, 9.645540265053947, 54.17955153887567,
    ],
    '010585853048': [
      9.550822564600336, 54.16002444463107, 9.617012134570837, 54.19329529304,
    ],
    '010585853068': [
      9.514303455775824, 54.15140156284407, 9.575335836387936, 54.19329529304,
    ],
    '010585853071': [
      9.579784908226886, 54.179521596599386, 9.64583404581941, 54.20798925531185,
    ],
    '010585853075': [
      9.558546025959918, 54.201131664089694, 9.620711235061904, 54.23904068026213,
    ],
    '010585853086': [
      9.611349284806451, 54.18825250233649, 9.752432555771923, 54.26349567692185,
    ],
    '010585853101': [
      9.66317922591916, 54.14308047606336, 9.720836804752492, 54.20332117389228,
    ],
    '010585853148': [
      9.586542294535425, 54.228599942955285, 9.658592217363784, 54.27346436889088,
    ],
    '010585853155': [
      9.632202245208381, 54.14515419142308, 9.681471415054993, 54.20044545993388,
    ],
    '010585853172': [
      9.629187116253622, 54.2537528584068, 9.691321277079544, 54.289935380815464,
    ],
    '010585864011': [
      9.712443599314255, 54.13811322345987, 9.814301431743482, 54.19502949791028,
    ],
    '010585864021': [
      9.735312741697005, 54.19957812460497, 9.8233042551897, 54.24668758072086,
    ],
    '010585864023': [
      9.852943796031552, 54.166599357725225, 9.921924382940206, 54.19095776802269,
    ],
    '010585864027': [
      9.730023964860015, 54.17897658158414, 9.810777661091477, 54.2253126216145,
    ],
    '010585864038': [
      9.90622621688938, 54.15909602466926, 9.969365578838328, 54.20326212409559,
    ],
    '010585864045': [
      9.852943796031552, 54.18044866187442, 9.897520942762672, 54.20773389956987,
    ],
    '010585864046': [
      9.79600960002736, 54.18044866187442, 9.856510706377675, 54.218818029220365,
    ],
    '010585864049': [
      9.730467924507888, 54.218818029220365, 9.900283629124981, 54.285120272059096,
    ],
    '010585864059': [
      9.780596870303603, 54.10592214243662, 9.86422997654968, 54.15560860569645,
    ],
    '010585864065': [
      9.8233042551897, 54.21112831159285, 9.900283629124981, 54.251009807248316,
    ],
    '010585864091': [
      9.902676508694718, 54.10255135899679, 9.964336819827594, 54.14889028583387,
    ],
    '010585864094': [
      9.890923177360982, 54.18184659696096, 9.978835076428334, 54.24956032275485,
    ],
    '010585864117': [
      9.802257440791218, 54.14717086980313, 9.871424243352807, 54.189817701259635,
    ],
    '010585864120': [
      9.720095883702719, 54.14077807305951, 9.752763974599088, 54.166847544413386,
    ],
    '010585864147': [
      9.857111227733673, 54.14163162603937, 9.928757774323822, 54.167281206187305,
    ],
    '010585864163': [
      9.842701093902422, 54.09773177405311, 9.912416486077841, 54.14889028583387,
    ],
    '010585864168': [
      9.854689656072843, 54.19674828771063, 9.913774082405236, 54.23338197463694,
    ],
    '010585888026': [
      9.761979166344304, 54.314262498545475, 9.88790345022039, 54.36296048893717,
    ],
    '010585888073': [
      9.769041778673527, 54.2670570229645, 9.839252963938625, 54.311764159282184,
    ],
    '010585888122': [
      9.748782799815539, 54.30498153283058, 9.806463695617527, 54.328392153877104,
    ],
    '010585888124': [
      9.674709725821634, 54.25140636502246, 9.756098123863095, 54.29931665779333,
    ],
    '010585888132': [
      9.720506944146562, 54.315915566204424, 9.773929279771544, 54.34700719174664,
    ],
    '010585888140': [
      9.702739631957314, 54.299151702511345, 9.753925410708321, 54.336323620093246,
    ],
    '010585888146': [
      9.722525278624822, 54.26052935680958, 9.77977705728412, 54.31162718396598,
    ],
    '010585889016': [
      10.081785396748286, 54.17252328198007, 10.125294104428615, 54.218459620823964,
    ],
    '010585889022': [
      9.989955044255767, 54.13135006679945, 10.053002351828637, 54.18962048961917,
    ],
    '010585889033': [
      10.053002351828637, 54.16582146089449, 10.100792302500471, 54.213516905564624,
    ],
    '010585889063': [
      10.002406681359856, 54.203349068356445, 10.035673962047914, 54.22885059735773,
    ],
    '010585889064': [
      10.067560619338908, 54.13887027859572, 10.130505191490627, 54.17572111956833,
    ],
    '010585889076': [
      9.956303624591209, 54.171992718147, 10.013951690925987, 54.199368936478905,
    ],
    '010585889098': [
      9.919357770552704, 54.13254514657703, 9.980186854939568, 54.16551724390094,
    ],
    '010585889108': [
      9.989168692570928, 54.1412838663499, 10.02389155743297, 54.172118133238705,
    ],
    '010585889109': [
      10.036289923999414, 54.125845490805354, 10.115443415838676, 54.16067578202764,
    ],
    '010585889133': [
      10.048612802814286, 54.18344532917829, 10.075254042660827, 54.210793592716925,
    ],
    '010585889143': [
      10.008818685382932, 54.181948988279345, 10.053002351828637, 54.216926329764085,
    ],
    '010585889144': [
      9.945886906522434, 54.14772602963599, 9.994600955872071, 54.17776977426594,
    ],
    '010585889153': [
      9.959804474025407, 54.190076312342285, 10.009926584451513, 54.22420530333881,
    ],
    '010585889170': [
      10.024543103973475, 54.13091532938397, 10.068767716708834, 54.18344532917829,
    ],
    '010585890008': [
      9.658983821505334, 54.410944149105454, 9.715890408344999, 54.45463008941366,
    ],
    '010585890024': [
      9.671911482137107, 54.32531366688465, 9.745913364177737, 54.3547257915136,
    ],
    '010585890030': [
      9.57494610423155, 54.403565633901835, 9.672496753146934, 54.45436327581081,
    ],
    '010585890035': [
      9.703814935307237, 54.341862307390706, 9.796125969824773, 54.383205243205325,
    ],
    '010585890039': [
      9.704289050699048, 54.40900367512921, 9.763099375102513, 54.44153814847514,
    ],
    '010585890066': [
      9.719700464064365, 54.370579720857975, 9.815851448434657, 54.43483686379285,
    ],
    '010585890069': [
      9.793124953405696, 54.3834065845423, 9.843219548892163, 54.41898241350665,
    ],
    '010585890080': [
      9.821132034461058, 54.37015928757375, 9.904304691796547, 54.42743635506705,
    ],
    '010585890081': [
      9.678278139980685, 54.36113091648339, 9.719700464064365, 54.392982520141004,
    ],
    '010585890083': [
      9.678535292591233, 54.42931248072878, 9.74231190267947, 54.45721373481312,
    ],
    '010585890088': [
      9.70843081596791, 54.3824473964397, 9.744530125524733, 54.410864188966656,
    ],
    '010585890111': [
      9.670830746964516, 54.34879085006648, 9.72735223011303, 54.38081748001548,
    ],
    '010585890123': [
      9.722616586902625, 54.43042314463557, 9.783969646725373, 54.470147143463976,
    ],
    '010585890127': [
      9.546855401102823, 54.354509362309265, 9.672344009135472, 54.433611529889674,
    ],
    '010585890152': [
      9.779922981816625, 54.34443361320114, 9.872160083888732, 54.389988268073715,
    ],
    '010585890175': [
      9.657008886584878, 54.38081748001548, 9.71842685668536, 54.41740997530774,
    ],
    '010585893004': [
      9.855378571280092, 54.42052192810441, 9.94777414703281, 54.46315621329106,
    ],
    '010585893012': [
      9.811878681444165, 54.47553904585755, 9.918305125020975, 54.51642426280186,
    ],
    '010585893032': [
      9.965468449710391, 54.60589504150511, 10.031903567250257, 54.6467674549128,
    ],
    '010585893040': [
      9.941809375670731, 54.55203029900262, 10.026943034063907, 54.595966036433914,
    ],
    '010585893042': [
      9.947782390872133, 54.58082211583239, 10.027921661967536, 54.62806937341206,
    ],
    '010585893052': [
      9.674252360723553, 54.46294481171843, 9.757904645588372, 54.49497363828682,
    ],
    '010585893057': [
      9.773231999405905, 54.488813257689024, 9.834434319509322, 54.51955982949139,
    ],
    '010585893067': [
      9.628136139443418, 54.45436327581081, 9.694641351734658, 54.49537991234951,
    ],
    '010585893082': [
      9.852503804348826, 54.53253279289229, 9.955623520743329, 54.58266154204804,
    ],
    '010585893084': [
      9.641732395828752, 54.44383139743699, 9.7396254475456, 54.47220311579728,
    ],
    '010585893087': [
      9.95028692843164, 54.61881298268497, 9.994183672342038, 54.62980594369934,
    ],
    '010585893090': [
      9.697754513702893, 54.488813257689024, 9.793796263940548, 54.55417109345324,
    ],
    '010585893099': [
      9.834434319509322, 54.5059784972877, 9.93708038177851, 54.53961277872859,
    ],
    '010585893102': [
      9.783969646725373, 54.40976380774062, 9.8571706658147, 54.44907402298683,
    ],
    '010585893137': [
      9.770978195206627, 54.51415213459491, 9.897379171213466, 54.5829796318094,
    ],
    '010585893162': [
      9.831717638687923, 54.561863003603186, 9.972374808285927, 54.61292706934601,
    ],
    '010585893166': [
      9.907063376508077, 54.48947137453243, 10.026561733652304, 54.56836426508868,
    ],
    '010585893173': [
      9.743758379287122, 54.43483686379285, 9.822147273717698, 54.49036232476927,
    ],
    '010585893174': [
      9.906600381588904, 54.59694507500507, 9.964517345002752, 54.62980594369934,
    ],
    '010585895007': [
      9.81428785834049, 54.00848775856919, 9.898322658420705, 54.04631478449024,
    ],
    '010585895009': [
      9.701291126239289, 54.042700674334746, 9.860517174160554, 54.11575307147723,
    ],
    '010585895013': [
      9.303405665260712, 54.097768430197526, 9.375912527973961, 54.14911001208599,
    ],
    '010585895014': [
      9.321096583480463, 54.06373530203339, 9.425917760545675, 54.11815723114111,
    ],
    '010585895015': [
      9.50664844563382, 54.090753057210684, 9.558626852940645, 54.15645350673323,
    ],
    '010585895025': [
      9.311914810807037, 54.06489109175779, 9.352577257373355, 54.11787018688637,
    ],
    '010585895044': [
      9.816601167558549, 54.028161385941026, 9.930970165993553, 54.06950315932253,
    ],
    '010585895061': [
      9.437961716744976, 54.08755109080825, 9.505183182260994, 54.13290827275725,
    ],
    '010585895062': [
      9.643331578726032, 54.0470694551169, 9.693744552791362, 54.07750560867295,
    ],
    '010585895072': [
      9.375912527973961, 54.10929406858473, 9.453351111668466, 54.15943841962136,
    ],
    '010585895074': [
      9.731181248069014, 54.10928556778591, 9.782744700507703, 54.14513308938963,
    ],
    '010585895077': [
      9.602700016233923, 54.071565760977734, 9.723411145206793, 54.11105690059503,
    ],
    '010585895085': [
      9.60433358342889, 54.04775182406393, 9.660663611595865, 54.078717787621336,
    ],
    '010585895100': [
      9.45118433304088, 54.12253852220329, 9.524084628822067, 54.18593647919748,
    ],
    '010585895103': [
      9.678753417185543, 54.040574316245305, 9.750136757837888, 54.07606949103482,
    ],
    '010585895106': [
      9.717849198358872, 54.09756443779561, 9.780714438924829, 54.12894079450425,
    ],
    '010585895113': [
      9.566701561212385, 54.11105690059503, 9.65119324683987, 54.17121758322331,
    ],
    '010585895115': [
      9.66161615766439, 54.112465540366195, 9.732600036425545, 54.14960419546038,
    ],
    '010585895119': [
      9.423597938924724, 54.148023415358885, 9.461524690232112, 54.20088302768023,
    ],
    '010585895125': [
      9.558387369626308, 54.08742471034413, 9.61714553900948, 54.1277407328826,
    ],
    '010585895128': [
      9.884170364617654, 54.01043144680859, 9.955338762873911, 54.052814856605224,
    ],
    '010585895131': [
      9.702017601520467, 54.09350526473636, 9.746573526044614, 54.11732013015589,
    ],
    '010585895134': [
      9.61714553900948, 54.10449823449741, 9.669708274211922, 54.14573454484291,
    ],
    '010585895151': [
      9.472715575390447, 54.08601491888405, 9.517418722962367, 54.12854787919592,
    ],
    '010585895156': [
      9.360240143323963, 54.11815723114111, 9.426489499185811, 54.16746549582938,
    ],
    '010585895158': [
      9.459437869520634, 54.15797281712424, 9.506605459887924, 54.19692925601045,
    ],
    '010585895159': [
      9.66363624713662, 54.086324294562516, 9.736685050127942, 54.11684590818027,
    ],
    '010585895161': [
      9.395159200675238, 54.065874934716454, 9.453407613236216, 54.11789317406798,
    ],
    '010585895164': [
      9.524084628822067, 54.11806970507222, 9.593775163288505, 54.15953244160026,
    ],
    '010585895167': [
      9.581359898156965, 54.06757743548075, 9.63291820148379, 54.10078260675366,
    ],
    '010585896018': [
      9.975316810429618, 54.20921744230263, 10.038280040079627, 54.24440715818713,
    ],
    '010585896019': [
      10.033353691848726, 54.20815031231255, 10.101778934024896, 54.232387527037936,
    ],
    '010585896053': [
      10.03132134197514, 54.22493696952631, 10.126060902301345, 54.26827535682681,
    ],
    '010585896105': [
      10.000376264226531, 54.26837765005036, 10.07076122655575, 54.29976338452762,
    ],
    '010585896107': [
      10.041365872267022, 54.25521528387227, 10.094717252758246, 54.289601743069056,
    ],
    '010585896138': [
      9.970897228729262, 54.26595772551758, 10.02730932743583, 54.29363710542628,
    ],
    '010585896139': [
      10.000270328414715, 54.23396150906604, 10.042416144936867, 54.27576942701295,
    ],
    '010585896141': [
      9.948376231275319, 54.23850867690799, 10.006999753790714, 54.28586345510892,
    ],
    '010585896145': [
      10.096829766120628, 54.213216298665145, 10.125645878084988, 54.23560258068807,
    ],
    '010585896160': [
      10.030592511327963, 54.1975807409525, 10.065782146171115, 54.22328794100104,
    ],
    '010590045045': [
      9.870216447853698, 54.628687671154275, 10.033372899540074, 54.70133829833729,
    ],
    '010590075075': [
      9.510480579742973, 54.49157646718436, 9.606086939811442, 54.545967305016696,
    ],
    '010590113113': [
      9.49234083982587, 54.81052538451214, 9.614150322348017, 54.876791268890486,
    ],
    '010590120120': [
      9.34578155082154, 54.78027515182599, 9.424043994621195, 54.84285295875876,
    ],
    '010590183183': [
      9.245357166096749, 54.70376963508188, 9.448686427163866, 54.812202370191294,
    ],
    '010595912107': [
      9.321174499301597, 54.59854894985425, 9.400661684097821, 54.64307583699805,
    ],
    '010595912128': [
      9.257925454845292, 54.606927293013435, 9.323998208571707, 54.65678807260823,
    ],
    '010595912131': [
      9.313404793590369, 54.638460135116226, 9.401673386251607, 54.685745140410084,
    ],
    '010595912132': [
      9.20736254903719, 54.591191587331316, 9.31840313254248, 54.65678807260823,
    ],
    '010595912138': [
      9.346310122915026, 54.58701914364942, 9.441751951825271, 54.6340189689556,
    ],
    '010595912162': [
      9.28492128989032, 54.55257801766273, 9.349867547887868, 54.61016678179646,
    ],
    '010595912169': [
      9.249820584292387, 54.5711513240518, 9.313675534203599, 54.60194658658691,
    ],
    '010595912174': [
      9.257925454845292, 54.65099109900946, 9.372330882154065, 54.71352678061914,
    ],
    '010595915012': [
      9.629602464456662, 54.4771508545641, 9.675120957823793, 54.51005631090275,
    ],
    '010595915018': [
      9.529657729494842, 54.47306125927934, 9.579497278312045, 54.50544118096053,
    ],
    '010595915019': [
      9.4369575053468, 54.454456027406685, 9.537264405317387, 54.50509058012206,
    ],
    '010595915026': [
      9.567826728188086, 54.47407430718967, 9.630667520631185, 54.51005631090275,
    ],
    '010595915032': [
      9.591701275038174, 54.44251014686301, 9.641732395828752, 54.48084153454681,
    ],
    '010595915043': [
      9.508064625578184, 54.43045727311114, 9.567889464065239, 54.47405656897957,
    ],
    '010595915056': [
      9.558728569145117, 54.4327401379534, 9.599121226920238, 54.46007756650087,
    ],
    '010595915078': [
      9.546313074439556, 54.44171228295108, 9.620299125520262, 54.489122877499995,
    ],
    '010595919103': [
      9.54475818191786, 54.71661837044664, 9.603690939949246, 54.7483186203058,
    ],
    '010595919116': [
      9.462804940100927, 54.66986724090588, 9.597986969085307, 54.72709605676521,
    ],
    '010595919126': [
      9.46158619633121, 54.73032756723224, 9.566811841121028, 54.798042564585316,
    ],
    '010595919127': [
      9.553028860217625, 54.73945188095714, 9.62717549587362, 54.796863617952894,
    ],
    '010595919182': [
      9.448686427163866, 54.703268191367435, 9.547847030425014, 54.75523057497257,
    ],
    '010595920002': [
      9.915381622604446, 54.62808489013908, 9.935593526171948, 54.638107212896024,
    ],
    '010595920034': [
      9.89321032005806, 54.625880944145116, 9.93256283753855, 54.65308178569019,
    ],
    '010595920067': [
      9.815450893910075, 54.65650786583779, 9.877088052347817, 54.68966629950153,
    ],
    '010595920068': [
      9.828286660254955, 54.62050790135378, 9.91209246023105, 54.66185959058941,
    ],
    '010595937106': [
      9.646601391058345, 54.75662040790045, 9.718888531231203, 54.80468306429806,
    ],
    '010595937118': [
      9.606470908504175, 54.752274475317066, 9.664755561694781, 54.796863617952894,
    ],
    '010595937137': [
      9.611581087431928, 54.78397810703754, 9.667092601866601, 54.8284511987074,
    ],
    '010595937145': [
      9.553013671296746, 54.78927766246097, 9.63440698104033, 54.83087491051451,
    ],
    '010595937157': [
      9.572795725728053, 54.78927766246097, 9.616087518422304, 54.821988274304275,
    ],
    '010595937176': [
      9.503899618366257, 54.78978575049963, 9.569036214425545, 54.824388469148246,
    ],
    '010595937178': [
      9.658321667782493, 54.79451423131734, 9.727426767786348, 54.82232299193813,
    ],
    '010595940159': [
      9.422469591809618, 54.607368904057424, 9.511693626006698, 54.67985990152444,
    ],
    '010595940171': [
      9.366711735322268, 54.62190058793767, 9.434129833524361, 54.699172609728365,
    ],
    '010595940184': [
      9.366711735322268, 54.67461248382161, 9.483162635073548, 54.75190183162364,
    ],
    '010595949076': [
      9.620593207610492, 54.63333313526548, 9.678678062765398, 54.676515025467786,
    ],
    '010595949161': [
      9.592931141967988, 54.68780260728008, 9.717581231768824, 54.759570853179085,
    ],
    '010595949185': [
      9.532994740870395, 54.636253992569145, 9.680971786905044, 54.71661837044664,
    ],
    '010595952105': [
      9.162097403932266, 54.83202981189071, 9.187808858148426, 54.86604784323649,
    ],
    '010595952115': [
      9.218671638379746, 54.65678807260823, 9.30490058230274, 54.73932252534573,
    ],
    '010595952123': [
      9.071501784812932, 54.714278191197096, 9.136260391047772, 54.76951450539637,
    ],
    '010595952124': [
      9.077956462854551, 54.783078206846284, 9.166350165261914, 54.82929855468259,
    ],
    '010595952129': [
      9.176453826730947, 54.81044048163848, 9.245357303497522, 54.86168590357652,
    ],
    '010595952143': [
      9.148809608200086, 54.78794409989318, 9.20589956192214, 54.83202981189071,
    ],
    '010595952144': [
      9.19515496459831, 54.73582213230647, 9.277572174408741, 54.76946846186969,
    ],
    '010595952149': [
      9.134602822122234, 54.71748135267815, 9.196846499072619, 54.75035252563658,
    ],
    '010595952151': [
      9.166350165261914, 54.78173199237989, 9.250171436375982, 54.81687128409195,
    ],
    '010595952158': [
      9.10808547964388, 54.74746015329793, 9.209124007038053, 54.78723637416791,
    ],
    '010595952173': [
      9.161839717245487, 54.759224683433374, 9.273827914014637, 54.803229314528984,
    ],
    '010595952177': [
      9.105159861447275, 54.81765295249173, 9.176453826730947, 54.874313864432615,
    ],
    '010595952179': [
      9.063198983222762, 54.6473904713117, 9.257925454845292, 54.73932252534573,
    ],
    '010595974006': [
      9.656359571306727, 54.62491195883194, 9.740557708012123, 54.66639242580219,
    ],
    '010595974055': [
      9.686933018177891, 54.590987282850065, 9.726689445547308, 54.622226014637356,
    ],
    '010595974060': [
      9.660577329513655, 54.656422747929255, 9.74061051518946, 54.697592847765335,
    ],
    '010595974063': [
      9.733650923763683, 54.64033958286029, 9.78984354496257, 54.66643497354968,
    ],
    '010595974065': [
      9.74352298205001, 54.60486200553083, 9.781892474652008, 54.62348198663151,
    ],
    '010595974070': [
      9.739380382028614, 54.676033075729514, 9.796834383082055, 54.697592847765335,
    ],
    '010595974072': [
      9.727343113070436, 54.649763258645535, 9.789928561636556, 54.682082179218746,
    ],
    '010595974074': [
      9.789463658347241, 54.64813358534075, 9.83733841802604, 54.68811412100075,
    ],
    '010595974080': [
      9.717066844595223, 54.58375751466433, 9.769751371654174, 54.620256756315804,
    ],
    '010595974083': [
      9.687115004272153, 54.61798091087337, 9.844214086349174, 54.649752468473174,
    ],
    '010595974094': [
      9.713035442386715, 54.544516204391705, 9.797606903402759, 54.60486200553083,
    ],
    '010595974095': [
      9.778014270484455, 54.645304779339654, 9.81367946930889, 54.676206912128364,
    ],
    '010595974187': [
      9.769751371654174, 54.577623777772914, 9.885269801230157, 54.641559013747695,
    ],
    '010595987008': [
      9.54823034049255, 54.59519726645656, 9.62643696933924, 54.62115861736385,
    ],
    '010595987037': [
      9.47315233181352, 54.62956463136804, 9.54813837850473, 54.68531644422349,
    ],
    '010595987042': [
      9.480920449343515, 54.5509234923468, 9.550810977381069, 54.598438009950144,
    ],
    '010595987049': [
      9.500930190357774, 54.60797306870289, 9.558827276421693, 54.642759978246616,
    ],
    '010595987062': [
      9.505948016131722, 54.54206605194394, 9.547190651040061, 54.565667992826775,
    ],
    '010595987073': [
      9.590849135565033, 54.517748205203404, 9.687112035221654, 54.56627648177934,
    ],
    '010595987081': [
      9.456628977395749, 54.58179168312667, 9.572491733712196, 54.61565783142081,
    ],
    '010595987082': [
      9.596153175802838, 54.60465991750663, 9.670806720694033, 54.66710126203692,
    ],
    '010595987084': [
      9.540160729091495, 54.57274364413846, 9.622074868108477, 54.60087337192838,
    ],
    '010595987086': [
      9.655130471643671, 54.55181558374961, 9.724097420457156, 54.59489419131456,
    ],
    '010595987090': [
      9.611178445512408, 54.56504415268857, 9.663292042033303, 54.60876355242408,
    ],
    '010595987093': [
      9.554888738998164, 54.6183578222648, 9.622353690482814, 54.65092509364318,
    ],
    '010595987097': [
      9.64241982322839, 54.571094751338094, 9.699978962368217, 54.630014418110456,
    ],
    '010595987098': [
      9.52711777236062, 54.54192304289264, 9.625120818357924, 54.586013897230444,
    ],
    '010595987189': [
      9.672492236406443, 54.52524787836409, 9.73669902545337, 54.566182454757744,
    ],
    '010595990102': [
      9.709785809237758, 54.696776661277276, 9.75004127020678, 54.715347866984075,
    ],
    '010595990109': [
      9.77487531047757, 54.687502375630736, 9.853252817551652, 54.74258319208487,
    ],
    '010595990112': [
      9.87020718615863, 54.718825884922495, 9.942419929794333, 54.77129015640586,
    ],
    '010595990121': [
      9.919957045969095, 54.69680263738114, 9.989974347735515, 54.73832200651488,
    ],
    '010595990136': [
      9.938980357122045, 54.725630368088126, 9.983705363455192, 54.75926017082775,
    ],
    '010595990142': [
      9.981805275005552, 54.67655610789266, 10.036807381425064, 54.71747095262903,
    ],
    '010595990147': [
      9.900443832074394, 54.76459454179915, 9.964216299555105, 54.79959613302181,
    ],
    '010595990148': [
      9.783584901637187, 54.73016262449655, 9.87330212878259, 54.7595105345798,
    ],
    '010595990152': [
      9.930697760175617, 54.7352715604709, 9.977851192076715, 54.76985535999858,
    ],
    '010595990154': [
      9.93083800760647, 54.6800496019739, 9.981805275005552, 54.70848048316297,
    ],
    '010595990155': [
      9.885513571571328, 54.68917310300864, 9.923717615694326, 54.73010256306063,
    ],
    '010595990163': [
      9.81970828943981, 54.707422434547425, 9.885513571571328, 54.74258319208487,
    ],
    '010595990164': [
      9.768766691168738, 54.74152263273734, 9.834223108887217, 54.79726784476875,
    ],
    '010595990167': [
      9.70033571168794, 54.69515111849532, 9.785747545023401, 54.7443163272938,
    ],
    '010595990168': [
      9.826042063522811, 54.66612638635604, 9.904168026206836, 54.718825884922495,
    ],
    '010595990186': [
      9.691297547503924, 54.734610571934795, 9.78572045577813, 54.80655938466449,
    ],
    '010595993010': [
      9.366444954590353, 54.56364492573314, 9.481437970600073, 54.617808497408596,
    ],
    '010595993023': [
      9.35743790183222, 54.454456027406685, 9.454964471611586, 54.506262533419154,
    ],
    '010595993039': [
      9.316552178522674, 54.44188136801656, 9.382536206829664, 54.49428958104278,
    ],
    '010595993041': [
      9.421733754988708, 54.47543346493221, 9.516658965737031, 54.512762972974414,
    ],
    '010595993044': [
      9.354267822388454, 54.536502787041755, 9.454307104815214, 54.57183011124543,
    ],
    '010595993057': [
      9.426895260660086, 54.52941800738996, 9.542590110156308, 54.56487527044859,
    ],
    '010595993077': [
      9.40585925475051, 54.49412879930255, 9.52569278920407, 54.54120357243229,
    ],
    '010595993079': [
      9.321351138595324, 54.48813099642856, 9.416516956986623, 54.58847031100112,
    ],
    '010595993092': [
      9.281027513711601, 54.47745850746914, 9.353943273152483, 54.553058856459465,
    ],
    '010595996001': [
      9.38384875795234, 54.36357652399632, 9.489625284353524, 54.39039711316595,
    ],
    '010595996005': [
      9.259577907620896, 54.34617498289616, 9.360973452118444, 54.39792675526244,
    ],
    '010595996009': [
      9.327282333759745, 54.38276006113197, 9.437977671780876, 54.4280215952982,
    ],
    '010595996020': [
      9.298315052529523, 54.412800640093515, 9.408323857960712, 54.45123469255818,
    ],
    '010595996024': [
      9.259831775953431, 54.27539666327597, 9.387292568108684, 54.34739001480685,
    ],
    '010595996035': [
      9.379387397185218, 54.42014028827817, 9.464962321837136, 54.460279575716385,
    ],
    '010595996050': [
      9.348439852434296, 54.367861622079324, 9.495084537611156, 54.424171585067675,
    ],
    '010595996051': [
      9.458539417024248, 54.4235879689882, 9.516083038881717, 54.46415149635557,
    ],
    '010595996053': [
      9.484839053253454, 54.36357652399632, 9.563394870541773, 54.44493458995236,
    ],
    '010595996058': [
      9.31157696009803, 54.299585394892, 9.417242530652967, 54.37445429712602,
    ],
    '010595996087': [
      9.406588478269907, 54.33809077415508, 9.563394870541773, 54.37136140226817,
    ],
    '010595996088': [
      9.299603051012637, 54.27202415487596, 9.398517487796537, 54.30947232242768,
    ],
    '010595996096': [
      9.265443886956378, 54.38216359076974, 9.344611444407953, 54.429517321632346,
    ],
    '010595996188': [
      9.172342166911715, 54.3158010740722, 9.308607638593017, 54.386782972985024,
    ],
    '010600004004': [
      9.851733186251337, 53.887541166154094, 9.952191198597607, 53.94374601572693,
    ],
    '010600005005': [
      10.269611756494296, 53.91787684216248, 10.373352287101905, 53.97208886931941,
    ],
    '010600019019': [
      9.891931292628112, 53.748443265334735, 9.961439349594452, 53.76976221717395,
    ],
    '010600039039': [
      9.926963268048366, 53.74576761545827, 10.074337488124412, 53.815064866069164,
    ],
    '010600044044': [
      9.872450043411837, 53.80212301031722, 9.984448880393014, 53.85719539298118,
    ],
    '010600063063': [
      9.937116987201563, 53.65055705924426, 10.070834584473896, 53.75877418683212,
    ],
    '010600092092': [
      10.150912786741188, 53.93495309754955, 10.238346442725787, 53.97395487789162,
    ],
    '010605005003': [
      9.823909976461112, 53.95158469250163, 9.891399454836396, 53.98343766597301,
    ],
    '010605005009': [
      9.915555947099305, 53.91027138229979, 10.038019310614665, 53.949242392802866,
    ],
    '010605005013': [
      9.776787610407997, 53.95663827842226, 9.823909976461112, 53.981167150554256,
    ],
    '010605005021': [
      9.757330736296774, 53.91333111860951, 9.833859071483571, 53.93789412941852,
    ],
    '010605005023': [
      9.851463811319627, 53.93137657148008, 9.91376435533542, 53.95673096546309,
    ],
    '010605005027': [
      9.898322658420705, 53.93833707317646, 10.054242015832058, 54.02468908053547,
    ],
    '010605005031': [
      9.807070124863579, 53.93275384086727, 9.86777412390242, 53.959702321203885,
    ],
    '010605005033': [
      9.854382485993066, 53.982658765965745, 9.918314651259436, 54.01043144680859,
    ],
    '010605005035': [
      9.826593405299935, 53.977637376049685, 9.876331365011565, 54.01211524187501,
    ],
    '010605005037': [
      9.792129227109722, 53.81469757888645, 9.875604534514636, 53.88123379555039,
    ],
    '010605005040': [
      9.822215784602017, 53.906155403346624, 9.876699131069193, 53.940080825051,
    ],
    '010605005056': [
      9.752453445358654, 53.86021953596531, 9.813462260816504, 53.91333111860951,
    ],
    '010605005095': [
      9.761867912870247, 53.879768573382954, 9.858894418609422, 53.916072632733155,
    ],
    '010605005099': [
      9.87059274151992, 53.940896756446634, 9.956996187731232, 53.9870627273052,
    ],
    '010605024012': [
      10.197871257939454, 54.028009597093174, 10.269545225813232, 54.0893934084685,
    ],
    '010605024017': [
      10.285234600177997, 54.054188508251514, 10.353781246294703, 54.08014110254752,
    ],
    '010605024026': [
      10.121949235078224, 54.03140010923735, 10.217758751492031, 54.07171221634626,
    ],
    '010605024072': [
      10.256663672715556, 54.059278733886806, 10.301640623411819, 54.10122773383557,
    ],
    '010605024080': [
      10.300347740919376, 54.07102778829579, 10.35752219233676, 54.10781985632107,
    ],
    '010605024086': [
      10.240933265931098, 54.025952785949826, 10.291838860042713, 54.064190502938196,
    ],
    '010605024087': [
      10.285022650890593, 54.02453062090195, 10.339507716773738, 54.060513779454304,
    ],
    '010605024089': [
      10.201654787878214, 54.02971434823537, 10.232969908174198, 54.05235179123501,
    ],
    '010605034043': [
      10.136202131998232, 53.78727445080877, 10.194777437881084, 53.8182758960337,
    ],
    '010605034046': [
      10.108113172617822, 53.7450848094769, 10.145472952139936, 53.77171262946934,
    ],
    '010605034058': [
      10.111760266265966, 53.77086650736761, 10.15703746928711, 53.8208147517059,
    ],
    '010605034065': [
      10.10780086130782, 53.81085368101798, 10.171383164027441, 53.8413478378677,
    ],
    '010605034076': [
      10.134307416359796, 53.83590843569893, 10.198059717118104, 53.870519728435625,
    ],
    '010605034085': [
      10.161493158865179, 53.782062832453946, 10.262612190866223, 53.85497653099192,
    ],
    '010605043002': [
      9.866950273337238, 53.76797354394028, 9.969745700741246, 53.8164088671302,
    ],
    '010605043034': [
      10.036781330515126, 53.875457595319844, 10.107408889317309, 53.91923970783487,
    ],
    '010605043036': [
      9.950372453317812, 53.88567935693286, 10.045704296284894, 53.935099793379536,
    ],
    '010605043054': [
      9.826788475061111, 53.84765960824001, 9.944398055191678, 53.90016896736275,
    ],
    '010605043064': [
      9.856037806755907, 53.8250240641292, 9.97587543041743, 53.88035051186885,
    ],
    '010605043073': [
      9.940017203179302, 53.85719539298118, 10.027571211286201, 53.90251107213223,
    ],
    '010605048042': [
      10.05352969305977, 53.82840827471292, 10.08553453932031, 53.843888334209055,
    ],
    '010605048045': [
      9.999041260262272, 53.83245874974728, 10.081494042465662, 53.866280867125276,
    ],
    '010605048047': [
      9.97879072579385, 53.79446444228917, 10.113769274565595, 53.833636104318764,
    ],
    '010605048066': [
      9.97587543041743, 53.826693955461465, 10.013789898163266, 53.86230632667924,
    ],
    '010605048077': [
      10.07990207611084, 53.82202476619297, 10.136874377238486, 53.860037660183345,
    ],
    '010605048082': [
      10.021481060101609, 53.847835008672625, 10.109010118125235, 53.887519573219045,
    ],
    '010605048084': [
      10.09810332563422, 53.8413478378677, 10.14564005953817, 53.87512111398399,
    ],
    '010605048094': [
      10.044158521167816, 53.76488417588307, 10.118658198478466, 53.80544720325207,
    ],
    '010605048100': [
      9.989747603542643, 53.82226905528842, 10.038980215726973, 53.83994618114294,
    ],
    '010605053007': [
      10.105481997830463, 53.89017897560669, 10.223035189498857, 53.93764908726691,
    ],
    '010605053008': [
      10.275084190917596, 53.866259380954865, 10.329498701588873, 53.89155787748497,
    ],
    '010605053022': [
      10.156682017947983, 53.857455483734306, 10.215105738269997, 53.885126025548836,
    ],
    '010605053029': [
      10.206766038636673, 53.82662391228423, 10.272587842870903, 53.862397758472014,
    ],
    '010605053041': [
      10.240130918593287, 53.90603710870119, 10.304960244747193, 53.93416877369761,
    ],
    '010605053051': [
      10.203601368844083, 53.88104308543937, 10.251403038643106, 53.91176143066079,
    ],
    '010605053053': [
      10.19330603313871, 53.84752218301177, 10.282764167386741, 53.89130049837464,
    ],
    '010605053057': [
      10.237645824366888, 53.888645429929326, 10.283289876600033, 53.923362162338755,
    ],
    '010605053062': [
      10.261325258843433, 53.84555789037309, 10.318895626769105, 53.87257684277052,
    ],
    '010605053074': [
      10.272193283948967, 53.88979183327748, 10.314425644296307, 53.91216614954363,
    ],
    '010605053088': [
      10.085860019618881, 53.86907553552228, 10.204958602521566, 53.90170057962309,
    ],
    '010605053101': [
      10.203921449600879, 53.911370564127736, 10.24181929576151, 53.94405961754379,
    ],
    '010605063011': [
      9.969717311766455, 53.964686324636155, 10.067427439532098, 54.040461852198085,
    ],
    '010605063016': [
      10.21082580380853, 53.992315485472055, 10.294508852031415, 54.04042532473396,
    ],
    '010605063028': [
      10.012134312308433, 54.004164036965264, 10.149367058441614, 54.057730819985494,
    ],
    '010605063038': [
      10.032543622232481, 53.92982000567621, 10.141417546066082, 53.98756401346771,
    ],
    '010605063052': [
      10.039861502007337, 53.973890927307636, 10.124108786945289, 54.01969793073087,
    ],
    '010605063068': [
      10.11535226538133, 53.96845198090242, 10.22805266283414, 54.03888992536194,
    ],
    '010605086006': [
      10.357118001494321, 53.868051178913724, 10.416906553236144, 53.887580888570746,
    ],
    '010605086010': [
      10.282532073962265, 53.98579092529075, 10.341807914114005, 54.03053935447905,
    ],
    '010605086015': [
      10.357118001494321, 53.874587506810556, 10.433965482293091, 53.894844395841055,
    ],
    '010605086018': [
      10.326952222579159, 53.8715204817234, 10.358122711942503, 53.887580888570746,
    ],
    '010605086020': [
      10.237890799102416, 53.928299075529345, 10.274344444002072, 53.962280176428656,
    ],
    '010605086024': [
      10.420237972881784, 53.906097969280715, 10.47040920779443, 53.93209330914381,
    ],
    '010605086025': [
      10.484382856390443, 54.01799841794184, 10.563246410311681, 54.0730248163022,
    ],
    '010605086030': [
      10.286338644002901, 53.96672831642299, 10.350248034947706, 53.99537674832699,
    ],
    '010605086048': [
      10.298799386326419, 53.90603710870119, 10.347469090565179, 53.92289625335456,
    ],
    '010605086049': [
      10.309014880573518, 53.9491097307553, 10.350248034947706, 53.97489169997426,
    ],
    '010605086050': [
      10.320794931393586, 53.97489169997426, 10.394466076281995, 54.01194805505546,
    ],
    '010605086059': [
      10.203229217213003, 53.96151134711954, 10.301616460281, 54.00738854676889,
    ],
    '010605086060': [
      10.31399300335579, 53.99982843546452, 10.393832682598461, 54.04651686659767,
    ],
    '010605086061': [
      10.335418796943873, 53.87861551918854, 10.44511873997154, 53.916588145984434,
    ],
    '010605086067': [
      10.447145053041066, 53.91234713267239, 10.552907894925957, 53.988714578376836,
    ],
    '010605086069': [
      10.349825916296643, 53.94450371810309, 10.454266181864774, 53.984689053846566,
    ],
    '010605086070': [
      10.237890799102416, 53.93748990070713, 10.291282650769592, 53.97952374594741,
    ],
    '010605086071': [
      10.363963776704132, 53.93199916361657, 10.430859549875192, 53.95287807718508,
    ],
    '010605086075': [
      10.328439330017334, 54.017425736134214, 10.510362021130861, 54.08245017551034,
    ],
    '010605086079': [
      10.324216849689213, 53.93525627901594, 10.370058479669364, 53.95380100054047,
    ],
    '010605086081': [
      10.459413448767439, 53.89972266824994, 10.510193741560759, 53.93058847140775,
    ],
    '010605086090': [
      10.399192420121958, 53.99716082724543, 10.487737417123919, 54.034281815243794,
    ],
    '010605086091': [
      10.302828778170728, 53.88204057834429, 10.349192928190833, 53.9069946923357,
    ],
    '010605086093': [
      10.329498701588873, 53.853418903570166, 10.39552789256135, 53.875598776901235,
    ],
    '010605086096': [
      10.32520315743855, 53.89972266824994, 10.467784972437922, 53.940153855710605,
    ],
    '010605086097': [
      10.372655025992902, 53.968418079435736, 10.460532443698783, 54.0220058258232,
    ],
    '010605086098': [
      10.428740708514367, 53.92345328061561, 10.474893135741173, 53.94953281569179,
    ],
    '010610029029': [
      9.403907780909048, 53.75591593633447, 9.451388121161656, 53.808938775745844,
    ],
    '010610046046': [
      9.470109789194671, 53.9000988682918, 9.577881487774349, 53.96320915876025,
    ],
    '010610113113': [
      9.351067903915894, 53.914602518649886, 9.389360495116717, 53.93281096198205,
    ],
    '010615104005': [
      9.671467853764526, 53.89754334802103, 9.705205667495232, 53.93538165297666,
    ],
    '010615104016': [
      9.621601627322057, 53.91514181022357, 9.660481509317153, 53.938984220876954,
    ],
    '010615104017': [
      9.492730652428294, 53.87134552784507, 9.648389728519568, 53.91180399758822,
    ],
    '010615104053': [
      9.581495531424544, 53.91512034544782, 9.621601627322057, 53.932978816135666,
    ],
    '010615104058': [
      9.574882301602665, 53.88764084014733, 9.627741806081035, 53.91709921880567,
    ],
    '010615104061': [
      9.5444004381273, 53.871945474415014, 9.608352623753884, 53.893004642356374,
    ],
    '010615104068': [
      9.63818848147163, 53.889367015254294, 9.69292332182249, 53.925328275739766,
    ],
    '010615104072': [
      9.512920770548213, 53.88852956298419, 9.562081363085046, 53.91483137204337,
    ],
    '010615104079': [
      9.526650999883348, 53.90688320438817, 9.610769955119611, 53.948253117572776,
    ],
    '010615104109': [
      9.596914326648143, 53.87802464398294, 9.671031045561637, 53.92578753626927,
    ],
    '010615104115': [
      9.651447710906284, 53.915098150776565, 9.692532969633726, 53.94206935748877,
    ],
    '010615134004': [
      9.54545578251423, 53.75234250220065, 9.643281163316486, 53.777698844675065,
    ],
    '010615134012': [
      9.394680553123093, 53.78888670784773, 9.487909381364082, 53.82547492918709,
    ],
    '010615134015': [
      9.403100166768297, 53.80842203846073, 9.479243422151036, 53.84778799420602,
    ],
    '010615134027': [
      9.442430369681437, 53.76626405461967, 9.48542839136757, 53.793191155768454,
    ],
    '010615134037': [
      9.459703221415928, 53.76114149376215, 9.55296199735897, 53.79572493080206,
    ],
    '010615134041': [
      9.572817154547211, 53.82527304668669, 9.676442035031156, 53.87381359779362,
    ],
    '010615134044': [
      9.568030246789329, 53.77386305440906, 9.673825576297515, 53.83941824222787,
    ],
    '010615134050': [
      9.561596626402144, 53.76501914720575, 9.624954728780391, 53.79216158271071,
    ],
    '010615134054': [
      9.450649790357291, 53.80842203846073, 9.498302910433505, 53.834505130431275,
    ],
    '010615134074': [
      9.504615654458341, 53.71428371852712, 9.583563438260473, 53.76114149376215,
    ],
    '010615134101': [
      9.499789525687975, 53.77176807068065, 9.592029374261775, 53.83193999800427,
    ],
    '010615134118': [
      9.430225359354269, 53.719436220890906, 9.552778840794526, 53.76768858391604,
    ],
    '010615138008': [
      9.394805319585842, 53.9295126691477, 9.433748282709496, 53.94206506526804,
    ],
    '010615138010': [
      9.429935426640325, 53.921936084092884, 9.464467254535922, 53.93951506950953,
    ],
    '010615138024': [
      9.483331318895676, 53.996595273790895, 9.5848563201091, 54.026564578088056,
    ],
    '010615138034': [
      9.444380649407417, 53.90179617955559, 9.490446032701096, 53.949916743810796,
    ],
    '010615138035': [
      9.457227911796933, 53.89635312138883, 9.477725656842924, 53.907496267649584,
    ],
    '010615138039': [
      9.407351191773364, 53.88154046210863, 9.468832632962743, 53.91505224652343,
    ],
    '010615138040': [
      9.48292236015937, 53.9681631502222, 9.566963580411581, 54.005318520787526,
    ],
    '010615138045': [
      9.40409807683579, 53.96454977023022, 9.453958478390962, 53.99320553876915,
    ],
    '010615138047': [
      9.433304929363308, 53.975928525562715, 9.498578297309908, 54.011125624866494,
    ],
    '010615138052': [
      9.371239821564311, 53.951197467339576, 9.432809459017355, 53.97938045502876,
    ],
    '010615138059': [
      9.39080331307576, 53.93622667723715, 9.43266661577445, 53.9542628203153,
    ],
    '010615138065': [
      9.617699529846996, 53.92846128285064, 9.656000830699083, 53.96621221198885,
    ],
    '010615138067': [
      9.406872951838668, 53.98527784145528, 9.465213471591948, 54.026002331950174,
    ],
    '010615138070': [
      9.371239821564311, 53.943588966858535, 9.414719718896007, 53.96845361533155,
    ],
    '010615138082': [
      9.419293276951555, 53.93628751577703, 9.483502449864863, 53.975928525562715,
    ],
    '010615138083': [
      9.453958478390962, 53.95562840962558, 9.54732243315474, 53.98299181103797,
    ],
    '010615138084': [
      9.563152335997517, 54.016129991685865, 9.630260888265902, 54.04934925863869,
    ],
    '010615138098': [
      9.53948103399597, 53.94438055991841, 9.602372599474863, 53.96687595002482,
    ],
    '010615138100': [
      9.612639552851233, 54.016129991685865, 9.657756873395304, 54.04934925863869,
    ],
    '010615138114': [
      9.590699524460337, 53.92578753626927, 9.634173854623084, 53.96396601291164,
    ],
    '010615153006': [
      9.416711632321748, 53.8468593733435, 9.48367936218581, 53.88745997541905,
    ],
    '010615153022': [
      9.493875954800965, 53.87081935806762, 9.545373759225605, 53.89596451965856,
    ],
    '010615153026': [
      9.463172623471634, 53.79252735521195, 9.524407612981209, 53.81994054325753,
    ],
    '010615153030': [
      9.495490711685388, 53.82326767744138, 9.560410117131918, 53.85271572756924,
    ],
    '010615153055': [
      9.476390304488028, 53.81701756488999, 9.51062089454335, 53.84897976537091,
    ],
    '010615153056': [
      9.468163976441069, 53.87693014347004, 9.504585294846654, 53.90031667164792,
    ],
    '010615153057': [
      9.468832632962743, 53.868885270089756, 9.504825648776311, 53.88154046210863,
    ],
    '010615153073': [
      9.48120237707355, 53.84441669892349, 9.580537022032319, 53.87611777974153,
    ],
    '010615153092': [
      9.57746446286578, 53.85330375213594, 9.632733417538573, 53.88235781744621,
    ],
    '010615153104': [
      9.508134637462142, 53.80962853679924, 9.586984490691284, 53.84749252032304,
    ],
    '010615168001': [
      9.41798945262702, 54.05575902036742, 9.460863651379936, 54.08001078857726,
    ],
    '010615168003': [
      9.405352044434057, 54.00478744095339, 9.455233840124327, 54.038939695101284,
    ],
    '010615168011': [
      9.333681984118682, 54.04097681688534, 9.394851099261215, 54.07078876372303,
    ],
    '010615168013': [
      9.379597828643409, 54.033320460855215, 9.440619804576198, 54.05087148076062,
    ],
    '010615168014': [
      9.378672378826003, 54.04331644311395, 9.424177420632052, 54.070998954653724,
    ],
    '010615168021': [
      9.51674516250068, 54.043011625564645, 9.548639285145137, 54.07176314861322,
    ],
    '010615168031': [
      9.297795668864554, 53.99730889433964, 9.388275998945215, 54.03696578911261,
    ],
    '010615168033': [
      9.43864675128827, 54.026002331950174, 9.466187103352135, 54.0459651273931,
    ],
    '010615168043': [
      9.285182448645969, 54.03099459124352, 9.381155764477123, 54.066293992477455,
    ],
    '010615168048': [
      9.455233840124327, 54.00577933565983, 9.485530405976727, 54.02783607287863,
    ],
    '010615168066': [
      9.496409372828966, 54.017769299264515, 9.574632199180119, 54.051452754328736,
    ],
    '010615168076': [
      9.396978752390337, 54.022068257982326, 9.431963230880472, 54.04575235005292,
    ],
    '010615168078': [
      9.344265202850169, 53.96845361533155, 9.406872951838668, 53.99577220055021,
    ],
    '010615168081': [
      9.492310012907685, 54.052783908789245, 9.532984489634828, 54.07298430660667,
    ],
    '010615168085': [
      9.463785251935256, 54.01946135823176, 9.52310956775204, 54.053073490584104,
    ],
    '010615168087': [
      9.479102343204522, 54.06241570292697, 9.558626852940645, 54.096387501506925,
    ],
    '010615168091': [
      9.539878240044242, 54.04146369873574, 9.60648883951074, 54.090753057210684,
    ],
    '010615168097': [
      9.424104752355493, 54.03421573930356, 9.500038219843592, 54.064952279920306,
    ],
    '010615168105': [
      9.290344830408054, 53.9836349160136, 9.4091264293855, 54.012406435831565,
    ],
    '010615168106': [
      9.302212240047965, 53.96541511477842, 9.371239821564311, 53.994555435064925,
    ],
    '010615168107': [
      9.343676885241836, 54.010053801736504, 9.406999347494118, 54.03756489728788,
    ],
    '010615168108': [
      9.450733708101234, 54.05747314569253, 9.493868128069218, 54.09153745428187,
    ],
    '010615179002': [
      9.272555138225206, 53.96240100817422, 9.301029970955932, 53.97939461412313,
    ],
    '010615179007': [
      9.362593627071064, 53.84574882548474, 9.435630445677376, 53.904840909559425,
    ],
    '010615179018': [
      9.273518588923595, 53.84457320535264, 9.357535038842622, 53.89301922519376,
    ],
    '010615179020': [
      9.198257504047083, 53.88647589260994, 9.251749787915864, 53.93054147032822,
    ],
    '010615179023': [
      9.309027550410109, 53.86871984359512, 9.400811360637615, 53.918970877567276,
    ],
    '010615179025': [
      9.230029009082607, 53.92069211076705, 9.310273904990273, 53.9780145071821,
    ],
    '010615179060': [
      9.20600765874947, 53.91794481262308, 9.239769042431115, 53.944044875640486,
    ],
    '010615179062': [
      9.371531911770884, 53.90719268741302, 9.413101636927351, 53.943588966858535,
    ],
    '010615179063': [
      9.22875325505337, 53.90071824108692, 9.293402735776443, 53.9367943774879,
    ],
    '010615179077': [
      9.275470089761203, 53.89301922519376, 9.371531911770884, 53.94608212171167,
    ],
    '010615179095': [
      9.229245358580828, 53.87611210138671, 9.309027550410109, 53.91110795124568,
    ],
    '010615179102': [
      9.380412004550776, 53.89957580218285, 9.447767156562653, 53.932239247949084,
    ],
    '010615179110': [
      9.345373922939238, 53.82189780407681, 9.440697035768546, 53.87206050444888,
    ],
    '010615179119': [
      9.290164828824315, 53.93281096198205, 9.39080331307576, 53.98674472936167,
    ],
    '010615189019': [
      9.759605700299058, 53.959702321203885, 9.85392291186801, 54.007257811578086,
    ],
    '010615189028': [
      9.735075787300044, 53.98440736649989, 9.79085482632837, 54.03072042861526,
    ],
    '010615189036': [
      9.689278632921388, 54.00831283010307, 9.762002252500181, 54.048459109499504,
    ],
    '010615189038': [
      9.724502775707498, 53.89210967662919, 9.764268195976458, 53.91333111860951,
    ],
    '010615189042': [
      9.54496748908139, 53.95667986911838, 9.689278632921388, 54.03427653791496,
    ],
    '010615189049': [
      9.675140199692441, 53.93389317668597, 9.761859255701806, 53.9728961804784,
    ],
    '010615189064': [
      9.667047052352572, 53.98959287907929, 9.711804501248215, 54.023452087515324,
    ],
    '010615189071': [
      9.638995904056696, 53.94066476239004, 9.69237869660929, 53.98082573378711,
    ],
    '010615189080': [
      9.667392399380239, 53.98082573378711, 9.72953518367708, 54.00988645150915,
    ],
    '010615189086': [
      9.657482538394097, 54.023452087515324, 9.71367967259556, 54.06243252690958,
    ],
    '010615189088': [
      9.761766844661887, 53.93546428808781, 9.811987030892988, 53.974016629493846,
    ],
    '010615189089': [
      9.725811899140568, 53.979412536336675, 9.753463927186603, 54.00944268408253,
    ],
    '010615189093': [
      9.670481331502724, 53.971999227067435, 9.744528353676616, 53.98873447360028,
    ],
    '010615189096': [
      9.762002252500181, 54.01300608225228, 9.817806096798238, 54.05011009042806,
    ],
    '010615189103': [
      9.741122736621605, 53.971999227067435, 9.777108644382434, 53.985925559378394,
    ],
    '010615189111': [
      9.74296606068349, 54.03054054652484, 9.781569438493532, 54.053317685139774,
    ],
    '010615189112': [
      9.78095568511452, 53.99987683975003, 9.86333058246157, 54.02299304370097,
    ],
    '010615189116': [
      9.692532969633726, 53.911150604250615, 9.780906587359004, 53.942917150827846,
    ],
    '010615189117': [
      9.684853233053397, 53.89028344404496, 9.739652109703288, 53.92573842397424,
    ],
    '010620001001': [
      10.169759338810316, 53.63350308832972, 10.314668233027813, 53.70384233126695,
    ],
    '010620004004': [
      10.295787086070726, 53.76914305013373, 10.436318579541084, 53.8649303542638,
    ],
    '010620006006': [
      10.21327581834857, 53.710532401191735, 10.303737361765048, 53.74981158865345,
    ],
    '010620009009': [
      10.148321166200866, 53.5576765391397, 10.278312180097137, 53.59881974505186,
    ],
    '010620018018': [
      10.181085627794873, 53.51970205871575, 10.237306816737155, 53.55832587666351,
    ],
    '010620023023': [
      10.256333804312119, 53.640853677173915, 10.316919811400753, 53.6893654397146,
    ],
    '010620053053': [
      10.15292214931585, 53.513031176381936, 10.209321928416175, 53.558399658869924,
    ],
    '010620060060': [
      10.209321928416175, 53.49621397310279, 10.315627602121618, 53.58056745165692,
    ],
    '010620061061': [
      10.448109126443905, 53.814800076881404, 10.530632255391758, 53.859035709901505,
    ],
    '010620076076': [
      10.023842453998505, 53.70603402948563, 10.169523128154639, 53.77058480275242,
    ],
    '010620090090': [
      10.140733733678662, 53.66856975067638, 10.24554650576658, 53.71417818955941,
    ],
    '010625207019': [
      10.24120995555355, 53.78720761010273, 10.29929825561623, 53.82432261998006,
    ],
    '010625207046': [
      10.427227161551754, 53.795356153248235, 10.449597184412594, 53.81923754097047,
    ],
    '010625207050': [
      10.25943870012174, 53.77617316501346, 10.313929251990473, 53.798151754976885,
    ],
    '010625207056': [
      10.365625298962193, 53.74004758083544, 10.445586978488846, 53.783210647387556,
    ],
    '010625207062': [
      10.417962188478468, 53.75342768530813, 10.4813677715398, 53.80420112015915,
    ],
    '010625207065': [
      10.295734589092985, 53.74658844991183, 10.381329590324103, 53.793722606485055,
    ],
    '010625207089': [
      10.324930173325292, 53.71958947013029, 10.417835639761305, 53.75700521115277,
    ],
    '010625207091': [
      10.35251667140346, 53.672723102600884, 10.445528964908663, 53.73770346268684,
    ],
    '010625207092': [
      10.239412673400077, 53.810659841163734, 10.361471212224751, 53.8715204817234,
    ],
    '010625218005': [
      10.13259221429976, 53.739551112155496, 10.241536129060174, 53.78156334787144,
    ],
    '010625218014': [
      10.232272714417894, 53.68882795896381, 10.301908658799661, 53.720942400333065,
    ],
    '010625218016': [
      10.225851605088248, 53.74607676056683, 10.319926118712715, 53.78340166461612,
    ],
    '010625218027': [
      10.297481689224464, 53.69722512186116, 10.34422676418249, 53.73353024984962,
    ],
    '010625218036': [
      10.169523128154639, 53.70315927586849, 10.257007641977205, 53.76901823539278,
    ],
    '010625218051': [
      10.136597384693696, 53.77200846071047, 10.236345989026793, 53.802378071154216,
    ],
    '010625218078': [
      10.312076436906493, 53.67779063602033, 10.37529487193321, 53.722530184732605,
    ],
    '010625218081': [
      10.280291138963367, 53.72144451898669, 10.345492721731409, 53.76520488200469,
    ],
    '010625244003': [
      10.549971707446767, 53.84770070722284, 10.593256864053291, 53.88559399270048,
    ],
    '010625244008': [
      10.448109126443905, 53.78856758030849, 10.522814231612342, 53.82206611303926,
    ],
    '010625244025': [
      10.554519411949435, 53.83385109424175, 10.620014170992404, 53.855460261814514,
    ],
    '010625244031': [
      10.47269448340876, 53.851479065681836, 10.5165510399248, 53.867989167372926,
    ],
    '010625244032': [
      10.507103623893062, 53.87313483163389, 10.572664224368577, 53.90598559604675,
    ],
    '010625244039': [
      10.512641616071377, 53.79230722758441, 10.581758681842299, 53.822120427895776,
    ],
    '010625244048': [
      10.507103623893062, 53.89391172338197, 10.582661098828614, 53.91886423974353,
    ],
    '010625244059': [
      10.428785793787089, 53.85522839029756, 10.50964119438411, 53.90277627982741,
    ],
    '010625244083': [
      10.470678730255337, 53.75559147344159, 10.54764670629657, 53.79788317579058,
    ],
    '010625244087': [
      10.484041039766309, 53.85247526709778, 10.56265130931286, 53.8906268722914,
    ],
    '010625244093': [
      10.393884559755165, 53.8163457854688, 10.456313434955407, 53.87861551918854,
    ],
    '010625244094': [
      10.50668463767508, 53.80963086544778, 10.565125448903341, 53.85529327256158,
    ],
    '010625262011': [
      10.231738609132433, 53.59267458707165, 10.285193309897782, 53.6337715272948,
    ],
    '010625262035': [
      10.29230015079179, 53.63333540525231, 10.372289135768485, 53.68224783362009,
    ],
    '010625262069': [
      10.240689844837668, 53.61379837548838, 10.311939440136456, 53.65049113667546,
    ],
    '010625262071': [
      10.189751377151895, 53.58433130124473, 10.236409123867606, 53.6337715272948,
    ],
    '010625262088': [
      10.242804626158222, 53.56896212487838, 10.319414369309245, 53.6190212557172,
    ],
    '010625270020': [
      10.340333076153405, 53.57143095847769, 10.401169056686363, 53.606053765928955,
    ],
    '010625270021': [
      10.38543281577796, 53.63019966685707, 10.445796148358895, 53.66534419334402,
    ],
    '010625270022': [
      10.302892609380043, 53.59873525728358, 10.36106068952668, 53.63608832595009,
    ],
    '010625270026': [
      10.434812854588047, 53.59600348108473, 10.479320999457782, 53.61066700962761,
    ],
    '010625270033': [
      10.466729312385091, 53.62400459161765, 10.500881429882906, 53.63318775407625,
    ],
    '010625270040': [
      10.479320999457782, 53.60017857334646, 10.514266981104477, 53.62137800005298,
    ],
    '010625270045': [
      10.335871055532271, 53.629401402831014, 10.412678436300348, 53.67779063602033,
    ],
    '010625270058': [
      10.297695518594871, 53.57916832905823, 10.350459832094721, 53.60206536926829,
    ],
    '010625270082': [
      10.360584761075687, 53.59030946551973, 10.508765965520801, 53.63978298106935,
    ],
    '010625270086': [
      10.308029211072, 53.554565444045274, 10.363562191784034, 53.59114827924738,
    ],
    '020000000000': [
      8.420336832212504, 53.394925149255876, 10.324663788920763, 53.96395216989675,
    ],
    '031010000000': [
      10.412032148844725, 52.18727501689995, 10.64616495333375, 52.357094366400766,
    ],
    '031020000000': [
      10.232076953237081, 52.013281508004006, 10.506248488479756, 52.22396635194054,
    ],
    '031030000000': [
      10.647701868563882, 52.317070555034555, 10.90521089851078, 52.494344882858606,
    ],
    '031510009009': [
      10.430804895672908, 52.44598896499079, 10.623708183664762, 52.568440539961664,
    ],
    '031510025025': [
      10.553927383354756, 52.46031721581756, 10.727603850190103, 52.60211777052557,
    ],
    '031510040040': [
      10.627992763339284, 52.60211777052557, 10.901610143303381, 52.796021075841914,
    ],
    '031515401002': [
      10.725244023114263, 52.510548482656645, 10.834346712447216, 52.56048566053919,
    ],
    '031515401004': [
      10.663479550594191, 52.478495789874295, 10.734910029733896, 52.52912516492887,
    ],
    '031515401014': [
      10.718825080698426, 52.47971218661267, 10.793717567651074, 52.53578972725119,
    ],
    '031515401020': [
      10.642112289967116, 52.46151714679113, 10.702303451165218, 52.485595146493324,
    ],
    '031515401030': [
      10.717575536385892, 52.455752854082355, 10.75829907031808, 52.494850234330215,
    ],
    '031515401039': [
      10.692221210305926, 52.44359699321439, 10.743229992779742, 52.47942056760014,
    ],
    '031515402003': [
      10.812504001343289, 52.51515168477333, 10.886930093364759, 52.55579846222885,
    ],
    '031515402005': [
      10.81555340945833, 52.54918527481778, 10.976627862718617, 52.63257927201052,
    ],
    '031515402008': [
      10.702410264389203, 52.54345776049217, 10.84917762377149, 52.612171802505884,
    ],
    '031515402021': [
      10.859568891832607, 52.49334046985459, 11.009059955915292, 52.565406775242,
    ],
    '031515402024': [
      10.816579981971113, 52.459856943138504, 10.947927675135448, 52.516182313559824,
    ],
    '031515402031': [
      10.780837396368113, 52.48336908685828, 10.862012818271655, 52.54172410947988,
    ],
    '031515402032': [
      10.832742366543519, 52.55179540003718, 10.914328343501174, 52.610605830548174,
    ],
    '031515403007': [
      10.476283948050263, 52.64237373135475, 10.650314719968861, 52.74960705791737,
    ],
    '031515403011': [
      10.554683961501548, 52.682191717900494, 10.663508944692618, 52.74900170377296,
    ],
    '031515403019': [
      10.539605375119693, 52.73682220204927, 10.668566014218353, 52.795898635260556,
    ],
    '031515403028': [
      10.395327407148844, 52.73932393241275, 10.592364220072184, 52.83221781628688,
    ],
    '031515403029': [
      10.362018200875006, 52.65809162074319, 10.483492398896287, 52.76032501843622,
    ],
    '031515404006': [
      10.597036457118188, 52.37894616384022, 10.674658375127452, 52.47016563973475,
    ],
    '031515404013': [
      10.540591474688886, 52.418492428780176, 10.63155056121967, 52.4627875033961,
    ],
    '031515404022': [
      10.448274047667626, 52.395569355431604, 10.551541209518447, 52.45622947733948,
    ],
    '031515404037': [
      10.573164395171542, 52.399499306947135, 10.617175558529347, 52.42670246104875,
    ],
    '031515405012': [
      10.344735426360305, 52.38892527397309, 10.448274047667626, 52.45053175256567,
    ],
    '031515405015': [
      10.367948655751404, 52.41092445284924, 10.503496194456513, 52.479713777269616,
    ],
    '031515405017': [
      10.257432473111908, 52.42886417329803, 10.397803242880798, 52.52779931713093,
    ],
    '031515405018': [
      10.30661875550645, 52.46203204573513, 10.469015182002638, 52.56179293861597,
    ],
    '031515406001': [
      10.411186711548703, 52.36756467058055, 10.492503874888168, 52.41092445284924,
    ],
    '031515406016': [
      10.51729148294095, 52.32851174004292, 10.62469585919684, 52.42539260011793,
    ],
    '031515406023': [
      10.478366763752485, 52.39138218958789, 10.552179190036414, 52.42539260011793,
    ],
    '031515406027': [
      10.399804373898172, 52.31966296896507, 10.49221910303356, 52.369765778229365,
    ],
    '031515406034': [
      10.462305195129943, 52.34638955586281, 10.54512034236593, 52.399470590729706,
    ],
    '031515406041': [
      10.373996894736706, 52.371785646025856, 10.423574039067987, 52.395909832883135,
    ],
    '031515407010': [
      10.379468680916577, 52.59985026778237, 10.531594670626207, 52.69430711347531,
    ],
    '031515407026': [
      10.606415099429634, 52.59980606466274, 10.724321279849775, 52.65633405381283,
    ],
    '031515407033': [
      10.379813115426288, 52.55330689849044, 10.49819915748678, 52.62899694929199,
    ],
    '031515407035': [
      10.511464549871144, 52.54385155735673, 10.55875750452484, 52.561002094269575,
    ],
    '031515407036': [
      10.512437471844386, 52.55846673037637, 10.704860940982606, 52.66913370613349,
    ],
    '031515407038': [
      10.486664227541263, 52.559169072315896, 10.580135246483596, 52.61662557416498,
    ],
    '031530002002': [
      10.488787414451194, 51.822065889156946, 10.650763598995505, 51.937198808057445,
    ],
    '031530008008': [
      10.306181308180948, 51.95640862750687, 10.496209126405939, 52.056632008882254,
    ],
    '031530012012': [
      10.065715860435322, 51.808681363365146, 10.220828811187582, 51.961348189910495,
    ],
    '031530016016': [
      10.492496031847919, 51.65316005761287, 10.686983918753569, 51.765551522106826,
    ],
    '031530017017': [
      10.318843839529222, 51.84489762274203, 10.648365520843633, 52.00464149079515,
    ],
    '031530018018': [
      10.270403264478748, 51.76855046200886, 10.469175204191725, 51.84101671734799,
    ],
    '031530019019': [
      10.172040180885594, 51.852639854056314, 10.391929934160396, 52.03269862527327,
    ],
    '031540013013': [
      10.71597356636719, 52.20386333880906, 10.909863805281343, 52.347212689734924,
    ],
    '031540014014': [
      10.602115275714345, 52.29673119214389, 10.774425559937754, 52.3862260802635,
    ],
    '031540019019': [
      10.908630469508887, 52.10380024358782, 11.029062097311938, 52.17691404520272,
    ],
    '031540028028': [
      10.914278657169275, 52.13205663404435, 11.060873199538452, 52.287008708884606,
    ],
    '031545401008': [
      10.969762541955571, 52.29189886366444, 11.03873394283688, 52.33613804742841,
    ],
    '031545401015': [
      10.947522544601494, 52.268447184646945, 11.007809016774253, 52.295811112862346,
    ],
    '031545401016': [
      10.941455958056508, 52.32164143962984, 10.986783927607325, 52.347788426285334,
    ],
    '031545401018': [
      10.880306173498004, 52.283251727113196, 10.97700168858292, 52.332697747626604,
    ],
    '031545402002': [
      10.83085511820183, 52.04817446740058, 10.875271287079617, 52.090584649144844,
    ],
    '031545402006': [
      10.792165800040822, 52.04817446740058, 10.853813889613848, 52.10184245339246,
    ],
    '031545402012': [
      10.852980874094948, 52.05820645651371, 10.950597633788844, 52.098941412746896,
    ],
    '031545402027': [
      10.83035759331077, 52.05732811258209, 10.97036298150011, 52.153601305212625,
    ],
    '031545403005': [
      10.884810505577207, 52.19592623191674, 10.937776222645445, 52.22220952145167,
    ],
    '031545403017': [
      10.815733439494576, 52.180833691218254, 10.905534664909005, 52.22053810684227,
    ],
    '031545403021': [
      10.874802447654984, 52.214769101579634, 10.94019949620009, 52.255736870475445,
    ],
    '031545403022': [
      10.86439931909055, 52.22976035815747, 10.939032418520284, 52.287520743892784,
    ],
    '031545403025': [
      10.88866222992852, 52.16640780109734, 10.962075488980515, 52.19680162717201,
    ],
    '031545403026': [
      10.923063551412927, 52.173414320784296, 10.98319005798468, 52.22317048771769,
    ],
    '031545404001': [
      10.949913141691765, 52.3349359258022, 11.071238570989733, 52.410107613383424,
    ],
    '031545404004': [
      10.877636445991856, 52.41341445865442, 10.936017726510164, 52.46042624380122,
    ],
    '031545404007': [
      10.9047759864907, 52.42319607581679, 10.983304761593866, 52.471713780866686,
    ],
    '031545404009': [
      10.852029420962904, 52.3288175118381, 10.960421774724491, 52.403854585877596,
    ],
    '031545404024': [
      10.899816561840304, 52.38469232941441, 11.0020285289832, 52.4341352083074,
    ],
    '031550001001': [
      9.928535169620679, 51.82799988289659, 10.118413439489352, 51.948130424816966,
    ],
    '031550002002': [
      9.488801124662878, 51.624708937605405, 9.592780170384293, 51.69827171232048,
    ],
    '031550003003': [
      9.631723862832954, 51.737356201572354, 9.79808785259085, 51.87908408978985,
    ],
    '031550005005': [
      9.730993339909627, 51.598300409224876, 9.886603949747853, 51.71152911143004,
    ],
    '031550006006': [
      9.985501561048585, 51.727578597146604, 10.157840920881444, 51.83499081764393,
    ],
    '031550007007': [
      10.033744347034856, 51.60941444949417, 10.160362249458775, 51.729529224064,
    ],
    '031550009009': [
      9.694935072276511, 51.64265232596458, 9.925747253657562, 51.75816057338938,
    ],
    '031550010010': [
      9.865173558638316, 51.60221578219166, 10.0575460129728, 51.67259513663386,
    ],
    '031550011011': [
      9.890654017668195, 51.64168728540232, 10.119071450697877, 51.78947659687021,
    ],
    '031550012012': [
      9.529304780317142, 51.55216902228017, 9.76527957906414, 51.71680671739514,
    ],
    '031550013013': [
      9.759580176322611, 51.731058757415475, 10.037186160210045, 51.91361012056233,
    ],
    '031570001001': [
      10.131671957779021, 52.35408458679265, 10.388220813129022, 52.4494021678175,
    ],
    '031570002002': [
      9.997708986805103, 52.2225601273743, 10.14354132505567, 52.34214004791051,
    ],
    '031570005005': [
      10.24896442694847, 52.17507021531622, 10.368121811567462, 52.24332210177121,
    ],
    '031570006006': [
      10.117316830877252, 52.26202323163796, 10.34217429365717, 52.37465831622671,
    ],
    '031570007007': [
      10.295672891588753, 52.19277637590633, 10.452817005956604, 52.305658121230685,
    ],
    '031570008008': [
      10.292496052751622, 52.27596803628194, 10.439665734774044, 52.37935554471863,
    ],
    '031570009009': [
      10.123870035623915, 52.213265986547285, 10.303546454852372, 52.29840458591312,
    ],
    '031580006006': [
      10.591581309503098, 52.22131755847166, 10.757880315040548, 52.303211153472986,
    ],
    '031580037037': [
      10.436392634980086, 52.121031273243545, 10.644074630671636, 52.22385959263722,
    ],
    '031580039039': [
      10.469715648617958, 51.970534617195824, 10.655364748010339, 52.07436547549481,
    ],
    '031585402002': [
      10.177481620735866, 52.06081071467867, 10.270686590185024, 52.12005476864327,
    ],
    '031585402004': [
      10.176986214465002, 52.10789791749012, 10.251882066779624, 52.18006499822839,
    ],
    '031585402011': [
      10.23533002479922, 52.06315016794716, 10.32740115267423, 52.10595329483039,
    ],
    '031585402016': [
      10.266559574134996, 52.04228942050954, 10.345558077256351, 52.08658302284313,
    ],
    '031585402018': [
      10.202267279133665, 52.02842272342604, 10.274515661962198, 52.08308763436443,
    ],
    '031585402028': [
      10.192022900935891, 52.004513925261925, 10.287515083819146, 52.06081071467867,
    ],
    '031585403005': [
      10.431484955505248, 52.09863164174932, 10.507715159702686, 52.12639896320699,
    ],
    '031585403010': [
      10.506610650707653, 52.081535223810874, 10.578678101290985, 52.111725051121034,
    ],
    '031585403014': [
      10.445597051525457, 52.05925168081848, 10.521632747047807, 52.10541016905377,
    ],
    '031585403019': [
      10.519638015178623, 52.05655652802977, 10.567302806889002, 52.088480692306824,
    ],
    '031585403023': [
      10.506610650707653, 52.10541016905377, 10.569636203454055, 52.133329451329516,
    ],
    '031585403038': [
      10.560913900571766, 52.04009799678822, 10.676835869361078, 52.09968779406819,
    ],
    '031585406009': [
      10.635375576796475, 52.14323205549649, 10.707705116207356, 52.18471605552971,
    ],
    '031585406012': [
      10.660371149565142, 52.19062109637284, 10.768750716928729, 52.23147691188675,
    ],
    '031585406013': [
      10.670623065110066, 52.164032231112415, 10.783543698568419, 52.22732966165709,
    ],
    '031585406030': [
      10.59532524194074, 52.18221556285838, 10.6729857202167, 52.24591648262042,
    ],
    '031585406033': [
      10.654100142541962, 52.211553990980335, 10.701407999593382, 52.24240182876074,
    ],
    '031585407007': [
      10.817239111754695, 52.11495168098793, 10.88519044646055, 52.17380696747858,
    ],
    '031585407008': [
      10.562371671773441, 52.116491098758154, 10.650338803981903, 52.162147674638625,
    ],
    '031585407017': [
      10.64775397367948, 52.04586729204416, 10.730176486420973, 52.08855979145783,
    ],
    '031585407021': [
      10.567842869539533, 52.09926147173568, 10.629081574105095, 52.12045459583502,
    ],
    '031585407022': [
      10.704716965780063, 52.14666390800011, 10.7823964609187, 52.19528375366797,
    ],
    '031585407025': [
      10.72290790086664, 52.04862727234094, 10.759108815851926, 52.097513545192264,
    ],
    '031585407027': [
      10.720410758303776, 52.118992349362706, 10.839330001800178, 52.205964533755,
    ],
    '031585407031': [
      10.733809439257938, 52.07532299455523, 10.836096765719859, 52.12596570923891,
    ],
    '031585407032': [
      10.650338803981903, 52.097513545192264, 10.754624677483466, 52.15195191026503,
    ],
    '031585407035': [
      10.743466009121523, 52.04829851414241, 10.801007467865414, 52.08660680233713,
    ],
    '031585407036': [
      10.629081574105095, 52.116491098758154, 10.661266255779953, 52.14383240739825,
    ],
    '031585407040': [
      10.59671447153343, 52.07437075381504, 10.733809439257938, 52.13956827914014,
    ],
    '031590001001': [
      9.658844202582257, 51.52318193849124, 9.825718278527427, 51.61296594130628,
    ],
    '031590002002': [
      10.148011209946826, 51.75164809304983, 10.260848623609593, 51.83253601460397,
    ],
    '031590003003': [
      10.369754081133411, 51.56273289709796, 10.56998080210218, 51.68071978850571,
    ],
    '031590004004': [
      10.500217484483583, 51.55364523088326, 10.593106502814752, 51.622537784246006,
    ],
    '031590007007': [
      9.817192952388108, 51.5589056580835, 10.070038525563998, 51.6220423828765,
    ],
    '031590010010': [
      10.139667163023352, 51.4680830847224, 10.367783688718873, 51.5684472492534,
    ],
    '031590013013': [
      9.820868611300789, 51.373086665980246, 10.022664276113558, 51.50567930563086,
    ],
    '031590015015': [
      9.95463518270036, 51.4172212880067, 10.185747602966853, 51.53555617792079,
    ],
    '031590016016': [
      9.800333299013207, 51.483821717312274, 10.053774289562508, 51.590704214852266,
    ],
    '031590017017': [
      9.570616263376637, 51.35652666799043, 9.803377055817158, 51.557186828501614,
    ],
    '031590019019': [
      10.270151720808988, 51.555146354430775, 10.456792177590367, 51.70716892584459,
    ],
    '031590026026': [
      10.114928003254418, 51.66735419437273, 10.398351263583567, 51.76641534445161,
    ],
    '031590029029': [
      9.728078565722168, 51.41056116283422, 9.929562694322195, 51.52097414600961,
    ],
    '031590034034': [
      9.542860104055361, 51.2947737493829, 9.772588223680934, 51.3927369000186,
    ],
    '031590036036': [
      10.561503198439134, 51.5589409485269, 10.665836254755282, 51.65316005761287,
    ],
    '031595401008': [
      9.641545422372737, 51.45962472061924, 9.710311438588139, 51.503585236005165,
    ],
    '031595401009': [
      9.731024379702918, 51.46920931518551, 9.815828282065096, 51.53882295950439,
    ],
    '031595401021': [
      9.761332752354946, 51.425085031013474, 9.847542561990535, 51.48506043733226,
    ],
    '031595401024': [
      9.639926072472843, 51.48719554136705, 9.752704361535477, 51.54090436924345,
    ],
    '031595401031': [
      9.68341210684342, 51.427184273318126, 9.791107904450861, 51.4965743680398,
    ],
    '031595402005': [
      10.12226397082396, 51.61106001896855, 10.179797925117168, 51.64739841205876,
    ],
    '031595402006': [
      10.111045682112708, 51.592371702609555, 10.161534381016848, 51.61703049782524,
    ],
    '031595402014': [
      10.160310361314515, 51.5823090472702, 10.247425490094324, 51.630405243769665,
    ],
    '031595402022': [
      10.070038525563998, 51.57584126137017, 10.149611737610503, 51.62265848589328,
    ],
    '031595402025': [
      10.210403469322339, 51.54193684313757, 10.280338158127456, 51.57105320375903,
    ],
    '031595402027': [
      10.261060934602893, 51.5684472492534, 10.320528445844257, 51.60888741133257,
    ],
    '031595402028': [
      10.174690302738046, 51.54417961053707, 10.246057574142306, 51.59082829492195,
    ],
    '031595402030': [
      10.239103349358816, 51.562043004536605, 10.30118946670616, 51.598142439973365,
    ],
    '031595402037': [
      10.14959170392987, 51.57568679103465, 10.196143754404531, 51.6055295156751,
    ],
    '031595402038': [
      10.22250488883441, 51.588541922455256, 10.295880869312901, 51.62865673454513,
    ],
    '031595403012': [
      10.255178811790941, 51.641816277593335, 10.309265193044299, 51.663696486173414,
    ],
    '031595403018': [
      10.165707824715684, 51.60888741133257, 10.299660494583321, 51.676384838301836,
    ],
    '031595403020': [
      10.26143424213715, 51.65828267130642, 10.315105182861888, 51.68538342075199,
    ],
    '031595403039': [
      10.139827597297455, 51.62865673454513, 10.22582333437298, 51.68091097056009,
    ],
    '031595404011': [
      10.040235735124869, 51.552945244139984, 10.143217450082068, 51.60941444949417,
    ],
    '031595404023': [
      10.050224317520598, 51.51502901131734, 10.133154916159572, 51.5550289771182,
    ],
    '031595404032': [
      10.111892515757441, 51.5428053053905, 10.193373324250912, 51.58695454682564,
    ],
    '031595404033': [
      10.120411178712297, 51.5189708867555, 10.188345373934633, 51.55560340934699,
    ],
    '031595404035': [
      10.035981885351903, 51.54009497726331, 10.089606592354757, 51.576686006325005,
    ],
    '032410001001': [
      9.606292608012383, 52.30609156888471, 9.916967790787039, 52.453225636801854,
    ],
    '032410002002': [
      9.395588136307621, 52.260791159562324, 9.567505758963181, 52.40060224002664,
    ],
    '032410003003': [
      9.919555733669013, 52.40823096754182, 10.102927860852269, 52.53894702343144,
    ],
    '032410004004': [
      9.781581843816511, 52.46180037898709, 9.99755883666442, 52.60748507905173,
    ],
    '032410005005': [
      9.486115374322695, 52.39859802777709, 9.644905606345954, 52.49960407297053,
    ],
    '032410006006': [
      9.52643063507115, 52.27792578371817, 9.64136876776317, 52.368914146021744,
    ],
    '032410007007': [
      9.67001657877686, 52.262178532647525, 9.781276672414073, 52.335719512519965,
    ],
    '032410008008': [
      9.772058453315312, 52.42055542711815, 9.931978813940509, 52.50410623792851,
    ],
    '032410009009': [
      9.762531310691067, 52.26173276069339, 9.914180795624835, 52.32562809616836,
    ],
    '032410010010': [
      9.630544816727308, 52.42298551328535, 9.775166192206898, 52.506095129617925,
    ],
    '032410011011': [
      9.88455090872795, 52.32212809698305, 10.156224970167427, 52.43122189301152,
    ],
    '032410012012': [
      9.23759194236251, 52.44119721512629, 9.656894297020077, 52.67514515107213,
    ],
    '032410013013': [
      9.68896542869724, 52.16918219272653, 9.827571224765462, 52.29702492538718,
    ],
    '032410014014': [
      9.614352245399697, 52.26085469701467, 9.702124976064576, 52.35713968904413,
    ],
    '032410015015': [
      9.489160698842484, 52.345735876114325, 9.664721462897186, 52.422606766291686,
    ],
    '032410016016': [
      9.862808056894641, 52.2803262472457, 10.07759880266211, 52.427945951874314,
    ],
    '032410017017': [
      9.464558039773758, 52.13092618890192, 9.752093581847435, 52.26351236613158,
    ],
    '032410018018': [
      10.054698334689725, 52.390883647901916, 10.304265935550166, 52.52326836343775,
    ],
    '032410019019': [
      9.580284008717372, 52.489881380116685, 9.83315394825368, 52.63822443405152,
    ],
    '032410020020': [
      9.472514904500768, 52.22788317650736, 9.665437888319584, 52.29344429307289,
    ],
    '032410021021': [
      9.274204673139515, 52.36347839765024, 9.506169208211167, 52.500188505671396,
    ],
    '032510007007': [
      8.62943886816361, 52.77402644802685, 8.884705394233315, 52.95980449305833,
    ],
    '032510012012': [
      8.294541955680089, 52.53141270254186, 8.447310236447587, 52.68842696032576,
    ],
    '032510037037': [
      8.641176065034504, 52.93627258742529, 8.818137652036423, 53.05210870380649,
    ],
    '032510040040': [
      8.660651355645506, 52.618874498643336, 8.888740586038095, 52.72920431247853,
    ],
    '032510041041': [
      8.732140587791047, 52.83671599340973, 8.952852510439598, 52.97259934273032,
    ],
    '032510042042': [
      8.449688488966233, 52.73368716325302, 8.70324607667681, 52.851384986027,
    ],
    '032510044044': [
      8.498417138584685, 52.500526196372604, 8.770197350658316, 52.59367369310059,
    ],
    '032510047047': [
      8.768411240074977, 52.9527616721774, 8.930600389285964, 53.03890452625391,
    ],
    '032515401009': [
      8.394824269654887, 52.446021950772824, 8.509685226745487, 52.5303852176747,
    ],
    '032515401020': [
      8.305702493024016, 52.4774763321667, 8.460866456820785, 52.53141270254186,
    ],
    '032515401022': [
      8.311276953108727, 52.506570080677, 8.447310236447587, 52.54745713075503,
    ],
    '032515401023': [
      8.339883845740713, 52.443761177037814, 8.395876745997953, 52.477357648652564,
    ],
    '032515401025': [
      8.314319374605775, 52.46914729624729, 8.415965708055253, 52.50844475929324,
    ],
    '032515401029': [
      8.381577197039471, 52.446021950772824, 8.446913532774905, 52.51732442700036,
    ],
    '032515401036': [
      8.296934671130089, 52.443761177037814, 8.368659013099675, 52.48007203309697,
    ],
    '032515402005': [
      8.40361575220889, 52.659081018989134, 8.535841032534668, 52.76042849429934,
    ],
    '032515402013': [
      8.335955035354951, 52.63282942253176, 8.496833155472576, 52.7225281822744,
    ],
    '032515402014': [
      8.501763655980128, 52.71071214552209, 8.645272230941385, 52.77793667467818,
    ],
    '032515402017': [
      8.496833155472576, 52.62758472031973, 8.661272254793168, 52.72663243138699,
    ],
    '032515403002': [
      8.903965203574602, 52.716275707496784, 9.064109517447296, 52.806546139332504,
    ],
    '032515403026': [
      8.988701111934871, 52.8415049817896, 9.115688678546935, 52.907436531826505,
    ],
    '032515403033': [
      8.981708201812573, 52.866873846685216, 9.076277674835145, 52.92589139786701,
    ],
    '032515403049': [
      8.877609466137713, 52.74810823006097, 9.06678278531923, 52.89786961104408,
    ],
    '032515404003': [
      8.732545788381959, 52.529950071522144, 8.84577690465428, 52.58093928099313,
    ],
    '032515404004': [
      8.739404770177922, 52.56178138807894, 8.862235425506066, 52.645074950061456,
    ],
    '032515404018': [
      8.616998454774272, 52.61817167403487, 8.668657748698966, 52.68573416333613,
    ],
    '032515404021': [
      8.750375863201654, 52.53410877528294, 8.900566147932661, 52.621477408690644,
    ],
    '032515404043': [
      8.639630753054366, 52.55548502943036, 8.776813638006347, 52.63999181852156,
    ],
    '032515404045': [
      8.609920089815978, 52.58757153017499, 8.739936841746422, 52.67934103128541,
    ],
    '032515405006': [
      8.53149056419372, 52.5850782993993, 8.641382051375494, 52.637998232458536,
    ],
    '032515405011': [
      8.445671218533843, 52.62675315766934, 8.543251340104385, 52.659081018989134,
    ],
    '032515405019': [
      8.486432561243355, 52.524687788601476, 8.571573824690423, 52.6236798038921,
    ],
    '032515405030': [
      8.437380358493938, 52.524687788601476, 8.542248372582172, 52.634113138114415,
    ],
    '032515405046': [
      8.415342167420215, 52.529709837055954, 8.5036812478387, 52.64599880708564,
    ],
    '032515406001': [
      8.828417751139435, 52.75677578657209, 8.896937993649354, 52.80925506766304,
    ],
    '032515406015': [
      8.628928676023147, 52.68482129232305, 8.74771632250997, 52.777166776716356,
    ],
    '032515406028': [
      8.68241037215054, 52.7513974814594, 8.799243937104647, 52.790009837196486,
    ],
    '032515406031': [
      8.73495407675415, 52.71003038280003, 8.804350021904627, 52.77445844153361,
    ],
    '032515406032': [
      8.778247891618493, 52.71455732840543, 8.89318404069604, 52.77529125989631,
    ],
    '032515406038': [
      8.799243937104647, 52.75406439283491, 8.88541874308259, 52.82900951175999,
    ],
    '032515407008': [
      8.908640154510007, 52.631509232803424, 9.01927755370896, 52.69564995509917,
    ],
    '032515407024': [
      8.848038150197086, 52.630452273693464, 8.91856332429647, 52.70391625420558,
    ],
    '032515407027': [
      8.853241722003032, 52.68234089923998, 8.950145969896113, 52.74811227159739,
    ],
    '032515407034': [
      8.912387186921293, 52.676621268165505, 8.989257592596491, 52.71947387249219,
    ],
    '032515407035': [
      8.945345742912963, 52.68589268577762, 9.029849127933245, 52.739444749601354,
    ],
    '032520001001': [
      9.15449965470904, 51.99688938620784, 9.337125874543755, 52.119421928378344,
    ],
    '032520002002': [
      9.324290596843412, 52.13131010430626, 9.51699469103396, 52.27383480703346,
    ],
    '032520003003': [
      9.17468970023317, 51.92134597296332, 9.365401765794951, 52.01208001481626,
    ],
    '032520004004': [
      9.436203553709717, 52.03720509981306, 9.607824739175241, 52.16686806455873,
    ],
    '032520005005': [
      9.289526443864675, 51.96979362290083, 9.538379530795812, 52.080811057478385,
    ],
    '032520006006': [
      9.258380512110577, 52.046534848286356, 9.457918892620906, 52.1676154983141,
    ],
    '032520007007': [
      9.155006102104167, 52.09960970110034, 9.388049385919816, 52.22131476631265,
    ],
    '032520008008': [
      9.522317405671766, 51.9647022465698, 9.6860850681548, 52.14413847163395,
    ],
    '032540002002': [
      9.739143895584311, 51.93005523048776, 9.906787717379686, 52.035885036284746,
    ],
    '032540003003': [
      9.909938861437677, 52.23014016914246, 10.034504853307803, 52.29369141724245,
    ],
    '032540005005': [
      9.955637344566787, 52.01404327493797, 10.087417854288223, 52.13079108239984,
    ],
    '032540008008': [
      10.015591373681467, 51.95386805816809, 10.206711041620819, 52.06035614392768,
    ],
    '032540011011': [
      9.864733375464832, 52.06501633965523, 10.006382479847218, 52.119393308361346,
    ],
    '032540014014': [
      9.629057482212877, 52.067858925577276, 9.762825694245931, 52.16982658102831,
    ],
    '032540017017': [
      9.84533919597088, 52.15959535235162, 9.947401718643025, 52.237975457010315,
    ],
    '032540020020': [
      9.923680456995802, 52.177591599338385, 10.084929428504132, 52.237975457010315,
    ],
    '032540021021': [
      9.84656047369344, 52.09381500807023, 10.036112691111546, 52.1939613911249,
    ],
    '032540022022': [
      10.066138049490323, 52.04319505938244, 10.202267279133665, 52.1315591869225,
    ],
    '032540026026': [
      9.685681942116046, 52.118245038606275, 9.862375634560609, 52.21430952453983,
    ],
    '032540028028': [
      9.769138527758413, 52.19652628845906, 9.93378230855633, 52.27052465011319,
    ],
    '032540029029': [
      10.014313479239247, 52.11018163844575, 10.156029378147375, 52.23560986539914,
    ],
    '032540032032': [
      10.134949755954404, 52.117353224210206, 10.264158211046443, 52.23431160035795,
    ],
    '032540042042': [
      9.84643429307193, 51.89669783340874, 10.009908513607503, 51.96611888478113,
    ],
    '032540044044': [
      9.89752085623892, 51.9273069425936, 10.086316894799202, 52.02541912999946,
    ],
    '032540045045': [
      9.818160955959003, 51.96140651275808, 9.97438544057868, 52.084198313000144,
    ],
    '032545406013': [
      9.643603799969037, 52.03294302013255, 9.740358175995045, 52.10432026190649,
    ],
    '032545406041': [
      9.634022519401015, 51.95556122648088, 9.771987963005149, 52.05483913824719,
    ],
    '032545406043': [
      9.727630151622456, 52.02018764932185, 9.888713309253589, 52.13488168426646,
    ],
    '032550008008': [
      9.717677323416211, 51.89650082828157, 9.8956504020816, 51.98299308662684,
    ],
    '032550023023': [
      9.415811402159223, 51.719771606013325, 9.58112010116407, 51.85508943337195,
    ],
    '032555401002': [
      9.456848203938296, 51.84540312912275, 9.558857552478125, 51.93152990433905,
    ],
    '032555401015': [
      9.49050837927956, 51.87241138994831, 9.574766330137338, 51.92415735156643,
    ],
    '032555401021': [
      9.559658610135454, 51.895731660852675, 9.60885754317227, 51.92600917354844,
    ],
    '032555401030': [
      9.54245385945098, 51.87297912372177, 9.617506402142519, 51.92031239853816,
    ],
    '032555403004': [
      9.378853086156363, 51.73429096888648, 9.428555191074999, 51.76790291986078,
    ],
    '032555403009': [
      9.41045838544412, 51.68292177178562, 9.493764268411681, 51.721921413964175,
    ],
    '032555403014': [
      9.387131422357298, 51.70238199723209, 9.42649957669522, 51.74034598532865,
    ],
    '032555403026': [
      9.374834453657769, 51.64596233715272, 9.438125060670544, 51.70238199723209,
    ],
    '032555408003': [
      9.475557289962909, 51.90789096865025, 9.554405161917622, 51.996282591296236,
    ],
    '032555408005': [
      9.374650082742834, 51.89251426297112, 9.470298075637096, 51.93152990433905,
    ],
    '032555408016': [
      9.524103363101613, 51.97191156220028, 9.619595186156205, 52.04360073462343,
    ],
    '032555408017': [
      9.414331210056218, 51.93794919489522, 9.497283720851607, 52.002546256189106,
    ],
    '032555408019': [
      9.361195488455557, 51.85543141926976, 9.465211828310448, 51.89046521155051,
    ],
    '032555408020': [
      9.48077120356202, 51.99057669179427, 9.541586811007939, 52.01884503202961,
    ],
    '032555408025': [
      9.52536295283843, 51.9203265524819, 9.595242627701666, 51.980859336641174,
    ],
    '032555408031': [
      9.341279396712146, 51.9225812445565, 9.457004757050253, 51.98296326864966,
    ],
    '032555408032': [
      9.456848203938296, 51.92412102556265, 9.510345829127116, 51.95658069308764,
    ],
    '032555408033': [
      9.323971677430238, 51.85390398839537, 9.470298075637096, 51.90987252001922,
    ],
    '032555408035': [
      9.309029160757342, 51.88817324605851, 9.389405168243082, 51.93412057746472,
    ],
    '032555409001': [
      9.54535295656901, 51.84582495122438, 9.586715780559173, 51.87520913768012,
    ],
    '032555409007': [
      9.555009924489868, 51.83353925521098, 9.628161955171658, 51.876432385057925,
    ],
    '032555409010': [
      9.582046945580625, 51.95311522189326, 9.631638427934163, 51.98653351538431,
    ],
    '032555409012': [
      9.69274706279471, 51.864885936507015, 9.80204142789785, 51.899547338110864,
    ],
    '032555409013': [
      9.57786666072007, 51.9045013586762, 9.696525454441295, 51.96758588087243,
    ],
    '032555409018': [
      9.574285523439558, 51.78444441496958, 9.652373530575618, 51.85052832492066,
    ],
    '032555409022': [
      9.649805389655686, 51.92641099639846, 9.691029752483576, 51.96838099652127,
    ],
    '032555409027': [
      9.65920973708179, 51.88340457948318, 9.707106996224287, 51.91155060583077,
    ],
    '032555409028': [
      9.592798060701936, 51.93871288786574, 9.645163280890173, 51.9749534285808,
    ],
    '032555409034': [
      9.57796581082459, 51.85052832492066, 9.681101551005034, 51.91679281688084,
    ],
    '032555409036': [
      9.628161955171658, 51.831495889949394, 9.709066103852225, 51.88395839043678,
    ],
    '032560022022': [
      9.161120813347786, 52.59083613837142, 9.307933536829337, 52.686391617110885,
    ],
    '032560025025': [
      9.093873861318896, 52.40962222958963, 9.276668407622438, 52.541640010110385,
    ],
    '032560030030': [
      8.871777686629986, 52.52791516961584, 9.105157174577174, 52.6479760057257,
    ],
    '032565402005': [
      9.181835180395323, 52.66812201097847, 9.259454556411619, 52.716523148166466,
    ],
    '032565402011': [
      9.199601893387628, 52.71611340068087, 9.310658541080198, 52.7709168982949,
    ],
    '032565402012': [
      9.244912879853654, 52.67653647359238, 9.385027189329174, 52.76405348811838,
    ],
    '032565402027': [
      9.199601893387628, 52.69990234486105, 9.260670851818405, 52.73050712099501,
    ],
    '032565407020': [
      9.271336766664598, 52.55555900122502, 9.373138610742629, 52.61335124355849,
    ],
    '032565407026': [
      9.403153672808278, 52.62375598899662, 9.534555042271377, 52.72811241742552,
    ],
    '032565407029': [
      9.282520768803865, 52.61763226236372, 9.467359814719403, 52.735298414954876,
    ],
    '032565407031': [
      9.262811321647318, 52.602276226288915, 9.426030774516509, 52.66207442974114,
    ],
    '032565408004': [
      8.698749761633389, 52.38737261645864, 8.791789594005087, 52.52606490770749,
    ],
    '032565408024': [
      8.891626102140698, 52.40215866750845, 8.9992558077676, 52.49822926200256,
    ],
    '032565408033': [
      8.766635818499774, 52.45973634665373, 8.955764662783311, 52.58818030659556,
    ],
    '032565408034': [
      8.772621274957409, 52.38917619979003, 8.92546553124725, 52.49848502037936,
    ],
    '032565409003': [
      9.045711693077276, 52.752496577885445, 9.194359200402133, 52.80515092372692,
    ],
    '032565409007': [
      9.160805299774072, 52.72708517963949, 9.310658541080198, 52.803929092636444,
    ],
    '032565409008': [
      9.204742573888078, 52.74334567847364, 9.26586275361678, 52.765105332030316,
    ],
    '032565409009': [
      9.243115755831546, 52.76398239793169, 9.31312136562395, 52.792055456492854,
    ],
    '032565409010': [
      9.166849560372505, 52.75889894945893, 9.328395277395092, 52.82179396435209,
    ],
    '032565409013': [
      9.090591202883122, 52.81217700448288, 9.217614214833862, 52.910216946503574,
    ],
    '032565409014': [
      9.10590932805957, 52.791487853506155, 9.182503649894771, 52.82001438530151,
    ],
    '032565409015': [
      9.034360592541029, 52.79414858586409, 9.126539500609582, 52.85219392965047,
    ],
    '032565409028': [
      9.114294830014115, 52.72997539636152, 9.222261937839427, 52.76921562670796,
    ],
    '032565409035': [
      9.039987667887, 52.71936979257988, 9.13453477145326, 52.77203233565345,
    ],
    '032565410006': [
      9.09034582728719, 52.5710442350165, 9.204515829588264, 52.61050476552961,
    ],
    '032565410016': [
      9.18665522608455, 52.53577220802584, 9.336425610322486, 52.60816025485289,
    ],
    '032565410017': [
      9.08620493139424, 52.52356119502439, 9.248773191187492, 52.57830992884915,
    ],
    '032565410018': [
      9.079000839618777, 52.47560336437647, 9.174844594007022, 52.532677842491516,
    ],
    '032565410032': [
      8.9390805228504, 52.45735312049672, 9.109704520421705, 52.560487777627664,
    ],
    '032565411001': [
      9.091875134883262, 52.68012921821441, 9.227469602428268, 52.74039335365156,
    ],
    '032565411002': [
      9.044050598773623, 52.5842422913068, 9.168284440446167, 52.66120658953416,
    ],
    '032565411019': [
      9.041886815279533, 52.582359096661456, 9.172488489629657, 52.64518510939746,
    ],
    '032565411021': [
      9.06688052587905, 52.63007696594662, 9.197760074834573, 52.690471328944625,
    ],
    '032565411023': [
      8.974304287538631, 52.60107237596443, 9.058551024907795, 52.666302174915124,
    ],
    '032565411036': [
      9.008740275785572, 52.65769820455947, 9.150076277987546, 52.735644526930884,
    ],
    '032570003003': [
      9.13041420691345, 52.20694316611592, 9.330636477051288, 52.27673629694047,
    ],
    '032570009009': [
      8.963621455571927, 52.2339553648958, 9.100939873475369, 52.349896538727656,
    ],
    '032570028028': [
      9.085587326630586, 52.2307038151868, 9.228335269515393, 52.29615466356115,
    ],
    '032570031031': [
      8.984992859449948, 52.09691931268522, 9.24650467268815, 52.22377869140208,
    ],
    '032570035035': [
      9.128114912368302, 52.259023708466074, 9.287373897753938, 52.35093085600108,
    ],
    '032575401001': [
      9.080517577315268, 52.24662949912082, 9.118866731477771, 52.265451498707,
    ],
    '032575401005': [
      9.079487972307883, 52.234659787072445, 9.114243421148078, 52.25296489204365,
    ],
    '032575401008': [
      9.11854423422583, 52.22094815481464, 9.14188298936482, 52.231375557748855,
    ],
    '032575401012': [
      9.095557621538546, 52.22094815481464, 9.121263625940955, 52.238430985846634,
    ],
    '032575401022': [
      9.061755281121831, 52.21808925551381, 9.108627013180381, 52.23933713612847,
    ],
    '032575402007': [
      9.282631640260817, 52.31756777154393, 9.327848474096545, 52.36897048335557,
    ],
    '032575402015': [
      9.258593045097808, 52.32432619376034, 9.296691708309996, 52.34792349607594,
    ],
    '032575402020': [
      9.264644407425996, 52.33938396455484, 9.320805573356456, 52.37774220642067,
    ],
    '032575402021': [
      9.228381318262732, 52.32367759219962, 9.274295785278083, 52.38313279269051,
    ],
    '032575403006': [
      9.315954690186905, 52.295968651155505, 9.434182206952567, 52.389534330121826,
    ],
    '032575403011': [
      9.353660194921467, 52.36267022754643, 9.423848453720769, 52.40612036419468,
    ],
    '032575403016': [
      9.326356642911618, 52.34945281337782, 9.38670613062084, 52.388595538776244,
    ],
    '032575403036': [
      9.378487170807333, 52.34812448525564, 9.423848453720769, 52.37899382115097,
    ],
    '032575404019': [
      9.192011890119138, 52.347886641217556, 9.240470406625045, 52.38806957265064,
    ],
    '032575404023': [
      9.073869826441417, 52.325651584495375, 9.170311489296001, 52.37161215201127,
    ],
    '032575404025': [
      9.110710100706203, 52.3414563729047, 9.17449035967105, 52.383244364256846,
    ],
    '032575404027': [
      9.156194011948664, 52.33933055013527, 9.197443338786199, 52.376565928208144,
    ],
    '032575404030': [
      9.140064443769989, 52.369317532763056, 9.22479275086635, 52.40517033410222,
    ],
    '032575404037': [
      9.095193766335859, 52.36963742231953, 9.162957671292734, 52.41211995059366,
    ],
    '032575405013': [
      9.103660590344722, 52.28944424848116, 9.155240394870527, 52.32140801265551,
    ],
    '032575405014': [
      9.08326056945615, 52.31343716504245, 9.129206906438307, 52.34311416887334,
    ],
    '032575405026': [
      9.134605872991092, 52.27859889514736, 9.192524855079135, 52.3136696146667,
    ],
    '032575405034': [
      9.071286605729448, 52.28466271885522, 9.116861858493316, 52.32826191030325,
    ],
    '032575406002': [
      9.255759659805648, 52.27322894823618, 9.358212737814986, 52.32896334788883,
    ],
    '032575406017': [
      9.31160140911572, 52.21285503128451, 9.393913425294853, 52.26900924722795,
    ],
    '032575406018': [
      9.345777877843929, 52.255193037930965, 9.448379540039916, 52.295968651155505,
    ],
    '032575406024': [
      9.36583544743408, 52.24765948475846, 9.421566609076319, 52.27096139773086,
    ],
    '032575406029': [
      9.309889670883043, 52.24718983557829, 9.361284828349609, 52.27655468379854,
    ],
    '032575406032': [
      9.320229779823416, 52.29117558186953, 9.406536754395026, 52.33367646850573,
    ],
    '032575407004': [
      9.271464933404065, 52.370331143097744, 9.32221434619798, 52.417905069002224,
    ],
    '032575407010': [
      9.266847090953206, 52.40589111767746, 9.374353004847794, 52.45481561005313,
    ],
    '032575407033': [
      9.205573981578866, 52.375463673481384, 9.291199537518736, 52.41730189796223,
    ],
    '032575407038': [
      9.158025005900262, 52.39520492009644, 9.291050447798906, 52.44024496400674,
    ],
    '033510004004': [
      9.89571994018388, 52.70680045595368, 10.160922086785092, 52.89130628668908,
    ],
    '033510006006': [
      9.983876688625202, 52.56399976232844, 10.208499507019873, 52.72794661139238,
    ],
    '033510010010': [
      10.061841377982784, 52.833541657033834, 10.281429624884886, 52.93644295523756,
    ],
    '033510012012': [
      9.868744987221476, 52.5780861793852, 10.01714568559484, 52.6723056644754,
    ],
    '033510023023': [
      9.73453904781654, 52.596893118152096, 9.885874025054644, 52.6894404049949,
    ],
    '033510024024': [
      9.72536843339457, 52.64013942060095, 10.044027109595124, 52.7531493374519,
    ],
    '033510025025': [
      10.12954696162922, 52.658150170788566, 10.441583045677667, 52.821406627956016,
    ],
    '033510026026': [
      9.991103227684388, 52.73665817496366, 10.38528141748723, 52.89941658055343,
    ],
    '033515402005': [
      10.173379076181883, 52.49091937792186, 10.257839131303381, 52.538599662139774,
    ],
    '033515402007': [
      10.13936303827011, 52.51416682308371, 10.25780063792557, 52.57079082477786,
    ],
    '033515402017': [
      10.24665825789828, 52.48852254701133, 10.38126241148136, 52.573609331367926,
    ],
    '033515402022': [
      10.120687392438159, 52.54486189458773, 10.301054482563597, 52.610221966086776,
    ],
    '033515403002': [
      10.242378850044316, 52.58378909415901, 10.350626297036941, 52.63107540392333,
    ],
    '033515403003': [
      10.208499507019873, 52.63306398557996, 10.29817724251969, 52.67498011534345,
    ],
    '033515403008': [
      10.281608819809843, 52.62196551006812, 10.405344967464574, 52.726792714316744,
    ],
    '033515403015': [
      10.294008163214741, 52.554912814615946, 10.41489077748633, 52.62899694929199,
    ],
    '033515403016': [
      10.177284218081226, 52.580413581632286, 10.340585971490963, 52.664188468350964,
    ],
    '033515404001': [
      9.96530265375718, 52.536245798690445, 10.096236296358985, 52.59287479891063,
    ],
    '033515404018': [
      10.055059132797954, 52.50861557149802, 10.13936303827011, 52.569977490100506,
    ],
    '033515404021': [
      10.113276109891938, 52.49758924901298, 10.173379076181883, 52.552773574796895,
    ],
    '033520011011': [
      8.551136645502638, 53.76055211616991, 8.863231242289206, 53.89225263144631,
    ],
    '033520032032': [
      8.492095581323682, 53.39395143393219, 8.78150383254692, 53.51392579554637,
    ],
    '033520050050': [
      8.61614733535508, 53.484062374956565, 8.892280447654533, 53.62086418752494,
    ],
    '033520059059': [
      8.670894384425264, 53.372912681158816, 8.970931170659028, 53.52041541738523,
    ],
    '033520060060': [
      8.49603798904601, 53.280505035427446, 8.774830446707035, 53.43634199370823,
    ],
    '033520061061': [
      8.482531292229796, 53.61812154396171, 8.712563391952585, 53.822647952099175,
    ],
    '033520062062': [
      8.508829157533308, 53.51937993747699, 8.994874766515538, 53.736522349764385,
    ],
    '033525404002': [
      8.967897061553536, 53.55632961916684, 9.090081562734865, 53.62720940016274,
    ],
    '033525404024': [
      9.051209083860257, 53.554028359903896, 9.152190879918797, 53.611527370177036,
    ],
    '033525404029': [
      9.001820154568275, 53.606472324237934, 9.174562180353758, 53.677637911075635,
    ],
    '033525404036': [
      8.969607407036536, 53.62301342032217, 9.086213004359232, 53.70079901171586,
    ],
    '033525404052': [
      8.926319971032665, 53.59454640916346, 9.019476682322422, 53.69104104142936,
    ],
    '033525407020': [
      9.158575050843677, 53.61237610358182, 9.278578643137811, 53.675985170461544,
    ],
    '033525407022': [
      9.056422074142176, 53.644087977731324, 9.223397664047987, 53.72266588769553,
    ],
    '033525407044': [
      9.152627842745066, 53.69109149586983, 9.298591677856246, 53.76854445216114,
    ],
    '033525411004': [
      8.958660412852891, 53.77116087644266, 9.031566421730975, 53.84028810354215,
    ],
    '033525411008': [
      8.95751133885249, 53.687651966997294, 9.023364886843462, 53.779492421188486,
    ],
    '033525411025': [
      8.830631542973004, 53.70284925725718, 8.959933163290497, 53.75743630373713,
    ],
    '033525411038': [
      8.837949410896327, 53.74447092206819, 8.934366206137385, 53.792810116318535,
    ],
    '033525411039': [
      9.003940070739825, 53.779492421188486, 9.047756233373448, 53.82082562835802,
    ],
    '033525411041': [
      8.757790121244101, 53.746377196253995, 8.866149125429665, 53.78887006776396,
    ],
    '033525411042': [
      9.096138587320741, 53.70971766899026, 9.222731320017612, 53.790975444569085,
    ],
    '033525411043': [
      8.908819979931277, 53.663723917432506, 8.96960124246548, 53.72484410591212,
    ],
    '033525411045': [
      8.927567915332975, 53.74646655397233, 8.961035742366224, 53.800745213057105,
    ],
    '033525411046': [
      8.830538363889676, 53.7849318758846, 8.959085231181382, 53.83753387272573,
    ],
    '033525411051': [
      8.82717937226151, 53.634650051736365, 8.940360657180785, 53.70676393190468,
    ],
    '033525411055': [
      8.710140184355835, 53.67987343380707, 8.835996925158563, 53.765902374136,
    ],
    '033525411056': [
      8.972585995350363, 53.689302575291855, 9.124360155081368, 53.78115000521868,
    ],
    '033525411063': [
      9.005177494876444, 53.75454319077703, 9.145389519472445, 53.8128618035152,
    ],
    '033530005005': [
      9.783128689638033, 53.24444494237293, 9.930477859448123, 53.37922733182837,
    ],
    '033530026026': [
      9.727495854506962, 53.36415592331152, 9.863993542371269, 53.50471893691924,
    ],
    '033530029029': [
      9.804395187744685, 53.33392043444108, 9.95795554962797, 53.456478128782116,
    ],
    '033530031031': [
      9.921655530066053, 53.31660361865867, 10.108492390422562, 53.46412429502836,
    ],
    '033530032032': [
      10.056953234465496, 53.342748850640426, 10.170717175336982, 53.42694286188371,
    ],
    '033530040040': [
      10.089740803929821, 53.28679140457983, 10.325639774644786, 53.40837825617972,
    ],
    '033535401007': [
      10.244021673008408, 53.350601802554735, 10.33493827146733, 53.4341273250135,
    ],
    '033535401023': [
      10.315619712494788, 53.35902371371998, 10.396212685838734, 53.42495673339262,
    ],
    '033535401033': [
      10.363442866689315, 53.35405753278469, 10.471472420136248, 53.413205620670226,
    ],
    '033535402002': [
      9.946515760774448, 53.252764875083244, 10.005896085545894, 53.30857129725982,
    ],
    '033535402004': [
      10.01378231943753, 53.27610715801668, 10.097499238821044, 53.32192079614527,
    ],
    '033535402009': [
      9.986874629129703, 53.128405392078506, 10.110756548728517, 53.22810331279173,
    ],
    '033535402016': [
      9.89172538336651, 53.21022224239487, 10.070493727988163, 53.29434874464855,
    ],
    '033535402024': [
      9.979853002167525, 53.27924106504315, 10.051422769537826, 53.3349789802372,
    ],
    '033535402036': [
      9.84672885595112, 53.17323278089653, 10.009484194724225, 53.24543564344523,
    ],
    '033535403001': [
      9.727495854506962, 53.363801186237566, 9.781910162566673, 53.42242742465761,
    ],
    '033535403008': [
      9.725744586202335, 53.313959854829385, 9.812955049697917, 53.340635432846156,
    ],
    '033535403014': [
      9.562420881305382, 53.329356551255216, 9.658787655123316, 53.37625734156835,
    ],
    '033535403019': [
      9.668629916451673, 53.32889694225612, 9.732964421012905, 53.39482682159382,
    ],
    '033535403025': [
      9.67777737718824, 53.37980062762903, 9.740844126718173, 53.42242742465761,
    ],
    '033535403028': [
      9.617967534991557, 53.33895323900981, 9.679683876946479, 53.40965104143069,
    ],
    '033535403039': [
      9.722916008487923, 53.334102593132506, 9.8308625949745, 53.37399114147137,
    ],
    '033535404003': [
      9.953320998698024, 53.32483277110035, 9.99677051443781, 53.3439181910985,
    ],
    '033535404017': [
      9.947432381618547, 53.3349789802372, 10.010744225626938, 53.358613599991116,
    ],
    '033535404020': [
      9.882176183779189, 53.27132237423674, 9.984035106044791, 53.3424302798816,
    ],
    '033535405010': [
      10.109565050324859, 53.16976220308634, 10.186081382711874, 53.21722963453223,
    ],
    '033535405011': [
      10.045368216949528, 53.20851515085891, 10.14259757428701, 53.25305459339818,
    ],
    '033535405012': [
      10.116114354942308, 53.265201286828365, 10.22550126159168, 53.30062671273822,
    ],
    '033535405013': [
      10.072477102424802, 53.169242320234474, 10.136664343994878, 53.24136832515201,
    ],
    '033535405030': [
      10.124248682690789, 53.18050859320421, 10.233567278653316, 53.26544945514147,
    ],
    '033535405034': [
      10.048467240855127, 53.241632237072885, 10.167663066721001, 53.31288454002764,
    ],
    '033535405037': [
      10.187842325280018, 53.246292504263764, 10.259802990950787, 53.29073316466251,
    ],
    '033535405042': [
      10.097499238821044, 53.283135155709736, 10.172597483638095, 53.31288454002764,
    ],
    '033535406006': [
      9.632799882728728, 53.283439106341675, 9.73423382412784, 53.33844297973022,
    ],
    '033535406015': [
      9.7886461837788, 53.20604083172405, 9.893697816134795, 53.27722956519208,
    ],
    '033535406018': [
      9.57975721531297, 53.258955316514836, 9.693588383128452, 53.35021353797718,
    ],
    '033535406021': [
      9.709898672738243, 53.28897218002156, 9.795425629456773, 53.34361681207833,
    ],
    '033535406022': [
      9.606956081934147, 53.21618335508101, 9.706733357416091, 53.24553669147528,
    ],
    '033535406027': [
      9.683003411531914, 53.186860879857456, 9.806454901759428, 53.264687093513444,
    ],
    '033535406035': [
      9.628730319730217, 53.23466558212938, 9.850718166469374, 53.31297348550956,
    ],
    '033535406038': [
      9.756343247071717, 53.189747127758146, 9.833480051253153, 53.26601637006827,
    ],
    '033535406041': [
      9.601734681470454, 53.24300825963278, 9.708241120124088, 53.28381441311486,
    ],
    '033545403005': [
      11.405703445917815, 52.975879981101315, 11.512152004294746, 53.06642872285955,
    ],
    '033545403007': [
      11.322828803758, 53.01310789840831, 11.420630973218742, 53.065335769073805,
    ],
    '033545403010': [
      11.382610742178308, 53.03314938232186, 11.47525732536509, 53.078576554879874,
    ],
    '033545403020': [
      11.312189987396852, 52.92452598865924, 11.460148918933905, 52.9849307260589,
    ],
    '033545403021': [
      11.491036640593109, 52.99793797927772, 11.597698156800796, 53.052980916162504,
    ],
    '033545406003': [
      11.122808310716852, 53.11928427372658, 11.212828779894753, 53.168669335310746,
    ],
    '033545406004': [
      11.00971336895649, 53.04023607065981, 11.171667833503752, 53.157613926161105,
    ],
    '033545406006': [
      10.874437972053727, 53.09129265952212, 11.026030941070632, 53.16055286979072,
    ],
    '033545406008': [
      11.143979487193752, 53.02647809170224, 11.250260609224618, 53.14392585096244,
    ],
    '033545406009': [
      10.90225542593706, 53.1127870078838, 11.098436592055833, 53.20216822302833,
    ],
    '033545406011': [
      10.97535667159177, 53.022486105343845, 11.149632914046137, 53.06899151512396,
    ],
    '033545406012': [
      10.920068738927041, 53.05887310687369, 11.047010832106658, 53.12364570837731,
    ],
    '033545406014': [
      11.212828779894753, 53.03733606400677, 11.325632866736322, 53.13924749261718,
    ],
    '033545406019': [
      10.86007937544266, 53.17936508173363, 10.970615868304655, 53.25124233972524,
    ],
    '033545406027': [
      10.833462877303415, 53.01739110525194, 10.98825581081187, 53.103944304921455,
    ],
    '033545407001': [
      10.895287184802406, 52.8533535097279, 10.992626091914136, 52.9174237937658,
    ],
    '033545407002': [
      10.841661480666417, 52.90477476465469, 11.015313717091509, 52.99753356937186,
    ],
    '033545407013': [
      10.967936763253428, 52.94824942576366, 11.112197908929527, 53.03805738004115,
    ],
    '033545407015': [
      11.230564647293194, 52.875482434594524, 11.43863681616566, 52.95418451531634,
    ],
    '033545407016': [
      10.99468700407302, 52.910154697200795, 11.08965503582983, 52.972065770294876,
    ],
    '033545407017': [
      11.156196140433286, 52.8913548709568, 11.256660134192547, 52.93240648488097,
    ],
    '033545407018': [
      11.070837863436617, 52.92425128948124, 11.259384828886278, 53.032993244289116,
    ],
    '033545407022': [
      10.803214003459363, 52.84625926005202, 10.9292397201214, 52.93203374238862,
    ],
    '033545407023': [
      11.19684097134662, 52.94856370612097, 11.373929255587713, 53.06422832125545,
    ],
    '033545407024': [
      10.88984377148639, 52.968746189465435, 11.030476109113021, 53.04563947423688,
    ],
    '033545407025': [
      11.194587568424684, 52.918362001983134, 11.29150138771724, 52.98235408391361,
    ],
    '033545407026': [
      11.053998960483517, 52.896509821565765, 11.169150958850665, 52.9560862419002,
    ],
    '033550001001': [
      10.424473225885253, 53.25438471000607, 10.493016625020633, 53.312877452100935,
    ],
    '033550009009': [
      10.614075339553338, 53.21793031204196, 10.87122324209386, 53.36902507007635,
    ],
    '033550022022': [
      10.330698036164165, 53.19157046972049, 10.514270440453096, 53.28517288019076,
    ],
    '033550049049': [
      10.783483671617248, 53.1389604969447, 11.19334839862899, 53.34857596121206,
    ],
    '033555401002': [
      10.143340887012089, 53.10348847226945, 10.272798169238719, 53.14473440937866,
    ],
    '033555401008': [
      10.26946885786386, 53.08784628025208, 10.34670723933695, 53.176224343600346,
    ],
    '033555401027': [
      10.174363227366594, 53.13334916302655, 10.285295271904022, 53.19322782545865,
    ],
    '033555401029': [
      10.037997787767292, 53.042993663258635, 10.28626646776632, 53.119313424952956,
    ],
    '033555401034': [
      10.076029709179506, 53.10601216486793, 10.186948019846366, 53.18796432434681,
    ],
    '033555402004': [
      10.309221576128508, 53.28353834522904, 10.431881817569163, 53.32697829917851,
    ],
    '033555402007': [
      10.36959768257583, 53.322323410028254, 10.43146211601647, 53.36988104267029,
    ],
    '033555402017': [
      10.308350816321834, 53.32335766971988, 10.364399229505464, 53.3604957240499,
    ],
    '033555402023': [
      10.268063518546771, 53.257835337451034, 10.333381511451444, 53.30057954414081,
    ],
    '033555402028': [
      10.21157057530481, 53.283705217733875, 10.330875230073525, 53.331253509086785,
    ],
    '033555402039': [
      10.305856965524264, 53.26290605879637, 10.366087445538149, 53.304747950558905,
    ],
    '033555402042': [
      10.326586349216408, 53.31043503501506, 10.389539471002987, 53.36331660443613,
    ],
    '033555403010': [
      10.691748430007232, 53.12227564166155, 10.786600973588406, 53.181538031268005,
    ],
    '033555403012': [
      10.71216206726438, 53.19461523919024, 10.790410372042816, 53.24126275097741,
    ],
    '033555403013': [
      10.628744610805258, 53.14882563281803, 10.780671118764113, 53.25233987346972,
    ],
    '033555403025': [
      10.76497514993116, 53.13833296929117, 10.90739255544151, 53.19822125835209,
    ],
    '033555403037': [
      10.777930734797172, 53.18094357371358, 10.87797980394667, 53.22892856764796,
    ],
    '033555404020': [
      10.242240732236935, 53.21215763478141, 10.333600422476248, 53.28880009682461,
    ],
    '033555404031': [
      10.259802990950787, 53.23301310943096, 10.374736698033042, 53.29203883943128,
    ],
    '033555404035': [
      10.244331525317248, 53.18771565750186, 10.35702513228292, 53.23160061505426,
    ],
    '033555404041': [
      10.198281261167969, 53.19004168572462, 10.264540330764001, 53.256524323780056,
    ],
    '033555405006': [
      10.335041480639541, 53.113477338176146, 10.408882166277525, 53.173343470352265,
    ],
    '033555405014': [
      10.414546426683877, 53.16912680230655, 10.471193531657766, 53.213738801497755,
    ],
    '033555405016': [
      10.2759446472657, 53.14360119732554, 10.37400093428603, 53.21163236105242,
    ],
    '033555405024': [
      10.3634641625418, 53.15135377236516, 10.445319598493318, 53.1992154204039,
    ],
    '033555406005': [
      10.49426374452573, 53.21163576578682, 10.56012532037851, 53.243127449559154,
    ],
    '033555406026': [
      10.588506976671392, 53.24143132444734, 10.685230943610888, 53.306869760637774,
    ],
    '033555406030': [
      10.509102880676512, 53.203572268385734, 10.62588066042983, 53.27227258342861,
    ],
    '033555406036': [
      10.600433450405216, 53.18242758116867, 10.692712329008963, 53.251568556116304,
    ],
    '033555406038': [
      10.507254480976048, 53.17059655605986, 10.612919969855408, 53.218212351679696,
    ],
    '033555406040': [
      10.436702860642782, 53.1864405623986, 10.508577794026687, 53.22707920939837,
    ],
    '033555407003': [
      10.442751685126956, 53.34690295213755, 10.528830716672248, 53.38599692744904,
    ],
    '033555407011': [
      10.406185599812323, 53.30849726313503, 10.508101400921012, 53.36170240515615,
    ],
    '033555407015': [
      10.475135973763294, 53.31964702511883, 10.572960326220949, 53.35147948956199,
    ],
    '033555407018': [
      10.552111029655132, 53.33017324377174, 10.650798880580068, 53.36902507007635,
    ],
    '033555407019': [
      10.505455689783647, 53.34579722784027, 10.601399764113772, 53.37039870190883,
    ],
    '033555407021': [
      10.540590829867412, 53.28778262388652, 10.635216087223425, 53.332409428794016,
    ],
    '033555407032': [
      10.512329129614272, 53.259386479657415, 10.611125111644347, 53.311650203578594,
    ],
    '033555407033': [
      10.460966575240988, 53.25242409327896, 10.544774173967863, 53.335438673616636,
    ],
    '033560002002': [
      8.955992420945522, 53.12477574840085, 9.068500661426084, 53.24239024603376,
    ],
    '033560005005': [
      8.777726751962627, 53.12736693246598, 9.00282590854624, 53.21090515704518,
    ],
    '033560007007': [
      8.659386021622508, 53.18438289312701, 8.947307155776139, 53.3259887580892,
    ],
    '033560008008': [
      8.662313285165757, 53.1617364461264, 8.806245045255292, 53.223218631440126,
    ],
    '033560009009': [
      8.481138723955961, 53.1780690594449, 8.70248214200539, 53.36232208379026,
    ],
    '033560011011': [
      8.823817000045462, 53.18570565498739, 9.02695104999802, 53.33822185601789,
    ],
    '033565401001': [
      8.735961618439513, 53.332821359317514, 8.812632164714836, 53.37943069115899,
    ],
    '033565401003': [
      8.780027348434254, 53.26678766907404, 8.876733225735054, 53.341034957716865,
    ],
    '033565401004': [
      8.786835958178775, 53.341034957716865, 8.911378417378952, 53.39551743621676,
    ],
    '033565401006': [
      8.763890869120328, 53.31648571334199, 8.84628873788636, 53.35052878011277,
    ],
    '033565401010': [
      8.84628873788636, 53.282894054758266, 8.96464821013334, 53.374354222592245,
    ],
    '033570008008': [
      9.076502543834751, 53.40839118496838, 9.284117337091484, 53.593322228403345,
    ],
    '033570016016': [
      8.900058077684138, 53.31891550329677, 9.120126354357659, 53.451214829274114,
    ],
    '033570039039': [
      9.271010592706693, 53.05123810556481, 9.473660627133278, 53.192280851411034,
    ],
    '033570041041': [
      9.36036804144747, 53.107435009463316, 9.64675061263486, 53.24651851466982,
    ],
    '033570051051': [
      9.437330034416327, 52.92044313300358, 9.679656657714785, 53.06595401195246,
    ],
    '033575401006': [
      9.469221475956168, 53.04346991660465, 9.562389832213547, 53.08588669063532,
    ],
    '033575401009': [
      9.473660627133278, 53.05352343358256, 9.582152736757179, 53.11654209728454,
    ],
    '033575401024': [
      9.422716085124664, 53.03760912495488, 9.504222840631874, 53.107435009463316,
    ],
    '033575401025': [
      9.560736377455568, 53.056414627634005, 9.64602722981897, 53.11654209728454,
    ],
    '033575401031': [
      9.360955178576393, 52.99765437962254, 9.492034896143558, 53.05702699488514,
    ],
    '033575401054': [
      9.319593889963196, 52.98203744291728, 9.422535710421961, 53.05123810556481,
    ],
    '033575402015': [
      9.624103469058596, 53.1362563970454, 9.75244316249577, 53.21082802576306,
    ],
    '033575402023': [
      9.451590348560323, 53.18742246093978, 9.530755845662275, 53.24859648137842,
    ],
    '033575402033': [
      9.517347312739462, 53.178513291237586, 9.682562712471922, 53.226824731689476,
    ],
    '033575402046': [
      9.529319581982584, 53.20825924938407, 9.631096475357689, 53.258955316514836,
    ],
    '033575402049': [
      9.582629026615592, 53.161939781294414, 9.683805490107307, 53.2198853820084,
    ],
    '033575403002': [
      9.010645857453627, 53.53037194792835, 9.10723469402304, 53.571525505731884,
    ],
    '033575403004': [
      8.908277764965193, 53.40915929563479, 9.059818530573622, 53.4694611110206,
    ],
    '033575403012': [
      8.967226809129663, 53.49645354804791, 9.09064913261519, 53.55792920224993,
    ],
    '033575403027': [
      8.899406987559791, 53.45462659015984, 9.034687626320398, 53.53634889356532,
    ],
    '033575403035': [
      8.988543576643782, 53.44154306017715, 9.099730439326022, 53.51552035478084,
    ],
    '033575404003': [
      9.25413352896282, 53.354773837540144, 9.375870772857747, 53.41813962069062,
    ],
    '033575404011': [
      9.197017776190474, 53.38693964569817, 9.291577414643935, 53.43997798807061,
    ],
    '033575404014': [
      9.233818895163735, 53.41222072139182, 9.347339585987417, 53.46962315928201,
    ],
    '033575404036': [
      9.12005774275551, 53.27477958794544, 9.208760484001129, 53.366899343390195,
    ],
    '033575404038': [
      9.074891537823072, 53.27477958794544, 9.157206667993616, 53.357440891206615,
    ],
    '033575404040': [
      9.064795412934034, 53.371015817137156, 9.198777289650556, 53.42860732333094,
    ],
    '033575404042': [
      9.19554126694841, 53.30365278475813, 9.27703440829791, 53.364473143104135,
    ],
    '033575404043': [
      9.117085150783454, 53.32948217642965, 9.276533725909704, 53.40378450262434,
    ],
    '033575405017': [
      9.419370387878136, 53.25851864933465, 9.484218330114334, 53.30222867122156,
    ],
    '033575405019': [
      9.43550797660759, 53.234059487734825, 9.503111367478503, 53.27031404681331,
    ],
    '033575405029': [
      9.540878938476817, 53.28835787893491, 9.587414266239199, 53.33110003323364,
    ],
    '033575405032': [
      9.409973702767298, 53.29197943398518, 9.49159472382937, 53.33313850841946,
    ],
    '033575405034': [
      9.496615108250401, 53.295008175152084, 9.536068187928873, 53.32266322302732,
    ],
    '033575405044': [
      9.47132050951641, 53.237764798954096, 9.57975721531297, 53.342735737059506,
    ],
    '033575405048': [
      9.512046256761522, 53.251300411971705, 9.604146791702384, 53.332320427613695,
    ],
    '033575405050': [
      9.436039958904418, 53.301832894643724, 9.535349772072847, 53.35945341698321,
    ],
    '033575405056': [
      9.480526998582054, 53.336594104515726, 9.57310601321516, 53.383729086517505,
    ],
    '033575406001': [
      9.262047754595434, 53.013239135112556, 9.365029350445862, 53.08911757627862,
    ],
    '033575406005': [
      9.263911781818026, 53.120692480436965, 9.347221339881816, 53.16609741791723,
    ],
    '033575406020': [
      9.247828767906553, 53.08303692891934, 9.295934443880203, 53.13519685782615,
    ],
    '033575406022': [
      9.165301555090426, 53.03244444319323, 9.273785344688397, 53.08303692891934,
    ],
    '033575406028': [
      9.176375178263502, 53.15606834620063, 9.280641698289307, 53.21285500591037,
    ],
    '033575406037': [
      9.17037688421392, 53.11158142339988, 9.28789310782533, 53.17208844264416,
    ],
    '033575406045': [
      9.14813651841538, 53.07533249765559, 9.264378237942172, 53.135228681567035,
    ],
    '033575407007': [
      8.990022157949683, 53.27192140970794, 9.137144487056633, 53.334694168454426,
    ],
    '033575407010': [
      9.110227483199477, 53.1854893143179, 9.25603144930191, 53.24180476677351,
    ],
    '033575407026': [
      8.99364824690531, 53.243854753340244, 9.142088068537323, 53.28557700682133,
    ],
    '033575407030': [
      9.126968174989832, 53.2321724795865, 9.212521887500625, 53.27811399524883,
    ],
    '033575407047': [
      9.02585610442622, 53.19625820242268, 9.127306976294802, 53.24762686180636,
    ],
    '033575407052': [
      9.061828189227157, 53.14386425339876, 9.19200124890769, 53.202022282253374,
    ],
    '033575407053': [
      9.098689231876415, 53.21686777980219, 9.187981294464262, 53.25603728166858,
    ],
    '033575407055': [
      9.030656345722907, 53.17101698482517, 9.123329285464608, 53.208235007820285,
    ],
    '033575408013': [
      9.317262576136395, 53.20964969543104, 9.440587161351543, 53.29213812155454,
    ],
    '033575408018': [
      9.218689358177379, 53.1755809060958, 9.361021300602365, 53.25110723101443,
    ],
    '033575408021': [
      9.26265057483667, 53.28131805189891, 9.446584107903307, 53.38805228146714,
    ],
    '033575408057': [
      9.167310473726783, 53.23301302040908, 9.347191043031474, 53.33846733247307,
    ],
    '033580002002': [
      9.860441172366047, 53.05807408042985, 10.11633187081984, 53.180261047826434,
    ],
    '033580008008': [
      9.661522949591415, 52.84048932020008, 9.857260571280506, 52.95647286192332,
    ],
    '033580016016': [
      9.962499010321384, 52.89861343432566, 10.235153167314447, 53.07944646662202,
    ],
    '033580017017': [
      9.608315030466422, 52.988295455254175, 9.77943579245093, 53.11437986020358,
    ],
    '033580019019': [
      9.625482849897885, 53.03227022775023, 9.937816265729088, 53.219059312399494,
    ],
    '033580021021': [
      9.660075279930322, 52.92843560181185, 10.030031519984632, 53.07911634823473,
    ],
    '033580023023': [
      9.857260571280506, 52.86725311348677, 10.080493526131995, 52.97907177061995,
    ],
    '033580024024': [
      9.374534172087527, 52.72539957155702, 9.720266289922371, 52.968995306824205,
    ],
    '033585401001': [
      9.461774569332288, 52.72652214389805, 9.56844806359018, 52.782022414253916,
    ],
    '033585401006': [
      9.579343834860675, 52.715820827984224, 9.660669436617932, 52.751527478024634,
    ],
    '033585401011': [
      9.492845173445271, 52.70649489558844, 9.60161672572126, 52.76030918949259,
    ],
    '033585401012': [
      9.595954826561899, 52.70174988866005, 9.67623044533946, 52.73409405670642,
    ],
    '033585401014': [
      9.5577476858412, 52.738747587092796, 9.66231201925396, 52.79722828913039,
    ],
    '033585402003': [
      9.398315170030456, 52.76517391782588, 9.58223250497563, 52.80950491148527,
    ],
    '033585402009': [
      9.400839236644877, 52.72391282814864, 9.475991859536068, 52.7820344851078,
    ],
    '033585402013': [
      9.331095787230092, 52.793230903778934, 9.413769740867139, 52.83422432074445,
    ],
    '033585402018': [
      9.317724390493982, 52.71436907571603, 9.405385810387266, 52.80347052121708,
    ],
    '033585403005': [
      9.653828930882835, 52.632662364077994, 9.746012912001294, 52.68782301976407,
    ],
    '033585403007': [
      9.619942390086102, 52.67394792130569, 9.76067335085099, 52.738154604110335,
    ],
    '033585403010': [
      9.480730388251317, 52.660065604703384, 9.59302019627507, 52.7271221927685,
    ],
    '033585403015': [
      9.63527943971782, 52.60104536796705, 9.714316243691382, 52.637166817932766,
    ],
    '033585403020': [
      9.56877708826514, 52.633613748525434, 9.682881116134915, 52.710783002639104,
    ],
    '033590010010': [
      9.598278195353991, 53.41216129286218, 9.783232657782172, 53.50911322894403,
    ],
    '033590013013': [
      9.229503851896355, 53.649377712002554, 9.485653005429638, 53.789732469769824,
    ],
    '033590028028': [
      9.627083876365916, 53.49062867137613, 9.779369927760644, 53.57181767202134,
    ],
    '033590038038': [
      9.370316952189699, 53.538788001300496, 9.541065889069564, 53.68006198105629,
    ],
    '033595401003': [
      9.549259232913057, 53.41972606945776, 9.649662012874659, 53.47297683533064,
    ],
    '033595401006': [
      9.563606438026339, 53.38802376229159, 9.684682995497718, 53.44166737497819,
    ],
    '033595401037': [
      9.509835236437073, 53.33819175113725, 9.623659956164483, 53.427210507077874,
    ],
    '033595402011': [
      9.414232548355141, 53.49179092949601, 9.52524878325572, 53.55489179946424,
    ],
    '033595402017': [
      9.329811072183427, 53.480786721035926, 9.44132963032848, 53.57111984613474,
    ],
    '033595402031': [
      9.22522846941936, 53.44741026725522, 9.408917220157486, 53.53669412571317,
    ],
    '033595403002': [
      9.357960249113374, 53.34467181847823, 9.511482242086863, 53.44998413572921,
    ],
    '033595403005': [
      9.403583296880988, 53.4415743259545, 9.50318355517351, 53.50108656894844,
    ],
    '033595403008': [
      9.338591953804036, 53.40532860594377, 9.416068858943692, 53.46589515466063,
    ],
    '033595403023': [
      9.43431514887861, 53.402317696994146, 9.591396478750315, 53.504905439161355,
    ],
    '033595405001': [
      9.49836168785371, 53.54414427426828, 9.57451805302924, 53.57733901739066,
    ],
    '033595405007': [
      9.526233594399452, 53.45701222769926, 9.590118801274905, 53.50319470800435,
    ],
    '033595405012': [
      9.4955752592687, 53.5221070612429, 9.576917436176666, 53.55289745390441,
    ],
    '033595405027': [
      9.509365982712808, 53.485174039151964, 9.615167100020143, 53.529226394415836,
    ],
    '033595405034': [
      9.58779485366037, 53.47226859947395, 9.627918752854345, 53.510413943064194,
    ],
    '033595406020': [
      9.603168213454955, 53.565454310800476, 9.634593654562334, 53.581769616575784,
    ],
    '033595406021': [
      9.570205754686926, 53.517495049197144, 9.622019957954825, 53.55782853551834,
    ],
    '033595406026': [
      9.497313734145784, 53.567562236192494, 9.58469722271602, 53.61391713998332,
    ],
    '033595406032': [
      9.606357630634767, 53.53390583905159, 9.656522698970607, 53.567605622628335,
    ],
    '033595406033': [
      9.592334303594612, 53.50911322894403, 9.650366432635085, 53.54009686572621,
    ],
    '033595406039': [
      9.567604825404603, 53.55501884154633, 9.613709502720596, 53.58811207032135,
    ],
    '033595407004': [
      9.01284540898508, 53.790975444569085, 9.191372743825248, 53.86347825813442,
    ],
    '033595407018': [
      9.23547041321165, 53.79922802790867, 9.33183096767685, 53.85983015945992,
    ],
    '033595407030': [
      9.167290989149457, 53.802922658373355, 9.254296255026823, 53.86347825813442,
    ],
    '033595407035': [
      9.145389519472445, 53.75605764211579, 9.308982944165873, 53.81132662089848,
    ],
    '033595407040': [
      9.269230064201759, 53.72978705191536, 9.354359399899186, 53.816531754867015,
    ],
    '033595409009': [
      9.212367799820653, 53.602100708454486, 9.299382228356237, 53.643980935207324,
    ],
    '033595409014': [
      9.306674611793392, 53.57111984613474, 9.386757586977376, 53.603163930674334,
    ],
    '033595409015': [
      9.269717254772527, 53.632291933473205, 9.358463711315595, 53.68330306945556,
    ],
    '033595409016': [
      9.157673586625318, 53.532025320243484, 9.254874762813229, 53.593322228403345,
    ],
    '033595409019': [
      9.207462831012299, 53.66737180719296, 9.329409088200668, 53.696521543413574,
    ],
    '033595409022': [
      9.329796206473462, 53.59133866533796, 9.430306113784235, 53.66561343676711,
    ],
    '033595409024': [
      9.262531234791368, 53.52341739119644, 9.370316952189699, 53.58775639270066,
    ],
    '033595409025': [
      9.270823908259128, 53.586666711636326, 9.331732663915664, 53.658883552886195,
    ],
    '033595409029': [
      9.140185526502666, 53.58190763200583, 9.233014749222354, 53.62293651342186,
    ],
    '033595409036': [
      9.22245685325111, 53.547502929257824, 9.306900682605349, 53.6078758452234,
    ],
    '033600004004': [
      10.382754409223955, 53.08358126901598, 10.583373840964786, 53.202883624295644,
    ],
    '033600025025': [
      10.466944443401545, 52.87761077251739, 10.693488513422363, 53.04067002753498,
    ],
    '033605404015': [
      10.64025954654191, 52.97826973911114, 10.750179305011343, 53.042280505738326,
    ],
    '033605404016': [
      10.641458236194408, 52.96628885184528, 10.704274256909558, 52.99101124511007,
    ],
    '033605404018': [
      10.718841290450408, 52.952354605864414, 10.89227691752861, 53.04452611831408,
    ],
    '033605404022': [
      10.747518759663611, 53.01053835599226, 10.840060880846336, 53.09393739880668,
    ],
    '033605404024': [
      10.672136417533139, 52.896213764604376, 10.872354969834234, 52.98027818210701,
    ],
    '033605405007': [
      10.246027911853766, 52.853965698451944, 10.382726376336207, 52.99633808803778,
    ],
    '033605405009': [
      10.34866476031927, 52.929843701987714, 10.48844339765953, 52.993888025166804,
    ],
    '033605405023': [
      10.316614689167729, 52.806678180456764, 10.514773575110537, 52.94541594081633,
    ],
    '033605407001': [
      10.55251341975732, 53.097590225605046, 10.696377215793202, 53.190569481765465,
    ],
    '033605407002': [
      10.493851306559652, 53.03608997864148, 10.661348461773192, 53.10795842960476,
    ],
    '033605407003': [
      10.476279842606099, 53.01581138895468, 10.579475405630921, 53.070221540954755,
    ],
    '033605407006': [
      10.346570690034195, 53.00366508646347, 10.489580137942399, 53.08201645031002,
    ],
    '033605407008': [
      10.53699099118749, 53.0105446901569, 10.610219357057993, 53.05131832421071,
    ],
    '033605407010': [
      10.3118689182371, 53.004068814157485, 10.417515140190545, 53.115065989861215,
    ],
    '033605407011': [
      10.667229196916354, 53.06500475103132, 10.776737449679409, 53.145025252887535,
    ],
    '033605407012': [
      10.4882630784205, 53.08463653554695, 10.573255255500378, 53.1239480142121,
    ],
    '033605407014': [
      10.405158881789061, 53.022201211554666, 10.503940005866514, 53.09310375094889,
    ],
    '033605407017': [
      10.615841314027273, 53.06699210805499, 10.692866133467765, 53.130799684681776,
    ],
    '033605407019': [
      10.314013903045586, 52.96810736305373, 10.482196014373002, 53.01700649776573,
    ],
    '033605407026': [
      10.63179743147626, 53.0303484123317, 10.761582620359192, 53.08054587794222,
    ],
    '033605407029': [
      10.145511412589407, 52.930919363436374, 10.343870935312458, 53.0949373095395,
    ],
    '033605408005': [
      10.601300805554041, 52.8045450745225, 10.7718131923235, 52.886638272622555,
    ],
    '033605408013': [
      10.574203643340837, 52.76472392450726, 10.759394019772971, 52.843551636904934,
    ],
    '033605408020': [
      10.715903185397032, 52.84241147304632, 10.841022816213815, 52.89742419152075,
    ],
    '033605408030': [
      10.441583045677667, 52.80945754940508, 10.757283930495936, 52.94491952792199,
    ],
    '033610001001': [
      8.926409233677091, 52.98213641998134, 9.143101222693966, 53.05478700686017,
    ],
    '033610003003': [
      9.18127615201229, 52.77245357279077, 9.354685909692302, 52.90755380496189,
    ],
    '033610005005': [
      9.268013476343471, 52.82052636227042, 9.46360402977175, 53.02806223312967,
    ],
    '033610006006': [
      9.075059842295062, 52.962708874831144, 9.288351792151175, 53.042644817003094,
    ],
    '033610008008': [
      8.950571548362753, 53.016044633709924, 9.20436676888722, 53.1843483679205,
    ],
    '033610009009': [
      8.962051541099157, 53.03695442089617, 9.150892916098982, 53.10341789947695,
    ],
    '033610012012': [
      9.16008117695928, 52.87917120824792, 9.314356956652736, 53.003472978557724,
    ],
    '033615401002': [
      9.070143651235128, 52.8932768170434, 9.188555209340995, 52.97383570502935,
    ],
    '033615401004': [
      8.930350163094863, 52.88778709036978, 9.001553285040979, 52.952582008982645,
    ],
    '033615401010': [
      8.904648479936338, 52.92633654431178, 8.971415163383, 53.011876381664294,
    ],
    '033615401013': [
      8.947932647655223, 52.91761649970931, 9.124730769936136, 53.009550208448964,
    ],
    '034010000000': [
      8.5791195266159, 52.986679394899404, 8.711125676669303, 53.109138198284995,
    ],
    '034020000000': [
      6.99862874036812, 53.32080206444661, 7.313452559744403, 53.41030141955247,
    ],
    '034030000000': [
      8.130178847820597, 53.08246905348501, 8.311956169291456, 53.203128435458225,
    ],
    '034040000000': [
      7.928588873120657, 52.22047062226136, 8.179482768342936, 52.33871703089355,
    ],
    '034050000000': [
      7.995299448853396, 53.50187827306485, 8.172202785278776, 53.63824957438288,
    ],
    '034510001001': [
      7.700751456822408, 53.1591346809942, 7.872899025612867, 53.265696833077804,
    ],
    '034510002002': [
      7.896634434715162, 53.13096082237432, 8.166947140299616, 53.264541211131096,
    ],
    '034510004004': [
      7.8399292106886, 53.05879599315792, 8.143385530520858, 53.172795512288396,
    ],
    '034510005005': [
      8.105371622118238, 53.189408410858604, 8.31487197592078, 53.35417794425035,
    ],
    '034510007007': [
      7.800178835632259, 53.16493904188604, 8.060516701527844, 53.350879163693456,
    ],
    '034510008008': [
      8.03057082424858, 53.17732566768799, 8.204762738043767, 53.34237199747599,
    ],
    '034520001001': [
      7.402098591925335, 53.409997724662055, 7.6791423531241, 53.56114843257649,
    ],
    '034520002002': [
      7.36300126862263, 53.72018753772312, 7.430945828399203, 53.735039924211414,
    ],
    '034520006006': [
      7.483338468264833, 53.3327240996027, 7.731395615177709, 53.46143277976783,
    ],
    '034520007007': [
      7.300816493145962, 53.502295304418304, 7.443383200032799, 53.64018389061307,
    ],
    '034520011011': [
      7.133448024822233, 53.38749393956579, 7.285727727389392, 53.459715721230744,
    ],
    '034520012012': [
      7.281740719373034, 53.34838221096709, 7.541533377412539, 53.4677581573183,
    ],
    '034520013013': [
      6.851934413165893, 53.66265215027534, 7.097155786019625, 53.68741077552138,
    ],
    '034520014014': [
      6.99764165910904, 53.35345339539557, 7.212057162728504, 53.545064030302456,
    ],
    '034520019019': [
      7.087107718895806, 53.49690178427342, 7.268666155302535, 53.668279345706495,
    ],
    '034520020020': [
      7.137838027284767, 53.697241587969295, 7.346203264594674, 53.72601054375524,
    ],
    '034520023023': [
      7.241090957821521, 53.39707071949117, 7.419315748212612, 53.53670896307566,
    ],
    '034520025025': [
      7.644820557468189, 53.357833799679725, 7.816043434075786, 53.472090689340774,
    ],
    '034520027027': [
      7.31427267233704, 53.61945547110161, 7.554065423822333, 53.68338113475876,
    ],
    '034525401015': [
      7.284920906279797, 53.53438142403669, 7.34405635296767, 53.56211339268199,
    ],
    '034525401017': [
      7.228511175472599, 53.51649396998054, 7.313481627981827, 53.5354906106213,
    ],
    '034525401021': [
      7.18737641921529, 53.51131180802652, 7.288353989955319, 53.56211339268199,
    ],
    '034525401022': [
      7.309191239629336, 53.51447996006661, 7.349483415843519, 53.54377970886344,
    ],
    '034525401024': [
      7.219252019237143, 53.46613116977675, 7.317948525966732, 53.53031632135621,
    ],
    '034525401026': [
      7.187840536369106, 53.45009815488733, 7.260843790431979, 53.51349407003605,
    ],
    '034525403003': [
      7.294717946186193, 53.573062073993896, 7.335305982485111, 53.60885798092302,
    ],
    '034525403008': [
      7.273339538607422, 53.578809332236645, 7.344238213375522, 53.63152533038222,
    ],
    '034525403009': [
      7.241736276789352, 53.62111053251617, 7.326295628735648, 53.68338113475876,
    ],
    '034525403010': [
      7.24482721796752, 53.55661807549512, 7.326318619368727, 53.57966256303044,
    ],
    '034525403016': [
      7.224331329624104, 53.5675730637067, 7.274774959162578, 53.631910447048,
    ],
    '034530001001': [
      7.668968232731267, 53.086597356959714, 7.884877010494814, 53.179540037936015,
    ],
    '034530002002': [
      7.898227212236147, 52.9641533659909, 8.100118323108143, 53.0830476907956,
    ],
    '034530003003': [
      7.994691941006379, 52.75268869343927, 8.206038348669681, 52.82785215222965,
    ],
    '034530004004': [
      7.965233666530541, 52.79568938761353, 8.102676318249738, 52.923330297837865,
    ],
    '034530005005': [
      8.08702033222559, 52.78835689015894, 8.258857394604737, 52.92869000629103,
    ],
    '034530006006': [
      7.832040359815876, 52.67964770956605, 8.07579871652383, 52.76626627012217,
    ],
    '034530007007': [
      7.710057022579313, 52.9059076897436, 7.960980834423629, 53.120050524428564,
    ],
    '034530008008': [
      7.934312251005128, 52.88060763476591, 8.12281878070623, 53.020100600840145,
    ],
    '034530009009': [
      7.792268258104839, 52.7513556242778, 8.004276086667373, 52.83638272537755,
    ],
    '034530010010': [
      7.692918836744905, 52.78252379137476, 7.857002359127502, 52.87945989444844,
    ],
    '034530011011': [
      7.634976122782374, 52.678005759246666, 7.886647846999479, 52.81378279704807,
    ],
    '034530012012': [
      7.791712009432245, 52.81644558972793, 7.999966666562341, 52.934749273107485,
    ],
    '034530013013': [
      7.610363978161398, 53.01770008680077, 7.782868144654977, 53.18748532454264,
    ],
    '034540010010': [
      7.21248307865879, 52.33406181731717, 7.426713609634278, 52.479184906234636,
    ],
    '034540014014': [
      7.123416731113122, 52.548223566542646, 7.417126898995408, 52.654789653077,
    ],
    '034540018018': [
      7.063512353567766, 52.72280895518831, 7.389657321996689, 52.88207926284264,
    ],
    '034540019019': [
      7.360553419756712, 52.60879928038309, 7.594195547854101, 52.750949051542044,
    ],
    '034540032032': [
      7.195968238151677, 52.42030389006613, 7.453844551274894, 52.602466891062555,
    ],
    '034540035035': [
      7.135101716383432, 52.62371441632753, 7.443442620585878, 52.774387417152965,
    ],
    '034540041041': [
      7.29181835606718, 53.00619139534016, 7.52555178481432, 53.11180325428676,
    ],
    '034540044044': [
      7.19893465138337, 53.00716696704327, 7.315970800030611, 53.11785803072784,
    ],
    '034540045045': [
      7.258030431251393, 52.28006996263971, 7.438519673008713, 52.35146415864618,
    ],
    '034540054054': [
      6.995378495457558, 52.58934899942262, 7.191748297665468, 52.760510925953874,
    ],
    '034545401007': [
      7.181120951019595, 52.94093162776902, 7.297995465661968, 53.00021797971626,
    ],
    '034545401008': [
      7.294937002413133, 52.94757638500955, 7.438964337065729, 52.99129836704668,
    ],
    '034545401020': [
      7.208633771992858, 52.97358887945855, 7.325987419687255, 53.031293106933084,
    ],
    '034545401025': [
      7.289225655729461, 52.909360257450615, 7.404037897798356, 52.95431302773495,
    ],
    '034545401030': [
      7.312442004400081, 52.98095777598615, 7.391435617572347, 53.02121425822445,
    ],
    '034545401037': [
      7.411597683209002, 52.92672829015138, 7.475543715755772, 52.988606256371746,
    ],
    '034545401038': [
      7.373129290381211, 52.98345128689155, 7.465989361798688, 53.01586147262701,
    ],
    '034545401056': [
      7.153299263632396, 52.912151161712515, 7.301103303890071, 52.945966993914524,
    ],
    '034545401060': [
      7.382982967934567, 52.88701681305019, 7.439839244623403, 52.95229647972271,
    ],
    '034545402001': [
      7.529496450787607, 52.489310242112694, 7.619590899800889, 52.5372002955915,
    ],
    '034545402003': [
      7.458780728297824, 52.39728351000966, 7.548053222824279, 52.4579741625075,
    ],
    '034545402012': [
      7.496420411660666, 52.420982797234906, 7.608904026335445, 52.52397560650594,
    ],
    '034545402036': [
      7.409511629947992, 52.43832322850861, 7.501146212456253, 52.50336211707583,
    ],
    '034545402053': [
      7.45345933284506, 52.473992679831035, 7.512519051918503, 52.51130784607977,
    ],
    '034545403009': [
      7.54604989994229, 52.60945136031175, 7.655943504253249, 52.658337435496456,
    ],
    '034545403021': [
      7.549875772483244, 52.64716755480846, 7.69513849227986, 52.72592277166682,
    ],
    '034545403026': [
      7.500248896360762, 52.69755720263887, 7.714323029162996, 52.798515808765615,
    ],
    '034545404013': [
      7.267753675280275, 52.87082219955976, 7.391640993650602, 52.91584147749846,
    ],
    '034545404029': [
      7.258478973511136, 52.817976598328926, 7.4252231446415, 52.88168633614867,
    ],
    '034545404039': [
      7.158255557314959, 52.84597333743801, 7.306624577601907, 52.89050473285675,
    ],
    '034545404040': [
      7.147822860760309, 52.828334295655196, 7.294189410541152, 52.86492361420876,
    ],
    '034545404043': [
      7.341948100933029, 52.862789391512415, 7.439158966342149, 52.919174417024124,
    ],
    '034545404052': [
      7.119210860653722, 52.878999234947436, 7.313342136880866, 52.92339594155832,
    ],
    '034545405002': [
      7.379657419177436, 52.55446758001016, 7.474904044225629, 52.6165660416744,
    ],
    '034545405015': [
      7.430993260320625, 52.56061891193787, 7.54604989994229, 52.61684468793134,
    ],
    '034545405017': [
      7.557847855376605, 52.53585976178076, 7.619590899800889, 52.6058278085444,
    ],
    '034545405028': [
      7.405546762905272, 52.50336211707583, 7.50429011362827, 52.58386588472293,
    ],
    '034545405031': [
      7.498278640183005, 52.51932110944678, 7.58703088341244, 52.60945136031175,
    ],
    '034545405059': [
      7.54604989994229, 52.57223430288865, 7.622084709585324, 52.615277995145604,
    ],
    '034545406004': [
      7.533732829803147, 53.00583770800474, 7.646546629481452, 53.05924221064724,
    ],
    '034545406006': [
      7.562439125983155, 52.93529982061492, 7.617382471202995, 52.98146128363151,
    ],
    '034545406011': [
      7.564983405517354, 52.95108766276178, 7.710057022579313, 53.043703040998935,
    ],
    '034545406022': [
      7.661654416467908, 52.96246290829848, 7.718931427893464, 53.01770008680077,
    ],
    '034545406051': [
      7.436532592090494, 52.95082266019488, 7.586735118545084, 53.043096843749474,
    ],
    '034545407005': [
      7.439706407903922, 52.88719699992207, 7.599140814636833, 52.96064683673361,
    ],
    '034545407016': [
      7.463009218369121, 52.74776653791233, 7.529034973806906, 52.80296610783817,
    ],
    '034545407023': [
      7.524858841280151, 52.761930726095954, 7.597094449986445, 52.801393825527555,
    ],
    '034545407024': [
      7.421890957638974, 52.71853515358023, 7.475662279970421, 52.80208225373458,
    ],
    '034545407047': [
      7.423047871011002, 52.800341326547404, 7.579335139946076, 52.87914973385838,
    ],
    '034545407048': [
      7.545772604279259, 52.84191524011932, 7.666096736465471, 52.91877014761296,
    ],
    '034545407050': [
      7.330639823816199, 52.735414640340046, 7.476009007166891, 52.85315324715476,
    ],
    '034545407058': [
      7.416837855641714, 52.85252676000213, 7.550375155407128, 52.9295188120119,
    ],
    '034545408034': [
      7.376304342394583, 52.37408007263588, 7.515704408528738, 52.4436617861476,
    ],
    '034545408046': [
      7.510686370631925, 52.3690081626382, 7.604073795058902, 52.43231221363355,
    ],
    '034545408049': [
      7.405192562108305, 52.33344749978043, 7.534216608371646, 52.40389766989474,
    ],
    '034545409027': [
      7.565012919722006, 52.78528053543571, 7.652720093264113, 52.83798167862113,
    ],
    '034545409033': [
      7.57591927384104, 52.89870634208284, 7.721674658345288, 52.98751243627544,
    ],
    '034545409042': [
      7.644652993542771, 52.883551371937365, 7.760256526971432, 52.96570610515008,
    ],
    '034545409055': [
      7.733660587272771, 52.859352836892995, 7.831702950398363, 52.94210248260658,
    ],
    '034545409057': [
      7.569397284623543, 52.791737501555566, 7.739819566613252, 52.91726460813469,
    ],
    '034550007007': [
      7.815444977510684, 53.503281259840826, 7.949539476389903, 53.59594586284287,
    ],
    '034550014014': [
      7.932141626207909, 53.46191558809877, 8.064828876924606, 53.525609627513994,
    ],
    '034550015015': [
      7.828377248724109, 53.503281259840826, 8.047535419538333, 53.600987203188126,
    ],
    '034550020020': [
      7.811398426730109, 53.57855859280208, 8.090946494976388, 53.718645181453056,
    ],
    '034550021021': [
      7.846123191913333, 53.773692785117085, 7.978262288564055, 53.79527357068148,
    ],
    '034550025025': [
      7.937027878906223, 53.304668769432546, 8.098417805493007, 53.466838600971826,
    ],
    '034550026026': [
      8.0323273291374, 53.32116259524024, 8.209572726644005, 53.452156910895695,
    ],
    '034550027027': [
      7.859195312444554, 53.332928095690235, 8.06932996579996, 53.4736377912629,
    ],
    '034560001001': [
      7.026322773348735, 52.241290016130606, 7.209375789184303, 52.368655765678696,
    ],
    '034560015015': [
      6.998914815001217, 52.3595764546601, 7.202830995073739, 52.5249584515215,
    ],
    '034560025025': [
      7.08495582381264, 52.44379912129083, 7.285033220738456, 52.60130469195261,
    ],
    '034565401002': [
      6.789672674593517, 52.57229160702884, 6.91900219982944, 52.651545282269694,
    ],
    '034565401009': [
      6.868865632654487, 52.550488319593704, 7.047001145810718, 52.6187091989891,
    ],
    '034565401012': [
      6.711137486055238, 52.56180221877711, 6.822784880981974, 52.65293341707247,
    ],
    '034565401019': [
      6.881849723239819, 52.5879179226933, 7.005416194548173, 52.64572395585104,
    ],
    '034565402004': [
      6.942994290528279, 52.50723137171512, 7.000485186238857, 52.556784065079775,
    ],
    '034565402005': [
      7.021905734342323, 52.54780435320361, 7.108688522737359, 52.604760450802225,
    ],
    '034565402013': [
      6.940975652995737, 52.44222212549491, 6.977868769977745, 52.479653523367446,
    ],
    '034565402014': [
      6.917764961295344, 52.456100123690085, 7.012979297673222, 52.53839171457502,
    ],
    '034565402017': [
      6.990605786380859, 52.493663195157346, 7.088783941882896, 52.593028842439445,
    ],
    '034565403003': [
      7.126228018997169, 52.34055206604797, 7.258030431251393, 52.446376913106775,
    ],
    '034565403010': [
      7.093896072402799, 52.32611064965193, 7.190285972772092, 52.37996558703609,
    ],
    '034565403016': [
      7.218250151566725, 52.26416341073939, 7.316644057423912, 52.292637460410425,
    ],
    '034565403018': [
      7.093896072402799, 52.315898298757524, 7.241728755771519, 52.3595764546601,
    ],
    '034565403020': [
      7.208894266672698, 52.264272483122845, 7.306169164740251, 52.33656023500841,
    ],
    '034565403027': [
      7.191811118140553, 52.27147868368821, 7.261889125041968, 52.34971596110869,
    ],
    '034565404006': [
      6.744467018206104, 52.459626157338704, 6.869124182450225, 52.49291360133349,
    ],
    '034565404007': [
      6.876499710114921, 52.499033389045444, 6.954746609781099, 52.55355921378337,
    ],
    '034565404008': [
      6.852380752889039, 52.43523931380107, 6.965873547420265, 52.48276505229157,
    ],
    '034565404011': [
      6.700109564020126, 52.46746267335495, 6.852274537090068, 52.54441784426172,
    ],
    '034565404023': [
      6.8452148666737, 52.46351420956614, 6.923997585295996, 52.51618496111513,
    ],
    '034565404024': [
      6.681455746236923, 52.477115342899026, 6.773581172896773, 52.56320413304334,
    ],
    '034565404026': [
      6.764872484658516, 52.50368927452216, 6.895415770945864, 52.57440902884174,
    ],
    '034570002002': [
      6.656202420860439, 53.55672194758686, 6.812072685166163, 53.618197951661365,
    ],
    '034570012012': [
      7.229071799551581, 53.220143598841226, 7.406134128681988, 53.32559926578367,
    ],
    '034570013013': [
      7.368281027185005, 53.20336894142311, 7.543440801594564, 53.29233043812771,
    ],
    '034570014014': [
      7.298888218800323, 53.27262100336175, 7.56010960093101, 53.3722760625471,
    ],
    '034570017017': [
      7.576222706287891, 53.05924221064724, 7.649001005376116, 53.214039523362175,
    ],
    '034570018018': [
      7.492719974648403, 53.03509074233883, 7.610363978161398, 53.216528774991794,
    ],
    '034570020020': [
      7.663575842517341, 53.233090817454254, 7.885642176753827, 53.375585548105086,
    ],
    '034570021021': [
      7.253495896690657, 53.1010588525251, 7.40899666514652, 53.23124409334894,
    ],
    '034570022022': [
      7.36284222858227, 53.0785102565413, 7.51462053672546, 53.213757017927485,
    ],
    '034570024024': [
      7.180601285887162, 53.11302280715161, 7.313839325551306, 53.2874016380783,
    ],
    '034575402003': [
      7.532331491098665, 53.24711902853872, 7.600664496012262, 53.28317606560744,
    ],
    '034575402009': [
      7.640466045235841, 53.31444127470981, 7.704874650659049, 53.341115762277944,
    ],
    '034575402010': [
      7.542445669791761, 53.25836200690794, 7.680233776675005, 53.34780405134671,
    ],
    '034575402011': [
      7.535238989083709, 53.253414652688434, 7.621247624630703, 53.293748294646335,
    ],
    '034575402015': [
      7.525262148833621, 53.32463204948976, 7.571464300205855, 53.356603540150175,
    ],
    '034575402019': [
      7.645186190726737, 53.29538820049089, 7.691386455033436, 53.32359304406777,
    ],
    '034575403006': [
      7.514550259087692, 53.17919834849498, 7.73321466386683, 53.23622548321259,
    ],
    '034575403008': [
      7.590407785683317, 53.222019372845914, 7.692397600040269, 53.28167365864246,
    ],
    '034575403016': [
      7.528264715701662, 53.22363286723161, 7.597454833272346, 53.26213055107024,
    ],
    '034580003003': [
      8.315566440831223, 52.90492568715412, 8.515275451019138, 53.024687898318746,
    ],
    '034580005005': [
      8.429365090886904, 52.96582962166701, 8.634440853660374, 53.128148509335205,
    ],
    '034580007007': [
      8.114123435426734, 52.8707509064135, 8.341062630361991, 53.01742429577622,
    ],
    '034580009009': [
      8.210887715241405, 52.99227729752844, 8.437178945939076, 53.09927881773536,
    ],
    '034580010010': [
      8.282335337833066, 53.05582473150526, 8.52186357587438, 53.171019035837986,
    ],
    '034580013013': [
      8.051249305741392, 52.99958960322294, 8.255511372690604, 53.11150846561408,
    ],
    '034580014014': [
      8.30738083422334, 52.82133563554473, 8.47948459861287, 52.9399142584461,
    ],
    '034585401001': [
      8.54501864102786, 52.83952058725068, 8.642927112439537, 52.8999898545275,
    ],
    '034585401002': [
      8.458044939418697, 52.797863103375796, 8.545258822080225, 52.84665795975778,
    ],
    '034585401004': [
      8.606102465448021, 52.894369979751815, 8.653552479539112, 52.94369638069073,
    ],
    '034585401006': [
      8.582714631122256, 52.93853633830601, 8.661905667510265, 53.018606205804666,
    ],
    '034585401008': [
      8.514875331124776, 52.88859326656907, 8.623320644150859, 52.939923309698415,
    ],
    '034585401011': [
      8.628533599573718, 52.91413513526052, 8.689942081551314, 52.967287892926,
    ],
    '034585401012': [
      8.457046110431978, 52.90581469311828, 8.60322783950279, 52.986679394899404,
    ],
    '034585401015': [
      8.467910571222392, 52.83041020800771, 8.57997842007722, 52.919650736557266,
    ],
    '034590003003': [
      8.290541027802398, 52.27155004518629, 8.47032639672659, 52.38382006900333,
    ],
    '034590004004': [
      7.998817470027248, 52.11305453603666, 8.109552340451932, 52.1781229395723,
    ],
    '034590005005': [
      8.019372216639258, 52.05747453910723, 8.133992728447991, 52.137142810068084,
    ],
    '034590006006': [
      8.124956114684085, 52.07204021872904, 8.18709154927928, 52.124626616910426,
    ],
    '034590008008': [
      8.096012831110219, 52.282568541662826, 8.207866712905801, 52.37817665030283,
    ],
    '034590012012': [
      8.123481710746136, 52.203526480517475, 8.32629398467361, 52.32105975437426,
    ],
    '034590013013': [
      8.178101084971015, 52.32697828175641, 8.390991708387828, 52.4987941179544,
    ],
    '034590014014': [
      7.844275744430471, 52.35900975032284, 8.158575653265862, 52.48065071501022,
    ],
    '034590015015': [
      8.146387504379991, 52.073698815231666, 8.267805496907759, 52.15246583521363,
    ],
    '034590019019': [
      7.988476845529577, 52.1675013293377, 8.147088327027882, 52.24013154763795,
    ],
    '034590020020': [
      7.899680021957646, 52.169924064734325, 8.040373780186584, 52.22256755184723,
    ],
    '034590021021': [
      7.921687264285105, 52.20871316778626, 8.012293232561522, 52.27554573271548,
    ],
    '034590022022': [
      8.109359695279396, 52.11631150681642, 8.236015386415392, 52.213324149299716,
    ],
    '034590024024': [
      8.20347047509658, 52.108181344324855, 8.516660099541207, 52.28258727652551,
    ],
    '034590029029': [
      8.126667748802046, 52.304279310176625, 8.293352310297404, 52.451091213831305,
    ],
    '034590033033': [
      7.936979123568443, 52.31740717133696, 8.096953926022442, 52.37525123809705,
    ],
    '034590034034': [
      7.884863638739005, 52.036091566971415, 8.058416748367945, 52.116023340173356,
    ],
    '034595401007': [
      7.866911550985682, 52.59173308441632, 8.085813303647255, 52.67378971410339,
    ],
    '034595401025': [
      7.688821398146734, 52.63048018902529, 7.928938391952263, 52.70958686035073,
    ],
    '034595401028': [
      7.82885537288981, 52.585046274001925, 7.922241276599778, 52.648248416807846,
    ],
    '034595401030': [
      7.903845468091496, 52.65922136173878, 8.034374222342533, 52.69541383739755,
    ],
    '034595402001': [
      7.893387888614589, 52.45408017195554, 8.016002317088464, 52.53796722913937,
    ],
    '034595402002': [
      7.814802758099128, 52.47593998869696, 7.938721716408807, 52.606052754574804,
    ],
    '034595402010': [
      7.885429118585741, 52.51794035862479, 7.998366403668671, 52.61986841064111,
    ],
    '034595402016': [
      7.751856063895778, 52.5284821313167, 7.835057644782536, 52.63048018902529,
    ],
    '034595402018': [
      7.977363220982957, 52.53209198916378, 8.057006077250149, 52.621095282223884,
    ],
    '034595402023': [
      7.809596943588314, 52.56826096229256, 7.853862019576208, 52.637308859450826,
    ],
    '034595402031': [
      7.970918845399947, 52.45696342997865, 8.0633052326194, 52.53578470563004,
    ],
    '034595403009': [
      7.608273517962384, 52.58697678065073, 7.810467169864953, 52.66338114338708,
    ],
    '034595403011': [
      7.608273517962384, 52.527203144942455, 7.789725746006901, 52.61703618726446,
    ],
    '034595403017': [
      7.608516218140649, 52.45621879614633, 7.796422563968287, 52.547101729676434,
    ],
    '034595404026': [
      7.719219786010392, 52.42883749873492, 7.8488975963451, 52.5322521235547,
    ],
    '034595404027': [
      7.746741787292501, 52.36860023888378, 7.891727377232749, 52.464360036435586,
    ],
    '034595404032': [
      7.684865115404531, 52.3924852108568, 7.7889152275666, 52.47690924645783,
    ],
    '034600001001': [
      8.046727647845831, 52.69777151793386, 8.249628016009856, 52.77146304341207,
    ],
    '034600002002': [
      8.12825897170404, 52.479644791902196, 8.349382928995777, 52.57815296139576,
    ],
    '034600003003': [
      8.017499394561577, 52.597186664038624, 8.191338878375456, 52.703097803151394,
    ],
    '034600004004': [
      8.309372664800971, 52.71124167664821, 8.471478906792164, 52.825384949053905,
    ],
    '034600005005': [
      8.04231723332655, 52.524431280795135, 8.193461392462432, 52.624748592022335,
    ],
    '034600006006': [
      8.138331669073652, 52.602504794632914, 8.310573963759657, 52.71720864599579,
    ],
    '034600007007': [
      8.014456631166086, 52.43296948110534, 8.204940219736857, 52.5887684756083,
    ],
    '034600008008': [
      8.148053534705406, 52.55710108872238, 8.315728547125914, 52.638302609254886,
    ],
    '034600009009': [
      8.19831296831488, 52.68696469917048, 8.383076790191739, 52.80000304829419,
    ],
    '034600010010': [
      8.236197519362552, 52.776002795271566, 8.406434357172635, 52.88409765145496,
    ],
    '034610001001': [
      8.386586928137419, 53.1204854559423, 8.578453233801211, 53.22742025621231,
    ],
    '034610002002': [
      8.420403418192233, 53.28600292790794, 8.498855356928717, 53.376700873321006,
    ],
    '034610003003': [
      8.229944323407837, 53.47679826122577, 8.474628439704482, 53.61726140337046,
    ],
    '034610004004': [
      8.292714504507865, 53.15259129167973, 8.489171656828349, 53.2957646969748,
    ],
    '034610005005': [
      8.165236340249583, 53.283995472296375, 8.320095444345693, 53.45409338968326,
    ],
    '034610006006': [
      8.537472937599011, 53.09931907612719, 8.654558461445273, 53.175951974855025,
    ],
    '034610007007': [
      8.362032199374783, 53.43352092561668, 8.554806122675398, 53.55915522999237,
    ],
    '034610008008': [
      8.268130685582276, 53.235110232061345, 8.450357611657061, 53.39203283259174,
    ],
    '034610009009': [
      8.307293424557471, 53.36232208379026, 8.498855356928717, 53.50038633426771,
    ],
    '034620005005': [
      7.678381401780459, 53.3622541680721, 7.971569300736902, 53.51642293945687,
    ],
    '034620007007': [
      7.464725302538784, 53.72198489281822, 7.63118316546026, 53.75883087921743,
    ],
    '034620014014': [
      7.668771499467447, 53.752126327315224, 7.814697355876557, 53.78137113214045,
    ],
    '034620019019': [
      7.646059832966571, 53.485306470897726, 7.857434025096137, 53.71164296095757,
    ],
    '034625401002': [
      7.574744580440397, 53.55641137469583, 7.681803255, 53.614905167693806,
    ],
    '034625401003': [
      7.535183723580268, 53.62435257118, 7.659520084554835, 53.687368774635736,
    ],
    '034625401006': [
      7.488889655236378, 53.61390456680904, 7.603399139560636, 53.66797831921973,
    ],
    '034625401008': [
      7.514421982020838, 53.573953917212556, 7.622796347808302, 53.63091876060547,
    ],
    '034625401010': [
      7.593777200655539, 53.66362519284377, 7.772472674983297, 53.70316186724437,
    ],
    '034625401015': [
      7.611673226791371, 53.60693899488725, 7.719798204261112, 53.66575134151792,
    ],
    '034625401017': [
      7.678774514591288, 53.6413421461078, 7.761828994388535, 53.69099394153755,
    ],
    '034625402001': [
      7.521437141289741, 53.55191024751876, 7.593880394237479, 53.590676245905335,
    ],
    '034625402004': [
      7.412293150023252, 53.53303175808895, 7.478752688111935, 53.57931799376931,
    ],
    '034625402009': [
      7.408395160266536, 53.576964897787825, 7.446113601811633, 53.622271333350284,
    ],
    '034625402011': [
      7.476726378473345, 53.549953946800905, 7.545089328877368, 53.59461230125503,
    ],
    '034625402012': [
      7.493089875598837, 53.59009822130421, 7.563157812347042, 53.62796220629904,
    ],
    '034625402013': [
      7.457724073836178, 53.576743811268976, 7.491126059689973, 53.6255561392412,
    ],
    '034625402016': [
      7.472813608401454, 53.58782281549486, 7.507710240089344, 53.6255561392412,
    ],
    '034625402018': [
      7.430864973795626, 53.54608218197264, 7.509892890268246, 53.62384666271404,
    ],
    '040110000000': [
      8.481138723955961, 53.011876381664294, 8.990830709886586, 53.59723137720544,
    ],
    '040120000000': [
      8.492095581323682, 53.472870787748995, 8.652245582778836, 53.607283051429285,
    ],
    '051110000000': [
      6.688509237549388, 51.12602629253124, 6.936212581402689, 51.353876898546375,
    ],
    '051120000000': [
      6.625577040142793, 51.33287572594562, 6.831283745040738, 51.559985539947334,
    ],
    '051130000000': [
      6.894188676468152, 51.34772643524257, 7.135876638890793, 51.5343027489244,
    ],
    '051140000000': [
      6.481813814730383, 51.28769754411301, 6.705421668716456, 51.40639955758574,
    ],
    '051160000000': [
      6.291764842442043, 51.08555763564043, 6.533989057878421, 51.24744606667798,
    ],
    '051170000000': [
      6.8112830610995, 51.35276405536982, 6.961545894462287, 51.47116138306212,
    ],
    '051190000000': [
      6.780454480533454, 51.45116866287223, 6.929512784845066, 51.57973591019031,
    ],
    '051200000000': [
      7.135962730675251, 51.14492084651248, 7.305843657472595, 51.22583968852356,
    ],
    '051220000000': [
      6.951125834173397, 51.116473696866606, 7.171881120406822, 51.21965702565307,
    ],
    '051240000000': [
      7.018256841104588, 51.16551705085659, 7.312327661885663, 51.317228700108465,
    ],
    '051540004004': [
      6.11570472950608, 51.712822918474416, 6.284265533334668, 51.81269425421679,
    ],
    '051540008008': [
      6.105754959587644, 51.80544754620412, 6.388794241134375, 51.90383176213633,
    ],
    '051540012012': [
      6.200934269246682, 51.46712868352154, 6.417189162701501, 51.575909060550835,
    ],
    '051540016016': [
      6.026584454393491, 51.61368993273686, 6.229379836305418, 51.7491857367454,
    ],
    '051540020020': [
      6.378942457265045, 51.4659298637668, 6.500326848880706, 51.57367640801989,
    ],
    '051540024024': [
      6.235407308209981, 51.687334066257364, 6.411090437773317, 51.82780406997872,
    ],
    '051540028028': [
      6.314983798064572, 51.40554018262488, 6.471749400604609, 51.49138353179925,
    ],
    '051540032032': [
      6.15744463955027, 51.526768252254385, 6.376720335197203, 51.65335511766958,
    ],
    '051540036036': [
      6.037045875582036, 51.73193529945443, 6.244563277269562, 51.86537566935111,
    ],
    '051540040040': [
      5.945323165982273, 51.72415372619421, 6.089617339309844, 51.84396133384928,
    ],
    '051540044044': [
      6.302444338102682, 51.7016237105834, 6.534214618059265, 51.832752066807146,
    ],
    '051540048048': [
      6.420190863615684, 51.416144532564424, 6.52036805322198, 51.48402876437737,
    ],
    '051540052052': [
      6.206025600864089, 51.35687480562114, 6.320995668616046, 51.4879182036172,
    ],
    '051540056056': [
      6.212077911108431, 51.63627064120415, 6.379781316361929, 51.71559765045016,
    ],
    '051540060060': [
      6.266716517716291, 51.35687480562114, 6.397205893970805, 51.445811818855645,
    ],
    '051540064064': [
      6.091790866437288, 51.56077342522172, 6.25580412202, 51.677312420635104,
    ],
    '051580004004': [
      6.871584055028128, 51.19021643440638, 6.994804384306637, 51.242664889836796,
    ],
    '051580008008': [
      6.963911719972889, 51.17180992553787, 7.051922512802254, 51.242931889112505,
    ],
    '051580012012': [
      6.917557705776221, 51.29534774503545, 7.011242988103075, 51.358782416525415,
    ],
    '051580016016': [
      6.895109357938832, 51.140708905281485, 6.987240096099177, 51.197352825748546,
    ],
    '051580020020': [
      6.905667432149149, 51.06721292264007, 6.996532239514585, 51.146934548415324,
    ],
    '051580024024': [
      6.927371659616142, 51.21815073883829, 7.042434102510981, 51.294819794390214,
    ],
    '051580026026': [
      6.854346577040057, 51.0643754083172, 6.927304817376807, 51.13001217851788,
    ],
    '051580028028': [
      6.800785404473388, 51.264673928988685, 6.982007989575097, 51.37090810073599,
    ],
    '051580032032': [
      7.001174295389666, 51.292402277963475, 7.166996462885683, 51.3791629348189,
    ],
    '051580036036': [
      6.980649183339052, 51.254801515413725, 7.097537619112752, 51.324251514543434,
    ],
    '051620004004': [
      6.696416399902558, 51.046043496862126, 6.880193027596574, 51.161113840238414,
    ],
    '051620008008': [
      6.519170726209898, 51.01732927392124, 6.714832280169245, 51.15318210958685,
    ],
    '051620012012': [
      6.436070715743571, 51.034683989438896, 6.593887747471328, 51.158470499685315,
    ],
    '051620016016': [
      6.559427927019169, 51.178680106304384, 6.675983006131058, 51.26031316200452,
    ],
    '051620020020': [
      6.4806867521249, 51.141668126535784, 6.626705121918687, 51.23191357184911,
    ],
    '051620022022': [
      6.5846549547091, 51.23362272483531, 6.734374734473777, 51.33645464567657,
    ],
    '051620024024': [
      6.614924450022063, 51.11853320704331, 6.79880260811349, 51.235379148419845,
    ],
    '051620028028': [
      6.625562722490979, 51.01523536576785, 6.761382370747721, 51.11135039599812,
    ],
    '051660004004': [
      6.071940362719117, 51.22754650039277, 6.241488179462912, 51.30754387637723,
    ],
    '051660008008': [
      6.304217676676702, 51.30446101687206, 6.406120454843395, 51.37779929810505,
    ],
    '051660012012': [
      6.35833940861276, 51.33130078856807, 6.534433808758867, 51.42444488473746,
    ],
    '051660016016': [
      6.153834009086942, 51.252814242841715, 6.325037667247367, 51.36565885184111,
    ],
    '051660020020': [
      6.067610723767435, 51.16715953435949, 6.250104344893471, 51.237938914514636,
    ],
    '051660024024': [
      6.210014012434635, 51.175120990715385, 6.331002453297041, 51.268207493226214,
    ],
    '051660028028': [
      6.38637259697665, 51.278187622144124, 6.514993201260519, 51.349723910066444,
    ],
    '051660032032': [
      6.263611046153546, 51.216719612049, 6.457559229735058, 51.32299485947314,
    ],
    '051660036036': [
      6.411607467614495, 51.223184619325636, 6.625425060963112, 51.30045491622459,
    ],
    '051700004004': [
      6.413762218826696, 51.55472749188334, 6.563121060902052, 51.63028297598797,
    ],
    '051700008008': [
      6.686311668078998, 51.53197847038758, 6.865263612743474, 51.60713280344,
    ],
    '051700012012': [
      6.480468950547402, 51.69166314467708, 6.772963870381663, 51.81687157859084,
    ],
    '051700016016': [
      6.66889035929389, 51.58584547067572, 6.869946079080548, 51.71427345040856,
    ],
    '051700020020': [
      6.44870212244958, 51.47284401811152, 6.589554265315552, 51.56696207354203,
    ],
    '051700024024': [
      6.557525372202978, 51.392518953251205, 6.677982315366399, 51.52305389406413,
    ],
    '051700028028': [
      6.499153247924891, 51.39016509823348, 6.599067299105533, 51.48131352801861,
    ],
    '051700032032': [
      6.533413832609683, 51.50413449932203, 6.700046000225516, 51.62386308211695,
    ],
    '051700036036': [
      6.700765810959273, 51.631037239660145, 6.941026970244535, 51.74620067869002,
    ],
    '051700040040': [
      6.298791471298888, 51.56078407192274, 6.4441039553368, 51.67296873495147,
    ],
    '051700044044': [
      6.586642022625258, 51.5639676598316, 6.721689602562857, 51.6364462182742,
    ],
    '051700048048': [
      6.460748612411591, 51.61614367096426, 6.713452993710444, 51.72347603751073,
    ],
    '051700052052': [
      6.356091498318086, 51.61333986362949, 6.512495137925776, 51.755068076936865,
    ],
    '053140000000': [
      7.025469686804715, 50.63094619108741, 7.211885337909323, 50.77436035378428,
    ],
    '053150000000': [
      6.773912610206384, 50.82976443591155, 7.163219024869747, 51.08460709577052,
    ],
    '053160000000': [
      6.896983961373239, 51.0117109155811, 7.115743340551418, 51.09691858408541,
    ],
    '053340002002': [
      5.974479699532669, 50.66228784002544, 6.216912518718199, 50.85604813757975,
    ],
    '053340004004': [
      6.121594746109862, 50.841979628264596, 6.2298609832588, 50.89357492309046,
    ],
    '053340008008': [
      6.142079528028745, 50.886536354980656, 6.228471002236388, 50.95005603873141,
    ],
    '053340012012': [
      6.189806075221465, 50.77905876310261, 6.340669805331027, 50.88547956927252,
    ],
    '053340016016': [
      6.058055695960073, 50.80886938267381, 6.145244897469853, 50.91376265188071,
    ],
    '053340020020': [
      6.175039197040101, 50.49488153916519, 6.380032579597479, 50.61129921983252,
    ],
    '053340024024': [
      6.165625496099848, 50.623020557919666, 6.272697971238788, 50.70547589573312,
    ],
    '053340028028': [
      6.244892823067748, 50.52994708770446, 6.416921992010493, 50.68652117060247,
    ],
    '053340032032': [
      6.175391359988783, 50.684875919688764, 6.365209358564914, 50.80450448678997,
    ],
    '053340036036': [
      6.087548349563055, 50.80579958587639, 6.208740780585698, 50.85437770987945,
    ],
    '053580004004': [
      6.200359332406143, 50.863356597351164, 6.332365107858881, 50.93689433831534,
    ],
    '053580008008': [
      6.386128255336164, 50.741548853332034, 6.537967937468165, 50.857193236210364,
    ],
    '053580012012': [
      6.382041174688482, 50.59868002592481, 6.57591510152063, 50.66375417636667,
    ],
    '053580016016': [
      6.286462674018908, 50.65062177933077, 6.456907392949387, 50.77350279324159,
    ],
    '053580020020': [
      6.314508821393951, 50.834457629634, 6.433390381625218, 50.8965343854414,
    ],
    '053580024024': [
      6.264632480253573, 50.88056125790408, 6.454868645578618, 50.980472562531446,
    ],
    '053580028028': [
      6.416492341030459, 50.69372134469399, 6.548840987990737, 50.78511083165284,
    ],
    '053580032032': [
      6.299764748758027, 50.758565841652796, 6.419269121570081, 50.83678059680232,
    ],
    '053580036036': [
      6.194843584359233, 50.936709854721634, 6.361182675370819, 51.024557752304666,
    ],
    '053580040040': [
      6.502486997265579, 50.80176889968265, 6.6163684855281, 50.89262305127225,
    ],
    '053580044044': [
      6.375858550575131, 50.636279946131765, 6.601379890001969, 50.71346262007133,
    ],
    '053580048048': [
      6.413398087470319, 50.84103666868414, 6.536026659900804, 50.95195991690131,
    ],
    '053580052052': [
      6.521357696900903, 50.76496899412378, 6.718451139266795, 50.836208673517056,
    ],
    '053580056056': [
      6.33665489380107, 50.93481856005312, 6.500269010522957, 51.0472450243956,
    ],
    '053580060060': [
      6.517718883210828, 50.690560822089466, 6.698026606760544, 50.78824541924789,
    ],
    '053620004004': [
      6.457846524058708, 50.969454463269116, 6.659404878368129, 51.05907036810521,
    ],
    '053620008008': [
      6.56087533197444, 50.916029830482834, 6.7682511928085, 51.021268833682036,
    ],
    '053620012012': [
      6.833306210603607, 50.78483607911102, 6.939579709893145, 50.85654815484494,
    ],
    '053620016016': [
      6.478824492162685, 50.892391229985364, 6.654826712283358, 50.976444356924894,
    ],
    '053620020020': [
      6.682126451093112, 50.717830153453114, 6.851452317634426, 50.861815587595444,
    ],
    '053620024024': [
      6.71976304768321, 50.87784221679388, 6.857898619116676, 50.94897892153148,
    ],
    '053620028028': [
      6.779574638944688, 50.83690668522916, 6.923911982024421, 50.910575506823264,
    ],
    '053620032032': [
      6.552387921722043, 50.823726354894774, 6.804043151320551, 50.92619120998384,
    ],
    '053620036036': [
      6.711380084496173, 50.93882694091744, 6.844261605681432, 51.06610052626282,
    ],
    '053620040040': [
      6.930764051331836, 50.792791041927266, 7.029986627519381, 50.84506056538214,
    ],
    '053660004004': [
      6.691056461630271, 50.45284465094898, 6.930917361231762, 50.60834821307827,
    ],
    '053660008008': [
      6.584687895773203, 50.33736225850645, 6.803584434881977, 50.47130034854026,
    ],
    '053660012012': [
      6.414126259160307, 50.33804013794795, 6.606821434598842, 50.44365606594126,
    ],
    '053660016016': [
      6.710197467473409, 50.561449172081645, 6.931826407811542, 50.70304302438391,
    ],
    '053660020020': [
      6.315420618830167, 50.32269894560116, 6.580890533629079, 50.514225550211314,
    ],
    '053660024024': [
      6.497159784301603, 50.45985228057626, 6.613454593924314, 50.574937376545925,
    ],
    '053660028028': [
      6.535623932526168, 50.521929662305865, 6.769938609836659, 50.65193599747003,
    ],
    '053660032032': [
      6.548888180357763, 50.443259296403546, 6.775663425276084, 50.539353560051254,
    ],
    '053660036036': [
      6.347511899781553, 50.499365821472594, 6.55322690598319, 50.619095960384584,
    ],
    '053660040040': [
      6.759604002489287, 50.687680827569004, 6.915768718416575, 50.78741383703341,
    ],
    '053660044044': [
      6.566873938157324, 50.63058426826828, 6.776270710168262, 50.75394497355607,
    ],
    '053700004004': [
      6.200252377352848, 51.015566100364, 6.477057736063593, 51.11719823954701,
    ],
    '053700008008': [
      5.952266044925277, 50.94787759077198, 6.08101594072636, 51.040988937052475,
    ],
    '053700012012': [
      6.01560597574356, 50.93091680199032, 6.236335647394313, 51.01736320974141,
    ],
    '053700016016': [
      6.039186943342002, 50.99730754522048, 6.213185567805681, 51.12225958801721,
    ],
    '053700020020': [
      6.151917313172948, 50.98854550929783, 6.306413334395184, 51.09109606432835,
    ],
    '053700024024': [
      5.865998792060445, 50.97498765695309, 5.983280980717725, 51.0665267060453,
    ],
    '053700028028': [
      6.01560597574356, 50.90088710446859, 6.15415971469036, 50.953720308093565,
    ],
    '053700032032': [
      5.96849811682273, 51.03249366585127, 6.061059321245106, 51.10594139580151,
    ],
    '053700036036': [
      6.080684762451636, 51.07610187496578, 6.20580200965487, 51.148051283539274,
    ],
    '053700040040': [
      6.139017358371298, 51.10104983904611, 6.354978199817422, 51.18942953365833,
    ],
    '053740004004': [
      7.61745489744422, 50.99653990893797, 7.734227713362183, 51.062054941608494,
    ],
    '053740008008': [
      7.326013765456244, 50.94687605981919, 7.514901998370669, 51.02537417460669,
    ],
    '053740012012': [
      7.43663273789094, 50.974877036319285, 7.717394998588524, 51.08614376784495,
    ],
    '053740016016': [
      7.267647162653672, 51.101181232036375, 7.398769838701152, 51.19581397701452,
    ],
    '053740020020': [
      7.251516984118647, 50.97092896546458, 7.46287566415661, 51.078914416467164,
    ],
    '053740024024': [
      7.451949987338214, 51.04674495302926, 7.617035623933357, 51.10627884876323,
    ],
    '053740028028': [
      7.646837327581019, 50.82039231856423, 7.76569290176677, 50.91739335583722,
    ],
    '053740032032': [
      7.460825673715846, 50.85324708360506, 7.620747482949988, 50.94101129174948,
    ],
    '053740036036': [
      7.295009960503122, 51.170058485469276, 7.430255663156888, 51.25022373573879,
    ],
    '053740040040': [
      7.589603046878941, 50.90302243635441, 7.792071133381722, 51.009952428000766,
    ],
    '053740044044': [
      7.51556473676882, 50.82033860009763, 7.686653796795505, 50.92884782000687,
    ],
    '053740048048': [
      7.426894178239792, 50.93064868277465, 7.616835585348189, 50.99433513318566,
    ],
    '053740052052': [
      7.275543209992991, 51.04863201489814, 7.502763606556199, 51.18730133002734,
    ],
    '053780004004': [
      7.061896704064998, 50.91923749512315, 7.2544147736531, 51.0267109520043,
    ],
    '053780008008': [
      7.057829831141057, 51.06255297732754, 7.166718573484306, 51.12009771644636,
    ],
    '053780012012': [
      7.184200891195998, 50.98748433268363, 7.339884816094478, 51.08751837493203,
    ],
    '053780016016': [
      6.9922793715707, 51.08172508961828, 7.146126050465829, 51.13780536288838,
    ],
    '053780020020': [
      7.09184093417753, 51.0102239064148, 7.209255691293396, 51.07439917068366,
    ],
    '053780024024': [
      7.193639814590406, 50.90676400239416, 7.399726488031076, 50.98748433268363,
    ],
    '053780028028': [
      7.137476981623452, 50.86846680417477, 7.249085669511406, 50.94326304379452,
    ],
    '053780032032': [
      7.138692895422593, 51.06573365663645, 7.298368097793269, 51.16078466566221,
    ],
    '053820004004': [
      6.960765964754564, 50.66144719287278, 7.043913907461172, 50.75622579330066,
    ],
    '053820008008': [
      7.197174762876736, 50.624965457929825, 7.35972178530673, 50.68709467340668,
    ],
    '053820012012': [
      6.861339616343477, 50.718866630636064, 7.066560890665594, 50.80441348447823,
    ],
    '053820016016': [
      7.381424820020914, 50.71157557590116, 7.539111488156271, 50.817574866051224,
    ],
    '053820020020': [
      7.229644730905193, 50.69784007365626, 7.439103012782301, 50.81275934172916,
    ],
    '053820024024': [
      7.167884387297106, 50.66480093091056, 7.370358995922325, 50.74503306477086,
    ],
    '053820028028': [
      7.191321762921918, 50.812718890812086, 7.304739448904196, 50.927714102076614,
    ],
    '053820032032': [
      6.959159125163186, 50.56476613537562, 7.064222163618557, 50.66652116080939,
    ],
    '053820036036': [
      7.300306040349642, 50.84526478124484, 7.478522362222348, 50.94879440938224,
    ],
    '053820040040': [
      7.275824225640725, 50.80828511561673, 7.406383593777548, 50.90676400239416,
    ],
    '053820044044': [
      6.982251987791392, 50.767853871710834, 7.100675564246283, 50.84914858920766,
    ],
    '053820048048': [
      6.886040890210261, 50.55560309226694, 7.018918052136913, 50.67334600493438,
    ],
    '053820052052': [
      7.337817589178686, 50.777711959446926, 7.528815851494287, 50.877691281877006,
    ],
    '053820056056': [
      7.125469607274862, 50.73953679566852, 7.242500016293612, 50.80141395719948,
    ],
    '053820060060': [
      7.174917178526918, 50.78073899245867, 7.309531143960871, 50.82806317574909,
    ],
    '053820064064': [
      6.856049045612559, 50.635449663437775, 6.996749427413803, 50.734030015232804,
    ],
    '053820068068': [
      7.076840584253698, 50.761595984653134, 7.213540475575728, 50.87507252800835,
    ],
    '053820072072': [
      7.03996896302274, 50.585829628022466, 7.19542780685804, 50.65950868145189,
    ],
    '053820076076': [
      7.472848666370592, 50.73971679437214, 7.682048948491643, 50.84252904309255,
    ],
    '055120000000': [
      6.83162714080117, 51.497839731300864, 6.997392994287458, 51.644568127274674,
    ],
    '055130000000': [
      6.993065955283146, 51.48127817884516, 7.145285396838137, 51.63138594152854,
    ],
    '055150000000': [
      7.475957172948689, 51.83994206540846, 7.773956751720315, 52.05988009566392,
    ],
    '055540004004': [
      6.867322785425894, 52.0212410872032, 7.067125395159137, 52.18107761851745,
    ],
    '055540008008': [
      6.470891408581955, 51.79059703630552, 6.721329679701233, 51.91577497528591,
    ],
    '055540012012': [
      6.732341002919707, 51.77388037252301, 6.921614317813913, 51.93248514881944,
    ],
    '055540016016': [
      6.92791513517152, 51.88488797237771, 7.090428800842335, 52.006621624520776,
    ],
    '055540020020': [
      6.951167319355327, 52.13446956143846, 7.099494894340572, 52.242977072995664,
    ],
    '055540024024': [
      7.012821341378685, 52.07996896979849, 7.175304214561663, 52.19662275894506,
    ],
    '055540028028': [
      6.889959722581403, 51.77188871393896, 7.023581215716763, 51.871409935862225,
    ],
    '055540032032': [
      6.390280681457734, 51.80303053639351, 6.532273932143613, 51.874057213632064,
    ],
    '055540036036': [
      7.039115996557284, 52.00601718162479, 7.185094267841435, 52.09029009371418,
    ],
    '055540040040': [
      6.757998994652421, 51.72890592740617, 6.916541758482035, 51.802845121928804,
    ],
    '055540044044': [
      6.980498853819472, 51.77750450120263, 7.172998774221599, 51.88855229551029,
    ],
    '055540048048': [
      6.643877239285967, 51.76910899589057, 6.765747857657431, 51.90584061014043,
    ],
    '055540052052': [
      7.105195819616767, 52.04322283314459, 7.274475062984296, 52.12830751139647,
    ],
    '055540056056': [
      6.827980370146964, 51.96201860844593, 7.048578048944364, 52.044634277370804,
    ],
    '055540060060': [
      6.753890630517743, 51.91101539801848, 6.930875990459241, 51.99372019443078,
    ],
    '055540064064': [
      6.8795208388699, 51.850936046455374, 7.047301510095641, 51.94153047825295,
    ],
    '055540068068': [
      6.686646867072085, 51.99372019443078, 6.91091495386856, 52.12775574728582,
    ],
    '055580004004': [
      7.54973329414773, 51.70694080753376, 7.735395737953841, 51.84462963895478,
    ],
    '055580008008': [
      7.211223614404819, 51.937377151783316, 7.432756757549185, 52.03989776688772,
    ],
    '055580012012': [
      7.057026247378849, 51.84552086826213, 7.26179542051084, 51.98786101096936,
    ],
    '055580016016': [
      7.099791011526976, 51.779005825458256, 7.433544162405202, 51.92639930838325,
    ],
    '055580020020': [
      7.365566066338001, 51.93181789095327, 7.521407165974271, 52.00960638957792,
    ],
    '055580024024': [
      7.257934055390546, 51.7219602067237, 7.5366914150521, 51.8315492171561,
    ],
    '055580028028': [
      7.477045539763719, 51.68637965448532, 7.627844427340224, 51.77575738962326,
    ],
    '055580032032': [
      7.255593766500533, 51.877086807927505, 7.462295188002171, 51.97062316707418,
    ],
    '055580036036': [
      7.298469141291105, 51.66460524444376, 7.451444332462506, 51.74244803566915,
    ],
    '055580040040': [
      7.048578048944364, 51.97416785553442, 7.332721711622024, 52.06178139376141,
    ],
    '055580044044': [
      7.419963834886013, 51.77189843836803, 7.598964616345282, 51.9397020931472,
    ],
    '055620004004': [
      7.240706229801835, 51.522045518394954, 7.373423432028517, 51.627102769797695,
    ],
    '055620008008': [
      7.24132355004298, 51.61369302236385, 7.422134115916358, 51.720606796083175,
    ],
    '055620012012': [
      6.894130472572601, 51.6225223414746, 7.089034070080817, 51.80021539906943,
    ],
    '055620014014': [
      6.920459110224655, 51.5331081938082, 7.031939844554074, 51.62410649547889,
    ],
    '055620016016': [
      7.046999841106455, 51.6958869444009, 7.32264442999478, 51.82119439727364,
    ],
    '055620020020': [
      7.067376495105327, 51.551205724023156, 7.179535981336609, 51.63337757273747,
    ],
    '055620024024': [
      7.022066003354975, 51.61486031187872, 7.2017821913478, 51.72025325177025,
    ],
    '055620028028': [
      7.190300361133468, 51.62417473090352, 7.297065109318552, 51.70297631070208,
    ],
    '055620032032': [
      7.134351022524802, 51.55289021626056, 7.293141470607168, 51.65111798872297,
    ],
    '055620036036': [
      7.320570346117995, 51.58702449782344, 7.464770104584709, 51.66221795291063,
    ],
    '055660004004': [
      7.402158845988985, 51.99509374659741, 7.55464782071959, 52.08943240806804,
    ],
    '055660008008': [
      7.432488053892788, 52.128937642574165, 7.630807121226198, 52.22962776210044,
    ],
    '055660012012': [
      7.523912212398323, 52.03359349679656, 7.755221858457834, 52.151990997418835,
    ],
    '055660016016': [
      7.455798140088798, 52.205001390105494, 7.681008458123967, 52.37047766291654,
    ],
    '055660020020': [
      7.542908053753495, 52.34012035997648, 7.714050508213504, 52.47362255161305,
    ],
    '055660024024': [
      7.24175571122518, 52.05710762698065, 7.354076289560307, 52.14347968448643,
    ],
    '055660028028': [
      7.60355023043443, 52.1980506795269, 7.837391694083216, 52.34611355799792,
    ],
    '055660032032': [
      7.700507755759716, 52.09415665370439, 7.850464401758328, 52.17802224570459,
    ],
    '055660036036': [
      7.290256978949831, 52.026654292538495, 7.41485493533513, 52.08973748585355,
    ],
    '055660040040': [
      7.722652541942142, 52.1160564441861, 7.928652026073532, 52.21876675135365,
    ],
    '055660044044': [
      7.837282909744781, 52.08322757889454, 8.023636677490254, 52.17975925925461,
    ],
    '055660048048': [
      7.883483159650684, 52.23308661424896, 7.990204949657881, 52.36541281095014,
    ],
    '055660052052': [
      7.136157077391251, 52.11598089015909, 7.27189540757174, 52.18423394849152,
    ],
    '055660056056': [
      7.729827092468345, 52.27758304399521, 7.818450685137198, 52.381013624274445,
    ],
    '055660060060': [
      7.325105864470705, 52.17936309254362, 7.444033931322294, 52.29305652892451,
    ],
    '055660064064': [
      7.427094483623057, 52.06341040385428, 7.549210542526458, 52.14295187221613,
    ],
    '055660068068': [
      7.099165913722853, 52.1635392520112, 7.296440760358188, 52.26683999903986,
    ],
    '055660072072': [
      7.625618707867975, 52.32315909713187, 7.780451815435007, 52.400857236406736,
    ],
    '055660076076': [
      7.36587365256662, 52.19163316591067, 7.58657095884821, 52.33892393689228,
    ],
    '055660080080': [
      7.55616389148864, 52.137015006536735, 7.712828589199238, 52.2245165676506,
    ],
    '055660084084': [
      7.26111607274876, 52.079927415762555, 7.455425693141563, 52.19377446070137,
    ],
    '055660088088': [
      7.685007027479981, 52.17625461114819, 7.926887990353542, 52.261436963733004,
    ],
    '055660092092': [
      7.794416689884447, 52.24952471999096, 7.923457990052047, 52.38047056841968,
    ],
    '055660096096': [
      7.21637720805606, 52.187245912338106, 7.385887277654235, 52.28112894283163,
    ],
    '055700004004': [
      7.788250518710042, 51.69998508274408, 7.987362225123961, 51.83158339099832,
    ],
    '055700008008': [
      7.952886032930456, 51.701521465507234, 8.137435740571163, 51.8185585581624,
    ],
    '055700012012': [
      8.06988402481849, 51.89319251777543, 8.170486769414609, 51.95690418628655,
    ],
    '055700016016': [
      7.61264538215103, 51.724162992977654, 7.816586914129512, 51.877186485795114,
    ],
    '055700020020': [
      7.878294773090784, 51.804868284117305, 8.139606312872854, 51.922951864017335,
    ],
    '055700024024': [
      7.757299948557359, 51.8726854203193, 7.918375660466793, 51.96823922391286,
    ],
    '055700028028': [
      8.083627157419297, 51.75818937820561, 8.257073293975672, 51.899461901681384,
    ],
    '055700032032': [
      7.724691659812847, 52.00144222860564, 7.919493545105951, 52.104151798401496,
    ],
    '055700036036': [
      7.980189064328481, 51.956112349568635, 8.11306981915507, 52.06859272470447,
    ],
    '055700040040': [
      7.687314813998166, 51.80174510908035, 7.889420668329469, 51.90689893100366,
    ],
    '055700044044': [
      7.703597154285657, 51.93045063097566, 7.89601361587119, 52.062978252081265,
    ],
    '055700048048': [
      8.117189930004312, 51.66074383808442, 8.319216358649188, 51.777282909124764,
    ],
    '055700052052': [
      7.857475468655179, 51.852411717067504, 8.100601848512254, 52.05062420826721,
    ],
    '057110000000': [
      8.380626698699622, 51.91541815966803, 8.663654891968905, 52.11242809890289,
    ],
    '057540004004': [
      8.19991173875451, 52.04499016032538, 8.368394334920382, 52.13385405302804,
    ],
    '057540008008': [
      8.28562176105319, 51.85695599597451, 8.50589603031812, 51.97581310064633,
    ],
    '057540012012': [
      8.24386020011614, 51.99475640462069, 8.419969778091719, 52.094516215933425,
    ],
    '057540016016': [
      8.11017759476978, 51.92627838047605, 8.331990593120493, 52.01082414915575,
    ],
    '057540020020': [
      8.151291052417436, 51.842702138030326, 8.314681765983442, 51.94981312137537,
    ],
    '057540024024': [
      8.255249577393165, 51.72290480694162, 8.368103186566014, 51.80493689966847,
    ],
    '057540028028': [
      8.199421125294311, 51.79100196619659, 8.40183119816725, 51.89580372478359,
    ],
    '057540032032': [
      8.333875809493202, 51.7168184743011, 8.53423753791546, 51.87562318099954,
    ],
    '057540036036': [
      8.557272098024637, 51.85152838739261, 8.746592051050374, 51.93004743271819,
    ],
    '057540040040': [
      8.288238985967933, 51.96770693120672, 8.460678280313195, 52.04467841713419,
    ],
    '057540044044': [
      8.448147550953838, 51.83171439859953, 8.61309167219362, 51.925708662379314,
    ],
    '057540048048': [
      8.075679638881075, 51.997827730751794, 8.260184689966977, 52.08760209508455,
    ],
    '057540052052': [
      8.352178370177596, 52.04467841713419, 8.472171745434974, 52.11543041485367,
    ],
    '057580004004': [
      8.473196642576196, 52.1645654234325, 8.635153630598728, 52.25933506889849,
    ],
    '057580008008': [
      8.498844836608692, 52.10249705736027, 8.616097248694059, 52.1714798917869,
    ],
    '057580012012': [
      8.557877964500033, 52.0599704832035, 8.75442299273916, 52.16981920238997,
    ],
    '057580016016': [
      8.591298647177716, 52.130189328784425, 8.678863231845249, 52.18229260559172,
    ],
    '057580020020': [
      8.584311794751608, 52.17375513518284, 8.683492540242506, 52.260627925449725,
    ],
    '057580024024': [
      8.66359915100011, 52.150577400212406, 8.783659951481201, 52.24876168489144,
    ],
    '057580028028': [
      8.443176625822618, 52.192549699667964, 8.562831124758507, 52.26755288902943,
    ],
    '057580032032': [
      8.408867139050768, 52.10096988758748, 8.538050449606366, 52.18591059805385,
    ],
    '057580036036': [
      8.732875032493125, 52.10298012878305, 8.928372936419754, 52.19691102245561,
    ],
    '057620004004': [
      8.9601700302759, 51.64395271490639, 9.117195820600518, 51.79724107793117,
    ],
    '057620008008': [
      9.238280171708148, 51.61183528402331, 9.443588963635314, 51.73807978130725,
    ],
    '057620012012': [
      9.126175256149459, 51.5068837516846, 9.372667716429856, 51.66320044441348,
    ],
    '057620016016': [
      9.063230522735148, 51.6282210295744, 9.286862429172261, 51.79735137735762,
    ],
    '057620020020': [
      9.249442637734782, 51.673563514681575, 9.459868448414474, 51.86483597256556,
    ],
    '057620024024': [
      9.157191980757633, 51.78057491270398, 9.30562834949966, 51.86598121907884,
    ],
    '057620028028': [
      8.99171572472698, 51.756686666144724, 9.189781512675644, 51.859163794954014,
    ],
    '057620032032': [
      8.952978247100704, 51.788190782871666, 9.179710964259055, 51.910789740038645,
    ],
    '057620036036': [
      8.904890734231065, 51.44282812400547, 9.271186415250773, 51.5781774713364,
    ],
    '057620040040': [
      8.97779220299743, 51.538395294795905, 9.204791117410398, 51.66212110731328,
    ],
    '057660004004': [
      8.683721595097522, 51.86570433771846, 8.822759757914842, 51.935567694779394,
    ],
    '057660008008': [
      8.65417916655133, 52.018825778158764, 8.856356775156357, 52.12595665548144,
    ],
    '057660012012': [
      9.038842020344815, 51.96832407032736, 9.196936371640222, 52.05055636612139,
    ],
    '057660016016': [
      8.958244148524237, 51.899112313894456, 9.195142423628974, 52.0113606065006,
    ],
    '057660020020': [
      8.764735597287197, 51.858901883563775, 8.98933883565155, 51.99813150115193,
    ],
    '057660024024': [
      8.965314184492918, 51.997875592251276, 9.107192209139727, 52.07495335291888,
    ],
    '057660028028': [
      9.019830283675672, 52.03824102683182, 9.194386194686226, 52.14818183471605,
    ],
    '057660032032': [
      8.877066478396863, 51.795128944334856, 9.092487506972827, 51.92591675390579,
    ],
    '057660036036': [
      8.866966517014315, 52.060226103477845, 9.039727435680092, 52.1942603429185,
    ],
    '057660040040': [
      8.710196107887752, 51.92131069398051, 8.876278248255549, 52.03148196731232,
    ],
    '057660044044': [
      8.806770847897985, 51.978101322673346, 8.997005778018421, 52.103398976712036,
    ],
    '057660048048': [
      8.642498564709692, 51.96946432909773, 8.732621473363377, 52.044587738099665,
    ],
    '057660052052': [
      9.18784796885693, 51.84980191871641, 9.344341234914875, 51.975889126687946,
    ],
    '057660056056': [
      8.607434327306478, 51.91579359335268, 8.730889959494016, 51.9831432985976,
    ],
    '057660060060': [
      9.083775035039992, 51.852063410923265, 9.239864791635913, 51.953579517917696,
    ],
    '057660064064': [
      8.74192780810804, 51.798441127811635, 8.91758070069654, 51.881227107710906,
    ],
    '057700004004': [
      8.720594526277686, 52.16247049480546, 8.871698276718018, 52.2763735461351,
    ],
    '057700008008': [
      8.519692014196282, 52.33304639158122, 8.72346595284858, 52.416347719980955,
    ],
    '057700012012': [
      8.694031799177903, 52.26294101409762, 8.86229250000926, 52.401332286874414,
    ],
    '057700016016': [
      8.555243941811298, 52.23249126914829, 8.744219658071161, 52.29717944808282,
    ],
    '057700020020': [
      8.533635481829347, 52.26617803861541, 8.728469915688, 52.34351847930172,
    ],
    '057700024024': [
      8.792086332398917, 52.246742405316546, 8.998389621992937, 52.3647970436056,
    ],
    '057700028028': [
      8.774892249412229, 52.31893711619196, 9.135129899780857, 52.500349079291496,
    ],
    '057700032032': [
      8.829134229284245, 52.181319198154135, 9.0747491325281, 52.27261420584778,
    ],
    '057700036036': [
      8.4446780275296, 52.25933506889849, 8.56919510415464, 52.366594564123865,
    ],
    '057700040040': [
      8.518883478895244, 52.39288381748399, 8.717746145153543, 52.53157696411929,
    ],
    '057700044044': [
      8.296934671130089, 52.35292380313423, 8.568054000833477, 52.51477916764372,
    ],
    '057740004004': [
      8.874589186335989, 51.67390495129982, 8.999963772189039, 51.802266357350085,
    ],
    '057740008008': [
      8.723938794859864, 51.75677411756331, 8.928319290728908, 51.8328472028569,
    ],
    '057740012012': [
      8.668973469812268, 51.607737883420285, 8.856775395575784, 51.6956740238739,
    ],
    '057740016016': [
      8.472055211390842, 51.46766372310479, 8.713104675917537, 51.63139219788816,
    ],
    '057740020020': [
      8.402781169727428, 51.7042836628301, 8.678406542307354, 51.84303623105129,
    ],
    '057740024024': [
      8.570747549769578, 51.79242681140764, 8.765048830950526, 51.87851141925019,
    ],
    '057740028028': [
      8.73781433956913, 51.53089954849958, 9.016825511874089, 51.70017612970034,
    ],
    '057740032032': [
      8.63576305921519, 51.65561624188551, 8.900576987378786, 51.80083798999042,
    ],
    '057740036036': [
      8.468426042048064, 51.605877098728946, 8.723655593339208, 51.730160764274466,
    ],
    '057740040040': [
      8.625279205391301, 51.448529010734596, 8.845891168917566, 51.615589160170956,
    ],
    '059110000000': [
      7.105195026113207, 51.41129525136229, 7.34951280187729, 51.53274002116423,
    ],
    '059130000000': [
      7.302543729553975, 51.416686420486016, 7.637184608232275, 51.60013457835558,
    ],
    '059140000000': [
      7.376645750686293, 51.26546123518999, 7.598713084713656, 51.41730223994289,
    ],
    '059150000000': [
      7.676429753678839, 51.578425203618636, 7.997435536637235, 51.74446058490845,
    ],
    '059160000000': [
      7.122323978601965, 51.5041791417408, 7.295814336341561, 51.57317217632943,
    ],
    '059540004004': [
      7.365752615488343, 51.21364402675505, 7.51751592177542, 51.31614539294617,
    ],
    '059540008008': [
      7.301556819926751, 51.2398597138333, 7.432142238454434, 51.331378322871736,
    ],
    '059540012012': [
      7.298940608461043, 51.30354181374049, 7.398410632090513, 51.36641064281949,
    ],
    '059540016016': [
      7.108615920170037, 51.30950624115501, 7.255614131302689, 51.425772260425866,
    ],
    '059540020020': [
      7.353557050861552, 51.39051312507063, 7.466126745311414, 51.43457929679599,
    ],
    '059540024024': [
      7.252565639885505, 51.24894499717623, 7.319997857173047, 51.31422542561268,
    ],
    '059540028028': [
      7.1755086003755, 51.29534499838286, 7.316114736932763, 51.384976079241966,
    ],
    '059540032032': [
      7.295678467027587, 51.346034964264, 7.407124078857333, 51.40947805732794,
    ],
    '059540036036': [
      7.247059332966529, 51.370178637007044, 7.423408118863852, 51.48320932011107,
    ],
    '059580004004': [
      7.86204719685141, 51.35543407285979, 8.208624018899197, 51.4910979532994,
    ],
    '059580008008': [
      8.351534070615266, 51.26248350108277, 8.451942541351405, 51.4083185556711,
    ],
    '059580012012': [
      8.461627319122357, 51.291832875336574, 8.75649348955317, 51.48448239105075,
    ],
    '059580016016': [
      8.066227120838386, 51.173400017995455, 8.296302038694058, 51.31398859715745,
    ],
    '059580020020': [
      8.509369823624349, 51.09429493181118, 8.720227895473386, 51.17647913329705,
    ],
    '059580024024': [
      8.700880118623203, 51.3720829940921, 8.969678844602438, 51.54774137322074,
    ],
    '059580028028': [
      8.58742326872481, 51.13247014717723, 8.768491037671696, 51.27671722815964,
    ],
    '059580032032': [
      8.096351575574007, 51.250603012973265, 8.373480190995163, 51.410796773993034,
    ],
    '059580036036': [
      8.414632078257387, 51.25917714971118, 8.573632626362055, 51.434161267512465,
    ],
    '059580040040': [
      8.130099033311136, 51.09278616202164, 8.488548159041045, 51.28812658242619,
    ],
    '059580044044': [
      7.901604643410887, 51.234126340955996, 8.13200165149704, 51.3934804981244,
    ],
    '059580048048': [
      8.419303133689338, 51.124225149840974, 8.607657314777292, 51.27709190208033,
    ],
    '059620004004': [
      7.631374786101727, 51.239587889958536, 7.763681380987386, 51.31719776710298,
    ],
    '059620008008': [
      7.772749821110977, 51.29101141416227, 7.934434058301743, 51.39650167219629,
    ],
    '059620012012': [
      7.417874472902856, 51.12606644796811, 7.578903511448018, 51.240563435428754,
    ],
    '059620016016': [
      7.720836749710192, 51.3135688057561, 7.854119293184494, 51.41733587322279,
    ],
    '059620020020': [
      7.691419624230853, 51.139874509120034, 7.813081051764509, 51.22887498340136,
    ],
    '059620024024': [
      7.584551967853347, 51.30337469734885, 7.742980952954304, 51.47371871753261,
    ],
    '059620028028': [
      7.495657902870863, 51.10160194335459, 7.67024638754341, 51.18931989575803,
    ],
    '059620032032': [
      7.553822834451029, 51.155883448906785, 7.717723525048165, 51.270510662106915,
    ],
    '059620036036': [
      7.597250776951057, 51.069303820525235, 7.83914264289062, 51.156394208339854,
    ],
    '059620040040': [
      7.69133941489565, 51.38911122783894, 7.894947575304431, 51.47850657014176,
    ],
    '059620044044': [
      7.577187850605102, 51.27553204274629, 7.662164890019455, 51.34710999022156,
    ],
    '059620048048': [
      7.730446363145455, 51.24762307420676, 7.922190994313251, 51.318335391454006,
    ],
    '059620052052': [
      7.765977855755308, 51.1517568666312, 7.951081917243528, 51.25911437525688,
    ],
    '059620056056': [
      7.494609823732058, 51.21990398423457, 7.633100715821518, 51.29640733151015,
    ],
    '059620060060': [
      7.6939039888019, 51.218815089326704, 7.812961372859331, 51.28855939094699,
    ],
    '059660004004': [
      7.796961795273059, 51.07353251594801, 8.003283037695587, 51.17032738834669,
    ],
    '059660008008': [
      7.704347098644782, 50.977577699143126, 7.831025599383323, 51.07892094122202,
    ],
    '059660012012': [
      7.899186241825014, 51.12836803411155, 8.120036399880387, 51.24708160148101,
    ],
    '059660016016': [
      7.935038967557642, 51.004743908986896, 8.246011618917485, 51.113795513382144,
    ],
    '059660020020': [
      7.958854498467443, 51.05730058142458, 8.241494598071482, 51.19433804183743,
    ],
    '059660024024': [
      7.803732396930478, 50.98936184103334, 7.974071390325424, 51.08820663765052,
    ],
    '059660028028': [
      7.780592259385685, 50.92484429393494, 7.943456117270057, 51.00325404778242,
    ],
    '059700004004': [
      8.222509684881272, 50.96010712721231, 8.549986676722696, 51.14791051304585,
    ],
    '059700008008': [
      8.01102064362972, 50.68592429961673, 8.167404585149084, 50.7973260041663,
    ],
    '059700012012': [
      8.188556942401254, 50.92967967456638, 8.34651461070467, 51.05158606482669,
    ],
    '059700016016': [
      7.829291267100849, 50.844713400602636, 7.958443180094992, 50.93474156791141,
    ],
    '059700020020': [
      8.010519524525813, 50.94575789795328, 8.214857984794037, 51.02498171144462,
    ],
    '059700024024': [
      7.923262097269206, 50.9252468571722, 8.063002858649545, 51.04238730636606,
    ],
    '059700028028': [
      8.239484238672846, 50.861604892192915, 8.465412537799704, 50.986673579995326,
    ],
    '059700032032': [
      8.03246025663742, 50.8340744308324, 8.282947229562563, 50.97221323439568,
    ],
    '059700036036': [
      7.964925078256727, 50.74609716223831, 8.077961215647294, 50.820123545596,
    ],
    '059700040040': [
      7.924741081488591, 50.81185953479669, 8.127564420304509, 50.949754976148164,
    ],
    '059700044044': [
      8.045108470405994, 50.78842971575835, 8.201436081409962, 50.87794051462139,
    ],
    '059740004004': [
      8.224676568536132, 51.5079155160926, 8.385162081253817, 51.59299615861539,
    ],
    '059740008008': [
      8.124416147182588, 51.51876146533585, 8.245112693038351, 51.64631682521394,
    ],
    '059740012012': [
      7.881369971800646, 51.46572463337726, 8.034650984638883, 51.53801976968734,
    ],
    '059740016016': [
      8.200753267373486, 51.57132684375071, 8.431440610393354, 51.64849043128625,
    ],
    '059740020020': [
      8.412722277663375, 51.56648208157484, 8.584533380924873, 51.68634681730713,
    ],
    '059740024024': [
      7.945647461384455, 51.613969852599766, 8.210906898747021, 51.72170555163543,
    ],
    '059740028028': [
      8.18297343301614, 51.626480718788905, 8.482675925686342, 51.729806072107905,
    ],
    '059740032032': [
      8.012503848278106, 51.42185259712545, 8.233960866196073, 51.533205592411754,
    ],
    '059740036036': [
      8.35036483726956, 51.405911398859814, 8.548715629622382, 51.59902327269397,
    ],
    '059740040040': [
      7.982887515767815, 51.52179298615009, 8.176375400854754, 51.6275183640182,
    ],
    '059740044044': [
      8.201772353756695, 51.38891508325777, 8.409927076518592, 51.52292360034871,
    ],
    '059740048048': [
      7.911137249581847, 51.563255720015576, 8.088888680503075, 51.674261707387245,
    ],
    '059740052052': [
      7.825725581738646, 51.509768363602156, 7.998390551409159, 51.59565006630477,
    ],
    '059740056056': [
      7.831362869660652, 51.458250355286914, 7.921543327181527, 51.53200303024646,
    ],
    '059780004004': [
      7.561270749627806, 51.58775986110703, 7.687762118663469, 51.66045517833603,
    ],
    '059780008008': [
      7.715440555431275, 51.56119818171925, 7.825725581738646, 51.62567757851249,
    ],
    '059780012012': [
      7.658644504632582, 51.46649268035639, 7.850135417592222, 51.529433934227164,
    ],
    '059780016016': [
      7.59672716650182, 51.45161051151626, 7.67015193097073, 51.52037536691078,
    ],
    '059780020020': [
      7.5901371359316, 51.54625553429718, 7.749949372041963, 51.61464313752756,
    ],
    '059780024024': [
      7.419049447558422, 51.57519735854954, 7.592484416629481, 51.65162566013015,
    ],
    '059780028028': [
      7.50646241915505, 51.38538538407411, 7.633850741266597, 51.4767782079216,
    ],
    '059780032032': [
      7.409099634925496, 51.64133317035706, 7.548899090488276, 51.7360164994539,
    ],
    '059780036036': [
      7.628430150139967, 51.49273946290177, 7.842869525422707, 51.578425203618636,
    ],
    '059780040040': [
      7.540552577207631, 51.62978033023513, 7.728177937506477, 51.72864295313991,
    ],
    '064110000000': [
      8.563135755223678, 49.7967979080471, 8.74804759641104, 49.9547201002162,
    ],
    '064120000000': [
      8.471728870886876, 50.015820462154565, 8.800180429706838, 50.225651513847566,
    ],
    '064130000000': [
      8.719421080880451, 50.04679651679388, 8.842953177853568, 50.136508432332974,
    ],
    '064140000000': [
      8.109617884820603, 49.99330808211186, 8.385315137558823, 50.15187219545061,
    ],
    '064310001001': [
      8.770451399041185, 49.512153748998806, 8.807141007650646, 49.574348446515195,
    ],
    '064310002002': [
      8.54804903755485, 49.653299639789765, 8.713222270701372, 49.729740404041564,
    ],
    '064310003003': [
      8.356371663469291, 49.66175343755893, 8.511087199366852, 49.716414493371275,
    ],
    '064310004004': [
      8.683424378480654, 49.53506359002618, 8.773705211274473, 49.599995088809465,
    ],
    '064310005005': [
      8.413079453659352, 49.61316860333134, 8.522318946549262, 49.67490662902245,
    ],
    '064310006006': [
      8.479389850262077, 49.64161187753213, 8.566660856464692, 49.716782476693126,
    ],
    '064310007007': [
      8.721293335919238, 49.623065120166835, 8.885244699635237, 49.684151894699845,
    ],
    '064310008008': [
      8.703429376792998, 49.514844453504345, 8.772641186327068, 49.54843818720901,
    ],
    '064310009009': [
      8.80665087194149, 49.60241380244007, 8.884057308298706, 49.65539070871436,
    ],
    '064310010010': [
      8.42590897324926, 49.695614893637504, 8.539094864450126, 49.73468761537746,
    ],
    '064310011011': [
      8.588984031682351, 49.60367116853481, 8.731217586336397, 49.68134960203337,
    ],
    '064310012012': [
      8.824754858769294, 49.42500137944574, 8.951223594836005, 49.48531757834853,
    ],
    '064310013013': [
      8.367618855090345, 49.57261177579743, 8.594056923070136, 49.67861156125132,
    ],
    '064310014014': [
      8.655726331297712, 49.68070415524037, 8.775459518333262, 49.75357720409772,
    ],
    '064310015015': [
      8.722247282632553, 49.67230600514789, 8.807409371969733, 49.73825406875341,
    ],
    '064310016016': [
      8.514060825975376, 49.60435651035207, 8.598930375324302, 49.68267158739613,
    ],
    '064310017017': [
      8.69034889717751, 49.55179664435384, 8.79949019116711, 49.62936936438582,
    ],
    '064310018018': [
      8.801872873820678, 49.394822920698154, 8.897439313664764, 49.45536463694567,
    ],
    '064310019019': [
      8.707409045984914, 49.58510350683573, 8.80733662687066, 49.66776848600387,
    ],
    '064310020020': [
      8.494135235977135, 49.519637470082834, 8.616053112341802, 49.59279363468662,
    ],
    '064310021021': [
      8.785026496329458, 49.492176471096975, 8.91050662235514, 49.613422264275194,
    ],
    '064310022022': [
      8.561816026283006, 49.71179839954903, 8.627590825796615, 49.73409386328231,
    ],
    '064320001001': [
      8.554763492569693, 49.72588427497299, 8.643728819915223, 49.765948232428684,
    ],
    '064320002002': [
      8.860738519872614, 49.910634590416414, 9.026960691545234, 50.00170346712518,
    ],
    '064320003003': [
      8.560408588890464, 49.74672158855443, 8.626552445733488, 49.77528765480122,
    ],
    '064320004004': [
      8.763407022097747, 49.88380508526946, 8.871487289692242, 49.92584902998165,
    ],
    '064320005005': [
      8.755721842416152, 49.93577128085231, 8.886292377804812, 49.96278218215283,
    ],
    '064320006006': [
      8.593786132943327, 49.94311057626473, 8.670786728944812, 49.96650101997203,
    ],
    '064320007007': [
      8.775727012407554, 49.73657171685831, 8.839746613585287, 49.78074086018633,
    ],
    '064320008008': [
      8.519881097578493, 49.82559195210244, 8.598870544903077, 49.88369179273996,
    ],
    '064320009009': [
      8.773632351410079, 49.76236615348881, 8.864223935585393, 49.809736033638686,
    ],
    '064320010010': [
      8.839620075507892, 49.81154541490096, 9.042715764631115, 49.919475836706034,
    ],
    '064320011011': [
      8.740227087270643, 49.847899345367374, 8.865382714832904, 49.90249302786807,
    ],
    '064320012012': [
      8.725333556629542, 49.89471399831674, 8.796925900961467, 49.960406711726655,
    ],
    '064320013013': [
      8.702414814137208, 49.72344652803674, 8.788577197646353, 49.78642296315172,
    ],
    '064320014014': [
      8.657332343968227, 49.77369845603967, 8.725736592968044, 49.84486268961141,
    ],
    '064320015015': [
      8.770620586514292, 49.90652044401136, 8.913734643655923, 49.943564202788366,
    ],
    '064320016016': [
      8.690844964339853, 49.77595128673336, 8.801299400341863, 49.862750300384235,
    ],
    '064320017017': [
      8.848661379749245, 49.78718614556339, 8.969351172302716, 49.867273059295705,
    ],
    '064320018018': [
      8.535889933088912, 49.76747890205921, 8.649471122145918, 49.838574648608095,
    ],
    '064320019019': [
      8.780415429637914, 49.79621413136512, 8.870255396871878, 49.856093403244344,
    ],
    '064320020020': [
      8.725211896041621, 49.846834092069784, 8.806497179350195, 49.89213956271813,
    ],
    '064320021021': [
      8.957191597252308, 49.862259468733185, 9.049735316191905, 49.95041545944392,
    ],
    '064320022022': [
      8.61729131883784, 49.72504708538749, 8.703724241880327, 49.79796837616059,
    ],
    '064320023023': [
      8.54981093581008, 49.882065722161954, 8.633063783183808, 49.956364008600744,
    ],
    '064330001001': [
      8.41361206701547, 49.76572014257023, 8.504518595716137, 49.803871899655654,
    ],
    '064330002002': [
      8.335802753838546, 49.97100592086803, 8.40245931022877, 50.00194958968092,
    ],
    '064330003003': [
      8.496491865409329, 49.871408003612046, 8.577822935027775, 49.95043489267801,
    ],
    '064330004004': [
      8.448399242360956, 49.71599066367629, 8.56275769806091, 49.786900683298406,
    ],
    '064330005005': [
      8.29015936243682, 49.94173797296864, 8.367455125389927, 50.00191119231122,
    ],
    '064330006006': [
      8.40665465869484, 49.86288272978475, 8.550518563392394, 49.96600306168867,
    ],
    '064330007007': [
      8.470180223387182, 50.026035309595, 8.558812083654711, 50.08343886237338,
    ],
    '064330008008': [
      8.504177770728994, 49.94486225022851, 8.629941544139054, 50.02456583446883,
    ],
    '064330009009': [
      8.422616915829511, 49.93019883522547, 8.527891737010108, 49.976226472394174,
    ],
    '064330010010': [
      8.425427857038587, 49.99097200304827, 8.51622532921071, 50.03700944439625,
    ],
    '064330011011': [
      8.376936519005364, 49.78568407634181, 8.548669993513936, 49.88232814005824,
    ],
    '064330012012': [
      8.360604380425173, 49.93886022398207, 8.548738239796648, 50.024078647362614,
    ],
    '064330013013': [
      8.390578347640403, 49.78405683257016, 8.505704425960445, 49.82869978981256,
    ],
    '064330014014': [
      8.344009025765319, 49.861122170989184, 8.44586254513255, 49.95634768823091,
    ],
    '064340001001': [
      8.496285385027015, 50.20131397353738, 8.712927975814482, 50.27443223968551,
    ],
    '064340002002': [
      8.568574249047947, 50.23145134800219, 8.690335684488616, 50.29053544554797,
    ],
    '064340003003': [
      8.353336681264633, 50.178248604550724, 8.4516338378783, 50.25913840906356,
    ],
    '064340004004': [
      8.390462421626241, 50.34573046861128, 8.514772031015088, 50.41591772473748,
    ],
    '064340005005': [
      8.412395674168302, 50.15964052866934, 8.514503709097138, 50.22996562782878,
    ],
    '064340006006': [
      8.475231532295924, 50.163203295036496, 8.564437330731005, 50.218441050450295,
    ],
    '064340007007': [
      8.469194243299244, 50.24542488596571, 8.556643731606117, 50.33614634418743,
    ],
    '064340008008': [
      8.4543993868358, 50.168885270693885, 8.638880732363758, 50.24542488596571,
    ],
    '064340009009': [
      8.395009042596328, 50.22739900305388, 8.496285385027015, 50.308017252920386,
    ],
    '064340010010': [
      8.551389706437556, 50.155399892906544, 8.591773554536038, 50.18654606022953,
    ],
    '064340011011': [
      8.43527852944064, 50.30447903120086, 8.609868554935705, 50.399981575702846,
    ],
    '064340012012': [
      8.52844243686243, 50.25957661138231, 8.650148059957667, 50.35460174233057,
    ],
    '064340013013': [
      8.315407704637122, 50.273892722428975, 8.465090457785992, 50.38678932675541,
    ],
    '064350001001': [
      9.298736933539844, 50.17506869396285, 9.429222358138865, 50.245330208262516,
    ],
    '064350002002': [
      9.332661936913203, 50.212268258610216, 9.50222788074008, 50.35491366740633,
    ],
    '064350003003': [
      9.241961812879676, 50.12907112145097, 9.405177482734834, 50.23912889179325,
    ],
    '064350004004': [
      9.25104933825665, 50.32220583462233, 9.378792696818737, 50.4614924879262,
    ],
    '064350005005': [
      9.239631975590278, 50.27218162391748, 9.347878611084333, 50.33221245851092,
    ],
    '064350006006': [
      8.884204717865423, 50.148464054010006, 8.980471343669501, 50.220185231657936,
    ],
    '064350007007': [
      8.954727828889206, 50.13294531565708, 9.019400972890386, 50.18803386933531,
    ],
    '064350008008': [
      9.376087389424322, 50.08523668700312, 9.53249280535572, 50.170193640565934,
    ],
    '064350009009': [
      9.071796583669407, 50.09114733061903, 9.205127110354589, 50.16329765550438,
    ],
    '064350010010': [
      9.112684716949198, 50.16329765550438, 9.270653262271809, 50.24942941195106,
    ],
    '064350011011': [
      8.942587415430474, 50.067772333552355, 9.003204701374155, 50.097446741316816,
    ],
    '064350012012': [
      9.068743559757982, 50.18224758940805, 9.261287672303608, 50.28845930052865,
    ],
    '064350013013': [
      8.9420679512832, 50.2122812851991, 9.032648943211456, 50.254579256823924,
    ],
    '064350014014': [
      8.86113215876665, 50.07574963559374, 9.028256186862004, 50.19531911165462,
    ],
    '064350015015': [
      9.057264284178013, 50.14263412801596, 9.158556858429343, 50.188109807171585,
    ],
    '064350016016': [
      9.370396747068098, 50.1267830269279, 9.522695474182362, 50.21454988805479,
    ],
    '064350017017': [
      9.006163664762447, 50.15141973631397, 9.09054909917505, 50.2144184765881,
    ],
    '064350018018': [
      9.158556858429343, 50.13912374171449, 9.271481358462102, 50.2002620209322,
    ],
    '064350019019': [
      8.782234991695734, 50.12508624459595, 8.882631048253891, 50.18517318756179,
    ],
    '064350020020': [
      8.948280480856143, 50.18223412179586, 9.01745614929165, 50.21508997395577,
    ],
    '064350021021': [
      8.831983492813777, 50.20612326874586, 8.962422199651625, 50.2810705585941,
    ],
    '064350022022': [
      8.788914424429453, 50.17007207281046, 8.832445776996554, 50.19596323367483,
    ],
    '064350023023': [
      9.001339535123165, 50.112390246908454, 9.073565885239741, 50.161787366647665,
    ],
    '064350024024': [
      9.012682396089676, 50.20312886473656, 9.07348165706485, 50.24963104260768,
    ],
    '064350025025': [
      9.449652230315735, 50.29020111044762, 9.682670146219255, 50.411803761444226,
    ],
    '064350026026': [
      8.8046170222449, 50.17824276682782, 8.887732970051816, 50.236881464417486,
    ],
    '064350027027': [
      9.553851815696728, 50.22560326936112, 9.74800294985789, 50.372107393094204,
    ],
    '064350028028': [
      9.36511521004542, 50.24803871907566, 9.557957735270014, 50.44356149197409,
    ],
    '064350029029': [
      9.193547290234768, 50.22708373138095, 9.351419306568747, 50.33201689785896,
    ],
    '064360001001': [
      8.45297685120937, 50.129623263515704, 8.517691619353723, 50.173576883330355,
    ],
    '064360002002': [
      8.320749282851967, 50.12873799636245, 8.413890304385209, 50.201710450382585,
    ],
    '064360003003': [
      8.532230093676706, 50.130633022401526, 8.599081504659706, 50.173858303833796,
    ],
    '064360004004': [
      8.375430624374125, 49.997638016319506, 8.467242339588216, 50.05997673557124,
    ],
    '064360005005': [
      8.450953137315455, 50.01953469566595, 8.519878555202748, 50.085642999579086,
    ],
    '064360006006': [
      8.330791178668287, 49.997638016319506, 8.412853335828713, 50.06051782095854,
    ],
    '064360007007': [
      8.346112680841367, 50.04572699222517, 8.471728870886876, 50.13994526421675,
    ],
    '064360008008': [
      8.376425078902608, 50.10117072205575, 8.48812114842061, 50.1878051800743,
    ],
    '064360009009': [
      8.446887277545036, 50.05997673557124, 8.49104443084743, 50.10117072205575,
    ],
    '064360010010': [
      8.475938479312235, 50.10532549307355, 8.513516386361424, 50.13744428301308,
    ],
    '064360011011': [
      8.508737666960963, 50.12834901353776, 8.563202669840903, 50.16919424040999,
    ],
    '064360012012': [
      8.503043784169373, 50.11630572560062, 8.557150120469469, 50.150597402014355,
    ],
    '064370001001': [
      8.915387675066405, 49.70329354150908, 9.083360613359257, 49.78136856886279,
    ],
    '064370003003': [
      8.839746613585287, 49.73767278140192, 8.926241362502697, 49.797893648538604,
    ],
    '064370004004': [
      8.991585776572567, 49.79084520292514, 9.088994090931902, 49.85629444133291,
    ],
    '064370005005': [
      8.897998144575746, 49.710297757537006, 8.991124497680579, 49.75421822564994,
    ],
    '064370006006': [
      8.93679000828331, 49.58579352826666, 9.073337866641792, 49.674473083078425,
    ],
    '064370007007': [
      8.797066378028205, 49.72366786886859, 8.875769908482805, 49.767889463274315,
    ],
    '064370009009': [
      8.915677882947067, 49.758517452031214, 9.025037141010943, 49.819572059288724,
    ],
    '064370010010': [
      9.004277243710904, 49.74111176932678, 9.134435375589046, 49.79950392551057,
    ],
    '064370011011': [
      8.919321325085594, 49.61844350226309, 9.149286825587954, 49.75558269646585,
    ],
    '064370012012': [
      8.862256251138076, 49.59982744984863, 8.966445839339771, 49.7044536238045,
    ],
    '064370013013': [
      8.786298355838008, 49.655452640082764, 8.927792017713012, 49.74480587168898,
    ],
    '064370016016': [
      8.880600743011854, 49.46983556917988, 9.126361153207393, 49.60974416635212,
    ],
    '064380001001': [
      8.746518456372206, 49.984488276583775, 8.826631060885582, 50.03944362343247,
    ],
    '064380002002': [
      8.635363005499801, 49.9547201002162, 8.76812279732235, 50.05354865251899,
    ],
    '064380003003': [
      8.604048340176366, 49.95100899838618, 8.703573856765638, 50.013098208060754,
    ],
    '064380004004': [
      8.905311384877361, 50.04555290292265, 8.99165002257838, 50.08993823552824,
    ],
    '064380005005': [
      8.759580879825664, 50.02674167632576, 8.863541018784181, 50.07008253158945,
    ],
    '064380006006': [
      8.604048340176366, 49.95100899838618, 8.725333556629542, 50.03007512320724,
    ],
    '064380007007': [
      8.969002325474062, 49.989431189652, 9.046685536021386, 50.0430375519911,
    ],
    '064380008008': [
      8.806762276129694, 50.07644153561091, 8.888028951308605, 50.133002928726214,
    ],
    '064380009009': [
      8.588924500986442, 50.01203506149779, 8.761861463009046, 50.062246919728594,
    ],
    '064380010010': [
      8.82552740157334, 50.050435396079386, 8.910955836931747, 50.095200084701915,
    ],
    '064380011011': [
      8.818673855349559, 49.95713117300403, 8.94488083925271, 50.07149395694899,
    ],
    '064380012012': [
      8.742219037988702, 49.946585838127504, 8.852662083983095, 50.00898431283208,
    ],
    '064380013013': [
      8.906119167178549, 49.996273734597786, 9.02354351243102, 50.06222492217969,
    ],
    '064390001001': [
      8.021377081686172, 50.2057083244754, 8.162032093592666, 50.27999333071106,
    ],
    '064390002002': [
      7.958174106854682, 50.094638763514695, 8.102058750918047, 50.178907161216735,
    ],
    '064390003003': [
      8.00272652157961, 50.005168188097464, 8.153077901482854, 50.09507157631542,
    ],
    '064390004004': [
      7.883423038109703, 49.974436752903, 7.991839187447505, 50.09723619446023,
    ],
    '064390005005': [
      7.883002148794517, 50.102776641328404, 8.0433423756769, 50.23710575049127,
    ],
    '064390006006': [
      8.017638546344399, 50.137062772870685, 8.166361640501854, 50.24561155590356,
    ],
    '064390007007': [
      8.136387383754613, 50.189760503664544, 8.252508744185942, 50.291592906059876,
    ],
    '064390008008': [
      8.204075783058316, 50.17218401183623, 8.408439896171926, 50.27871443284923,
    ],
    '064390009009': [
      8.044142460316175, 50.02821011626063, 8.106207437183834, 50.08767944397084,
    ],
    '064390010010': [
      7.774300801225483, 50.008481355689916, 7.926501960644261, 50.127159120463205,
    ],
    '064390011011': [
      8.227417212545854, 50.14611699757795, 8.370761903459842, 50.20091561997244,
    ],
    '064390012012': [
      7.913166412993186, 49.98526448208008, 8.054326580876502, 50.11235789743722,
    ],
    '064390013013': [
      7.839097562488087, 49.9724231369085, 7.946345421688861, 50.08641262908157,
    ],
    '064390014014': [
      7.958174106854682, 50.06418623983269, 8.137851587963565, 50.13275542517337,
    ],
    '064390015015': [
      8.099263005476718, 50.093807723156715, 8.24149197957022, 50.22059605555568,
    ],
    '064390016016': [
      8.296696403712055, 50.221034161364464, 8.40985999939056, 50.29548230922613,
    ],
    '064390017017': [
      8.127184577256905, 50.028289594383914, 8.17664823837437, 50.06802996856131,
    ],
    '064400001001': [
      8.899123482060807, 50.25411780033199, 9.007860954130779, 50.315385135698186,
    ],
    '064400002002': [
      8.710876953332374, 50.34206475624745, 8.795434787895495, 50.41107587921165,
    ],
    '064400003003': [
      8.701977341396217, 50.16287522547337, 8.795170391189634, 50.220675348999706,
    ],
    '064400004004': [
      9.000830204225284, 50.23198697886641, 9.225623167268944, 50.343918130224,
    ],
    '064400005005': [
      8.514140821118577, 50.36716946078592, 8.737117269614888, 50.48367920625729,
    ],
    '064400006006': [
      8.838904696457236, 50.35911309292468, 8.956389697155757, 50.41986981734181,
    ],
    '064400007007': [
      8.817087466684708, 50.28956419627636, 8.98264882221776, 50.35311685935556,
    ],
    '064400008008': [
      8.639850036927854, 50.28976837501993, 8.818630016455042, 50.36415546449092,
    ],
    '064400009009': [
      9.131944168355234, 50.36183112835348, 9.290234182186197, 50.46324487748591,
    ],
    '064400010010': [
      8.96413743112928, 50.3034589480119, 9.037449606808085, 50.34209521834296,
    ],
    '064400011011': [
      9.09356668956976, 50.37997896539024, 9.178920599462419, 50.439735383871636,
    ],
    '064400012012': [
      8.69034970287613, 50.194546987326206, 8.826885675196337, 50.26789955615969,
    ],
    '064400013013': [
      9.108698418321255, 50.32545714735115, 9.277813818860379, 50.37514846314643,
    ],
    '064400014014': [
      8.957926592085629, 50.24403616771704, 9.020271984161877, 50.2853556229329,
    ],
    '064400015015': [
      8.666699322738177, 50.431362846279576, 8.804956627467883, 50.48367920625729,
    ],
    '064400016016': [
      8.900370293259208, 50.378195444880056, 9.125919459442386, 50.49890061082805,
    ],
    '064400017017': [
      8.776962678121112, 50.236148997005834, 8.90101702972185, 50.322878296825166,
    ],
    '064400018018': [
      8.605418261358205, 50.324711402964084, 8.716870314349766, 50.404484822704276,
    ],
    '064400019019': [
      8.987433198036154, 50.315979046157715, 9.166099080544816, 50.39874817149052,
    ],
    '064400020020': [
      8.92522831850319, 50.32904833842129, 9.06033899481694, 50.38992503964355,
    ],
    '064400021021': [
      8.795434787895495, 50.32923194316686, 8.934937652753327, 50.37744672881339,
    ],
    '064400022022': [
      8.707587089521065, 50.404484822704276, 8.791213698645075, 50.44249582732586,
    ],
    '064400023023': [
      8.595648810277392, 50.23614058860321, 8.744265080790006, 50.31670573662951,
    ],
    '064400024024': [
      8.766698040679179, 50.36415546449092, 8.901111472172879, 50.44656818329958,
    ],
    '064400025025': [
      8.728226669138197, 50.25556257100213, 8.787913417308848, 50.30830533068397,
    ],
    '065310001001': [
      8.780700006124649, 50.64779379944383, 8.863225494072049, 50.7082187435953,
    ],
    '065310002002': [
      8.519287813624995, 50.60300005025764, 8.627167272735537, 50.69897042923953,
    ],
    '065310003003': [
      8.734191925915868, 50.57017137514069, 8.864511750448052, 50.64825605282825,
    ],
    '065310004004': [
      8.73961993660417, 50.53085433551232, 8.82104549617699, 50.59333176068005,
    ],
    '065310005005': [
      8.556384740449223, 50.52411134050922, 8.762201610951735, 50.635068301919176,
    ],
    '065310006006': [
      8.850193407003765, 50.555346634901284, 9.0693655064952, 50.690151750074016,
    ],
    '065310007007': [
      8.585585697999665, 50.56421028764378, 8.642089923971383, 50.61011962335014,
    ],
    '065310008008': [
      8.796638229954956, 50.42954576641817, 9.002121374723812, 50.528096811480005,
    ],
    '065310009009': [
      8.529590731926849, 50.41349520407525, 8.702881789401328, 50.515276773978336,
    ],
    '065310010010': [
      8.908088750536859, 50.48993208912147, 9.13324417336819, 50.58123453572537,
    ],
    '065310011011': [
      8.739173867331287, 50.45713159016123, 8.9267625589544, 50.55867785545148,
    ],
    '065310012012': [
      8.613194540646267, 50.503969541506606, 8.71126268248912, 50.56340404306232,
    ],
    '065310013013': [
      8.645968336756178, 50.6334149754505, 8.73110738842922, 50.703344353065894,
    ],
    '065310014014': [
      8.685596744035934, 50.47461107877746, 8.786273394164661, 50.55814204814377,
    ],
    '065310015015': [
      8.827893505593412, 50.63200175868887, 8.954704651135092, 50.70925010467344,
    ],
    '065310016016': [
      8.804704096840934, 50.54773343856934, 8.924767646679353, 50.63210470974419,
    ],
    '065310017017': [
      8.718181306425686, 50.63285346064857, 8.805387198387015, 50.6960545802221,
    ],
    '065310018018': [
      8.598423950226287, 50.59510723703612, 8.696778309364475, 50.701320787212794,
    ],
    '065320001001': [
      8.389696588295411, 50.57339174769707, 8.481124158269626, 50.667104905940604,
    ],
    '065320002002': [
      8.431280865246055, 50.687890305865785, 8.574118482756496, 50.74014413721328,
    ],
    '065320003003': [
      8.312180799789715, 50.45665344645769, 8.451482132771481, 50.54804081059139,
    ],
    '065320004004': [
      8.120413589319151, 50.65434436302147, 8.256909084360872, 50.71224738145915,
    ],
    '065320005005': [
      8.230498524475628, 50.814317995709125, 8.355744388925158, 50.88341522856111,
    ],
    '065320006006': [
      8.206017207381064, 50.707849064997205, 8.392465019722202, 50.80414848513938,
    ],
    '065320007007': [
      8.112147050393672, 50.59943346627307, 8.256618701136492, 50.678159943013355,
    ],
    '065320008008': [
      8.306358518867347, 50.58086036993813, 8.436139295704798, 50.66510764618307,
    ],
    '065320009009': [
      8.292119541960309, 50.77211531689515, 8.432913208391168, 50.85615864652495,
    ],
    '065320010010': [
      8.151574876963371, 50.55430086110324, 8.362617331370618, 50.63316745943486,
    ],
    '065320011011': [
      8.128358718521852, 50.69543531959947, 8.299579949700972, 50.850155808778496,
    ],
    '065320012012': [
      8.191613607316278, 50.62798724897966, 8.375696632699512, 50.724437762032544,
    ],
    '065320013013': [
      8.414081508524726, 50.62471470074868, 8.563090480652793, 50.70244355219159,
    ],
    '065320014014': [
      8.489415727412434, 50.469507060011004, 8.650533153898392, 50.5364920967886,
    ],
    '065320015015': [
      8.533538649375686, 50.556124019215204, 8.606245698023638, 50.62711580605508,
    ],
    '065320016016': [
      8.265081602655393, 50.52275598374197, 8.381557993586085, 50.58510866413182,
    ],
    '065320017017': [
      8.333242391675899, 50.64917491910806, 8.439977368087188, 50.724171565600464,
    ],
    '065320018018': [
      8.433709740268451, 50.45378683816309, 8.546431504473931, 50.53331695568407,
    ],
    '065320019019': [
      8.369128090365004, 50.71319149314237, 8.458935171974998, 50.796089745149175,
    ],
    '065320020020': [
      8.27105867131571, 50.6228485578387, 8.378510317521748, 50.67134804845657,
    ],
    '065320021021': [
      8.365734992552795, 50.508949366607, 8.46016618619993, 50.581645605730884,
    ],
    '065320022022': [
      8.423721092163303, 50.395760202740846, 8.57750959935653, 50.470510050947084,
    ],
    '065320023023': [
      8.44430118373231, 50.50784199504068, 8.622260509282057, 50.63336421588802,
    ],
    '065330001001': [
      8.101529023457386, 50.428336847603774, 8.213968170580667, 50.49951807609269,
    ],
    '065330002002': [
      8.11449955174607, 50.33570095107884, 8.257433958943727, 50.38723632483123,
    ],
    '065330003003': [
      8.218061487717804, 50.26559395042973, 8.363495519523779, 50.33970484003405,
    ],
    '065330004004': [
      7.978226504602632, 50.466664267240105, 8.070960893811845, 50.55693655800561,
    ],
    '065330005005': [
      8.041252183404586, 50.482804834403346, 8.080833712756085, 50.53197573993612,
    ],
    '065330006006': [
      7.961762121556744, 50.39931971411289, 8.051624537946616, 50.44525686336057,
    ],
    '065330007007': [
      7.996767455460657, 50.42358778151619, 8.149290557900915, 50.49209917273712,
    ],
    '065330008008': [
      8.069857845461344, 50.276083056506266, 8.233073215710386, 50.35761902521668,
    ],
    '065330009009': [
      7.986486621103174, 50.35682633498998, 8.155631495607704, 50.44575638941079,
    ],
    '065330010010': [
      8.20606135915145, 50.50179611082742, 8.315352395136545, 50.58566639857475,
    ],
    '065330011011': [
      8.111068522751012, 50.518991597965076, 8.239057574465823, 50.59943346627307,
    ],
    '065330012012': [
      8.158348812428011, 50.48101197983238, 8.233008165596104, 50.54330881300823,
    ],
    '065330013013': [
      8.085450040225792, 50.38723632483123, 8.242209782118069, 50.461311303366294,
    ],
    '065330014014': [
      8.198014936974339, 50.32201381753908, 8.362313437812752, 50.38345434232415,
    ],
    '065330015015': [
      8.155631495607704, 50.357803397212145, 8.29807117946797, 50.44096154766406,
    ],
    '065330016016': [
      8.070129516578312, 50.48238461624446, 8.16571805984861, 50.53874611086024,
    ],
    '065330017017': [
      8.1710507021567, 50.45296339692458, 8.371883446747214, 50.51528381467324,
    ],
    '065330018018': [
      8.291054452801099, 50.3697836061025, 8.466211988878069, 50.47665090111648,
    ],
    '065330019019': [
      8.22975814938742, 50.391664204671144, 8.34990948578806, 50.47972548661216,
    ],
    '065340001001': [
      8.867408129497523, 50.72526394308129, 8.97762716882678, 50.82087135017443,
    ],
    '065340002002': [
      8.392997113196401, 50.790594683390324, 8.470772106020199, 50.83638188631255,
    ],
    '065340003003': [
      8.434124758990203, 50.723030622729254, 8.524292720835913, 50.81548200160697,
    ],
    '065340004004': [
      8.41627006439571, 50.86401627470375, 8.635591461398436, 50.96921569146206,
    ],
    '065340005005': [
      8.35525439855956, 50.84032115884774, 8.506606892784317, 50.908301533171546,
    ],
    '065340006006': [
      8.746099341964777, 50.84233510727841, 8.875190416713492, 50.9149065144846,
    ],
    '065340007007': [
      8.480702739600172, 50.796671694223086, 8.632895540957156, 50.900885847488084,
    ],
    '065340008008': [
      8.748327728636617, 50.687875180818615, 8.917904435453451, 50.78698975610909,
    ],
    '065340009009': [
      8.644897192189111, 50.67921607910495, 8.766710561280892, 50.72411630805032,
    ],
    '065340010010': [
      8.498780196332518, 50.73008148351746, 8.650000517610302, 50.82696614305206,
    ],
    '065340011011': [
      8.82968910295229, 50.78376608495628, 9.006763880603204, 50.89370191827129,
    ],
    '065340012012': [
      8.614689687673073, 50.83349756795439, 8.791262576898571, 50.89032437742338,
    ],
    '065340013013': [
      8.540782795029797, 50.67403815004124, 8.669853574535455, 50.76301121187846,
    ],
    '065340014014': [
      8.630222047290463, 50.737937037248344, 8.858139505702495, 50.858711565448765,
    ],
    '065340015015': [
      8.601710174845515, 50.924065519784605, 8.732054356550028, 50.99595274189769,
    ],
    '065340016016': [
      9.0269152584603, 50.818557424638186, 9.149269967000771, 50.920923236101586,
    ],
    '065340017017': [
      8.806344486421377, 50.85969521670008, 9.02021980952114, 50.96406454825623,
    ],
    '065340018018': [
      8.951554959420816, 50.75212613520892, 9.095084266364214, 50.90988147372586,
    ],
    '065340019019': [
      8.392997113196401, 50.80531903931286, 8.504222520900296, 50.864242768306994,
    ],
    '065340020020': [
      8.63541988623515, 50.71686260923596, 8.774128498434562, 50.81189488289519,
    ],
    '065340021021': [
      8.592494500380505, 50.86515824939365, 8.825622118114481, 50.97763769673354,
    ],
    '065340022022': [
      8.8800977691319, 50.899535431587246, 8.974887701756792, 50.970901363105654,
    ],
    '065350001001': [
      9.171133867419698, 50.699723547960254, 9.460477815299024, 50.82429603194272,
    ],
    '065350002002': [
      9.141135026845037, 50.75960958173635, 9.241045123300589, 50.83701882580018,
    ],
    '065350003003': [
      9.105687730377154, 50.58951503082826, 9.243864764273601, 50.67715138890139,
    ],
    '065350004004': [
      9.334843230825864, 50.38574968496104, 9.474029026343391, 50.49003749309431,
    ],
    '065350005005': [
      9.007183705708055, 50.63852146213406, 9.147911882899749, 50.73028380863353,
    ],
    '065350006006': [
      9.35508797608254, 50.691198220649916, 9.506401727611395, 50.76865976132576,
    ],
    '065350007007': [
      9.246576819418584, 50.4379790611919, 9.455407091062872, 50.54132446937844,
    ],
    '065350008008': [
      9.242468577866417, 50.51220940666457, 9.498154527503004, 50.59415235485293,
    ],
    '065350009009': [
      8.906196790306513, 50.67562012137439, 9.105512088949833, 50.77158032328339,
    ],
    '065350010010': [
      9.014130525613506, 50.71447153188031, 9.187594616961933, 50.83118924099311,
    ],
    '065350011011': [
      9.28564114368157, 50.57796791737693, 9.454797803965468, 50.703769030813525,
    ],
    '065350012012': [
      9.231199636741055, 50.53498288379681, 9.352655847357404, 50.64512670065211,
    ],
    '065350013013': [
      8.943419547552878, 50.56632059589817, 9.143770965194435, 50.686915637982416,
    ],
    '065350014014': [
      9.14190223591914, 50.65868858929366, 9.270376113688883, 50.742608783758996,
    ],
    '065350015015': [
      9.451466962153898, 50.606399858909015, 9.649680124489038, 50.76588797369761,
    ],
    '065350016016': [
      9.04325765679196, 50.43603714189012, 9.271000792663644, 50.54874460995697,
    ],
    '065350017017': [
      9.236478425994362, 50.63037403508412, 9.381130545851631, 50.73769172033799,
    ],
    '065350018018': [
      9.10563528274454, 50.53498288379681, 9.260312523089882, 50.620877243157295,
    ],
    '065350019019': [
      9.416931710196627, 50.575053353857626, 9.499648782895207, 50.671494639075064,
    ],
    '066110000000': [
      9.352551302188376, 51.2629207107762, 9.568024766543873, 51.35447555967089,
    ],
    '066310001001': [
      9.46773343799489, 50.61071189298897, 9.551923483513706, 50.66339107404495,
    ],
    '066310002002': [
      9.610040854080756, 50.667386964265724, 9.770707301946349, 50.75130496872767,
    ],
    '066310003003': [
      9.764634305073816, 50.504912538599925, 9.877887895058475, 50.56992882699896,
    ],
    '066310004004': [
      9.741581981541124, 50.41630573017824, 9.854413193090844, 50.496717541550986,
    ],
    '066310005005': [
      9.946184539288689, 50.46250282027662, 10.041550181583482, 50.54933014402481,
    ],
    '066310006006': [
      9.646019012086812, 50.41323724249135, 9.790453816516115, 50.51113506917348,
    ],
    '066310007007': [
      9.708804335038499, 50.7181394344277, 9.930100956690055, 50.8114988015333,
    ],
    '066310008008': [
      9.484004073811006, 50.381332291382925, 9.623978358449286, 50.457254497401884,
    ],
    '066310009009': [
      9.565875368901503, 50.49972043436052, 9.731900069879424, 50.62866822887548,
    ],
    '066310010010': [
      9.801075647202314, 50.39747931984356, 9.998470027940392, 50.50270095109317,
    ],
    '066310011011': [
      9.479461322499654, 50.5139568218786, 9.608927408246892, 50.63096775419137,
    ],
    '066310012012': [
      9.89439556183442, 50.51671690526271, 10.062016335922847, 50.60660312125692,
    ],
    '066310013013': [
      9.767826259755623, 50.52585217114238, 9.960735017354331, 50.63010498448412,
    ],
    '066310014014': [
      9.42855245315812, 50.475722182924436, 9.575432909519483, 50.557959657502806,
    ],
    '066310015015': [
      9.62105790962296, 50.59668736898896, 9.855141269434867, 50.742851348744516,
    ],
    '066310016016': [
      9.611134503694954, 50.35616275835986, 9.759329325067664, 50.46677878049152,
    ],
    '066310017017': [
      9.699051904827066, 50.49403933820589, 9.838134927146571, 50.55605478814021,
    ],
    '066310018018': [
      9.451966394950192, 50.42751829699895, 9.699164288534586, 50.51418955126262,
    ],
    '066310019019': [
      9.792725677699485, 50.61087810285231, 9.928969936347107, 50.70818250139654,
    ],
    '066310020020': [
      9.696104709843032, 50.54388632494812, 9.794446057317398, 50.633285103736796,
    ],
    '066310021021': [
      9.820881040153417, 50.456804436493755, 9.948062089616041, 50.528965760235664,
    ],
    '066310022022': [
      9.85098517007349, 50.66956934947761, 9.940857843114436, 50.75754179135634,
    ],
    '066310023023': [
      9.949044458587322, 50.57721455072064, 10.081725173512737, 50.67644877425644,
    ],
    '066320001001': [
      9.566338677433368, 50.9812174679633, 9.753750933570602, 51.07951089716047,
    ],
    '066320002002': [
      9.612745454864822, 50.81354565535525, 9.825654751665354, 50.909609508046714,
    ],
    '066320003003': [
      9.704041657944511, 50.91552855311347, 9.919410271556114, 51.04155017624672,
    ],
    '066320004004': [
      9.433513847725576, 50.73453322248112, 9.561080732575157, 50.81450420144496,
    ],
    '066320005005': [
      9.789984682199826, 51.02280347875188, 9.886943040983322, 51.08347729358889,
    ],
    '066320006006': [
      9.807641763545966, 50.84388235387989, 9.929824724458623, 50.92184324496667,
    ],
    '066320007007': [
      9.692670074143638, 50.79396787361313, 9.771852967654926, 50.85131541827503,
    ],
    '066320008008': [
      9.604007250182718, 50.71942275515999, 9.739068076991709, 50.81097196827328,
    ],
    '066320009009': [
      9.894896914778133, 50.852357070922494, 10.05834478174325, 50.93189049528407,
    ],
    '066320010010': [
      9.887152818749326, 50.76727070200155, 9.975893951707727, 50.860706388459306,
    ],
    '066320011011': [
      9.49595443075545, 50.80928232650258, 9.626778466925954, 50.89024574096879,
    ],
    '066320012012': [
      9.545580504845002, 50.877403519611576, 9.837894421443822, 50.9949577909953,
    ],
    '066320013013': [
      9.87123700882646, 50.957205117240086, 10.00274049018126, 51.05217318227062,
    ],
    '066320014014': [
      9.48237408798773, 50.86740109811152, 9.656836129780569, 50.95380133723997,
    ],
    '066320015015': [
      9.510559207593761, 50.756088117498265, 9.708024308434357, 50.84186695271543,
    ],
    '066320016016': [
      9.897981110619199, 50.82632033583808, 10.037950035458621, 50.86838059709177,
    ],
    '066320017017': [
      9.82920974304581, 50.89823201078516, 9.931664899788489, 50.97788946740065,
    ],
    '066320018018': [
      9.656695967432865, 50.9488562567472, 9.803757585767126, 51.08301351229772,
    ],
    '066320019019': [
      9.741701676480599, 50.78990842917074, 9.910003848071055, 50.86296229189496,
    ],
    '066320020020': [
      9.900250055141404, 50.917251295019746, 10.063302543881408, 50.997114462486735,
    ],
    '066330001001': [
      9.351951962060078, 51.34808056255381, 9.443924951027046, 51.38476941161172,
    ],
    '066330002002': [
      9.398573697618426, 51.614082246284006, 9.478878758496313, 51.65505607536417,
    ],
    '066330003003': [
      9.325981310428054, 51.22104413542482, 9.483877611118658, 51.28256473919715,
    ],
    '066330004004': [
      9.141389367479567, 51.39619242951966, 9.277143515154277, 51.47017415560045,
    ],
    '066330005005': [
      9.270816646826251, 51.36628773013146, 9.445763950272587, 51.45267828598999,
    ],
    '066330006006': [
      9.20839787050167, 51.19722075473214, 9.310632899420296, 51.2870697986334,
    ],
    '066330007007': [
      9.426092391846641, 51.37825847648528, 9.503134419667646, 51.40995070291495,
    ],
    '066330008008': [
      9.461244399000721, 51.21244704114571, 9.518815880149862, 51.28263940642818,
    ],
    '066330009009': [
      9.485399426442568, 51.33745193705591, 9.60268680161212, 51.415404828817366,
    ],
    '066330010010': [
      9.330507480648244, 51.39944103555178, 9.496799052994703, 51.483929831977775,
    ],
    '066330011011': [
      9.285340634027545, 51.2976921106482, 9.382887845319582, 51.35398267400028,
    ],
    '066330012012': [
      9.628194122741583, 51.20972395265375, 9.759598233208115, 51.27168461925309,
    ],
    '066330013013': [
      9.31833887284887, 51.45684515580815, 9.550236973802285, 51.558114071042745,
    ],
    '066330014014': [
      9.444365892915734, 51.40001883119121, 9.549391131058366, 51.46730357389416,
    ],
    '066330015015': [
      9.548887783984874, 51.24627675155118, 9.671854943210397, 51.305114733956245,
    ],
    '066330016016': [
      9.217185409619928, 51.44941096353513, 9.354230042556276, 51.552727465004125,
    ],
    '066330017017': [
      9.514371484234001, 51.24472380549197, 9.597704588558924, 51.29179402745121,
    ],
    '066330018018': [
      9.12407799609613, 51.170932351787854, 9.244472726903968, 51.2870697986334,
    ],
    '066330019019': [
      9.634126825523053, 51.304472462184805, 9.688316649386602, 51.317896223213715,
    ],
    '066330020020': [
      9.53093087295763, 51.292530839547986, 9.63649342920922, 51.34150869221707,
    ],
    '066330022022': [
      9.577435033177167, 51.46067729492869, 9.64219126237588, 51.543726081675494,
    ],
    '066330023023': [
      9.250445537268943, 51.249998460427854, 9.404144413182792, 51.308069858297195,
    ],
    '066330024024': [
      9.500522386862986, 51.173998255091206, 9.644989678979192, 51.2644372311895,
    ],
    '066330025025': [
      9.320423282575197, 51.527401650188786, 9.536417635918486, 51.62708083992947,
    ],
    '066330026026': [
      9.426092391846641, 51.34386174763637, 9.501291446656003, 51.37993430527369,
    ],
    '066330028028': [
      9.094123241808703, 51.24457814049777, 9.288229602094585, 51.40797464533813,
    ],
    '066330029029': [
      9.208939497973702, 51.290250621739965, 9.353466584072065, 51.438151018732405,
    ],
    '066330030030': [
      9.509355269387614, 51.548566851739096, 9.684987656586761, 51.63917899852136,
    ],
    '066340001001': [
      9.19335235941458, 50.98721469756795, 9.36124550360189, 51.10179111865774,
    ],
    '066340002002': [
      9.336962418090517, 51.1881887759722, 9.461881724328046, 51.25483276322151,
    ],
    '066340003003': [
      9.362761731511311, 51.07449927320832, 9.537329320932537, 51.194512832361895,
    ],
    '066340004004': [
      9.250453414181127, 50.89624435186273, 9.419036750498275, 51.015128999631195,
    ],
    '066340005005': [
      9.187254499186633, 51.08407455031409, 9.365439526607412, 51.19757639434341,
    ],
    '066340006006': [
      8.974171407221931, 50.90280076660657, 9.154551334854654, 50.999623347331706,
    ],
    '066340007007': [
      9.301754859881354, 51.142491690378755, 9.428963196197705, 51.25483276322151,
    ],
    '066340008008': [
      9.453648265201302, 51.17411543591816, 9.571324871543824, 51.22310245815402,
    ],
    '066340009009': [
      9.33019191657059, 50.928727128322144, 9.487507237260832, 51.07998990561286,
    ],
    '066340010010': [
      9.056210568570712, 50.95065338533935, 9.188485423189789, 51.0278351522025,
    ],
    '066340011011': [
      9.44109010432927, 50.90978951756196, 9.58159752769855, 51.07556201281952,
    ],
    '066340012012': [
      9.48441292464838, 51.15771966425413, 9.597863480857159, 51.19374784396571,
    ],
    '066340013013': [
      9.429436931182384, 51.05181477114167, 9.578673809238225, 51.10791195605464,
    ],
    '066340014014': [
      9.502762227970731, 51.08919049730744, 9.693276603950032, 51.18513241797418,
    ],
    '066340015015': [
      9.541465842584238, 51.023782345122754, 9.694096466256648, 51.09683752973234,
    ],
    '066340016016': [
      9.173472314491761, 50.955464595494945, 9.29103557083836, 51.0427638315987,
    ],
    '066340017017': [
      9.276293999849281, 50.82552815961303, 9.424994686851228, 50.92480234419146,
    ],
    '066340018018': [
      9.265707408478239, 51.18601025766507, 9.352062087820824, 51.25465055050909,
    ],
    '066340019019': [
      9.404195786598143, 50.808353257928005, 9.514374628441354, 50.89388832629387,
    ],
    '066340020020': [
      9.314841336553075, 50.773012011661585, 9.478114033834165, 50.84751526854274,
    ],
    '066340021021': [
      9.230213213149186, 50.800671274102186, 9.338059035957752, 50.871328958493365,
    ],
    '066340022022': [
      9.10916597341728, 50.86251702315952, 9.302645976148419, 50.97402945719557,
    ],
    '066340023023': [
      9.393631450749837, 50.879938649127354, 9.492442201256681, 50.934861783410355,
    ],
    '066340024024': [
      9.583636437415642, 51.06976685328931, 9.775949556867637, 51.17186816358282,
    ],
    '066340025025': [
      9.267746940811259, 51.06011592209626, 9.427825684646821, 51.13421228324355,
    ],
    '066340026026': [
      9.142657229165433, 50.82028037037553, 9.306618422530958, 50.90726943992649,
    ],
    '066340027027': [
      9.097710563962762, 51.01880693951508, 9.214703189636603, 51.095929399074755,
    ],
    '066350001001': [
      8.503104783038232, 51.003451704852736, 8.737803588256574, 51.10183794926922,
    ],
    '066350002002': [
      8.91952293601681, 51.268287439752754, 9.127359280599299, 51.44814266526562,
    ],
    '066350003003': [
      8.95777555734564, 51.0278351522025, 9.221149966762514, 51.14494299221809,
    ],
    '066350004004': [
      8.505571688154614, 50.95486874293602, 8.713201927487818, 51.07714402211382,
    ],
    '066350006006': [
      8.70580308610597, 50.975534509397164, 8.882079115078696, 51.039348483768165,
    ],
    '066350007007': [
      8.653840195363314, 51.292832707370444, 8.937544059694003, 51.392761183194665,
    ],
    '066350008008': [
      8.890696729127678, 51.434750356232236, 9.09452383703376, 51.518359380728754,
    ],
    '066350009009': [
      8.960587401723355, 51.11130160367696, 9.20387396237399, 51.21987031362814,
    ],
    '066350010010': [
      8.837335379581654, 51.05636126245808, 8.994067931320116, 51.15731280808132,
    ],
    '066350011011': [
      8.664311472034159, 51.02105311124583, 8.926086082903453, 51.126012759734664,
    ],
    '066350012012': [
      8.87088042663807, 50.93704725259201, 9.035119198521173, 51.01816694722351,
    ],
    '066350013013': [
      8.870533007724788, 50.98818562744298, 9.098774414575908, 51.08511949708303,
    ],
    '066350014014': [
      8.473905454214453, 50.94854557102206, 8.622184228062007, 51.02505586248223,
    ],
    '066350015015': [
      8.727339712024708, 51.20898606855224, 8.965653061690126, 51.333183519456504,
    ],
    '066350016016': [
      8.692383440983935, 51.105350571689605, 8.876677468362399, 51.234246481780595,
    ],
    '066350017017': [
      8.730015627244445, 50.950662421330996, 8.918338637280351, 51.014275112704546,
    ],
    '066350018018': [
      8.863907697066395, 51.28542723368421, 9.048862008620018, 51.38354990836361,
    ],
    '066350019019': [
      8.813701488649642, 51.10748632923324, 8.995022338462787, 51.24611029060282,
    ],
    '066350020020': [
      9.029913970108199, 51.356245427815594, 9.173961748228466, 51.463795800740805,
    ],
    '066350021021': [
      8.94242518871286, 51.17480730569203, 9.12885164101132, 51.314007241742885,
    ],
    '066350022022': [
      8.556302501935685, 51.24689738863063, 8.779033582255476, 51.34342922503278,
    ],
    '066360001001': [
      9.856144994378292, 51.229022793522915, 10.0589729531211, 51.3208942248601,
    ],
    '066360002002': [
      9.85205077496289, 51.22044791037887, 9.97550215208959, 51.257369457737916,
    ],
    '066360003003': [
      9.951798278234685, 51.13016868155631, 10.130156116896442, 51.242020415171645,
    ],
    '066360004004': [
      9.729388047138867, 51.214385376262506, 9.860252057018439, 51.28041965956391,
    ],
    '066360005005': [
      10.031883578760889, 50.993377036694234, 10.215075026809625, 51.06543408592314,
    ],
    '066360006006': [
      9.626428686468726, 51.145152428421774, 9.85705398516697, 51.24397968520463,
    ],
    '066360007007': [
      9.99661300856193, 51.18500254383468, 10.149129996195127, 51.253933736613135,
    ],
    '066360008008': [
      9.840300463060554, 51.16941553094773, 9.989394525141414, 51.22848575623464,
    ],
    '066360009009': [
      9.85455272484339, 51.34798751390856, 9.928416205254228, 51.421577468814526,
    ],
    '066360010010': [
      9.98991269368061, 51.049973408389896, 10.156980687256963, 51.13125187744896,
    ],
    '066360011011': [
      9.821986186473136, 50.99310447067136, 10.059272529109592, 51.12417277184914,
    ],
    '066360012012': [
      9.775878340879917, 51.08147963034181, 9.961622994284394, 51.18851906221117,
    ],
    '066360013013': [
      10.104071951203256, 51.11252757393393, 10.235519404869814, 51.21108964140151,
    ],
    '066360014014': [
      9.911788900378161, 51.114005339272204, 10.088542265913613, 51.17836440510452,
    ],
    '066360015015': [
      10.073971338147288, 51.096316054302974, 10.178348465128124, 51.1397864611124,
    ],
    '066360016016': [
      9.703496892931808, 51.26458092877405, 9.950026918210826, 51.41245207911257,
    ],
    '071110000000': [
      7.485762201457761, 50.28007267574105, 7.690862110628698, 50.40975533291164,
    ],
    '071310007007': [
      7.057974124791578, 50.47893470537808, 7.208732770448906, 50.58243502003845,
    ],
    '071310070070': [
      7.147251355239962, 50.55574155684984, 7.278867098795554, 50.64903206664493,
    ],
    '071310077077': [
      7.155575779992899, 50.4918583565361, 7.284356710591592, 50.56531256308371,
    ],
    '071310090090': [
      6.998262640918148, 50.53852358672619, 7.169091705064995, 50.61153435831465,
    ],
    '071315001001': [
      6.907399306390822, 50.35515622577297, 7.013805363007052, 50.39860350685794,
    ],
    '071315001004': [
      6.810857319931485, 50.39329632558779, 6.842141466422825, 50.41991931636236,
    ],
    '071315001005': [
      6.770327291525719, 50.395689695236754, 6.826389396983588, 50.442553299561574,
    ],
    '071315001008': [
      6.837770731164396, 50.33486764008138, 6.892474107168884, 50.382691297084705,
    ],
    '071315001009': [
      6.853878329153114, 50.32197516708403, 6.887756135955557, 50.33486764008138,
    ],
    '071315001015': [
      6.795614618556165, 50.32651743293864, 6.841114219393037, 50.35016518846395,
    ],
    '071315001018': [
      6.769853964419899, 50.37001787712352, 6.816756305133406, 50.405166142182466,
    ],
    '071315001021': [
      6.783470609378804, 50.417394574441076, 6.850837003520741, 50.436038917603156,
    ],
    '071315001022': [
      6.837722642007565, 50.41327643453794, 6.870207150777818, 50.43222042993184,
    ],
    '071315001026': [
      6.870608095533036, 50.45369764286818, 6.909442391695708, 50.468822730878735,
    ],
    '071315001028': [
      6.955814584076901, 50.350459250269104, 7.006117624027816, 50.37971983072447,
    ],
    '071315001030': [
      6.801164207503541, 50.35863976094693, 6.837770731164396, 50.38288826956949,
    ],
    '071315001032': [
      6.886235024167163, 50.374947061028706, 6.916204731001591, 50.38993431194152,
    ],
    '071315001033': [
      6.750899187392646, 50.45284465094898, 6.858718894713111, 50.491312379803965,
    ],
    '071315001034': [
      6.886860470729061, 50.42327655153871, 6.929511654218023, 50.45369764286818,
    ],
    '071315001037': [
      6.973923735784075, 50.379940460865775, 7.046309057533218, 50.44457431081202,
    ],
    '071315001042': [
      6.890452182394542, 50.3390085905375, 6.919974187947527, 50.360724274117175,
    ],
    '071315001044': [
      6.904833297412113, 50.38993431194152, 6.991956725670106, 50.42774155503167,
    ],
    '071315001050': [
      6.951025004807469, 50.32886057991257, 6.984296288003912, 50.35291341076106,
    ],
    '071315001051': [
      6.887756135955557, 50.30644160607557, 6.951025004807469, 50.334236204436934,
    ],
    '071315001052': [
      6.812462363158364, 50.377766908619506, 6.849455181431401, 50.395689695236754,
    ],
    '071315001058': [
      6.92941083262894, 50.32901648689803, 6.966265917439138, 50.35587677813316,
    ],
    '071315001062': [
      6.743330858864347, 50.43276596141176, 6.788824929160472, 50.458055868030804,
    ],
    '071315001065': [
      6.831550211872959, 50.3261589935252, 6.868572614189204, 50.36793641419285,
    ],
    '071315001066': [
      6.918486403549363, 50.334236204436934, 6.955814584076901, 50.362467873316795,
    ],
    '071315001069': [
      6.837379666880667, 50.38268302082344, 6.928989174375652, 50.42838749810613,
    ],
    '071315001072': [
      6.837379666880667, 50.376293133265996, 6.886235024167163, 50.40937374092562,
    ],
    '071315001074': [
      6.858718894713111, 50.43619332590657, 6.909442391695708, 50.456724457314444,
    ],
    '071315001075': [
      6.814114679959142, 50.31832751402385, 6.853878329153114, 50.34208542033149,
    ],
    '071315001076': [
      6.909010691544386, 50.4483792062525, 6.929511654218023, 50.47062604429586,
    ],
    '071315001079': [
      6.797600300609723, 50.336861264484114, 6.833103381538415, 50.36238734144649,
    ],
    '071315001082': [
      6.777354042829478, 50.425084734498526, 6.868164464471117, 50.46012459381408,
    ],
    '071315001083': [
      6.868572614189204, 50.32197516708403, 6.92941083262894, 50.3463862523253,
    ],
    '071315001084': [
      6.875630226714222, 50.34907565895878, 6.928944769609454, 50.38268302082344,
    ],
    '071315001085': [
      6.859670952754645, 50.41926583464211, 6.892405712266248, 50.43706696551517,
    ],
    '071315001086': [
      6.832050992958706, 50.36764489887924, 6.868241068149942, 50.38104271689664,
    ],
    '071315001501': [
      6.900752700057276, 50.41796423000492, 6.976735743505718, 50.457960340968725,
    ],
    '071315002002': [
      6.938186764116604, 50.45584408610387, 7.019436215725567, 50.50389908025219,
    ],
    '071315002003': [
      6.941172574601366, 50.4985745867583, 7.027600458841452, 50.54387398448509,
    ],
    '071315002011': [
      6.917156081716344, 50.50886425195985, 6.99221628608928, 50.56278423671138,
    ],
    '071315002017': [
      7.027600458841452, 50.50323784361846, 7.058947101045184, 50.54310167975038,
    ],
    '071315002027': [
      7.023100885278046, 50.40419437291265, 7.116879547675229, 50.48204897875296,
    ],
    '071315002029': [
      6.920927130979531, 50.4483792062525, 6.976735743505718, 50.47939477822124,
    ],
    '071315002036': [
      6.973423472224701, 50.543370903892395, 7.006725254507375, 50.56534302158057,
    ],
    '071315002039': [
      6.969190302976788, 50.4185764276879, 7.079942390617778, 50.50323784361846,
    ],
    '071315002040': [
      6.885209390163366, 50.50232478806753, 6.923190435185059, 50.52912245755054,
    ],
    '071315002047': [
      6.901569605141145, 50.464958062182255, 6.960738037414135, 50.5114749486606,
    ],
    '071315002049': [
      7.007002731219327, 50.49988542170665, 7.031366732247526, 50.539468356503214,
    ],
    '071315002068': [
      7.019436215725567, 50.495381132667674, 7.058947101045184, 50.52070793475394,
    ],
    '071315003006': [
      7.247685657202346, 50.48178536249268, 7.320321828667682, 50.54360589074526,
    ],
    '071315003014': [
      7.282666896502542, 50.46019188514732, 7.343908241555157, 50.49628014749947,
    ],
    '071315003025': [
      7.242557631089515, 50.46776372954489, 7.286999945487867, 50.489484723740546,
    ],
    '071315003081': [
      7.203430610564245, 50.46776372954489, 7.25232797135445, 50.493067764293464,
    ],
    '071315004016': [
      7.109926210385167, 50.45885727358977, 7.205323795726122, 50.489475468329104,
    ],
    '071315004041': [
      7.138701675052246, 50.48571106482058, 7.209245536632382, 50.51178208172433,
    ],
    '071315004054': [
      7.137300492442005, 50.428665653999055, 7.195062430068631, 50.46924526910364,
    ],
    '071315004055': [
      7.178980763785052, 50.43456955244208, 7.242557631089515, 50.48571106482058,
    ],
    '071315004059': [
      7.116879547675229, 50.450783315363395, 7.181844601444872, 50.47281943570001,
    ],
    '071315004060': [
      7.173157912603907, 50.44087800128848, 7.210796905582934, 50.46431152853511,
    ],
    '071315004073': [
      7.102470532915619, 50.47115509418957, 7.161000040204423, 50.50412073733436,
    ],
    '071315004201': [
      7.14999864865073, 50.42047898950443, 7.187245706272108, 50.441902197499005,
    ],
    '071315004202': [
      7.233362241669544, 50.43986393738676, 7.298828062272735, 50.475405406243105,
    ],
    '071315004204': [
      7.181043899384895, 50.428744582463416, 7.202839759069548, 50.44624030716464,
    ],
    '071315004205': [
      7.2261561698239, 50.393472192540884, 7.287039503240854, 50.44162319778105,
    ],
    '071315004206': [
      7.038549717315559, 50.3907247404462, 7.095295897695915, 50.43735950082962,
    ],
    '071315004208': [
      7.085125124543298, 50.433224694201705, 7.16051483928435, 50.45885727358977,
    ],
    '071315004209': [
      7.248556352853797, 50.42579743546299, 7.293847733591035, 50.45104335881466,
    ],
    '071315004210': [
      7.169868856826905, 50.40438005091834, 7.246167462361408, 50.434875158537615,
    ],
    '071315004211': [
      7.091065459513123, 50.38989224279752, 7.186755801565147, 50.42047898950443,
    ],
    '071315004502': [
      7.080073685350672, 50.395808687305696, 7.169868856826905, 50.43352085871182,
    ],
    '071325003018': [
      7.913139331717751, 50.72156209838726, 8.026523973572745, 50.763717620340785,
    ],
    '071325003019': [
      7.975134317495804, 50.688403717121886, 8.027626393533474, 50.722217612201376,
    ],
    '071325003026': [
      8.00119742766506, 50.69723120179745, 8.040108597714962, 50.73423526882191,
    ],
    '071325003036': [
      7.946372000210177, 50.692338754257186, 7.99925015440989, 50.72757003161405,
    ],
    '071325003050': [
      7.911379099810612, 50.74850804805451, 7.986639788691387, 50.81470737152473,
    ],
    '071325003068': [
      7.992147779879088, 50.71050107672956, 8.019856972117257, 50.72325682758202,
    ],
    '071325003075': [
      7.898814108110813, 50.73451947300802, 7.942003063140048, 50.757178360180255,
    ],
    '071325003079': [
      7.964883447329469, 50.675917305708886, 8.005399082673335, 50.69300061984102,
    ],
    '071325003101': [
      7.898814108110813, 50.74656713784461, 7.917164505285792, 50.763910587703826,
    ],
    '071325003113': [
      7.904987372554896, 50.70861519553785, 7.955528674143891, 50.73982219065893,
    ],
    '071325006007': [
      7.605385011037074, 50.7327705286347, 7.646646562438394, 50.75474561376632,
    ],
    '071325006010': [
      7.681751256508658, 50.778772319032264, 7.708878699601035, 50.79956195183435,
    ],
    '071325006013': [
      7.643265056871878, 50.740406984700606, 7.673530734813931, 50.761498661168616,
    ],
    '071325006014': [
      7.685366877258304, 50.736306859250014, 7.737190445576018, 50.756474085722864,
    ],
    '071325006028': [
      7.6801331656088, 50.765308176837955, 7.711246033476267, 50.78324382480889,
    ],
    '071325006034': [
      7.661044568378132, 50.796504886042364, 7.699267739105164, 50.825580239528925,
    ],
    '071325006038': [
      7.66027407104523, 50.771099571814595, 7.682048948491643, 50.78618427703521,
    ],
    '071325006044': [
      7.65966072497496, 50.7549754698876, 7.696713503393306, 50.77559386650933,
    ],
    '071325006077': [
      7.592304729855975, 50.74508973549026, 7.612189494672627, 50.76721258330627,
    ],
    '071325006091': [
      7.611602079726768, 50.75108161033632, 7.660074352368365, 50.76828675635499,
    ],
    '071325006096': [
      7.687108839280496, 50.749952534291396, 7.724019809038675, 50.77282397047871,
    ],
    '071325006102': [
      7.669381217376035, 50.733925510215414, 7.702150052573724, 50.75625136341211,
    ],
    '071325007012': [
      7.915725870707796, 50.79739188011721, 7.973139021869356, 50.82845475488419,
    ],
    '071325007037': [
      7.736210236135694, 50.83811606376326, 7.850013725472951, 50.94044358263937,
    ],
    '071325007045': [
      7.810541654217487, 50.857375707803456, 7.86244275089026, 50.88314354646171,
    ],
    '071325007063': [
      7.810541654217487, 50.782992433987644, 7.942201299897825, 50.86767504223905,
    ],
    '071325007072': [
      7.918452165289255, 50.81470737152473, 7.977476896943601, 50.84662843117033,
    ],
    '071325007076': [
      7.847754731370053, 50.826575957594784, 7.919907377011435, 50.87810258938949,
    ],
    '071325008008': [
      7.70815175850626, 50.799668150674734, 7.794313110944684, 50.85008900313209,
    ],
    '071325008011': [
      7.751230569002343, 50.77055104844558, 7.8314975636094, 50.802406640444005,
    ],
    '071325008054': [
      7.748990232127435, 50.78405592664529, 7.826499658036631, 50.810514193950986,
    ],
    '071325008080': [
      7.761863600008207, 50.80480386880041, 7.833374780108838, 50.8435591216163,
    ],
    '071325008105': [
      7.753105988011963, 50.73312567132728, 7.797662763208447, 50.755980812724516,
    ],
    '071325008117': [
      7.693119326148069, 50.738618275392085, 7.833792461870734, 50.83009825784646,
    ],
    '071325009002': [
      7.867471688359269, 50.74656713784461, 7.899762719784056, 50.782992433987644,
    ],
    '071325009006': [
      7.828860785012367, 50.76245575237805, 7.891090705612443, 50.80380321629322,
    ],
    '071325009020': [
      7.845879662209774, 50.72528897629812, 7.861658756573886, 50.74377633606482,
    ],
    '071325009024': [
      7.826191143289593, 50.741226962326984, 7.845879662209774, 50.769407266730354,
    ],
    '071325009025': [
      7.859278149603842, 50.71481556531062, 7.907839793337531, 50.74656713784461,
    ],
    '071325009030': [
      7.772859975997144, 50.73161672262304, 7.797662763208447, 50.74812861775642,
    ],
    '071325009039': [
      7.788300327807293, 50.72710371489551, 7.829319832001096, 50.76612834515371,
    ],
    '071325009042': [
      7.891090705612443, 50.763105018044556, 7.921051897392807, 50.78845828074156,
    ],
    '071325009059': [
      7.85587576929089, 50.736867561214375, 7.898814108110813, 50.75405697425699,
    ],
    '071325009066': [
      7.802713897560353, 50.70594554510208, 7.839800785154043, 50.72710371489551,
    ],
    '071325009071': [
      7.839359137666627, 50.741226962326984, 7.886258379918044, 50.75877857292176,
    ],
    '071325009073': [
      7.849638318773785, 50.678498133150214, 7.892542314946456, 50.7157834065391,
    ],
    '071325009095': [
      7.836375859238034, 50.70260529779528, 7.873217353585872, 50.728208953594724,
    ],
    '071325009098': [
      7.828860785012367, 50.773300723640425, 7.855975541273316, 50.79345042229059,
    ],
    '071325009107': [
      7.811181307023065, 50.725229986916624, 7.846800191908363, 50.74364429406317,
    ],
    '071325009108': [
      7.839359137666627, 50.75305251392029, 7.875782795008674, 50.76768649011868,
    ],
    '071325009111': [
      7.820903760384576, 50.7914831823767, 7.85790958713859, 50.8112007907287,
    ],
    '071325010001': [
      7.616040324981453, 50.668769599669595, 7.639268462876046, 50.67923037482814,
    ],
    '071325010004': [
      7.639746015872539, 50.709719914933466, 7.651697736339616, 50.730627444700474,
    ],
    '071325010005': [
      7.547232096974724, 50.64750894107394, 7.592235711383053, 50.66327133384502,
    ],
    '071325010009': [
      7.567081464503314, 50.69719472007761, 7.59910297476363, 50.71462130442898,
    ],
    '071325010015': [
      7.510726435036027, 50.59824743058019, 7.543604411366942, 50.62243079643126,
    ],
    '071325010016': [
      7.489867075615196, 50.60223057629705, 7.510726435036027, 50.62861567706623,
    ],
    '071325010017': [
      7.62251277716127, 50.70734462614181, 7.642687619271599, 50.73870136285884,
    ],
    '071325010022': [
      7.67971115021867, 50.70680430850268, 7.715085549475858, 50.72619705466466,
    ],
    '071325010023': [
      7.51396193097762, 50.620982083078346, 7.550921175439389, 50.641644197905265,
    ],
    '071325010027': [
      7.504286149119317, 50.68988052493672, 7.524996847462633, 50.70145220749129,
    ],
    '071325010029': [
      7.464122710405981, 50.58937559132505, 7.484815541417382, 50.610020870493486,
    ],
    '071325010031': [
      7.477347168436925, 50.68653956114568, 7.504599926685874, 50.712370023845004,
    ],
    '071325010032': [
      7.502089783659102, 50.641403614875244, 7.548699089107124, 50.661735688519265,
    ],
    '071325010033': [
      7.615564418961802, 50.65254104215824, 7.649843870112853, 50.67408062432448,
    ],
    '071325010035': [
      7.51871058954637, 50.69730769229145, 7.548024896607068, 50.70764505546514,
    ],
    '071325010040': [
      7.639268462876046, 50.6516192682138, 7.700358082523286, 50.678716114853955,
    ],
    '071325010041': [
      7.535052962358524, 50.67262058152309, 7.559791028538203, 50.68850790649431,
    ],
    '071325010043': [
      7.514659204220239, 50.59376246257516, 7.545101959920923, 50.613726252660946,
    ],
    '071325010046': [
      7.48181765978363, 50.70586604009418, 7.543410793677886, 50.73024190244137,
    ],
    '071325010047': [
      7.593539681488817, 50.68784186125384, 7.633795496923846, 50.707101869301894,
    ],
    '071325010048': [
      7.711297356645275, 50.7291282298687, 7.74468048464237, 50.74877662345977,
    ],
    '071325010049': [
      7.561878824059943, 50.68179624342186, 7.599217756807174, 50.698791276173885,
    ],
    '071325010051': [
      7.606461778173147, 50.71348714891279, 7.629621540156123, 50.73316236292807,
    ],
    '071325010052': [
      7.63595457859999, 50.72851730126584, 7.676814374524794, 50.7419805096865,
    ],
    '071325010053': [
      7.453358380120685, 50.66893189276623, 7.49754103411023, 50.701029823073185,
    ],
    '071325010055': [
      7.501385637703994, 50.57405450424116, 7.547505229876577, 50.59824743058019,
    ],
    '071325010056': [
      7.712831867497397, 50.71611192141203, 7.734142056583035, 50.72550769970863,
    ],
    '071325010057': [
      7.686025973767293, 50.67220667712309, 7.726238679356035, 50.696775399235214,
    ],
    '071325010058': [
      7.693106815467964, 50.721585505323105, 7.723214701082279, 50.736306859250014,
    ],
    '071325010060': [
      7.479328362940594, 50.64770278620735, 7.516438653161442, 50.67507054334271,
    ],
    '071325010061': [
      7.611288209819634, 50.7005580248823, 7.635462689367285, 50.71584976850673,
    ],
    '071325010062': [
      7.439103012782301, 50.69119816939749, 7.48181765978363, 50.71992559235784,
    ],
    '071325010064': [
      7.521571798908322, 50.686186384791704, 7.561878824059943, 50.69787169634976,
    ],
    '071325010065': [
      7.484932188103589, 50.572574346586805, 7.516711583702148, 50.58646826630978,
    ],
    '071325010067': [
      7.651815881494747, 50.690289705619136, 7.698032678607786, 50.71638052836073,
    ],
    '071325010069': [
      7.497531548482292, 50.6723032250462, 7.535052962358524, 50.69147747601846,
    ],
    '071325010070': [
      7.657240971113141, 50.671953661474355, 7.700358082523286, 50.690289705619136,
    ],
    '071325010078': [
      7.495466057536782, 50.59446607094181, 7.514659204220239, 50.605449865650236,
    ],
    '071325010081': [
      7.651115005683885, 50.705111680129384, 7.67971115021867, 50.733925510215414,
    ],
    '071325010082': [
      7.546519836235681, 50.7134830350185, 7.606461778173147, 50.7433143505665,
    ],
    '071325010083': [
      7.493171220547381, 50.605449865650236, 7.529521091486911, 50.62861567706623,
    ],
    '071325010085': [
      7.472745858477548, 50.58450178989263, 7.50240366511146, 50.60223057629705,
    ],
    '071325010086': [
      7.635860261268385, 50.64531327421408, 7.678361244624839, 50.668220960639864,
    ],
    '071325010087': [
      7.589547192454409, 50.727737863265375, 7.615088154501953, 50.746833175316546,
    ],
    '071325010088': [
      7.508089856709204, 50.656767256532106, 7.541360713929449, 50.67602529441799,
    ],
    '071325010089': [
      7.464122710405981, 50.5974449205455, 7.495466057536782, 50.617408629046736,
    ],
    '071325010090': [
      7.534805753831675, 50.58892552246725, 7.558277872337825, 50.60681973130078,
    ],
    '071325010092': [
      7.676814374524794, 50.72619705466466, 7.711297356645275, 50.74066786474864,
    ],
    '071325010093': [
      7.52674280337058, 50.64753637201602, 7.566177155251959, 50.66148263574302,
    ],
    '071325010094': [
      7.481280810543545, 50.69952398179475, 7.51956267213192, 50.71992559235784,
    ],
    '071325010097': [
      7.45134052358216, 50.610020870493486, 7.524175174971646, 50.65228724954049,
    ],
    '071325010099': [
      7.591387569046573, 50.65058519636045, 7.625842255277896, 50.673274664961866,
    ],
    '071325010100': [
      7.540187768732449, 50.660263994500745, 7.561490671985311, 50.678609706182534,
    ],
    '071325010103': [
      7.547672234208852, 50.636361155191494, 7.585813696288339, 50.65139934169306,
    ],
    '071325010104': [
      7.550072657104077, 50.61383730627196, 7.575387940554675, 50.637280843899546,
    ],
    '071325010106': [
      7.677906068847398, 50.68978720970661, 7.701513791782544, 50.70680430850268,
    ],
    '071325010109': [
      7.5998653656644, 50.64613274936306, 7.627834940380509, 50.65968375301861,
    ],
    '071325010110': [
      7.671175738180321, 50.71638052836073, 7.693106815467964, 50.733925510215414,
    ],
    '071325010112': [
      7.556189398306406, 50.67341951838136, 7.575668551896519, 50.69413955452952,
    ],
    '071325010114': [
      7.519502395973158, 50.712874640257134, 7.562280813956962, 50.74652812449795,
    ],
    '071325010115': [
      7.54140659669305, 50.69413955452952, 7.571861141574241, 50.72208543156936,
    ],
    '071325010116': [
      7.516711583702148, 50.56593208537306, 7.537833762876826, 50.57925863458383,
    ],
    '071325010118': [
      7.585050681835026, 50.70234988564254, 7.611967071933156, 50.727737863265375,
    ],
    '071325010119': [
      7.519122208546659, 50.67262058152309, 7.540187768732449, 50.686186384791704,
    ],
    '071325010201': [
      7.672056513621435, 50.62288730378443, 7.703076165586422, 50.661177137017674,
    ],
    '071325010501': [
      7.599217756807174, 50.66739079088481, 7.677906068847398, 50.71011485071743,
    ],
    '071325010502': [
      7.558899941603946, 50.652381894779204, 7.604401687690593, 50.68784186125384,
    ],
    '071330006006': [
      7.790533072069902, 49.787206434788196, 7.939257506570964, 49.88220234083936,
    ],
    '071335001003': [
      7.813223108080749, 49.77096329439278, 7.870832138014687, 49.79289320873306,
    ],
    '071335001012': [
      7.929062977017248, 49.86176137885631, 7.961459588355387, 49.88112990325683,
    ],
    '071335001030': [
      7.758973839363517, 49.75694814179387, 7.819919914916297, 49.79407869593765,
    ],
    '071335001031': [
      7.864439487102795, 49.784122369266115, 7.927418011331935, 49.822268416161776,
    ],
    '071335001032': [
      7.855094679916649, 49.75631655254809, 7.933204480934937, 49.78763839388407,
    ],
    '071335001037': [
      7.883142198819142, 49.809355647973256, 7.924545153896941, 49.8385161076489,
    ],
    '071335001039': [
      7.768620051245009, 49.749891731405725, 7.796010328476367, 49.771011537716035,
    ],
    '071335001045': [
      7.796010328476367, 49.75011770986609, 7.860602876958233, 49.772328705160625,
    ],
    '071335001069': [
      7.900710587748769, 49.77775406491519, 7.932625583695293, 49.80339846896561,
    ],
    '071335001078': [
      7.929917122394993, 49.83681739410614, 7.966811881504936, 49.8626287726164,
    ],
    '071335001080': [
      7.937365596888771, 49.82362070134793, 7.963588429061193, 49.842080941683086,
    ],
    '071335001104': [
      7.895576704334232, 49.75099372364001, 7.91686893645287, 49.767542961824375,
    ],
    '071335001106': [
      7.907822181499284, 49.81140430951437, 7.943271356204667, 49.83681739410614,
    ],
    '071335006002': [
      7.657803718929415, 49.85593228506554, 7.690864924978793, 49.87638171136084,
    ],
    '071335006004': [
      7.683418866194789, 49.87109180040013, 7.716916786769491, 49.895029198183465,
    ],
    '071335006013': [
      7.645160392044608, 49.82758388566944, 7.700752504917066, 49.85979627199699,
    ],
    '071335006014': [
      7.706113535290555, 49.78534999947271, 7.730888760771719, 49.80413603006201,
    ],
    '071335006015': [
      7.707555403330155, 49.86196879388521, 7.756842297020084, 49.8829717328899,
    ],
    '071335006019': [
      7.690801871946319, 49.82955495689099, 7.722535474736349, 49.838484122012105,
    ],
    '071335006021': [
      7.712588026022502, 49.87956604927331, 7.743224063704942, 49.90059102545259,
    ],
    '071335006027': [
      7.71900096064437, 49.74497407223645, 7.768620051245009, 49.79953893271672,
    ],
    '071335006033': [
      7.642578738395124, 49.869446374693446, 7.673542760817389, 49.88581123012845,
    ],
    '071335006036': [
      7.786929242500222, 49.86791137484468, 7.82322217354237, 49.89299682066256,
    ],
    '071335006040': [
      7.819062075011925, 49.85345441504999, 7.846002522319483, 49.87315899040811,
    ],
    '071335006044': [
      7.712403199360749, 49.90001072181142, 7.775439679140708, 49.92701347377049,
    ],
    '071335006048': [
      7.759927647508404, 49.80255440721681, 7.814895454850965, 49.839148393971044,
    ],
    '071335006061': [
      7.737595344572068, 49.84368168198506, 7.804373112393059, 49.86381003121582,
    ],
    '071335006068': [
      7.666663647386153, 49.88889408520131, 7.691301504746687, 49.90445132481414,
    ],
    '071335006070': [
      7.755336058490409, 49.7870919456946, 7.798717613145978, 49.81337346027628,
    ],
    '071335006071': [
      7.788269887056768, 49.80036660126644, 7.824959051035072, 49.81597985303642,
    ],
    '071335006074': [
      7.730888760771719, 49.76715450206068, 7.768620051245009, 49.803105482962515,
    ],
    '071335006075': [
      7.680362400715087, 49.79199776834632, 7.706113535290555, 49.803643607446745,
    ],
    '071335006086': [
      7.770485235327994, 49.85232223261162, 7.82560687082765, 49.87966243093934,
    ],
    '071335006088': [
      7.756576230297594, 49.86344166372537, 7.785091320046344, 49.87367485453482,
    ],
    '071335006089': [
      7.724451206588379, 49.796077276341784, 7.761865130510223, 49.82772201616959,
    ],
    '071335006098': [
      7.72837940381588, 49.8736591753297, 7.773036348440011, 49.88491864469173,
    ],
    '071335006099': [
      7.653600755592957, 49.88511455880586, 7.72812733146488, 49.93212627488748,
    ],
    '071335006100': [
      7.617922321595993, 49.87588458378483, 7.685104928864097, 49.935295357540284,
    ],
    '071335006101': [
      7.675029100659093, 49.83112740954154, 7.74716125494456, 49.87258508210156,
    ],
    '071335006105': [
      7.803256954439653, 49.815706162322, 7.841661554520154, 49.83120243886454,
    ],
    '071335006107': [
      7.637149394681368, 49.79199776834632, 7.750173707515006, 49.838846070890995,
    ],
    '071335006109': [
      7.726308901899341, 49.87619674275122, 7.789925688159859, 49.9092266555795,
    ],
    '071335006112': [
      7.722535474736349, 49.81533582485718, 7.797470834061492, 49.85179568780338,
    ],
    '071335006115': [
      7.580793359567904, 49.86854032572246, 7.649820441975276, 49.925990413933185,
    ],
    '071335006117': [
      7.781943992672077, 49.83836783904393, 7.827168665361085, 49.85345441504999,
    ],
    '071335009008': [
      7.423485142076907, 49.73590909640189, 7.464147930694379, 49.765154769800624,
    ],
    '071335009010': [
      7.472586283531003, 49.71638771513307, 7.523413766404945, 49.75109851488269,
    ],
    '071335009016': [
      7.483650786471305, 49.818172387748405, 7.510211510800818, 49.83793094667285,
    ],
    '071335009038': [
      7.4008277021603, 49.79815464725862, 7.432895616720786, 49.82180147120203,
    ],
    '071335009041': [
      7.461136179030199, 49.74154470331499, 7.530807675228982, 49.771996737140526,
    ],
    '071335009042': [
      7.459503154785494, 49.81627141122434, 7.492115287474272, 49.833935001544496,
    ],
    '071335009043': [
      7.401094700914745, 49.80964497958487, 7.483650786471305, 49.85430815128263,
    ],
    '071335009046': [
      7.463547587827189, 49.778106592311566, 7.530403229643097, 49.82182766503797,
    ],
    '071335009047': [
      7.502226225131581, 49.81770786912596, 7.523851965043992, 49.83523773538805,
    ],
    '071335009052': [
      7.412017750627167, 49.74732768420531, 7.498662291203109, 49.803657717249365,
    ],
    '071335009059': [
      7.514971573376434, 49.70797540531558, 7.564501332534651, 49.75560403458054,
    ],
    '071335009063': [
      7.477135025501929, 49.75560403458054, 7.530807675228982, 49.78483045596506,
    ],
    '071335009073': [
      7.429026786785255, 49.7972922291355, 7.475524967979209, 49.82088253856469,
    ],
    '071335009077': [
      7.491648847944595, 49.7030554422425, 7.524701828533138, 49.72126282063265,
    ],
    '071335009096': [
      7.49785539573779, 49.80143904867808, 7.541687315326221, 49.84295503013683,
    ],
    '071335009113': [
      7.510647251628101, 49.84257284773201, 7.540915294585621, 49.87093863167973,
    ],
    '071335009201': [
      7.395481190490831, 49.82180147120203, 7.423075994404251, 49.842575740767984,
    ],
    '071335009202': [
      7.451111764908632, 49.833935001544496, 7.516537725726917, 49.861010444369604,
    ],
    '071335009203': [
      7.460226726594344, 49.85166638159813, 7.493261052150562, 49.868226896625664,
    ],
    '071335009204': [
      7.388058128936279, 49.83950431954391, 7.425698189197954, 49.85903819567394,
    ],
    '071335009205': [
      7.493261052150562, 49.84950122624611, 7.546726296170388, 49.89118100915001,
    ],
    '071335010001': [
      7.628741285240982, 49.733856358348106, 7.68420297007827, 49.759689941643195,
    ],
    '071335010005': [
      7.583030571356111, 49.821748710274534, 7.61374592023084, 49.83957340386217,
    ],
    '071335010009': [
      7.567603529697185, 49.72687708387964, 7.622417298685144, 49.75364571035735,
    ],
    '071335010011': [
      7.656149553601539, 49.63919831982079, 7.711139443342922, 49.68604253269506,
    ],
    '071335010017': [
      7.610727074118409, 49.684388642917526, 7.651884096787919, 49.70757625817339,
    ],
    '071335010020': [
      7.688962996618203, 49.69086155702417, 7.735087844589254, 49.715763861818616,
    ],
    '071335010022': [
      7.623254792702943, 49.83088325611293, 7.649040973177487, 49.852307151596996,
    ],
    '071335010024': [
      7.601943857412315, 49.70677540320776, 7.647296640701889, 49.733856358348106,
    ],
    '071335010049': [
      7.538766529086392, 49.70510351885221, 7.582343531666732, 49.73903331145194,
    ],
    '071335010050': [
      7.605827437978522, 49.86056694750783, 7.638012704890659, 49.87351598478295,
    ],
    '071335010051': [
      7.582010308990539, 49.69780688032519, 7.627013066831914, 49.733278852119355,
    ],
    '071335010053': [
      7.54933287572339, 49.73449226039423, 7.601079529112609, 49.774082248207066,
    ],
    '071335010055': [
      7.557324112167231, 49.82098262162208, 7.595492735208398, 49.83957340386217,
    ],
    '071335010057': [
      7.606748825960552, 49.733278852119355, 7.643182421139322, 49.763161999580795,
    ],
    '071335010058': [
      7.714251451785357, 49.721876215802695, 7.763508474552708, 49.748227425326235,
    ],
    '071335010060': [
      7.557838321160339, 49.67983805163665, 7.612798805349357, 49.7023580736727,
    ],
    '071335010062': [
      7.530403229643097, 49.79866679054892, 7.548903581201678, 49.80750943321511,
    ],
    '071335010064': [
      7.569508051868509, 49.749917135848705, 7.638086821313482, 49.79157005151531,
    ],
    '071335010065': [
      7.643735514880761, 49.68604253269506, 7.703659862873834, 49.73233779533675,
    ],
    '071335010066': [
      7.513478264399144, 49.75210996770526, 7.587196358801737, 49.80237399806435,
    ],
    '071335010067': [
      7.562396440443312, 49.79052704300262, 7.623254792702943, 49.83185827720112,
    ],
    '071335010072': [
      7.603528312256945, 49.786784509065704, 7.645160392044608, 49.838846070890995,
    ],
    '071335010076': [
      7.681855807928305, 49.740733995360685, 7.751271844436374, 49.78224290033349,
    ],
    '071335010081': [
      7.628741285240982, 49.71418432526421, 7.668961497904101, 49.73832264915898,
    ],
    '071335010082': [
      7.621428797259082, 49.849126398649396, 7.657803718929415, 49.86251498755012,
    ],
    '071335010083': [
      7.668869717876884, 49.71078129568588, 7.72835182448963, 49.74598191847291,
    ],
    '071335010084': [
      7.672821156945203, 49.667051953713546, 7.697735631898903, 49.706681446682225,
    ],
    '071335010090': [
      7.690971771227547, 49.665527885498705, 7.7239275986115, 49.69473920848774,
    ],
    '071335010092': [
      7.535576548828916, 49.69156690723863, 7.592200210107103, 49.717988766903844,
    ],
    '071335010094': [
      7.532651508147234, 49.826618444225275, 7.565632103565707, 49.86078626586892,
    ],
    '071335010102': [
      7.647881667431648, 49.747662913186176, 7.722568937683986, 49.7945650858894,
    ],
    '071335010111': [
      7.539748633280624, 49.79866679054892, 7.575392099940853, 49.8348390405516,
    ],
    '071335010116': [
      7.633291858094424, 49.85593228506554, 7.660162005439916, 49.87258414577202,
    ],
    '071335010501': [
      7.53596532878946, 49.75594626197401, 7.683955419235252, 49.908107762319375,
    ],
    '071335011018': [
      7.862458078585374, 49.86368420169568, 7.920434341759648, 49.89043539478516,
    ],
    '071335011023': [
      7.683301514796831, 49.955164186403415, 7.770026232641432, 50.00135633775606,
    ],
    '071335011025': [
      7.650938734403393, 49.922579828121265, 7.765935076211608, 49.956165570189334,
    ],
    '071335011026': [
      7.856409607974726, 49.91975733156681, 7.899322194535308, 49.93546009616788,
    ],
    '071335011028': [
      7.766714698534202, 49.9183073255426, 7.794741794137683, 49.93329718754133,
    ],
    '071335011035': [
      7.812905499299468, 49.868336292495904, 7.883589870585984, 49.91240093723283,
    ],
    '071335011054': [
      7.833897921509718, 49.882447062497064, 7.918551726093392, 49.92166402459355,
    ],
    '071335011056': [
      7.867216067974471, 49.90969381479946, 7.908147573939025, 49.9302398569563,
    ],
    '071335011085': [
      7.792041707149547, 49.93634027228819, 7.807909004468305, 49.95006791351272,
    ],
    '071335011087': [
      7.836089889354143, 49.92166402459355, 7.871251918226961, 49.9430656199943,
    ],
    '071335011091': [
      7.698005851576475, 49.91561342331948, 7.775439679140708, 49.94102476668051,
    ],
    '071335011093': [
      7.775439679140708, 49.912653697107686, 7.810636891372192, 49.93329718754133,
    ],
    '071335011095': [
      7.658676681378288, 49.942121235148875, 7.752571618469387, 49.98028616316709,
    ],
    '071335011103': [
      7.739526400215949, 49.926774889659825, 7.793984118112602, 49.96859295073798,
    ],
    '071335011108': [
      7.791415157459617, 49.91240093723283, 7.856409607974726, 49.93952244479202,
    ],
    '071335011110': [
      7.762811346082439, 49.947500915423426, 7.822074029324563, 49.98427285775146,
    ],
    '071335011114': [
      7.769735526922052, 49.88479416675059, 7.833897921509718, 49.9183073255426,
    ],
    '071340045045': [
      7.25307373076775, 49.649197688510455, 7.443003712173932, 49.754442323833906,
    ],
    '071345001005': [
      7.293527598555561, 49.578295337368964, 7.447195206426774, 49.66572590834604,
    ],
    '071345001007': [
      7.230486823680611, 49.58701818970544, 7.294685009262843, 49.61040153654119,
    ],
    '071345001008': [
      7.26427015001841, 49.556365015347424, 7.325261097673565, 49.58623331201681,
    ],
    '071345001021': [
      7.273565722928196, 49.549927136510924, 7.311250689855686, 49.56810984320183,
    ],
    '071345001026': [
      7.26427015001841, 49.57231399497102, 7.316251827223404, 49.607106662657706,
    ],
    '071345001027': [
      7.271999680859448, 49.65780583771664, 7.31308165361648, 49.681485774409474,
    ],
    '071345001033': [
      7.209711278954475, 49.56481499805028, 7.238999083289669, 49.58058024462205,
    ],
    '071345001036': [
      7.228578561555576, 49.59769705862919, 7.276983890895225, 49.62884344056928,
    ],
    '071345001051': [
      7.201437810549729, 49.58058024462205, 7.241349345511428, 49.60100455632363,
    ],
    '071345001054': [
      7.304821114176202, 49.56463917218394, 7.343328004001776, 49.59069080755159,
    ],
    '071345001068': [
      7.244712784648593, 49.62271661006326, 7.315728499925759, 49.660609943936656,
    ],
    '071345001073': [
      7.247327341264562, 49.57350963135953, 7.27583455969617, 49.59396726454618,
    ],
    '071345001074': [
      7.217938223723134, 49.57043412301441, 7.247914507600667, 49.590422487184654,
    ],
    '071345001075': [
      7.261352214603082, 49.604336532907695, 7.311889129708367, 49.6389092754245,
    ],
    '071345002001': [
      7.06051595724713, 49.644505031814965, 7.111631516934832, 49.67930470003222,
    ],
    '071345002002': [
      7.027931313047543, 49.61195835308401, 7.102673479548834, 49.65454321570799,
    ],
    '071345002010': [
      7.128436788271164, 49.621682749125796, 7.197897906915598, 49.66940423551266,
    ],
    '071345002011': [
      7.042801279586848, 49.67648067505337, 7.103382598629474, 49.721510888536,
    ],
    '071345002015': [
      7.044009271728328, 49.609767077944156, 7.134500820192518, 49.67648067505337,
    ],
    '071345002016': [
      7.081691529831869, 49.64377321657737, 7.143539020731892, 49.68829995493928,
    ],
    '071345002018': [
      7.113787632393626, 49.609767077944156, 7.150714145523293, 49.63369619628191,
    ],
    '071345002020': [
      7.161256881280856, 49.621682749125796, 7.219772784463365, 49.65344582693248,
    ],
    '071345002022': [
      7.174121600574058, 49.663204869031425, 7.211527498980733, 49.6776314629777,
    ],
    '071345002023': [
      7.126211611006616, 49.655297611416444, 7.157134242924056, 49.67085672971342,
    ],
    '071345002024': [
      7.103631091638829, 49.59539391542678, 7.161256881280856, 49.623779295722564,
    ],
    '071345002029': [
      7.172601143081129, 49.57609055021779, 7.217938223723134, 49.60359832177974,
    ],
    '071345002031': [
      7.147402202249472, 49.66054664790025, 7.175802693754127, 49.67973778049121,
    ],
    '071345002034': [
      7.109641108845731, 49.689692006075575, 7.176248722778896, 49.723301311275165,
    ],
    '071345002042': [
      7.16076941993526, 49.59564802995477, 7.231785162722804, 49.63348112295844,
    ],
    '071345002048': [
      7.241733876326679, 49.64884374679556, 7.273744747516673, 49.672819859310316,
    ],
    '071345002050': [
      7.165429981538008, 49.71132718134154, 7.220397778630295, 49.74161528353792,
    ],
    '071345002053': [
      7.080234742628054, 49.60047266226202, 7.113787632393626, 49.62500880238421,
    ],
    '071345002057': [
      7.216562746291321, 49.6627341917668, 7.262277477485925, 49.69624574933887,
    ],
    '071345002058': [
      7.175802693754127, 49.66147995467589, 7.236380888048388, 49.69951790479674,
    ],
    '071345002061': [
      7.209428886821525, 49.62846442439253, 7.258569465278105, 49.65603781853626,
    ],
    '071345002062': [
      7.244343718496693, 49.681485774409474, 7.289210012459466, 49.71085474550063,
    ],
    '071345002063': [
      7.109641108845731, 49.67414123715101, 7.176248722778896, 49.70416808928734,
    ],
    '071345002070': [
      7.196048824464803, 49.64837273361864, 7.245803444989208, 49.66513748183225,
    ],
    '071345002071': [
      7.081427984022723, 49.663826215724676, 7.148252301212981, 49.69767956463016,
    ],
    '071345002072': [
      7.233162573805589, 49.703472059912386, 7.273778617791385, 49.71903354078311,
    ],
    '071345002078': [
      7.18877446991456, 49.65723059203462, 7.218887762880711, 49.67083052879574,
    ],
    '071345002080': [
      7.133184967459274, 49.69654917751583, 7.203688238657104, 49.73060365162329,
    ],
    '071345002084': [
      7.185309261842622, 49.71212450519168, 7.247387685570848, 49.750180068941525,
    ],
    '071345002085': [
      7.26181706969225, 49.66896269055804, 7.288240019664202, 49.68866445970525,
    ],
    '071345002094': [
      7.191466100706607, 49.689080038976925, 7.245365223025297, 49.71345782312365,
    ],
    '071345005003': [
      7.081986761068306, 49.69691417725034, 7.198259677858278, 49.769853733049295,
    ],
    '071345005004': [
      7.243463472163222, 49.801566418372396, 7.296827703730145, 49.81766583854165,
    ],
    '071345005006': [
      7.386230785134542, 49.75190027776452, 7.443832076095079, 49.79815464725862,
    ],
    '071345005009': [
      7.36264886589484, 49.75190027776452, 7.409657938994847, 49.78213545337088,
    ],
    '071345005012': [
      7.342308288206651, 49.825376141939955, 7.373388447565796, 49.85104280624764,
    ],
    '071345005013': [
      7.308370196741195, 49.790503640729035, 7.354363656796775, 49.80980740702761,
    ],
    '071345005014': [
      7.172326355446562, 49.78346649889694, 7.238704521041826, 49.81339713620638,
    ],
    '071345005017': [
      7.355603354845671, 49.825376141939955, 7.398348912060288, 49.8663559272646,
    ],
    '071345005019': [
      7.397510753725688, 49.69825463620606, 7.435312050678209, 49.73084300737717,
    ],
    '071345005025': [
      7.361206858565759, 49.73859145294888, 7.415313717102257, 49.761027970621384,
    ],
    '071345005028': [
      7.329742222915304, 49.74199070907362, 7.361206858565759, 49.75845682914989,
    ],
    '071345005030': [
      7.308439365443233, 49.87452485953723, 7.345574045712892, 49.900980114276635,
    ],
    '071345005032': [
      7.380626546598358, 49.78867069355066, 7.423684651247423, 49.812120559064255,
    ],
    '071345005035': [
      7.35255572432596, 49.85787970811088, 7.397902316728268, 49.88783130614653,
    ],
    '071345005037': [
      7.209167815371715, 49.8121841904354, 7.286831468228151, 49.83562638117835,
    ],
    '071345005038': [
      7.268429351354146, 49.76204956148798, 7.302139241184268, 49.78082836406907,
    ],
    '071345005039': [
      7.324005462758855, 49.77215485693946, 7.36412859610014, 49.7954938192201,
    ],
    '071345005040': [
      7.210225356111217, 49.73248694584582, 7.266553111221787, 49.76551183631165,
    ],
    '071345005041': [
      7.332612303076827, 49.72423600699037, 7.37156542410902, 49.75236638836274,
    ],
    '071345005043': [
      7.221786011102242, 49.86115762726241, 7.259913647551315, 49.89416882832729,
    ],
    '071345005044': [
      7.230769055017948, 49.81225432972444, 7.328079852031645, 49.842375569805924,
    ],
    '071345005046': [
      7.216024585761368, 49.76551183631165, 7.268429351354146, 49.801566418372396,
    ],
    '071345005047': [
      7.229294680832179, 49.74457485725957, 7.269678324430973, 49.77300918412991,
    ],
    '071345005049': [
      7.249101598459744, 49.87692935749878, 7.287969784242362, 49.89938360012396,
    ],
    '071345005052': [
      7.238847509307636, 49.71085474550063, 7.275183256876162, 49.73270176343058,
    ],
    '071345005055': [
      7.418878150017871, 49.706945431818255, 7.447765785990414, 49.74171338767246,
    ],
    '071345005056': [
      7.258795183078389, 49.77532778708193, 7.325673668639681, 49.80622363236956,
    ],
    '071345005059': [
      7.337888721363329, 49.77332293722937, 7.387015993506301, 49.80563466910089,
    ],
    '071345005060': [
      7.302139241184268, 49.74795536079496, 7.372933412422179, 49.77751248343244,
    ],
    '071345005064': [
      7.30478885003011, 49.80416488987874, 7.354363656796775, 49.822913660292166,
    ],
    '071345005065': [
      7.345574045712892, 49.87223424572925, 7.397902316728268, 49.89672130359732,
    ],
    '071345005066': [
      7.415579606788093, 49.676221424415594, 7.48109391630082, 49.72146606550181,
    ],
    '071345005067': [
      7.299499230325718, 49.76738702637294, 7.330431693086214, 49.783553674680554,
    ],
    '071345005069': [
      7.299025556499295, 49.83819378549474, 7.368842645575626, 49.88200495823627,
    ],
    '071345005076': [
      7.189824677486138, 49.79692640036772, 7.258795183078389, 49.826498081266976,
    ],
    '071345005077': [
      7.441088626406043, 49.7030554422425, 7.493787740518992, 49.747937229256195,
    ],
    '071345005079': [
      7.338146549631399, 49.88200495823627, 7.376830433888914, 49.89986283316054,
    ],
    '071345005081': [
      7.182375195257873, 49.749980942089294, 7.233970467281571, 49.78428700435723,
    ],
    '071345005082': [
      7.478906265105587, 49.67598413094758, 7.524701828533138, 49.70797540531558,
    ],
    '071345005083': [
      7.432483751943506, 49.66678186970645, 7.491648847944595, 49.70815914694638,
    ],
    '071345005086': [
      7.373388447565796, 49.80563466910089, 7.401094700914745, 49.830497334937874,
    ],
    '071345005087': [
      7.230769055017948, 49.83562638117835, 7.314236421232446, 49.86755383206502,
    ],
    '071345005088': [
      7.303625303778823, 49.82229574740307, 7.361589096138482, 49.85104280624764,
    ],
    '071345005089': [
      7.255402885519509, 49.745712500206004, 7.316005035171669, 49.78082836406907,
    ],
    '071345005090': [
      7.281582698586368, 49.73541131624101, 7.316664667016081, 49.74795536079496,
    ],
    '071345005091': [
      7.288745000226093, 49.79466279726758, 7.312281652129322, 49.81428563641144,
    ],
    '071345005092': [
      7.255911056096527, 49.854994992271884, 7.329983931197213, 49.882906204734155,
    ],
    '071345005093': [
      7.336028169511207, 49.80240092871893, 7.381423049935951, 49.825615924918395,
    ],
    '071345005095': [
      7.127455621156045, 49.750180068941525, 7.198259677858278, 49.789001022884854,
    ],
    '071345005502': [
      7.149611495878649, 49.77455363478938, 7.190533988870068, 49.803281453690005,
    ],
    '071355001007': [
      7.227848361357188, 50.08870323773582, 7.254824739945043, 50.10800087966313,
    ],
    '071355001012': [
      7.068567699505817, 50.08691821498247, 7.134635868923241, 50.113361705620505,
    ],
    '071355001015': [
      7.189572613533709, 50.09193429448977, 7.24066615595147, 50.11794899507743,
    ],
    '071355001017': [
      7.220891218216829, 50.10756174722376, 7.291475481140237, 50.165218226245806,
    ],
    '071355001020': [
      7.108421195228674, 50.118697670863796, 7.211403507726373, 50.18056131018483,
    ],
    '071355001021': [
      7.102872162111072, 50.11510755010067, 7.141284168446974, 50.136919387198404,
    ],
    '071355001024': [
      7.080064156920002, 50.06718624658473, 7.190574504155078, 50.12662410160048,
    ],
    '071355001025': [
      7.189572613533709, 50.09987190464066, 7.276711193418774, 50.129227423004465,
    ],
    '071355001027': [
      7.196454596630177, 50.12294917227072, 7.23656778859085, 50.14497833654207,
    ],
    '071355001029': [
      7.091697009401339, 50.13174597188215, 7.138309513043414, 50.17457927678884,
    ],
    '071355001036': [
      7.098498312187505, 50.15995291906028, 7.161628518310194, 50.20406282142998,
    ],
    '071355001049': [
      7.145557648573864, 50.15106630477054, 7.229553065274842, 50.19268306388339,
    ],
    '071355001053': [
      7.303374816248468, 50.12537552929961, 7.377578744162396, 50.15584726514979,
    ],
    '071355001056': [
      7.337488405242802, 50.14453781233548, 7.381940342816124, 50.174042588667234,
    ],
    '071355001060': [
      7.189572613533709, 50.088949214534395, 7.227848361357188, 50.10836775468876,
    ],
    '071355001065': [
      7.349761141270254, 50.182123466978254, 7.384728091749233, 50.217946017096615,
    ],
    '071355001066': [
      7.313736662784295, 50.168013389528795, 7.375794599430041, 50.19966921313843,
    ],
    '071355001069': [
      7.176206247407136, 50.076137661884495, 7.201828954747209, 50.09192762876463,
    ],
    '071355001072': [
      7.228596293509299, 50.162793204617245, 7.296227592067323, 50.192516883184645,
    ],
    '071355001079': [
      7.173521218173619, 50.05485109337204, 7.248359413008005, 50.10836775468876,
    ],
    '071355001082': [
      7.25038044633498, 50.1193283794265, 7.350394562617669, 50.20681594905538,
    ],
    '071355001086': [
      7.192091096262682, 50.14146518317628, 7.25038044633498, 50.165218226245806,
    ],
    '071355001090': [
      7.189895492796833, 50.18714309708371, 7.226602991601235, 50.214467003743025,
    ],
    '071355002009': [
      7.215508583167575, 50.192516883184645, 7.282567667199684, 50.21502059206032,
    ],
    '071355002011': [
      7.209749154518014, 50.219449327205695, 7.242157025535059, 50.23730418020384,
    ],
    '071355002014': [
      7.245902126679336, 50.17452450721432, 7.282567667199684, 50.19719029735381,
    ],
    '071355002016': [
      7.262483818762448, 50.192516883184645, 7.297623099670402, 50.23182423674025,
    ],
    '071355002022': [
      7.20906561829599, 50.20509691376028, 7.242157025535059, 50.231152946037064,
    ],
    '071355002023': [
      7.138797497566228, 50.24805121270598, 7.191406177717857, 50.28076163074892,
    ],
    '071355002026': [
      7.056564474121358, 50.238889231281235, 7.091978222510769, 50.257606154593155,
    ],
    '071355002028': [
      7.153442886596629, 50.233982528073405, 7.186167857183886, 50.250002239260915,
    ],
    '071355002031': [
      7.237856213652498, 50.214269511453885, 7.270500580347393, 50.23482407629248,
    ],
    '071355002033': [
      7.181440630262676, 50.23279061513635, 7.217331610920465, 50.2619088239702,
    ],
    '071355002038': [
      7.151461071296694, 50.21266546606221, 7.192853586967553, 50.23489267222941,
    ],
    '071355002040': [
      7.085753269869344, 50.24415195201285, 7.119387526809072, 50.270500603218196,
    ],
    '071355002042': [
      7.144003330059332, 50.18280381843951, 7.196672999426247, 50.218241540742206,
    ],
    '071355002043': [
      7.206642361596311, 50.23484215681025, 7.24669029607161, 50.26111353882319,
    ],
    '071355002044': [
      7.215330074105977, 50.172643468549346, 7.255775608222564, 50.19902680483303,
    ],
    '071355002045': [
      7.104655787936814, 50.216354452477, 7.176572804694732, 50.25036260491479,
    ],
    '071355002046': [
      7.061728244876368, 50.25019955285897, 7.113961913568221, 50.27977114981438,
    ],
    '071355002051': [
      7.089977399334016, 50.18280381843951, 7.177386492292794, 50.218241540742206,
    ],
    '071355002052': [
      7.047913384738528, 50.214961827302545, 7.0913986333207, 50.23995075341234,
    ],
    '071355002058': [
      7.076440106412857, 50.216354452477, 7.133402930497155, 50.2509084999972,
    ],
    '071355002062': [
      7.2740406597828, 50.204448919408186, 7.319818874895241, 50.23582252120094,
    ],
    '071355002067': [
      7.05006064684322, 50.20369101326587, 7.077784513760439, 50.23050812513974,
    ],
    '071355002075': [
      7.234137254016525, 50.228994895874536, 7.292225656218058, 50.25385968209497,
    ],
    '071355002084': [
      7.111901848785604, 50.24860102958179, 7.151678581131271, 50.27777626591364,
    ],
    '071355002093': [
      7.182215716468526, 50.21223025224233, 7.214299372857004, 50.23489267222941,
    ],
    '071355002502': [
      7.075433211659149, 50.20058963231405, 7.104655787936814, 50.22304014658929,
    ],
    '071355003002': [
      7.011916055022789, 50.158984125970605, 7.077784513760439, 50.2047006781903,
    ],
    '071355003005': [
      6.982232030348717, 50.168833294725346, 7.027525944481368, 50.20387395625419,
    ],
    '071355003008': [
      7.036987347673874, 50.06505854009901, 7.098063347590639, 50.104662286456914,
    ],
    '071355003018': [
      7.052995820537642, 50.158984125970605, 7.117302457027813, 50.2047006781903,
    ],
    '071355003030': [
      6.969302806718177, 50.16245286104435, 6.999154808212259, 50.18439277130668,
    ],
    '071355003034': [
      7.035109106492916, 50.13875481937277, 7.102590418569965, 50.16590128970608,
    ],
    '071355003035': [
      6.993626941842591, 50.14215683154351, 7.040212955767514, 50.16016380853226,
    ],
    '071355003048': [
      7.02888095426621, 50.08574894637269, 7.080064156920002, 50.11419460854088,
    ],
    '071355003057': [
      6.979908617494964, 50.08278454756338, 7.05410582909077, 50.15385493484448,
    ],
    '071355003078': [
      6.991231813110812, 50.15949909223794, 7.040212955767514, 50.17266181870705,
    ],
    '071355003083': [
      6.953813128349895, 50.176824421626996, 7.060205838227308, 50.237705219943166,
    ],
    '071355003085': [
      7.03582688109148, 50.113361705620505, 7.106146419761125, 50.13120388144926,
    ],
    '071355003087': [
      6.97084375429128, 50.136962257634444, 6.994058552487036, 50.15252118896113,
    ],
    '071355003089': [
      7.049441232915767, 50.12460452142781, 7.104748578140649, 50.14986483214448,
    ],
    '071355003091': [
      6.955892796804206, 50.14647101476218, 7.002903711408897, 50.16618552139454,
    ],
    '071355003501': [
      7.002698891532845, 50.064019999343365, 7.057959631877694, 50.10656435318216,
    ],
    '071355005001': [
      7.08254221535206, 50.04704302837765, 7.130126640734701, 50.07718665581098,
    ],
    '071355005003': [
      7.245529455433922, 49.97030431939022, 7.287554448992612, 49.994919938390105,
    ],
    '071355005004': [
      7.276711193418774, 50.06661433937849, 7.319368778486619, 50.1193283794265,
    ],
    '071355005010': [
      7.282728864666289, 50.02856064954561, 7.328754028326922, 50.04958355402743,
    ],
    '071355005013': [
      7.127855686471891, 49.95919842940769, 7.261349134142137, 50.04094782785473,
    ],
    '071355005019': [
      7.128566549117392, 50.04425166429882, 7.163127042219927, 50.06922763525393,
    ],
    '071355005032': [
      7.308260689868903, 50.06661433937849, 7.339584927551745, 50.09502468568597,
    ],
    '071355005037': [
      7.208807384099428, 50.036301531971375, 7.258279539138994, 50.08111020893637,
    ],
    '071355005039': [
      7.309780707151992, 50.023854830239564, 7.349570807998461, 50.04958355402743,
    ],
    '071355005041': [
      7.265576838796679, 50.03419104645901, 7.296101117622238, 50.05241925555642,
    ],
    '071355005054': [
      7.246119112596435, 50.059773632871185, 7.285437771325142, 50.09987190464066,
    ],
    '071355005061': [
      7.252101168434705, 50.04665185724396, 7.315357644168056, 50.10756174722376,
    ],
    '071355005064': [
      7.22750727252002, 50.039666643990834, 7.272859375824568, 50.07333557621592,
    ],
    '071355005068': [
      7.127944019792606, 50.06603405660499, 7.173521218173619, 50.099161931197834,
    ],
    '071355005070': [
      7.28758561755168, 50.01198840643801, 7.335617982901118, 50.029505853494015,
    ],
    '071355005071': [
      7.252515505782652, 49.9908961664859, 7.354053230441919, 50.02520336186829,
    ],
    '071355005073': [
      7.101321990305786, 50.024970258235996, 7.144917230117243, 50.05031619359318,
    ],
    '071355005074': [
      7.296101117622238, 50.04665185724396, 7.328754028326922, 50.06661433937849,
    ],
    '071355005076': [
      7.08254221535206, 50.06355378118341, 7.134635868923241, 50.08814360633379,
    ],
    '071355005077': [
      7.251376857856441, 50.00983298448012, 7.277080285748709, 50.04122655331366,
    ],
    '071355005080': [
      7.315357644168056, 50.061416119621164, 7.347798473594806, 50.09194509666887,
    ],
    '071355005081': [
      7.242327799213713, 50.02047922659669, 7.262898779246373, 50.036301531971375,
    ],
    '071355005088': [
      7.26854565079726, 50.01256398832972, 7.288723246759303, 50.03668517766675,
    ],
    '071355005092': [
      7.137024230460559, 49.98751433528164, 7.262898779246373, 50.06718624658473,
    ],
    '071370003003': [
      7.288611132815247, 50.38753766366884, 7.451456203755079, 50.47687266355777,
    ],
    '071370068068': [
      7.098052435064967, 50.27973105819501, 7.296293131893427, 50.3631950193816,
    ],
    '071370203203': [
      7.55383669989265, 50.40654434889245, 7.651826374033871, 50.46421578091533,
    ],
    '071375001056': [
      7.339920218133835, 50.381758931303914, 7.387922967614022, 50.415442632578035,
    ],
    '071375001057': [
      7.275932291933653, 50.34930188178028, 7.363093983623354, 50.41288208901451,
    ],
    '071375001081': [
      7.255185592668071, 50.39071226205706, 7.374873471414377, 50.43631030901774,
    ],
    '071375001088': [
      7.355889363930247, 50.366653349434095, 7.405321886231508, 50.412698751643006,
    ],
    '071375001096': [
      7.39665948118521, 50.36154961819649, 7.442024173487185, 50.388408614097976,
    ],
    '071375002023': [
      7.244410717951067, 50.27411897821334, 7.294823640708748, 50.29196693492804,
    ],
    '071375002027': [
      7.326549034449119, 50.26966883448603, 7.36597584431393, 50.28869599916979,
    ],
    '071375002029': [
      7.239410155062522, 50.25993400511706, 7.269639715937772, 50.28037969814715,
    ],
    '071375002030': [
      7.326549034449119, 50.251720668173306, 7.362433712379498, 50.2729097204641,
    ],
    '071375002041': [
      7.382001722590458, 50.25803510104335, 7.411584957818808, 50.28798948704281,
    ],
    '071375002048': [
      7.343688252229709, 50.301260974445135, 7.386436689415438, 50.323314136701946,
    ],
    '071375002053': [
      7.243512862689668, 50.251802152723634, 7.286355024076754, 50.27818214104236,
    ],
    '071375002065': [
      7.385270163556702, 50.29753325659809, 7.42007941944979, 50.32783028029029,
    ],
    '071375002070': [
      7.269580364123064, 50.24900527137411, 7.327975169778795, 50.28879410837776,
    ],
    '071375002080': [
      7.273596061367749, 50.24125744729279, 7.340764182250789, 50.26966883448603,
    ],
    '071375002086': [
      7.333318427916541, 50.322665266454266, 7.436406284720561, 50.37338327607936,
    ],
    '071375002087': [
      7.286356589591591, 50.21875755257272, 7.344137805794866, 50.251720668173306,
    ],
    '071375002089': [
      7.246838005462254, 50.28012444165916, 7.378461769252619, 50.32874954805427,
    ],
    '071375002095': [
      7.357675586077704, 50.28331259050228, 7.40214455069522, 50.30651415385827,
    ],
    '071375002102': [
      7.276108171642193, 50.317667748367356, 7.315042701858609, 50.34881948193981,
    ],
    '071375002112': [
      7.302530502703693, 50.31922815842962, 7.356165990458457, 50.34396762318609,
    ],
    '071375002114': [
      7.310720082179233, 50.19846366138246, 7.367702078347906, 50.239725679874525,
    ],
    '071375002501': [
      7.312677980171812, 50.210104012331186, 7.418397143938189, 50.2854204808442,
    ],
    '071375003001': [
      7.050417021985454, 50.36209185963925, 7.090305893903813, 50.38363333553188,
    ],
    '071375003004': [
      7.059794799695768, 50.28772681201482, 7.114060388107732, 50.30923226777103,
    ],
    '071375003006': [
      7.046309057533218, 50.3783517767296, 7.101558402843154, 50.39998982645597,
    ],
    '071375003007': [
      7.010935904059808, 50.332624998162856, 7.086773848708573, 50.37449246349621,
    ],
    '071375003011': [
      7.069496445783042, 50.270500603218196, 7.145339249472489, 50.297569832222614,
    ],
    '071375003014': [
      6.973398923771012, 50.28551164466194, 7.038006770910846, 50.330386024770334,
    ],
    '071375003019': [
      7.041665323817202, 50.27977114981438, 7.08587135408284, 50.3068446907138,
    ],
    '071375003025': [
      7.174604990193064, 50.34475192378649, 7.237467094507153, 50.38291024218668,
    ],
    '071375003034': [
      7.101505104501329, 50.38418823047385, 7.132269057442681, 50.403149602015894,
    ],
    '071375003035': [
      6.980902893164031, 50.34212996929158, 7.035742304290783, 50.38720955068735,
    ],
    '071375003036': [
      7.093827475022004, 50.317281120665356, 7.129127901168134, 50.3377004352841,
    ],
    '071375003043': [
      7.185455714111623, 50.25803731842534, 7.246833579138203, 50.289750025640345,
    ],
    '071375003049': [
      7.111760746939898, 50.354657261905444, 7.180653310061127, 50.383443407054855,
    ],
    '071375003055': [
      7.228446420080117, 50.33296710338227, 7.273589715241817, 50.3603489526888,
    ],
    '071375003060': [
      7.083243031407943, 50.35543787007083, 7.118630193281022, 50.38348136905514,
    ],
    '071375003061': [
      7.089024559867232, 50.37490257282936, 7.120418570763443, 50.39290188411931,
    ],
    '071375003063': [
      7.020005675752325, 50.31403477458871, 7.050231747965475, 50.33469109039462,
    ],
    '071375003066': [
      7.080775931597274, 50.308070748993245, 7.12276304419356, 50.33456628437504,
    ],
    '071375003074': [
      7.123659240934193, 50.26402240753566, 7.205760973296366, 50.31109959113233,
    ],
    '071375003077': [
      7.017021589186408, 50.28914049719105, 7.059794799695768, 50.315764788651364,
    ],
    '071375003079': [
      7.043703323594094, 50.3068446907138, 7.091807575187144, 50.334165179133144,
    ],
    '071375003092': [
      7.138973692722539, 50.30516863031929, 7.179856887776581, 50.324921808573635,
    ],
    '071375003097': [
      7.158291584095592, 50.34475192378649, 7.215583897274181, 50.36317107008886,
    ],
    '071375003099': [
      7.021125204597544, 50.367714103015906, 7.059566850755434, 50.3907247404462,
    ],
    '071375003105': [
      7.06104005276079, 50.33039525169494, 7.107504896314928, 50.35543787007083,
    ],
    '071375003110': [
      7.100625754415089, 50.292390499227544, 7.150169698950118, 50.32080165675566,
    ],
    '071375003113': [
      7.044883860051378, 50.352348849974604, 7.098052435064967, 50.37487937196532,
    ],
    '071375004008': [
      7.189023224310148, 50.37770181481206, 7.257923766994874, 50.410992393788256,
    ],
    '071375004069': [
      7.197217252524081, 50.35577384333614, 7.329248390989925, 50.397734280071234,
    ],
    '071375004093': [
      7.149348982917073, 50.37195560028636, 7.199530751387551, 50.41388402441397,
    ],
    '071375004101': [
      7.265287687462643, 50.33686784488477, 7.333976983427533, 50.363670417922364,
    ],
    '071375004106': [
      7.118603942615859, 50.37895765627962, 7.161830109155349, 50.393727004356805,
    ],
    '071375007218': [
      7.573568797118732, 50.38113273421811, 7.617387175939556, 50.40975533291164,
    ],
    '071375007224': [
      7.614974919645974, 50.37149253166181, 7.657811724370476, 50.38726225300636,
    ],
    '071375007226': [
      7.589644449900585, 50.38628672078511, 7.680623370325715, 50.430097928183336,
    ],
    '071375007229': [
      7.592418616545879, 50.40576673495934, 7.652521710107387, 50.434243879058634,
    ],
    '071375008202': [
      7.409578428102738, 50.334732734243644, 7.488944086239015, 50.38193838134623,
    ],
    '071375008209': [
      7.531474291982676, 50.39102578938631, 7.55383669989265, 50.42176528414399,
    ],
    '071375008211': [
      7.43959342843532, 50.373130831844655, 7.478885102338618, 50.41121476754733,
    ],
    '071375008216': [
      7.465139584976781, 50.3634263441114, 7.538141070378116, 50.41335599118958,
    ],
    '071375008222': [
      7.538141070378116, 50.39102578938631, 7.573568797118732, 50.417687730835745,
    ],
    '071375008225': [
      7.501714870042317, 50.3964780189427, 7.531959701673019, 50.42176528414399,
    ],
    '071375008228': [
      7.433597483969055, 50.40712766227255, 7.480332330456132, 50.428536100563036,
    ],
    '071375009201': [
      7.441723914810153, 50.22345782201083, 7.501403598780078, 50.255811346996175,
    ],
    '071375009204': [
      7.585325056031659, 50.25284571159826, 7.642045279048566, 50.27934031640034,
    ],
    '071375009205': [
      7.408146470777079, 50.19583069389547, 7.483214975549669, 50.23006903108091,
    ],
    '071375009206': [
      7.350394562617669, 50.174042588667234, 7.418447464709709, 50.222738020518705,
    ],
    '071375009207': [
      7.465388851660916, 50.251456075207194, 7.529755365782138, 50.32099309034213,
    ],
    '071375009208': [
      7.372533310520835, 50.207860892778136, 7.436233659783825, 50.240826464595514,
    ],
    '071375009212': [
      7.394226496994301, 50.2712849314723, 7.504529557384291, 50.35058475310049,
    ],
    '071375009214': [
      7.411598386137799, 50.22733990816725, 7.447258517626806, 50.255811346996175,
    ],
    '071375009215': [
      7.375794599430041, 50.16087698438658, 7.429809554156824, 50.19583069389547,
    ],
    '071375009217': [
      7.454167912922904, 50.24802773992699, 7.516132820007564, 50.303141741717425,
    ],
    '071375009219': [
      7.45651556358914, 50.21385457898696, 7.516132820007564, 50.251456075207194,
    ],
    '071375009220': [
      7.441723914810153, 50.247626432636565, 7.501403598780078, 50.268749902175166,
    ],
    '071375009221': [
      7.529755365782138, 50.2553212251536, 7.627445004000342, 50.29542687091649,
    ],
    '071375009223': [
      7.631267393876834, 50.246019799573034, 7.651530527012295, 50.269912865433696,
    ],
    '071375009227': [
      7.528941276895575, 50.26391062247598, 7.559183596758345, 50.28925762326452,
    ],
    '071375009230': [
      7.487383582904553, 50.308007717329374, 7.534922593277863, 50.338143980969086,
    ],
    '071375009231': [
      7.457406049549169, 50.32966647527976, 7.490287076955161, 50.34603715815336,
    ],
    '071375009504': [
      7.406714508910558, 50.25006254814424, 7.45774146987832, 50.288250870880944,
    ],
    '071380045045': [
      7.383274299436728, 50.412451686346905, 7.58214298092589, 50.508016891888175,
    ],
    '071385001003': [
      7.370358995922325, 50.61353445122469, 7.486349982045534, 50.69314337272022,
    ],
    '071385001044': [
      7.363043142114979, 50.57536254064578, 7.475801887891341, 50.64366680243403,
    ],
    '071385001077': [
      7.311699428584216, 50.61863519458073, 7.387935128926557, 50.671595284268776,
    ],
    '071385001080': [
      7.35909753617134, 50.67010314041139, 7.453358380120685, 50.71891437742706,
    ],
    '071385002004': [
      7.291893848989973, 50.502585366476765, 7.386728981021816, 50.55658299321705,
    ],
    '071385002024': [
      7.33534881328996, 50.46280033013098, 7.393252037915829, 50.50035991444359,
    ],
    '071385002038': [
      7.359932554455333, 50.443418897701264, 7.409132860847249, 50.49330137911106,
    ],
    '071385002063': [
      7.312861817765491, 50.48408564252812, 7.401245380199563, 50.53034712557791,
    ],
    '071385003012': [
      7.58143329751697, 50.51888538907686, 7.702977690114739, 50.594389367094976,
    ],
    '071385003023': [
      7.596039256009093, 50.47654568805271, 7.679489694585765, 50.52728823523725,
    ],
    '071385003031': [
      7.565934654671995, 50.46371077781066, 7.598085702682419, 50.49129771481876,
    ],
    '071385003034': [
      7.579950165006409, 50.48770217989951, 7.627347435890791, 50.530088760031454,
    ],
    '071385003069': [
      7.651498972984975, 50.50465934145087, 7.672800289783094, 50.521675741736,
    ],
    '071385003201': [
      7.666094958213979, 50.55037536877478, 7.714464540152689, 50.60112055027187,
    ],
    '071385004009': [
      7.278867098795554, 50.54982907477778, 7.38637791139297, 50.57720960434042,
    ],
    '071385004037': [
      7.278867098795554, 50.52970779738652, 7.385553975389308, 50.566201737606654,
    ],
    '071385004041': [
      7.262413584211366, 50.55858437877809, 7.33945066898313, 50.61705692724075,
    ],
    '071385004055': [
      7.264444914104391, 50.572208617015924, 7.296917931907351, 50.588408778671905,
    ],
    '071385004068': [
      7.32323575177952, 50.574626535347576, 7.397812484861536, 50.61297751983794,
    ],
    '071385004075': [
      7.311074194769248, 50.60447504667772, 7.366619682463281, 50.62984199791646,
    ],
    '071385004501': [
      7.250415835198569, 50.57474456179504, 7.296783860689763, 50.599024943034756,
    ],
    '071385005011': [
      7.573789350017539, 50.53370246709818, 7.622690223370353, 50.56021008576508,
    ],
    '071385005013': [
      7.538598007857898, 50.59880577051722, 7.586852377872731, 50.62869115423615,
    ],
    '071385005014': [
      7.543220603431172, 50.57783922021566, 7.599702386751749, 50.60461433493128,
    ],
    '071385005025': [
      7.620099553295094, 50.581752715989886, 7.658500252509731, 50.59435869426696,
    ],
    '071385005027': [
      7.581084039001539, 50.56744935752234, 7.609281602746083, 50.58363930787996,
    ],
    '071385005040': [
      7.531316226511117, 50.555083700386895, 7.571578628252873, 50.58398024255265,
    ],
    '071385005048': [
      7.596255030743188, 50.5576013448499, 7.61793780358774, 50.56868892214005,
    ],
    '071385005050': [
      7.570829886984193, 50.61697168726518, 7.618703791084983, 50.652381894779204,
    ],
    '071385005052': [
      7.643161551853624, 50.61256983337934, 7.700656862399037, 50.64702071950696,
    ],
    '071385005057': [
      7.575387940554675, 50.58363930787996, 7.639198917610868, 50.62017002054067,
    ],
    '071385005058': [
      7.592261356332628, 50.63260754263109, 7.626132006891672, 50.647434998925206,
    ],
    '071385005059': [
      7.599702386751749, 50.55807767748748, 7.658500252509731, 50.58788662290653,
    ],
    '071385005064': [
      7.617744984804479, 50.62253171883854, 7.658659186578394, 50.65295674083502,
    ],
    '071385005070': [
      7.599370625377624, 50.60539951508786, 7.649155368474673, 50.63503065599429,
    ],
    '071385005074': [
      7.543004995784033, 50.525731350061115, 7.59649237979057, 50.57798271629309,
    ],
    '071385005078': [
      7.631632787032117, 50.59197829484187, 7.674877933088197, 50.61954381638747,
    ],
    '071385007008': [
      7.240505376837397, 50.59482653565833, 7.278671286834801, 50.61282859607394,
    ],
    '071385007019': [
      7.223978610693191, 50.57816979410156, 7.329925834636373, 50.63554775935256,
    ],
    '071385007062': [
      7.211850962673938, 50.61134027657161, 7.281575303980366, 50.62626234652591,
    ],
    '071385007073': [
      7.210918017468014, 50.58283523110057, 7.272912291939544, 50.62045705976989,
    ],
    '071385009002': [
      7.514117820008249, 50.48450900105292, 7.570896709764956, 50.525731350061115,
    ],
    '071385009005': [
      7.472315733848411, 50.518579438882895, 7.515401771914395, 50.539464167527264,
    ],
    '071385009006': [
      7.421672259469487, 50.54856859297377, 7.475801887891341, 50.59182996162681,
    ],
    '071385009007': [
      7.376972346832233, 50.5110479648363, 7.413575385509181, 50.56156330287064,
    ],
    '071385009010': [
      7.393680859358725, 50.48995609582374, 7.455647644886314, 50.51635378003485,
    ],
    '071385009015': [
      7.437972826573477, 50.49703204752957, 7.479721276899927, 50.5265877944227,
    ],
    '071385009026': [
      7.50538621979382, 50.506351479785906, 7.538794035077923, 50.52652267525434,
    ],
    '071385009030': [
      7.471129127716137, 50.5565493278948, 7.509387937495793, 50.58475195737101,
    ],
    '071385009036': [
      7.442090142754298, 50.52057700976519, 7.477219151647506, 50.551360378171516,
    ],
    '071385009042': [
      7.541126184104537, 50.47910911949876, 7.580459777936123, 50.50427361694362,
    ],
    '071385009043': [
      7.467292243776488, 50.47811661114581, 7.492179958569615, 50.49992248939739,
    ],
    '071385009047': [
      7.39940424188413, 50.51576410760413, 7.453867076763262, 50.54856859297377,
    ],
    '071385009053': [
      7.492283907920593, 50.54865418541445, 7.53330459031534, 50.57405450424116,
    ],
    '071385009054': [
      7.527415603392443, 50.534295064120855, 7.55853283127913, 50.557832392549145,
    ],
    '071385009061': [
      7.474910888686275, 50.48862600088258, 7.524270863531519, 50.519447184809835,
    ],
    '071385009065': [
      7.385553975389308, 50.56075193512119, 7.430728319921866, 50.5882940676188,
    ],
    '071385009066': [
      7.543358859873803, 50.51321947583818, 7.592046599319934, 50.534373448326164,
    ],
    '071385009071': [
      7.46682469481192, 50.51867362144134, 7.543358859873803, 50.55831739345949,
    ],
    '071385009072': [
      7.569573099392375, 50.49129771481876, 7.596054016715805, 50.52260691241649,
    ],
    '071385009076': [
      7.396861192954631, 50.53761780540856, 7.451703327985955, 50.565155831558506,
    ],
    '071400501501': [
      7.461034871121001, 50.15557672799729, 7.663634248647274, 50.26391062247598,
    ],
    '071405003001': [
      7.43062650024704, 50.01718036997848, 7.488809389970917, 50.04569845936522,
    ],
    '071405003009': [
      7.349570807998461, 50.01513898967604, 7.445234110235495, 50.07034749898651,
    ],
    '071405003010': [
      7.423992885841407, 50.09263925033401, 7.524437856662607, 50.13584330860051,
    ],
    '071405003018': [
      7.50661664393818, 50.06874111855247, 7.547941293851362, 50.10181970425125,
    ],
    '071405003021': [
      7.358305901217706, 50.059064558772675, 7.431151453128399, 50.10094981621396,
    ],
    '071405003042': [
      7.469590899361656, 50.06874111855247, 7.51592131471864, 50.100577884493575,
    ],
    '071405003046': [
      7.42088073371821, 50.024209031768756, 7.45669433582157, 50.056347414048005,
    ],
    '071405003055': [
      7.472799114453355, 50.06300515297105, 7.507258377842239, 50.08083256517913,
    ],
    '071405003064': [
      7.4254888918501, 50.05468650277353, 7.482800795943771, 50.08495791664585,
    ],
    '071405003073': [
      7.399272407856497, 50.09579081664546, 7.425173655982999, 50.11888550438532,
    ],
    '071405003095': [
      7.43062650024704, 50.00996512009275, 7.476540007207806, 50.024209031768756,
    ],
    '071405003131': [
      7.446132607660828, 50.06584265043094, 7.475857257098939, 50.09386415090537,
    ],
    '071405003147': [
      7.445234110235495, 50.040546476432866, 7.485485666964586, 50.056347414048005,
    ],
    '071405003153': [
      7.403734198406505, 50.07687540777634, 7.446804158328632, 50.101657215086945,
    ],
    '071405003202': [
      7.363447052204014, 50.11166393823707, 7.453969875997729, 50.16928285146998,
    ],
    '071405003204': [
      7.325699459237654, 50.023854830239564, 7.377086797674107, 50.08365299566637,
    ],
    '071405003502': [
      7.339648542428141, 50.1110377849316, 7.375223284086702, 50.13262571193264,
    ],
    '071405003503': [
      7.291475481140237, 50.0804513741375, 7.379103310103334, 50.13358408558114,
    ],
    '071405003504': [
      7.36465934915829, 50.10056550057106, 7.405398719473275, 50.13427624455963,
    ],
    '071405004006': [
      7.270805571240941, 49.943303980427686, 7.311494954333086, 49.9625082450619,
    ],
    '071405004007': [
      7.285703395875717, 49.96706366906096, 7.334045088672539, 49.995586843414024,
    ],
    '071405004024': [
      7.225659575871046, 49.91247229673714, 7.29538599744726, 49.93883735814959,
    ],
    '071405004028': [
      7.397902316728268, 49.88783130614653, 7.45015266037997, 49.91831304777949,
    ],
    '071405004029': [
      7.308494178991771, 49.900980114276635, 7.364713164264384, 49.92771008503705,
    ],
    '071405004030': [
      7.348526039729507, 49.9121036611136, 7.400150111871933, 49.93867193779683,
    ],
    '071405004040': [
      7.450677542116252, 49.868226896625664, 7.499937493562809, 49.89238879039368,
    ],
    '071405004041': [
      7.436935215672355, 49.88081948274924, 7.522398069337187, 49.91384224352665,
    ],
    '071405004044': [
      7.243356998541144, 49.946344061577165, 7.287286930946014, 49.975777709769496,
    ],
    '071405004048': [
      7.377379830241391, 49.904082433017116, 7.415432752446268, 49.92651095967455,
    ],
    '071405004049': [
      7.3967700390506, 49.96519477810252, 7.430391019079283, 49.9856199653465,
    ],
    '071405004050': [
      7.471965192390345, 49.85641427714231, 7.540921264178291, 49.89129643510098,
    ],
    '071405004053': [
      7.212652449334237, 49.88587364845034, 7.255493709786252, 49.91247229673714,
    ],
    '071405004062': [
      7.328870803766654, 49.97828710611182, 7.388830220345665, 50.025232176776896,
    ],
    '071405004067': [
      7.374869281838087, 49.917299879219506, 7.45377528819163, 49.97687345673042,
    ],
    '071405004071': [
      7.351232841828182, 49.97687345673042, 7.385414114835333, 49.9917112575586,
    ],
    '071405004081': [
      7.280113301565068, 49.87858473603459, 7.330451178002005, 49.90961198574661,
    ],
    '071405004082': [
      7.252200076368994, 49.928285235758494, 7.29224412132065, 49.951559590115174,
    ],
    '071405004086': [
      7.376830433888914, 49.88783130614653, 7.40800268049382, 49.91009465231337,
    ],
    '071405004090': [
      7.419869415906984, 49.92693454991286, 7.460754068694027, 49.94396296629991,
    ],
    '071405004094': [
      7.344523786836379, 49.96077612062734, 7.385744355659308, 49.98047724779016,
    ],
    '071405004105': [
      7.343250676212254, 49.93452234600683, 7.381275191858001, 49.957305082236566,
    ],
    '071405004107': [
      7.314574997060175, 49.91261006579602, 7.352980932449545, 49.94299443372903,
    ],
    '071405004109': [
      7.259026813753453, 49.89553466855944, 7.314574997060175, 49.91890645273892,
    ],
    '071405004111': [
      7.326838292105, 49.93930369020804, 7.375809566709881, 49.967971124658064,
    ],
    '071405004120': [
      7.20114233906649, 49.93883735814959, 7.259033136076997, 49.96856996770047,
    ],
    '071405004122': [
      7.382674138853869, 49.9722751790388, 7.421805136377617, 50.02049815236276,
    ],
    '071405004128': [
      7.314053448668275, 49.97570908164521, 7.345011128310998, 50.00213758191059,
    ],
    '071405004129': [
      7.430500994571797, 49.93939094034018, 7.458287105497861, 49.95593305111636,
    ],
    '071405004130': [
      7.397902316728268, 49.87772055330162, 7.450677542116252, 49.89727411344814,
    ],
    '071405004135': [
      7.420054004420793, 49.848953549225534, 7.471965192390345, 49.88906773320814,
    ],
    '071405004141': [
      7.311091507328275, 49.95405920819123, 7.345011128310998, 49.97828710611182,
    ],
    '071405004145': [
      7.280872739910817, 49.91261006579602, 7.331639232423107, 49.95479247490597,
    ],
    '071405004146': [
      7.330451178002005, 49.89591435649607, 7.380633473232966, 49.913729269361134,
    ],
    '071405004151': [
      7.344523786836379, 49.967971124658064, 7.362696682560543, 49.986362074409996,
    ],
    '071405004154': [
      7.421894336982915, 49.95593305111636, 7.4569041009839, 49.984650261632325,
    ],
    '071405004159': [
      7.225659575871046, 49.89154709242112, 7.271033933848738, 49.914175491130635,
    ],
    '071405004163': [
      7.425305512288409, 49.90480749851937, 7.481858289181855, 49.9325506710637,
    ],
    '071405004164': [
      7.392807531758004, 49.842575740767984, 7.439355335050428, 49.88783130614653,
    ],
    '071405004165': [
      7.284314987873351, 49.9622878675554, 7.314817642518795, 49.98658543103472,
    ],
    '071405008002': [
      7.544915076863623, 49.98842921319656, 7.583169992125511, 50.00806840651097,
    ],
    '071405008003': [
      7.558646302781948, 49.925990413933185, 7.661852433752157, 49.989028661923925,
    ],
    '071405008008': [
      7.480893098989116, 49.936724278069036, 7.515057628169086, 49.957496194735256,
    ],
    '071405008011': [
      7.596490528772908, 50.012475310183795, 7.622265571039753, 50.03748109915853,
    ],
    '071405008012': [
      7.54836460212638, 50.019250559746915, 7.586489380267448, 50.03408409743327,
    ],
    '071405008015': [
      7.421805136377617, 49.98166337435365, 7.457648226848354, 50.012837003523686,
    ],
    '071405008020': [
      7.529433694488441, 50.05923552383921, 7.578647150933727, 50.08617974555551,
    ],
    '071405008023': [
      7.540695807508528, 50.02921884380648, 7.584166984397798, 50.051669892607535,
    ],
    '071405008027': [
      7.683301514796831, 49.99714215626249, 7.728761870854114, 50.02197108726374,
    ],
    '071405008035': [
      7.616045241856951, 49.95274745948623, 7.668640359622724, 50.00304786116079,
    ],
    '071405008037': [
      7.666070091711144, 50.018640672900325, 7.696131727406925, 50.032295247205646,
    ],
    '071405008039': [
      7.446451906323292, 49.97922700941404, 7.48166929224567, 50.0008708030416,
    ],
    '071405008056': [
      7.514649783532876, 49.938350078549966, 7.551409715434633, 49.96845699243845,
    ],
    '071405008058': [
      7.525906491910141, 50.036230091289205, 7.572285148630113, 50.06090623542551,
    ],
    '071405008065': [
      7.47851947795693, 49.97985690504646, 7.508893145160849, 49.997238346372754,
    ],
    '071405008068': [
      7.584780473649726, 50.03748109915853, 7.638322610532939, 50.07370766791815,
    ],
    '071405008070': [
      7.488809389970917, 50.01977304493131, 7.54836460212638, 50.04977553579584,
    ],
    '071405008076': [
      7.456661362733697, 49.99548054723616, 7.524809080093186, 50.01977304493131,
    ],
    '071405008077': [
      7.501309129499273, 49.98379445518038, 7.535316700922109, 50.009335506027746,
    ],
    '071405008079': [
      7.481214680237408, 50.033170203394135, 7.538125718788176, 50.073242809019916,
    ],
    '071405008085': [
      7.609875578064012, 50.02480320495785, 7.666070091711144, 50.048381563276976,
    ],
    '071405008092': [
      7.485677683327697, 49.89118100915001, 7.545073614336373, 49.92360878178456,
    ],
    '071405008096': [
      7.602163582576916, 49.99222116980251, 7.639160708403573, 50.026611242577104,
    ],
    '071405008099': [
      7.552407306824774, 49.97126260384423, 7.581275480162304, 49.9902689484549,
    ],
    '071405008100': [
      7.45377528819163, 49.95593305111636, 7.501213234242548, 49.98802155712426,
    ],
    '071405008101': [
      7.468752354266915, 50.009109843754565, 7.518825437351863, 50.033170203394135,
    ],
    '071405008106': [
      7.518825437351863, 50.00475171681599, 7.546149762265137, 50.020760556647105,
    ],
    '071405008113': [
      7.481962258589155, 49.9508234979152, 7.517810286952105, 49.97454847803061,
    ],
    '071405008115': [
      7.456790455772468, 49.93939094034018, 7.487689684883712, 49.951541156751496,
    ],
    '071405008118': [
      7.542722227433957, 50.00406310256174, 7.579196175472904, 50.02921884380648,
    ],
    '071405008119': [
      7.458287105497861, 49.90951385554007, 7.509533246403552, 49.942213536051305,
    ],
    '071405008121': [
      7.573918496922745, 50.01468997750704, 7.598434953872628, 50.035281867123274,
    ],
    '071405008123': [
      7.406618872048473, 49.9856199653465, 7.450476359419814, 50.01398317521158,
    ],
    '071405008125': [
      7.633350136425396, 49.969038437305294, 7.706969679466056, 50.032295247205646,
    ],
    '071405008126': [
      7.566475146686502, 50.04784649506837, 7.593309662521127, 50.07518699517966,
    ],
    '071405008127': [
      7.538422306768143, 49.91266135025817, 7.617922321595993, 49.97126260384423,
    ],
    '071405008134': [
      7.497999319637383, 49.896011631975554, 7.586715640129119, 49.94376152863606,
    ],
    '071405008138': [
      7.5757260657763, 49.98072055986643, 7.624968900443473, 50.0010445613913,
    ],
    '071405008139': [
      7.45377528819163, 49.94707210690261, 7.495876888110158, 49.96739213999946,
    ],
    '071405008144': [
      7.501027386462702, 49.96338394445465, 7.558646302781948, 50.011403464040626,
    ],
    '071405008148': [
      7.572285148630113, 50.03408409743327, 7.609875578064012, 50.051669892607535,
    ],
    '071405008150': [
      7.525387411325366, 49.91941710690329, 7.567232610568796, 49.94911285192781,
    ],
    '071405008158': [
      7.576100621171416, 49.99330229734285, 7.610701709509653, 50.01807603207148,
    ],
    '071405008166': [
      7.40470796660076, 50.00562060284631, 7.443722945395131, 50.024209031768756,
    ],
    '071405009005': [
      7.603577017628836, 50.117845387393444, 7.642023793240104, 50.12706889275635,
    ],
    '071405009014': [
      7.493763086568401, 50.100343125068626, 7.543881352057078, 50.138922295698066,
    ],
    '071405009016': [
      7.600789230816821, 50.10240656728516, 7.639072071127088, 50.11791595989722,
    ],
    '071405009025': [
      7.600789230816821, 50.08504854053576, 7.706835306833574, 50.11791595989722,
    ],
    '071405009031': [
      7.565058931259775, 50.14249131649627, 7.602976958719121, 50.17364491802315,
    ],
    '071405009036': [
      7.515808489706666, 50.14093608371937, 7.565279338266209, 50.1742415201646,
    ],
    '071405009043': [
      7.453969875997729, 50.13524873374632, 7.519207353462987, 50.178756764976086,
    ],
    '071405009045': [
      7.519207353462987, 50.157659081386925, 7.595935825105515, 50.198001953316556,
    ],
    '071405009047': [
      7.537710984760619, 50.099362632501744, 7.578833343476042, 50.117266607925245,
    ],
    '071405009060': [
      7.581297987907218, 50.13676696840332, 7.657490733914943, 50.15557672799729,
    ],
    '071405009063': [
      7.593668153178796, 50.148682657199345, 7.649017795538125, 50.16565810914996,
    ],
    '071405009075': [
      7.530177528183672, 50.17899313180121, 7.580528743595067, 50.211709072770006,
    ],
    '071405009080': [
      7.585807292298287, 50.06337317930386, 7.624446740835443, 50.09572370499311,
    ],
    '071405009084': [
      7.551751659608838, 50.12475814926777, 7.598850855284842, 50.153258860263485,
    ],
    '071405009087': [
      7.543881352057078, 50.079462195914296, 7.606253856703026, 50.10240656728516,
    ],
    '071405009089': [
      7.567678900621993, 50.07261811258272, 7.588652948262774, 50.08931923673844,
    ],
    '071405009093': [
      7.461150042215435, 50.16573768412045, 7.505035630930572, 50.19129591648849,
    ],
    '071405009098': [
      7.537710984760619, 50.113369118992075, 7.566450985437178, 50.12475814926777,
    ],
    '071405009102': [
      7.503643825677987, 50.1742415201646, 7.549663794463278, 50.19790348403454,
    ],
    '071405009104': [
      7.639072071127088, 50.10424328510523, 7.714275361764961, 50.1267479199543,
    ],
    '071405009108': [
      7.529970350643105, 50.117266607925245, 7.558613551415796, 50.13554837551113,
    ],
    '071405009110': [
      7.558613551415796, 50.117970501112964, 7.604530884705174, 50.13676696840332,
    ],
    '071405009112': [
      7.681658985761084, 50.06628973984479, 7.762473105836126, 50.12965265683797,
    ],
    '071405009116': [
      7.633709501662601, 50.032295247205646, 7.716229349208039, 50.09515987781549,
    ],
    '071405009117': [
      7.559826814614386, 50.099362632501744, 7.604530884705174, 50.12527929103252,
    ],
    '071405009133': [
      7.636879205062619, 50.11791595989722, 7.726423170357308, 50.170690048319905,
    ],
    '071405009140': [
      7.539736824637393, 50.13325804332758, 7.565058931259775, 50.153258860263485,
    ],
    '071405009149': [
      7.505405467486558, 50.12723675711713, 7.543425508075999, 50.14158485598583,
    ],
    '071405009155': [
      7.689669833522681, 50.12006590269398, 7.739175867065981, 50.138042824117456,
    ],
    '071405009156': [
      7.598850855284842, 50.12527929103252, 7.648459911219494, 50.1404386611987,
    ],
    '071405009161': [
      7.617208181186188, 50.06429080214155, 7.66519670379194, 50.09222980998506,
    ],
    '071405009201': [
      7.422785962496666, 50.13584330860051, 7.480217008434918, 50.197371870125615,
    ],
    '071405009205': [
      7.418447464709709, 50.17902044077992, 7.461034871121001, 50.21245773818234,
    ],
    '071410075075': [
      7.589538244225614, 50.26623137729785, 7.755432765518665, 50.364657041570695,
    ],
    '071415003002': [
      7.934161352119536, 50.35443169928851, 7.995584105476016, 50.38864528964649,
    ],
    '071415003005': [
      7.973824076169985, 50.381334470544154, 8.020391132597807, 50.39389155966358,
    ],
    '071415003014': [
      7.984989037348226, 50.33772294396117, 8.013792410257372, 50.37102957447145,
    ],
    '071415003021': [
      7.864851550578453, 50.33194802773881, 7.886806177792846, 50.350238177614784,
    ],
    '071415003022': [
      7.919728936495522, 50.328903852310134, 7.973791440061039, 50.35357733214271,
    ],
    '071415003029': [
      7.995584105476016, 50.345022648776045, 8.062220756017947, 50.38580034259657,
    ],
    '071415003030': [
      7.871349210804426, 50.31050990122844, 7.905130269261941, 50.34299300174148,
    ],
    '071415003038': [
      7.897005471907272, 50.38722980740416, 7.946338432585324, 50.41689053043058,
    ],
    '071415003045': [
      7.903908170217707, 50.343541227431835, 7.937762292208199, 50.3647438245553,
    ],
    '071415003049': [
      7.986486621103174, 50.38928733971171, 8.023348778068133, 50.40135345155333,
    ],
    '071415003052': [
      7.95947904649262, 50.39198066751373, 7.991921267436728, 50.40690288922102,
    ],
    '071415003053': [
      7.938411663862978, 50.37102957447145, 7.999144786093513, 50.40011136049222,
    ],
    '071415003057': [
      7.916798036381234, 50.37460266029991, 7.943397745463828, 50.39408914412513,
    ],
    '071415003059': [
      7.8808854385972, 50.34299300174148, 7.909887282536523, 50.3647438245553,
    ],
    '071415003061': [
      7.993109043172976, 50.331485398052635, 8.069857845461344, 50.369602243904396,
    ],
    '071415003062': [
      7.854920306762503, 50.333919499840135, 7.903908170217707, 50.37725656710245,
    ],
    '071415003064': [
      7.849970496994001, 50.37175336884113, 7.917127923604709, 50.39999994786894,
    ],
    '071415003076': [
      7.897566365928951, 50.34143225016098, 7.967539875963992, 50.38170350902364,
    ],
    '071415003077': [
      7.886806177792846, 50.32709712517562, 7.923519848303644, 50.34727594102514,
    ],
    '071415003124': [
      7.898605567824026, 50.328288636916504, 7.948493942502036, 50.35149140250157,
    ],
    '071415003130': [
      7.93328470422216, 50.31441177174223, 7.973791440061039, 50.32954327409388,
    ],
    '071415003133': [
      7.952952129046884, 50.30973626209297, 7.98801276425848, 50.329778540283996,
    ],
    '071415003503': [
      7.95890154069065, 50.328903852310134, 7.99642907211137, 50.35710020882463,
    ],
    '071415007009': [
      7.803857984420308, 50.24649409925611, 7.8314330933128, 50.27154701483056,
    ],
    '071415007012': [
      7.859364282657831, 50.22110409878931, 7.888519515587656, 50.244023843476626,
    ],
    '071415007015': [
      7.774681527029413, 50.171120604090504, 7.823470299735238, 50.1962371688428,
    ],
    '071415007019': [
      7.859584477274966, 50.19840456737204, 7.907283008742804, 50.21699456286199,
    ],
    '071415007035': [
      7.774834785339272, 50.23163079286119, 7.789624955299129, 50.24810306572588,
    ],
    '071415007037': [
      7.809553088919977, 50.19398994094538, 7.837802484042727, 50.2125596947748,
    ],
    '071415007040': [
      7.707607901240777, 50.19975212878583, 7.738903110597991, 50.221628966368584,
    ],
    '071415007047': [
      7.717975907090522, 50.205433400080224, 7.774834785339272, 50.23722089217007,
    ],
    '071415007055': [
      7.744520470499218, 50.192277759029196, 7.790326230366088, 50.21877724286652,
    ],
    '071415007060': [
      7.887853709398295, 50.20183229867799, 7.947208007864284, 50.23479162409269,
    ],
    '071415007063': [
      7.821014311083933, 50.240781911588826, 7.855444506149506, 50.26467427291097,
    ],
    '071415007067': [
      7.750336250583757, 50.18946056144048, 7.79157728802355, 50.214815421960736,
    ],
    '071415007070': [
      7.741457093631475, 50.25208738977881, 7.766059726837558, 50.272665750939076,
    ],
    '071415007078': [
      7.832920705652604, 50.15529622336246, 7.866422896134427, 50.17849063483285,
    ],
    '071415007080': [
      7.839883593197076, 50.123742369594744, 7.87689259525459, 50.15529622336246,
    ],
    '071415007084': [
      7.785112416363662, 50.23163079286119, 7.826238467584388, 50.2493875988217,
    ],
    '071415007085': [
      7.795639829256522, 50.208591754543654, 7.873329530468417, 50.24331446958995,
    ],
    '071415007092': [
      7.837802484042727, 50.17384076707153, 7.912503781696099, 50.225260072933914,
    ],
    '071415007094': [
      7.757748902121897, 50.2319270201602, 7.777141814668765, 50.25208738977881,
    ],
    '071415007097': [
      7.794898825088978, 50.144943458738155, 7.835340111121139, 50.18338502505739,
    ],
    '071415007100': [
      7.713292233601539, 50.23722089217007, 7.760157564970741, 50.25627439552096,
    ],
    '071415007104': [
      7.87652639342238, 50.225260072933914, 7.918244842346726, 50.255517380787445,
    ],
    '071415007105': [
      7.818606039676341, 50.14617351600265, 7.866422896134427, 50.172653232120865,
    ],
    '071415007107': [
      7.820391116065053, 50.17783451659918, 7.844523272294258, 50.208591754543654,
    ],
    '071415007110': [
      7.769350248682512, 50.214815421960736, 7.79985997327292, 50.2319270201602,
    ],
    '071415007116': [
      7.811354890229783, 50.13266448273057, 7.852483982141273, 50.15920225400143,
    ],
    '071415007120': [
      7.790326230366088, 50.18338502505739, 7.823470299735238, 50.21724962459203,
    ],
    '071415007131': [
      7.868925280900183, 50.13124172182663, 7.928232574956142, 50.15019395260471,
    ],
    '071415007134': [
      7.866422896134427, 50.149156886052864, 7.915524366700298, 50.15938133768663,
    ],
    '071415007137': [
      7.867247541941962, 50.102776641328404, 7.928232574956142, 50.14464004607224,
    ],
    '071415007140': [
      7.713292233601539, 50.23009334925208, 7.760157564970741, 50.244473198588345,
    ],
    '071415007502': [
      7.859133020754431, 50.15529622336246, 7.904044434102425, 50.18074522457932,
    ],
    '071415009004': [
      7.75110570123856, 50.15889745327747, 7.782183734622257, 50.182890802259124,
    ],
    '071415009016': [
      7.735607805051762, 50.11012140693049, 7.796822234194833, 50.148566109952455,
    ],
    '071415009023': [
      7.683344482989324, 50.24119413740581, 7.742964253903525, 50.284091637310055,
    ],
    '071415009024': [
      7.673709754913108, 50.19252156119283, 7.719194078391206, 50.229984877587185,
    ],
    '071415009031': [
      7.724833521488059, 50.093550452985724, 7.847916110091512, 50.13266448273057,
    ],
    '071415009042': [
      7.57610200781697, 50.23348246038842, 7.606616815819794, 50.24974771576921,
    ],
    '071415009066': [
      7.586087112997729, 50.20066071255678, 7.688979657606954, 50.24013826738923,
    ],
    '071415009069': [
      7.756823554854329, 50.06733965003471, 7.839485318382855, 50.1134662201313,
    ],
    '071415009072': [
      7.642421741134228, 50.170690048319905, 7.67734052031513, 50.2044641065414,
    ],
    '071415009079': [
      7.716995892943531, 50.15688954306559, 7.777136134764127, 50.19054797237903,
    ],
    '071415009083': [
      7.64580107879689, 50.19821909199127, 7.681259637405021, 50.219025771628225,
    ],
    '071415009099': [
      7.702403156650259, 50.16269960620236, 7.765862870686895, 50.192277759029196,
    ],
    '071415009108': [
      7.591668575136138, 50.221628966368584, 7.730148505695131, 50.250900300462554,
    ],
    '071415009109': [
      7.727436525706253, 50.146022787072646, 7.7556591278074, 50.16465214144617,
    ],
    '071415009112': [
      7.66873365092463, 50.175327782800935, 7.703699831464359, 50.203498454760016,
    ],
    '071415009114': [
      7.749569942566167, 50.13576448785963, 7.775707785374198, 50.16203336242543,
    ],
    '071415009115': [
      7.768177786097685, 50.14153332322225, 7.811354890229783, 50.17455312650238,
    ],
    '071415009121': [
      7.663634248647274, 50.12965265683797, 7.739175867065981, 50.193855262798614,
    ],
    '071415009122': [
      7.802153371235363, 50.08135677386537, 7.840367448327567, 50.099751219569946,
    ],
    '071415009136': [
      7.778247461974443, 50.10199542960907, 7.839883593197076, 50.144943458738155,
    ],
    '071415009138': [
      7.702460580214994, 50.17908588659271, 7.750336250583757, 50.21298875626811,
    ],
    '071415009501': [
      7.627445004000342, 50.24119413740581, 7.730948477625814, 50.289215149493344,
    ],
    '071415010003': [
      7.853629515108471, 50.28040428110586, 7.900696284584931, 50.30384026533065,
    ],
    '071415010006': [
      7.697311518924939, 50.31665799576735, 7.752862043836154, 50.36692626414593,
    ],
    '071415010008': [
      7.690272255000231, 50.2784305437303, 7.742964253903525, 50.300738061264134,
    ],
    '071415010025': [
      7.735769914863125, 50.307480230053535, 7.777204342529942, 50.35329175074507,
    ],
    '071415010026': [
      7.741457093631475, 50.24810306572588, 7.782880118834381, 50.2727545501433,
    ],
    '071415010027': [
      7.761071363516743, 50.291906523246354, 7.788148742832214, 50.307642911719114,
    ],
    '071415010033': [
      7.772781745428542, 50.26439690108865, 7.80441314588125, 50.28995948342987,
    ],
    '071415010041': [
      7.660230084918354, 50.32897307358267, 7.69766790093882, 50.347162130763444,
    ],
    '071415010044': [
      7.651042275859138, 50.307245622727514, 7.724183043817278, 50.32479318272434,
    ],
    '071415010046': [
      7.777141814668765, 50.24539045242885, 7.80441314588125, 50.27154701483056,
    ],
    '071415010058': [
      7.769910173857569, 50.319590839029104, 7.814450754457436, 50.36124852413358,
    ],
    '071415010071': [
      7.741241519795432, 50.335936240428886, 7.777204342529942, 50.36702825485573,
    ],
    '071415010082': [
      7.854023204901892, 50.2524764260761, 7.887280310579023, 50.28040428110586,
    ],
    '071415010086': [
      7.645026233303647, 50.311520623939835, 7.671742262078069, 50.33091138733768,
    ],
    '071415010087': [
      7.755432765518665, 50.30242544076235, 7.780703222829564, 50.3120359206764,
    ],
    '071415010091': [
      7.772172844238347, 50.28995948342987, 7.835536734653123, 50.34714323086632,
    ],
    '071415010098': [
      7.670021196156362, 50.31851624040369, 7.712326742096189, 50.33683310396794,
    ],
    '071415010103': [
      7.826834744313207, 50.30190119089266, 7.871528375603059, 50.3348210525817,
    ],
    '071415010106': [
      7.759507553729439, 50.27248311480836, 7.799703772270348, 50.291906523246354,
    ],
    '071415010111': [
      7.850775944790755, 50.24001049479692, 7.902542113007459, 50.286833438182185,
    ],
    '071415010127': [
      7.741457093631475, 50.27248311480836, 7.772172844238347, 50.29684893243758,
    ],
    '071415010128': [
      7.830221133487968, 50.290364553609386, 7.88872285437312, 50.32257024878589,
    ],
    '071415010129': [
      7.799703772270348, 50.25912575306876, 7.882131687463588, 50.30407704594416,
    ],
    '071415010132': [
      7.731128028178891, 50.291498921750964, 7.765243610666487, 50.307480230053535,
    ],
    '071415010135': [
      7.824691279527852, 50.31818419927698, 7.860434810409226, 50.34470628853708,
    ],
    '071415010139': [
      7.810683257795012, 50.32470558244181, 7.86760699533742, 50.36124852413358,
    ],
    '071415010141': [
      7.775389478926495, 50.34224497620705, 7.810683257795012, 50.363508492959944,
    ],
    '071415010201': [
      7.732746332299421, 50.3641048085211, 7.79241893569242, 50.39958636681967,
    ],
    '071415011001': [
      7.989022270788862, 50.2578479493304, 8.027761355524454, 50.28129707149377,
    ],
    '071415011010': [
      7.974498731301923, 50.24620314377456, 8.033859259771392, 50.26935924695311,
    ],
    '071415011011': [
      7.948512213506821, 50.22025271541647, 7.992831430652656, 50.24620314377456,
    ],
    '071415011013': [
      7.942991688801949, 50.29517112356769, 7.969975677139542, 50.31658992033956,
    ],
    '071415011018': [
      7.885305567418011, 50.29768189671016, 7.943911890129423, 50.31990589778518,
    ],
    '071415011020': [
      8.060648105530266, 50.259610944527864, 8.11184035587314, 50.29798214719831,
    ],
    '071415011032': [
      7.974498731301923, 50.22912249026728, 8.037858907095407, 50.25740263969445,
    ],
    '071415011034': [
      7.97099027253264, 50.277420294897354, 7.997009390516975, 50.29503126184883,
    ],
    '071415011036': [
      8.000380957344184, 50.22537489371855, 8.05638442715974, 50.249412494164744,
    ],
    '071415011039': [
      7.924432720831956, 50.2576101366261, 7.952639187089922, 50.27878359554171,
    ],
    '071415011043': [
      8.003536287631707, 50.32170898157631, 8.056750150174903, 50.35251439517389,
    ],
    '071415011050': [
      7.897661124369066, 50.31327950253206, 7.935362380204102, 50.33123265806042,
    ],
    '071415011051': [
      8.014148577187962, 50.28322409620601, 8.088050104619132, 50.318324857107754,
    ],
    '071415011054': [
      7.914692809004778, 50.26566733352493, 7.959737624980958, 50.29656465093483,
    ],
    '071415011065': [
      8.08667982316405, 50.27061136158951, 8.121603474667804, 50.30700726415209,
    ],
    '071415011068': [
      7.934067713802218, 50.24620314377456, 8.027761355524454, 50.29503126184883,
    ],
    '071415011073': [
      7.949253898884542, 50.26512585954748, 7.978442595241421, 50.29517112356769,
    ],
    '071415011074': [
      7.889576745434162, 50.27280036874686, 7.950337334669829, 50.30664409459036,
    ],
    '071415011081': [
      8.013402471643671, 50.30310437498693, 8.06373666402934, 50.327735911001675,
    ],
    '071415011088': [
      7.941298064620424, 50.24444160189649, 7.974498731301923, 50.259879144018214,
    ],
    '071415011089': [
      8.01612926037414, 50.26417781792121, 8.050488194554738, 50.29778288656772,
    ],
    '071415011093': [
      8.080689558817534, 50.305796769508504, 8.107351484179425, 50.33003381408807,
    ],
    '071415011095': [
      8.007781258715209, 50.31212144418194, 8.07611874837183, 50.35682633498998,
    ],
    '071415011096': [
      7.879600023794186, 50.248586718071756, 7.934067713802218, 50.27280036874686,
    ],
    '071415011101': [
      7.918236876550936, 50.23748306553379, 7.967546696097323, 50.2576101366261,
    ],
    '071415011102': [
      8.051309931813051, 50.31430857908838, 8.08785612833277, 50.33261286754124,
    ],
    '071415011113': [
      8.000380957344184, 50.21520512018729, 8.041162794142958, 50.231594273862385,
    ],
    '071415011117': [
      7.906703885826744, 50.21607733170505, 7.953803755186128, 50.24386560144336,
    ],
    '071415011118': [
      7.877896017732032, 50.26079366649559, 7.914692809004778, 50.28096634173179,
    ],
    '071415011125': [
      8.042809613709238, 50.27296844937091, 8.0642085048784, 50.28904010344986,
    ],
    '071415011126': [
      7.959737624980958, 50.28963043655574, 8.018182979398693, 50.33772294396117,
    ],
    '071435001206': [
      7.920418289304148, 50.63053522560985, 7.978058339363613, 50.66734385057756,
    ],
    '071435001211': [
      7.905759203024811, 50.661244290023305, 7.928191942534068, 50.67319834501211,
    ],
    '071435001216': [
      7.908276228233894, 50.608292742216996, 7.956570750035334, 50.62550388459245,
    ],
    '071435001222': [
      7.990843884295586, 50.63579831004237, 8.020002639576232, 50.6598679405738,
    ],
    '071435001227': [
      7.956278688483522, 50.63053522560985, 7.981573315043807, 50.640697628016206,
    ],
    '071435001231': [
      7.91524278381723, 50.623122206743126, 7.956278688483522, 50.635651916218386,
    ],
    '071435001234': [
      7.909689597978463, 50.62333230746468, 7.933791645306452, 50.644086480473725,
    ],
    '071435001243': [
      7.982149979702839, 50.658005657561404, 8.037659741465228, 50.697373978009004,
    ],
    '071435001248': [
      7.910785255104361, 50.66094265351419, 7.948171347553561, 50.68234384694809,
    ],
    '071435001253': [
      7.920665728918166, 50.681833227211186, 7.968755916341205, 50.71063773130357,
    ],
    '071435001255': [
      7.938369357403412, 50.66429704973969, 7.975005079881292, 50.68801046711318,
    ],
    '071435001264': [
      7.874416534041528, 50.68311534267982, 7.91698212066136, 50.70379971502056,
    ],
    '071435001270': [
      7.883748430815989, 50.687669148278026, 7.94966124507138, 50.7189856636775,
    ],
    '071435001277': [
      7.972375743535827, 50.6541430332158, 8.003452718771527, 50.67692853071359,
    ],
    '071435001279': [
      7.883233931267206, 50.61317575043667, 7.914492581495425, 50.64296507353857,
    ],
    '071435001280': [
      7.87125235359052, 50.66096077081895, 7.943272561294023, 50.68801046711318,
    ],
    '071435001297': [
      7.968653226604892, 50.63058162520968, 7.998911529924843, 50.65460836624852,
    ],
    '071435001300': [
      7.860361847505217, 50.63812980313923, 7.938567201143215, 50.67086615677434,
    ],
    '071435002202': [
      7.824851701434064, 50.612748055088225, 7.894268882361462, 50.661665447173135,
    ],
    '071435002204': [
      7.766396065252034, 50.68435367507317, 7.792718736560359, 50.70087328742754,
    ],
    '071435002205': [
      7.811531997660789, 50.684481382744714, 7.850610979121097, 50.70227996597748,
    ],
    '071435002212': [
      7.691587142158927, 50.6575459728642, 7.722513685635549, 50.67529451689983,
    ],
    '071435002215': [
      7.816385411146304, 50.57984332677672, 7.860559278093359, 50.6022147083812,
    ],
    '071435002223': [
      7.812058743734293, 50.62050492882676, 7.846701851165121, 50.64807514670965,
    ],
    '071435002225': [
      7.698032678607786, 50.69172692581928, 7.734791870665251, 50.717021548866754,
    ],
    '071435002229': [
      7.784282338440207, 50.612946754157626, 7.874646375106381, 50.676290092597256,
    ],
    '071435002235': [
      7.738569198480804, 50.63014925382974, 7.799184274342593, 50.67795081819175,
    ],
    '071435002236': [
      7.741443860083458, 50.70087328742754, 7.790188111028929, 50.71946900233707,
    ],
    '071435002240': [
      7.749279081934143, 50.691917169867786, 7.778236905298218, 50.70735199231582,
    ],
    '071435002241': [
      7.730204143522134, 50.61539038506252, 7.774715876662348, 50.64207360283476,
    ],
    '071435002250': [
      7.72614434220884, 50.67886668975214, 7.75518075907426, 50.71048864722904,
    ],
    '071435002252': [
      7.778007545836157, 50.70913366943896, 7.811181307023065, 50.730724144920686,
    ],
    '071435002257': [
      7.778236905298218, 50.6900048225811, 7.815653814823831, 50.71319979546033,
    ],
    '071435002258': [
      7.828835926807577, 50.58982616064721, 7.866464981801701, 50.60786446164079,
    ],
    '071435002259': [
      7.826010371039459, 50.59985834963016, 7.871616683785351, 50.62132493712814,
    ],
    '071435002260': [
      7.813359573065219, 50.69476850975202, 7.858527483681103, 50.71178136495219,
    ],
    '071435002261': [
      7.736565625930371, 50.67434024209359, 7.769815071515362, 50.69397856210278,
    ],
    '071435002262': [
      7.756675206877715, 50.62643319761456, 7.793119311955472, 50.651130868029334,
    ],
    '071435002265': [
      7.743749035457681, 50.71351180622136, 7.794792793955088, 50.73970801462038,
    ],
    '071435002267': [
      7.720636599378922, 50.65323488437434, 7.753411356883976, 50.68269081185601,
    ],
    '071435002268': [
      7.703879723889632, 50.58685985945909, 7.768358003077513, 50.61803415398255,
    ],
    '071435002269': [
      7.766335049388314, 50.6692585594794, 7.805560280847608, 50.6900048225811,
    ],
    '071435002276': [
      7.81858631865393, 50.667437251900495, 7.889413545315616, 50.68662955748881,
    ],
    '071435002287': [
      7.664900297096218, 50.59401039033362, 7.730204143522134, 50.62288730378443,
    ],
    '071435002294': [
      7.784282338440207, 50.5834235991513, 7.838409494643419, 50.62681044681657,
    ],
    '071435002296': [
      7.7187833237974, 50.7094870521682, 7.749676798645925, 50.73371753623694,
    ],
    '071435002299': [
      7.792718736560359, 50.67514026674081, 7.836548615382901, 50.696347181545654,
    ],
    '071435002301': [
      7.700656862399037, 50.62191074045048, 7.738569198480804, 50.65898885813478,
    ],
    '071435002306': [
      7.708708384299165, 50.61803415398255, 7.730877228785986, 50.63595214155066,
    ],
    '071435002310': [
      7.737370677465519, 50.61376467904008, 7.78796225503181, 50.64896329409638,
    ],
    '071435002313': [
      7.713276346651267, 50.635174136966846, 7.744192283121401, 50.65323488437434,
    ],
    '071435003030': [
      7.674065499641916, 50.44230408442115, 7.705323170389039, 50.47166331102201,
    ],
    '071435003031': [
      7.668264680687893, 50.39231997156266, 7.744594950463846, 50.427899702750516,
    ],
    '071435003032': [
      7.635755971015501, 50.42013409162016, 7.7360165626285, 50.45703072522091,
    ],
    '071435003040': [
      7.664923981549684, 50.448839921246865, 7.682110931748018, 50.466208831592546,
    ],
    '071435004005': [
      7.851301015192875, 50.46278606198219, 7.86574970849422, 50.48740181064682,
    ],
    '071435004008': [
      7.82719046797942, 50.37844938738593, 7.854927393990603, 50.396288050608426,
    ],
    '071435004013': [
      7.690862110628698, 50.35409807168751, 7.741701825343073, 50.38222408900422,
    ],
    '071435004020': [
      7.846416437855019, 50.34823320013055, 7.882469495598336, 50.37760010314501,
    ],
    '071435004021': [
      7.872391971333956, 50.42407618546944, 7.939756398853509, 50.4676811059458,
    ],
    '071435004023': [
      7.939378415403006, 50.39672327784637, 7.970462882057929, 50.41850771280539,
    ],
    '071435004024': [
      7.872391971333956, 50.43125940955626, 7.902303349185667, 50.45655110657538,
    ],
    '071435004026': [
      7.867907567403003, 50.399661345647466, 7.911787317530967, 50.42407618546944,
    ],
    '071435004027': [
      7.840715151987464, 50.43125940955626, 7.879380837020649, 50.46299564683973,
    ],
    '071435004033': [
      7.813206023863283, 50.4036904562641, 7.857285185095567, 50.42557191235831,
    ],
    '071435004034': [
      7.819855841130622, 50.364241006438604, 7.864931018235295, 50.38299127733819,
    ],
    '071435004036': [
      7.810683257795012, 50.351809743369536, 7.852102154637825, 50.368958935635725,
    ],
    '071435004039': [
      7.718322409923259, 50.38175172986542, 7.757135595616578, 50.40772667146242,
    ],
    '071435004048': [
      7.72735449319332, 50.38414364367128, 7.884121135810722, 50.45611073494956,
    ],
    '071435004051': [
      7.909259308009373, 50.41004960985298, 7.961762121556744, 50.44074561989945,
    ],
    '071435004052': [
      7.703274286948349, 50.3766091078347, 7.719537459855659, 50.40120706714616,
    ],
    '071435004053': [
      7.75310131023376, 50.385460057894285, 7.825349119019875, 50.42053639400922,
    ],
    '071435004054': [
      7.955656407313761, 50.41850771280539, 7.987704958460053, 50.436493214138714,
    ],
    '071435004055': [
      7.874546170301473, 50.419355946214054, 7.920784703288245, 50.43867004642457,
    ],
    '071435004057': [
      7.79241893569242, 50.3765376664704, 7.834727008882538, 50.3994555943515,
    ],
    '071435004065': [
      7.860748046279674, 50.45301763862378, 7.908047710711624, 50.472041765025914,
    ],
    '071435004071': [
      7.64903632859072, 50.364657041570695, 7.703440831286576, 50.400566111409645,
    ],
    '071435004072': [
      7.846458721414076, 50.38414364367128, 7.884121135810722, 50.405079569939,
    ],
    '071435004077': [
      7.820923885185959, 50.39617078000778, 7.855270539492484, 50.40985773429281,
    ],
    '071435004079': [
      7.767862803880759, 50.35328234243451, 7.834753342130024, 50.39083187604631,
    ],
    '071435005001': [
      7.644999794960019, 50.45591521828583, 7.704468988096328, 50.48818906229985,
    ],
    '071435005006': [
      7.652996996435526, 50.47608192568268, 7.699903680758535, 50.51141784312347,
    ],
    '071435005007': [
      7.597974060221164, 50.46421578091533, 7.632819241752997, 50.484968282041436,
    ],
    '071435005009': [
      7.672800289783094, 50.49472689797507, 7.724754632735923, 50.518642534764936,
    ],
    '071435005038': [
      7.698077694438509, 50.46329335936406, 7.713756693578699, 50.486663008631496,
    ],
    '071435005050': [
      7.598085702682419, 50.447758693277365, 7.654270819005676, 50.47834935556785,
    ],
    '071435005059': [
      7.707593974201459, 50.49758123939643, 7.737986117663233, 50.511975508818836,
    ],
    '071435005062': [
      7.704835599054011, 50.44230408442115, 7.75662534889494, 50.48529713879542,
    ],
    '071435005068': [
      7.630084415536681, 50.46554160267735, 7.658008971313892, 50.486827523773556,
    ],
    '071435005082': [
      7.647009903233205, 50.46554160267735, 7.679558757623116, 50.49154007805163,
    ],
    '071435005084': [
      7.691280215743776, 50.48069135092405, 7.739581167437588, 50.50519058690869,
    ],
    '071435006214': [
      8.05376955514206, 50.66309825171449, 8.087135036150144, 50.68706468926076,
    ],
    '071435006218': [
      8.091423660971545, 50.54934216799095, 8.143698720971637, 50.58432381547045,
    ],
    '071435006237': [
      8.006131099070815, 50.59106047625398, 8.046751233195765, 50.6273369371516,
    ],
    '071435006244': [
      8.093384974918976, 50.629574934539825, 8.120349870037057, 50.652206629666146,
    ],
    '071435006245': [
      8.063823093647954, 50.55396143104462, 8.096900351109719, 50.583291800929466,
    ],
    '071435006246': [
      8.038410766389939, 50.545901456593384, 8.080238218511822, 50.572543613023896,
    ],
    '071435006256': [
      8.060073312893836, 50.67344652025266, 8.126323785202958, 50.70571526312899,
    ],
    '071435006271': [
      8.065821526346344, 50.533581325404086, 8.122126417096295, 50.56047879376447,
    ],
    '071435006272': [
      8.017388279473275, 50.61587164798784, 8.051651356229641, 50.63154012606576,
    ],
    '071435006274': [
      8.0138830363954, 50.630473976196306, 8.051651356229641, 50.65223396187696,
    ],
    '071435006278': [
      8.058962185386418, 50.64847219310312, 8.102269524402258, 50.665212232762556,
    ],
    '071435006282': [
      8.110578664215932, 50.57608913834745, 8.151574876963371, 50.609732679886775,
    ],
    '071435006283': [
      8.013978727522675, 50.645743849709724, 8.053005304709158, 50.66287516385645,
    ],
    '071435006285': [
      8.093137655536632, 50.609732679886775, 8.141142834181675, 50.64965733194026,
    ],
    '071435006286': [
      8.041329333479707, 50.58895719243859, 8.115032155792834, 50.643690601496715,
    ],
    '071435006291': [
      8.024929810408077, 50.65535455896405, 8.060441223788745, 50.671638644050574,
    ],
    '071435006292': [
      8.015553418265116, 50.55134786039111, 8.05740179425345, 50.59842632691431,
    ],
    '071435006295': [
      8.020736308719396, 50.671323290986265, 8.065182363037785, 50.697373978009004,
    ],
    '071435006302': [
      8.070725239092614, 50.6260876277399, 8.112317702073982, 50.65557638746777,
    ],
    '071435006303': [
      8.050200734889442, 50.569356031631266, 8.083170558474858, 50.59427717506191,
    ],
    '071435006309': [
      8.078760721636137, 50.576543795377454, 8.123876065728922, 50.613466417927405,
    ],
    '071435006311': [
      8.077018308651121, 50.652206629666146, 8.112317702073982, 50.67579303465223,
    ],
    '071435006315': [
      8.045641838027203, 50.63560745106077, 8.074153688305826, 50.66103025018204,
    ],
    '071435007015': [
      7.703391204480202, 50.5117954917447, 7.731265262117607, 50.52363812102962,
    ],
    '071435007018': [
      7.824365550519438, 50.549106654562735, 7.844416900332705, 50.580560954524216,
    ],
    '071435007019': [
      7.694668894184864, 50.56040992672766, 7.72822386620471, 50.59285760561734,
    ],
    '071435007022': [
      7.725756816893549, 50.53894687380505, 7.759947078407614, 50.55304240960234,
    ],
    '071435007025': [
      7.762831686365396, 50.555496629311314, 7.809756298967941, 50.62252388603006,
    ],
    '071435007029': [
      7.712950298326513, 50.55813133504151, 7.784817449514467, 50.61376467904008,
    ],
    '071435007041': [
      7.714748090654536, 50.528062556104246, 7.741627539176482, 50.54617455556831,
    ],
    '071435007044': [
      7.694318016875882, 50.533801417741245, 7.732483033438424, 50.5619182053343,
    ],
    '071435007045': [
      7.681417166874957, 50.56670180146194, 7.705532569368868, 50.59643397135791,
    ],
    '071435007046': [
      7.759446909728283, 50.52353204519679, 7.832501191521382, 50.564620232719406,
    ],
    '071435007056': [
      7.737986117663233, 50.49743698705964, 7.772947796974047, 50.52323029704848,
    ],
    '071435007061': [
      7.778753160547237, 50.50690778451845, 7.808986526947473, 50.52964030746742,
    ],
    '071435007064': [
      7.72961847578377, 50.55184083513027, 7.77189132703057, 50.565341454111845,
    ],
    '071435007066': [
      7.766099262745351, 50.57426630013135, 7.791204538894248, 50.60817504512396,
    ],
    '071435007067': [
      7.723315955801296, 50.50519058690869, 7.785626731011936, 50.5449270710368,
    ],
    '071435007069': [
      7.668805011047451, 50.51141784312347, 7.731265262117607, 50.535368233971994,
    ],
    '071435007075': [
      7.798620329338778, 50.55749517207272, 7.827383783979874, 50.586176146624545,
    ],
    '071435007078': [
      7.752342708378019, 50.49543043726532, 7.796619767954133, 50.52030660597647,
    ],
    '071435007085': [
      7.841695397540657, 50.554275550411695, 7.881673033297021, 50.59228116901678,
    ],
    '071435007221': [
      7.808986526947473, 50.522327451740445, 7.83621789046332, 50.54354829344041,
    ],
    '071435007305': [
      7.826530214170283, 50.53892077500839, 7.867029081154446, 50.55752071120814,
    ],
    '071435008011': [
      7.939756398853509, 50.436493214138714, 7.975980681670494, 50.46319890558411,
    ],
    '071435008037': [
      7.959432317539726, 50.443991496863525, 8.011238423517895, 50.473573381403334,
    ],
    '071435008058': [
      7.955656407313761, 50.43501893815777, 7.989840417245909, 50.449760198498765,
    ],
    '071435008074': [
      7.908047710711624, 50.44074561989945, 7.94617451025177, 50.47127573965974,
    ],
    '071435008080': [
      7.940179580177893, 50.45417837098575, 7.962113559092059, 50.47363171670463,
    ],
    '071435008203': [
      7.856096731511244, 50.52842937688563, 7.879875301974132, 50.554275550411695,
    ],
    '071435008208': [
      7.921017742476488, 50.468142201495034, 7.946157844162767, 50.499427063790456,
    ],
    '071435008210': [
      7.934695059034955, 50.487973328179635, 7.968747201651163, 50.50624695349539,
    ],
    '071435008220': [
      7.859492197495483, 50.50699503472335, 7.885375213376265, 50.52842937688563,
    ],
    '071435008232': [
      7.873453478322668, 50.51704442784449, 7.906729679236425, 50.54164827500772,
    ],
    '071435008239': [
      7.906729679236425, 50.49610473088022, 7.94685135000589, 50.518231948964676,
    ],
    '071435008251': [
      7.848211383577299, 50.52360783932389, 7.873453478322668, 50.54212965064022,
    ],
    '071435008263': [
      7.863622496726013, 50.4676811059458, 7.924777954387074, 50.52035527414932,
    ],
    '071435008266': [
      7.959432317539726, 50.472601866756996, 7.98734346831424, 50.49683572143268,
    ],
    '071435008273': [
      7.841590888104248, 50.481807304699586, 7.878658019868001, 50.50826675022035,
    ],
    '071435008281': [
      7.847177682869852, 50.49403087097235, 7.892019781396574, 50.519362296865445,
    ],
    '071435008290': [
      7.944705493347072, 50.49533320359953, 7.988530322701075, 50.51730027615114,
    ],
    '071435008304': [
      7.934695059034955, 50.472601866756996, 7.959996553435634, 50.499427063790456,
    ],
    '071435008316': [
      7.90485758475145, 50.47039483992398, 7.930180191483247, 50.48193684418171,
    ],
    '071435008501': [
      7.889987039060945, 50.52287764089089, 7.928578528107612, 50.541089755130734,
    ],
    '071435008502': [
      7.905809116772945, 50.51704442784449, 7.937203313791656, 50.528017561984804,
    ],
    '071435009200': [
      7.920246181963257, 50.58689158137521, 7.970514699175125, 50.612839291592316,
    ],
    '071435009207': [
      7.871123494205164, 50.574947281050065, 7.913541290935395, 50.59999575408313,
    ],
    '071435009209': [
      7.990818580257873, 50.52519766051921, 8.024778436903977, 50.547916100342235,
    ],
    '071435009213': [
      7.896133642232253, 50.552981341774206, 7.932366602210705, 50.5754581652588,
    ],
    '071435009219': [
      7.878320379090721, 50.605654559319774, 7.896031537944128, 50.62744487928927,
    ],
    '071435009224': [
      7.998110045026183, 50.54170407130803, 8.031664790308497, 50.57245651272171,
    ],
    '071435009226': [
      7.96265908653206, 50.51057054536615, 7.99594398961767, 50.52519766051921,
    ],
    '071435009228': [
      7.928578528107612, 50.515616821211346, 7.960340890310643, 50.54244184009177,
    ],
    '071435009230': [
      7.889987039060945, 50.528017561984804, 7.931072802016881, 50.54733103246016,
    ],
    '071435009233': [
      7.944783143032489, 50.58559940625424, 7.972647332836259, 50.60115528507703,
    ],
    '071435009238': [
      7.948475189907357, 50.57485305540936, 7.978346616040355, 50.58858256406873,
    ],
    '071435009242': [
      7.937692571402529, 50.59673399549512, 8.021200971385325, 50.63749398857029,
    ],
    '071435009247': [
      7.888618485253101, 50.54368452108302, 7.921893781106594, 50.557466017275786,
    ],
    '071435009249': [
      7.918923028012371, 50.540514852846876, 7.953822915194457, 50.56501233974936,
    ],
    '071435009254': [
      7.891174210358624, 50.57235300308714, 7.939996499953498, 50.602386403642676,
    ],
    '071435009284': [
      7.980947960706192, 50.58232434836869, 8.022202969805823, 50.60909328045422,
    ],
    '071435009288': [
      7.865951015810466, 50.58429831846963, 7.893271166317192, 50.61788902064689,
    ],
    '071435009289': [
      7.867029081154446, 50.541089755130734, 7.915594576598416, 50.57509336954047,
    ],
    '071435009293': [
      7.971805881554006, 50.57941985746635, 8.000440502386391, 50.59687513507374,
    ],
    '071435009298': [
      7.888301202310937, 50.59617502088487, 7.923991727075816, 50.616904234036696,
    ],
    '071435009307': [
      7.944705493347072, 50.515616821211346, 7.990818580257873, 50.53651345771139,
    ],
    '071435009308': [
      7.923579187128423, 50.532863897898714, 8.008266278894698, 50.59054143905445,
    ],
    '071435009312': [
      7.963073112915523, 50.52519766051921, 7.996416751031204, 50.551935709624146,
    ],
    '071435009314': [
      7.991031827260652, 50.56672408115283, 8.025870762661436, 50.58851666770698,
    ],
    '071435010003': [
      7.826750514852631, 50.46235403149869, 7.852649284083417, 50.47691152628526,
    ],
    '071435010010': [
      7.732115146505008, 50.43033345291378, 7.820003934643375, 50.46480561775408,
    ],
    '071435010012': [
      7.753453419884269, 50.46009336321157, 7.783277729004144, 50.47780569094368,
    ],
    '071435010028': [
      7.795823047310467, 50.499355820808525, 7.832148512646499, 50.52964030746742,
    ],
    '071435010042': [
      7.787112632445356, 50.48160629887229, 7.828803263134915, 50.50192918102033,
    ],
    '071435010047': [
      7.726818334673313, 50.48120021637022, 7.777063504482757, 50.49971620549939,
    ],
    '071435010049': [
      7.822416144222914, 50.47295230665862, 7.853807139070947, 50.49447613909859,
    ],
    '071435010060': [
      7.81432117137557, 50.490813312432216, 7.862990224690935, 50.52776545814777,
    ],
    '071435010070': [
      7.750852131372988, 50.476937092190724, 7.793472085288429, 50.49584716334801,
    ],
    '071435010073': [
      7.811804774345585, 50.4544149658916, 7.851301015192875, 50.470950809401465,
    ],
    '071435010081': [
      7.7360165626285, 50.43797502789507, 7.826828368507019, 50.489458372008286,
    ],
    '071435010275': [
      7.822201393376257, 50.517595214521094, 7.854006435560025, 50.53993422814319,
    ],
    '072110000000': [
      6.553475030504598, 49.69973539901346, 6.742912584416643, 49.85665960202474,
    ],
    '072310134134': [
      6.834643468606678, 49.955969632317704, 6.978241345217882, 50.03070181774293,
    ],
    '072310502502': [
      7.003713081440732, 49.73930505478151, 7.230769055017948, 49.87601837266526,
    ],
    '072315001008': [
      6.977517662542058, 49.89337875531597, 7.107446650316942, 49.95815933346933,
    ],
    '072315001012': [
      6.96115252554689, 49.83492205860122, 7.041937290730968, 49.916984874312966,
    ],
    '072315001016': [
      6.984660982046771, 49.85379447630104, 7.032383874583901, 49.89252610220191,
    ],
    '072315001030': [
      7.008465756057237, 49.96455404793459, 7.044222024097705, 49.98891676051968,
    ],
    '072315001040': [
      7.023885497276606, 49.83896381276706, 7.066153512605928, 49.8645569218405,
    ],
    '072315001041': [
      7.047713005550413, 49.91225328909554, 7.114959786437508, 49.952575801633344,
    ],
    '072315001056': [
      7.189203092868049, 49.83562638117835, 7.263607266684603, 49.88587364845034,
    ],
    '072315001066': [
      6.919869147345613, 49.88785117345166, 6.97805585704093, 49.912616640225785,
    ],
    '072315001070': [
      7.136206899097107, 49.86329877022263, 7.221786011102242, 49.9157131739105,
    ],
    '072315001071': [
      7.121530528090815, 49.858010508306855, 7.149958393651802, 49.884520239419366,
    ],
    '072315001075': [
      7.00357460065965, 49.91523258233829, 7.048044503465674, 49.943459695943076,
    ],
    '072315001076': [
      7.03148573938086, 49.95786380601849, 7.059223236176127, 49.9804591598671,
    ],
    '072315001077': [
      7.102806831488072, 49.86639026486638, 7.14331140406312, 49.91225328909554,
    ],
    '072315001081': [
      6.945846529868357, 49.912616640225785, 7.013240306311032, 49.951241289673554,
    ],
    '072315001086': [
      6.892642189558721, 49.86182369348036, 6.950212270894611, 49.9092691739262,
    ],
    '072315001087': [
      7.05285542997347, 49.85730304339814, 7.107145485613834, 49.90132121850568,
    ],
    '072315001090': [
      7.000235306610778, 49.885986494102404, 7.053670963137516, 49.916984874312966,
    ],
    '072315001092': [
      6.874804715717183, 49.82365688820844, 6.944207333732762, 49.882069508814,
    ],
    '072315001105': [
      6.8723089102972, 49.82713645105322, 6.982448383673483, 49.89669660531911,
    ],
    '072315001125': [
      6.981441603452395, 49.96976310068044, 7.02631138709574, 50.00318148088039,
    ],
    '072315001126': [
      7.007356026013119, 49.840627815791336, 7.077738156974101, 49.903778299229046,
    ],
    '072315001133': [
      6.943349985892374, 49.82754395321111, 7.032246937419649, 49.90007210156446,
    ],
    '072315001136': [
      6.955550054222135, 49.9467385701681, 7.059223236176127, 50.00873270096457,
    ],
    '072315006006': [
      6.941704647659, 49.7697082905689, 6.983298970202227, 49.811870952416015,
    ],
    '072315006017': [
      6.94629650150402, 49.72331569350081, 6.977509304915928, 49.74130283052204,
    ],
    '072315006018': [
      7.032767847875226, 49.742539653077465, 7.070659009510634, 49.76740881386643,
    ],
    '072315006019': [
      6.965918088795554, 49.7251868640389, 6.989938256944722, 49.741162683380196,
    ],
    '072315006032': [
      7.004417131130781, 49.77132677465476, 7.037309897746097, 49.794448224568,
    ],
    '072315006035': [
      6.979097121006506, 49.764317392270584, 7.012134076102497, 49.78866950778638,
    ],
    '072315006042': [
      6.968327164540778, 49.78850219041678, 7.007420502136204, 49.801999491051504,
    ],
    '072315006054': [
      6.977509304915928, 49.707246932353044, 7.104107510332443, 49.743906586254,
    ],
    '072315006058': [
      6.944207333732762, 49.798902013105625, 7.004566421208144, 49.84189315612007,
    ],
    '072315006064': [
      7.007344665179549, 49.756390067658586, 7.037924291972561, 49.78266000282559,
    ],
    '072315006078': [
      6.94984118617525, 49.737401547098735, 6.977509304915928, 49.75516091277555,
    ],
    '072315006079': [
      6.961939025813285, 49.673065972316344, 7.082691432272139, 49.72552290499893,
    ],
    '072315006083': [
      6.993448863521732, 49.794448224568, 7.020399756776326, 49.82122139439907,
    ],
    '072315006093': [
      6.918714393787488, 49.735870330790576, 6.953269218399058, 49.75556967711792,
    ],
    '072315006112': [
      7.037309897746097, 49.76118598616098, 7.065216582235348, 49.78266000282559,
    ],
    '072315006115': [
      6.902044399087095, 49.74801776910079, 6.945598635856342, 49.77996474687267,
    ],
    '072315006122': [
      6.944714651979785, 49.749266612791224, 6.975942263692329, 49.770354713907594,
    ],
    '072315006123': [
      6.960801835297834, 49.72734283322042, 7.085142364691196, 49.777313511676596,
    ],
    '072315006202': [
      6.896387227220729, 49.76258639302119, 6.935317479515404, 49.77937890407105,
    ],
    '072315006203': [
      6.875196106404899, 49.76935152861739, 6.941704647659, 49.790637742717465,
    ],
    '072315006204': [
      6.898990287896807, 49.77996474687267, 6.961019719529089, 49.817759571097376,
    ],
    '072315008001': [
      6.859540389272855, 49.92105855818734, 6.933602376175402, 49.97157066662099,
    ],
    '072315008003': [
      6.717927031753087, 49.945310941428396, 6.770374042445727, 49.970279222245054,
    ],
    '072315008007': [
      6.775425569056075, 49.951435898338566, 6.854023933860114, 49.99049658295224,
    ],
    '072315008009': [
      6.718302409922485, 50.05172734394882, 6.808304540493797, 50.09583227716983,
    ],
    '072315008010': [
      6.68148530751718, 49.940153747386915, 6.74228684665508, 49.98368278286112,
    ],
    '072315008013': [
      6.763166648272866, 49.939899257839755, 6.808216722564188, 49.978755891681914,
    ],
    '072315008021': [
      6.877737129561615, 50.07820349669279, 6.904514778924953, 50.08761464209737,
    ],
    '072315008022': [
      6.745748340299922, 49.88939249444066, 6.772485885975948, 49.91047663141835,
    ],
    '072315008023': [
      6.76106833930552, 49.910012459441695, 6.796456748587262, 49.93258061247322,
    ],
    '072315008024': [
      6.792326314449963, 49.927010566120586, 6.865309417428873, 49.964600475823225,
    ],
    '072315008025': [
      6.808855487378962, 50.09659018851577, 6.877143445167225, 50.1301825673062,
    ],
    '072315008026': [
      6.697697747144258, 50.0291006171473, 6.761662216218513, 50.07658679723553,
    ],
    '072315008031': [
      6.837985805113867, 49.886870607012945, 6.863638728635374, 49.90809574889047,
    ],
    '072315008036': [
      6.844142582325974, 50.03210645891431, 6.87384449038196, 50.056488037918236,
    ],
    '072315008037': [
      6.7619144815451, 49.922874794463645, 6.800019873217529, 49.94556580168795,
    ],
    '072315008044': [
      6.884724136330358, 50.017561943281635, 6.91980504441836, 50.04591678447907,
    ],
    '072315008046': [
      6.751422161797523, 50.01288059577116, 6.831730790717164, 50.055037935933356,
    ],
    '072315008049': [
      6.895378447282951, 50.03297012334533, 6.934697823155318, 50.07418367061788,
    ],
    '072315008050': [
      6.769053062911626, 49.894481994369805, 6.807627212052712, 49.91812592443122,
    ],
    '072315008051': [
      6.711937118675625, 49.88049107675073, 6.765831316577843, 49.922874794463645,
    ],
    '072315008053': [
      6.761427733548259, 49.85333445846434, 6.839514869262166, 49.89493888846765,
    ],
    '072315008062': [
      6.797549150224625, 49.988962878653815, 6.855626540276132, 50.0022241507154,
    ],
    '072315008065': [
      6.754282627743548, 50.03742635246964, 6.819802341984143, 50.06683697205118,
    ],
    '072315008069': [
      6.857569030884235, 49.88377759247182, 6.902678306421653, 49.930043594184845,
    ],
    '072315008074': [
      6.822615335531166, 50.0667404197187, 6.880775393750386, 50.093311343199474,
    ],
    '072315008080': [
      6.775108504984024, 50.06525145654953, 6.828663279680358, 50.12186688692619,
    ],
    '072315008082': [
      6.697697747144258, 50.07202823442394, 6.78902457396893, 50.119116545325184,
    ],
    '072315008085': [
      6.808116601518019, 49.99595884036453, 6.865966855765474, 50.0259858470595,
    ],
    '072315008091': [
      6.786643151186825, 49.99876077965084, 6.818830314210873, 50.01420058735948,
    ],
    '072315008095': [
      6.868158964505821, 50.034720646504034, 6.909311203223224, 50.079397177352575,
    ],
    '072315008096': [
      6.927216541550972, 50.03936661474504, 6.970055166966222, 50.07992704192658,
    ],
    '072315008100': [
      6.81514488485085, 50.05034526845402, 6.878464625429956, 50.07265181304954,
    ],
    '072315008101': [
      6.909311203223224, 50.05944415160232, 6.953075903979324, 50.088010247898325,
    ],
    '072315008103': [
      6.886714499520356, 49.89976627401374, 6.97805585704093, 49.942549953467086,
    ],
    '072315008104': [
      6.814363625782941, 50.07502688581304, 6.857433063977312, 50.09924264071863,
    ],
    '072315008107': [
      6.922571573301062, 49.93666482141884, 6.979243094220284, 49.96164303776605,
    ],
    '072315008108': [
      6.846823602185955, 50.00853100571773, 6.899825948238481, 50.04149467907482,
    ],
    '072315008111': [
      6.825537097100786, 49.86414916606189, 6.874804715717183, 49.894883745895235,
    ],
    '072315008113': [
      6.794002737057132, 49.91306362087428, 6.889434730780319, 49.95031388795387,
    ],
    '072315008114': [
      6.817594121699972, 50.02457689802616, 6.851332523990159, 50.05121285289066,
    ],
    '072315008116': [
      6.698588034036667, 50.02023154546621, 6.751422161797523, 50.04246030074472,
    ],
    '072315008117': [
      6.794002737057132, 49.884841779195796, 6.869103738761036, 49.92061226758927,
    ],
    '072315008127': [
      6.854075715888395, 50.08538372095013, 6.902254886588826, 50.109016679604295,
    ],
    '072315008503': [
      6.703367673771533, 49.96928573160313, 6.799723159566136, 50.030081613582425,
    ],
    '072315008504': [
      6.697597110527881, 49.91294696150547, 6.771274312864012, 49.94616618014275,
    ],
    '072315009004': [
      6.951037966523144, 50.0000434087656, 7.013473847296279, 50.04424102467397,
    ],
    '072315009005': [
      6.98880770818946, 50.003246107880145, 7.098894529092589, 50.068512983659204,
    ],
    '072315009014': [
      7.11230832214432, 49.993044959858395, 7.143373254940108, 50.024970258235996,
    ],
    '072315009020': [
      6.933307288689143, 50.02873524686944, 6.962859783497806, 50.04290403004915,
    ],
    '072315009029': [
      7.115029631309111, 49.941449816160244, 7.21653488946342, 49.99356227539515,
    ],
    '072315009033': [
      6.904092402740853, 50.00550030060149, 6.958443810988619, 50.03297012334533,
    ],
    '072315009057': [
      6.953075903979324, 50.03639732180797, 7.057959631877694, 50.09886260223359,
    ],
    '072315009067': [
      7.010551833849306, 49.99371843658125, 7.044073101068958, 50.02558169108865,
    ],
    '072315009068': [
      7.006954870629481, 49.95943372002004, 7.080386737792312, 50.00733077805561,
    ],
    '072315009072': [
      7.059128190105739, 49.96592624621374, 7.122806998311516, 50.01792510679825,
    ],
    '072315009110': [
      7.064931421247031, 50.00096156595798, 7.127855686471891, 50.04871571399587,
    ],
    '072315009120': [
      7.133651080670024, 49.94319973738455, 7.157893205575451, 49.96278615258866,
    ],
    '072315009124': [
      7.047713005550413, 49.905509285003134, 7.175432743423892, 49.984786844978146,
    ],
    '072315009132': [
      6.91980504441836, 50.02873524686944, 6.95289346212486, 50.0460987117977,
    ],
    '072315009206': [
      7.187849581432863, 49.91247229673714, 7.252200076368994, 49.95218103904685,
    ],
    '072315009501': [
      7.148377805512812, 49.90126412921604, 7.225659575871046, 49.94456424732019,
    ],
    '072320018018': [
      6.452658716530921, 49.935257544819386, 6.587285179951795, 50.01892095261184,
    ],
    '072325001201': [
      6.23660861619314, 50.05807717477185, 6.327832443068748, 50.11337208141044,
    ],
    '072325001211': [
      6.374952022252817, 50.107703906424916, 6.41533245318664, 50.132106628030364,
    ],
    '072325001212': [
      6.113382674699259, 50.058177198686764, 6.176219390093806, 50.11915785915204,
    ],
    '072325001213': [
      6.156605348181719, 50.02707137683132, 6.20727161929655, 50.0864614740312,
    ],
    '072325001214': [
      6.113382674699259, 50.04230964597745, 6.163773683861762, 50.06425759431534,
    ],
    '072325001217': [
      6.375628594434537, 50.12470395848793, 6.404253758915279, 50.13847909448647,
    ],
    '072325001220': [
      6.170362614806857, 50.092121967363546, 6.213968918269167, 50.12174409587418,
    ],
    '072325001221': [
      6.289810959618023, 50.12451824085753, 6.315018337892995, 50.14928655032594,
    ],
    '072325001229': [
      6.186783446819917, 50.147527998585915, 6.22379534435823, 50.178682201046314,
    ],
    '072325001233': [
      6.393581346088475, 50.092982170449176, 6.428327641276524, 50.10773076513807,
    ],
    '072325001234': [
      6.138038192784807, 50.13055061141079, 6.189432773085483, 50.150684279552635,
    ],
    '072325001240': [
      6.189432773085483, 50.12117246230788, 6.220588015309192, 50.1409438951421,
    ],
    '072325001245': [
      6.195999670850113, 50.06917792578909, 6.250265525006991, 50.09661780461399,
    ],
    '072325001246': [
      6.206186200912153, 50.03728566134786, 6.251149745363052, 50.06099668330538,
    ],
    '072325001247': [
      6.218592863324858, 50.14180073375625, 6.255488652594068, 50.167484911454345,
    ],
    '072325001248': [
      6.234429046509765, 50.05803928470168, 6.254148824060769, 50.07484958278253,
    ],
    '072325001249': [
      6.323869072177914, 50.112108305752336, 6.345943485715061, 50.12424342193213,
    ],
    '072325001253': [
      6.311317917361591, 50.05358819997405, 6.364668893882697, 50.083996264252704,
    ],
    '072325001254': [
      6.379548056112511, 50.07676085191451, 6.408803895406538, 50.10017788579362,
    ],
    '072325001255': [
      6.37724118538978, 50.10017788579362, 6.428327641276524, 50.120686157233955,
    ],
    '072325001258': [
      6.301082482245164, 50.076247432532675, 6.364668893882697, 50.09673862972789,
    ],
    '072325001259': [
      6.197822163831813, 50.12556602161928, 6.244018805069063, 50.150633164194154,
    ],
    '072325001260': [
      6.268293428605311, 50.09271337540883, 6.341790085158076, 50.13277595332951,
    ],
    '072325001261': [
      6.35802734066638, 50.12972995521946, 6.385777226008935, 50.14526079519528,
    ],
    '072325001262': [
      6.31032495350639, 50.11768881008414, 6.370818300889495, 50.154583399181305,
    ],
    '072325001263': [
      6.133569396017767, 50.13289621923209, 6.200567899517941, 50.17842432558089,
    ],
    '072325001264': [
      6.29845652913483, 50.087782738553955, 6.353816443041774, 50.112108305752336,
    ],
    '072325001267': [
      6.381200441424677, 50.04900938381711, 6.418315303291333, 50.079255898404405,
    ],
    '072325001270': [
      6.341790085158076, 50.112108305752336, 6.37961511515364, 50.132423154194285,
    ],
    '072325001277': [
      6.362014510488477, 50.06582681015833, 6.383894328867149, 50.083996264252704,
    ],
    '072325001285': [
      6.351095731999076, 50.03174647873505, 6.420349952979335, 50.07293780873619,
    ],
    '072325001287': [
      6.193832171377825, 50.04572984816533, 6.241003562462419, 50.072727112698026,
    ],
    '072325001291': [
      6.354797735325793, 50.10086342851569, 6.379094721820424, 50.11771418789735,
    ],
    '072325001293': [
      6.395261291423844, 50.05139344236687, 6.449378498513584, 50.10773076513807,
    ],
    '072325001294': [
      6.132918212309007, 50.0229237417793, 6.179175652050389, 50.05284738278425,
    ],
    '072325001297': [
      6.199972494260808, 50.08926397051128, 6.237231579982558, 50.12174409587418,
    ],
    '072325001298': [
      6.165511606021772, 50.074293989297864, 6.199972494260808, 50.10438847360658,
    ],
    '072325001301': [
      6.155506925509985, 50.10743822970421, 6.203959510902994, 50.13289621923209,
    ],
    '072325001309': [
      6.213968918269167, 50.114669715876126, 6.236531927861639, 50.126437145444086,
    ],
    '072325001310': [
      6.129362842824518, 50.11060061214062, 6.174496366022884, 50.13183545303409,
    ],
    '072325001315': [
      6.306446639626118, 50.1314670740363, 6.326547686574674, 50.14417373595389,
    ],
    '072325001322': [
      6.341790085158076, 50.08194641680006, 6.393581346088475, 50.11679259634463,
    ],
    '072325001333': [
      6.221603684612835, 50.10376224975857, 6.2928477306161, 50.15868964853818,
    ],
    '072325005001': [
      6.133374118458606, 50.01219327360182, 6.171155034723213, 50.02448233627041,
    ],
    '072325005002': [
      6.441712306437331, 49.87646259629221, 6.494877553627063, 49.898523024231395,
    ],
    '072325005003': [
      6.361130206384196, 50.003996152464026, 6.414624223069295, 50.03701437447983,
    ],
    '072325005004': [
      6.2460312303649, 49.88375632073774, 6.275253695510642, 49.906727048068504,
    ],
    '072325005005': [
      6.258400115155608, 50.028472074809734, 6.284129297452612, 50.067785689009234,
    ],
    '072325005008': [
      6.189171878982227, 49.95001533149228, 6.235569765874697, 49.984924670866036,
    ],
    '072325005011': [
      6.323682968836848, 50.026722137145164, 6.379861372185052, 50.05389019511514,
    ],
    '072325005012': [
      6.21755510403401, 49.954630632087586, 6.255006434458251, 49.995244249369605,
    ],
    '072325005016': [
      6.286983051207634, 49.87339132478847, 6.342780266835175, 49.89390780709769,
    ],
    '072325005019': [
      6.321826713913471, 49.827920130702694, 6.398881626463796, 49.874328351182086,
    ],
    '072325005022': [
      6.336652704132728, 49.951171152949726, 6.364241502634107, 49.96977317462953,
    ],
    '072325005025': [
      6.173239674702582, 49.99599614916198, 6.200630292119738, 50.01156158431691,
    ],
    '072325005028': [
      6.393231161528667, 49.81131139640521, 6.45734755590838, 49.82963107183991,
    ],
    '072325005031': [
      6.249551447352376, 50.04380320958438, 6.281985230532054, 50.067785689009234,
    ],
    '072325005033': [
      6.391733988750463, 49.82091265188996, 6.44060758820351, 49.85963462881141,
    ],
    '072325005037': [
      6.374182194261028, 49.84122893276114, 6.433405027396502, 49.880463590268285,
    ],
    '072325005038': [
      6.318239003611176, 49.99190552879866, 6.35397037079797, 50.02747416709589,
    ],
    '072325005040': [
      6.241226587379097, 49.94172914566298, 6.283033343186684, 49.96209550895801,
    ],
    '072325005041': [
      6.153509296668425, 49.982589928336544, 6.182324629466838, 50.00212600443435,
    ],
    '072325005042': [
      6.22783509949712, 49.8954139153255, 6.264256885747983, 49.91971662167427,
    ],
    '072325005047': [
      6.281985230532054, 50.04549543922567, 6.316955717476628, 50.077643755304045,
    ],
    '072325005049': [
      6.212191382605904, 49.995244249369605, 6.241777013035728, 50.0125014969267,
    ],
    '072325005053': [
      6.383591594284135, 49.87155460926935, 6.443714540919476, 49.90566856530374,
    ],
    '072325005054': [
      6.300786391264781, 49.90348002536845, 6.330116785273646, 49.92053560620458,
    ],
    '072325005056': [
      6.235731148066996, 50.00477111011462, 6.269087929764822, 50.02109372983994,
    ],
    '072325005059': [
      6.279040905283636, 49.91489412525313, 6.312764136052341, 49.94094006197674,
    ],
    '072325005063': [
      6.433405027396502, 49.82704235054294, 6.476335550312115, 49.86081352693985,
    ],
    '072325005064': [
      6.199179540635162, 50.01060404984189, 6.243248921495288, 50.038680136585235,
    ],
    '072325005065': [
      6.472634590947133, 49.86177200054966, 6.512379385269498, 49.88975493717801,
    ],
    '072325005066': [
      6.165536015304665, 49.96316892926908, 6.189171878982227, 49.982589928336544,
    ],
    '072325005067': [
      6.217993530092443, 49.88949498877623, 6.308542783974341, 49.95770025444539,
    ],
    '072325005068': [
      6.219422710451747, 49.98671125198387, 6.262484599289998, 50.00825747936024,
    ],
    '072325005069': [
      6.290277235108693, 49.88279121750332, 6.347848746693472, 49.908747113814506,
    ],
    '072325005072': [
      6.253709253398396, 49.933639881866476, 6.304712774842465, 49.97472129299662,
    ],
    '072325005073': [
      6.242089503350118, 50.018890461668484, 6.276429052415025, 50.03353150925638,
    ],
    '072325005078': [
      6.461840871088097, 49.8297166981162, 6.503278668941584, 49.84856129213857,
    ],
    '072325005080': [
      6.303296905135114, 49.92646699537889, 6.366262173427562, 49.97541628553202,
    ],
    '072325005082': [
      6.449840179378279, 49.813274844399295, 6.49116885367874, 49.83595875282746,
    ],
    '072325005084': [
      6.250353348712605, 49.978498885761574, 6.282186298189521, 50.00477111011462,
    ],
    '072325005085': [
      6.250353348712605, 49.968463715996265, 6.277349591668018, 49.9859639172553,
    ],
    '072325005088': [
      6.262484599289998, 49.98290458944917, 6.319182429809002, 50.028472074809734,
    ],
    '072325005090': [
      6.318218149711929, 49.97821269523069, 6.343465126632162, 49.99244110672768,
    ],
    '072325005093': [
      6.448036017214055, 49.84654114493834, 6.505976300577447, 49.877408903435324,
    ],
    '072325005094': [
      6.352004515748848, 49.94382297505233, 6.376157786234079, 49.95978058551435,
    ],
    '072325005095': [
      6.310523650478328, 49.869109578803034, 6.383591594284135, 49.93379126438042,
    ],
    '072325005102': [
      6.331592682090082, 49.97541628553202, 6.369528622436763, 50.01170249228073,
    ],
    '072325005103': [
      6.382877021547664, 49.89711985457127, 6.4310450602209, 49.92103920793889,
    ],
    '072325005106': [
      6.276429052415025, 50.02259787493049, 6.301420231775926, 50.04686103712242,
    ],
    '072325005108': [
      6.418541252031446, 49.85963462881141, 6.448379212030662, 49.883400405732615,
    ],
    '072325005110': [
      6.171465272591179, 49.97758157045184, 6.220127741370386, 50.001386219182855,
    ],
    '072325005112': [
      6.220021813021212, 49.914410879929555, 6.243439255637684, 49.932149949070904,
    ],
    '072325005114': [
      6.363057632262843, 49.880463590268285, 6.400846992351821, 49.9144063259377,
    ],
    '072325005116': [
      6.190049566845381, 49.99696580040691, 6.216854733146066, 50.01831661670417,
    ],
    '072325005117': [
      6.295057150949709, 50.0080365133861, 6.336625226437157, 50.0381460680318,
    ],
    '072325005121': [
      6.159523406591653, 49.99974095073172, 6.205741382969583, 50.0337479074833,
    ],
    '072325005122': [
      6.301002638689353, 49.96769357861284, 6.343465126632162, 49.98698979522969,
    ],
    '072325005127': [
      6.138040438168468, 49.99041442188143, 6.164072770333915, 50.014286240789886,
    ],
    '072325005128': [
      6.300247365466334, 50.03784557087141, 6.334259674379594, 50.05534353176148,
    ],
    '072325005130': [
      6.17156569026105, 49.94891815046507, 6.206941360091419, 49.97758157045184,
    ],
    '072325005131': [
      6.258917373384723, 49.853077254285324, 6.348411310346312, 49.89138480624036,
    ],
    '072325005132': [
      6.351566841362358, 49.99895974006964, 6.396639651078134, 50.029784813081434,
    ],
    '072325005138': [
      6.235260079361002, 50.03106105381269, 6.264906614158339, 50.044691182612574,
    ],
    '072325005218': [
      6.487596877965993, 49.839017115693316, 6.537919485013916, 49.86177200054966,
    ],
    '072325005225': [
      6.505976300577447, 49.86035626842486, 6.544854575609655, 49.88405317763865,
    ],
    '072325005503': [
      6.273018030858672, 49.96308361665161, 6.316102041501902, 49.99916926577133,
    ],
    '072325006202': [
      6.286689725661608, 50.2609612963413, 6.385883575381515, 50.32317404472985,
    ],
    '072325006206': [
      6.259928013198095, 50.22527790196297, 6.315532945925043, 50.266642505489834,
    ],
    '072325006207': [
      6.271395035385429, 50.186501416184534, 6.337233228756642, 50.2392473840562,
    ],
    '072325006208': [
      6.295390922346312, 50.23273570740631, 6.371813860010119, 50.27967302756259,
    ],
    '072325006209': [
      6.532030262138912, 50.186293007910855, 6.596285717030182, 50.236297016235554,
    ],
    '072325006216': [
      6.412143986097671, 50.13408978655035, 6.453567420019731, 50.16075016859954,
    ],
    '072325006222': [
      6.428327641276524, 50.084135056786636, 6.473411836204811, 50.11343575161304,
    ],
    '072325006223': [
      6.474099375798811, 50.1823627788109, 6.521898312164017, 50.22216561610742,
    ],
    '072325006224': [
      6.436402432917142, 50.16748674047777, 6.477418725258067, 50.188313837507856,
    ],
    '072325006226': [
      6.433052666883619, 50.21443603640111, 6.51337818129616, 50.26511903519821,
    ],
    '072325006227': [
      6.371813860010119, 50.20779731932092, 6.436751809063272, 50.282220417987496,
    ],
    '072325006230': [
      6.238954927775056, 50.19928240690564, 6.28576505552777, 50.22741592580524,
    ],
    '072325006231': [
      6.238857550713029, 50.15174238436129, 6.304168446593573, 50.20238082639134,
    ],
    '072325006236': [
      6.160311919756112, 50.16492693655946, 6.240103892988162, 50.19594369406915,
    ],
    '072325006238': [
      6.411316852745399, 50.11549250535747, 6.442369203592989, 50.14246404256709,
    ],
    '072325006250': [
      6.462907219528939, 50.260478564976985, 6.517217856856934, 50.28576507080317,
    ],
    '072325006256': [
      6.426044349313938, 50.10578210700077, 6.478493830575379, 50.12472141792465,
    ],
    '072325006265': [
      6.271301814878278, 50.14571810976327, 6.318737953041537, 50.1644764507917,
    ],
    '072325006266': [
      6.368448004226968, 50.129566928858786, 6.416222235031559, 50.155633662073306,
    ],
    '072325006271': [
      6.226766684040074, 50.239141764207616, 6.276443716890499, 50.266642505489834,
    ],
    '072325006272': [
      6.443148316959261, 50.279953668097036, 6.48039024879695, 50.31307590768469,
    ],
    '072325006276': [
      6.419291871847658, 50.15310648840876, 6.439213983527226, 50.165769115885915,
    ],
    '072325006279': [
      6.468297080933326, 50.08113098221598, 6.505828239206678, 50.108673348890534,
    ],
    '072325006280': [
      6.432771918872148, 50.11918915082277, 6.468768545190536, 50.14726253014027,
    ],
    '072325006283': [
      6.278241043527152, 50.25076445262635, 6.338902805637767, 50.28716519417204,
    ],
    '072325006284': [
      6.409107939085283, 50.1587000958118, 6.450131129891982, 50.17448121186256,
    ],
    '072325006288': [
      6.396298005896343, 50.254933018695084, 6.48039024879695, 50.29740323023799,
    ],
    '072325006290': [
      6.368448004226968, 50.152297457280106, 6.409367558756141, 50.17788525920887,
    ],
    '072325006292': [
      6.325000837412913, 50.16967676724561, 6.37497985298572, 50.18918577530923,
    ],
    '072325006295': [
      6.29264764328309, 50.148308170709456, 6.377783716603917, 50.20224236323983,
    ],
    '072325006296': [
      6.35031425633221, 50.1754602011842, 6.452182725846658, 50.23395898455735,
    ],
    '072325006300': [
      6.39804945930396, 50.17027027890557, 6.492076492617715, 50.2150025288205,
    ],
    '072325006302': [
      6.357664254946743, 50.27473636094574, 6.443204374475074, 50.32326812055617,
    ],
    '072325006304': [
      6.447101542706962, 50.12472141792465, 6.503562472161454, 50.17701148578285,
    ],
    '072325006305': [
      6.499344269647493, 50.216323570008946, 6.569291984813669, 50.27698718790849,
    ],
    '072325006307': [
      6.486137942972533, 50.127076995014576, 6.549256148674882, 50.15876028608137,
    ],
    '072325006308': [
      6.322178704271566, 50.18913558496453, 6.384066472559086, 50.2609612963413,
    ],
    '072325006318': [
      6.504352912208348, 50.15508636949787, 6.564487333721377, 50.21852698586906,
    ],
    '072325006320': [
      6.3173826916479, 50.17467142521483, 6.387231293170244, 50.200625115724094,
    ],
    '072325006321': [
      6.468768545190536, 50.10674132125842, 6.521140834199207, 50.13353599125243,
    ],
    '072325006327': [
      6.402158254856468, 50.14000307646925, 6.427725409082782, 50.159760439260424,
    ],
    '072325006328': [
      6.214320976176563, 50.223447149594705, 6.267403684168848, 50.25947703651323,
    ],
    '072325006329': [
      6.167615480846805, 50.18229612464964, 6.257455377248722, 50.2572104112291,
    ],
    '072325006332': [
      6.4732982294221, 50.14604432296753, 6.552131501693313, 50.18797896958664,
    ],
    '072325007006': [
      6.597784447745989, 49.89156207805353, 6.629832082819532, 49.9047852223581,
    ],
    '072325007010': [
      6.639559825925934, 49.940335532172625, 6.680367268466006, 49.96624554280088,
    ],
    '072325007050': [
      6.678559715648825, 49.93108582418228, 6.707760154946472, 49.95709737999874,
    ],
    '072325007055': [
      6.599381776383522, 49.87694934733865, 6.632807286436221, 49.89622535497872,
    ],
    '072325007104': [
      6.622980071751039, 49.949684223887914, 6.642750403742338, 49.96028638183373,
    ],
    '072325007107': [
      6.613649202197311, 49.896951116198096, 6.666608008800343, 49.923867442226395,
    ],
    '072325007123': [
      6.613783542538875, 49.917313958028274, 6.700290164550292, 49.95385247669567,
    ],
    '072325007289': [
      6.626113373429448, 49.878592076339224, 6.7140009228193, 49.92488085150866,
    ],
    '072325007311': [
      6.663139627157303, 49.96423827462502, 6.72723570414492, 50.00877855146838,
    ],
    '072325008007': [
      6.582088608161327, 49.98939829896078, 6.631849315852916, 50.021087717215096,
    ],
    '072325008009': [
      6.36902855173684, 49.96914154017735, 6.410279292656965, 49.99895974006964,
    ],
    '072325008013': [
      6.383761648896941, 49.933769160470156, 6.44862224122875, 49.95529094297245,
    ],
    '072325008014': [
      6.48473771019624, 50.02583376571762, 6.521152880735163, 50.054215053536815,
    ],
    '072325008015': [
      6.42827261438897, 50.010312554803214, 6.471112889843199, 50.02939831141495,
    ],
    '072325008017': [
      6.452658716530921, 49.94335312030769, 6.503056125365848, 49.96435439484472,
    ],
    '072325008020': [
      6.411928734112994, 49.96873445798213, 6.466529854289085, 50.003996152464026,
    ],
    '072325008024': [
      6.587177741924123, 49.895678269731135, 6.614946953516641, 49.925219749590866,
    ],
    '072325008026': [
      6.422529054613692, 49.90566856530374, 6.47114775763502, 49.932826662160736,
    ],
    '072325008027': [
      6.614126651794536, 49.95427509372341, 6.685886845811015, 49.99294131173334,
    ],
    '072325008029': [
      6.394179685353119, 50.018756073830495, 6.42827261438897, 50.03457488155702,
    ],
    '072325008030': [
      6.445427753604399, 50.02939831141495, 6.486418413931951, 50.059888831440816,
    ],
    '072325008032': [
      6.354497667460864, 49.912088909734976, 6.382877021547664, 49.93054202830381,
    ],
    '072325008034': [
      6.504140463008723, 49.900910317334905, 6.553737409438533, 49.923658989374466,
    ],
    '072325008035': [
      6.557968346542365, 50.02468546269436, 6.587513339565708, 50.038127949842114,
    ],
    '072325008036': [
      6.383499738493573, 49.98035677120035, 6.421772223283602, 50.01075207517729,
    ],
    '072325008039': [
      6.525476478247058, 50.0039418486318, 6.571599373623031, 50.04359137696543,
    ],
    '072325008043': [
      6.623720992954294, 50.001177938858284, 6.6681236347478, 50.02840418102894,
    ],
    '072325008044': [
      6.59515075628327, 49.953679097724674, 6.628117686346742, 49.980042069590944,
    ],
    '072325008045': [
      6.361347557563622, 49.923550427457634, 6.391139292584875, 49.94401624255105,
    ],
    '072325008046': [
      6.414593255735165, 50.00875415053725, 6.431510979710795, 50.02386137773821,
    ],
    '072325008048': [
      6.440007000015047, 50.05091681935052, 6.479352161585269, 50.09919547274858,
    ],
    '072325008057': [
      6.369528622436763, 49.9873696054424, 6.40234726609962, 50.0077420942892,
    ],
    '072325008058': [
      6.566424455604797, 49.95481530499931, 6.60582292414303, 49.98047946558487,
    ],
    '072325008060': [
      6.542103954213787, 49.88405317763865, 6.597784447745989, 49.910845073450474,
    ],
    '072325008061': [
      6.542509472150502, 49.86322509575041, 6.584891658873098, 49.88715661347773,
    ],
    '072325008062': [
      6.427543343146012, 49.926576617204795, 6.469937534009541, 49.94384812421377,
    ],
    '072325008070': [
      6.580174795550643, 50.02658045270036, 6.617281820791078, 50.05320090128722,
    ],
    '072325008071': [
      6.602402895344828, 50.03837005022206, 6.636370332189029, 50.08591310242387,
    ],
    '072325008074': [
      6.464608069492442, 50.01207260219621, 6.494442803248319, 50.03333918337899,
    ],
    '072325008075': [
      6.557749828311199, 50.038127949842114, 6.602402895344828, 50.06899121783783,
    ],
    '072325008076': [
      6.529214242594873, 50.04088677171157, 6.580467366934409, 50.09076548182982,
    ],
    '072325008077': [
      6.492364923480666, 49.87134073650724, 6.544854575609655, 49.90901661830058,
    ],
    '072325008079': [
      6.447206890546082, 49.92602728745026, 6.503056125365848, 49.95770160678135,
    ],
    '072325008081': [
      6.574649949729025, 49.96965783359051, 6.616629033562033, 49.99495904379401,
    ],
    '072325008083': [
      6.389829491129106, 49.96198644777059, 6.412357205115742, 49.975815993155834,
    ],
    '072325008086': [
      6.490381714639624, 50.0023911798694, 6.535682230287292, 50.04359137696543,
    ],
    '072325008087': [
      6.541316860079635, 50.07276239171487, 6.593281256247132, 50.11089121119968,
    ],
    '072325008091': [
      6.470292058496836, 49.911325631704266, 6.515360196278294, 49.947214402591825,
    ],
    '072325008092': [
      6.411498426516931, 50.022627372038826, 6.464608069492442, 50.04079729604828,
    ],
    '072325008097': [
      6.501203398464654, 49.91862222952028, 6.534700883363022, 49.944005478178106,
    ],
    '072325008098': [
      6.409667836610814, 50.03487279343507, 6.456924447141422, 50.05934513807016,
    ],
    '072325008099': [
      6.402072076474281, 49.94774301212093, 6.456771708881774, 49.98682643717065,
    ],
    '072325008100': [
      6.373871423247411, 49.94233956448776, 6.402950710579073, 49.96421779605882,
    ],
    '072325008101': [
      6.608151568329885, 50.01680374427696, 6.648254009076601, 50.04444201260935,
    ],
    '072325008105': [
      6.629140024606937, 49.98138871447834, 6.671987412203572, 50.00147791895605,
    ],
    '072325008109': [
      6.453133640269923, 49.98073350959949, 6.527274908574354, 50.017677845263044,
    ],
    '072325008111': [
      6.557784668811651, 49.929704632312266, 6.628539497013107, 49.956982094540294,
    ],
    '072325008113': [
      6.576537220205385, 50.05320090128722, 6.628932615087221, 50.10285188730908,
    ],
    '072325008115': [
      6.531935378847318, 49.91791273662345, 6.568403858075821, 49.94201230817672,
    ],
    '072325008118': [
      6.465625620933134, 50.04601314118991, 6.502724832341298, 50.09463722230843,
    ],
    '072325008119': [
      6.490045806727352, 50.05075305767927, 6.516121168941444, 50.096732727681626,
    ],
    '072325008120': [
      6.502724832341298, 50.042454483876135, 6.542527594932877, 50.09675802812772,
    ],
    '072325008124': [
      6.37403112620682, 49.9144063259377, 6.412145372663673, 49.93870623296341,
    ],
    '072325008125': [
      6.551752407504009, 49.90987528780963, 6.621335383693253, 49.93416260515885,
    ],
    '072325008126': [
      6.572146681993071, 49.895678269731135, 6.597784447745989, 49.91518439905241,
    ],
    '072325008129': [
      6.581237028751846, 50.09645026109026, 6.609409838396648, 50.11009677446555,
    ],
    '072325008133': [
      6.397712286917831, 49.91942368418045, 6.435072077750055, 49.93590388137902,
    ],
    '072325008134': [
      6.431371041116003, 49.9999318198968, 6.47574710121367, 50.01854973634765,
    ],
    '072325008135': [
      6.547069233237825, 50.01575335897462, 6.614056933281708, 50.044804664233766,
    ],
    '072325008137': [
      6.4310450602209, 49.89431979698708, 6.508361484976342, 49.918144421615885,
    ],
    '072325008203': [
      6.525706269739411, 50.095671945351235, 6.546649594656501, 50.11454322289553,
    ],
    '072325008210': [
      6.502075705646937, 50.0857652029193, 6.590005621453579, 50.14604432296753,
    ],
    '072325008228': [
      6.656622616628611, 49.99845574642207, 6.713316716312203, 50.028927050468795,
    ],
    '072325008273': [
      6.545110223505407, 50.10575882340231, 6.570690488687635, 50.11548809997228,
    ],
    '072325008282': [
      6.641845072950257, 50.01859304884941, 6.718499781703213, 50.094762790739466,
    ],
    '072325008306': [
      6.631187784539829, 50.04284341470695, 6.673959649426256, 50.090015752276365,
    ],
    '072325008313': [
      6.614843967476626, 50.05460942067455, 6.663151932096892, 50.11748719937748,
    ],
    '072325008331': [
      6.603672990632958, 50.09645026109026, 6.629628958173439, 50.11324375261005,
    ],
    '072325008501': [
      6.411928734112994, 49.98073350959949, 6.476690377703747, 50.01069010764003,
    ],
    '072325008502': [
      6.341857838218846, 49.95495027644681, 6.391974842669681, 49.985416208147214,
    ],
    '072335001006': [
      6.74251298572712, 50.244937485364495, 6.773798510336364, 50.26589977380136,
    ],
    '072335001008': [
      6.761668013487841, 50.10821677341857, 6.805974633722443, 50.13354897145246,
    ],
    '072335001011': [
      6.813143319841538, 50.12186688692619, 6.858764120731699, 50.13706819070705,
    ],
    '072335001014': [
      6.872438021767584, 50.196921317928535, 6.914501682188495, 50.22956947866537,
    ],
    '072335001016': [
      6.922652972422847, 50.157349672479306, 6.971499670556765, 50.20011699517493,
    ],
    '072335001017': [
      6.693405093938981, 50.08950736042339, 6.755448895456801, 50.12137438295727,
    ],
    '072335001018': [
      6.76394525895941, 50.235160868017154, 6.821850221971411, 50.258993795140825,
    ],
    '072335001020': [
      6.769090167021866, 50.24176132506039, 6.849827635031597, 50.289460283541956,
    ],
    '072335001021': [
      6.890455549768079, 50.13926406178196, 6.933015155765279, 50.16682166202499,
    ],
    '072335001025': [
      6.888737486498728, 50.22731875125732, 6.926741262689504, 50.244207801821226,
    ],
    '072335001027': [
      6.865304458472338, 50.10094139719267, 6.956788178833134, 50.145824674397936,
    ],
    '072335001030': [
      6.730216100953405, 50.22132502338966, 6.783209337319403, 50.248542908396686,
    ],
    '072335001031': [
      6.861210256767761, 50.20466546927849, 6.898284189925868, 50.233385638277475,
    ],
    '072335001034': [
      6.943173992166052, 50.11615765221529, 6.99514242773731, 50.13959505406091,
    ],
    '072335001039': [
      6.724593146981907, 50.211648833905144, 6.769076591695955, 50.2385925498246,
    ],
    '072335001040': [
      6.84198752302559, 50.24555653016479, 6.864924072460339, 50.263123511478796,
    ],
    '072335001042': [
      6.855100408859421, 50.147078397237166, 6.915789833325102, 50.20004983765301,
    ],
    '072335001043': [
      6.660207244629966, 50.08354197029225, 6.706063769445235, 50.12441932573197,
    ],
    '072335001046': [
      6.900898176761279, 50.07418367061788, 6.950930537397357, 50.09710972432522,
    ],
    '072335001049': [
      6.833359055652672, 50.22510591207678, 6.880092538568668, 50.25161284211559,
    ],
    '072335001052': [
      6.735746001769439, 50.14001313896556, 6.785529391294632, 50.17134278992328,
    ],
    '072335001055': [
      6.718409566990586, 50.167289901510834, 6.79123625074818, 50.191012484959465,
    ],
    '072335001061': [
      6.859993453918616, 50.23129307561921, 6.905649749216442, 50.262186208066076,
    ],
    '072335001062': [
      6.880582590647325, 50.13339187700968, 6.904905987178607, 50.15261527239201,
    ],
    '072335001063': [
      6.819936273569842, 50.14581596436144, 6.877002017003005, 50.18672820068196,
    ],
    '072335001064': [
      6.914501682188495, 50.20011699517493, 6.956904719867594, 50.2313501003975,
    ],
    '072335001065': [
      6.696989563030715, 50.10949267385313, 6.779515394658749, 50.144381609578446,
    ],
    '072335001067': [
      6.903948407573418, 50.16431262529586, 6.942931553103374, 50.19157631577267,
    ],
    '072335001068': [
      6.887628362729859, 50.18164237833424, 6.953813128349895, 50.208929788013,
    ],
    '072335001070': [
      6.898391094665628, 50.09217901000332, 6.953620036394702, 50.1260964372647,
    ],
    '072335001071': [
      6.943511533292872, 50.07992704192658, 6.981521444841733, 50.122632548989976,
    ],
    '072335001074': [
      6.841955849795702, 50.122769748066325, 6.889786334236424, 50.15098157661937,
    ],
    '072335001075': [
      6.769182255256498, 50.119484221550245, 6.848781436058993, 50.170032748916135,
    ],
    '072335001077': [
      6.906642776367794, 50.208929788013, 6.942128045284783, 50.238189707469154,
    ],
    '072335001079': [
      6.692120062096379, 50.14404917184144, 6.737276370695063, 50.18750745372757,
    ],
    '072335001081': [
      6.655143385977647, 50.1121342596213, 6.7419929580254, 50.14964237553144,
    ],
    '072335001084': [
      6.931337716100745, 50.13409891822368, 6.97629108772961, 50.158725320323356,
    ],
    '072335001501': [
      6.751447458938435, 50.16085151125306, 6.87545959237929, 50.246220166744074,
    ],
    '072335004003': [
      6.87499530778326, 50.25493480809381, 6.905649749216442, 50.27537846564955,
    ],
    '072335004010': [
      6.840452633211482, 50.263123511478796, 6.896073269242097, 50.284241459402395,
    ],
    '072335004032': [
      6.914026796947744, 50.2313501003975, 6.948208024849728, 50.24920957130977,
    ],
    '072335004037': [
      6.896919547119462, 50.24192712892085, 6.937769435648575, 50.262186208066076,
    ],
    '072335004048': [
      6.849827635031597, 50.25006364189947, 6.88679716450067, 50.267435545431404,
    ],
    '072335004201': [
      7.004856930350019, 50.27486672011972, 7.060351130084248, 50.29290748790705,
    ],
    '072335004202': [
      6.951332599170655, 50.2764185504685, 6.976467052497325, 50.292053242131225,
    ],
    '072335004203': [
      6.942128045284783, 50.225371602218516, 6.978529658465789, 50.244856112000285,
    ],
    '072335004205': [
      6.837188722182045, 50.30212329247734, 6.87220983388244, 50.3261589935252,
    ],
    '072335004206': [
      6.803452788100721, 50.27763054958283, 6.856970363799665, 50.30447523796484,
    ],
    '072335004207': [
      6.801612754761317, 50.30043593835138, 6.83737639962478, 50.32376577889695,
    ],
    '072335004208': [
      6.971702129715751, 50.30668504134371, 6.99059276174532, 50.326546843315825,
    ],
    '072335004210': [
      6.977242053666385, 50.329728159286006, 7.010935904059808, 50.348974694415546,
    ],
    '072335004212': [
      6.848469117544121, 50.28344133766718, 6.888538556290957, 50.30242274274078,
    ],
    '072335004213': [
      6.968719588446604, 50.244856112000285, 6.983250784245989, 50.25890388323929,
    ],
    '072335004215': [
      6.992917129783289, 50.21909028083907, 7.026305461870166, 50.24608551572909,
    ],
    '072335004216': [
      6.937769435648575, 50.238857287440865, 6.969907735081653, 50.25538260979441,
    ],
    '072335004217': [
      7.017884202181444, 50.224393894776654, 7.036265603629003, 50.25305287876165,
    ],
    '072335004218': [
      6.859200366071582, 50.262186208066076, 6.957369030778896, 50.32312947414819,
    ],
    '072335004220': [
      6.976582585405767, 50.319375473866344, 7.020005675752325, 50.33786843054853,
    ],
    '072335004221': [
      6.969907735081653, 50.23671274907815, 6.992918329425699, 50.247457468132666,
    ],
    '072335004222': [
      6.95093261709615, 50.26480624668304, 6.99270759042924, 50.27886817038539,
    ],
    '072335004224': [
      7.010251017157078, 50.23628844476916, 7.057716547189551, 50.26778028593693,
    ],
    '072335004225': [
      6.949940095280551, 50.272944125456526, 7.005586054687545, 50.30668504134371,
    ],
    '072335004226': [
      6.912789636553748, 50.25387876952454, 6.955069662545176, 50.27345474872351,
    ],
    '072335004228': [
      7.010238317707384, 50.330386024770334, 7.039711356125788, 50.34212996929158,
    ],
    '072335004230': [
      7.029839165677592, 50.24844202235216, 7.069496445783042, 50.28232263607207,
    ],
    '072335004233': [
      6.943826472911603, 50.29898262456071, 6.973398923771012, 50.31487053600106,
    ],
    '072335004234': [
      6.986989976830328, 50.2593566161681, 7.035279894241332, 50.281953467947666,
    ],
    '072335004236': [
      6.95093261709615, 50.244856112000285, 6.986989976830328, 50.27130714618984,
    ],
    '072335004242': [
      6.981922264381867, 50.24566028152726, 7.024562161880623, 50.26480624668304,
    ],
    '072335004243': [
      6.905649749216442, 50.24920957130977, 6.942371905732464, 50.267144117152824,
    ],
    '072335004244': [
      6.943826472911603, 50.31475870241264, 6.977242053666385, 50.33786843054853,
    ],
    '072335006002': [
      6.59796421917737, 50.2905908188864, 6.623523830649447, 50.30602598224045,
    ],
    '072335006004': [
      6.698986504905818, 50.22393914436547, 6.734917185428741, 50.248122575550184,
    ],
    '072335006005': [
      6.658513210949525, 50.29142602037178, 6.7162420377012, 50.32861009835787,
    ],
    '072335006007': [
      6.609031995383261, 50.30495294193727, 6.652990967405455, 50.339538481685054,
    ],
    '072335006019': [
      6.642319415212151, 50.254592381407285, 6.692147506481713, 50.278849661169346,
    ],
    '072335006022': [
      6.574707763388272, 50.3473509002001, 6.624295733728424, 50.38842618198959,
    ],
    '072335006023': [
      6.589618964840566, 50.33425457725295, 6.636563142417185, 50.3540493423118,
    ],
    '072335006026': [
      6.561566499416699, 50.159522990412384, 6.734803295203675, 50.26240082487511,
    ],
    '072335006028': [
      6.547680977082844, 50.31780475793216, 6.617004107567154, 50.33621962030713,
    ],
    '072335006029': [
      6.627689303444529, 50.25460948666706, 6.706522667548581, 50.32033476663799,
    ],
    '072335006033': [
      6.712932271667055, 50.24317990175362, 6.743983925304129, 50.26589977380136,
    ],
    '072335006035': [
      6.529201080120675, 50.333827918621424, 6.603735646336535, 50.3784998543005,
    ],
    '072335006036': [
      6.569291984813669, 50.24624395468988, 6.630110079935397, 50.27885049055778,
    ],
    '072335006038': [
      6.685731424562854, 50.29005800412821, 6.753516622566751, 50.33736225850645,
    ],
    '072335006041': [
      6.53566898072022, 50.29939620123568, 6.631724315317618, 50.325974609250316,
    ],
    '072335006050': [
      6.711288108443314, 50.18067434143231, 6.761467461055354, 50.21228167707046,
    ],
    '072335006053': [
      6.601299094447053, 50.271053060302854, 6.637023318475691, 50.30495294193727,
    ],
    '072335006054': [
      6.734162326549313, 50.258993795140825, 6.804935497770756, 50.2985299329717,
    ],
    '072335006056': [
      6.672177432308374, 50.19397514038351, 6.715488826388058, 50.24633098495273,
    ],
    '072335006058': [
      6.667854289680269, 50.24230012590026, 6.714764168150433, 50.27159673015528,
    ],
    '072335006060': [
      6.644004505474126, 50.117972341354715, 6.717258721478196, 50.16016736197175,
    ],
    '072335006076': [
      6.699734278790311, 50.286535426283926, 6.816813610078255, 50.36309464232099,
    ],
    '072335006080': [
      6.687527770929337, 50.2622896298479, 6.752421318806156, 50.29647705630226,
    ],
    '072335006083': [
      6.636347787125197, 50.31765403395394, 6.699734278790311, 50.37197126991057,
    ],
    '072335006204': [
      6.586762228225382, 50.15211406371819, 6.683174253585985, 50.20016471983196,
    ],
    '072335006209': [
      6.57652194003234, 50.100150608988585, 6.676157513662914, 50.140411240034496,
    ],
    '072335006211': [
      6.517217856856934, 50.24624395468988, 6.582678504125696, 50.27698718790849,
    ],
    '072335006214': [
      6.385493659371398, 50.33271197394176, 6.460818181390023, 50.39080568429113,
    ],
    '072335006219': [
      6.468529495463261, 50.312052749671864, 6.514678430088245, 50.35268752143349,
    ],
    '072335006223': [
      6.551621075063573, 50.157797918211934, 6.597855971335628, 50.196535709868016,
    ],
    '072335006227': [
      6.549256148674882, 50.128374129440175, 6.672189624598477, 50.16443119448328,
    ],
    '072335006229': [
      6.769986743648944, 50.303474125420664, 6.818701978019327, 50.362495130875736,
    ],
    '072335006232': [
      6.418264685708748, 50.295777542858936, 6.484534880407887, 50.33989551793025,
    ],
    '072335006235': [
      6.472998041041699, 50.28333388550988, 6.519450381585641, 50.31307590768469,
    ],
    '072335006237': [
      6.385493659371398, 50.3506224084154, 6.431883774179855, 50.38424918943378,
    ],
    '072335006239': [
      6.545921816072606, 50.321273820372475, 6.586948124256987, 50.34403606555423,
    ],
    '072335006240': [
      6.485824577911948, 50.29880743200517, 6.558122843812734, 50.369293152960424,
    ],
    '072335006241': [
      6.511299707159428, 50.27215650669999, 6.602462702432685, 50.31117305475179,
    ],
    '072355001005': [
      6.866868803908075, 49.72757111976696, 6.911581434126306, 49.763687005130166,
    ],
    '072355001008': [
      6.858110735894575, 49.69380595596952, 6.949175297277326, 49.74857230999221,
    ],
    '072355001014': [
      6.976962980207086, 49.65384512830264, 7.022134491271657, 49.68052617746934,
    ],
    '072355001030': [
      6.929523883787346, 49.677400894663904, 6.973846927489565, 49.7251868640389,
    ],
    '072355001035': [
      6.866213624329989, 49.60269979242504, 6.932659691694989, 49.65473551044803,
    ],
    '072355001036': [
      6.890797881320557, 49.619634954779066, 6.932896664140071, 49.65994634574501,
    ],
    '072355001045': [
      6.899145018386598, 49.62479347769649, 6.991966764461168, 49.6904707796862,
    ],
    '072355001047': [
      6.88289346035794, 49.689415970313156, 6.924606545264477, 49.718056636935984,
    ],
    '072355001092': [
      6.866335624940879, 49.74552681506906, 6.902044399087095, 49.779710638711755,
    ],
    '072355001093': [
      7.003202274536027, 49.62664523593344, 7.06051595724713, 49.68983227263741,
    ],
    '072355001112': [
      6.916286841287222, 49.67417608182241, 6.954780643419321, 49.729691635805146,
    ],
    '072355001114': [
      6.842221224998106, 49.64235541150182, 6.917210567490353, 49.69658327895661,
    ],
    '072355001153': [
      6.988173034161832, 49.62277204836411, 7.036270926220648, 49.671501760021705,
    ],
    '072355003055': [
      6.558071966394921, 49.64534187760925, 6.586994261226772, 49.6782287032339,
    ],
    '072355003068': [
      6.519701986318165, 49.63417111264757, 6.672311702623553, 49.724660610701775,
    ],
    '072355003095': [
      6.422575798970102, 49.6156996485656, 6.523340633714696, 49.66800627499138,
    ],
    '072355003096': [
      6.47863678349584, 49.68543082588073, 6.517475354054333, 49.713148604465594,
    ],
    '072355003101': [
      6.469328339683778, 49.63066679013876, 6.506511452234579, 49.657973887318505,
    ],
    '072355003106': [
      6.653214978757225, 49.65168600030145, 6.688952716041682, 49.68956499478546,
    ],
    '072355003132': [
      6.482491749065374, 49.6547691288285, 6.536505411890466, 49.689153294714316,
    ],
    '072355003133': [
      6.449151645184127, 49.65977010978978, 6.497351631702286, 49.695958985569625,
    ],
    '072355003143': [
      6.51191672273855, 49.6877244162118, 6.561057056043262, 49.71383566416731,
    ],
    '072355003144': [
      6.521627431671604, 49.63663991764832, 6.560116800046508, 49.66247938776614,
    ],
    '072355003146': [
      6.426315961227597, 49.66081385065368, 6.466876708669027, 49.679998237128274,
    ],
    '072355003148': [
      6.574597981460738, 49.61136022276686, 6.651901054168241, 49.6782287032339,
    ],
    '072355004010': [
      6.747272870436091, 49.6820494114825, 6.800324665324903, 49.701417288113,
    ],
    '072355004021': [
      6.808417457977272, 49.70768977934364, 6.859285463976375, 49.734633627731284,
    ],
    '072355004037': [
      6.694625783927152, 49.695502135097506, 6.731777918901246, 49.71959643817631,
    ],
    '072355004038': [
      6.713558474159623, 49.70342099187013, 6.740073738717474, 49.72857272428059,
    ],
    '072355004044': [
      6.808417457977272, 49.72873443665353, 6.831973591142817, 49.75160843257339,
    ],
    '072355004046': [
      6.720137963598948, 49.651316673796515, 6.762983770972468, 49.67262177150063,
    ],
    '072355004050': [
      6.753457858471418, 49.6622741164186, 6.805962603554582, 49.688983445431454,
    ],
    '072355004056': [
      6.706015049208944, 49.747763107064934, 6.761386837087914, 49.77121206919879,
    ],
    '072355004070': [
      6.713558474159623, 49.7181820724747, 6.736710162805611, 49.736959859985014,
    ],
    '072355004080': [
      6.831150253467338, 49.72686086984929, 6.869729917693848, 49.75026019728564,
    ],
    '072355004085': [
      6.686822860439213, 49.753204113195785, 6.761386837087914, 49.783389820826415,
    ],
    '072355004090': [
      6.736710162805611, 49.69893319664786, 6.763573340417243, 49.737652965604546,
    ],
    '072355004100': [
      6.688781262118066, 49.660413398987046, 6.72097004193776, 49.68529906192102,
    ],
    '072355004103': [
      6.763573340417243, 49.66095104474583, 6.870690728917021, 49.736498927644185,
    ],
    '072355004107': [
      6.693295905558077, 49.675731952964405, 6.72897801082607, 49.700602445239525,
    ],
    '072355004116': [
      6.755463556337951, 49.701417288113, 6.774699657282587, 49.73677108175143,
    ],
    '072355004124': [
      6.718727003259128, 49.65290700821293, 6.774524331479341, 49.70822989977756,
    ],
    '072355004129': [
      6.731582853137236, 49.70822989977756, 6.750317311782052, 49.72857272428059,
    ],
    '072355004135': [
      6.784964073324325, 49.73015895150571, 6.818045079254821, 49.75813645250872,
    ],
    '072355004141': [
      6.714098608297625, 49.727642470192826, 6.788272218015591, 49.76682188881782,
    ],
    '072355006004': [
      6.790249423286016, 49.83167116840931, 6.829060055859336, 49.86221271391427,
    ],
    '072355006015': [
      6.837690679893099, 49.77811561686164, 6.880593099581633, 49.829827842713755,
    ],
    '072355006019': [
      6.802950689269819, 49.8177776998442, 6.843319185876946, 49.84839464748629,
    ],
    '072355006022': [
      6.757503585329335, 49.74685305427161, 6.833907508957979, 49.79583734784971,
    ],
    '072355006026': [
      6.732981699629825, 49.84890781521345, 6.796366716659514, 49.87897962280331,
    ],
    '072355006060': [
      6.700790782022314, 49.7919869181949, 6.747733147681246, 49.81606280874439,
    ],
    '072355006063': [
      6.819610012855247, 49.840354476621364, 6.887288526881586, 49.877668449748576,
    ],
    '072355006067': [
      6.855728198260375, 49.829827842713755, 6.887288526881586, 49.84493630210358,
    ],
    '072355006074': [
      6.859282147222996, 49.78446778697372, 6.915372618559298, 49.832537135056,
    ],
    '072355006077': [
      6.779076449593025, 49.80221709053044, 6.794215776065689, 49.82023357809572,
    ],
    '072355006078': [
      6.726813451200859, 49.781726687693045, 6.78677542634457, 49.81606280874439,
    ],
    '072355006083': [
      6.782363305261518, 49.74685305427161, 6.872652586213215, 49.836364473668965,
    ],
    '072355006091': [
      6.725738728061009, 49.86405522155618, 6.763209758816005, 49.89115071207431,
    ],
    '072355006108': [
      6.827123524478679, 49.78487563778248, 6.85766561318904, 49.812207332634166,
    ],
    '072355006115': [
      6.778158015018867, 49.77540240943689, 6.833907508957979, 49.80221709053044,
    ],
    '072355006120': [
      6.808758374319535, 49.809169745233355, 6.845882932812046, 49.819097892462075,
    ],
    '072355006125': [
      6.690278382503178, 49.81189096322813, 6.796366716659514, 49.8817009507276,
    ],
    '072355006134': [
      6.828984984419209, 49.82672535215856, 6.86123021553087, 49.842906478817625,
    ],
    '072355006207': [
      6.884083556031928, 49.80489235851438, 6.95045865316108, 49.84268805386244,
    ],
    '072355007001': [
      6.565170019968662, 49.77371059254886, 6.631449107906426, 49.804091357901804,
    ],
    '072355007027': [
      6.647305515258687, 49.68233479004015, 6.699345590148209, 49.71189413927698,
    ],
    '072355007048': [
      6.679915147149276, 49.6908489942388, 6.696257168602252, 49.70991801525481,
    ],
    '072355007051': [
      6.517475354054333, 49.70259460670425, 6.561057056043262, 49.74004759954703,
    ],
    '072355007069': [
      6.598101831681801, 49.80432679027074, 6.673809707929177, 49.87036012360355,
    ],
    '072355007073': [
      6.495347037032586, 49.711710973785486, 6.546559542895166, 49.76418790423344,
    ],
    '072355007094': [
      6.565170019968662, 49.78272416140825, 6.638965677018964, 49.827712657344065,
    ],
    '072355007111': [
      6.475518802370022, 49.76199085675855, 6.570125410713556, 49.84133275382087,
    ],
    '072355007137': [
      6.527051057375175, 49.73989014457102, 6.618455856884015, 49.79147059024422,
    ],
    '072355007151': [
      6.632807286436221, 49.85397935941888, 6.725436560684439, 49.91596707906425,
    ],
    '072355007501': [
      6.525332747068102, 49.820663921858795, 6.639774668019775, 49.895678269731135,
    ],
    '072355008002': [
      6.527126807202771, 49.62175050832322, 6.574609694734407, 49.646595195207595,
    ],
    '072355008003': [
      6.66429999137488, 49.608944128758566, 6.698175196140518, 49.62364452919504,
    ],
    '072355008025': [
      6.467995440823395, 49.604119581564426, 6.520672396592089, 49.63066679013876,
    ],
    '072355008028': [
      6.507345125944045, 49.52836442443205, 6.584238684442297, 49.56453703036081,
    ],
    '072355008033': [
      6.649416075920145, 49.53548354019079, 6.723206155843163, 49.57569458702355,
    ],
    '072355008040': [
      6.713384983240708, 49.63756847164807, 6.777993463828687, 49.66559945738269,
    ],
    '072355008043': [
      6.658796134004578, 49.608944128758566, 6.727318791618991, 49.637023042618,
    ],
    '072355008052': [
      6.573019218656991, 49.556381374252894, 6.650500293565819, 49.62009654166018,
    ],
    '072355008057': [
      6.533378388086999, 49.551979332768994, 6.583452724313749, 49.57646525420408,
    ],
    '072355008058': [
      6.765261586453899, 49.59245159399449, 6.868265620656391, 49.66497948849809,
    ],
    '072355008062': [
      6.424023023337726, 49.53075525363495, 6.533378388086999, 49.572178590407255,
    ],
    '072355008072': [
      6.672311702623553, 49.63695876134203, 6.729925964508305, 49.66994485579019,
    ],
    '072355008081': [
      6.715870475858628, 49.56922166689579, 6.8248380889496, 49.627079820815794,
    ],
    '072355008082': [
      6.48418105057456, 49.621385208391494, 6.529646368268479, 49.646636709668755,
    ],
    '072355008098': [
      6.568193972622142, 49.6149672581408, 6.602005903695855, 49.62953210633569,
    ],
    '072355008104': [
      6.358421964631198, 49.54347110107262, 6.440495446186493, 49.5987401045431,
    ],
    '072355008105': [
      6.651842122865355, 49.627297395623785, 6.702995667172889, 49.65168600030145,
    ],
    '072355008118': [
      6.483228873508196, 49.583705576209304, 6.622084533812652, 49.629034337291756,
    ],
    '072355008119': [
      6.705354802456619, 49.6044842471842, 6.802775513131766, 49.66095104474583,
    ],
    '072355008122': [
      6.574081243903464, 49.619652886537565, 6.627169032912404, 49.64255080998674,
    ],
    '072355008123': [
      6.683733008844894, 49.62666829060146, 6.718024648075743, 49.641504602848606,
    ],
    '072355008126': [
      6.548673897634636, 49.549452424144505, 6.651888754116622, 49.593379031729015,
    ],
    '072355008131': [
      6.563716578008291, 49.51755467782337, 6.654341102143784, 49.56644829396275,
    ],
    '072355008136': [
      6.507343807487373, 49.56453703036081, 6.553742222490452, 49.598466648883864,
    ],
    '072355008140': [
      6.619497011223331, 49.58248519063655, 6.674742559066591, 49.6370724613642,
    ],
    '072355008142': [
      6.786738337626817, 49.583078752465426, 6.839325710067616, 49.62545283840446,
    ],
    '072355008149': [
      6.38277567057952, 49.58139183753412, 6.48418105057456, 49.640214622482276,
    ],
    '072355008152': [
      6.650306345909048, 49.55625732612939, 6.769227129591187, 49.61451385653137,
    ],
    '072355008154': [
      6.428574712755283, 49.562007545679435, 6.522733055829616, 49.60783328313162,
    ],
    '073110000000': [
      8.30736711964244, 49.48487613725592, 8.422819890420103, 49.581981148919574,
    ],
    '073120000000': [
      7.630895584234817, 49.35765343505276, 7.870155223176042, 49.494876584208654,
    ],
    '073130000000': [
      7.865467521605622, 49.15498639394041, 8.180553832873894, 49.315564975806446,
    ],
    '073140000000': [
      8.298410559948087, 49.42804742148351, 8.464454999684817, 49.55238317457771,
    ],
    '073150000000': [
      8.143852551784969, 49.896225137843444, 8.347050720485084, 50.03542459712748,
    ],
    '073160000000': [
      7.996158519772212, 49.29657738833583, 8.317379671328503, 49.400712811559025,
    ],
    '073170000000': [
      7.515707971381409, 49.14506349024899, 7.676622571430753, 49.23390308356809,
    ],
    '073180000000': [
      8.378638426425372, 49.28239981402863, 8.487666055209061, 49.37548406192157,
    ],
    '073190000000': [
      8.237947456446797, 49.585863633129556, 8.448399242360956, 49.73522161605438,
    ],
    '073200000000': [
      7.289315100760335, 49.18820719296885, 7.448388071850429, 49.317059021302285,
    ],
    '073310003003': [
      8.040381826077382, 49.721285776347095, 8.165980600926584, 49.7724490700674,
    ],
    '073315001001': [
      8.098164263531311, 49.762245764807716, 8.15725651378027, 49.79380498344243,
    ],
    '073315001005': [
      7.988220988433407, 49.72215228186001, 8.017400792074664, 49.73626888241863,
    ],
    '073315001007': [
      8.173565399614821, 49.79112415913307, 8.23507318819515, 49.82447887703418,
    ],
    '073315001008': [
      8.088137780245352, 49.772281446353915, 8.115730931766276, 49.791762897450845,
    ],
    '073315001010': [
      8.134824318067503, 49.78638493892848, 8.183591791572248, 49.815083113970175,
    ],
    '073315001012': [
      8.047499661308319, 49.763459488268126, 8.080714796949986, 49.79968613636401,
    ],
    '073315001014': [
      8.13295552465606, 49.7034061295973, 8.153556158726703, 49.72186007435993,
    ],
    '073315001020': [
      8.14436098981647, 49.69739112597041, 8.185809340909142, 49.727821861167925,
    ],
    '073315001021': [
      8.001541082669062, 49.738651568071965, 8.060247118849041, 49.774184026064646,
    ],
    '073315001022': [
      8.101445433383711, 49.69869258351296, 8.14134750670042, 49.720592001245414,
    ],
    '073315001024': [
      8.102018689946433, 49.67782178707396, 8.185809340909142, 49.70586883403624,
    ],
    '073315001025': [
      7.995634105972952, 49.76805667739941, 8.068785235086594, 49.81453716336138,
    ],
    '073315001026': [
      8.148945264132067, 49.742783733857244, 8.215137675844012, 49.77531990150042,
    ],
    '073315001027': [
      8.048556110255692, 49.69520110709691, 8.102018689946433, 49.72170140084072,
    ],
    '073315001031': [
      8.153234443365475, 49.72658403300123, 8.207926774018087, 49.751861689671735,
    ],
    '073315001032': [
      8.157133919264924, 49.75586311808948, 8.233846322499222, 49.80281712509207,
    ],
    '073315001042': [
      8.111976047585856, 49.71515185886957, 8.153556158726703, 49.73159958826633,
    ],
    '073315001043': [
      8.068236972931459, 49.77108545271683, 8.098933743070502, 49.80205381789838,
    ],
    '073315001044': [
      8.017740416626642, 49.70015233869979, 8.07206098737475, 49.73092303739102,
    ],
    '073315001050': [
      7.980047369977134, 49.734292765686895, 8.022963812304301, 49.76064477391751,
    ],
    '073315001051': [
      7.953113281920479, 49.71815716703102, 7.998748829299577, 49.74574953018195,
    ],
    '073315001052': [
      8.117969072840639, 49.65926731555623, 8.185340667990504, 49.69313469489516,
    ],
    '073315001053': [
      7.959761825386323, 49.6965652806306, 8.052741557311439, 49.74401754486068,
    ],
    '073315001067': [
      8.080409537596507, 49.70484631555709, 8.112912925710196, 49.728085717478486,
    ],
    '073315002002': [
      8.286942760678887, 49.74426391384909, 8.354427328677689, 49.78362278954749,
    ],
    '073315002018': [
      8.351866790435489, 49.72478573685255, 8.458076092894116, 49.773904748841886,
    ],
    '073315002034': [
      8.351866790435489, 49.74426391384909, 8.417432296958706, 49.80360848107733,
    ],
    '073315002038': [
      8.407639297569736, 49.726327666852086, 8.479598174516273, 49.767870135159,
    ],
    '073315002045': [
      8.286942760678887, 49.732462213196584, 8.354206093261226, 49.74920643494699,
    ],
    '073315003023': [
      8.17354372563398, 49.644149065818276, 8.24038402635778, 49.67609121759784,
    ],
    '073315003041': [
      8.20503722631259, 49.60989772663052, 8.244599121230873, 49.62840212396864,
    ],
    '073315003046': [
      8.151199831195344, 49.64157943015023, 8.18741322204965, 49.666790055626585,
    ],
    '073315003047': [
      8.232671896442092, 49.64788856539995, 8.278831976157065, 49.67153786996726,
    ],
    '073315003048': [
      8.17840382764111, 49.620773087558426, 8.24038402635778, 49.64788856539995,
    ],
    '073315003054': [
      8.219155686136698, 49.58839085010553, 8.256295579623716, 49.61780014627696,
    ],
    '073315003066': [
      8.151885845061386, 49.625766210452376, 8.183685568808293, 49.6419185401694,
    ],
    '073315005017': [
      7.976723785325105, 49.77989763284752, 8.017700184570394, 49.81113028301133,
    ],
    '073315005030': [
      7.993072562829361, 49.81915092151532, 8.040150633937353, 49.8548920816223,
    ],
    '073315005035': [
      7.979484928930327, 49.807207736082894, 8.017700184570394, 49.81915092151532,
    ],
    '073315005060': [
      7.931007447853961, 49.77880686695773, 7.980290594311611, 49.807207736082894,
    ],
    '073315005062': [
      7.926923542226551, 49.74859519240956, 7.973934119115212, 49.777447181002074,
    ],
    '073315005070': [
      7.940531294729927, 49.73058699287506, 8.013598435214714, 49.78294349616445,
    ],
    '073315005072': [
      7.925305620483217, 49.801007571158294, 8.013792845068574, 49.83509438456666,
    ],
    '073315005075': [
      7.903718006810887, 49.74322339767042, 7.98896865467797, 49.79243589065139,
    ],
    '073315006004': [
      8.026718575947593, 49.79769408088857, 8.099351058301362, 49.82815997487879,
    ],
    '073315006019': [
      8.086128666272593, 49.79056088283665, 8.120633018231464, 49.81416956904806,
    ],
    '073315006029': [
      8.146056251069185, 49.808679658225756, 8.195130816100193, 49.83955464681274,
    ],
    '073315006033': [
      8.029401918324421, 49.838167132074375, 8.06550173972058, 49.86320549387611,
    ],
    '073315006056': [
      8.049641427522257, 49.86917758362465, 8.120943872282767, 49.897581626151336,
    ],
    '073315006058': [
      8.094058345332463, 49.847718741337566, 8.185377798185195, 49.89982833491257,
    ],
    '073315006059': [
      8.142400918266231, 49.83656328763191, 8.214509435106567, 49.859892340610095,
    ],
    '073315006061': [
      8.111331681260648, 49.791762897450845, 8.155640572630977, 49.824786942769485,
    ],
    '073315006063': [
      8.06550173972058, 49.82815997487879, 8.106032183838265, 49.861411775344386,
    ],
    '073315006064': [
      8.151358820468635, 49.85264791313462, 8.204365933298043, 49.88593034396157,
    ],
    '073315006065': [
      8.04868624621038, 49.85281439679882, 8.094058345332463, 49.871444082485866,
    ],
    '073315006068': [
      8.013792845068574, 49.81113028301133, 8.08079508266895, 49.85281439679882,
    ],
    '073315006073': [
      8.073830257748913, 49.8101003572884, 8.150093686691065, 49.86917758362465,
    ],
    '073315007006': [
      8.248503199843332, 49.7144317491262, 8.354206093261226, 49.74028413305589,
    ],
    '073315007009': [
      8.202323259575465, 49.67578503813373, 8.237687536098441, 49.68955741378842,
    ],
    '073315007011': [
      8.186529840916116, 49.712694016070316, 8.21622087005609, 49.73800168868861,
    ],
    '073315007015': [
      8.203791606949233, 49.731419068813004, 8.287502434040507, 49.76040890045513,
    ],
    '073315007028': [
      8.22939055927299, 49.75436346422921, 8.262731071816335, 49.76853354970783,
    ],
    '073315007036': [
      8.17130096952116, 49.672882339163976, 8.221131006701944, 49.712694016070316,
    ],
    '073315007037': [
      8.22248374664747, 49.66567609288128, 8.25933519114134, 49.6889381544154,
    ],
    '073315007039': [
      8.170730436860357, 49.700101615159156, 8.209968251955452, 49.732726815377056,
    ],
    '073315007049': [
      8.215875234236819, 49.714995899303474, 8.251599722732392, 49.73298659662278,
    ],
    '073315007055': [
      8.276229230901953, 49.68245633362601, 8.353667630579555, 49.72772378543017,
    ],
    '073315007071': [
      8.209968251955452, 49.68504685317546, 8.279749002538395, 49.72041744491481,
    ],
    '073320002002': [
      7.952161814729518, 49.40155265376629, 8.255042634390536, 49.50422486355553,
    ],
    '073320024024': [
      8.123080322414152, 49.54434268483224, 8.19944220631063, 49.597340809203196,
    ],
    '073320025025': [
      8.216232140876665, 49.30969210546335, 8.318930663526746, 49.38819813730728,
    ],
    '073325001009': [
      8.05126386389431, 49.37770259496487, 8.233700264014617, 49.43841154390968,
    ],
    '073325001017': [
      8.170797087839933, 49.418833790419555, 8.208153926975314, 49.43750738298114,
    ],
    '073325001035': [
      8.197622894662027, 49.37906807876017, 8.27243159939222, 49.42125764166654,
    ],
    '073325001039': [
      8.205618245665441, 49.404247574398354, 8.237767582295822, 49.43034354224966,
    ],
    '073325001043': [
      8.132759580730687, 49.38323879491299, 8.21640917725329, 49.404247574398354,
    ],
    '073325002005': [
      8.084186758931674, 49.48508617658685, 8.1685633286906, 49.53106022517227,
    ],
    '073325002008': [
      8.1685633286906, 49.51396738230547, 8.199610734169658, 49.529075425370735,
    ],
    '073325002015': [
      8.20321567241389, 49.480440618049755, 8.239303053110728, 49.498862287559625,
    ],
    '073325002019': [
      8.068717808212627, 49.46404909343584, 8.23627425678548, 49.52549168892506,
    ],
    '073325002026': [
      8.026293610827844, 49.45836298068541, 8.194222184846632, 49.51651758992619,
    ],
    '073325002028': [
      8.038279293685049, 49.452195868899935, 8.194191720944584, 49.50081030797759,
    ],
    '073325002049': [
      8.100739253925536, 49.494510396343095, 8.175290886805339, 49.527428999792626,
    ],
    '073325002050': [
      8.053956548735814, 49.452195868899935, 8.271128057551074, 49.53459356032096,
    ],
    '073325005014': [
      7.825431201748939, 49.30811120323892, 7.995418050384631, 49.39977429250751,
    ],
    '073325005016': [
      7.968557530620965, 49.338102336416526, 8.036668476440568, 49.39494348737773,
    ],
    '073325005018': [
      7.998574113002399, 49.367824998488956, 8.052737801454446, 49.390643152784094,
    ],
    '073325005032': [
      8.02526593504628, 49.35303012460781, 8.08765275749723, 49.381535901141,
    ],
    '073325005034': [
      8.076241386716209, 49.360127057678234, 8.106946453420765, 49.39222792705982,
    ],
    '073325005037': [
      8.013007359726828, 49.37770259496487, 8.067052530080707, 49.405571986029706,
    ],
    '073325005048': [
      7.950887613316709, 49.38707594647078, 8.025519689715146, 49.42957343870757,
    ],
    '073325006013': [
      8.228584615669863, 49.45341401483656, 8.275575119150762, 49.478914174547114,
    ],
    '073325006020': [
      8.207562632671928, 49.43750738298114, 8.233700264014617, 49.46551530298464,
    ],
    '073325006022': [
      8.228584615669863, 49.43841154390968, 8.283141139195576, 49.46551530298464,
    ],
    '073325006046': [
      8.05984996336604, 49.39865553392207, 8.208153926975314, 49.45839342127595,
    ],
    '073325007001': [
      8.045976280170011, 49.47425391513888, 8.10680191322812, 49.52082868037724,
    ],
    '073325007003': [
      8.09908698327439, 49.50697195213905, 8.149681290249108, 49.538062473785914,
    ],
    '073325007004': [
      8.190782789314225, 49.5235709952418, 8.214090107175023, 49.547955676355244,
    ],
    '073325007006': [
      8.153495597430547, 49.592544218574524, 8.22316674369076, 49.62762188014043,
    ],
    '073325007007': [
      8.00393234507584, 49.48250636344675, 8.069735483372424, 49.51621161671493,
    ],
    '073325007010': [
      8.217758397887495, 49.55473671548374, 8.282150433480478, 49.59119062378214,
    ],
    '073325007012': [
      8.090463261836062, 49.55386631303379, 8.123652077767918, 49.58436960791986,
    ],
    '073325007021': [
      8.248473888173876, 49.53459356032096, 8.284387079050504, 49.55969085342997,
    ],
    '073325007023': [
      8.207114782706983, 49.5235709952418, 8.238994683097582, 49.553287269725516,
    ],
    '073325007027': [
      8.044949820077838, 49.525314645402055, 8.100979750247127, 49.54652515537552,
    ],
    '073325007029': [
      8.116167930268796, 49.59240288534789, 8.177540905843266, 49.62584964580672,
    ],
    '073325007030': [
      8.019013974732015, 49.46117566848269, 8.208387860362379, 49.55681065982536,
    ],
    '073325007031': [
      8.141895112462496, 49.527428999792626, 8.171420919068002, 49.54577649168161,
    ],
    '073325007033': [
      8.208387860362379, 49.53372070833491, 8.25402646358564, 49.56058277597989,
    ],
    '073325007036': [
      8.119210553443406, 49.56201598181991, 8.148546797452079, 49.582999692773704,
    ],
    '073325007038': [
      7.995116723942645, 49.463508162698275, 8.148695273297445, 49.556656114723026,
    ],
    '073325007040': [
      8.196697627743722, 49.553287269725516, 8.22014829713084, 49.57923495710976,
    ],
    '073325007041': [
      8.153495597430547, 49.57325123404738, 8.232351551744605, 49.60362414893184,
    ],
    '073325007042': [
      8.111984399272249, 49.56776859112039, 8.140354490896256, 49.597192285944395,
    ],
    '073325007044': [
      8.088404652734544, 49.53569719152999, 8.123652077767918, 49.553926394453825,
    ],
    '073325007047': [
      7.948283349691796, 49.47226931398774, 8.089549302041895, 49.532424481155694,
    ],
    '073335002019': [
      7.983183689866395, 49.51427155198755, 8.1010737604155, 49.5659900871921,
    ],
    '073335002038': [
      7.968733880152197, 49.5496427360506, 8.091331719989615, 49.58823162799367,
    ],
    '073335002060': [
      7.950371064865602, 49.4894051105869, 8.043698753846902, 49.55017346966937,
    ],
    '073335003001': [
      8.04867600897245, 49.62424554178848, 8.111644607395338, 49.665825558927494,
    ],
    '073335003006': [
      8.083895180733562, 49.592267270580294, 8.125861840604982, 49.61924843484381,
    ],
    '073335003012': [
      8.109871486056917, 49.61456390935143, 8.146308478654229, 49.6366283431895,
    ],
    '073335003017': [
      7.971356556358527, 49.579182023782785, 8.034740088858157, 49.61418960135262,
    ],
    '073335003018': [
      8.109884501609773, 49.64604125408513, 8.146130669589319, 49.673595376073386,
    ],
    '073335003026': [
      7.971356556358527, 49.56367197131758, 8.087397762160915, 49.611097615509486,
    ],
    '073335003032': [
      8.075715462891374, 49.62505985624391, 8.118914069698016, 49.64753416262853,
    ],
    '073335003041': [
      8.079227493020905, 49.575602475451525, 8.115153593770486, 49.59398168552918,
    ],
    '073335003058': [
      8.088054141055942, 49.61044608567885, 8.133354963417384, 49.63312317005956,
    ],
    '073335003064': [
      8.060742591976402, 49.60644013649976, 8.105557601796797, 49.627571987344005,
    ],
    '073335003074': [
      7.968476834003277, 49.58993207152859, 7.995904323426406, 49.6024600927904,
    ],
    '073335003081': [
      7.965918498384124, 49.60796349535565, 8.026191875025022, 49.62212012937168,
    ],
    '073335003501': [
      8.11773432719691, 49.621169978438644, 8.16044294492007, 49.66117805230294,
    ],
    '073335004005': [
      7.972312042876288, 49.61851234881512, 8.01083878580461, 49.62869162419886,
    ],
    '073335004007': [
      8.02132100433732, 49.65663706046111, 8.052777472062928, 49.688772907930435,
    ],
    '073335004010': [
      7.927751899017433, 49.62212012937168, 8.04867600897245, 49.65328415696099,
    ],
    '073335004013': [
      7.892081656749399, 49.60460697355736, 7.972312042876288, 49.64553124544028,
    ],
    '073335004022': [
      8.042759264751789, 49.64567468163821, 8.087472656213523, 49.681921764772724,
    ],
    '073335004031': [
      8.039430694453442, 49.68180008814879, 8.10462342374092, 49.70015233869979,
    ],
    '073335004035': [
      7.948599154818198, 49.60794077614814, 7.978341078551462, 49.62700625118609,
    ],
    '073335004039': [
      7.90939372836238, 49.63888028530942, 8.044714220566737, 49.691567941568294,
    ],
    '073335004040': [
      7.891281435968861, 49.662288460172086, 7.972896269682041, 49.73161797795682,
    ],
    '073335004045': [
      8.01083878580461, 49.60306411920692, 8.067881945709539, 49.64567468163821,
    ],
    '073335004046': [
      7.909509018009625, 49.7250389597562, 7.948581907051932, 49.755816723213464,
    ],
    '073335004047': [
      8.004140339308211, 49.682940975095526, 8.048556110255692, 49.71041618786741,
    ],
    '073335004056': [
      7.949928677688073, 49.69086443848716, 7.985197605887139, 49.70459340060076,
    ],
    '073335004057': [
      7.960913235905591, 49.67362942287176, 8.006157323592777, 49.7036461441353,
    ],
    '073335004062': [
      8.042759264751789, 49.65663706046111, 8.076474846060544, 49.681921764772724,
    ],
    '073335004076': [
      8.076474846060544, 49.66287999393309, 8.12245964186018, 49.69367413869339,
    ],
    '073335006009': [
      7.89818942051854, 49.56284573248121, 7.974276987359016, 49.61045036570208,
    ],
    '073335006011': [
      7.94263610500636, 49.554504560028796, 7.972504901729145, 49.579182023782785,
    ],
    '073335006020': [
      7.84470833681754, 49.58803960126572, 7.886033704950245, 49.628557477678946,
    ],
    '073335006027': [
      7.892311989285096, 49.52965858185017, 7.917872684271015, 49.55861199904486,
    ],
    '073335006030': [
      7.764116207800766, 49.53442508250132, 7.820184793041498, 49.58093497476057,
    ],
    '073335006033': [
      7.858007585382175, 49.573945689826985, 7.928923131364278, 49.60666487176954,
    ],
    '073335006042': [
      7.824203755129004, 49.531184517029324, 7.879101070645949, 49.56263550169473,
    ],
    '073335006048': [
      7.860941133535646, 49.52664759839076, 7.900418704528418, 49.55882384189391,
    ],
    '073335006069': [
      7.802637633014289, 49.5752450230897, 7.852178460648804, 49.603932103130234,
    ],
    '073335006071': [
      7.904196846483575, 49.529369348600675, 7.97260321968887, 49.563861424169296,
    ],
    '073335006075': [
      7.929209237179402, 49.58833899480612, 7.976758735658292, 49.60941504528372,
    ],
    '073335006080': [
      7.829810540809628, 49.51191995236213, 7.883615253279248, 49.53727348664201,
    ],
    '073335006503': [
      7.800769738371316, 49.53284022702986, 7.912173573326972, 49.588120977401786,
    ],
    '073335007003': [
      7.79281712951831, 49.70582248390733, 7.846873311780943, 49.75694814179387,
    ],
    '073335007004': [
      7.776991447864635, 49.667617288519004, 7.84490646140869, 49.70582248390733,
    ],
    '073335007008': [
      7.727178321710754, 49.628761061721065, 7.762271473371538, 49.65866827687436,
    ],
    '073335007014': [
      7.798446282562703, 49.65413847508443, 7.854297443848265, 49.68186002640016,
    ],
    '073335007016': [
      7.740784294013594, 49.60912620030043, 7.769054846319336, 49.63102712308702,
    ],
    '073335007021': [
      7.721643869107695, 49.66737089095244, 7.76652542019, 49.70327378286221,
    ],
    '073335007023': [
      7.841197727045674, 49.692253145495215, 7.909509018009625, 49.7250389597562,
    ],
    '073335007024': [
      7.75510681399006, 49.56094393440867, 7.795644895307407, 49.58322899549315,
    ],
    '073335007025': [
      7.849562199808057, 49.65975395168873, 7.90760446158331, 49.6969682922039,
    ],
    '073335007028': [
      7.738933684047445, 49.573705089521454, 7.808209396549064, 49.60071280789911,
    ],
    '073335007034': [
      7.734408651319266, 49.58475065272048, 7.833881464183717, 49.61369894561622,
    ],
    '073335007036': [
      7.826945639917849, 49.72587976849528, 7.856151512517227, 49.74164565109147,
    ],
    '073335007037': [
      7.782171135559046, 49.63355535834092, 7.826181525718797, 49.657166346000395,
    ],
    '073335007043': [
      7.776991447864635, 49.68090322582264, 7.828793018309996, 49.705964827225806,
    ],
    '073335007049': [
      7.845016990510902, 49.719632086136336, 7.91208842471034, 49.74305614200798,
    ],
    '073335007050': [
      7.868781991055095, 49.73262747251461, 7.917342061229439, 49.761904004806524,
    ],
    '073335007051': [
      7.77178958824477, 49.7232539447161, 7.812542488668501, 49.75694814179387,
    ],
    '073335007053': [
      7.845016990510902, 49.711091337063976, 7.884568694425882, 49.72847104989918,
    ],
    '073335007054': [
      7.74063002887883, 49.70736321918102, 7.79281712951831, 49.76735987632071,
    ],
    '073335007055': [
      7.795172117192034, 49.69813623750287, 7.841197727045674, 49.71630013678245,
    ],
    '073335007061': [
      7.744435680915487, 49.646182314546415, 7.783939939841987, 49.67110663748641,
    ],
    '073335007065': [
      7.866322700842876, 49.63462002657163, 7.942430750093524, 49.67028932891066,
    ],
    '073335007066': [
      7.840154164048768, 49.67197625760257, 7.886462249057554, 49.69331008593719,
    ],
    '073335007067': [
      7.745604929236562, 49.669049115557065, 7.795172117192034, 49.70736321918102,
    ],
    '073335007068': [
      7.760227183229295, 49.628761061721065, 7.783939939841987, 49.650723911398806,
    ],
    '073335007072': [
      7.756085626615663, 49.70255762378524, 7.804974642370631, 49.7232539447161,
    ],
    '073335007073': [
      7.777316037866591, 49.650723911398806, 7.802626817895422, 49.67110663748641,
    ],
    '073335007077': [
      7.716798187959781, 49.61869309896227, 7.747824809829853, 49.64078620148957,
    ],
    '073335007078': [
      7.723974627517456, 49.6976879809771, 7.756085626615663, 49.72840365848241,
    ],
    '073335007079': [
      7.701710363170601, 49.646312536439446, 7.760901225828674, 49.676815500820375,
    ],
    '073335007083': [
      7.826945639917849, 49.73276580760939, 7.878580158152916, 49.76522737667181,
    ],
    '073335007084': [
      7.854297443848265, 49.64236395823524, 7.878734089819548, 49.661817290382764,
    ],
    '073335007201': [
      7.697164962888021, 49.602129932383484, 7.745017914630663, 49.62511840507103,
    ],
    '073335007202': [
      7.720456094318304, 49.587404553788716, 7.745921034170371, 49.60436729897744,
    ],
    '073335007203': [
      7.697449615369036, 49.587404553788716, 7.728565676868706, 49.610084997917696,
    ],
    '073335007502': [
      7.759667132345993, 49.600071855488885, 7.917226318713419, 49.65975395168873,
    ],
    '073340007007': [
      8.339763973095058, 49.17649712629503, 8.404971331463637, 49.255984958523385,
    ],
    '073340501501': [
      8.06911348717911, 48.98377815910969, 8.350758476753944, 49.09042756330815,
    ],
    '073345001001': [
      8.256862620579959, 49.17235145698383, 8.349934238291613, 49.211387072322836,
    ],
    '073345001014': [
      8.238692509710747, 49.170943792963634, 8.260638216260626, 49.21146412005048,
    ],
    '073345001023': [
      8.216075005572574, 49.170943792963634, 8.239659719528786, 49.21146412005048,
    ],
    '073345001036': [
      8.2322236925571, 49.21099063606164, 8.286919538647204, 49.261688552460434,
    ],
    '073345002002': [
      8.160575109014525, 48.96693267829496, 8.23512579611581, 49.00054533131882,
    ],
    '073345002008': [
      8.22241411452477, 48.99057343462273, 8.292310117091393, 49.039887775505306,
    ],
    '073345002021': [
      8.221382073234457, 48.96627450952723, 8.279385165597148, 48.998511662007324,
    ],
    '073345002027': [
      8.066533854781536, 48.975509764611715, 8.164180491968558, 49.00469894515459,
    ],
    '073345003009': [
      8.209772150226286, 49.10379675050186, 8.272128301736284, 49.1278895663886,
    ],
    '073345003012': [
      8.253147971237409, 49.07023163816897, 8.328597588607304, 49.10527315868588,
    ],
    '073345003022': [
      8.311345602748387, 49.08766448752128, 8.361073144472831, 49.12076426598997,
    ],
    '073345003024': [
      8.255395479006665, 49.08868361845758, 8.31904502647288, 49.13372417560012,
    ],
    '073345004004': [
      8.16530983345757, 49.10208466359005, 8.215815557013823, 49.12590717983228,
    ],
    '073345004005': [
      8.079437164693951, 49.05484848492675, 8.151490653115934, 49.08937793718402,
    ],
    '073345004013': [
      8.13348134317802, 49.05928821221413, 8.259678933571372, 49.110799925746456,
    ],
    '073345004020': [
      8.115870840713312, 49.054785415494656, 8.178434568261636, 49.093413815727246,
    ],
    '073345004030': [
      8.117316974395992, 49.1003301356363, 8.172880073614623, 49.13453747712795,
    ],
    '073345004031': [
      8.055862410323535, 49.05977094329282, 8.084735464270151, 49.07411544319945,
    ],
    '073345004034': [
      8.101627428149731, 49.085299922205195, 8.13882985468791, 49.10214090047661,
    ],
    '073345005006': [
      8.247833277450543, 49.2632178879163, 8.29971725910735, 49.2838198962602,
    ],
    '073345005017': [
      8.327763575699091, 49.21594212703284, 8.416497060203268, 49.26925875840214,
    ],
    '073345005018': [
      8.241421757536623, 49.203561616774294, 8.34712605879104, 49.26437800511036,
    ],
    '073345005028': [
      8.306470205597137, 49.25984852313153, 8.368759443199698, 49.29825766787826,
    ],
    '073345005032': [
      8.268952298267902, 49.25224233246365, 8.315307727329923, 49.28778594809012,
    ],
    '073345005033': [
      8.306461909822614, 49.2187851897945, 8.336680082317708, 49.26042067673682,
    ],
    '073345006011': [
      8.306072256454886, 49.14429680006973, 8.371911932145197, 49.18655062399899,
    ],
    '073345006015': [
      8.29436711382322, 49.13412576031013, 8.349295567488735, 49.15476019120157,
    ],
    '073345006016': [
      8.289562037135376, 49.103379108872836, 8.371281543552998, 49.14510943233691,
    ],
    '073345006025': [
      8.256862620579959, 49.12038479537697, 8.32115067148153, 49.174093360202995,
    ],
    '073355001003': [
      7.393346569118834, 49.36341980583043, 7.486605287589472, 49.41926838815994,
    ],
    '073355001011': [
      7.501419768013558, 49.33651407178302, 7.556041146403998, 49.37442370721763,
    ],
    '073355001201': [
      7.408969004399802, 49.354662955657105, 7.457347468093323, 49.37481383195213,
    ],
    '073355001202': [
      7.480953460195301, 49.36512640569874, 7.538469407698302, 49.396089865574226,
    ],
    '073355001203': [
      7.438726608939487, 49.3397746709458, 7.505192178138496, 49.378127389024364,
    ],
    '073355002004': [
      7.844808274482541, 49.45104908290159, 7.96784912772612, 49.53481305338899,
    ],
    '073355002007': [
      7.858895111570188, 49.443178212330125, 7.953625466889731, 49.486361519845936,
    ],
    '073355002010': [
      7.918713521432744, 49.41242551688558, 8.002056134260126, 49.46376566706895,
    ],
    '073355002015': [
      7.847494024383451, 49.395929859861184, 7.943441821893269, 49.4525753603634,
    ],
    '073355002026': [
      7.799309838150164, 49.46192668740898, 7.883376866977658, 49.53284022702986,
    ],
    '073355002028': [
      7.894232461703674, 49.50885619365327, 7.93772419818354, 49.53609087391058,
    ],
    '073355002048': [
      7.816107519095189, 49.36330192843477, 7.962171003554652, 49.42255462925601,
    ],
    '073355002205': [
      7.831986569309263, 49.50401133331164, 7.883615253279248, 49.52664759839076,
    ],
    '073355008016': [
      7.420287973620082, 49.40405408837717, 7.52198454035826, 49.44227377941409,
    ],
    '073355008020': [
      7.498822003755278, 49.46376446474218, 7.557631249753626, 49.49279196044216,
    ],
    '073355008030': [
      7.449690079254594, 49.435604121013604, 7.498822003755278, 49.48756024951455,
    ],
    '073355008038': [
      7.495669312440387, 49.40459436390734, 7.631092203600995, 49.484276797978275,
    ],
    '073355008044': [
      7.484353114729629, 49.44213940195639, 7.546269299620699, 49.485657865595776,
    ],
    '073355009005': [
      7.59594122019789, 49.48912025807783, 7.649590824799105, 49.52182286254597,
    ],
    '073355009006': [
      7.629355560780578, 49.48912025807783, 7.669423677866019, 49.51007276043065,
    ],
    '073355009019': [
      7.561638031268143, 49.501414767365866, 7.607695746699997, 49.52938968091215,
    ],
    '073355009024': [
      7.557631249753626, 49.463617975398535, 7.609056742058551, 49.484276797978275,
    ],
    '073355009040': [
      7.637171168315916, 49.44169462842298, 7.702408788117285, 49.495500164131485,
    ],
    '073355009043': [
      7.557631249753626, 49.482495965564695, 7.613567700116561, 49.51336777218808,
    ],
    '073355009049': [
      7.587532916821436, 49.435410171199734, 7.656549903428035, 49.49601577162533,
    ],
    '073355009501': [
      7.47817217704194, 49.484276797978275, 7.572710061237153, 49.522982040447665,
    ],
    '073355010009': [
      7.607695746699997, 49.518620431168934, 7.662172620645823, 49.54536547847117,
    ],
    '073355010013': [
      7.73356711892559, 49.531087482233715, 7.781345769490533, 49.57402440696244,
    ],
    '073355010014': [
      7.66279879551373, 49.51118306245475, 7.698580747318174, 49.53173053698238,
    ],
    '073355010017': [
      7.664324480721721, 49.48704650829536, 7.736058068573199, 49.518529575933314,
    ],
    '073355010025': [
      7.691074609186112, 49.50883762331818, 7.746147392871106, 49.54088829099158,
    ],
    '073355010029': [
      7.639119506166217, 49.54534357266589, 7.746768565423801, 49.59589593667182,
    ],
    '073355010033': [
      7.641888802202885, 49.521910160411245, 7.691074609186112, 49.55828139499199,
    ],
    '073355010034': [
      7.702346659477288, 49.473752929069036, 7.757866991686644, 49.50255414475001,
    ],
    '073355010035': [
      7.725058466525653, 49.48195370357592, 7.831986569309263, 49.53630268148946,
    ],
    '073355010041': [
      7.686726767610974, 49.53173053698238, 7.73808612157512, 49.560599269657786,
    ],
    '073355010042': [
      7.724471083974943, 49.526770390349625, 7.761998105080923, 49.553466995924005,
    ],
    '073355010046': [
      7.615655273755342, 49.50888214271585, 7.676619809334364, 49.53106818170532,
    ],
    '073355011002': [
      7.595490983644289, 49.376236933198754, 7.678223074293455, 49.415792701389634,
    ],
    '073355011012': [
      7.472946505281516, 49.38605754231108, 7.519621228497219, 49.405020806476216,
    ],
    '073355011018': [
      7.592462677927616, 49.403674519919505, 7.669256217038022, 49.429062448191324,
    ],
    '073355011021': [
      7.648992635873267, 49.3425470606551, 7.698977617979355, 49.38713418741766,
    ],
    '073355011022': [
      7.515480342970315, 49.38457605449161, 7.604569862193762, 49.42096871230491,
    ],
    '073355011023': [
      7.628053822891215, 49.341862256552055, 7.671060578230668, 49.36070547784604,
    ],
    '073355011027': [
      7.526740494595186, 49.35295844085201, 7.574251428400906, 49.39474232071167,
    ],
    '073355011031': [
      7.564008079160601, 49.36900876842244, 7.604343515527787, 49.39937153457135,
    ],
    '073355011037': [
      7.604343515527787, 49.35920343966678, 7.690088752947765, 49.39872933977073,
    ],
    '073355011045': [
      7.691734117005668, 49.362169923520966, 7.748169899440454, 49.39455456637677,
    ],
    '073355011047': [
      7.726413905419644, 49.30685278130713, 7.83801842165151, 49.396600931062025,
    ],
    '073355011204': [
      7.669241394667297, 49.33122168910824, 7.736192076447844, 49.367333611784396,
    ],
    '073365008001': [
      7.635318649236238, 49.6552965915456, 7.67186138197803, 49.67252015300894,
    ],
    '073365008005': [
      7.561891992873266, 49.58361326820852, 7.586267565862253, 49.61460469595516,
    ],
    '073365008012': [
      7.526718979353488, 49.6297457379841, 7.553844434707822, 49.647608334152594,
    ],
    '073365008013': [
      7.612306893321476, 49.64147126998126, 7.635318649236238, 49.66022833452346,
    ],
    '073365008014': [
      7.504373808459709, 49.622769539770374, 7.529297269310606, 49.64348946867213,
    ],
    '073365008019': [
      7.627105180158572, 49.59032790165579, 7.652091416481129, 49.62341250648864,
    ],
    '073365008023': [
      7.523095029604907, 49.54858636458041, 7.590401652657677, 49.57482251920962,
    ],
    '073365008029': [
      7.633532716913162, 49.63092332548395, 7.657765211351264, 49.66008776127834,
    ],
    '073365008030': [
      7.504373808459709, 49.59808089884752, 7.543367733519132, 49.62693296000346,
    ],
    '073365008033': [
      7.539671467548779, 49.647608334152594, 7.569845986444462, 49.66518964241027,
    ],
    '073365008035': [
      7.546311788084917, 49.63953408475191, 7.573393177443373, 49.65521371821665,
    ],
    '073365008036': [
      7.66131548206459, 49.59175964510969, 7.706527651855409, 49.62139572567523,
    ],
    '073365008038': [
      7.598803282306979, 49.61223102748922, 7.622262092879676, 49.634065783271986,
    ],
    '073365008040': [
      7.513900300419331, 49.640036425922155, 7.546311788084917, 49.6608425868439,
    ],
    '073365008042': [
      7.538189082266043, 49.57482251920962, 7.584206571266021, 49.59927812584406,
    ],
    '073365008043': [
      7.612306893321476, 49.61012801183914, 7.643296435785497, 49.64200009519195,
    ],
    '073365008044': [
      7.426775230147292, 49.639898576211, 7.528723318152489, 49.66678186970645,
    ],
    '073365008045': [
      7.520239825478568, 49.67551617352394, 7.549904022144727, 49.71372121574276,
    ],
    '073365008048': [
      7.530381816483153, 49.51800968559253, 7.584757071587491, 49.552668237832194,
    ],
    '073365008049': [
      7.540195526098312, 49.662394370344195, 7.600538781678557, 49.69215506796582,
    ],
    '073365008050': [
      7.463579202399695, 49.622769539770374, 7.515397640281565, 49.64894152922852,
    ],
    '073365008053': [
      7.608286994995913, 49.533218212278435, 7.660503912996257, 49.571264668245604,
    ],
    '073365008057': [
      7.489862442188861, 49.659079338574145, 7.528723318152489, 49.67896932917273,
    ],
    '073365008058': [
      7.567701798134308, 49.63852760547413, 7.615083636361828, 49.67327466105274,
    ],
    '073365008060': [
      7.578334097002357, 49.61223102748922, 7.615365123325584, 49.64147126998126,
    ],
    '073365008061': [
      7.58473905242856, 49.65753010807578, 7.62949718299245, 49.68439693643717,
    ],
    '073365008062': [
      7.528627695755379, 49.66076925012267, 7.553302483319869, 49.67631672012663,
    ],
    '073365008065': [
      7.543257009389251, 49.59889138861675, 7.569210516846124, 49.61252296061625,
    ],
    '073365008069': [
      7.67708471074354, 49.620087481037906, 7.728652397514324, 49.65304730782219,
    ],
    '073365008072': [
      7.535473480914612, 49.566178855224116, 7.584206571266021, 49.585665616963084,
    ],
    '073365008073': [
      7.604107259130487, 49.58923712939973, 7.633752326872507, 49.61223102748922,
    ],
    '073365008074': [
      7.623615679297473, 49.6575172715735, 7.672821156945203, 49.70146342735721,
    ],
    '073365008075': [
      7.527791798679002, 49.606720793685014, 7.586267565862253, 49.633732821130614,
    ],
    '073365008085': [
      7.638397667191857, 49.60793301374204, 7.692657422565888, 49.639859861081696,
    ],
    '073365008086': [
      7.648282358680834, 49.585777819416904, 7.679708172722146, 49.610541696783486,
    ],
    '073365008087': [
      7.567377338826356, 49.52182286254597, 7.612124231242809, 49.567405713179134,
    ],
    '073365008090': [
      7.584206571266021, 49.55206446519735, 7.621695263858023, 49.5793271936118,
    ],
    '073365008095': [
      7.453578466846669, 49.57731389645664, 7.527800801225777, 49.643660499986524,
    ],
    '073365008100': [
      7.443003712173932, 49.65429852820218, 7.501665807033358, 49.67718093948314,
    ],
    '073365008104': [
      7.545410354618537, 49.625718389586496, 7.585436942210543, 49.64708724021298,
    ],
    '073365008105': [
      7.583974893233896, 49.55920416567777, 7.657780272039683, 49.61460469595516,
    ],
    '073365009004': [
      7.283792784310681, 49.43199142966127, 7.339048288425384, 49.45636271074735,
    ],
    '073365009008': [
      7.381234376813688, 49.43060420288641, 7.41490024833986, 49.45662567536104,
    ],
    '073365009010': [
      7.246297845491649, 49.415918155122625, 7.293687023492474, 49.457405167122516,
    ],
    '073365009011': [
      7.328279023301994, 49.41439277136954, 7.3876239638275, 49.440719859617474,
    ],
    '073365009016': [
      7.290227509379585, 49.41687723714314, 7.348556591701779, 49.43867392397226,
    ],
    '073365009017': [
      7.289975219941718, 49.398104468352024, 7.325966200156179, 49.42727918773747,
    ],
    '073365009027': [
      7.283792784310681, 49.444007126897695, 7.332529475362185, 49.465953212809204,
    ],
    '073365009031': [
      7.414405645580309, 49.45194827826463, 7.462101597096725, 49.48229505327948,
    ],
    '073365009032': [
      7.382316660282156, 49.41429043414017, 7.423214941602822, 49.43621606960464,
    ],
    '073365009037': [
      7.379490798231447, 49.454587364320936, 7.417860030280046, 49.477036341761846,
    ],
    '073365009041': [
      7.320940062821637, 49.459958925133876, 7.368354371375289, 49.49484618629959,
    ],
    '073365009047': [
      7.372167342994935, 49.482719853068495, 7.407497611223387, 49.50425364274904,
    ],
    '073365009054': [
      7.299360615239667, 49.45636271074735, 7.349365267476569, 49.475935832062454,
    ],
    '073365009056': [
      7.296429223638315, 49.47460681613732, 7.347835503201624, 49.50627176241781,
    ],
    '073365009064': [
      7.411746216617655, 49.423336953361805, 7.460862667764578, 49.4576147986657,
    ],
    '073365009076': [
      7.332529475362185, 49.43867392397226, 7.363903173775741, 49.46007615026943,
    ],
    '073365009082': [
      7.399820839624451, 49.47323958120733, 7.472595569614885, 49.49785636826314,
    ],
    '073365009092': [
      7.319833199336374, 49.37752130299952, 7.414089388453022, 49.42144718006242,
    ],
    '073365009096': [
      7.357445057248765, 49.43999208590727, 7.407051105884582, 49.46645653778537,
    ],
    '073365009101': [
      7.358819365825958, 49.462102378902976, 7.387254270672686, 49.498941948803115,
    ],
    '073365009102': [
      7.290727669415837, 49.36371902882257, 7.397746831394764, 49.400946980555084,
    ],
    '073365009107': [
      7.43629878906765, 49.479343485275734, 7.480865796731439, 49.51718769641981,
    ],
    '073365009501': [
      7.380082252966299, 49.46905527467592, 7.438407137957268, 49.49405365371795,
    ],
    '073365010002': [
      7.30877240985413, 49.50627176241781, 7.351024297160266, 49.52790143000717,
    ],
    '073365010003': [
      7.418793896895438, 49.52871618592033, 7.509522095524807, 49.57229539877634,
    ],
    '073365010006': [
      7.38670649832754, 49.54813847305765, 7.418793896895438, 49.56809270036036,
    ],
    '073365010009': [
      7.486317808027187, 49.522982040447665, 7.542058831706955, 49.5582532802116,
    ],
    '073365010015': [
      7.358391279399846, 49.56809270036036, 7.396868007645238, 49.59864126326354,
    ],
    '073365010018': [
      7.341846665833931, 49.51498531487466, 7.383370350765796, 49.53635669705772,
    ],
    '073365010021': [
      7.508331381165672, 49.55605653836867, 7.523095029604907, 49.58466695906174,
    ],
    '073365010022': [
      7.415880842413207, 49.557947960349985, 7.459681166307084, 49.581104721905625,
    ],
    '073365010024': [
      7.407248662201639, 49.496830386939145, 7.437603384927256, 49.52035003323667,
    ],
    '073365010025': [
      7.47349597712214, 49.51825842813225, 7.506578458454498, 49.539170855585,
    ],
    '073365010034': [
      7.409297379694103, 49.515287865754146, 7.451906904814976, 49.535084071846256,
    ],
    '073365010039': [
      7.281576644679062, 49.49910933731578, 7.309828245363403, 49.5218643149319,
    ],
    '073365010046': [
      7.498683515311806, 49.55605653836867, 7.543257009389251, 49.59889138861675,
    ],
    '073365010051': [
      7.343328004001776, 49.55065156290496, 7.396868007645238, 49.589584599715415,
    ],
    '073365010052': [
      7.318399244925414, 49.49432994875614, 7.378024013591969, 49.51528696562616,
    ],
    '073365010055': [
      7.34940046148947, 49.519956508270795, 7.433743240670299, 49.557947960349985,
    ],
    '073365010066': [
      7.467866516103901, 49.49659523798384, 7.503036502719346, 49.52257690729114,
    ],
    '073365010067': [
      7.433865310072735, 49.59472354148733, 7.4832300315569, 49.643660499986524,
    ],
    '073365010068': [
      7.505133139268215, 49.522982040447665, 7.530381816483153, 49.535848455891525,
    ],
    '073365010070': [
      7.394599059535044, 49.56437472565934, 7.420990200287062, 49.59567664377979,
    ],
    '073365010071': [
      7.500986269371064, 49.50393908259431, 7.530381816483153, 49.52370089510245,
    ],
    '073365010077': [
      7.300182896809561, 49.52000604464677, 7.356950395501426, 49.55665564035526,
    ],
    '073365010079': [
      7.428420111603423, 49.53215293400551, 7.453803357039424, 49.550037456827575,
    ],
    '073365010081': [
      7.43582507055739, 49.589973731971426, 7.464470565908376, 49.615581737114304,
    ],
    '073365010084': [
      7.275997310390216, 49.533272196177634, 7.311250689855686, 49.556365015347424,
    ],
    '073365010088': [
      7.34940046148947, 49.53635669705772, 7.380589495310781, 49.55739466562102,
    ],
    '073365010089': [
      7.447548505627089, 49.51718769641981, 7.474548235679206, 49.53215293400551,
    ],
    '073365010091': [
      7.377668615746029, 49.503940583309614, 7.410326532424658, 49.52142450412499,
    ],
    '073365010094': [
      7.279677945695279, 49.48208554024413, 7.318399244925414, 49.51046614565908,
    ],
    '073365010097': [
      7.322652259386469, 49.553662845279156, 7.365227679573587, 49.578295337368964,
    ],
    '073365010098': [
      7.418720358661489, 49.49734165526343, 7.467866516103901, 49.52414589375348,
    ],
    '073365010099': [
      7.415772413325382, 49.57501155783914, 7.486306800174147, 49.59786265238312,
    ],
    '073365010103': [
      7.486306800174147, 49.5582532802116, 7.509522095524807, 49.584777070738774,
    ],
    '073365010106': [
      7.451103835027966, 49.56043623951772, 7.492884671824178, 49.57731389645664,
    ],
    '073375001001': [
      7.878143234914564, 49.21011823160438, 8.043445654963225, 49.28095173638391,
    ],
    '073375001017': [
      7.981426157309003, 49.23539793260297, 8.022964186543252, 49.26396560450953,
    ],
    '073375001024': [
      7.935678164640496, 49.22671102313435, 8.005058093266127, 49.26396560450953,
    ],
    '073375001033': [
      7.896743874311144, 49.137187799773564, 7.955770319790441, 49.17142408930841,
    ],
    '073375001054': [
      7.955770319790441, 49.14149284256346, 7.982749115879791, 49.156893050597226,
    ],
    '073375001064': [
      7.981426157309003, 49.252410167148, 8.044574130362982, 49.282579747293134,
    ],
    '073375001067': [
      7.865689846982653, 49.210484558635265, 7.950341078047952, 49.24726304576742,
    ],
    '073375001074': [
      7.910456336392535, 49.120958665121506, 7.963096131822251, 49.15421072269161,
    ],
    '073375001078': [
      7.911219989746843, 49.164092122229526, 7.953857866895686, 49.185376965633964,
    ],
    '073375001080': [
      7.97228173712739, 49.15296299387985, 8.01392946786762, 49.17560521837917,
    ],
    '073375001081': [
      7.944821382855706, 49.15421072269161, 7.980395414549639, 49.18885823249173,
    ],
    '073375001083': [
      7.889232767814104, 49.1779186472932, 7.95213035279365, 49.210484558635265,
    ],
    '073375001501': [
      7.827494377197005, 49.18283953025712, 8.019576554380448, 49.28057028066004,
    ],
    '073375002005': [
      7.940462372895746, 49.09145552420919, 8.01176849786777, 49.13167568421055,
    ],
    '073375002006': [
      8.05128964181315, 49.085508739067365, 8.092916835146667, 49.11495925834781,
    ],
    '073375002008': [
      7.902777255678221, 49.0983022912643, 7.963477371041399, 49.123990718810106,
    ],
    '073375002013': [
      7.885499106582071, 49.07753747527628, 7.948399170205907, 49.09884211526691,
    ],
    '073375002018': [
      8.02686336598434, 49.07371085244317, 8.08452341349353, 49.0900746756401,
    ],
    '073375002019': [
      7.92655595453811, 49.076653240179375, 8.01322390332452, 49.1011563987299,
    ],
    '073375002029': [
      7.956464978950116, 49.121089701533236, 8.033688807028833, 49.13592584128623,
    ],
    '073375002037': [
      8.082876112690583, 49.085299922205195, 8.102353100441318, 49.100486132728186,
    ],
    '073375002045': [
      8.011250579558904, 49.075412374052405, 8.04483887984638, 49.105889972008704,
    ],
    '073375002046': [
      8.007362559980628, 49.0152889182505, 8.04197384382287, 49.061130334490095,
    ],
    '073375002049': [
      7.96044156478328, 49.13193497555954, 8.039904558083325, 49.158959503946605,
    ],
    '073375002055': [
      8.02100788270252, 49.105165726211766, 8.05836617404552, 49.12684956073481,
    ],
    '073375002056': [
      8.020242533555239, 49.05977094329282, 8.056691011804205, 49.075412374052405,
    ],
    '073375002058': [
      8.033414414521928, 49.08358511714411, 8.067481971733908, 49.108240863050185,
    ],
    '073375002059': [
      7.894360814531077, 49.0604626870765, 8.02686336598434, 49.087969617934085,
    ],
    '073375002060': [
      7.8461175391157, 49.13038244628329, 7.887534342775043, 49.155663353869436,
    ],
    '073375002062': [
      7.975977643552041, 49.10557160389877, 8.032528265419321, 49.12684956073481,
    ],
    '073375002071': [
      7.881344431087062, 49.0402686752966, 7.994419894821759, 49.077877761164935,
    ],
    '073375002072': [
      7.962389577415659, 49.0209322184993, 8.017179600470051, 49.061130334490095,
    ],
    '073375002076': [
      8.020242533555239, 48.99638365908541, 8.077314671002195, 49.062453431262966,
    ],
    '073375002079': [
      7.85317948043843, 49.11494156935646, 7.920665056417612, 49.148167014059325,
    ],
    '073375003002': [
      8.197203391754254, 49.27504017860776, 8.231585155203737, 49.29720320180986,
    ],
    '073375003011': [
      8.221496603909085, 49.275566838265604, 8.264387397770184, 49.2987361076128,
    ],
    '073375003015': [
      7.97540429748214, 49.240930908375226, 8.085395542924932, 49.29296160742561,
    ],
    '073375003020': [
      7.962231287101901, 49.273729000297415, 8.15020572167793, 49.31919506278085,
    ],
    '073375003021': [
      7.935291777627578, 49.24599656647472, 8.166157771720586, 49.32587283293765,
    ],
    '073375003025': [
      7.961916213791913, 49.241366805923754, 8.107539052811209, 49.2943376161701,
    ],
    '073375003027': [
      8.206288196644907, 49.25940904278246, 8.250893384318983, 49.27639576337712,
    ],
    '073375003028': [
      7.962293234162775, 49.23551131021471, 8.073870899033247, 49.275468763476454,
    ],
    '073375003032': [
      8.019759328510244, 49.27994684855686, 8.322105225643256, 49.30969210546335,
    ],
    '073375003035': [
      8.162837421930043, 49.25358839278811, 8.206348696851164, 49.27690623490748,
    ],
    '073375003036': [
      7.946692063622003, 49.25188473556646, 8.10785614631636, 49.30948731293052,
    ],
    '073375003048': [
      8.176018682014861, 49.25449419410971, 8.208985933336729, 49.268291745701475,
    ],
    '073375003066': [
      7.953210477822687, 49.26431134376266, 8.123829777486174, 49.33386700160664,
    ],
    '073375003069': [
      7.987356407459291, 49.241417271126586, 8.137830051773365, 49.286103674251564,
    ],
    '073375003077': [
      7.97297710279559, 49.273375904877604, 8.200256598227005, 49.33386700160664,
    ],
    '073375003084': [
      8.021829650567668, 49.25863250685873, 8.094420035404116, 49.28481453887253,
    ],
    '073375004038': [
      8.167812927475149, 49.109453072440544, 8.26307742214322, 49.1710972074243,
    ],
    '073375004039': [
      8.238692509710747, 49.1278895663886, 8.264224188164999, 49.17235145698383,
    ],
    '073375004044': [
      8.132335629223629, 49.12590717983228, 8.19687188626396, 49.17615970394649,
    ],
    '073375004068': [
      8.116652295371336, 49.12575866263611, 8.168141887689238, 49.1555538586144,
    ],
    '073375005007': [
      8.042090752468672, 49.09908027273594, 8.11937511820336, 49.15689917469264,
    ],
    '073375005009': [
      7.919841421387036, 49.198057913606135, 8.048741232946282, 49.26119279103156,
    ],
    '073375005012': [
      8.013135527576768, 49.227864969774906, 8.10691141464749, 49.25395675069272,
    ],
    '073375005022': [
      7.994409178226548, 49.158959503946605, 8.036361710193853, 49.1797723637105,
    ],
    '073375005026': [
      7.918391076383043, 49.22130064494794, 8.076306194013531, 49.28878781284163,
    ],
    '073375005031': [
      8.011123216732743, 49.14984528567788, 8.064982767002164, 49.17141884234746,
    ],
    '073375005040': [
      8.029927770011156, 49.12280865998857, 8.074487962845039, 49.15498639394041,
    ],
    '073375005042': [
      7.974414857350218, 49.171301916063285, 8.069645272614082, 49.19173974925969,
    ],
    '073375005043': [
      8.091862752247197, 49.15256039278536, 8.133295208211829, 49.173584567882145,
    ],
    '073375005050': [
      8.136525874964738, 49.22681757727798, 8.156684007921006, 49.24911808371647,
    ],
    '073375005051': [
      7.981177055224815, 49.17214499687003, 8.040394837315665, 49.20253010729473,
    ],
    '073375005065': [
      8.00144635145014, 49.19173974925969, 8.046840643774017, 49.2015426863621,
    ],
    '073375005073': [
      7.918391076383043, 49.20119743223224, 8.065269757576726, 49.28095173638391,
    ],
    '073375005082': [
      7.961916213791913, 49.227302842962224, 8.136997430349847, 49.28272890862873,
    ],
    '073375006047': [
      7.978843443592871, 49.287694120047945, 8.200256598227005, 49.34234912244817,
    ],
    '073375006052': [
      7.992052514727827, 49.287694120047945, 8.1418430305025, 49.32349960835667,
    ],
    '073375006070': [
      8.006589783987893, 49.28947887367348, 8.12337091416717, 49.314143643781286,
    ],
    '073375007014': [
      8.156684007921006, 49.20662113097826, 8.180553832873894, 49.22773163795619,
    ],
    '073375007023': [
      8.147624372332317, 49.20989386049229, 8.207278862716068, 49.255450188146085,
    ],
    '073375007041': [
      8.186079370606143, 49.20942685620187, 8.239659719528786, 49.2602766519073,
    ],
    '073375007061': [
      8.168329506047654, 49.16525028919662, 8.216861983468558, 49.217904812796796,
    ],
    '073380004004': [
      8.33405195674218, 49.55774805836497, 8.42317503868604, 49.607774376658305,
    ],
    '073380005005': [
      8.269184432991883, 49.31693815260195, 8.378638426425372, 49.40541890431735,
    ],
    '073380017017': [
      8.368407597538857, 49.393801203978164, 8.414599580133812, 49.433853517535,
    ],
    '073380019019': [
      8.307339173230254, 49.41209097112906, 8.384458962516026, 49.46916611382859,
    ],
    '073380025025': [
      8.326873942293364, 49.347376163829416, 8.416464939554276, 49.41406968862821,
    ],
    '073385001006': [
      8.283141139195576, 49.39551764695627, 8.355832303573303, 49.453070046879944,
    ],
    '073385001014': [
      8.256672580933852, 49.39481548799705, 8.306474997695886, 49.43682164012375,
    ],
    '073385001022': [
      8.232637660546503, 49.41900768941027, 8.284471587227495, 49.44705296970468,
    ],
    '073385004003': [
      8.248618582410334, 49.477165019248424, 8.271323207036891, 49.497813920659176,
    ],
    '073385004008': [
      8.271323207036891, 49.44705296970468, 8.318830338086533, 49.478914174547114,
    ],
    '073385004018': [
      8.271128057551074, 49.470073749414986, 8.308300388415573, 49.50202938484921,
    ],
    '073385006002': [
      8.307386471267007, 49.54928652350805, 8.342603093417841, 49.58134864861711,
    ],
    '073385006009': [
      8.287677153034016, 49.56460197509733, 8.32325624834567, 49.5898816760355,
    ],
    '073385006012': [
      8.269576075433791, 49.53442663399003, 8.322000536479786, 49.557135060236305,
    ],
    '073385006013': [
      8.27941224371873, 49.54853343523724, 8.315386108105258, 49.5898816760355,
    ],
    '073385006015': [
      8.287677153034016, 49.57950328376837, 8.343678765453944, 49.60050811611275,
    ],
    '073385006016': [
      8.25402646358564, 49.497813920659176, 8.315902475064748, 49.53634435965987,
    ],
    '073385007007': [
      8.350206121959298, 49.297869131575496, 8.40543817610256, 49.347376163829416,
    ],
    '073385007010': [
      8.317379671328503, 49.304821375488466, 8.365009577170829, 49.33421451110469,
    ],
    '073385007011': [
      8.317379671328503, 49.28268379774628, 8.37448996749916, 49.31069075981994,
    ],
    '073385007023': [
      8.36117417942897, 49.25072599316028, 8.46699601924009, 49.30750027106882,
    ],
    '073385008001': [
      8.45209775759606, 49.40749349957633, 8.508058934634978, 49.44233011711854,
    ],
    '073385008020': [
      8.406340838955288, 49.387016999053444, 8.478542821379415, 49.43970951332547,
    ],
    '073385008021': [
      8.42411936360207, 49.339060197253154, 8.50226678821919, 49.403732791750535,
    ],
    '073385008026': [
      8.413413687265635, 49.374823502304515, 8.497024300319348, 49.415440103179286,
    ],
    '073390005005': [
      7.870425796505895, 49.913054374380124, 7.996824940885602, 49.980084247632696,
    ],
    '073390009009': [
      8.138170014851442, 50.00341044227836, 8.20462112280283, 50.03542459712748,
    ],
    '073390030030': [
      7.976660625284642, 49.92987044561113, 8.15771127702537, 50.02587186084757,
    ],
    '073395001003': [
      7.687448685575867, 50.02067286145176, 7.781344990559107, 50.08204631073741,
    ],
    '073395001007': [
      7.666070091711144, 50.031620656479326, 7.718231620427168, 50.06628973984479,
    ],
    '073395001036': [
      7.696131727406925, 50.00991970389398, 7.768329768886059, 50.04240727756248,
    ],
    '073395001038': [
      7.846271224074297, 49.9302398569563, 7.899322194535308, 49.9575913917116,
    ],
    '073395001040': [
      7.787665188371912, 50.00051735545355, 7.830637873921451, 50.03699533277788,
    ],
    '073395001044': [
      7.715183536949914, 50.00135633775606, 7.807164174373741, 50.05074027437368,
    ],
    '073395001045': [
      7.728761870854114, 50.00094400803277, 7.794270810425817, 50.03097328736427,
    ],
    '073395001058': [
      7.803091906104173, 49.98323173574623, 7.863021298758499, 50.02172675286355,
    ],
    '073395001062': [
      7.770026232641432, 49.93634027228819, 7.848459428435154, 49.98427285775146,
    ],
    '073395001063': [
      7.728761870854114, 49.94672983071907, 7.886360357952864, 50.00541302027502,
    ],
    '073395002006': [
      8.270248321846832, 49.907513580239055, 8.34969586582651, 49.94759431735213,
    ],
    '073395002020': [
      8.270248321846832, 49.90395324101405, 8.297776704215261, 49.922232523768834,
    ],
    '073395002026': [
      8.251001296148067, 49.896225137843444, 8.284535260115579, 49.91995931289162,
    ],
    '073395002034': [
      8.277538743263458, 49.880249435279794, 8.319137199557352, 49.90899607296176,
    ],
    '073395002039': [
      8.30696248642203, 49.88972512196833, 8.356478052800046, 49.93181071118503,
    ],
    '073395003001': [
      7.996824940885602, 49.90964839428814, 8.052190845338504, 49.941896566101995,
    ],
    '073395003008': [
      8.059558237711581, 49.91032142007517, 8.10307372270405, 49.92987044561113,
    ],
    '073395003016': [
      8.048597926578944, 49.89287714949355, 8.12232762086124, 49.92005188886777,
    ],
    '073395003019': [
      7.982900029140805, 49.923818329262254, 8.036677094474223, 49.972432643279035,
    ],
    '073395003041': [
      8.005847895325086, 49.906200466796186, 8.059628376090062, 49.93157272357072,
    ],
    '073395003046': [
      7.993842211586232, 49.88663137880466, 8.049038905977167, 49.90964839428814,
    ],
    '073395003048': [
      7.952030962665545, 49.930795638961314, 7.994211308859566, 49.956498587654536,
    ],
    '073395003051': [
      8.059628376090062, 49.92005188886777, 8.139326495406358, 49.958264997387076,
    ],
    '073395006017': [
      8.127074094783355, 49.91256324398224, 8.179737380479779, 49.96381285073531,
    ],
    '073395006031': [
      8.042832443035051, 49.885076992433696, 8.120943872282767, 49.907089431564714,
    ],
    '073395006032': [
      8.200252731496612, 49.929550230013966, 8.243347316309379, 49.956232108088905,
    ],
    '073395006042': [
      8.17054417382515, 49.88552257476069, 8.228912968464835, 49.92148039869913,
    ],
    '073395006047': [
      8.148559541488288, 49.9114702994483, 8.23502464060284, 49.96753342871881,
    ],
    '073395006054': [
      8.191685497365416, 49.86766433364385, 8.211844586369244, 49.887287310941225,
    ],
    '073395006057': [
      8.10307372270405, 49.89065033993112, 8.176979939192325, 49.949196522718445,
    ],
    '073395006067': [
      8.211071596605528, 49.87384602847312, 8.251001296148067, 49.90157779502708,
    ],
    '073395007010': [
      8.268256250465935, 49.81744993529493, 8.312827958128606, 49.84511669875837,
    ],
    '073395007011': [
      8.289755046212667, 49.82585582730997, 8.332355190764279, 49.85697344546263,
    ],
    '073395007012': [
      8.312827958128606, 49.80996676962025, 8.378942545674882, 49.84502354463058,
    ],
    '073395007013': [
      8.228388893785977, 49.78837900623247, 8.274126185869719, 49.81343677742082,
    ],
    '073395007015': [
      8.271405379282566, 49.78362278954749, 8.312968541675225, 49.80216866074599,
    ],
    '073395007018': [
      8.239592162974603, 49.821696849878315, 8.268329828801734, 49.840709651464024,
    ],
    '073395007024': [
      8.312734848829834, 49.78205680287033, 8.400473775945262, 49.82118350830204,
    ],
    '073395007025': [
      8.20327113412737, 49.849881512471136, 8.248615010221156, 49.878016408167596,
    ],
    '073395007028': [
      8.233091625355303, 49.76787613768652, 8.280607658761964, 49.78876156915474,
    ],
    '073395007033': [
      8.235953538192692, 49.83956648171618, 8.282749425671788, 49.85450913404683,
    ],
    '073395007035': [
      8.339906822399673, 49.80996676962025, 8.390578347640403, 49.827421989147375,
    ],
    '073395007037': [
      8.245792248240148, 49.86566519885295, 8.293199312993993, 49.89830820665281,
    ],
    '073395007043': [
      8.274038678614133, 49.844017169408566, 8.359220007181012, 49.90344672655336,
    ],
    '073395007049': [
      8.33070845268755, 49.83307647751725, 8.38626296518978, 49.86463860216252,
    ],
    '073395007053': [
      8.232662495741375, 49.852523174020185, 8.278607809151884, 49.882755607236156,
    ],
    '073395007059': [
      8.267808767578716, 49.79741379760748, 8.315352191583822, 49.82585582730997,
    ],
    '073395007060': [
      8.188940098219835, 49.824275172711346, 8.248650505637416, 49.853484929025235,
    ],
    '073395007064': [
      8.231726978764264, 49.803409186422726, 8.278771362825907, 49.8286674365519,
    ],
    '073395007066': [
      8.268736781952303, 49.76857284890833, 8.312968541675225, 49.78555097454024,
    ],
    '073395007201': [
      8.253749782246901, 49.74766917679644, 8.300580098364184, 49.77633549111772,
    ],
    '073395008002': [
      7.960599135879681, 49.88787992582871, 8.005847895325086, 49.923818329262254,
    ],
    '073395008004': [
      7.95286032083821, 49.83303066359905, 7.994529137534419, 49.853310270714445,
    ],
    '073395008021': [
      7.914773184778896, 49.87756366414994, 7.954038434950024, 49.913054374380124,
    ],
    '073395008022': [
      7.899504635362624, 49.903512612053504, 7.949810873467526, 49.92088893895998,
    ],
    '073395008029': [
      7.949810873467526, 49.884896582060236, 7.980241297977466, 49.91322769121143,
    ],
    '073395008050': [
      8.004633337996797, 49.8495803202149, 8.036610449425558, 49.888271310300546,
    ],
    '073395008056': [
      7.954575342825341, 49.8422201403965, 8.022490138584896, 49.898655986501275,
    ],
    '073395008065': [
      7.946071699088383, 49.87476545924245, 7.980241297977466, 49.89090091975104,
    ],
    '073395008068': [
      7.952324609409411, 49.86473746363776, 7.991883465738313, 49.89090091975104,
    ],
    '073395008202': [
      8.024029330531905, 49.85741739448548, 8.06453729298765, 49.88850387874532,
    ],
    '073405001001': [
      7.814908795357409, 49.033124760019604, 7.907334921545721, 49.09682337231547,
    ],
    '073405001002': [
      7.821664121784679, 49.11494156935646, 7.862116095248764, 49.167515135018576,
    ],
    '073405001004': [
      7.710446243454762, 49.108969368818784, 7.807715408133406, 49.18649858477839,
    ],
    '073405001009': [
      7.798886413209716, 49.14432995736275, 7.850250216491864, 49.177820772139604,
    ],
    '073405001010': [
      7.825666355150088, 49.0908290094657, 7.913443524081952, 49.1180971922911,
    ],
    '073405001011': [
      7.651167974114208, 49.045170680256554, 7.759781113419595, 49.13023058611836,
    ],
    '073405001021': [
      7.736638878642478, 49.044147905076535, 7.771607042687719, 49.05651651538959,
    ],
    '073405001029': [
      7.605892298117166, 49.05064863087308, 7.696043696810648, 49.12346325806999,
    ],
    '073405001033': [
      7.818549515045014, 49.06850859957396, 7.865392697810313, 49.10010608162123,
    ],
    '073405001034': [
      7.790528368959189, 49.05531637524905, 7.827526274349716, 49.07330204792528,
    ],
    '073405001039': [
      7.7296503220554, 49.07103445757634, 7.806898476896547, 49.106709793421906,
    ],
    '073405001043': [
      7.801737764905266, 49.124646885925, 7.835621039923845, 49.15008433470503,
    ],
    '073405001045': [
      7.695990322768526, 49.044147905076535, 7.790931885446815, 49.08575255892106,
    ],
    '073405001501': [
      7.754313065398375, 49.1039599374516, 7.825666355150088, 49.127093759883685,
    ],
    '073405001502': [
      7.790931885446815, 49.071543147176456, 7.838085629715191, 49.116525020999525,
    ],
    '073405002005': [
      7.871321693937289, 49.14232248889294, 7.898389959892097, 49.161921563294506,
    ],
    '073405002006': [
      7.888914986439737, 49.15413696531013, 7.911219989746843, 49.17698707350478,
    ],
    '073405002014': [
      7.805632501721651, 49.16205104057786, 7.872661409543317, 49.202157814635015,
    ],
    '073405002020': [
      7.71876565304042, 49.16456503571554, 7.812846691874431, 49.2092886310036,
    ],
    '073405002030': [
      7.883484351517084, 49.17142408930841, 7.917029348972109, 49.190514552413404,
    ],
    '073405002047': [
      7.858319576826175, 49.15339131567982, 7.897830010659417, 49.186167244616065,
    ],
    '073405002049': [
      7.812846691874431, 49.181829256657295, 7.916347182583691, 49.21596676697453,
    ],
    '073405002057': [
      7.750957741402584, 49.19853291731206, 7.909126484684706, 49.33394921660127,
    ],
    '073405003008': [
      7.529277488673657, 49.08114142181776, 7.644156955946485, 49.13715064448435,
    ],
    '073405003019': [
      7.522437494668151, 49.10308908365501, 7.544746645917753, 49.13218612039967,
    ],
    '073405003026': [
      7.470195609580622, 49.13218612039967, 7.536612745664169, 49.1815877881713,
    ],
    '073405003028': [
      7.576247994486217, 49.116503433220494, 7.730201121361776, 49.19174543135415,
    ],
    '073405003036': [
      7.570765241415054, 49.15305904602753, 7.59468092830274, 49.1728166876875,
    ],
    '073405003040': [
      7.665761062841926, 49.185392632553665, 7.736114876835696, 49.20420483790876,
    ],
    '073405003048': [
      7.489719166432025, 49.11027062036472, 7.523286190797215, 49.14588966870179,
    ],
    '073405003052': [
      7.523286190797215, 49.12499138673331, 7.578048552318088, 49.150614047933914,
    ],
    '073405003053': [
      7.50525888933478, 49.14506349024899, 7.580820367055943, 49.19042318679523,
    ],
    '073405003205': [
      7.482246264920504, 49.17469052059808, 7.529651696155145, 49.201434098929084,
    ],
    '073405004003': [
      7.652391359279142, 49.24021362683594, 7.741890490210769, 49.27577280329468,
    ],
    '073405004007': [
      7.607146971236095, 49.25392816198041, 7.691968586946479, 49.27440830725765,
    ],
    '073405004027': [
      7.726875759005695, 49.256554160563645, 7.842999559567128, 49.32185977272164,
    ],
    '073405004031': [
      7.689910867692046, 49.224224725033245, 7.828288968282204, 49.27195017779352,
    ],
    '073405004032': [
      7.654927508690283, 49.18890870532691, 7.759109045256135, 49.24780357378951,
    ],
    '073405004038': [
      7.598913150116019, 49.21806895332642, 7.67450468323247, 49.254381985212085,
    ],
    '073405006012': [
      7.664765564761877, 49.31344976740623, 7.718168231221459, 49.338479294485225,
    ],
    '073405006015': [
      7.679223894332714, 49.27161278860216, 7.799835412936281, 49.32487222509625,
    ],
    '073405006016': [
      7.590514830512622, 49.28986896229783, 7.664486715923652, 49.33199384627849,
    ],
    '073405006022': [
      7.573163969795736, 49.26611706669733, 7.637344054063512, 49.30832952986785,
    ],
    '073405006025': [
      7.628053822891215, 49.317185591717276, 7.671060578230668, 49.3425470606551,
    ],
    '073405006044': [
      7.699162252581966, 49.3143569835731, 7.767697619299984, 49.34374578813444,
    ],
    '073405006050': [
      7.650280710095183, 49.304445783526155, 7.68401083425529, 49.32560866529702,
    ],
    '073405006054': [
      7.619621640784024, 49.26481558273985, 7.701215320596828, 49.31344976740623,
    ],
    '073405008201': [
      7.34410520805161, 49.194985296910694, 7.401205871648774, 49.21807434624313,
    ],
    '073405008202': [
      7.43019435985009, 49.26675724087704, 7.482680470486552, 49.29410884669097,
    ],
    '073405008203': [
      7.39085580206321, 49.33380943225445, 7.438726608939487, 49.36806889425734,
    ],
    '073405008206': [
      7.390088951200882, 49.20557155062215, 7.484748864443895, 49.27561328457138,
    ],
    '073405008207': [
      7.458484053656051, 49.22191171838653, 7.508006269532634, 49.26156034549279,
    ],
    '073405008208': [
      7.397262217925425, 49.17931230150983, 7.447906361138691, 49.219584094543855,
    ],
    '073405008209': [
      7.408544832604282, 49.28245458130327, 7.441251846272912, 49.32133585117825,
    ],
    '073405008210': [
      7.432644077342409, 49.18089213404698, 7.471433072299392, 49.20692934435515,
    ],
    '073405008211': [
      7.321139283585298, 49.157727917222836, 7.385574295743725, 49.20554153366266,
    ],
    '073405008212': [
      7.377465694587451, 49.309474363271576, 7.45093964481348, 49.33923181434053,
    ],
    '073405008213': [
      7.431636628480401, 49.29273157068767, 7.465701973135117, 49.32549938515429,
    ],
    '073405008214': [
      7.446688612323811, 49.18089213404698, 7.491649469258724, 49.208032636730174,
    ],
    '073405008218': [
      7.381294017618954, 49.1751678584182, 7.410671649631488, 49.19992782296297,
    ],
    '073405008221': [
      7.437533856909824, 49.162299216360665, 7.488570763094069, 49.18396114868516,
    ],
    '073405008223': [
      7.424624723505553, 49.33301498912079, 7.455367234314795, 49.354662955657105,
    ],
    '073405008226': [
      7.446688612323811, 49.20692934435515, 7.495083615049462, 49.222491149079715,
    ],
    '073405008227': [
      7.435034340715832, 49.32549938515429, 7.481802798748511, 49.34999636306268,
    ],
    '073405009017': [
      7.523755720536655, 49.27347138184697, 7.578178727351884, 49.31678660501635,
    ],
    '073405009018': [
      7.531525465293403, 49.32919299186953, 7.577176983387274, 49.35295844085201,
    ],
    '073405009023': [
      7.526792096738921, 49.215604561876, 7.56835748760883, 49.2399583694026,
    ],
    '073405009024': [
      7.529370595043699, 49.23578234118088, 7.576681377443764, 49.25590836506639,
    ],
    '073405009035': [
      7.481363703998439, 49.19780634773625, 7.544725834573329, 49.23551692512626,
    ],
    '073405009037': [
      7.56230462168049, 49.232459405283166, 7.59939683204137, 49.24872393284714,
    ],
    '073405009041': [
      7.533886333525924, 49.31400804723687, 7.577176983387274, 49.33636545024547,
    ],
    '073405009042': [
      7.56250890988921, 49.293793973437495, 7.59415385482009, 49.323276181719784,
    ],
    '073405009051': [
      7.544165297012004, 49.24381297158697, 7.609068184559765, 49.28221184763284,
    ],
    '073405009055': [
      7.574075776495651, 49.305123791482316, 7.632211520257058, 49.36548968027955,
    ],
    '073405009204': [
      7.47464247054901, 49.3033199229405, 7.502445136849608, 49.330318269365584,
    ],
    '073405009215': [
      7.485665624785766, 49.324538288981095, 7.537281265770649, 49.35600496193439,
    ],
    '073405009216': [
      7.45093964481348, 49.3110558417676, 7.494455330256584, 49.34133203833116,
    ],
    '073405009217': [
      7.49148157447593, 49.246787729933665, 7.553957065144442, 49.29245504131959,
    ],
    '073405009219': [
      7.556041146403998, 49.33996141512227, 7.610677851993259, 49.376236933198754,
    ],
    '073405009220': [
      7.470683401007445, 49.26568459143678, 7.524239654876556, 49.298786711266835,
    ],
    '073405009222': [
      7.480442130210494, 49.23101137858452, 7.542432669747671, 49.271355819786216,
    ],
    '073405009224': [
      7.48760808206207, 49.29047680101124, 7.534544533934672, 49.313972417296206,
    ],
    '073405009225': [
      7.494455330256584, 49.30576859387097, 7.53392978338287, 49.334080351762246,
    ],
    '073405009228': [
      7.439592591532207, 49.28643910397026, 7.493475031483244, 49.32076143602715,
    ],
    '081110000000': [
      9.041401114212695, 48.68990069429967, 9.315270991513744, 48.86357180230843,
    ],
    '081150003003': [
      8.935837978551218, 48.65493257669437, 9.113030140999003, 48.70334183363775,
    ],
    '081150028028': [
      8.95761006979483, 48.74566011606768, 9.066879629418212, 48.833556008678784,
    ],
    '081150029029': [
      8.93095676485804, 48.72910657529449, 9.036142514836953, 48.76266958244011,
    ],
    '081150041041': [
      8.879583173083832, 48.73252592036342, 8.97451124868399, 48.80857181499016,
    ],
    '081150042042': [
      8.871138021197194, 48.78941989019478, 8.966468604294159, 48.83029263091295,
    ],
    '081150044044': [
      9.024003089618176, 48.64179350474729, 9.105214674083218, 48.67386081695471,
    ],
    '081150045045': [
      8.904393077210315, 48.673990377994066, 9.10695561958812, 48.74863689254677,
    ],
    '081150050050': [
      8.799494243818197, 48.71691641713721, 8.934181825386792, 48.802527645791876,
    ],
    '081150051051': [
      9.023529597483742, 48.58777936714484, 9.101269601309156, 48.64858049343242,
    ],
    '081150052052': [
      8.87414269023678, 48.815998801010046, 8.966468604294159, 48.86673153255253,
    ],
    '081155001001': [
      8.818930186679912, 48.65310761930477, 8.928633282077598, 48.7097276340354,
    ],
    '081155001054': [
      8.855132558714525, 48.69657379825587, 8.94166623688824, 48.73252592036342,
    ],
    '081155002013': [
      8.90029265410702, 48.637327590846645, 8.983995942672465, 48.674686571130046,
    ],
    '081155002015': [
      8.845114893221764, 48.614332721854254, 8.962534478173435, 48.6614411670804,
    ],
    '081155003010': [
      8.794792736337165, 48.63421550494714, 8.84949108686273, 48.66424882004803,
    ],
    '081155003021': [
      8.78981849313664, 48.56151475931929, 8.97871838657645, 48.638280209177395,
    ],
    '081155003037': [
      8.864512639321795, 48.60660720159148, 8.929672217100993, 48.63439618900734,
    ],
    '081155004002': [
      8.976558443459915, 48.57787544259205, 9.042727600425476, 48.64742046652849,
    ],
    '081155004022': [
      8.918883202920002, 48.59572875788847, 8.988840491370786, 48.64742046652849,
    ],
    '081155004024': [
      8.983929146760955, 48.59624163070615, 9.048614688441926, 48.66333217587024,
    ],
    '081155005004': [
      8.78694054442679, 48.49911481711518, 8.86190617854708, 48.54231624290833,
    ],
    '081155005016': [
      8.792687103201574, 48.53732147997928, 8.889299022439513, 48.57475092261453,
    ],
    '081155005034': [
      8.757873643202652, 48.520547975324234, 8.807243673416707, 48.54976985000787,
    ],
    '081155005053': [
      8.747019616854587, 48.5482761029922, 8.824631476885134, 48.60377535983392,
    ],
    '081155006046': [
      9.085766231883268, 48.64208199120443, 9.1583805960656, 48.679281877991144,
    ],
    '081155006048': [
      9.087809896046188, 48.60175356431188, 9.174269265259083, 48.65798774880215,
    ],
    '081160015015': [
      9.287418750576611, 48.668975290406, 9.37095312477391, 48.71312570156123,
    ],
    '081160019019': [
      9.260074985746522, 48.70661570119073, 9.41648756285538, 48.77451112104755,
    ],
    '081160047047': [
      9.24543154183217, 48.661319994287936, 9.315054967570573, 48.698443429652734,
    ],
    '081160072072': [
      9.392138022984705, 48.66741963575026, 9.448506405755412, 48.70843617511533,
    ],
    '081160076076': [
      9.344827825727199, 48.74473629186387, 9.41760384216031, 48.78822060950959,
    ],
    '081160077077': [
      9.1583805960656, 48.628026902481004, 9.270616795175261, 48.69344554770286,
    ],
    '081160078078': [
      9.085766231883268, 48.65323175608482, 9.197896689229417, 48.707747316179166,
    ],
    '081160080080': [
      9.212627602325544, 48.69344554770286, 9.311920787318352, 48.7441620983029,
    ],
    '081160081081': [
      9.143585197365462, 48.60398368723342, 9.29367126064579, 48.651146973702616,
    ],
    '081165001016': [
      9.405145770804852, 48.596084004438524, 9.479548112224158, 48.63170995169221,
    ],
    '081165001033': [
      9.39201522236091, 48.60901082306484, 9.524213200434703, 48.670089489189344,
    ],
    '081165001048': [
      9.43188097671869, 48.66212677044618, 9.49152394076769, 48.68686461228439,
    ],
    '081165002018': [
      9.40174358822615, 48.53581331833894, 9.455699626194159, 48.5655155349252,
    ],
    '081165002054': [
      9.407170723679043, 48.5655155349252, 9.474155498849488, 48.60330011348613,
    ],
    '081165002079': [
      9.435984221195241, 48.511292786581784, 9.579846717166244, 48.585656977680685,
    ],
    '081165003005': [
      9.262909806762138, 48.58303115272329, 9.291121632576946, 48.602460165641745,
    ],
    '081165003006': [
      9.198498293126187, 48.58122861682662, 9.233031001433169, 48.59803219593066,
    ],
    '081165003008': [
      9.249811962008367, 48.56572496154444, 9.30160675684766, 48.58930103835528,
    ],
    '081165003041': [
      9.240097243064321, 48.59835319406469, 9.29615260605301, 48.62317995968558,
    ],
    '081165003042': [
      9.207107194675183, 48.566011996130754, 9.264305439548496, 48.600331774279404,
    ],
    '081165003063': [
      9.178945445703889, 48.59611244081699, 9.247358106167193, 48.62146919895291,
    ],
    '081165004011': [
      9.372407361083004, 48.55477451774283, 9.435984221195241, 48.60444197779461,
    ],
    '081165004036': [
      9.314292127741878, 48.552693467177754, 9.351550329497506, 48.57063331236825,
    ],
    '081165004046': [
      9.311873356238925, 48.53013519081311, 9.409742120721246, 48.57719430451173,
    ],
    '081165005020': [
      9.320350443030597, 48.5705504406983, 9.397095248232661, 48.6043252020968,
    ],
    '081165005022': [
      9.287060383894245, 48.57802040157043, 9.321822500525943, 48.59835319406469,
    ],
    '081165005049': [
      9.280500403927517, 48.578440475994846, 9.410824333830789, 48.654852808299964,
    ],
    '081165005050': [
      9.353822051445592, 48.63402876231143, 9.400644784509847, 48.6589416475718,
    ],
    '081165005068': [
      9.315042836409557, 48.6474619196284, 9.36604636865555, 48.671875951654876,
    ],
    '081165005073': [
      9.262344543256226, 48.64222950721494, 9.318490157131015, 48.66654693209056,
    ],
    '081165006004': [
      9.365033929606675, 48.718586780673725, 9.39413611677153, 48.7377615190824,
    ],
    '081165006014': [
      9.359138481951357, 48.70073214779661, 9.412572912164334, 48.71911409253972,
    ],
    '081165006056': [
      9.388600607000217, 48.70136752701606, 9.453582923889458, 48.74256997992937,
    ],
    '081165007007': [
      9.412368194289847, 48.7232553801033, 9.476091621043427, 48.77739776593064,
    ],
    '081165007027': [
      9.44256057847724, 48.6794136384361, 9.492600872353819, 48.705875112156946,
    ],
    '081165007037': [
      9.463466764416195, 48.72419488745975, 9.510758291889266, 48.77069667925126,
    ],
    '081165007058': [
      9.44307134197134, 48.70453107385087, 9.493532565779988, 48.72669987357447,
    ],
    '081165008012': [
      9.47053335871138, 48.560367076495055, 9.543341103637456, 48.61031562579646,
    ],
    '081165008029': [
      9.505180852097165, 48.630029744717426, 9.556131008771096, 48.64649572691092,
    ],
    '081165008043': [
      9.53312625464386, 48.55194020733479, 9.593867920741305, 48.59905928036165,
    ],
    '081165008053': [
      9.507259595786786, 48.63919625037664, 9.55465868263941, 48.66059349551582,
    ],
    '081165008070': [
      9.49974516064907, 48.57621957739779, 9.59640077953847, 48.63520454251614,
    ],
    '081165009035': [
      9.315054967570573, 48.668975290406, 9.396522035726205, 48.7041536458295,
    ],
    '081165009071': [
      9.357837166639868, 48.65019060373902, 9.42341787644132, 48.689649755457,
    ],
    '081170010010': [
      9.850929053363636, 48.639765312347926, 9.992118850106733, 48.7315669557409,
    ],
    '081175001006': [
      9.653790348762103, 48.5499412045096, 9.729611961197417, 48.63745992840125,
    ],
    '081175001014': [
      9.687643460857716, 48.56500217818088, 9.75147071899782, 48.639343026243715,
    ],
    '081175002018': [
      9.484460304600164, 48.677918101513214, 9.573186185267145, 48.749681489336645,
    ],
    '081175002044': [
      9.490935670193457, 48.656484794316256, 9.550503714122842, 48.69432470981324,
    ],
    '081175003019': [
      9.681959969640552, 48.67307883332481, 9.752733292375995, 48.727852400898676,
    ],
    '081175003037': [
      9.724848227297786, 48.709956481413315, 9.789718530452756, 48.75380566191398,
    ],
    '081175003042': [
      9.725107014818946, 48.68154766323642, 9.784396040540532, 48.716083288343214,
    ],
    '081175004007': [
      9.717164621049383, 48.58667154483546, 9.816124973811506, 48.65480488087626,
    ],
    '081175004024': [
      9.729611961197417, 48.559029968458994, 9.947305884897231, 48.67236280738867,
    ],
    '081175004033': [
      9.761900496771903, 48.61795093457318, 9.818218709750393, 48.656790312742814,
    ],
    '081175005026': [
      9.590994019642212, 48.65558242628393, 9.752133241467073, 48.77631019100346,
    ],
    '081175005043': [
      9.685849061370964, 48.63383061025438, 9.731734060178116, 48.67307883332481,
    ],
    '081175005053': [
      9.655467741522125, 48.740581364090495, 9.717888001179194, 48.779482457171454,
    ],
    '081175005055': [
      9.568160359797666, 48.71821044537545, 9.629237722856576, 48.750590878092694,
    ],
    '081175006015': [
      9.760437150497014, 48.63230545542228, 9.868131513263574, 48.736809785017826,
    ],
    '081175006025': [
      9.747256407520569, 48.640360105603534, 9.808461437445459, 48.67262649150528,
    ],
    '081175006049': [
      9.71180223230385, 48.6510711848605, 9.783806938611074, 48.6892767894373,
    ],
    '081175006061': [
      9.834875487426372, 48.694662842275264, 9.941530952182246, 48.75361825680813,
    ],
    '081175007016': [
      9.649510767089993, 48.5387423228915, 9.721568637591414, 48.56551316043616,
    ],
    '081175007028': [
      9.58764833487356, 48.57856699848849, 9.677690635342728, 48.62637752698954,
    ],
    '081175007031': [
      9.632306310189712, 48.518308819598104, 9.69583171963707, 48.55415033495927,
    ],
    '081175007035': [
      9.631092436089386, 48.55327429543955, 9.677690635342728, 48.59356268590774,
    ],
    '081175007058': [
      9.560643616389804, 48.53691711875742, 9.649510767089993, 48.58415056373934,
    ],
    '081175008001': [
      9.569939138851305, 48.74382495952742, 9.618652158246539, 48.781232859615876,
    ],
    '081175008009': [
      9.650612967387685, 48.74326020624581, 9.673239942819443, 48.761464453370124,
    ],
    '081175008011': [
      9.614498237580637, 48.74362016025653, 9.660102518119304, 48.77425715327992,
    ],
    '081175008038': [
      9.618652158246539, 48.719563355393106, 9.672034949401375, 48.745739125730275,
    ],
    '081175009002': [
      9.534969389048232, 48.61536240781216, 9.595545199907127, 48.640311151682965,
    ],
    '081175009012': [
      9.581011959494292, 48.619442897547096, 9.63006437123523, 48.66000965458316,
    ],
    '081175009017': [
      9.622757614448881, 48.62277086830384, 9.64902389753739, 48.658614267470185,
    ],
    '081175009023': [
      9.643104029666183, 48.62277086830384, 9.661671624809767, 48.65367883431386,
    ],
    '081175009029': [
      9.54070983694209, 48.653950267744094, 9.591619410858963, 48.67962393736357,
    ],
    '081175009060': [
      9.550541837445653, 48.63416192433338, 9.601818608531547, 48.65906132134917,
    ],
    '081175010003': [
      9.536612952398112, 48.672400745028554, 9.579013086942483, 48.7039205401866,
    ],
    '081175010051': [
      9.503179725127543, 48.67293274658254, 9.611447235604308, 48.76186441802737,
    ],
    '081175011020': [
      9.663316602396984, 48.64251380043377, 9.687869955431236, 48.680206588478406,
    ],
    '081175011030': [
      9.626656044416203, 48.62774383989859, 9.687869955431236, 48.685114584707826,
    ],
    '081180003003': [
      9.126521088421228, 48.89120464854913, 9.159325843734338, 48.92116928208255,
    ],
    '081180011011': [
      8.95817060747387, 48.81235789618132, 9.091445539524248, 48.86429933402295,
    ],
    '081180019019': [
      9.028978982066342, 48.753687643629505, 9.087926367646439, 48.814047082409154,
    ],
    '081180021021': [
      9.236925173357811, 48.98277708211053, 9.339749681901282, 49.043913383090576,
    ],
    '081180046046': [
      9.15232664311804, 48.84978783965199, 9.224695428218393, 48.88420625315504,
    ],
    '081180048048': [
      9.138505432699247, 48.87348713483831, 9.311654578603733, 48.93056034003891,
    ],
    '081180050050': [
      9.014477142837384, 48.88919838642914, 9.126574041981325, 48.943366440680656,
    ],
    '081180051051': [
      9.106697990457885, 48.85667406570918, 9.1537691268393, 48.89973553067439,
    ],
    '081180060060': [
      9.290921234020585, 49.00117072791198, 9.415235929687087, 49.060037998365615,
    ],
    '081180076076': [
      8.87574447326761, 48.941807226399014, 9.094474482070114, 49.0447732378431,
    ],
    '081180080080': [
      9.050291070048322, 48.82227800858801, 9.141854883295808, 48.86858524669671,
    ],
    '081180081081': [
      9.223756347574763, 48.84680297282726, 9.316138391831483, 48.909318396390056,
    ],
    '081185001007': [
      9.118195304388898, 48.97559791469198, 9.236925173357811, 49.03360237571392,
    ],
    '081185001016': [
      9.029648258875326, 49.00113426327343, 9.074808500623039, 49.01574894745802,
    ],
    '081185001018': [
      9.148069057978926, 49.00556547863793, 9.188917077150204, 49.048559933976954,
    ],
    '081185001028': [
      9.16943600106262, 48.98621048121438, 9.200959924907194, 49.01607629738646,
    ],
    '081185001047': [
      9.061162727476184, 48.98020680384145, 9.129744844605574, 49.0096671862683,
    ],
    '081185001053': [
      9.191084701991976, 48.97793331303806, 9.255703839787, 49.0211158979558,
    ],
    '081185001074': [
      9.116553610061418, 49.00042470124796, 9.159229311477734, 49.02854174025971,
    ],
    '081185002071': [
      9.087189203979435, 48.90889270719682, 9.158227360593957, 48.94105612368579,
    ],
    '081185002077': [
      9.151318653048852, 48.9449385185125, 9.21506766485785, 48.99389897412377,
    ],
    '081185002079': [
      9.0681585909107, 48.92588004878727, 9.166629523181598, 48.98365161405357,
    ],
    '081185003010': [
      9.015536158108393, 49.007989486686924, 9.13173539841117, 49.06137822626512,
    ],
    '081185003015': [
      9.056975687543504, 49.00742894154568, 9.111393441871552, 49.03175407439511,
    ],
    '081185003040': [
      9.103388781659035, 49.02314469943056, 9.175388929560281, 49.06526291207087,
    ],
    '081185004063': [
      9.18349293423685, 48.94142336803011, 9.362136928077076, 48.98984885983161,
    ],
    '081185004078': [
      9.153373025914208, 48.915419218995744, 9.227568112006455, 48.947873954329395,
    ],
    '081185005001': [
      9.30901229418192, 48.904599502664716, 9.376068255745086, 48.93507194859331,
    ],
    '081185005006': [
      9.217304297756833, 48.9249706608807, 9.248769622822135, 48.95294688459988,
    ],
    '081185005014': [
      9.276186364302129, 48.918462195664844, 9.315163442337795, 48.95358243072563,
    ],
    '081185005049': [
      9.24841718196872, 48.90020900320174, 9.371697129021895, 48.98254243581514,
    ],
    '081185006027': [
      8.985333633815722, 48.85319194053181, 9.064050706038211, 48.88273555459934,
    ],
    '081185006067': [
      9.029025275939869, 48.85864071952736, 9.124401765306567, 48.890743387277034,
    ],
    '081185007054': [
      9.231487947020897, 48.950862403481885, 9.339098343304261, 48.99731879284437,
    ],
    '081185007070': [
      9.21506766485785, 48.952099853370974, 9.352763640327014, 48.99562159224018,
    ],
    '081185008012': [
      8.908635372168707, 48.85552965788338, 9.030848137811267, 48.91347060906667,
    ],
    '081185008059': [
      8.99721016543122, 48.91943446870241, 9.050407293534697, 48.949910014768584,
    ],
    '081185008068': [
      8.98376359571534, 48.94684479274777, 9.041885964758709, 48.98028110965735,
    ],
    '081185008073': [
      8.900365990188147, 48.88384235462637, 9.035770371129098, 49.02161096049919,
    ],
    '081190001001': [
      9.639177705508255, 48.81184230161369, 9.767965678046258, 48.915298696940276,
    ],
    '081190020020': [
      9.235859485744609, 48.778845218028756, 9.319744501937121, 48.86042011619729,
    ],
    '081190041041': [
      9.34316305964621, 48.824284047330494, 9.396875679825381, 48.8618887032767,
    ],
    '081190044044': [
      9.520183469659303, 48.933483601652604, 9.697988315335698, 49.02627180570671,
    ],
    '081190061061': [
      9.478726597942348, 48.84878956763403, 9.601637493051602, 48.912198078415926,
    ],
    '081190079079': [
      9.276092172684825, 48.81078619184662, 9.428185213095867, 48.90826022034365,
    ],
    '081190089089': [
      9.428185213095867, 48.82234087359458, 9.513969669119714, 48.89375055784954,
    ],
    '081190090090': [
      9.404054943074597, 48.78864575658134, 9.47819928149757, 48.84447482829503,
    ],
    '081190091091': [
      9.335926653250464, 48.75840119063546, 9.437174657460668, 48.835362818310145,
    ],
    '081190093093': [
      9.306252027670734, 48.76523321453195, 9.355102191050104, 48.81645283649542,
    ],
    '081195001003': [
      9.439504220389274, 48.890566031057304, 9.49384972223264, 48.92360593705306,
    ],
    '081195001004': [
      9.516412108258333, 48.89806406475478, 9.596234221566599, 48.95843472625083,
    ],
    '081195001006': [
      9.479791129232666, 48.9197895688695, 9.562089259774138, 48.972571017889145,
    ],
    '081195001008': [
      9.371894047212058, 48.90154230217562, 9.50159088462613, 48.993433908734,
    ],
    '081195001018': [
      9.350588976751245, 48.910906508051305, 9.417709836969708, 48.94130652293325,
    ],
    '081195001038': [
      9.301571734925115, 48.92773160551012, 9.381817544337608, 48.96586746569207,
    ],
    '081195001053': [
      9.418554329451128, 48.96576963057235, 9.500493410751123, 49.02467304470755,
    ],
    '081195001083': [
      9.459477341121872, 48.90136881876749, 9.53817662062804, 48.944353037483694,
    ],
    '081195001087': [
      9.32543669148975, 48.94951194478221, 9.434038425833094, 49.024445683840966,
    ],
    '081195002055': [
      9.556316983875831, 48.770054340381996, 9.651207667964457, 48.8565445980002,
    ],
    '081195002076': [
      9.545515459224562, 48.797179779834025, 9.639177705508255, 48.85416285647093,
    ],
    '081195003067': [
      9.474129834285371, 48.740343085359235, 9.585758135217375, 48.85395735462525,
    ],
    '081195003086': [
      9.436456522764228, 48.765246439760986, 9.507467023074492, 48.82213053484683,
    ],
    '081195004024': [
      9.492137002571488, 49.01287854602115, 9.611580927409623, 49.07739121629808,
    ],
    '081195004069': [
      9.382112963926799, 49.01791773324114, 9.495171005648045, 49.07485677423798,
    ],
    '081195004075': [
      9.458828112312755, 48.97114568921512, 9.55818300404188, 49.047025287706504,
    ],
    '081195005037': [
      9.585810705466583, 48.893754364017504, 9.704723888080265, 48.9462793294436,
    ],
    '081195005084': [
      9.556307049429645, 48.841314243168505, 9.695402126012258, 48.92289059268854,
    ],
    '081195006042': [
      9.342807340732, 48.88311337872304, 9.429209347335133, 48.92098327491651,
    ],
    '081195006068': [
      9.322374912893665, 48.86038300574283, 9.380442940803663, 48.891532179142494,
    ],
    '081195006085': [
      9.362287126413023, 48.84447482829503, 9.460036905074679, 48.90286900999937,
    ],
    '081210000000': [
      9.053266692783762, 49.09336139261472, 9.297571331248783, 49.20942753807365,
    ],
    '081250007007': [
      9.10946725446187, 49.20656117567636, 9.20386005826851, 49.25102289159223,
    ],
    '081250039039': [
      9.132055594764767, 49.25263406988823, 9.242139516704219, 49.327937264919065,
    ],
    '081250058058': [
      9.072331307477015, 49.1196782335846, 9.16070708216272, 49.17069166828593,
    ],
    '081250068068': [
      9.22682496185645, 49.266491546206, 9.357668365635861, 49.330378932456284,
    ],
    '081250107107': [
      9.414683239589976, 49.04684416463683, 9.526353710379116, 49.13826490055539,
    ],
    '081255001005': [
      9.177222281946946, 49.20344155683729, 9.267836885418532, 49.275411851704625,
    ],
    '081255001078': [
      9.226983836336162, 49.20796445539693, 9.300980302144916, 49.26375984215247,
    ],
    '081255001079': [
      9.156322890179725, 49.23221086700034, 9.187611039010847, 49.26472736801023,
    ],
    '081255002006': [
      8.962840430706942, 49.19700821736636, 9.15754326228633, 49.299017680235295,
    ],
    '081255002049': [
      8.957438247761436, 49.174696411483424, 9.02691859331789, 49.222467011185714,
    ],
    '081255002087': [
      9.06031461894797, 49.25729297830681, 9.11548024773489, 49.27946683088988,
    ],
    '081255003013': [
      8.990465016006635, 49.04516339576815, 9.125964737335744, 49.11808815360233,
    ],
    '081255003017': [
      8.987474806014395, 49.02215550333408, 9.063993056643701, 49.06945603935798,
    ],
    '081255004026': [
      8.817702373062126, 49.075987610898835, 9.002238325569461, 49.19419219535378,
    ],
    '081255004034': [
      8.934975975310037, 49.12675760527688, 9.016562617577724, 49.17992244146034,
    ],
    '081255004047': [
      8.886775067526836, 49.17842813091058, 8.964738013945007, 49.213294726895505,
    ],
    '081255005030': [
      9.19121518226904, 49.08682659287344, 9.259048071335483, 49.11281769796132,
    ],
    '081255005094': [
      9.162503941902159, 49.06937239504359, 9.246603026321615, 49.10469937344239,
    ],
    '081255006056': [
      9.117602641340941, 49.051155709628674, 9.375218496359679, 49.104231227907256,
    ],
    '081255006066': [
      9.171236312120756, 49.0211158979558, 9.25689249479331, 49.06246264350125,
    ],
    '081255006074': [
      9.068910117177445, 49.09642849371214, 9.15273159213299, 49.12574198762087,
    ],
    '081255007048': [
      9.431813757829763, 49.28939009006605, 9.515850274038344, 49.33776009061066,
    ],
    '081255007063': [
      9.28748519729995, 49.28059658784322, 9.41710812918134, 49.365385352866795,
    ],
    '081255007084': [
      9.309871148748286, 49.34397145503788, 9.37646555644815, 49.387267241702276,
    ],
    '081255007103': [
      9.388193697591715, 49.294253468236015, 9.465593723729008, 49.3642957269369,
    ],
    '081255008027': [
      9.235468367846174, 49.15961364850761, 9.294093334879287, 49.203693313374416,
    ],
    '081255008065': [
      9.159525643868577, 49.16995550570513, 9.318415239469699, 49.22168874724884,
    ],
    '081255008096': [
      9.171308359649046, 49.20103488096754, 9.217942093339797, 49.2183454843343,
    ],
    '081255009069': [
      9.263221420186118, 49.185866774675674, 9.369035003275222, 49.2792583594034,
    ],
    '081255009111': [
      9.345728463964615, 49.2330299071502, 9.445425504126906, 49.29881426666388,
    ],
    '081255009113': [
      9.35281444995789, 49.1809693441017, 9.451557881671818, 49.238129121227644,
    ],
    '081255010038': [
      8.972610241812108, 49.03666590344373, 9.048773332588235, 49.09109279875442,
    ],
    '081255010081': [
      8.93075624690328, 49.03475164677088, 8.986543346888714, 49.08046690164695,
    ],
    '081255010108': [
      8.865850064550207, 49.03676055830025, 8.95058713527902, 49.082538311627765,
    ],
    '081255011059': [
      9.3379712509723, 49.05801244927552, 9.451379107697651, 49.120126442075296,
    ],
    '081255011110': [
      9.333101143342658, 49.102463194568806, 9.448297143847187, 49.159053106013744,
    ],
    '081255012001': [
      9.274138544169972, 49.060713557039975, 9.34449496089343, 49.0907936757057,
    ],
    '081255012008': [
      9.287044833432791, 49.03170350077754, 9.426098414635455, 49.080870733173974,
    ],
    '081255012046': [
      9.20238700406532, 49.02749851775918, 9.320741453834023, 49.08682659287344,
    ],
    '081255012098': [
      9.246603026321615, 49.07420309307392, 9.375598735068122, 49.11654017974626,
    ],
    '081255013061': [
      9.009791409406201, 49.1645829720277, 9.05583428270251, 49.19832201736115,
    ],
    '081255013086': [
      8.945721077560625, 49.096622163307835, 9.091356592756549, 49.19727643870541,
    ],
    '081255014021': [
      9.293195194814272, 49.16598364507765, 9.366462928135338, 49.19959667134072,
    ],
    '081255014024': [
      9.306327626416591, 49.12458775307391, 9.339384145112513, 49.159053106013744,
    ],
    '081255014057': [
      9.297571331248783, 49.10646785252699, 9.339725537907, 49.137929498384345,
    ],
    '081255014102': [
      9.25514960007025, 49.11654017974626, 9.370322491376335, 49.19102170293948,
    ],
    '081260011011': [
      9.345180122933911, 49.09574457735154, 9.539370970981254, 49.213013729080494,
    ],
    '081260072072': [
      9.44134618755036, 49.295723272598934, 9.639485848853772, 49.396199253463585,
    ],
    '081265001047': [
      9.623096180608353, 49.16166278318338, 9.765072878720114, 49.26555471614006,
    ],
    '081265001058': [
      9.537090931456806, 49.17399576108378, 9.657547320170234, 49.26287984818076,
    ],
    '081265001085': [
      9.593105925828013, 49.12687631316517, 9.673611186299613, 49.21280834391892,
    ],
    '081265002020': [
      9.663286750286407, 49.33733739492137, 9.771051519024729, 49.417541483997084,
    ],
    '081265002045': [
      9.570563623373367, 49.34380748889596, 9.70402620346234, 49.429649146867476,
    ],
    '081265002056': [
      9.731139419983952, 49.28667246046713, 9.860316265792392, 49.40780812587413,
    ],
    '081265003039': [
      9.610855618937588, 49.28060385675966, 9.762911140649997, 49.358127434328665,
    ],
    '081265003046': [
      9.640535873527721, 49.24059209266572, 9.833143648898453, 49.31990848867441,
    ],
    '081265004028': [
      9.438975431343033, 49.232840135959606, 9.590746398180501, 49.326897398008974,
    ],
    '081265004060': [
      9.568432648286889, 49.252448647460675, 9.651143011444757, 49.30968076605021,
    ],
    '081265004086': [
      9.57885368646043, 49.28381030817792, 9.630120381272256, 49.33440476919768,
    ],
    '081265005066': [
      9.415892427972688, 49.15123579008123, 9.61661014587359, 49.28286103415885,
    ],
    '081265005069': [
      9.458412389773553, 49.105228806786876, 9.613293802929888, 49.19300921434644,
    ],
    '081265005094': [
      9.449459832362008, 49.218338027607956, 9.554014636247972, 49.28256966419393,
    ],
    '081270008008': [
      9.84130206841579, 49.263409902176015, 10.120368462855161, 49.34294174733318,
    ],
    '081270052052': [
      9.49785089120446, 49.047204323935375, 9.651308304776338, 49.13357513658232,
    ],
    '081270075075': [
      9.843126191836276, 49.306980207873565, 10.12411327941587, 49.39472018121295,
    ],
    '081275001009': [
      9.736282298224138, 49.14349640243193, 9.837582603680001, 49.25811521419038,
    ],
    '081275001086': [
      9.690751048924358, 49.136457206155356, 9.788388416737227, 49.19950419952624,
    ],
    '081275002014': [
      9.944111381487524, 49.08063916635324, 10.168508098796561, 49.185766696649885,
    ],
    '081275002073': [
      10.011662856585787, 49.152154035646646, 10.171290725667717, 49.21375383140833,
    ],
    '081275002103': [
      9.90910601102595, 49.033259429549524, 10.092159483470336, 49.12859542564594,
    ],
    '081275002104': [
      10.069499897972024, 49.03679137005974, 10.170506280552528, 49.1021359523656,
    ],
    '081275003101': [
      10.116435565654681, 49.09429930877855, 10.25545509709607, 49.18211889721422,
    ],
    '081275003102': [
      10.158725408006838, 49.04077838729189, 10.263242603717488, 49.1000605311134,
    ],
    '081275004032': [
      9.859348015243324, 49.19268709214815, 9.987367948626249, 49.28717451065433,
    ],
    '081275004047': [
      9.818699681097282, 49.2167349468514, 9.916161945043344, 49.290738287206246,
    ],
    '081275005043': [
      9.82370758950872, 49.11485464211786, 9.972933833221505, 49.23272506581698,
    ],
    '081275005089': [
      9.839888623050962, 49.076782173898, 9.954849420889378, 49.13742469644171,
    ],
    '081275005099': [
      9.80273172075022, 49.13161900398878, 9.897523010298855, 49.19268709214815,
    ],
    '081275006023': [
      9.662890674362918, 48.95608422924154, 9.764725821392764, 49.01211583115583,
    ],
    '081275006025': [
      9.703018131589557, 48.95204736905917, 9.83112546553476, 49.04944864424162,
    ],
    '081275006062': [
      9.59671298196282, 48.992923071396234, 9.7094270590967, 49.054798293027126,
    ],
    '081275006079': [
      9.79663839376511, 48.91799876421896, 9.917014339347698, 48.99942143162334,
    ],
    '081275007012': [
      9.880374567957793, 49.00669528576615, 9.984647043589758, 49.05305836962334,
    ],
    '081275007013': [
      9.848872007705031, 48.95931465836765, 10.014399994787262, 49.02840106878564,
    ],
    '081275007063': [
      9.792465950434249, 48.99755622874154, 9.95450109286922, 49.081056378851265,
    ],
    '081275008046': [
      9.917282699723334, 49.169396798732336, 10.04438923279633, 49.232670639676094,
    ],
    '081275008071': [
      9.938478166004518, 49.21707252783811, 10.156482608373636, 49.32680491923607,
    ],
    '081275008091': [
      10.032063014042253, 49.20234701753746, 10.140618402749372, 49.248512019870475,
    ],
    '081275009056': [
      9.734467128519828, 49.045451691493874, 9.807364997923132, 49.09488911438575,
    ],
    '081275009059': [
      9.58008434803289, 49.08522337537166, 9.69406780887066, 49.14911086414469,
    ],
    '081275009076': [
      9.6137570268035, 49.04656141742289, 9.87445996659185, 49.16689715416694,
    ],
    '081275009100': [
      9.645825822664383, 49.02979021762593, 9.757807249608007, 49.09628392320637,
    ],
    '081280020020': [
      9.972985251340416, 49.38369292327222, 10.161522815285602, 49.545018106810296,
    ],
    '081280039039': [
      9.29525886099806, 49.70398454719782, 9.419613189765247, 49.77813983319881,
    ],
    '081280064064': [
      9.39785676193766, 49.635496766910734, 9.608596445738034, 49.70962640610503,
    ],
    '081280082082': [
      9.830630756589052, 49.351555292314295, 10.051765555274708, 49.45590644510939,
    ],
    '081280126126': [
      9.853536254731232, 49.431253000565604, 10.001863316889414, 49.55306048020522,
    ],
    '081280131131': [
      9.367695171516003, 49.69302320804935, 9.650784762863312, 49.792109817163684,
    ],
    '081280139139': [
      9.571734381640177, 49.50829678694161, 9.825291047332772, 49.59732705039615,
    ],
    '081285001006': [
      9.639915954742609, 49.40686165823619, 9.714441027225028, 49.452776922394484,
    ],
    '081285001007': [
      9.691880309678307, 49.38831249413625, 9.868429289843876, 49.525798824895915,
    ],
    '081285001058': [
      9.795295108406675, 49.48313959259708, 9.922202706422118, 49.58588462021511,
    ],
    '081285002014': [
      9.559874251680688, 49.42670283072265, 9.705596075046099, 49.54753695666973,
    ],
    '081285002138': [
      9.492130433932594, 49.43951396822813, 9.596737734711722, 49.55697529936153,
    ],
    '081285003047': [
      9.710086921882391, 49.571789066772574, 9.814976545500773, 49.6613420959157,
    ],
    '081285003137': [
      9.792908340382146, 49.561976242743654, 9.872442617533617, 49.661364117633774,
    ],
    '081285004045': [
      9.692981445826586, 49.63895472671988, 9.836205728947753, 49.729228854164134,
    ],
    '081285004061': [
      9.499383782149108, 49.5449967146726, 9.629346402405146, 49.64908455924691,
    ],
    '081285004115': [
      9.585373514442368, 49.56216791028793, 9.725889684328573, 49.68360357281583,
    ],
    '081285004128': [
      9.56734040795529, 49.65521781386429, 9.728442865525647, 49.72677984526591,
    ],
    '081350010010': [
      10.298388383177224, 48.65381822289902, 10.49134005793233, 48.7480342997448,
    ],
    '081350015015': [
      9.919343053562272, 48.568687688241894, 10.180081372555884, 48.666892189725736,
    ],
    '081350020020': [
      10.077647484436337, 48.549878140249106, 10.218891822464078, 48.663204246881875,
    ],
    '081350025025': [
      10.027554492543647, 48.70392015216261, 10.176237682904084, 48.78707162881588,
    ],
    '081350032032': [
      9.956989138849199, 48.64406883558692, 10.123716977331908, 48.765195014437566,
    ],
    '081355001016': [
      10.168599017752241, 48.57259309321717, 10.322756170479082, 48.66488361813381,
    ],
    '081355001021': [
      10.22233749314415, 48.58045842745353, 10.306355553537742, 48.616509453388545,
    ],
    '081355002019': [
      10.10455298116099, 48.643002610268745, 10.27988489631181, 48.78300439356969,
    ],
    '081355002026': [
      10.201482312990377, 48.6805236142995, 10.333663932770694, 48.75382176854182,
    ],
    '081355003027': [
      10.18380703635927, 48.51016885954668, 10.268776485601853, 48.5825463400197,
    ],
    '081355003031': [
      10.227731394475613, 48.516025450765476, 10.314728026832103, 48.587653264633126,
    ],
    '081360002002': [
      9.868557812507781, 48.85805835282201, 10.040315121350448, 48.954955100319324,
    ],
    '081360027027': [
      9.67140839253608, 48.903528619449865, 9.845089045507166, 48.97332313655181,
    ],
    '081360042042': [
      9.619442761776138, 48.7710016190812, 9.731291136037985, 48.82827377650865,
    ],
    '081360045045': [
      10.203925337282076, 48.73065902787869, 10.443373950748642, 48.825312349837546,
    ],
    '081360050050': [
      10.056862984522581, 48.753487816334015, 10.145603999257412, 48.8082077830068,
    ],
    '081365001021': [
      9.962009197274758, 48.73187794610726, 10.082979641559325, 48.84869330568518,
    ],
    '081365001033': [
      10.02987809849162, 48.87579593492913, 10.126129054067938, 48.92914474356569,
    ],
    '081365001088': [
      9.97290020963019, 48.74865291733038, 10.277695410325727, 48.89890462245163,
    ],
    '081365002010': [
      10.261452748876929, 48.81242118798433, 10.42840451139819, 48.91938875745992,
    ],
    '081365002037': [
      10.360142915133471, 48.8523209851508, 10.45388823870946, 48.90661194683318,
    ],
    '081365002087': [
      10.386521565217247, 48.808806603892194, 10.452744670601176, 48.883225043735656,
    ],
    '081365003003': [
      9.890391653098698, 48.940645256577426, 10.020511952186542, 48.98187563986415,
    ],
    '081365003018': [
      10.167121995772726, 48.981105267154106, 10.27064886408143, 49.0480262652302,
    ],
    '081365003019': [
      10.048526319132138, 48.90561381519822, 10.303718139868694, 49.025167821721475,
    ],
    '081365003035': [
      10.044918970373207, 48.999295108287974, 10.186251031830555, 49.06021730029497,
    ],
    '081365003046': [
      10.00381125370259, 48.89696453666467, 10.121825353298219, 48.97839682356133,
    ],
    '081365003060': [
      9.973914903675707, 48.968166740481806, 10.098491475397429, 49.052335159890056,
    ],
    '081365003084': [
      10.226773587561064, 49.007208213800354, 10.321813855878656, 49.0592797007995,
    ],
    '081365003089': [
      10.111787324489777, 48.89253108088968, 10.203987607019195, 48.948230389573666,
    ],
    '081365004038': [
      10.200817296395266, 48.836404704032155, 10.326718178557298, 48.90594103795911,
    ],
    '081365004082': [
      10.139337575401298, 48.85430821728157, 10.293180303541746, 48.92876413596198,
    ],
    '081365005020': [
      9.813560519520918, 48.86971775336895, 9.896228439306249, 48.92387408729809,
    ],
    '081365005024': [
      9.862134115487853, 48.84091194028183, 9.932078371661975, 48.87762642915539,
    ],
    '081365005034': [
      9.844933602453246, 48.819510513677955, 9.92239545638187, 48.849929223940514,
    ],
    '081365005040': [
      9.854226557827435, 48.84318198248996, 9.884551160580365, 48.856428241676355,
    ],
    '081365005049': [
      9.892953072976603, 48.8874727004603, 9.931673350757336, 48.91711651355167,
    ],
    '081365005062': [
      9.894946550616243, 48.85934647207049, 9.964425480319052, 48.8910558537963,
    ],
    '081365006007': [
      9.907939131384913, 48.72737920197283, 10.007591294417464, 48.76220144844294,
    ],
    '081365006009': [
      9.892943565980927, 48.801604488295055, 9.950524114175472, 48.843994522725644,
    ],
    '081365006028': [
      9.896975045018083, 48.75414061098055, 9.996629526587084, 48.81953161134766,
    ],
    '081365006029': [
      9.92239545638187, 48.83403834982367, 9.985280724006026, 48.86127214615237,
    ],
    '081365006043': [
      9.935057577891516, 48.80791661272913, 9.993144516609444, 48.843646158863876,
    ],
    '081365007065': [
      9.71428965555871, 48.71473344958983, 9.943552451674712, 48.8427842651461,
    ],
    '081365007079': [
      9.792536856238742, 48.71711643498837, 9.862672788341994, 48.78468010312256,
    ],
    '081365008015': [
      9.759028558901639, 48.84200118703666, 9.820205395722537, 48.87472827297535,
    ],
    '081365008044': [
      9.753170941554476, 48.813987061605346, 9.81123416021554, 48.85337746569644,
    ],
    '081365008061': [
      9.764073640098609, 48.867011634677155, 9.854152138405299, 48.91321919008809,
    ],
    '081365008066': [
      9.739712517613851, 48.85841889306737, 9.797121167013303, 48.90919175847048,
    ],
    '081365008070': [
      9.805384957992528, 48.8420968833039, 9.867460861671299, 48.87910526408459,
    ],
    '081365009068': [
      10.25435223982309, 48.96888658390668, 10.381800337481458, 49.03187987252669,
    ],
    '081365009071': [
      10.302580060359546, 48.958064347120846, 10.410451332436287, 48.996015594116265,
    ],
    '081365009075': [
      10.277716695363683, 48.89280405586452, 10.454395893963511, 48.96888658390668,
    ],
    '082110000000': [
      8.11328925875741, 48.667363987212376, 8.320801147982698, 48.847693134501576,
    ],
    '082120000000': [
      8.279385165597148, 48.941492111782544, 8.54332846155004, 49.08941555597683,
    ],
    '082150017017': [
      8.350008136972784, 48.87778306780231, 8.453410359483188, 48.9746054233354,
    ],
    '082150046046': [
      8.288971202454741, 48.84283127020197, 8.414856830285942, 48.92287654846572,
    ],
    '082150047047': [
      8.404169472492429, 48.811995353208445, 8.501753315964065, 48.889629288227844,
    ],
    '082150064064': [
      8.67763216501894, 49.153484256561995, 8.820714558934233, 49.23733146581242,
    ],
    '082150084084': [
      8.573860382073644, 49.14133280620993, 8.717668393321713, 49.203686290826425,
    ],
    '082150089089': [
      8.543419120314491, 48.98525581324677, 8.660557308594617, 49.060703067054085,
    ],
    '082150090090': [
      8.482300694218187, 49.02816137573042, 8.594639356620718, 49.08873195468586,
    ],
    '082150096096': [
      8.44863446579355, 48.85875415402192, 8.55347065994164, 48.95298994499086,
    ],
    '082150097097': [
      8.640020604619904, 49.08813920931255, 8.842211599131279, 49.172861399297645,
    ],
    '082150101101': [
      8.500482925723544, 48.95298994499086, 8.59982124730486, 49.02975291255998,
    ],
    '082150102102': [
      8.34050373981325, 49.06510323613056, 8.440521389438645, 49.12939098891089,
    ],
    '082150105105': [
      8.367452017983846, 49.09720320035146, 8.452447850862443, 49.15591954898486,
    ],
    '082150106106': [
      8.47771740214316, 49.18920948748083, 8.598486242045096, 49.26978225097632,
    ],
    '082150108108': [
      8.258873651167882, 48.935217707952624, 8.371069425996915, 48.99217534074724,
    ],
    '082150109109': [
      8.427189312161843, 49.04136357254712, 8.526456543322812, 49.139923373688816,
    ],
    '082150110110': [
      8.449139902940221, 48.902612159989026, 8.493447753182336, 48.944341851315315,
    ],
    '082155001039': [
      8.583050010850222, 49.2098182495244, 8.641509287271655, 49.24660883489392,
    ],
    '082155001100': [
      8.574411838386954, 49.18999871152279, 8.687210090039803, 49.243406157957885,
    ],
    '082155002007': [
      8.635394869342715, 48.98901295455884, 8.763005785345658, 49.098288259108934,
    ],
    '082155002025': [
      8.605492868767495, 49.03111670109551, 8.687860156937175, 49.07931163678118,
    ],
    '082155003009': [
      8.508893680705004, 49.059957523834164, 8.689553596454529, 49.20028291306373,
    ],
    '082155003021': [
      8.56076107793099, 49.137830125959, 8.615997725959025, 49.18377328663077,
    ],
    '082155003029': [
      8.517615913556273, 49.17181354236287, 8.586507869370397, 49.2146794629819,
    ],
    '082155003103': [
      8.50466428212113, 49.1154643681467, 8.575568638672666, 49.1610408762806,
    ],
    '082155004099': [
      8.432577858975975, 49.125390252941315, 8.521326021823572, 49.18920948748083,
    ],
    '082155004111': [
      8.368359003868566, 49.13329933410656, 8.485595649427848, 49.2082174635409,
    ],
    '082155005040': [
      8.812069261874065, 49.057971698800074, 8.87994121990835, 49.0954059608426,
    ],
    '082155005059': [
      8.743515083302507, 49.03364813839607, 8.839515495355087, 49.109654547598346,
    ],
    '082155006066': [
      8.382891654170262, 49.1850248111643, 8.508893680705004, 49.26549120369093,
    ],
    '082155006107': [
      8.444733673910976, 49.24463738058678, 8.54250595873285, 49.28765987129998,
    ],
    '082155007082': [
      8.827485180734023, 49.08009086520796, 8.892969740497502, 49.13181637823699,
    ],
    '082155007094': [
      8.785023334404906, 49.0865034408978, 8.832626583455106, 49.12611668192319,
    ],
    '082160008008': [
      8.163626993449585, 48.6358494385674, 8.249734968110328, 48.707040223066436,
    ],
    '082160013013': [
      8.222460888755313, 48.58858926650349, 8.435944490800193, 48.71980095189161,
    ],
    '082160015015': [
      8.284963079939102, 48.770681184377914, 8.419776046962323, 48.86190259014566,
    ],
    '082165001006': [
      8.265057292227892, 48.82830058498789, 8.307838041128235, 48.85153734851486,
    ],
    '082165001024': [
      8.234256317916449, 48.78540595568637, 8.299982973549492, 48.857027476867415,
    ],
    '082165002007': [
      8.033338585342447, 48.62911716667282, 8.257491515721584, 48.75762395876084,
    ],
    '082165002041': [
      8.031377144293495, 48.62525582530624, 8.25560836002023, 48.71933189671573,
    ],
    '082165003002': [
      8.188775122173785, 48.94157642808139, 8.273767445053506, 48.98060243543104,
    ],
    '082165003005': [
      8.224419226961208, 48.88095132448161, 8.295677444696468, 48.92525210068525,
    ],
    '082165003009': [
      8.230316096486611, 48.907918417839596, 8.353426539572546, 48.953168852201586,
    ],
    '082165003012': [
      8.170762122485868, 48.915110521256075, 8.239482901163631, 48.94598367957824,
    ],
    '082165004017': [
      8.279525251634857, 48.65728802756643, 8.484349226699733, 48.78684164622598,
    ],
    '082165004029': [
      8.371770934312238, 48.74495284393033, 8.43241774657028, 48.804432218027465,
    ],
    '082165004059': [
      8.320801147982698, 48.702742534715036, 8.404452322718862, 48.7341590685234,
    ],
    '082165005023': [
      8.107666574105377, 48.78935484278498, 8.186490373639902, 48.85158800919738,
    ],
    '082165005033': [
      8.248929087547818, 48.84770844362502, 8.305220141316118, 48.88644299101797,
    ],
    '082165005039': [
      8.207180739292536, 48.864968831998404, 8.272162038867068, 48.90577103921086,
    ],
    '082165005043': [
      8.116781472475171, 48.81386196865547, 8.265203915336906, 48.91479668861363,
    ],
    '082165005052': [
      8.159269118448861, 48.88505320350218, 8.229948938000623, 48.926485343490285,
    ],
    '082165006028': [
      7.958046291511239, 48.681390279085925, 8.043134565343184, 48.75322849877807,
    ],
    '082165006063': [
      7.968883308122057, 48.681390279085925, 8.105586823592084, 48.798660315582204,
    ],
    '082165007022': [
      8.084352777929789, 48.7709245127023, 8.153303464975796, 48.826414841821695,
    ],
    '082165007049': [
      8.077327573531868, 48.733948306617535, 8.220616031290213, 48.783847115397975,
    ],
    '082210000000': [
      8.57243770566808, 49.35226534753399, 8.793286850163295, 49.460172270639816,
    ],
    '082220000000': [
      8.414848112165167, 49.40749349957633, 8.588168068078419, 49.5891149224367,
    ],
    '082250014014': [
      9.224537488323717, 49.45252361053045, 9.428745523764528, 49.59351307176448,
    ],
    '082250060060': [
      9.071591714684194, 49.4886058039566, 9.277721230111872, 49.581273505374696,
    ],
    '082255001032': [
      9.382869687459792, 49.500656861740275, 9.55086617299156, 49.660644575868496,
    ],
    '082255001039': [
      9.377725681217917, 49.5472557001851, 9.470971793956444, 49.61984408234266,
    ],
    '082255001109': [
      9.258891099249746, 49.49924661840174, 9.493853164742054, 49.65872986898754,
    ],
    '082255002033': [
      9.074088268013439, 49.27192685439099, 9.158453009794911, 49.33667043137249,
    ],
    '082255002042': [
      9.042591762485674, 49.27890674688396, 9.110720318090914, 49.3271465713664,
    ],
    '082255003002': [
      8.938800545589693, 49.33470792574738, 9.045696754424734, 49.39321097206461,
    ],
    '082255003068': [
      8.98549637000327, 49.37465758983297, 9.067935211992102, 49.42795079724578,
    ],
    '082255003116': [
      8.947187307276048, 49.365796311878924, 9.007670331375433, 49.399567045291974,
    ],
    '082255004024': [
      9.127721043050467, 49.413780047253276, 9.194379738643379, 49.470093799852684,
    ],
    '082255004052': [
      9.109069868829549, 49.43106101346645, 9.262569262403035, 49.50112949298527,
    ],
    '082255005058': [
      9.086904820593906, 49.32151298822412, 9.197817711334602, 49.46088961947706,
    ],
    '082255005067': [
      9.114662497631697, 49.30291672632531, 9.187031186307692, 49.339366154327266,
    ],
    '082255005074': [
      9.013078881777135, 49.319719383518965, 9.101414852437944, 49.368696601507004,
    ],
    '082255005117': [
      9.15846719081043, 49.35378214030093, 9.261683625266604, 49.44584352010973,
    ],
    '082255006010': [
      9.045696754424734, 49.36370129264425, 9.102737153385071, 49.384613944266476,
    ],
    '082255006064': [
      9.037307368382491, 49.368696601507004, 9.101165734557721, 49.42428232256083,
    ],
    '082255006113': [
      9.013811697006439, 49.40292507260312, 9.054869587860665, 49.42725064328019,
    ],
    '082255006118': [
      9.019179019689727, 49.41626618658196, 9.130298263408939, 49.499066623161504,
    ],
    '082255007075': [
      9.340900904741943, 49.401830535003675, 9.477870077879802, 49.48576643099315,
    ],
    '082255007082': [
      9.426547435470209, 49.42230743882674, 9.52125478968499, 49.5100892380667,
    ],
    '082255007114': [
      9.447737310465069, 49.37549506727808, 9.603655079529528, 49.44968030563613,
    ],
    '082255008009': [
      9.17891914157467, 49.29760787872714, 9.315352945623868, 49.38172497739797,
    ],
    '082255008115': [
      9.236332003512917, 49.371982185374954, 9.346905219277, 49.43685271627376,
    ],
    '082255009001': [
      9.326973575091316, 49.360064921501596, 9.464458082145839, 49.42376584506635,
    ],
    '082255009091': [
      9.256150208297335, 49.40790255403484, 9.390212648397672, 49.462198928472766,
    ],
    '082260009009': [
      8.462843498042465, 49.373786760312335, 8.541604961837985, 49.418050878951654,
    ],
    '082260012012': [
      8.620030126179175, 49.437020441336564, 8.7459410443247, 49.46677062882406,
    ],
    '082260018018': [
      8.611437167226237, 49.37915567064145, 8.647787559795526, 49.412203876607286,
    ],
    '082260028028': [
      8.572532152660914, 49.49309502280635, 8.640444412871613, 49.54156089272028,
    ],
    '082260036036': [
      8.547193558810653, 49.455774110146336, 8.586046339598967, 49.49309502280635,
    ],
    '082260037037': [
      8.497830972445826, 49.33802465933115, 8.557937240115553, 49.39223662566823,
    ],
    '082260038038': [
      8.572532152660914, 49.44465158035087, 8.647541765375312, 49.50042826707367,
    ],
    '082260041041': [
      8.600548323603368, 49.31350408376695, 8.771612516298987, 49.36128771324438,
    ],
    '082260060060': [
      8.66663049454345, 49.30848307212562, 8.73670540303797, 49.34000063976328,
    ],
    '082260062062': [
      8.56243478288948, 49.33655797522419, 8.633302281404246, 49.38119587037473,
    ],
    '082260063063': [
      8.57243770566808, 49.37702862032514, 8.617657788061484, 49.41558799827591,
    ],
    '082260076076': [
      8.606405980426477, 49.31350408376695, 8.66663049454345, 49.37048815746832,
    ],
    '082260082082': [
      8.636479954142128, 49.45482916129155, 8.769367717922028, 49.49970788791789,
    ],
    '082260084084': [
      8.496330244215827, 49.33749476565965, 8.59182140290214, 49.41852113833555,
    ],
    '082260095095': [
      8.594298115540361, 49.27737250826986, 8.668333641309875, 49.32903872506194,
    ],
    '082260096096': [
      8.603431574196192, 49.46917790993479, 8.780776796246132, 49.59279363468662,
    ],
    '082260103103': [
      8.561485759049857, 49.23595259854627, 8.655886509679304, 49.28670555193509,
    ],
    '082260105105': [
      8.573076463589722, 49.424558285409766, 8.627063500669182, 49.478119308642455,
    ],
    '082260107107': [
      8.626116396025546, 49.48787760932635, 8.713255090829946, 49.52569100729816,
    ],
    '082265001013': [
      8.851826358215344, 49.41448755642479, 9.100455991290248, 49.57113055328832,
    ],
    '082265001081': [
      8.886069330275832, 49.384809573151, 8.989431180757482, 49.45242249513783,
    ],
    '082265002020': [
      8.838084246887936, 49.298463962004135, 8.879792470265068, 49.335699165800804,
    ],
    '082265002048': [
      8.769693572990741, 49.323312609044606, 8.820118206790768, 49.3516885737241,
    ],
    '082265002049': [
      8.778262973614877, 49.30516964698535, 8.864648500932331, 49.352123899077114,
    ],
    '082265002086': [
      8.861824357481282, 49.329667641973224, 8.910597827557181, 49.368993816706194,
    ],
    '082265002104': [
      8.846678696733433, 49.3407857981266, 8.923024024223775, 49.40804592722099,
    ],
    '082265003031': [
      8.589207076644845, 49.58182395749688, 8.6976700990699, 49.606609714163596,
    ],
    '082265003040': [
      8.595034655660038, 49.59830221013901, 8.682075434722833, 49.623862448937786,
    ],
    '082265004003': [
      8.453430651137436, 49.26224346872945, 8.551322306837944, 49.33115737916243,
    ],
    '082265004032': [
      8.456203111488106, 49.30349581245614, 8.604027954078148, 49.359310066406806,
    ],
    '082265004059': [
      8.509899556304045, 49.28385604198599, 8.535811581758763, 49.308452829337774,
    ],
    '082265004068': [
      8.529256426778275, 49.266042723352065, 8.609849022399743, 49.32933698098971,
    ],
    '082265005006': [
      8.745261127700518, 49.333896929506494, 8.802261239712498, 49.38294315784892,
    ],
    '082265005022': [
      8.725403861335876, 49.3489447173938, 8.759663649861082, 49.37594042182081,
    ],
    '082265005056': [
      8.757132590649519, 49.368446944096206, 8.891464486679018, 49.415039592696566,
    ],
    '082265005097': [
      8.798237530284377, 49.34569723538356, 8.859859194893499, 49.3817806299342,
    ],
    '082265006046': [
      8.647818368197573, 49.229085682894706, 8.699892019011221, 49.258678427534626,
    ],
    '082265006054': [
      8.686659357013319, 49.22706099052917, 8.769883819497997, 49.27049386244782,
    ],
    '082265006065': [
      8.654171949550294, 49.2496874678969, 8.724354893138932, 49.27955778909057,
    ],
    '082265007027': [
      8.808579081428059, 49.462969091733605, 8.85671573150819, 49.5045218598545,
    ],
    '082265007029': [
      8.749128743317911, 49.47041962137767, 8.822446319911645, 49.525944798087004,
    ],
    '082265007080': [
      8.766511537104899, 49.41046403430592, 8.832479771133762, 49.473733511814224,
    ],
    '082265007099': [
      8.747036101068115, 49.454606501784085, 8.789975542762724, 49.48003191608354,
    ],
    '082265008085': [
      8.766498798377217, 49.17439863912299, 9.010226528378501, 49.29477279875923,
    ],
    '082265008101': [
      8.7876137856867, 49.28081221140376, 8.854824525347242, 49.314034615521656,
    ],
    '082265008102': [
      8.736038919647427, 49.198489494245834, 8.814020869926308, 49.24805422244416,
    ],
    '082265009017': [
      8.88807043924153, 49.323613209460355, 8.952517453611955, 49.3797020260086,
    ],
    '082265009055': [
      8.93797396287719, 49.25686595746776, 9.04263894207403, 49.31492894741601,
    ],
    '082265009058': [
      8.872873699563947, 49.304840773587976, 8.932382639453573, 49.33431679323469,
    ],
    '082265009066': [
      8.914275542558313, 49.344226139918376, 8.967403288506077, 49.38833151209936,
    ],
    '082265009091': [
      8.84854010424897, 49.271339955488976, 8.954028602403016, 49.323613209460355,
    ],
    '082265009106': [
      8.932382639453573, 49.29262595030972, 9.05681187158785, 49.34585899695037,
    ],
    '082265010010': [
      8.717701404277497, 49.2605591145986, 8.80407460631692, 49.315303925266875,
    ],
    '082265010098': [
      8.647761483439938, 49.26561078637785, 8.780068366947809, 49.33048733286833,
    ],
    '082310000000': [
      8.627396834490678, 48.81856699068425, 8.809114125963278, 48.92952933881241,
    ],
    '082350065065': [
      8.58605734000503, 48.76639833984656, 8.722845290542024, 48.82876501246736,
    ],
    '082350080080': [
      8.638516525771287, 48.59575180057217, 8.819674319761441, 48.6785677200351,
    ],
    '082355001006': [
      8.538688372097969, 48.54516984337136, 8.674684488287847, 48.65278379314623,
    ],
    '082355001022': [
      8.58561414252677, 48.54212782283413, 8.643247310288274, 48.58200038967272,
    ],
    '082355001066': [
      8.449757752362373, 48.587616408394425, 8.567483652853976, 48.6623642735839,
    ],
    '082355002007': [
      8.740224579423396, 48.70576813828544, 8.82427056903939, 48.75800489339718,
    ],
    '082355002029': [
      8.789898533774391, 48.66983692172503, 8.863009479294815, 48.7150433602348,
    ],
    '082355002057': [
      8.821774930167352, 48.70683338365985, 8.875128650973005, 48.73678376973333,
    ],
    '082355002067': [
      8.755279977508726, 48.736162357973775, 8.835190562809005, 48.76347965829435,
    ],
    '082355003018': [
      8.460609153263407, 48.75652692863611, 8.532277800091606, 48.814043364543046,
    ],
    '082355003033': [
      8.375597407757041, 48.74495284393033, 8.50592297993383, 48.836651554442994,
    ],
    '082355004008': [
      8.640721573082823, 48.75172908209139, 8.819892790830782, 48.802531558334756,
    ],
    '082355004073': [
      8.653007697636413, 48.79478682065552, 8.729360912207907, 48.83869540802481,
    ],
    '082355005047': [
      8.602583842323332, 48.6312634417905, 8.732147550165498, 48.68844052788372,
    ],
    '082355005050': [
      8.544168535814482, 48.614977497154584, 8.662573286212123, 48.72873171128561,
    ],
    '082355005084': [
      8.601986732634666, 48.67247651424366, 8.7341008522885, 48.72574654727009,
    ],
    '082355006055': [
      8.571211433650186, 48.70822209928335, 8.689130541950428, 48.772040084773494,
    ],
    '082355006085': [
      8.659822652269616, 48.64884682851976, 8.804625431955232, 48.76203964286038,
    ],
    '082355007020': [
      8.634350364409409, 48.575875038762554, 8.7251078042332, 48.64099770090689,
    ],
    '082355007032': [
      8.599404490358268, 48.500197446836054, 8.686744162430102, 48.56363556236852,
    ],
    '082355007046': [
      8.671941336353717, 48.48397450872847, 8.773045445542763, 48.600636819073564,
    ],
    '082355007060': [
      8.670122091916912, 48.5583216662183, 8.701958593830451, 48.577706638899826,
    ],
    '082355008025': [
      8.409445547402795, 48.62006912020226, 8.496451881829962, 48.68598088357685,
    ],
    '082355008035': [
      8.550613996523422, 48.78729660572727, 8.608478273262914, 48.81759396865666,
    ],
    '082355008079': [
      8.439924502780046, 48.650177759572195, 8.62440516620289, 48.791407937349845,
    ],
    '082360004004': [
      8.565021240742093, 48.848825029120306, 8.648976533542047, 48.8992360699727,
    ],
    '082360028028': [
      8.871312482811904, 48.93656516247088, 8.946604852428981, 49.02161096049919,
    ],
    '082360030030': [
      8.647997139650744, 48.910217118404596, 8.707015451840196, 48.936953979658135,
    ],
    '082360033033': [
      8.732509127495906, 48.99570408944114, 8.839094840704778, 49.0457015322389,
    ],
    '082360046046': [
      8.756991038087504, 48.886111144945495, 8.84339551516301, 48.93344338078678,
    ],
    '082360070070': [
      8.5173446587181, 48.873733994917096, 8.633072779747247, 48.919494942257444,
    ],
    '082360071071': [
      8.535251556994961, 48.91324097416246, 8.610305182082486, 48.98723465569029,
    ],
    '082360072072': [
      8.467768070818856, 48.8108485596463, 8.569126110166401, 48.88158996241282,
    ],
    '082365001019': [
      8.784204762469539, 48.816468382284555, 8.85991456738307, 48.845405455292266,
    ],
    '082365001025': [
      8.838218889731802, 48.792394195056715, 8.901426018744681, 48.837129116968185,
    ],
    '082365001039': [
      8.837123465122325, 48.83668106225482, 8.901286197541788, 48.88020494864918,
    ],
    '082365001065': [
      8.822704572183188, 48.861151970600844, 8.929053797005912, 48.921340990587865,
    ],
    '082365001067': [
      8.775969324622615, 48.8428072581943, 8.846670232788442, 48.86509680038225,
    ],
    '082365001068': [
      8.793719620160523, 48.86065579371335, 8.840442599235969, 48.88860685489106,
    ],
    '082365002011': [
      8.648153161613985, 48.93097172935545, 8.704617113970889, 48.95600985502656,
    ],
    '082365002074': [
      8.600103811788298, 48.90958998648754, 8.662682965695058, 48.95645972071957,
    ],
    '082365002076': [
      8.574586712044178, 48.946033239031316, 8.69587429067059, 49.00753164006784,
    ],
    '082365003038': [
      8.756388857707513, 48.97143260634603, 8.872864736763857, 49.02230274477593,
    ],
    '082365003061': [
      8.835502453594396, 48.99996581530034, 8.9040502495463, 49.06122862034268,
    ],
    '082365004040': [
      8.77217182161912, 48.897092403625, 8.9258311871168, 49.00057824585673,
    ],
    '082365004050': [
      8.767839488405624, 48.94763192186017, 8.840420148462492, 48.980994487661484,
    ],
    '082365005013': [
      8.616098276735531, 48.81238889478623, 8.694244765542491, 48.852717418509904,
    ],
    '082365005043': [
      8.517062281618964, 48.78482280915372, 8.61938736291736, 48.865520832642886,
    ],
    '082365006031': [
      8.725003734455793, 48.92299089740283, 8.793396145129472, 48.948717835003386,
    ],
    '082365006073': [
      8.668566931241134, 48.92185575977273, 8.753835607263634, 48.99626802734729,
    ],
    '082365006075': [
      8.719106340779364, 48.939774925754264, 8.780323691240623, 48.99806928195829,
    ],
    '082365007044': [
      8.716759711624661, 48.77627290928661, 8.817148734411022, 48.846296357898375,
    ],
    '082365007062': [
      8.768099729493667, 48.787321061717265, 8.842337218998688, 48.852494616669425,
    ],
    '082370002002': [
      8.329739622393856, 48.30105276586131, 8.501352971132505, 48.438343731782325,
    ],
    '082370004004': [
      8.20996192361094, 48.47523173507262, 8.431051127911363, 48.623547045590485,
    ],
    '082370045045': [
      8.367857070811546, 48.34366643492361, 8.522150371520029, 48.43999425390866,
    ],
    '082375001019': [
      8.456244171407372, 48.453617738289005, 8.548266536305187, 48.515396084174846,
    ],
    '082375001030': [
      8.450239890312561, 48.40044558162704, 8.54793419533429, 48.46082302863484,
    ],
    '082375001061': [
      8.524718555393832, 48.40007176749868, 8.57840407001304, 48.47158691224581,
    ],
    '082375001074': [
      8.53562182969958, 48.45830373473365, 8.639102663264454, 48.51452845372504,
    ],
    '082375002028': [
      8.270333100877147, 48.42051860731663, 8.487235837790934, 48.560799128717605,
    ],
    '082375002073': [
      8.38782454761353, 48.515396084174846, 8.538688372097969, 48.639602624493726,
    ],
    '082375002075': [
      8.233650105246456, 48.349453290503845, 8.359094309621248, 48.479372758662386,
    ],
    '082375003024': [
      8.67633733041454, 48.37675770949779, 8.7662150716524, 48.41638196679044,
    ],
    '082375003027': [
      8.69169057276273, 48.43787348934559, 8.827881875151594, 48.50422412726637,
    ],
    '082375003040': [
      8.545302701086118, 48.3945553528936, 8.77740465957972, 48.51032783202508,
    ],
    '082375005032': [
      8.492331114076274, 48.548375632254775, 8.562006439124753, 48.587616408394425,
    ],
    '082375005054': [
      8.474840559770078, 48.497102395106396, 8.630704187330524, 48.5566280848984,
    ],
    '082375005072': [
      8.547765096333295, 48.54397800446047, 8.578316406764191, 48.576918930492134,
    ],
    '083110000000': [
      7.662771822219934, 47.90400483824986, 7.929452820309766, 48.071122744773206,
    ],
    '083150068068': [
      8.10722350156949, 47.833541468742354, 8.279335240252955, 47.9047733571234,
    ],
    '083150076076': [
      7.529992041244472, 47.74387592366896, 7.617684424276641, 47.90182419817591,
    ],
    '083150133133': [
      7.573856510244988, 48.053272364687054, 7.699854479811084, 48.1163533758594,
    ],
    '083155001006': [
      7.640307784911413, 47.88139119264477, 7.725095798860891, 47.968470969883136,
    ],
    '083155001048': [
      7.581107720214899, 47.89792362057644, 7.663235561372494, 47.960326947701674,
    ],
    '083155002015': [
      7.568728281192711, 47.95425768713312, 7.684302075693211, 48.0909668639114,
    ],
    '083155002059': [
      7.613973388723799, 48.027837236282245, 7.707562650132337, 48.08373988287609,
    ],
    '083155002072': [
      7.659538952816384, 47.99634970020641, 7.707701902321048, 48.04744991309271,
    ],
    '083155003020': [
      7.982328009380581, 47.92125475526503, 8.093576742685274, 48.00503068833431,
    ],
    '083155003064': [
      7.912883514167806, 47.938038900449705, 7.993826747443317, 47.988870504968766,
    ],
    '083155003084': [
      7.883656549541821, 47.86629675055224, 8.039386151408882, 47.94896468542736,
    ],
    '083155003109': [
      7.923883996590814, 47.9763183346397, 8.018805923692303, 48.02568004691134,
    ],
    '083155004014': [
      7.767130301821807, 47.89130346043758, 7.87216513298293, 47.935736117800595,
    ],
    '083155004131': [
      7.702699082035888, 47.874549769868345, 7.841461671436436, 47.9540028430157,
    ],
    '083155005047': [
      7.849930671793832, 48.010412576398295, 7.923883996590814, 48.055206157388575,
    ],
    '083155005051': [
      7.884481629159513, 48.035151602634045, 7.915912211828835, 48.05638879455572,
    ],
    '083155006008': [
      7.670105627782183, 47.847375091301906, 7.727729091974396, 47.86779945472562,
    ],
    '083155006033': [
      7.597427583306238, 47.87925532684451, 7.671809569345707, 47.91114452064188,
    ],
    '083155006050': [
      7.610875015249058, 47.85713039333324, 7.706929547748062, 47.89175848686446,
    ],
    '083155007003': [
      7.8093555657318, 47.94398106508332, 7.854139160636322, 47.96337592918894,
    ],
    '083155007056': [
      7.835556931822289, 47.9121627146909, 7.878799816506891, 47.95053524475446,
    ],
    '083155007073': [
      7.805594265196119, 47.956586456390056, 7.841889250529507, 47.972793209108175,
    ],
    '083155007107': [
      7.791812307857078, 47.922036701028915, 7.828591776451783, 47.94287493091301,
    ],
    '083155007125': [
      7.801691519763129, 47.922036701028915, 7.842704919505671, 47.956586456390056,
    ],
    '083155008016': [
      8.016323528430078, 47.90904978103417, 8.157166951104687, 47.9800126716135,
    ],
    '083155008052': [
      8.023385213560779, 47.86808764651251, 8.144691895569316, 47.920005921764115,
    ],
    '083155009013': [
      7.684738418193533, 48.056299840781264, 7.749761061169481, 48.09200344025521,
    ],
    '083155009030': [
      7.695840479820277, 48.07413257876607, 7.756179983576383, 48.11280537175141,
    ],
    '083155009043': [
      7.697262653964031, 48.033322938582934, 7.753044858762767, 48.06290939944427,
    ],
    '083155010039': [
      8.242227378924346, 47.865703904087276, 8.311364352659922, 47.94614731861665,
    ],
    '083155010070': [
      8.2689198419109, 47.8410555797515, 8.439039206498348, 47.94321788669165,
    ],
    '083155011115': [
      7.733202956105277, 48.017477977170586, 7.785547571315758, 48.04788958518333,
    ],
    '083155011132': [
      7.745149838720471, 48.03282324617716, 7.815532175695563, 48.08498574176081,
    ],
    '083155012004': [
      7.554468280457263, 47.769205713913145, 7.635158686613122, 47.81033031469526,
    ],
    '083155012007': [
      7.646059902109035, 47.771569006609184, 7.725404504980672, 47.81351364831732,
    ],
    '083155012022': [
      7.595457051343314, 47.83197737628956, 7.674651018895804, 47.87628474637456,
    ],
    '083155012074': [
      7.571681498695797, 47.7569922797388, 7.783198572914364, 47.846364683858866,
    ],
    '083155012111': [
      7.660195634184155, 47.80179523581249, 7.767656752675193, 47.85418506448937,
    ],
    '083155013041': [
      7.915707202740542, 48.0144595489172, 8.015732216724183, 48.064839967734024,
    ],
    '083155013094': [
      8.046469578936055, 47.95249569945816, 8.153542484389478, 48.032614834123514,
    ],
    '083155013095': [
      7.998432099097052, 47.99377586523459, 8.10083681291562, 48.06319757063375,
    ],
    '083155014028': [
      7.765536067709234, 47.93246452654759, 7.8093555657318, 47.968720194660065,
    ],
    '083155014089': [
      7.739658867653794, 47.92912630995003, 7.780845052456715, 47.94587811712436,
    ],
    '083155014098': [
      7.677781011684452, 47.942381576688106, 7.790345292128897, 47.97845230519535,
    ],
    '083155015037': [
      7.987385494084596, 47.842825354917245, 8.142745701548376, 47.88490978441701,
    ],
    '083155015102': [
      8.079499681920064, 47.76157797740009, 8.233447046865573, 47.857858845771275,
    ],
    '083155016108': [
      7.680116159142589, 47.83195538743992, 7.76838629029537, 47.90099372328606,
    ],
    '083155016130': [
      7.754925500146855, 47.80179523581249, 7.892075258301221, 47.904043952659194,
    ],
    '083155017031': [
      8.19364648841414, 47.942126497903715, 8.3204161411751, 47.99703073075574,
    ],
    '083155017113': [
      8.109483482170427, 47.88263888146828, 8.271605540042488, 47.998636167723255,
    ],
    '083165001009': [
      7.847589761860482, 48.04761364312318, 7.92372059625835, 48.09525791965877,
    ],
    '083165001036': [
      7.793563451691004, 48.07839060322233, 7.847589761860482, 48.09765488014976,
    ],
    '083165001045': [
      7.793563451691004, 48.05354885437101, 7.867246035547359, 48.08785261628115,
    ],
    '083165002003': [
      7.980979765669916, 48.17069691937478, 8.099729016543826, 48.23417839906969,
    ],
    '083165002010': [
      7.9916549627769, 48.1284858344525, 8.183215851893337, 48.228872091294825,
    ],
    '083165002055': [
      7.989225868259447, 48.120038762034696, 8.08300773348972, 48.164865900168465,
    ],
    '083165003011': [
      7.81679070733848, 48.08261186318481, 7.910937380706809, 48.1595739353901,
    ],
    '083165003024': [
      7.76562966791184, 48.141547981877956, 7.882505856899561, 48.18267423726009,
    ],
    '083165003039': [
      7.884812408119799, 48.080141264742956, 7.948234833539852, 48.14389596469077,
    ],
    '083165003043': [
      7.756051937253682, 48.08462955057551, 7.872436146087617, 48.1744409992385,
    ],
    '083165003054': [
      7.85787173881536, 48.13086893124352, 7.982841930872929, 48.20563963475485,
    ],
    '083165004017': [
      7.742934160996372, 48.18732012394306, 7.916163060709498, 48.241733817552955,
    ],
    '083165004020': [
      7.710237237983141, 48.15932508830226, 7.944780386989874, 48.227182410131284,
    ],
    '083165004049': [
      7.637097546648008, 48.17635001381263, 7.710237237983141, 48.22805988122726,
    ],
    '083165004053': [
      7.668316091681079, 48.19505049856371, 7.746287492503341, 48.259337464425464,
    ],
    '083165005002': [
      7.698958922615859, 48.10618428448727, 7.777003065756643, 48.13697569079564,
    ],
    '083165005012': [
      7.638704861071842, 48.10915322384751, 7.728515753904555, 48.15906773624998,
    ],
    '083165005013': [
      7.67476476650473, 48.158246487400945, 7.73991506530994, 48.19505049856371,
    ],
    '083165005037': [
      7.712338675312504, 48.128610927756405, 7.774169176609623, 48.188341297054805,
    ],
    '083165005038': [
      7.577624199188224, 48.106514284892434, 7.641269792550087, 48.1697832938544,
    ],
    '083165005051': [
      7.611357304799369, 48.14543529828784, 7.682137765848589, 48.1957755061282,
    ],
    '083165006014': [
      7.955737923409016, 48.10702264186675, 8.045694601607652, 48.19426323182631,
    ],
    '083165006042': [
      8.01520945015382, 48.02892221458143, 8.166297932602452, 48.131463001263384,
    ],
    '083165006056': [
      7.893628268144636, 48.05747291247956, 8.034742539761952, 48.13465897070452,
    ],
    '083170005005': [
      7.938581374300589, 48.50523851095025, 8.033723460768138, 48.61702119925879,
    ],
    '083170031031': [
      7.822812991224008, 48.345792866710035, 7.978037549753568, 48.41660957680276,
    ],
    '083170051051': [
      8.179174418782168, 48.160347471189276, 8.311965562087327, 48.24792292877925,
    ],
    '083170057057': [
      7.794450384016168, 48.48706766521673, 7.950312584404123, 48.638174269509946,
    ],
    '083170141141': [
      7.832057596502684, 48.498831882437, 7.953789672116259, 48.603308212397806,
    ],
    '083170151151': [
      7.753424070071998, 48.393530478370224, 7.860062864455359, 48.50183403441672,
    ],
    '083170153153': [
      7.837242233134594, 48.603803466932376, 8.017216945735449, 48.71845485298128,
    ],
    '083175001001': [
      7.965686014320281, 48.58642310696824, 8.247474208488438, 48.68233615704568,
    ],
    '083175001068': [
      8.040571338841946, 48.618503013079724, 8.202139618972996, 48.708594532922646,
    ],
    '083175001116': [
      8.055693032043152, 48.59345185070182, 8.242161480060934, 48.67513855632392,
    ],
    '083175001118': [
      8.09903692029146, 48.594448533718726, 8.22759841610939, 48.630510248145974,
    ],
    '083175002026': [
      7.763652453219799, 48.21817767600831, 7.939681114396048, 48.279208230814035,
    ],
    '083175002073': [
      7.776895173970066, 48.26335279745088, 7.897925238526134, 48.33361424691028,
    ],
    '083175002113': [
      7.746287492503341, 48.22588334019888, 7.935447869729376, 48.26691452498466,
    ],
    '083175002114': [
      7.681271549658859, 48.23595529881463, 7.751477127029023, 48.28598717674405,
    ],
    '083175002152': [
      7.710280397743327, 48.22101314573972, 7.932781652401417, 48.32594899627568,
    ],
    '083175003009': [
      7.954319875662969, 48.37843424903673, 8.0026828882548, 48.42372175430965,
    ],
    '083175003034': [
      7.96959237589081, 48.35248924214299, 8.093517421800254, 48.45648637040387,
    ],
    '083175003097': [
      7.968301211425286, 48.42125275020138, 8.042066527179514, 48.46567802338151,
    ],
    '083175004029': [
      8.091252490857581, 48.28015350593822, 8.155758097206903, 48.34135195809779,
    ],
    '083175004040': [
      8.059169403228356, 48.25540330254013, 8.124683816392967, 48.31575024870133,
    ],
    '083175004046': [
      8.01743237518225, 48.22181407603892, 8.085910027500287, 48.269428726562666,
    ],
    '083175004078': [
      8.070012715734327, 48.21019044614536, 8.176520018255275, 48.26755313814798,
    ],
    '083175004129': [
      7.991540507776282, 48.247510774470484, 8.07755750136159, 48.325745799245894,
    ],
    '083175005039': [
      8.166817032602976, 48.2046706702238, 8.246152281286625, 48.288534737048685,
    ],
    '083175005041': [
      8.121427016414417, 48.24995206949296, 8.2125226644278, 48.35116444055737,
    ],
    '083175006056': [
      8.08586163275538, 48.546735509905545, 8.148005157867495, 48.61396106918773,
    ],
    '083175006102': [
      8.121749891640146, 48.52905552044534, 8.204877687962345, 48.594448533718726,
    ],
    '083175006126': [
      8.148005157867495, 48.55756661875434, 8.236890072687945, 48.60419996893754,
    ],
    '083175007059': [
      7.786970601912169, 48.27113952175396, 7.894719381928941, 48.34514942338223,
    ],
    '083175007065': [
      7.791613769696496, 48.28895232536488, 7.979471209744647, 48.380267528862916,
    ],
    '083175008008': [
      8.169318995650807, 48.401462450483145, 8.270333100877147, 48.49297684947112,
    ],
    '083175008098': [
      8.116355928090703, 48.41485812859785, 8.24133746077819, 48.560685322656376,
    ],
    '083175009067': [
      8.091495214445818, 48.493545088466504, 8.174453806642472, 48.55050304923451,
    ],
    '083175009089': [
      7.980006932073841, 48.452687909311315, 8.121143371838212, 48.67239984275224,
    ],
    '083175009110': [
      7.965686014320281, 48.55891335838899, 8.094127768486722, 48.663687534912704,
    ],
    '083175010021': [
      7.96932163355511, 48.452687909311315, 8.093473297976955, 48.520225500165736,
    ],
    '083175010047': [
      7.849701497867303, 48.36783873009915, 7.978037549753568, 48.45324172274005,
    ],
    '083175010096': [
      7.861793393783244, 48.3970908726366, 8.028631071924469, 48.5518991933182,
    ],
    '083175010100': [
      7.951612662070826, 48.43527117800176, 7.99580461671168, 48.46346464296373,
    ],
    '083175010122': [
      7.83476065323523, 48.43491922194726, 7.913324514624797, 48.49142755618379,
    ],
    '083175011121': [
      7.902719544481342, 48.20198336925165, 8.026683996996667, 48.30425988001211,
    ],
    '083175011127': [
      7.892822733773158, 48.26837186206769, 7.997831325954038, 48.34864922599964,
    ],
    '083175012075': [
      7.742570768926832, 48.367972359630166, 7.832089115308147, 48.43398917418806,
    ],
    '083175012150': [
      7.731090196679033, 48.3138067816524, 7.800749864902633, 48.415182156450825,
    ],
    '083175013093': [
      8.169906207848866, 48.29655411521998, 8.300770967032266, 48.40151676875175,
    ],
    '083175013145': [
      8.204570352069513, 48.236667918135936, 8.330172319170039, 48.351787584484995,
    ],
    '083175014011': [
      7.977179017225291, 48.28942740648079, 8.051409552998859, 48.35999828584553,
    ],
    '083175014085': [
      8.055488509253582, 48.37044140746927, 8.150118726693254, 48.4618381808091,
    ],
    '083175014088': [
      8.102444025015554, 48.33871159106369, 8.217914593901625, 48.42494925672335,
    ],
    '083175014146': [
      8.031400467798655, 48.31148325525998, 8.147947328384827, 48.37713222660042,
    ],
    '083250012012': [
      8.47162161133928, 48.318443471391575, 8.585001240159222, 48.40501966543596,
    ],
    '083255001014': [
      8.44071969055928, 48.18098599236907, 8.554062163278871, 48.25798356853794,
    ],
    '083255001071': [
      8.415915768807045, 48.178092852273295, 8.49269421031423, 48.20802462096264,
    ],
    '083255002015': [
      8.55267401150265, 48.213692600726176, 8.683215296095788, 48.29343792761211,
    ],
    '083255002045': [
      8.494319317546857, 48.26074233410603, 8.661740079282382, 48.331223103765026,
    ],
    '083255002070': [
      8.415816025480856, 48.274109066973466, 8.524367332811995, 48.31383916346719,
    ],
    '083255003011': [
      8.60533358644495, 48.18796513670294, 8.710618717750975, 48.268680671953305,
    ],
    '083255003049': [
      8.5478443330589, 48.11724712417785, 8.744025691520896, 48.22267482128177,
    ],
    '083255003064': [
      8.666480511127927, 48.1353065804455, 8.752402627109722, 48.1801072489024,
    ],
    '083255003069': [
      8.477936487929558, 48.125564292323176, 8.605642929774866, 48.190951733479096,
    ],
    '083255003072': [
      8.542778467436714, 48.07015640270182, 8.66187107645228, 48.13928520411323,
    ],
    '083255004050': [
      8.300770967032266, 48.28331614287028, 8.414133434674667, 48.386546109364026,
    ],
    '083255004051': [
      8.277150800225714, 48.243037730812894, 8.392319013644745, 48.30561856377248,
    ],
    '083255005001': [
      8.379275255516136, 48.242551446953286, 8.444731883840545, 48.32270357274628,
    ],
    '083255005024': [
      8.384550259465671, 48.156426169274155, 8.446657888436134, 48.203666887976944,
    ],
    '083255005036': [
      8.286836200562945, 48.21315078539063, 8.364661806063564, 48.263832493161864,
    ],
    '083255005053': [
      8.28172842612227, 48.15949446015308, 8.534998528916345, 48.279035935046316,
    ],
    '083255006057': [
      8.544855469023203, 48.31219927459839, 8.744619812275046, 48.41005509256667,
    ],
    '083255006061': [
      8.619809751723967, 48.29905091703829, 8.719566581133863, 48.353396417000276,
    ],
    '083255007009': [
      8.523207938100356, 48.204208437052905, 8.603392353582514, 48.26490611160216,
    ],
    '083255007060': [
      8.5518857129472, 48.18851796436581, 8.611213930703805, 48.21690641846022,
    ],
    '083260003003': [
      8.507359639172435, 47.94379058783144, 8.659987355264834, 48.049778166087,
    ],
    '083260005005': [
      8.472278353988257, 47.770292667887716, 8.640152201998509, 47.89253316547259,
    ],
    '083260031031': [
      8.34228154622821, 48.119278180512005, 8.491173066517014, 48.1830848213055,
    ],
    '083260052052': [
      8.272786780171339, 48.07509440116122, 8.402424164008147, 48.17233647626786,
    ],
    '083260068068': [
      8.190926664010272, 47.96520800404822, 8.360783284157897, 48.08085596224278,
    ],
    '083265001006': [
      8.270157424581324, 47.87466883516646, 8.476002548246694, 47.98307283453382,
    ],
    '083265001012': [
      8.310325952427691, 47.884641247120854, 8.617841025101272, 48.0095184331288,
    ],
    '083265001027': [
      8.33454747895133, 47.84563392187614, 8.615419929691189, 47.9634322644173,
    ],
    '083265002017': [
      8.132526866717342, 47.992870329527996, 8.28238436824148, 48.10356720795288,
    ],
    '083265002020': [
      8.109079818513461, 48.00751678290614, 8.174911709620593, 48.0759024760784,
    ],
    '083265003054': [
      8.135910799590004, 48.080152571033786, 8.254393796738606, 48.12925982458075,
    ],
    '083265003055': [
      8.125962045719081, 48.11540915888574, 8.246651289329742, 48.18429120970388,
    ],
    '083265003060': [
      8.213669783367735, 48.09516148994066, 8.297778046351329, 48.18618862571158,
    ],
    '083265004010': [
      8.519133457960898, 48.077713805236534, 8.578043280182845, 48.11387584081275,
    ],
    '083265004037': [
      8.393580474129381, 48.08969283655675, 8.447680368839704, 48.12771299002133,
    ],
    '083265004041': [
      8.457273391416475, 48.10235631886974, 8.555657955171403, 48.169168103976425,
    ],
    '083265004061': [
      8.57689163936245, 48.00910398268644, 8.643518777825458, 48.04897236323343,
    ],
    '083265004065': [
      8.329037927296104, 48.05469028717525, 8.405357353632866, 48.11432454870448,
    ],
    '083265004074': [
      8.30810891510381, 47.98103696305253, 8.636498473774244, 48.12422813679287,
    ],
    '083265004075': [
      8.414026809105355, 47.98652940419543, 8.523158397822305, 48.022692118631525,
    ],
    '083275001004': [
      8.895362491520803, 48.057841416361775, 8.9475768545004, 48.11044195601525,
    ],
    '083275001008': [
      8.934087563184782, 47.9829811545101, 9.013126049620963, 48.03293364533965,
    ],
    '083275001016': [
      8.89837333449236, 47.98881879073982, 8.977606800517327, 48.057841416361775,
    ],
    '083275001027': [
      8.937310677122772, 48.057715328048, 8.996419686657363, 48.10708657634115,
    ],
    '083275001030': [
      8.84998507498138, 48.03708635590398, 8.93345785341494, 48.08670086326792,
    ],
    '083275001036': [
      8.821024762036762, 48.00522772513972, 8.913018284415413, 48.064786873666044,
    ],
    '083275001041': [
      8.857411225677334, 48.07138083069818, 8.918988413978932, 48.10125045245698,
    ],
    '083275002007': [
      8.789651084164564, 48.10325695383361, 8.842669863905925, 48.135728525721504,
    ],
    '083275002009': [
      8.751742862714089, 48.15359668454584, 8.818358614756246, 48.18476651853843,
    ],
    '083275002013': [
      8.84264249079035, 48.10325695383361, 8.88600328667872, 48.13510315536721,
    ],
    '083275002019': [
      8.73362716245618, 48.11473698380858, 8.792329477635121, 48.15458356629851,
    ],
    '083275002029': [
      8.842669863905925, 48.08670086326792, 8.895362491520803, 48.106977358218344,
    ],
    '083275002040': [
      8.82152027458319, 48.12265406221259, 8.864856754484084, 48.14996511569803,
    ],
    '083275002051': [
      8.769771185998989, 48.12644854611523, 8.83455263803317, 48.17257493550948,
    ],
    '083275003018': [
      8.58821977870126, 47.846508195829415, 8.719320218907463, 47.9604884342899,
    ],
    '083275003025': [
      8.637039347598371, 47.88565043389272, 8.82296277163561, 48.001779502701595,
    ],
    '083275004002': [
      8.638843588258313, 48.06439883894672, 8.722886662442946, 48.12112297772794,
    ],
    '083275004005': [
      8.752728742475192, 48.05011970438826, 8.785507249476622, 48.10398004205402,
    ],
    '083275004006': [
      8.77083382082701, 48.08162651683769, 8.857411225677334, 48.121754481294055,
    ],
    '083275004010': [
      8.697968752328702, 48.09236436949085, 8.773905455125574, 48.13037279109387,
    ],
    '083275004011': [
      8.772001255077372, 48.02979392594081, 8.829440297283822, 48.087985752113035,
    ],
    '083275004017': [
      8.685879893507737, 48.111263652622945, 8.745059735797891, 48.14098521154107,
    ],
    '083275004023': [
      8.704593694347585, 48.034824339079016, 8.756787212547932, 48.05873789077597,
    ],
    '083275004033': [
      8.797626990805352, 48.04753947661402, 8.862354488432667, 48.090884267992735,
    ],
    '083275004046': [
      8.66907542357888, 48.043376837898364, 8.767624697135918, 48.09637924041631,
    ],
    '083275005012': [
      8.638467748950811, 48.0264500763731, 8.696980625319744, 48.05537799534636,
    ],
    '083275005020': [
      8.66907542357888, 48.03347010388574, 8.715967800516802, 48.05873789077597,
    ],
    '083275005048': [
      8.630175269229508, 47.99431045048518, 8.700251435135447, 48.03264840867855,
    ],
    '083275005049': [
      8.600315116239427, 48.04073616375751, 8.674294806463543, 48.102239793137926,
    ],
    '083275006038': [
      8.894516212549334, 47.92457830611414, 9.021141219974119, 47.99476654255177,
    ],
    '083275006050': [
      8.692369643840538, 47.92745260669983, 8.908789786508684, 48.02979392594081,
    ],
    '083275006054': [
      8.73870069465658, 47.98211608602899, 8.834166411737977, 48.030172248797065,
    ],
    '083275006055': [
      8.683575726756846, 47.99244609063439, 8.757196134328813, 48.04017663220466,
    ],
    '083275006056': [
      8.747281592641537, 48.01469313916922, 8.812415189146911, 48.05294339566766,
    ],
    '083275006057': [
      8.817840367852725, 47.87966861792385, 8.954578948179647, 47.97513363034225,
    ],
    '083350035035': [
      8.688447478144358, 47.74214445051754, 8.822410183581336, 47.815571203057736,
    ],
    '083350063063': [
      8.908532884395981, 47.72490855882202, 9.061137877385168, 47.81401430646592,
    ],
    '083350080080': [
      8.61381948738449, 47.759707304225394, 8.733354611365845, 47.869539850564415,
    ],
    '083355001001': [
      8.833497183148964, 47.825806474570015, 8.887030720232591, 47.863629712693744,
    ],
    '083355001022': [
      8.690520667326483, 47.80762216314125, 8.841648962368215, 47.926992610686696,
    ],
    '083355001097': [
      8.783469851041914, 47.793523381939465, 8.859330863662583, 47.85383938598527,
    ],
    '083355002015': [
      8.660309370902626, 47.6854025457932, 8.717315707649, 47.714646635111706,
    ],
    '083355002026': [
      8.729053508598351, 47.67589185765392, 8.807896752771939, 47.716280807672376,
    ],
    '083355002028': [
      8.711533595962027, 47.707224884711515, 8.809266592203485, 47.75849812219795,
    ],
    '083355003025': [
      8.945535078576171, 47.66853731442235, 9.005826517240353, 47.715053989478974,
    ],
    '083355003055': [
      8.911443792256343, 47.687527592188154, 8.974589970508204, 47.74164893043939,
    ],
    '083355003061': [
      8.849715409834653, 47.65204025882834, 8.952628431239749, 47.704663167946805,
    ],
    '083355004002': [
      9.03473875272497, 47.7026371164275, 9.12614562951444, 47.7731304697286,
    ],
    '083355004043': [
      9.086451949733359, 47.65553781249926, 9.216704665637584, 47.76263193807391,
    ],
    '083355004066': [
      9.02086447202726, 47.6833990158465, 9.131840847538525, 47.738960286789975,
    ],
    '083355005075': [
      8.808407576581407, 47.697425933643956, 8.926234874313925, 47.81495622940201,
    ],
    '083355005077': [
      8.876049082834912, 47.764249706647945, 8.949745165130837, 47.83051804809939,
    ],
    '083355005081': [
      8.846696926152122, 47.80897447757419, 8.887030720232591, 47.83604901680554,
    ],
    '083355005100': [
      8.805211661416587, 47.70340690075033, 8.886530927734826, 47.751722069092075,
    ],
    '083355006021': [
      8.833497183148964, 47.844636498053006, 8.981803729599276, 47.933329666214824,
    ],
    '083355006057': [
      8.965095325705894, 47.88225970008321, 9.08061205696078, 47.94052187722108,
    ],
    '083355006079': [
      8.939448502752859, 47.80027055221332, 9.12844857061505, 47.90189890796749,
    ],
    '083355006096': [
      9.04945042660573, 47.85709373331388, 9.147692723559704, 47.917067430594834,
    ],
    '083355006098': [
      8.975819720277023, 47.772662431017245, 9.080410720628945, 47.848709881425364,
    ],
    '083355006099': [
      8.882472490138452, 47.81671186526811, 8.983264458915778, 47.868425366695746,
    ],
    '083360014014': [
      7.513843247066228, 47.63211445645137, 7.636201269784848, 47.70756418668657,
    ],
    '083360084084': [
      7.709758621888356, 47.61660486374263, 7.785555167881084, 47.73388926153492,
    ],
    '083360087087': [
      7.887695201888764, 47.75734876561052, 8.021384291989191, 47.87897183797111,
    ],
    '083360091091': [
      7.566540767051007, 47.57733913502586, 7.649297576700884, 47.63214991164642,
    ],
    '083360105105': [
      7.634013982677003, 47.53349842620088, 7.724065546710649, 47.57550507638942,
    ],
    '083360107107': [
      7.73637446380045, 47.67412346449245, 7.852460531049014, 47.82257589629823,
    ],
    '083365001045': [
      7.569798490221951, 47.658996929161745, 7.716790889379445, 47.75023901179335,
    ],
    '083365001104': [
      7.687611600989401, 47.712821643359604, 7.752449920647402, 47.78961804434049,
    ],
    '083365003043': [
      7.671993400400314, 47.57137469381766, 7.723309246662981, 47.606690323022804,
    ],
    '083365003050': [
      7.63346808971393, 47.59238578290302, 7.729098321689346, 47.678574775256784,
    ],
    '083365004069': [
      7.70934320983498, 47.54241218532725, 7.840955577514012, 47.62520954218964,
    ],
    '083365004082': [
      7.829255538805704, 47.581974072181424, 7.903153815348166, 47.637552402965035,
    ],
    '083365005006': [
      7.513843247066228, 47.699383839594795, 7.620518383395603, 47.74387592366896,
    ],
    '083365005078': [
      7.549191176707369, 47.72455857548361, 7.708772241524327, 47.77893385895566,
    ],
    '083365006004': [
      7.844714021275969, 47.798545476322, 7.903825704335803, 47.83866336233353,
    ],
    '083365006010': [
      7.833295021486724, 47.779664747967644, 7.857860239121796, 47.817170891019806,
    ],
    '083365006025': [
      7.839131179318006, 47.73564371066435, 7.942368106861807, 47.78213786827944,
    ],
    '083365006079': [
      7.857860239121796, 47.77027705773777, 8.003304991389763, 47.80978317562636,
    ],
    '083365006080': [
      7.833704636912095, 47.78213786827944, 7.887185897608058, 47.82731494027263,
    ],
    '083365006089': [
      7.903296053073024, 47.775915134592545, 7.942368106861807, 47.79609557136154,
    ],
    '083365006090': [
      7.894161476452707, 47.79336029791917, 7.92782208348401, 47.83230286184567,
    ],
    '083365006094': [
      7.871685973297844, 47.76241323047981, 7.891234691076464, 47.77846039825148,
    ],
    '083365006096': [
      7.855462797584249, 47.824000212905, 7.918237078836205, 47.86732737290004,
    ],
    '083365007034': [
      7.87133979935931, 47.64207270551848, 7.91715008428783, 47.68909939636023,
    ],
    '083365007036': [
      7.815491336844089, 47.66741436820445, 7.843751365458585, 47.70270572749838,
    ],
    '083365007057': [
      7.758423563230084, 47.62242864828753, 7.796724591157902, 47.67412346449245,
    ],
    '083365007081': [
      7.785555167881084, 47.61810980469099, 7.980607727027267, 47.7303398416767,
    ],
    '083365008008': [
      7.604171188374032, 47.62156549631898, 7.647964402186441, 47.64851554045748,
    ],
    '083365008019': [
      7.577062091662116, 47.62015863781143, 7.606591071372341, 47.64459061581177,
    ],
    '083365008024': [
      7.588493329324836, 47.64360477079059, 7.614866390205796, 47.657944716522934,
    ],
    '083365008073': [
      7.622319224752529, 47.63651485539198, 7.682223055954156, 47.66212813492103,
    ],
    '083365008075': [
      7.607175341043885, 47.6478227016443, 7.638640806213487, 47.669484241865824,
    ],
    '083365008100': [
      7.637989873092647, 47.649497158939994, 7.673307231091819, 47.66729351040206,
    ],
    '083365009103': [
      7.805060334806894, 47.690802434794826, 7.973679832067063, 47.75605977731723,
    ],
    '083365009106': [
      7.890147056206671, 47.705994738428245, 7.973679832067063, 47.76401114125507,
    ],
    '083370002002': [
      8.07115027681708, 47.582659333985404, 8.168157919335968, 47.67176000320582,
    ],
    '083370038038': [
      8.006998426369577, 47.61131732801097, 8.100417191859592, 47.722577244715666,
    ],
    '083370062062': [
      8.35555744643305, 47.601452763528194, 8.487158219668789, 47.689168272674785,
    ],
    '083370066066': [
      8.019366689646406, 47.55283044402454, 8.108187104929943, 47.62197921321047,
    ],
    '083370106106': [
      8.3244304074258, 47.7093068565045, 8.530341971731273, 47.82961689906454,
    ],
    '083370116116': [
      7.87133979935931, 47.577120136494706, 7.953103331676542, 47.67698202493341,
    ],
    '083375001022': [
      8.2308211748971, 47.76672711430551, 8.417577801305603, 47.853194681599796,
    ],
    '083375001127': [
      8.370589600278183, 47.78098124056751, 8.472291293417731, 47.856811474615554,
    ],
    '083375002030': [
      8.445963630206306, 47.614089852280564, 8.538725137270252, 47.64851149957631,
    ],
    '083375002060': [
      8.526582401098494, 47.625676439739074, 8.62767757772871, 47.6720055855008,
    ],
    '083375002070': [
      8.552382503660247, 47.596125222623414, 8.604847644717381, 47.641890019848134,
    ],
    '083375003053': [
      8.346750808829396, 47.5661558944854, 8.488967292950498, 47.606876832673294,
    ],
    '083375003125': [
      8.258720549927741, 47.56997593318014, 8.39747349169902, 47.62692984380243,
    ],
    '083375004039': [
      8.192093330771298, 47.73209324700404, 8.309494047340625, 47.82431668952977,
    ],
    '083375004128': [
      8.192483717851859, 47.67132637316428, 8.37854260873186, 47.78008766045683,
    ],
    '083375005049': [
      7.937430900518875, 47.632486771370445, 8.038722001239995, 47.72274720578716,
    ],
    '083375005076': [
      7.995918398832087, 47.55063333223849, 8.052906578776819, 47.62059518834522,
    ],
    '083375005090': [
      7.931849145094644, 47.58198264026135, 8.025654268001846, 47.65501795513193,
    ],
    '083375005096': [
      7.906507397873354, 47.5443747220118, 8.014074106884298, 47.59244193980853,
    ],
    '083375006013': [
      7.997400400578172, 47.75867020908356, 8.095257450627138, 47.842825354917245,
    ],
    '083375006027': [
      8.059164826526974, 47.65777471715122, 8.143613937059317, 47.7525874712877,
    ],
    '083375006045': [
      8.153162489545725, 47.74705611333581, 8.192483717851859, 47.78216234970806,
    ],
    '083375006051': [
      8.131768719315913, 47.695046469945694, 8.224100047736844, 47.74847475258485,
    ],
    '083375006059': [
      8.021281424699358, 47.713095471098775, 8.099898484122912, 47.76870282733588,
    ],
    '083375006097': [
      8.020922295485322, 47.67176000320582, 8.15411367216662, 47.856819152598106,
    ],
    '083375006108': [
      7.960042452602297, 47.69036385653472, 8.03432833142831, 47.77561221148486,
    ],
    '083375007032': [
      8.14309007940355, 47.59434539977038, 8.190841978411258, 47.63370175534472,
    ],
    '083375007065': [
      8.28747058998272, 47.60605386668809, 8.36581891618, 47.63817943541008,
    ],
    '083375007118': [
      8.124988163521662, 47.64214528212411, 8.25524669786681, 47.70353287834582,
    ],
    '083375007126': [
      8.115209806285147, 47.605386350326455, 8.339098902070221, 47.703164737237586,
    ],
    '083375008123': [
      8.321783931348016, 47.62539643466156, 8.404425843372884, 47.68716877390608,
    ],
    '083375008124': [
      8.358599609622686, 47.67934760651395, 8.421159908672545, 47.726527643097185,
    ],
    '084150014014': [
      9.31724311790877, 48.50464620068641, 9.401696609668573, 48.546290822558674,
    ],
    '084150019019': [
      9.231915288315117, 48.457208757228265, 9.327336120762459, 48.509200494495424,
    ],
    '084150059059': [
      9.17032805215735, 48.42156163553436, 9.300398086224659, 48.48465660863693,
    ],
    '084150061061': [
      9.115954475463022, 48.416655528174395, 9.256216557822338, 48.5790928377218,
    ],
    '084150073073': [
      9.160331137762753, 48.25228455772872, 9.34472363970014, 48.362743155190316,
    ],
    '084150080080': [
      9.13657874865973, 48.50078779949665, 9.169275962312296, 48.52746448262097,
    ],
    '084150091091': [
      9.122034214702678, 48.33202009081976, 9.25226732068554, 48.42450903816815,
    ],
    '084150092092': [
      9.218307806013211, 48.38606167892613, 9.315737455425342, 48.46215846713258,
    ],
    '084150093093': [
      9.293576003267814, 48.4089136112401, 9.415814524666308, 48.51600877731247,
    ],
    '084155001089': [
      9.239887657708097, 48.3596942982392, 9.34462824283221, 48.421509563154814,
    ],
    '084155001090': [
      9.27966698824569, 48.298616145332545, 9.458395807148438, 48.37612798954905,
    ],
    '084155002029': [
      9.290423777199932, 48.558950130291564, 9.32230985244054, 48.578440475994846,
    ],
    '084155002050': [
      9.23861456208076, 48.49238345156529, 9.330145953120626, 48.562084506771136,
    ],
    '084155002062': [
      9.239671188447202, 48.54489946481615, 9.290767231541441, 48.56750653935114,
    ],
    '084155003027': [
      9.33056555133594, 48.35325831890343, 9.460285334057582, 48.42403672774512,
    ],
    '084155003048': [
      9.529428452186888, 48.35649775750462, 9.599675956640287, 48.39385931612266,
    ],
    '084155003053': [
      9.411664845272822, 48.30822761453899, 9.630170767751602, 48.450492690279084,
    ],
    '084155004060': [
      9.125296174850062, 48.54658055884315, 9.224083883235819, 48.58290338420479,
    ],
    '084155004087': [
      9.126382945403039, 48.5729966727079, 9.207107194675183, 48.60463807169543,
    ],
    '084155005028': [
      9.418421227869358, 48.49902554793612, 9.487344477568882, 48.545486187361725,
    ],
    '084155005039': [
      9.378682489885449, 48.50496301594474, 9.424251641663165, 48.53720757757097,
    ],
    '084155005078': [
      9.345494226318557, 48.43837595564122, 9.486657871507536, 48.52586558528316,
    ],
    '084155005088': [
      9.47427929219142, 48.47113951624345, 9.591694570200326, 48.541547768783666,
    ],
    '084155006034': [
      9.393449240016237, 48.24541956739429, 9.557714222035063, 48.33621598027008,
    ],
    '084155006058': [
      9.331999238022572, 48.21950144853057, 9.434948518757807, 48.31584899867848,
    ],
    '084155006085': [
      9.368140801961756, 48.194644785599586, 9.500097480506527, 48.26721101906221,
    ],
    '084160009009': [
      9.078270186054814, 48.57859472847072, 9.132200217183824, 48.622724561765,
    ],
    '084160022022': [
      9.11782638434454, 48.52209030386321, 9.173863736407112, 48.56622407510346,
    ],
    '084160023023': [
      9.068433176585732, 48.47127855325941, 9.153670629370485, 48.53410724956262,
    ],
    '084160041041': [
      8.963407501006907, 48.44994465730435, 9.130913089766809, 48.594223116501645,
    ],
    '084160048048': [
      8.884955676885063, 48.51630357976051, 9.03511887118322, 48.59127402576014,
    ],
    '084165001011': [
      9.010425234554102, 48.436201945344415, 9.08003607637909, 48.48458725960337,
    ],
    '084165001015': [
      9.068433176585732, 48.43277195338019, 9.138735132719747, 48.48458725960337,
    ],
    '084165001026': [
      9.043541005348144, 48.418015159386485, 9.103003670671391, 48.44700549916679,
    ],
    '084165002006': [
      8.934845128151588, 48.38034910290669, 9.002279971020625, 48.4168663559547,
    ],
    '084165002025': [
      8.996324224972819, 48.362706994751264, 9.149520925264413, 48.43312003770972,
    ],
    '084165002031': [
      8.974309460872549, 48.39855681332093, 9.057337063547054, 48.44642013948796,
    ],
    '084165003018': [
      8.86990559021464, 48.39051740098003, 8.938367629321208, 48.4378307935644,
    ],
    '084165003036': [
      8.75619262192412, 48.39680237004425, 9.015711859536278, 48.5401086005778,
    ],
    '084165003049': [
      8.827501191790626, 48.463430074538465, 8.904747942279338, 48.50024134453093,
    ],
    '084165003050': [
      8.764708135384872, 48.406377510295435, 8.871415366733281, 48.45830529704823,
    ],
    '084170013013': [
      9.024734641154678, 48.25170948495347, 9.215108652479714, 48.372707521355416,
    ],
    '084170025025': [
      8.732022440141874, 48.31384481225992, 8.862551362966471, 48.41676951944555,
    ],
    '084170054054': [
      8.648244212141494, 48.23062184951826, 8.766970016826548, 48.34438884312407,
    ],
    '084175001010': [
      9.068494904398266, 48.222044701955475, 9.11480473956482, 48.25562844677145,
    ],
    '084175001079': [
      8.883601146747974, 48.15947308411187, 9.079943463695516, 48.31280184401865,
    ],
    '084175002002': [
      8.763783681587462, 48.21387828850882, 8.94496571996441, 48.32642667108279,
    ],
    '084175002022': [
      8.733089611120795, 48.26034326823676, 8.828981033404766, 48.335931284260646,
    ],
    '084175003008': [
      8.872450308509114, 48.2793418912309, 8.9787623805884, 48.34471825531888,
    ],
    '084175003023': [
      8.849447463145664, 48.31632155201829, 8.919417026914966, 48.36355071882318,
    ],
    '084175004031': [
      8.891961053594882, 48.2999780464225, 9.061116556568278, 48.39055277288266,
    ],
    '084175004036': [
      9.015902791635162, 48.30965358851083, 9.06809713378833, 48.34680235687218,
    ],
    '084175004051': [
      8.830851910709834, 48.3585343815746, 8.927289721126273, 48.41649821127634,
    ],
    '084175005044': [
      8.84518953971157, 48.11952496279859, 9.009639495736003, 48.218953488295604,
    ],
    '084175005045': [
      8.861772866720921, 48.10125045245698, 8.955659348767782, 48.15330319092018,
    ],
    '084175005047': [
      8.815005432198983, 48.143324950900585, 8.892786146374123, 48.19125302397253,
    ],
    '084175006014': [
      8.728486073965133, 48.228873503358976, 8.763783681587462, 48.26034326823676,
    ],
    '084175006015': [
      8.76114257169622, 48.223333187800264, 8.796909363352643, 48.26034326823676,
    ],
    '084175006016': [
      8.764967084066006, 48.20098240254593, 8.821458528351402, 48.2452254242215,
    ],
    '084175006029': [
      8.813819551534054, 48.18046208148096, 8.855544365379798, 48.22199325937842,
    ],
    '084175006052': [
      8.784149504330538, 48.18041934251991, 8.831755542370837, 48.20359552806004,
    ],
    '084175006057': [
      8.718753272522417, 48.15968284664846, 8.807136055327186, 48.234432566754165,
    ],
    '084175006071': [
      8.75725153878593, 48.18240103807389, 8.792573840995008, 48.19658498214922,
    ],
    '084175006078': [
      8.703772964530668, 48.208273020476625, 8.739549321643764, 48.23128447398255,
    ],
    '084175007063': [
      9.03249499877252, 48.14880217952471, 9.111500475956177, 48.22314429214965,
    ],
    '084175007075': [
      9.079943463695516, 48.13397157747605, 9.18799280745675, 48.23628247615279,
    ],
    '084210000000': [
      9.842381638670362, 48.308119854586614, 10.041371693582688, 48.46534819983208,
    ],
    '084250039039': [
      9.758368259247293, 48.26817552388254, 9.937775106025162, 48.36431288380091,
    ],
    '084250108108': [
      9.580555088108893, 48.346218505673086, 9.777723397809641, 48.427142220397386,
    ],
    '084250141141': [
      9.801595369169657, 48.37486584160539, 9.941024267510835, 48.49240155370226,
    ],
    '084255001002': [
      9.62188955043725, 48.29889790827301, 9.82041532057085, 48.36532580412739,
    ],
    '084255001004': [
      9.747227051467895, 48.320758697982754, 9.798728302225884, 48.346218505673086,
    ],
    '084255002017': [
      9.718219462074346, 48.43424502463222, 9.827528392646364, 48.4871590086916,
    ],
    '084255002020': [
      9.680194725912735, 48.356466358519356, 9.862426952047578, 48.45702886152053,
    ],
    '084255003028': [
      10.011892953250213, 48.19494108511886, 10.087699075338925, 48.25505751003547,
    ],
    '084255003066': [
      10.00066447589112, 48.244689937108944, 10.065084310998735, 48.30204209609775,
    ],
    '084255003140': [
      10.00980286263242, 48.142516228656056, 10.097603916847122, 48.19839236192899,
    ],
    '084255004014': [
      9.936773205704164, 48.464332836587424, 10.007181168638198, 48.50611844515081,
    ],
    '084255004031': [
      9.799533757442493, 48.43706692569271, 9.978560145778728, 48.52665804880385,
    ],
    '084255004135': [
      9.91197395435177, 48.492856583843015, 9.978276424042214, 48.53711432759468,
    ],
    '084255005033': [
      9.505554591393246, 48.206365073514334, 9.860749936099904, 48.36516123502354,
    ],
    '084255005050': [
      9.75670170880879, 48.24515047514304, 9.805261693635941, 48.280970388507065,
    ],
    '084255005088': [
      9.804748659191953, 48.29287405181833, 9.858503341968753, 48.3239215900591,
    ],
    '084255005093': [
      9.777709455733781, 48.27254321945107, 9.837821643282021, 48.30876401576609,
    ],
    '084255006064': [
      9.921373044932055, 48.26685171399185, 9.972423809760391, 48.3120533694993,
    ],
    '084255006110': [
      9.960458085955459, 48.2437541587072, 10.02967918834897, 48.284345870707675,
    ],
    '084255006137': [
      9.9739152181808, 48.29303469433394, 10.03785393096033, 48.35208134588633,
    ],
    '084255006138': [
      9.949176316814224, 48.278661681896104, 10.022278645888306, 48.324198817794176,
    ],
    '084255007071': [
      9.590263924365342, 48.432262516009146, 9.801889619049511, 48.5387423228915,
    ],
    '084255007079': [
      9.69583171963707, 48.49393551003614, 9.8045060384842, 48.55728989355587,
    ],
    '084255007084': [
      9.717898127637513, 48.50796116833237, 9.848820165203389, 48.56592767699941,
    ],
    '084255007134': [
      9.580620906217575, 48.4885757981944, 9.658603261382982, 48.54106175778027,
    ],
    '084255007139': [
      9.619212864298785, 48.416756344531834, 9.697482040164955, 48.4690554093906,
    ],
    '084255008005': [
      9.960373683198789, 48.55043325851298, 10.058088674506042, 48.60682882124301,
    ],
    '084255008011': [
      10.17066882135116, 48.488512166555196, 10.240554689944938, 48.55869793115392,
    ],
    '084255008013': [
      10.056749672494963, 48.54103511173847, 10.109983965363316, 48.58703615841842,
    ],
    '084255008019': [
      9.98663655373156, 48.48613381415601, 10.053409722224163, 48.53022081472563,
    ],
    '084255008022': [
      10.037062196301328, 48.53102880121027, 10.085038709436562, 48.563894050820274,
    ],
    '084255008024': [
      9.975799113690698, 48.50440615395937, 10.004968789176015, 48.52205334465376,
    ],
    '084255008062': [
      9.970751552236356, 48.511925459053295, 10.03962549640417, 48.54053311745007,
    ],
    '084255008072': [
      10.002382823806732, 48.455432848047664, 10.198692725733828, 48.53102880121027,
    ],
    '084255008083': [
      10.003879804278574, 48.52583418112036, 10.071502822534555, 48.561993689677834,
    ],
    '084255008085': [
      10.071502822534555, 48.5126289419862, 10.130126436679994, 48.54261135585746,
    ],
    '084255008092': [
      10.123361050040337, 48.51508298788293, 10.163670264158906, 48.556216753281724,
    ],
    '084255008097': [
      10.154353250395161, 48.4803426802609, 10.218036848659299, 48.55714216775386,
    ],
    '084255008112': [
      10.098935520525687, 48.52563674988721, 10.143634217469604, 48.57045124761732,
    ],
    '084255008130': [
      9.944122388714392, 48.53465154849124, 10.015121549445174, 48.59056033906344,
    ],
    '084255009008': [
      9.81518920374414, 48.540208950952774, 9.969157948661415, 48.63369176326238,
    ],
    '084255009075': [
      9.834191389209916, 48.50795452532713, 9.96650237712591, 48.58522895740896,
    ],
    '084255010035': [
      9.489762196877853, 48.220877407146254, 9.538290754642782, 48.254553596601056,
    ],
    '084255010036': [
      9.616582925863094, 48.18388856074531, 9.675738721845056, 48.22423721597198,
    ],
    '084255010052': [
      9.650015311290545, 48.1595371159456, 9.68052299710384, 48.18610845759192,
    ],
    '084255010055': [
      9.594621657988315, 48.19998005122931, 9.638942262101537, 48.220915840862276,
    ],
    '084255010073': [
      9.53197385426631, 48.24018826868794, 9.610871355716162, 48.28109941015363,
    ],
    '084255010081': [
      9.619382501563374, 48.20935364525107, 9.684653841732654, 48.25666076254575,
    ],
    '084255010090': [
      9.527276972957964, 48.192267445791565, 9.628113400516517, 48.244352687700086,
    ],
    '084255010091': [
      9.644044674829658, 48.17171490198473, 9.74563262135493, 48.20400712094964,
    ],
    '084255010098': [
      9.523700382269976, 48.23688225800117, 9.573604305864706, 48.25373836557642,
    ],
    '084255010104': [
      9.659830089304174, 48.21822359543349, 9.716278163741432, 48.25495325420929,
    ],
    '084255010123': [
      9.595558431694005, 48.22367956865118, 9.627367617641834, 48.25844809584167,
    ],
    '084255010124': [
      9.672519884432866, 48.192401539582704, 9.746682159997865, 48.2205520618472,
    ],
    '084255010125': [
      9.622721982412914, 48.19158777427197, 9.649233976421018, 48.20921823111914,
    ],
    '084260134134': [
      9.71147921885208, 48.1204453039022, 9.84261633203031, 48.216464457020564,
    ],
    '084265001005': [
      9.594284452352502, 48.08339396546046, 9.63924277165885, 48.12881272020551,
    ],
    '084265001006': [
      9.578383309411187, 48.017667186294055, 9.617759387550489, 48.03770288680405,
    ],
    '084265001013': [
      9.56907506563586, 48.03321893752079, 9.646961611835845, 48.09616381744436,
    ],
    '084265001020': [
      9.54844873631369, 48.095203193962035, 9.605955504452227, 48.13941461843894,
    ],
    '084265001036': [
      9.532646682654706, 48.04263711307336, 9.57878184050855, 48.07827426933451,
    ],
    '084265001064': [
      9.536598034737043, 48.065646882412075, 9.59488136264304, 48.106613534253086,
    ],
    '084265001078': [
      9.590050443013793, 48.08016115153795, 9.610088350348637, 48.10266710853107,
    ],
    '084265001090': [
      9.627702471138456, 48.04665371346942, 9.685558817669376, 48.08758519487073,
    ],
    '084265001109': [
      9.62853972879054, 48.09616381744436, 9.668451021214574, 48.13167274042234,
    ],
    '084265001118': [
      9.634291069128308, 48.07939495593091, 9.685483461014922, 48.11532144754091,
    ],
    '084265002014': [
      9.595375175096502, 47.96557512703224, 9.709298731577794, 48.05218589662638,
    ],
    '084265002062': [
      9.686162749157255, 47.97225674815745, 9.784986407377607, 48.06725985982548,
    ],
    '084265003011': [
      9.651366685862513, 48.10871613366096, 9.732485843460903, 48.179638188607996,
    ],
    '084265003021': [
      9.675517128159738, 48.04726699154111, 9.904415691139645, 48.129576071407755,
    ],
    '084265003038': [
      9.757298504774445, 47.952010381778244, 9.922019963648047, 48.03173650057075,
    ],
    '084265003058': [
      9.74878998920739, 47.99120804839451, 9.833901406600319, 48.05813600501939,
    ],
    '084265003071': [
      9.816774464973934, 48.09141945679376, 9.940935325246706, 48.17672917699307,
    ],
    '084265003074': [
      9.702939564445469, 48.05381426007921, 9.778845289520238, 48.114893806512654,
    ],
    '084265003120': [
      9.810360297975759, 48.01767157250401, 9.867944618985117, 48.08987241371396,
    ],
    '084265003128': [
      9.72638534849912, 48.10746405914332, 9.832685552806067, 48.164585306842916,
    ],
    '084265004019': [
      10.020693442590622, 48.02051618054081, 10.105393461846798, 48.07444310806651,
    ],
    '084265004031': [
      10.062252416800838, 48.08956942403205, 10.138959888171284, 48.12487773262259,
    ],
    '084265004044': [
      9.993297097337623, 48.06275322217585, 10.104606145116344, 48.115177813719924,
    ],
    '084265004065': [
      10.027330602858136, 48.115136934657734, 10.11295558896298, 48.16208140229685,
    ],
    '084265004066': [
      10.040045751187098, 48.023548723999305, 10.143280439519183, 48.097335650703904,
    ],
    '084265005001': [
      9.860749936099904, 48.23325655377506, 9.946816512218472, 48.2937361574632,
    ],
    '084265005028': [
      9.900432529186128, 48.205346301695165, 10.00347306099393, 48.252671582024554,
    ],
    '084265005070': [
      9.764244047080455, 48.19134623497047, 9.990847123075644, 48.26909883781501,
    ],
    '084265005073': [
      9.838735591572041, 48.15930088921213, 9.960226097457983, 48.20280457536744,
    ],
    '084265006043': [
      9.956224282964122, 48.017522474108326, 10.040045751187098, 48.086809352044774,
    ],
    '084265006087': [
      9.86574627298229, 48.018827152570324, 10.011247542029759, 48.12189444840678,
    ],
    '084265006113': [
      9.880155573782012, 47.98537578931249, 9.989859156954864, 48.04971905753328,
    ],
    '084265006135': [
      9.9140530597237, 48.101527347569224, 10.05282537347877, 48.15158438665175,
    ],
    '084265007008': [
      9.354302548110281, 48.09130320151128, 9.463900097107297, 48.16112573111999,
    ],
    '084265007035': [
      9.497381282012276, 48.084768437052496, 9.567857923231038, 48.1497368512476,
    ],
    '084265007045': [
      9.391654885266005, 48.0665320367063, 9.539679430229379, 48.12266007350653,
    ],
    '084265007067': [
      9.262234127571631, 48.104516586910535, 9.425529854586632, 48.239230840447746,
    ],
    '084265007097': [
      9.387004354975819, 48.061881574868316, 9.547715047867483, 48.232612000599964,
    ],
    '084265007121': [
      9.494642368739385, 48.14468605403157, 9.601188147340926, 48.19989144356386,
    ],
    '084265007124': [
      9.544305205147314, 48.11532144754091, 9.67338787575373, 48.205470309645705,
    ],
    '084265008100': [
      9.911933293003996, 47.9459051409634, 10.06717330933613, 48.05139151690981,
    ],
    '084265008117': [
      10.04297344588454, 47.97366838753867, 10.136803044148378, 48.026168658469935,
    ],
    '084265009108': [
      9.918731377147903, 48.13686253985146, 10.039718917657847, 48.24683241176492,
    ],
    '084265009125': [
      9.979400090051657, 48.15158438665175, 10.068334258755351, 48.204446301571714,
    ],
    '084350035035': [
      9.514303930005456, 47.65502455941903, 9.624446247879279, 47.73640481957299,
    ],
    '084355001013': [
      9.509442157414824, 47.61156123557419, 9.567961151757217, 47.661732228617375,
    ],
    '084355001029': [
      9.554232241081726, 47.583462782745585, 9.64459706877921, 47.636099731894134,
    ],
    '084355001030': [
      9.526805554163705, 47.58633440328502, 9.596766667729423, 47.64210587211851,
    ],
    '084355002016': [
      9.381815114160712, 47.63709549825272, 9.559913932226342, 47.738057251601276,
    ],
    '084355002024': [
      9.32840489784021, 47.66054144602611, 9.39308957067973, 47.69357827016357,
    ],
    '084355003005': [
      9.305153600521509, 47.703222395930915, 9.381887115315592, 47.75282296565483,
    ],
    '084355003034': [
      9.309612122516384, 47.67847111151994, 9.462502441192164, 47.7561524385645,
    ],
    '084355003045': [
      9.440721316945794, 47.70008477701537, 9.501419131035657, 47.76451717393323,
    ],
    '084355003067': [
      9.336200534260978, 47.736057282904966, 9.462583716510133, 47.83500348946877,
    ],
    '084355004010': [
      9.251826552271421, 47.7035339743246, 9.28584663770372, 47.719611868749155,
    ],
    '084355004018': [
      9.30568694045488, 47.669528324345684, 9.33533838645251, 47.68892808358291,
    ],
    '084355004036': [
      9.231638212930335, 47.68529982346745, 9.309612122516384, 47.72935488005739,
    ],
    '084355004054': [
      9.284829673124658, 47.67585117179043, 9.315114438184228, 47.709113582328676,
    ],
    '084355004066': [
      9.206788468708943, 47.71421725592446, 9.281274501100885, 47.75864199378504,
    ],
    '084355005015': [
      9.213980659312375, 47.79213006795933, 9.311841185989245, 47.84819750835984,
    ],
    '084355005020': [
      9.23796923705037, 47.79894425128032, 9.374121048967373, 47.88158130939531,
    ],
    '084355005052': [
      9.222094979234706, 47.7251150912507, 9.365217945866936, 47.81803710451545,
    ],
    '084355006042': [
      9.658130102921477, 47.63152689172699, 9.74453287511619, 47.68649575737446,
    ],
    '084355006057': [
      9.544269197958709, 47.60418314636531, 9.692073430850439, 47.70584769148881,
    ],
    '084355007047': [
      9.102826816190479, 47.78699197868178, 9.246180025910784, 47.85813792744632,
    ],
    '084355007053': [
      9.069671208149686, 47.78327849274926, 9.126409079801597, 47.811237391067465,
    ],
    '084355007059': [
      9.067653705254374, 47.74445770577697, 9.252637729059856, 47.85974653047797,
    ],
    '084360008008': [
      9.567236096796599, 47.90463788538708, 9.729807518264476, 47.98251122049283,
    ],
    '084360010010': [
      9.798878026145994, 47.83117173150838, 10.046273635793053, 47.98420493790327,
    ],
    '084360049049': [
      9.977213148411794, 47.640582310535244, 10.13871607588012, 47.767149692284406,
    ],
    '084360052052': [
      9.803124851170942, 47.726608091890775, 9.962418046273092, 47.848407624952536,
    ],
    '084360094094': [
      9.870538581101814, 47.65354338263392, 10.004371401022189, 47.753538414863,
    ],
    '084365001005': [
      9.517185546753492, 47.898664980638834, 9.606541047682633, 47.9560819688685,
    ],
    '084365001019': [
      9.491645988895725, 47.9146262934041, 9.545114476702185, 47.98822954342966,
    ],
    '084365001024': [
      9.487499068232333, 47.88311848697543, 9.546839478600505, 47.9238038100561,
    ],
    '084365001027': [
      9.465693377573002, 47.914110567384185, 9.543480778909547, 47.96537444439355,
    ],
    '084365001032': [
      9.45541440050689, 47.86975188573214, 9.50096226972811, 47.89369879317221,
    ],
    '084365001040': [
      9.438794348028589, 47.882736895986454, 9.500051922665092, 47.92734941705606,
    ],
    '084365001047': [
      9.42234861571827, 47.92440623113032, 9.500469057624223, 47.964229912199684,
    ],
    '084365001053': [
      9.401325706159716, 47.91520830159493, 9.453549786595532, 47.94021701103809,
    ],
    '084365001067': [
      9.397488014015345, 47.8938753447899, 9.45760863392382, 47.92222235366376,
    ],
    '084365001077': [
      9.451096970262212, 47.889045105692425, 9.487499068232333, 47.91649300563115,
    ],
    '084365001093': [
      9.543480778909547, 47.934220349763066, 9.623457159784373, 48.00476739017558,
    ],
    '084365002009': [
      9.655379565653496, 47.854400590005, 9.845736874248784, 47.980560065410806,
    ],
    '084365002014': [
      9.697752616153315, 47.828511230504155, 9.790250566281962, 47.88006879024421,
    ],
    '084365003018': [
      9.653358395561519, 47.68389064343815, 9.735216867396106, 47.73926908695866,
    ],
    '084365003039': [
      9.630278477660072, 47.71269686501119, 9.694387613809274, 47.76942786645955,
    ],
    '084365003069': [
      9.647452739351237, 47.75161391930107, 9.745007945154711, 47.83162867945511,
    ],
    '084365003079': [
      9.681855299382004, 47.73175247795999, 9.761189912046634, 47.79448681821579,
    ],
    '084365004003': [
      9.998817759740732, 47.86488372651069, 10.107786665664323, 47.922860299332775,
    ],
    '084365004004': [
      9.994793195810248, 47.90351108503162, 10.111303576894452, 47.98095438356463,
    ],
    '084365004055': [
      9.903741269150728, 47.737594150453624, 10.137819318772172, 47.883469109006334,
    ],
    '084365005011': [
      9.610140058764491, 47.80452350659353, 9.726203004973094, 47.84734989109853,
    ],
    '084365005012': [
      9.62198823012851, 47.830299123109576, 9.717884535968677, 47.889786755348645,
    ],
    '084365005013': [
      9.532011631772459, 47.79485545616231, 9.61625063845249, 47.8570850504722,
    ],
    '084365005064': [
      9.484648672275117, 47.700108543416775, 9.663108831755803, 47.815271253363264,
    ],
    '084365005082': [
      9.606381675524654, 47.78821840827758, 9.672508268084998, 47.82327726865503,
    ],
    '084365006078': [
      9.730712835621278, 47.74821646860912, 9.807651830820081, 47.81210213388454,
    ],
    '084365006085': [
      9.732079671604604, 47.78093395538494, 9.838410725369679, 47.879148345543946,
    ],
    '084365007001': [
      9.683014185015363, 47.60145907571995, 9.745114932560234, 47.644477545145676,
    ],
    '084365007006': [
      9.711257947210626, 47.681639935374314, 9.807036586985518, 47.74821646860912,
    ],
    '084365007081': [
      9.728971395317414, 47.60266074337307, 9.896518734143704, 47.77377290453683,
    ],
    '084365008083': [
      9.37793150990859, 47.81809101049659, 9.481993592060523, 47.90529454949699,
    ],
    '084365008095': [
      9.42998422925622, 47.7561524385645, 9.54008893315532, 47.8569513236216,
    ],
    '084365009087': [
      9.560408059174227, 47.86275531568172, 9.675410067349409, 47.91837266809426,
    ],
    '084365009096': [
      9.481324621155217, 47.835002794754935, 9.637923999965361, 47.90341282944259,
    ],
    '084370086086': [
      9.278216360104434, 47.881640695227205, 9.455590287564862, 48.0147759647761,
    ],
    '084375001031': [
      9.183436910614649, 48.21895341913569, 9.350969350714989, 48.28731820977394,
    ],
    '084375001047': [
      9.19113982264115, 48.15270462499528, 9.320539819703919, 48.23512166786841,
    ],
    '084375001082': [
      9.109919982823284, 48.20816262037949, 9.201383687672525, 48.27009307505985,
    ],
    '084375001114': [
      9.17304821051771, 48.147327614649015, 9.25609608760796, 48.21306161253513,
    ],
    '084375002053': [
      9.33542902250399, 47.98543746646831, 9.434163597649865, 48.06052173389284,
    ],
    '084375002076': [
      9.259507051389829, 47.997441032655985, 9.38590900625699, 48.0925978539164,
    ],
    '084375002101': [
      9.268375462356163, 48.047786729516766, 9.36462945302285, 48.11233468153103,
    ],
    '084375003072': [
      8.986812910263598, 47.98477460428863, 9.091561600330916, 48.08572029118193,
    ],
    '084375003078': [
      9.044335727346606, 47.954036911932775, 9.19279224853518, 48.06104906646781,
    ],
    '084375003123': [
      9.011360407757786, 47.910538127656885, 9.148727144040315, 47.99002823344354,
    ],
    '084375004056': [
      9.31613530578882, 47.81850484779296, 9.411157332731575, 47.900584172035046,
    ],
    '084375004088': [
      9.170286423520304, 47.85875705101768, 9.342880747698986, 47.98855475528329,
    ],
    '084375004118': [
      9.102706134753127, 47.88220952773662, 9.225293288160872, 47.980008528526156,
    ],
    '084375004124': [
      9.120125188716154, 47.8405484383601, 9.258158973102004, 47.90678958869494,
    ],
    '084375005044': [
      9.380439351417952, 48.01808212315271, 9.512580122934391, 48.102955429314086,
    ],
    '084375005100': [
      9.396355191800163, 47.957525072555285, 9.605230205401336, 48.06726085648837,
    ],
    '084375006005': [
      8.932492301398417, 48.029986830319274, 9.115187660456888, 48.109679928331666,
    ],
    '084375006008': [
      9.222372519499276, 48.086279505150344, 9.326297374965176, 48.157558277503604,
    ],
    '084375006059': [
      9.108387061302624, 48.02171608286009, 9.188904314967546, 48.08682488476917,
    ],
    '084375006065': [
      9.174529617253386, 47.97206755641061, 9.302810407310934, 48.04062451458465,
    ],
    '084375006104': [
      9.085073141780144, 48.02868779759413, 9.272807808106016, 48.15406253376381,
    ],
    '084375006105': [
      9.230301834470197, 48.052727519973686, 9.292484598312353, 48.090814191074884,
    ],
    '084375007102': [
      8.953498749845505, 48.08646160843678, 9.02700194681663, 48.1451692902705,
    ],
    '084375007107': [
      8.997673271835257, 48.089664328869624, 9.163597018977834, 48.1650136940832,
    ],
    '091610000000': [
      11.25586221537212, 48.684788306030065, 11.502950262903848, 48.820189476415834,
    ],
    '091620000000': [
      11.361018007447456, 48.06162333614268, 11.72294847561243, 48.248014839947125,
    ],
    '091630000000': [
      12.05831671113274, 47.81321815596717, 12.153284462263676, 47.88662039600643,
    ],
    '091710111111': [
      12.60763729200329, 48.20010984505509, 12.731496731106498, 48.25173311524721,
    ],
    '091710112112': [
      12.761250286343584, 48.12309740536668, 12.854072120278088, 48.20349550526194,
    ],
    '091710113113': [
      12.630693800994631, 48.101596795019475, 12.788722558777808, 48.197525335247725,
    ],
    '091710117117': [
      12.541996576909845, 48.10237415786524, 12.631520140186375, 48.16919414669889,
    ],
    '091710118118': [
      12.83279795010858, 48.17883256895348, 12.933452828229067, 48.248325145013396,
    ],
    '091710125125': [
      12.66278488766041, 48.214458713813116, 12.817351787196193, 48.26808114846731,
    ],
    '091710127127': [
      12.561338453537061, 48.28278884983674, 12.702099337662778, 48.352821587927714,
    ],
    '091710131131': [
      12.585950527324695, 48.218702422101174, 12.634742924406666, 48.24271567645846,
    ],
    '091710132132': [
      12.564681485541, 48.23907532577002, 12.62332679246411, 48.289212568243634,
    ],
    '091710133133': [
      12.575964824188096, 48.182867801692154, 12.659180425954611, 48.22772810957202,
    ],
    '091710137137': [
      12.611381411577598, 48.24924611635911, 12.720384399797156, 48.29371734195501,
    ],
    '091715101114': [
      12.728934282340848, 48.177832153477006, 12.802800837969421, 48.228231417169646,
    ],
    '091715101124': [
      12.750079932580547, 48.152236526748055, 12.833505714344126, 48.218767469914674,
    ],
    '091715102116': [
      12.567652099388658, 48.06428191275922, 12.63079187476405, 48.11268683861343,
    ],
    '091715102119': [
      12.649333508407727, 48.08913172828983, 12.719631851878539, 48.14291054615198,
    ],
    '091715102122': [
      12.613879373404856, 48.06500806249351, 12.677528248412477, 48.13703099081741,
    ],
    '091715102134': [
      12.615487769980307, 48.04495164992484, 12.709670705805175, 48.09465242611914,
    ],
    '091715103123': [
      12.793846954786675, 48.20349550526194, 12.904056051611537, 48.28931694369303,
    ],
    '091715103130': [
      12.84801097334181, 48.23620554525799, 12.902890531411627, 48.260545325412096,
    ],
    '091715104115': [
      12.725499044006973, 48.28167996467149, 12.851760482254903, 48.32656470479332,
    ],
    '091715104126': [
      12.720384399797156, 48.25520173203537, 12.807440623902274, 48.2928046645882,
    ],
    '091715104129': [
      12.682481270778435, 48.26332860992076, 12.75200899430383, 48.3311996183171,
    ],
    '091715106121': [
      12.639383617050775, 48.15339278887234, 12.737467484808006, 48.21786867353981,
    ],
    '091715106135': [
      12.577864656069705, 48.13846633335797, 12.663194022776647, 48.19440225623317,
    ],
    '091720111111': [
      12.873991439674208, 47.77983307164675, 12.978714081138085, 47.85134865427311,
    ],
    '091720112112': [
      12.763637731969409, 47.76253068190798, 12.907138983679555, 47.83274159657596,
    ],
    '091720114114': [
      12.795990544102743, 47.68076043511897, 12.944732041408956, 47.77126324299767,
    ],
    '091720115115': [
      12.88044159899601, 47.688188880703564, 12.930024843346523, 47.73825501216184,
    ],
    '091720116116': [
      12.976358360650122, 47.60216241017448, 13.088407631243879, 47.67282232165336,
    ],
    '091720117117': [
      12.884277388655109, 47.60977466696998, 13.000132459664579, 47.70959831887122,
    ],
    '091720118118': [
      12.94051005263166, 47.81910637686612, 13.003361188887025, 47.86846875811968,
    ],
    '091720122122': [
      12.850928840906725, 47.8944401401378, 12.965944876710086, 47.96241047510888,
    ],
    '091720124124': [
      13.001972405830623, 47.66225843045415, 13.079959871084998, 47.70945153921621,
    ],
    '091720128128': [
      12.835579874536913, 47.74482355794134, 12.939633248269228, 47.806703672889164,
    ],
    '091720129129': [
      12.77959093914186, 47.496917677961584, 12.960975375285358, 47.65856974676686,
    ],
    '091720130130': [
      12.874837330126057, 47.841697675636176, 12.987696313780992, 47.915218724108776,
    ],
    '091720131131': [
      12.702833417063323, 47.62694334176467, 12.896589397319948, 47.75558520154055,
    ],
    '091720132132': [
      12.908707330179295, 47.46439066047113, 13.071799298141539, 47.624027754034586,
    ],
    '091720134134': [
      12.728785489802418, 47.80436215241783, 12.911384821809113, 47.89203259582417,
    ],
    '091730111111': [
      11.398771619169318, 47.71727028964898, 11.499297511653666, 47.79090353923626,
    ],
    '091730112112': [
      11.531372407950801, 47.743617081813696, 11.610105861578246, 47.8293301367746,
    ],
    '091730118118': [
      11.472777815447325, 47.80578510438115, 11.66457087641977, 47.92475397725345,
    ],
    '091730120120': [
      11.430331664828916, 47.8778623282638, 11.605542949815923, 47.973159460202545,
    ],
    '091730123123': [
      11.359306752282938, 47.789568522783306, 11.453647166449922, 47.87091633307045,
    ],
    '091730124124': [
      11.55909958128206, 47.68013088139887, 11.670583623008666, 47.75717995031957,
    ],
    '091730126126': [
      11.409148273213718, 47.841978271019485, 11.517098583552972, 47.89926979211245,
    ],
    '091730130130': [
      11.388921784154206, 47.90834480940386, 11.466125296971331, 47.97848833818584,
    ],
    '091730131131': [
      11.289886106688556, 47.53043804472982, 11.539093643069826, 47.65396301555364,
    ],
    '091730134134': [
      11.405674394457646, 47.76969075746413, 11.523268136502528, 47.85532598923522,
    ],
    '091730135135': [
      11.330185120287924, 47.49508759174254, 11.679342894146659, 47.70940732883897,
    ],
    '091730137137': [
      11.325579097795993, 47.792564174439256, 11.418387402612858, 47.93358292641242,
    ],
    '091730145145': [
      11.466889694787948, 47.66193471453698, 11.560751121515475, 47.82769411596504,
    ],
    '091730147147': [
      11.401193908545231, 47.893838325873396, 11.45027165578748, 47.932363275111776,
    ],
    '091735107113': [
      11.344106049362576, 47.653380160445664, 11.482513781660044, 47.72465785515987,
    ],
    '091735107115': [
      11.372745922649916, 47.69701598344935, 11.484169360500395, 47.74148277234791,
    ],
    '091735108133': [
      11.262702684843525, 47.568501806611735, 11.432108968154582, 47.698311875960435,
    ],
    '091735108142': [
      11.271906307949033, 47.61362866093136, 11.348216972584597, 47.675946132357836,
    ],
    '091735109127': [
      11.5842415809676, 47.72767364064069, 11.629378687649751, 47.775848512605535,
    ],
    '091735109140': [
      11.598743785765336, 47.7316013399311, 11.662346692289388, 47.791388036717194,
    ],
    '091735109141': [
      11.598743785765336, 47.79010141605792, 11.664931411282547, 47.83200083867234,
    ],
    '091740111111': [
      11.164751652357474, 48.33849601309344, 11.331712896039377, 48.44087228519015,
    ],
    '091740113113': [
      11.276504616545862, 48.201403431250654, 11.433256162163106, 48.293688324339925,
    ],
    '091740115115': [
      11.384370117611489, 48.22949825246917, 11.501133871547404, 48.31081686616201,
    ],
    '091740118118': [
      11.223751609285458, 48.29978624011537, 11.333482414623157, 48.37375152250194,
    ],
    '091740121121': [
      11.506793508866828, 48.27852444064679, 11.57948063131674, 48.351569800084015,
    ],
    '091740122122': [
      11.419850044007354, 48.26242615048736, 11.531498939838729, 48.327463667014285,
    ],
    '091740126126': [
      11.427729734961215, 48.20665386832896, 11.501133871547404, 48.255239560705895,
    ],
    '091740131131': [
      11.28730169185041, 48.30610230226332, 11.426125779147156, 48.424607775536614,
    ],
    '091740135135': [
      11.157358801310759, 48.278921661948736, 11.257230217667388, 48.34732813143999,
    ],
    '091740136136': [
      11.421110890418099, 48.37712700391848, 11.53035289748325, 48.441034006781884,
    ],
    '091740137137': [
      11.110649132207032, 48.26711769794026, 11.186381911749713, 48.32634905070019,
    ],
    '091740141141': [
      11.398241802431654, 48.3025373364811, 11.520315832614699, 48.356832651257164,
    ],
    '091740143143': [
      11.28995928749299, 48.27677084254169, 11.404265757847385, 48.34704907972501,
    ],
    '091740146146': [
      11.215922948870816, 48.26241716931741, 11.305883079497624, 48.314801041489915,
    ],
    '091740147147': [
      11.257934260892473, 48.41044669373014, 11.388151867419342, 48.4549673505477,
    ],
    '091740150150': [
      11.420211463745076, 48.34442954908986, 11.52487562191531, 48.387401294877314,
    ],
    '091740151151': [
      11.380321698341984, 48.35473012040135, 11.454239757445007, 48.410617688784946,
    ],
    '091750111111': [
      11.82160952715535, 48.13101671040442, 11.88800276260344, 48.18161479565088,
    ],
    '091750115115': [
      11.916170774842142, 48.048388982671575, 12.046667534506428, 48.12422724148104,
    ],
    '091750118118': [
      11.881832063453869, 48.15544841429065, 11.939557338244827, 48.19979701067959,
    ],
    '091750122122': [
      11.928309375597744, 48.003306077422785, 12.025831204389505, 48.06633647657352,
    ],
    '091750123123': [
      11.939557338244827, 48.11744190542423, 12.050214699894688, 48.17438474934004,
    ],
    '091750124124': [
      11.833898502726964, 48.04635663464071, 11.92843803868125, 48.090281594064884,
    ],
    '091750127127': [
      11.836746381989386, 48.17352372471631, 11.890327909684551, 48.20987580938735,
    ],
    '091750132132': [
      11.747881855440257, 48.0882330865956, 11.844673505779653, 48.159712927425886,
    ],
    '091750133133': [
      11.755826553077492, 48.17456656455274, 11.847521501649362, 48.22675392596812,
    ],
    '091750135135': [
      11.769822853236251, 48.151830600054346, 11.840941681060055, 48.18594926314747,
    ],
    '091750137137': [
      11.993067547679, 48.04839184319669, 12.087948133971542, 48.13698046615223,
    ],
    '091750139139': [
      11.78203375850091, 48.04688805079733, 11.855295397644129, 48.11806190419281,
    ],
    '091755112112': [
      11.92217915877487, 47.95415063873401, 12.040372236442028, 48.02033900972109,
    ],
    '091755112119': [
      11.997832520239857, 48.00415017066881, 12.086632535153573, 48.06084083367274,
    ],
    '091755112136': [
      12.027658583246003, 47.97041515221307, 12.098263492916512, 48.017373274733394,
    ],
    '091755114113': [
      11.881233081612404, 47.93007376563099, 11.945939109190812, 48.00114757068925,
    ],
    '091755114114': [
      11.879693500910552, 48.000519580115395, 11.95415595717358, 48.05622434857241,
    ],
    '091755114116': [
      11.762122232139932, 47.96270608221037, 11.846787639554604, 48.02173465959412,
    ],
    '091755114121': [
      11.818990829820201, 47.947206634357464, 11.908287990543323, 48.01816786760673,
    ],
    '091755114128': [
      11.833898502726964, 48.008501546373324, 11.916170774842142, 48.06242523024526,
    ],
    '091755114131': [
      11.784283925847095, 48.00619794883963, 11.84841889513236, 48.05660976733864,
    ],
    '091760112112': [
      11.506737906582469, 48.85886996271743, 11.743662906621894, 48.95971127957769,
    ],
    '091760114114': [
      11.383495530079808, 48.95262623278753, 11.59423605973812, 49.08519009521668,
    ],
    '091760118118': [
      11.249646098066508, 48.78141576186472, 11.332474262552998, 48.859666063158905,
    ],
    '091760120120': [
      11.406175886693774, 48.88678041437981, 11.521303819122817, 48.96326069962248,
    ],
    '091760121121': [
      11.041224676597691, 48.83370665068329, 11.14458908786485, 48.90404348370694,
    ],
    '091760123123': [
      11.128536898390466, 48.85270932684664, 11.275419649561515, 48.92243044622489,
    ],
    '091760126126': [
      11.325545895611372, 48.7786226253322, 11.396730998990355, 48.84981406503989,
    ],
    '091760129129': [
      11.489610754242385, 48.733426641682286, 11.60309571977571, 48.83292148904793,
    ],
    '091760131131': [
      11.44304888247667, 48.81836835601157, 11.477090714138388, 48.83860870266542,
    ],
    '091760132132': [
      11.27247367811977, 48.83834218757605, 11.354945587737125, 48.91156812667917,
    ],
    '091760137137': [
      11.285926291142056, 48.96995538528551, 11.4707525375703, 49.03445138179648,
    ],
    '091760138138': [
      11.260555541208875, 48.86820400316196, 11.459005067404133, 48.991808493956675,
    ],
    '091760139139': [
      11.470309479964884, 48.787672631765616, 11.572020679178006, 48.89956143610735,
    ],
    '091760143143': [
      11.429434704370475, 48.79210467916728, 11.479905199491677, 48.83378420758965,
    ],
    '091760148148': [
      10.96177024240108, 48.82212024854249, 11.05312515776336, 48.887018200524096,
    ],
    '091760161161': [
      11.403018714424231, 48.83378420758965, 11.542697242093505, 48.90076413946082,
    ],
    '091760164164': [
      11.140718895569703, 48.959826449211555, 11.290381784829556, 49.05244657056051,
    ],
    '091760166166': [
      11.034096256833553, 48.79034206313228, 11.17300131805423, 48.84153008286877,
    ],
    '091760167167': [
      11.372984026692562, 48.81137763269939, 11.44304888247667, 48.86265022524495,
    ],
    '091765115155': [
      11.119103981788212, 48.908632338751836, 11.293456041240514, 48.969683995821256,
    ],
    '091765115160': [
      11.026655489181517, 48.88539637110072, 11.183308262453696, 48.96611207742942,
    ],
    '091765115165': [
      11.24749452609007, 48.877401670023445, 11.36881294482028, 48.94995464626036,
    ],
    '091765116116': [
      11.342244536221175, 48.84654728217463, 11.406912233339057, 48.89783981407805,
    ],
    '091765116124': [
      11.27210470405679, 48.7935776343842, 11.344656922163807, 48.859666063158905,
    ],
    '091765118111': [
      11.093415266542191, 48.80691925019787, 11.282688774645548, 48.882064010157414,
    ],
    '091765118122': [
      11.180273954490682, 48.77153849095048, 11.261175304083281, 48.800917676443504,
    ],
    '091765118149': [
      11.144319494775841, 48.78940245542818, 11.276815203620494, 48.83190030016629,
    ],
    '091765119147': [
      11.599319229954062, 48.823866297192026, 11.678775308457174, 48.886837867592156,
    ],
    '091765119150': [
      11.562395709041363, 48.81287626707618, 11.640793295863007, 48.864280465214016,
    ],
    '091765119153': [
      11.638623873862947, 48.774909321844525, 11.736367460494005, 48.8741524845613,
    ],
    '091770113113': [
      11.937564850651572, 48.272377153321194, 12.05862749651458, 48.34430648413849,
    ],
    '091770115115': [
      12.070915032346347, 48.227658421016784, 12.254749364475234, 48.32554325394532,
    ],
    '091770117117': [
      11.862199193655094, 48.25328881319467, 11.959646887178987, 48.36827152552785,
    ],
    '091770118118': [
      11.748061858241453, 48.2057645250558, 11.856211634965048, 48.26645760290248,
    ],
    '091770119119': [
      11.925265207602076, 48.16359087671583, 12.028276110255163, 48.198075874416176,
    ],
    '091770120120': [
      11.933944697948574, 48.332287372400245, 12.065311050900714, 48.39143411210872,
    ],
    '091770123123': [
      12.002331067906125, 48.14194825031823, 12.113219520526526, 48.234921399124616,
    ],
    '091770127127': [
      12.004628959917895, 48.22829434693509, 12.098132602286194, 48.30045818755555,
    ],
    '091770130130': [
      11.73212052113023, 48.249470581113655, 11.885397766111392, 48.298908248495444,
    ],
    '091770137137': [
      12.083284495664351, 48.18445524309341, 12.231901754740276, 48.26038303293798,
    ],
    '091770139139': [
      12.045771965723842, 48.2936507754553, 12.248613791955927, 48.39855262758343,
    ],
    '091775120114': [
      11.963431792022044, 48.183063720950884, 12.03490835062588, 48.2426355281773,
    ],
    '091775120135': [
      11.905356389270054, 48.182274518743945, 11.981307476871859, 48.232252633923196,
    ],
    '091775121142': [
      11.93448965352425, 48.23829778570867, 12.01417220532792, 48.28081817272126,
    ],
    '091775121144': [
      11.871437474531303, 48.22438138926717, 11.97004477368313, 48.266536494572215,
    ],
    '091775123116': [
      11.808435932711216, 48.32919457796521, 11.902177730788246, 48.42345581684288,
    ],
    '091775123133': [
      11.764539696935607, 48.289481481883584, 11.892155727893572, 48.385780846253574,
    ],
    '091775124131': [
      11.780724899955738, 48.2202555071229, 11.876247285167139, 48.264450984848736,
    ],
    '091775124134': [
      11.8534488909596, 48.19339894654982, 11.917258431799368, 48.22647157127577,
    ],
    '091775125121': [
      12.089491894142123, 48.36435688955237, 12.172116445944544, 48.42534842153893,
    ],
    '091775125122': [
      12.041562845714697, 48.32456546986531, 12.1002813434506, 48.3647874438457,
    ],
    '091775125124': [
      12.02075230197463, 48.385257768331364, 12.106374522607773, 48.42902140430035,
    ],
    '091775125138': [
      12.047807261579985, 48.35038587086044, 12.119601301683277, 48.401662608641,
    ],
    '091775126112': [
      11.894597856059152, 48.36252243387415, 11.948773922755091, 48.42697537758201,
    ],
    '091775126126': [
      11.914126906549514, 48.40108947690901, 12.027034654011349, 48.455074354306404,
    ],
    '091775126143': [
      11.94663551855689, 48.37110081503509, 12.034941084580103, 48.414448718367716,
    ],
    '091780116116': [
      11.657716266612574, 48.509139064022676, 11.797512649243847, 48.59544323678571,
    ],
    '091780120120': [
      11.575799072959311, 48.27039935419459, 11.698677820091572, 48.3313282221615,
    ],
    '091780122122': [
      11.697334665302488, 48.56082376342491, 11.866380700207422, 48.61646805620655,
    ],
    '091780123123': [
      11.50428564972874, 48.32763739640626, 11.622396136326579, 48.39430123687123,
    ],
    '091780124124': [
      11.641208649370352, 48.33110688928416, 11.791823402326337, 48.44903316138427,
    ],
    '091780130130': [
      11.685064163315973, 48.271743840570224, 11.783507357454276, 48.359566446511245,
    ],
    '091780133133': [
      11.493018545628171, 48.389343171417266, 11.56467117943662, 48.46024618147595,
    ],
    '091780136136': [
      11.612639377605412, 48.42517775171298, 11.7193968525496, 48.498978444711746,
    ],
    '091780137137': [
      11.549734300632048, 48.3724318620352, 11.70099896856418, 48.44422831859478,
    ],
    '091780138138': [
      11.795823282971439, 48.412627065779546, 11.914126906549514, 48.4557687360157,
    ],
    '091780140140': [
      11.775457075389959, 48.366142460258736, 11.844857266242183, 48.439545373854884,
    ],
    '091780143143': [
      11.86721103403671, 48.42697537758201, 12.017495828145375, 48.49568645419161,
    ],
    '091780144144': [
      11.762664341675313, 48.50244275194831, 11.865776007573336, 48.562846955989436,
    ],
    '091780145145': [
      11.594393113629803, 48.29027473427035, 11.705384594236085, 48.374260005976154,
    ],
    '091785127113': [
      11.554459728476825, 48.3995580412869, 11.637577652715697, 48.468005182574416,
    ],
    '091785127150': [
      11.529230859561997, 48.45403058847606, 11.603642552901565, 48.490829003545755,
    ],
    '091785129125': [
      11.895560067602956, 48.52443308931731, 11.972188012979522, 48.586790311408386,
    ],
    '091785129132': [
      11.828160108356524, 48.52612347263556, 11.910617735570579, 48.58668689341094,
    ],
    '091785129142': [
      11.855312006487841, 48.493447831498976, 11.944710280695029, 48.57107882423962,
    ],
    '091785129155': [
      11.835245452398377, 48.47476951260247, 12.0093807466666, 48.53238225216648,
    ],
    '091785130115': [
      11.705424637468987, 48.480241659155496, 11.788546869776495, 48.5265562832367,
    ],
    '091785130129': [
      11.797442375713885, 48.447319315608446, 11.889256408698353, 48.4938164315429,
    ],
    '091785130156': [
      11.661433796312542, 48.46841359456869, 11.754164602750691, 48.52084853803562,
    ],
    '091785130157': [
      11.690698639560088, 48.43935405507844, 11.835958973212602, 48.512311921348385,
    ],
    '091790113113': [
      11.223446304516623, 48.12015333460728, 11.33105077793016, 48.16407928016589,
    ],
    '091790117117': [
      11.131828454705998, 48.21893044119073, 11.23228600135856, 48.296159568766434,
    ],
    '091790118118': [
      11.287589278282967, 48.15239357155646, 11.340123507514091, 48.1801184426157,
    ],
    '091790119119': [
      11.265063994964528, 48.160977432104595, 11.328839114063504, 48.19832400742471,
    ],
    '091790121121': [
      11.17299505126503, 48.1477507804786, 11.284407970657691, 48.20302395921189,
    ],
    '091790123123': [
      11.306038767994053, 48.10599653767901, 11.412625151752653, 48.1584562927068,
    ],
    '091790126126': [
      11.355356479837205, 48.17815193736308, 11.393102313489742, 48.206712560097685,
    ],
    '091790134134': [
      11.187042068586932, 48.19310351005269, 11.328705315828893, 48.27432289880309,
    ],
    '091790138138': [
      10.992859679652556, 48.12180059297178, 11.135866644900386, 48.19635742855226,
    ],
    '091790142142': [
      11.284407970657691, 48.178108862978185, 11.404353050930226, 48.235061498079645,
    ],
    '091790145145': [
      11.31733626981972, 48.13659002686306, 11.373810342390302, 48.18667064507994,
    ],
    '091790149149': [
      11.05558195513746, 48.08808219084441, 11.141458018231182, 48.13088306690569,
    ],
    '091795131111': [
      11.059207747434774, 48.167537306304474, 11.142862669211688, 48.213361803190644,
    ],
    '091795131114': [
      11.038985395502332, 48.20075815319812, 11.11683403377894, 48.25656678526422,
    ],
    '091795131128': [
      11.089158190701063, 48.20730010496243, 11.135290803454271, 48.23413038286138,
    ],
    '091795131130': [
      11.102852140423566, 48.138885891502134, 11.16855656764154, 48.194533736189264,
    ],
    '091795131132': [
      11.15205282401033, 48.13914144530022, 11.204840561442074, 48.18182086563101,
    ],
    '091795131136': [
      11.11683403377894, 48.17876454470737, 11.201087053572667, 48.23406239066611,
    ],
    '091795131137': [
      11.061993705772267, 48.23293545763541, 11.145898777052302, 48.28135651321127,
    ],
    '091795131140': [
      11.117139577751974, 48.2266639792719, 11.168293883709776, 48.26002832935955,
    ],
    '091795132125': [
      11.133212195025946, 48.09680267547682, 11.198627365790939, 48.14702562778282,
    ],
    '091795132131': [
      11.103098092920453, 48.10757678101343, 11.14993575751164, 48.13587235888959,
    ],
    '091795132147': [
      11.169283459596386, 48.11242090084909, 11.234230292041808, 48.156936430725274,
    ],
    '091800112112': [
      11.029635417040451, 47.630699448813445, 11.129129921731106, 47.69808405618429,
    ],
    '091800116116': [
      11.032808733372363, 47.512232658845925, 11.176902420885348, 47.55302165150764,
    ],
    '091800117117': [
      10.869507461069642, 47.393744508360136, 11.223565733130265, 47.54866723681043,
    ],
    '091800118118': [
      10.932879082239968, 47.41839398376731, 11.065273316614325, 47.48343945083007,
    ],
    '091800122122': [
      11.158290987637374, 47.443027963612586, 11.295725718285018, 47.54717108240765,
    ],
    '091800123123': [
      11.156745446883377, 47.39682464583908, 11.42086397812465, 47.53043804472982,
    ],
    '091800124124': [
      11.121815994606003, 47.62224952036017, 11.235772731856844, 47.712919106777356,
    ],
    '091800125125': [
      10.98500641949969, 47.575162657804455, 11.123293192288097, 47.630699448813445,
    ],
    '091800126126': [
      11.079425987888943, 47.54002434251325, 11.193299914748355, 47.58218598802993,
    ],
    '091800134134': [
      11.042324234880152, 47.679390972432714, 11.182247444370423, 47.73689654431121,
    ],
    '091800136136': [
      11.222601508179284, 47.50539402154748, 11.330185120287924, 47.58058455557805,
    ],
    '091805133113': [
      10.964683358698409, 47.6738314510624, 11.049355323229655, 47.71435962080594,
    ],
    '091805133129': [
      10.915938036394552, 47.583292334100534, 11.05360807054704, 47.68996767254658,
    ],
    '091805135115': [
      10.952288049111665, 47.56053517975338, 11.118289356217492, 47.58400188889256,
    ],
    '091805135135': [
      10.983038705943308, 47.583292334100534, 11.078587339271806, 47.64346567954788,
    ],
    '091805136114': [
      11.114827305250513, 47.54602505967075, 11.263260593853747, 47.64128651428396,
    ],
    '091805136119': [
      11.24659951149812, 47.660974399052165, 11.348216972584597, 47.715477827214535,
    ],
    '091805136127': [
      11.178113046798009, 47.58751778952512, 11.288949185594598, 47.66866582251859,
    ],
    '091805136131': [
      11.078587339271806, 47.59215384958144, 11.167303123090727, 47.659606286412206,
    ],
    '091805137128': [
      11.222472457788411, 47.66797096948146, 11.291508597692658, 47.72474173903067,
    ],
    '091805137132': [
      11.124862149651294, 47.672118964652334, 11.203453192932427, 47.71490555807323,
    ],
    '091805137133': [
      11.182247444370423, 47.69864354205427, 11.229473179624362, 47.73342489069371,
    ],
    '091810113113': [
      10.749746709036467, 47.84273611924596, 10.917827462141187, 47.935918030035246,
    ],
    '091810114114': [
      10.968028509973706, 47.89836951488368, 11.126372102999161, 48.00048205690221,
    ],
    '091810116116': [
      10.948458558026347, 48.15626643886268, 11.03710671813993, 48.20989114307363,
    ],
    '091810122122': [
      10.945374509370863, 48.10279208611305, 11.068314974894657, 48.17304154528829,
    ],
    '091810128128': [
      10.846484543240104, 48.069350404133544, 10.897082323498635, 48.13386561542812,
    ],
    '091810130130': [
      10.808213326366156, 47.99080397030188, 10.923594681352254, 48.07842416864578,
    ],
    '091810132132': [
      10.886116181797272, 48.040462208907904, 10.98970690083632, 48.119811884494894,
    ],
    '091810144144': [
      11.036164021770013, 47.98665000292266, 11.097471049257901, 48.042447003837665,
    ],
    '091810145145': [
      10.882147615294436, 48.08489850685952, 11.021546612637506, 48.167957586886864,
    ],
    '091815138121': [
      10.771944653159128, 47.88413598772397, 10.881491939713019, 47.97946869439667,
    ],
    '091815138143': [
      10.807188153416545, 47.95877841096449, 10.881250413500215, 47.99703202841835,
    ],
    '091815139126': [
      10.789683798495112, 48.10068639893545, 10.857378723290378, 48.13892934548965,
    ],
    '091815139127': [
      10.756589211292612, 48.03413066993992, 10.851608615858728, 48.10203348207778,
    ],
    '091815139131': [
      10.786498389110816, 48.13234092042149, 10.867533697554796, 48.15851846642118,
    ],
    '091815140134': [
      10.890480230242495, 48.1602587804191, 10.96093733666011, 48.2372252978723,
    ],
    '091815140138': [
      10.855456136735167, 48.12305669689208, 10.919863443444878, 48.192361145980755,
    ],
    '091815141124': [
      10.9285294500861, 47.9811888573694, 11.011050986789343, 48.02609920761115,
    ],
    '091815141140': [
      10.90558518809423, 48.02249819049119, 10.972247794660822, 48.06401379825084,
    ],
    '091815141141': [
      10.87989817099765, 47.97505103776876, 10.978700918186115, 48.0342834072152,
    ],
    '091815142111': [
      10.917827462141187, 47.8620971790039, 10.983323491476057, 47.91702480602906,
    ],
    '091815142129': [
      10.86817912753219, 47.85811227604955, 10.934008828841986, 47.90013583430886,
    ],
    '091815142133': [
      10.86446613093919, 47.93296575153737, 10.979518388715176, 47.98577969750755,
    ],
    '091815142135': [
      10.881747362361896, 47.90013583430886, 11.007591779308203, 47.95189750721379,
    ],
    '091815142137': [
      10.948668728552617, 47.87373696333634, 11.021730467274793, 47.93059377460305,
    ],
    '091815142142': [
      10.93018756873045, 47.95888800776965, 10.99647350195925, 47.988885915820624,
    ],
    '091815143115': [
      11.097912529116375, 48.06374423234422, 11.135673284152253, 48.09712560245066,
    ],
    '091815143123': [
      11.051998858507732, 48.06164854510809, 11.100609491961187, 48.09722450397075,
    ],
    '091815143139': [
      11.06355045809733, 48.03435231319898, 11.105836699710036, 48.069184360099285,
    ],
    '091815144118': [
      10.99852244335274, 48.07452843594234, 11.08219728605241, 48.1053704877861,
    ],
    '091815144120': [
      10.969556413146888, 47.98931901310441, 11.053646320087967, 48.05062687985561,
    ],
    '091815144146': [
      10.977749969560877, 48.03527966731237, 11.072543258326437, 48.08677951187971,
    ],
    '091820111111': [
      11.64389202379672, 47.66268802616602, 11.740508397667845, 47.74824598280702,
    ],
    '091820112112': [
      11.918622550001578, 47.611174339706224, 12.060810677166813, 47.70746292454756,
    ],
    '091820114114': [
      11.884616887647612, 47.67169170106413, 12.021890252693122, 47.7864379010612,
    ],
    '091820116116': [
      11.67127296104537, 47.72079276776026, 11.796040706388808, 47.78759658640637,
    ],
    '091820119119': [
      11.786136584044442, 47.72827940439049, 11.892563548275712, 47.77910077983964,
    ],
    '091820120120': [
      11.610455474175954, 47.8227901607088, 11.743951162480963, 47.918383589818035,
    ],
    '091820123123': [
      11.831889520471993, 47.77423976753942, 11.957808852207181, 47.86361140648653,
    ],
    '091820124124': [
      11.598076700995637, 47.58134943235852, 11.854904686447643, 47.69993286928349,
    ],
    '091820125125': [
      11.77596336305239, 47.75847797744706, 11.902539848962055, 47.82480584543469,
    ],
    '091820127127': [
      11.624560375026743, 47.886433546914965, 11.718391001752137, 47.938628290718654,
    ],
    '091820129129': [
      11.738948642900992, 47.60216139231373, 11.893880364629876, 47.70190119614399,
    ],
    '091820131131': [
      11.795851533776114, 47.60840004756257, 11.941243043639481, 47.75613041003847,
    ],
    '091820132132': [
      11.719152993541543, 47.68959423950625, 11.811892364194321, 47.74815684317774,
    ],
    '091820133133': [
      11.72056489944775, 47.83507884753635, 11.80531139129653, 47.94320954308786,
    ],
    '091820134134': [
      11.622429056180355, 47.71472095395462, 11.725094710643516, 47.82390004726976,
    ],
    '091820136136': [
      11.674906448968123, 47.77172843217626, 11.80040975308401, 47.86661043848503,
    ],
    '091820137137': [
      11.774116445035673, 47.80856859439346, 11.871884010129595, 47.92407441577247,
    ],
    '091830112112': [
      12.321115673759605, 48.223569529241026, 12.45636206893542, 48.29588149770509,
    ],
    '091830113113': [
      12.304898404281023, 48.169395281249066, 12.39474291950445, 48.223569529241026,
    ],
    '091830114114': [
      12.248613791955927, 48.28468106621234, 12.3690899731989, 48.33003151517109,
    ],
    '091830119119': [
      12.103094263451087, 48.130999998348216, 12.210216990437903, 48.1851494098474,
    ],
    '091830127127': [
      12.43169524175398, 48.23072189087518, 12.516043531841607, 48.31490429771951,
    ],
    '091830128128': [
      12.45636206893542, 48.21490099401807, 12.565973132511136, 48.2845962668506,
    ],
    '091830135135': [
      12.214992507946974, 48.19554280447386, 12.310308722267596, 48.27564924395602,
    ],
    '091830144144': [
      12.22232626469088, 48.24241320416808, 12.326171658909454, 48.2995010358075,
    ],
    '091830148148': [
      12.378845400966572, 48.167694572858395, 12.490871566564174, 48.22688345790862,
    ],
    '091835145120': [
      12.323319888303534, 48.21179993489558, 12.39474291950445, 48.265348372106494,
    ],
    '091835145138': [
      12.291030121894702, 48.20407829267719, 12.343284457580872, 48.27002134327078,
    ],
    '091835146118': [
      12.202650833655648, 48.127224630110476, 12.351195002656645, 48.192317789229904,
    ],
    '091835146147': [
      12.251381902203333, 48.10542915926685, 12.418464171689799, 48.15336182529917,
    ],
    '091835147123': [
      12.131938003493378, 48.1653205042605, 12.21886425364949, 48.21909166330122,
    ],
    '091835147140': [
      12.201738088071437, 48.15218094280066, 12.322188119784215, 48.220992393537,
    ],
    '091835148122': [
      12.349328017246735, 48.14604655660464, 12.401972080614955, 48.17930394674469,
    ],
    '091835148124': [
      12.393573222863438, 48.14425917041067, 12.497366984711004, 48.20980838556203,
    ],
    '091835148145': [
      12.396041527591398, 48.111295650247804, 12.49369862619986, 48.172296256607645,
    ],
    '091835149115': [
      12.425126606321385, 48.36487836894191, 12.480573481695236, 48.4168590873925,
    ],
    '091835149129': [
      12.444218331804645, 48.33215706703881, 12.582444779670395, 48.429451739162566,
    ],
    '091835150125': [
      12.419996878322028, 48.29020435760261, 12.481323190333356, 48.33530997715662,
    ],
    '091835150132': [
      12.325180485538384, 48.27668752348285, 12.42552266374579, 48.34632416905683,
    ],
    '091835150143': [
      12.374895782465988, 48.31768556584849, 12.471453175730671, 48.37278225683133,
    ],
    '091835150151': [
      12.399423337668653, 48.26657478765296, 12.463220883732191, 48.29603531154607,
    ],
    '091835151134': [
      12.475925989410023, 48.14499057870683, 12.55738524913757, 48.19217369325078,
    ],
    '091835151136': [
      12.472416866890644, 48.158976027936134, 12.60159900651825, 48.24200640173264,
    ],
    '091835152116': [
      12.540535396864918, 48.25653014524185, 12.599642821354808, 48.30198541609042,
    ],
    '091835152130': [
      12.47759727136321, 48.27958402886991, 12.569104876550321, 48.34460616462444,
    ],
    '091835152131': [
      12.510896175252835, 48.3080912232574, 12.611211815678788, 48.38656665884264,
    ],
    '091835183126': [
      12.033171166059331, 48.12219161554703, 12.154055124876876, 48.17256894469941,
    ],
    '091835183139': [
      12.124880639098219, 48.08378319139353, 12.210216990437903, 48.15494846632344,
    ],
    '091840112112': [
      11.6744604679461, 48.145476311380925, 11.755826553077492, 48.237896396613614,
    ],
    '091840113113': [
      11.459165445415945, 47.983637332334695, 11.508918555764414, 48.037315848251005,
    ],
    '091840114114': [
      11.626922425949182, 47.93712730779017, 11.743748166792445, 48.044706997751085,
    ],
    '091840118118': [
      11.70999102669868, 48.13264869316392, 11.758037585762313, 48.15749757284991,
    ],
    '091840119119': [
      11.596493622941752, 48.21704462967764, 11.685064163315973, 48.271743840570224,
    ],
    '091840120120': [
      11.40166418500564, 48.106783328936615, 11.463334000346213, 48.137414644145096,
    ],
    '091840121121': [
      11.719878933861445, 48.034342721845164, 11.807026331417788, 48.10835913314475,
    ],
    '091840122122': [
      11.508918555764414, 48.028087987784005, 11.557165064419333, 48.06989295362109,
    ],
    '091840123123': [
      11.693814640333821, 48.09748759904192, 11.759843990627825, 48.137445673862,
    ],
    '091840127127': [
      11.693910325948492, 47.99799007158065, 11.788120256894446, 48.040896191390196,
    ],
    '091840129129': [
      11.66581293412954, 48.03052169479652, 11.754047436261041, 48.06917805304285,
    ],
    '091840130130': [
      11.644741526810947, 48.20166630536048, 11.759309091832943, 48.27909670558688,
    ],
    '091840131131': [
      11.731790606013629, 48.14830489357671, 11.774134982952516, 48.221501723198315,
    ],
    '091840132132': [
      11.40323649304057, 48.052734886549516, 11.473042482102262, 48.10546752105582,
    ],
    '091840134134': [
      11.538325451237922, 47.96139253235318, 11.627884163502374, 48.042836944829226,
    ],
    '091840135135': [
      11.499868362521184, 48.21302564403554, 11.617815007421672, 48.280894011626515,
    ],
    '091840136136': [
      11.646339821359451, 48.0523267407655, 11.695215817980513, 48.07501504499408,
    ],
    '091840137137': [
      11.708172620244895, 47.91664422079971, 11.853046231795949, 48.01454966463966,
    ],
    '091840138138': [
      11.385186421145466, 48.07846524965729, 11.463334000346213, 48.120643375563915,
    ],
    '091840139139': [
      11.497140058545712, 48.035210635247815, 11.546794990791717, 48.0775654817526,
    ],
    '091840140140': [
      11.683581387811047, 48.06529516245443, 11.731902992033062, 48.10490554482613,
    ],
    '091840141141': [
      11.565143194170064, 47.920424544261664, 11.698495476118255, 48.005988135855894,
    ],
    '091840142142': [
      11.4067179045863, 47.964682486311986, 11.473405291831346, 48.01311294771649,
    ],
    '091840144144': [
      11.471779020950555, 47.94917431981917, 11.568491874669931, 48.01270267133451,
    ],
    '091840145145': [
      11.589922395238261, 48.005866360355455, 11.675741523082353, 48.05462310237229,
    ],
    '091840146146': [
      11.602343316993135, 48.068883255400564, 11.69117901888182, 48.08688584047977,
    ],
    '091840147147': [
      11.626179608305936, 48.17351500916766, 11.696728390623006, 48.20715362012911,
    ],
    '091840148148': [
      11.589199505430852, 48.05410082605915, 11.646466993263239, 48.08688584047977,
    ],
    '091840149149': [
      11.513778539737316, 48.25506620339457, 11.596493622941752, 48.30066220948215,
    ],
    '091850113113': [
      11.24196922635729, 48.48272183202797, 11.341264960371165, 48.55124103638265,
    ],
    '091850125125': [
      10.981110329590152, 48.64672769524776, 11.102988534771546, 48.72949591226573,
    ],
    '091850127127': [
      11.022947485614818, 48.594223032008784, 11.173044753344234, 48.67508731872054,
    ],
    '091850139139': [
      11.244460474571014, 48.64971557037522, 11.344806505560728, 48.70426146725232,
    ],
    '091850140140': [
      11.338386583236826, 48.634239765482434, 11.45712650121554, 48.70376456408811,
    ],
    '091850149149': [
      11.1047893209892, 48.68821573368195, 11.303626752527514, 48.79640967991888,
    ],
    '091850150150': [
      11.054940111199265, 48.65977712940208, 11.181076685966005, 48.74035903118392,
    ],
    '091850153153': [
      10.95165625829136, 48.72165575028691, 11.144319494775841, 48.82280947322561,
    ],
    '091850158158': [
      11.127854176444838, 48.529975907624596, 11.317695200383097, 48.62836142026238,
    ],
    '091850163163': [
      11.122154958710725, 48.58964931568147, 11.254144682469116, 48.70725756817305,
    ],
    '091850168168': [
      11.280645877320698, 48.681051780603326, 11.376628308107547, 48.74808333892103,
    ],
    '091855154118': [
      11.160941031679066, 48.732730296618165, 11.304833839978084, 48.79766829119015,
    ],
    '091855154157': [
      11.125166423415672, 48.66486825374416, 11.20943385541783, 48.7106113406705,
    ],
    '091855155116': [
      11.202394708323515, 48.61351316569427, 11.30665891880405, 48.66036756614142,
    ],
    '091855155123': [
      11.281306584882845, 48.60533206141254, 11.383956696806136, 48.66986956406996,
    ],
    '091855155131': [
      11.202232314896944, 48.464129504603356, 11.302766505297463, 48.54893650804829,
    ],
    '091855155143': [
      11.16113453683097, 48.58350929895896, 11.260619706689148, 48.63268107235169,
    ],
    '091855155166': [
      11.297572344356619, 48.534815743096125, 11.385008017946003, 48.61244967156027,
    ],
    '091860113113': [
      11.433744132366233, 48.65979492051536, 11.510414541177637, 48.69984458614415,
    ],
    '091860125125': [
      11.295397321664224, 48.44294974902533, 11.418808017722332, 48.54247604544487,
    ],
    '091860128128': [
      11.33602389502045, 48.53540457221211, 11.458551309803207, 48.64305262892851,
    ],
    '091860132132': [
      11.35905207901049, 48.40638668699018, 11.449341148200395, 48.46665546169632,
    ],
    '091860137137': [
      11.431655564654672, 48.68299248273452, 11.565026745347605, 48.74978691251443,
    ],
    '091860139139': [
      11.636748814734222, 48.74290760463323, 11.723647925171873, 48.79360127094639,
    ],
    '091860143143': [
      11.38519033958162, 48.508485264598406, 11.58732499677182, 48.594877077814985,
    ],
    '091860146146': [
      11.416570368128209, 48.432650353024826, 11.534844608422844, 48.474263120632415,
    ],
    '091860149149': [
      11.490527869158766, 48.585206257845506, 11.58577030659956, 48.64725381270164,
    ],
    '091860151151': [
      11.383426818555064, 48.46114757297954, 11.485306592933895, 48.539514766086114,
    ],
    '091860152152': [
      11.564558496896, 48.4629956096284, 11.663194892539975, 48.56125354238709,
    ],
    '091860158158': [
      11.555721712141242, 48.720363882676146, 11.668652553573134, 48.8153088642119,
    ],
    '091860162162': [
      11.548396153955373, 48.54152908525575, 11.707634695896136, 48.66568776290784,
    ],
    '091865156116': [
      11.538449637477706, 48.708669552228024, 11.599905060003438, 48.74235173045854,
    ],
    '091865156122': [
      11.539601950681666, 48.63040319843695, 11.711444224244998, 48.74897187065655,
    ],
    '091865157126': [
      11.482778298726547, 48.482271197326966, 11.575157557653938, 48.521742497193316,
    ],
    '091865157130': [
      11.455593307961973, 48.468191841044586, 11.548877737961387, 48.494986170640324,
    ],
    '091865158144': [
      11.425036249680112, 48.58224284128409, 11.503815775921085, 48.644142833899785,
    ],
    '091865158147': [
      11.42697238913944, 48.62407258341025, 11.548009006053197, 48.69711554805204,
    ],
    '091870113113': [
      12.261049119891451, 47.96420852823997, 12.35729717529371, 48.05744737606535,
    ],
    '091870114114': [
      12.241316684341367, 47.67914520700144, 12.378269568213309, 47.80764463266684,
    ],
    '091870116116': [
      12.21668644427905, 48.045015288630815, 12.386573965571573, 48.12816341580163,
    ],
    '091870117117': [
      11.946465164667725, 47.81930430850419, 12.057318689703177, 47.91135167784662,
    ],
    '091870118118': [
      12.312583425206052, 47.77939046102085, 12.433469105596469, 47.83664108999985,
    ],
    '091870120120': [
      12.010702546924852, 47.699939020849705, 12.131588185049585, 47.75918589285918,
    ],
    '091870122122': [
      11.878023981592225, 47.842672902729014, 11.980794414187987, 47.94350047664648,
    ],
    '091870124124': [
      12.110771664682074, 48.02184261954015, 12.177937998978818, 48.08906865461362,
    ],
    '091870125125': [
      12.343417826407624, 47.900615598203785, 12.441295917781842, 47.95930428160699,
    ],
    '091870126126': [
      12.191225202377609, 47.995986540782276, 12.310880355847809, 48.062449165934474,
    ],
    '091870128128': [
      12.233301279132915, 47.86596194855976, 12.362966593796346, 47.93885741181554,
    ],
    '091870129129': [
      11.916934457131193, 47.73610258628121, 12.067438186832804, 47.83423488481307,
    ],
    '091870130130': [
      11.80482158157155, 47.862994853062986, 11.927689464279467, 47.95690214485634,
    ],
    '091870131131': [
      12.04635884963969, 47.68105503961668, 12.16689374694879, 47.74491557846135,
    ],
    '091870132132': [
      12.235823322714644, 47.74718204315169, 12.340366177062558, 47.83735773344369,
    ],
    '091870134134': [
      12.150034570871695, 47.95894532701873, 12.243668669567292, 48.02862331412342,
    ],
    '091870137137': [
      12.03023079828603, 47.86581440279299, 12.103572718034416, 47.937752552064524,
    ],
    '091870142142': [
      12.082097833060967, 47.881988920381026, 12.155299857225128, 47.9690212010655,
    ],
    '091870148148': [
      12.029444237852386, 47.60265977845276, 12.206998437749995, 47.65560340347307,
    ],
    '091870150150': [
      12.002077979032864, 47.818370046115206, 12.07918535907572, 47.86600467753078,
    ],
    '091870154154': [
      12.124632505315946, 47.758228910701014, 12.186034238857708, 47.80440292458683,
    ],
    '091870156156': [
      12.130752961781184, 47.700529727071206, 12.229376234965837, 47.75918589285918,
    ],
    '091870157157': [
      12.021718478253742, 47.624980650795976, 12.203902769308936, 47.70090936357153,
    ],
    '091870162162': [
      12.28179511198815, 47.82577322772143, 12.376803039384386, 47.873492162176014,
    ],
    '091870163163': [
      12.139093964793341, 47.86832658740192, 12.238551881066337, 47.911421299670714,
    ],
    '091870165165': [
      12.020442397038975, 47.73950346652919, 12.146142078397203, 47.81930430850419,
    ],
    '091870167167': [
      12.170519284665108, 47.80976957184085, 12.2924839658157, 47.874704569634105,
    ],
    '091870168168': [
      12.279856069264389, 47.85211557481733, 12.374808092176513, 47.89946148917911,
    ],
    '091870169169': [
      12.13079588086722, 47.77953135897856, 12.25125298363098, 47.839022899573095,
    ],
    '091870172172': [
      12.14827656298383, 47.71846716750378, 12.25806504408423, 47.790669723892634,
    ],
    '091870174174': [
      12.195904681536597, 47.8811164910931, 12.266528656410033, 47.95799315981713,
    ],
    '091870176176': [
      12.164280665202448, 48.06725987080603, 12.271922026286777, 48.14306679666742,
    ],
    '091870177177': [
      12.136596046142202, 47.836504948356854, 12.248332032660432, 47.89600467715025,
    ],
    '091870179179': [
      11.926258220171022, 47.89099324411333, 12.090468526775176, 47.994365731496465,
    ],
    '091870181181': [
      12.132090342430145, 47.89484753079668, 12.23154195661646, 47.97403772310831,
    ],
    '091870182182': [
      12.167257226044622, 48.02184261954015, 12.251393816104763, 48.076837285627526,
    ],
    '091875160121': [
      12.352362805560997, 47.87896186473119, 12.409340618925969, 47.91100223315642,
    ],
    '091875160123': [
      12.384695988435206, 47.85404232540665, 12.417278535231421, 47.87046944125054,
    ],
    '091875160138': [
      12.393032346599183, 47.87478870717688, 12.44448018571716, 47.9282971433289,
    ],
    '091875162139': [
      12.229435668406403, 47.91995738050318, 12.303542982710924, 47.98028045227988,
    ],
    '091875162145': [
      12.286613826040416, 47.92317903380406, 12.351260732583492, 47.970169524751725,
    ],
    '091875162173': [
      12.213784608306186, 47.97002054405385, 12.2817556582423, 48.00900643388854,
    ],
    '091875165164': [
      12.119330814372665, 47.99769244266673, 12.175649845667236, 48.032320054888025,
    ],
    '091875165170': [
      12.097808141996964, 47.960733751289084, 12.161270882915248, 48.015621544137495,
    ],
    '091875184159': [
      12.063080555912725, 48.011424144706154, 12.159492966326708, 48.099369033654064,
    ],
    '091875184186': [
      12.074249646818979, 48.08155612791345, 12.149874968044498, 48.131276996476856,
    ],
    '091880113113': [
      11.333018264099579, 47.9178625027044, 11.428714779370106, 47.998381053801864,
    ],
    '091880117117': [
      11.151883559201474, 47.9222832058899, 11.245562364515596, 48.02282402399235,
    ],
    '091880118118': [
      11.260070480133729, 47.91906259947628, 11.309683582673445, 47.97048796925788,
    ],
    '091880120120': [
      11.275539587294439, 48.029270998095626, 11.419733382650763, 48.10073207479768,
    ],
    '091880121121': [
      11.21054720539064, 48.08951997068146, 11.348120613547488, 48.135194952578885,
    ],
    '091880124124': [
      11.130035830301523, 47.95749901753426, 11.211133143281401, 48.04490028247235,
    ],
    '091880126126': [
      11.12953159615765, 48.03265961657006, 11.185995448664288, 48.10881631543388,
    ],
    '091880127127': [
      11.313565357855305, 48.069690273071735, 11.421137865045354, 48.1135057196334,
    ],
    '091880132132': [
      11.164889663505848, 47.99784665232492, 11.280734509009354, 48.076301385691195,
    ],
    '091880137137': [
      11.232724857094961, 47.95126554570471, 11.331771959617033, 47.99880041478488,
    ],
    '091880139139': [
      11.224728095909295, 47.973548092225975, 11.432113061075675, 48.0393177158281,
    ],
    '091880141141': [
      11.186102406854838, 47.87514864220437, 11.290323985124687, 47.9580361746312,
    ],
    '091880144144': [
      11.219603856562214, 48.04162508285697, 11.294999021024056, 48.10164533217417,
    ],
    '091880145145': [
      11.167626659186553, 48.04925868821695, 11.234867789501168, 48.11599056833573,
    ],
    '091890111111': [
      12.446970850315388, 47.9688541768176, 12.546264799374148, 48.02801702682451,
    ],
    '091890114114': [
      12.490381611386915, 47.86458785710171, 12.583910070202894, 47.95442001027868,
    ],
    '091890115115': [
      12.466322494589368, 48.0962471801465, 12.575626607993604, 48.16403260959493,
    ],
    '091890118118': [
      12.771409695142726, 47.949015773770554, 12.87581626417937, 48.04342768752791,
    ],
    '091890119119': [
      12.499316086192346, 47.79891318948884, 12.610545874561566, 47.89376341580596,
    ],
    '091890120120': [
      12.375372812675169, 47.75101652801193, 12.48977491052814, 47.82045361342801,
    ],
    '091890124124': [
      12.710824108741134, 47.734418707561176, 12.848779428221928, 47.81018032016322,
    ],
    '091890127127': [
      12.754844344943896, 47.92349308615527, 12.875674245592494, 47.9746393122306,
    ],
    '091890130130': [
      12.54278319926327, 47.890315710481865, 12.63546406480013, 47.938156637403814,
    ],
    '091890134134': [
      12.59831134002755, 47.95696613305474, 12.703570032180552, 48.04939178195622,
    ],
    '091890135135': [
      12.769119596229515, 47.87804449797688, 12.884731368392607, 47.93713742643507,
    ],
    '091890139139': [
      12.441021822288983, 47.62527116225093, 12.60504027701592, 47.70944775033374,
    ],
    '091890140140': [
      12.51228467514022, 47.670340603567524, 12.723967527010494, 47.79416016581924,
    ],
    '091890141141': [
      12.332260455659133, 47.684054136540645, 12.449233494348206, 47.754298182353686,
    ],
    '091890142142': [
      12.32372216912666, 48.0339617049811, 12.449591936085822, 48.13107574184308,
    ],
    '091890143143': [
      12.40597728904747, 47.91686588094185, 12.531336904712964, 47.998381374453906,
    ],
    '091890145145': [
      12.599200307817021, 47.76793007195255, 12.74307879214081, 47.84680910935809,
    ],
    '091890148148': [
      12.649780503060727, 47.8398224592863, 12.745471640383595, 47.89390580268139,
    ],
    '091890149149': [
      12.436020444222702, 48.043278354631504, 12.58287284919733, 48.11848979811421,
    ],
    '091890152152': [
      12.68137717641089, 47.986599003790694, 12.807659820119323, 48.11272299831493,
    ],
    '091890154154': [
      12.530858005589206, 47.922317369871635, 12.664255837750419, 47.99614456332391,
    ],
    '091890155155': [
      12.581177061395364, 47.83417962251974, 12.696352711291736, 47.9371760436556,
    ],
    '091890157157': [
      12.49913672661361, 47.98641227722071, 12.618536367489211, 48.070035547659714,
    ],
    '091890159159': [
      12.427745758722352, 47.79474872687554, 12.517120139298019, 47.86154343590874,
    ],
    '091890160160': [
      12.408090156545537, 47.68957690470432, 12.530852005991571, 47.75230130577873,
    ],
    '091895166113': [
      12.523479607261718, 47.75517982105471, 12.628252234761515, 47.83465619194673,
    ],
    '091895166161': [
      12.565833751180065, 47.82835827512392, 12.631351899846477, 47.860434437920894,
    ],
    '091895169129': [
      12.404947718668687, 47.743519837009636, 12.498608020704273, 47.77054402950519,
    ],
    '091895169146': [
      12.47120280878837, 47.75203506046147, 12.542981556618619, 47.80493175492666,
    ],
    '091895170126': [
      12.418686692015307, 48.01601512698231, 12.518210778226154, 48.06619588047806,
    ],
    '091895170133': [
      12.334238413784915, 47.97793872281403, 12.471091850354568, 48.05099847007496,
    ],
    '091895170137': [
      12.327163900216867, 47.94268986817403, 12.428270611893039, 48.00513038624842,
    ],
    '091895173150': [
      12.671239355368444, 47.946601085560516, 12.771799000301337, 48.013403028431895,
    ],
    '091895173162': [
      12.650959907282607, 47.88450095220435, 12.788603013469576, 47.98143468515384,
    ],
    '091895173165': [
      12.671849561496497, 47.879465802438716, 12.74781259068638, 47.92230380615524,
    ],
    '091900115115': [
      11.243353970661653, 47.84195786241392, 11.3015186818655, 47.88628606959568,
    ],
    '091900130130': [
      10.958484344633185, 47.77267470857278, 11.049015722791436, 47.83380250967893,
    ],
    '091900138138': [
      11.12056495871838, 47.885794671225796, 11.235816067162869, 47.95749901753426,
    ],
    '091900139139': [
      11.027997944888348, 47.76231948808341, 11.120389643949267, 47.83804462515876,
    ],
    '091900140140': [
      10.850742874468875, 47.735545444403016, 11.002372956791083, 47.88133872515019,
    ],
    '091900141141': [
      11.3361103903266, 47.72879927158478, 11.429393325782508, 47.799981393471185,
    ],
    '091900142142': [
      11.06324492927299, 47.774137467222815, 11.188390613615809, 47.84943053198113,
    ],
    '091900144144': [
      11.060286961976159, 47.88414919882145, 11.142287061759578, 47.928383472451216,
    ],
    '091900148148': [
      10.857679233899784, 47.78478877351574, 10.931859031143562, 47.84036653619926,
    ],
    '091900157157': [
      11.064237455272744, 47.7997146816668, 11.236458963566783, 47.88655589958754,
    ],
    '091900158158': [
      10.972857656828987, 47.812752264534964, 11.068593532290958, 47.908718646531796,
    ],
    '091900159159': [
      11.078678154972389, 47.84452031936461, 11.246535983162149, 47.897534373428186,
    ],
    '091905174111': [
      10.825521219889128, 47.77742234744413, 10.885915545490755, 47.86886954909692,
    ],
    '091905174129': [
      10.862962671883807, 47.83724769159428, 10.931081820614391, 47.87403054396346,
    ],
    '091905174133': [
      10.747663442191802, 47.785604474419664, 10.832379460362501, 47.829388888507836,
    ],
    '091905174149': [
      10.796252173652675, 47.80925803072618, 10.856574642924125, 47.83332819050508,
    ],
    '091905174151': [
      10.758383098967181, 47.824546863759096, 10.859613946845993, 47.86278639132297,
    ],
    '091905175114': [
      10.715835109796705, 47.68279899623829, 10.829759651960586, 47.7668405710328,
    ],
    '091905175118': [
      10.765589944567685, 47.74428238276953, 10.855914035921714, 47.79969668830272,
    ],
    '091905176113': [
      11.249256483734996, 47.73742588660287, 11.359996780459579, 47.78719999695036,
    ],
    '091905176126': [
      11.257752119166785, 47.70935874964508, 11.321844481022762, 47.748639850805056,
    ],
    '091905176136': [
      11.190371889364593, 47.71697082020591, 11.266438926382929, 47.7741060997551,
    ],
    '091905176153': [
      11.305517445953946, 47.693670524166485, 11.374335927090238, 47.74121937633251,
    ],
    '091905177120': [
      11.179377426545987, 47.76147608722717, 11.273068808552226, 47.81197749866945,
    ],
    '091905177121': [
      11.09225525249786, 47.714500380721944, 11.201670802888298, 47.765693325644236,
    ],
    '091905177131': [
      11.061683674408965, 47.72824085351693, 11.190371889364593, 47.78415647226037,
    ],
    '091905177135': [
      11.081733851034453, 47.753850650872884, 11.156116637565471, 47.79412550137135,
    ],
    '091905178117': [
      10.950211538183598, 47.716120594681946, 11.074378462990397, 47.778984926584435,
    ],
    '091905178145': [
      10.90851663459938, 47.69767578041983, 11.045194236424946, 47.76317835079199,
    ],
    '091905179132': [
      11.273068808552226, 47.76081923257925, 11.37817649254954, 47.81542862925089,
    ],
    '091905179152': [
      11.211152172086814, 47.78719999695036, 11.32628781080373, 47.85811918153309,
    ],
    '091905180143': [
      10.778063288455938, 47.65606213846127, 10.850211850947774, 47.70470940772616,
    ],
    '091905180154': [
      10.80246756035191, 47.65546634969804, 10.914555200261953, 47.77223211548142,
    ],
    '091905180160': [
      10.903613089423839, 47.616829390859785, 10.991234682483789, 47.72182456136323,
    ],
    '092610000000': [
      12.020547718821948, 48.508718569259194, 12.285688553739643, 48.59419553609071,
    ],
    '092620000000': [
      13.305140793305977, 48.54168976098804, 13.51368082283713, 48.61233058686633,
    ],
    '092630000000': [
      12.477566532316569, 48.84195570160681, 12.66794331951957, 48.922697391564256,
    ],
    '092710111111': [
      12.843219597509048, 48.704427729593384, 12.9366392961911, 48.76869898519944,
    ],
    '092710113113': [
      13.05510623835799, 48.7748542477271, 13.13772939856415, 48.836872794590086,
    ],
    '092710116116': [
      12.85508529280957, 48.87298776147219, 12.949283286831038, 48.95451998360111,
    ],
    '092710119119': [
      12.876588135346843, 48.78689177031566, 13.073100278589209, 48.90152783563342,
    ],
    '092710122122': [
      12.942140507721845, 48.86603953031018, 13.037721482595583, 48.95221781668291,
    ],
    '092710125125': [
      13.018393457869792, 48.732908804933224, 13.147145735602237, 48.82450129979805,
    ],
    '092710127127': [
      13.11016242897218, 48.699891440460156, 13.201270813275942, 48.74125700529455,
    ],
    '092710128128': [
      12.994260081299652, 48.61928695491113, 13.111079174764845, 48.6889744058092,
    ],
    '092710132132': [
      12.865585020393336, 48.83971769494321, 12.947887621891013, 48.87826765279784,
    ],
    '092710138138': [
      12.996751738302509, 48.74215491827456, 13.05279981868249, 48.79306280920825,
    ],
    '092710140140': [
      12.836837278838239, 48.83920856671494, 12.916876574183194, 48.897568412865404,
    ],
    '092710141141': [
      12.90353315388052, 48.59972212545348, 13.101992180016165, 48.775825298603046,
    ],
    '092710146146': [
      12.840754315964633, 48.754821358593674, 12.9678689357425, 48.81091125037011,
    ],
    '092710151151': [
      12.750088652898945, 48.78090437347071, 12.906280657738222, 48.84136654427558,
    ],
    '092710153153': [
      13.01636167712839, 48.68180599073913, 13.159833050458577, 48.7466919820245,
    ],
    '092715202123': [
      13.114884734310786, 48.77743034692623, 13.218577845037819, 48.834397993173106,
    ],
    '092715202126': [
      13.137970445454894, 48.8223155937885, 13.206392019260317, 48.86458595981023,
    ],
    '092715202130': [
      13.08577602605551, 48.82717680859433, 13.201960536978618, 48.88846127506442,
    ],
    '092715202148': [
      13.00927431241492, 48.820342590509355, 13.093740111491522, 48.8823715832226,
    ],
    '092715204139': [
      12.794448937691696, 48.67971333632608, 12.870244756129749, 48.73231692111398,
    ],
    '092715204143': [
      12.769225080889258, 48.72146497939054, 12.863540606477212, 48.78692690665019,
    ],
    '092715204152': [
      12.843588257400468, 48.66105128057804, 12.91201888430494, 48.71732673357392,
    ],
    '092715205118': [
      12.900805082518795, 48.675000579549966, 12.963710329067126, 48.72744968121463,
    ],
    '092715205135': [
      12.930849967987719, 48.72263210363643, 13.006466353281215, 48.80339528050992,
    ],
    '092715206114': [
      13.185237773051078, 48.699891440460156, 13.258559035082689, 48.760357349617585,
    ],
    '092715206149': [
      13.129292404530506, 48.738714259613644, 13.253858584469228, 48.814475220959814,
    ],
    '092720118118': [
      13.47713116315228, 48.77969577677975, 13.611697577535198, 48.88296401458422,
    ],
    '092720120120': [
      13.352732931319375, 48.78435299330321, 13.472320723841746, 48.902844801267236,
    ],
    '092720121121': [
      13.598665605686675, 48.761515953012925, 13.719560182688184, 48.83260330044248,
    ],
    '092720122122': [
      13.673964532898333, 48.78581034470804, 13.795367398198394, 48.8860695312704,
    ],
    '092720127127': [
      13.444192330104817, 48.80996983561847, 13.574764636187355, 48.89862558985575,
    ],
    '092720129129': [
      13.640547854133525, 48.68797284136885, 13.734284685681972, 48.77385613521333,
    ],
    '092720134134': [
      13.552254005336234, 48.85797922186728, 13.625226964477932, 48.94642564297137,
    ],
    '092720136136': [
      13.697885043740222, 48.710971133513645, 13.827074494076326, 48.7994306669403,
    ],
    '092720140140': [
      13.428765014070619, 48.78454753527791, 13.492341963295585, 48.83363655663438,
    ],
    '092720141141': [
      13.469122233995412, 48.7112766573294, 13.562928956027267, 48.7951193474138,
    ],
    '092720142142': [
      13.311005320281675, 48.74976777736181, 13.405027624504132, 48.80511724005694,
    ],
    '092720143143': [
      13.37082770831821, 48.87366538428652, 13.460704272749156, 48.98000859916321,
    ],
    '092720146146': [
      13.444623210939028, 48.86118270919012, 13.514464125855396, 48.94354245160342,
    ],
    '092720149149': [
      13.27899591444084, 48.86940894971034, 13.389173310540011, 48.98070698167282,
    ],
    '092720151151': [
      13.542257267460428, 48.68344352411755, 13.67566816068405, 48.79633104697745,
    ],
    '092725211116': [
      13.27789701097491, 48.85897178927045, 13.332424847402526, 48.92370551816996,
    ],
    '092725211128': [
      13.234759356663405, 48.81465285318535, 13.311391460050103, 48.87721158319068,
    ],
    '092725211145': [
      13.17011584725228, 48.81465285318535, 13.268774452656563, 48.86250231404447,
    ],
    '092725211147': [
      13.289271702201106, 48.79841348725143, 13.369285694432753, 48.881028272105205,
    ],
    '092725212126': [
      13.564466177588935, 48.800014243293234, 13.669447310073888, 48.85022104748647,
    ],
    '092725212139': [
      13.636511015377753, 48.85531629681988, 13.705999258060986, 48.91139745108942,
    ],
    '092725213150': [
      13.257976055053199, 48.73064056990043, 13.350906785641964, 48.818844298220974,
    ],
    '092725213152': [
      13.211453986248898, 48.74620269403614, 13.285399121601898, 48.823304251776364,
    ],
    '092725214119': [
      13.426653304612916, 48.714831852207496, 13.47323835987767, 48.758676419393296,
    ],
    '092725214138': [
      13.394971030423882, 48.745554040569594, 13.491375713045986, 48.81801688279429,
    ],
    '092730111111': [
      11.79253452603372, 48.77375366292774, 11.920904165686002, 48.88538590618431,
    ],
    '092730116116': [
      11.968771826684229, 48.86214380240696, 12.133315754808665, 48.96357045107274,
    ],
    '092730137137': [
      11.716885278123316, 48.8536957833837, 12.012783404046843, 48.964264578501336,
    ],
    '092730147147': [
      11.692069813403744, 48.599558389122116, 11.826541924812247, 48.69300627515945,
    ],
    '092730152152': [
      11.698366366874602, 48.75770177295238, 11.828286249428336, 48.910431074036424,
    ],
    '092730159159': [
      11.765229593930776, 48.9702562847867, 11.896229737959152, 49.019930026490634,
    ],
    '092730164164': [
      11.59423605973812, 48.91871245411747, 11.799893774329568, 49.02137279236522,
    ],
    '092730165165': [
      11.905741449710467, 48.72373724517502, 12.041144665027934, 48.824781437599064,
    ],
    '092735215121': [
      11.766335512976946, 48.91852329714286, 11.840421344357207, 48.972508725302255,
    ],
    '092735215133': [
      11.80690530113752, 48.92431814073523, 11.885143866431928, 48.97837824322877,
    ],
    '092735216166': [
      11.871702187273034, 48.8177350852555, 11.987119431962851, 48.91242200626635,
    ],
    '092735216175': [
      11.967396489174845, 48.87298823838701, 12.046894675283083, 48.90922733038335,
    ],
    '092735217125': [
      11.93850223743411, 48.80542743575583, 12.035161773705275, 48.87962120986084,
    ],
    '092735217127': [
      12.033504137298364, 48.74974423845627, 12.10372159200861, 48.819717794066996,
    ],
    '092735217141': [
      11.977200362735148, 48.775694960814285, 12.118234410582392, 48.87915799914919,
    ],
    '092735218119': [
      11.819411242047337, 48.764968170270514, 11.885524282670092, 48.80526741023162,
    ],
    '092735218139': [
      11.880451660532085, 48.737995128469805, 11.946607708036563, 48.79493606133497,
    ],
    '092735218172': [
      11.782997935994183, 48.708479240673014, 11.898729059956146, 48.77375366292774,
    ],
    '092735218177': [
      11.78477617361854, 48.708696289057656, 11.851914457767425, 48.74668973961528,
    ],
    '092735218181': [
      11.87994178717834, 48.70026755174471, 11.948531973451436, 48.75441675427632,
    ],
    '092735219113': [
      11.655302077166347, 48.64844191883769, 11.760713029826986, 48.720363882676146,
    ],
    '092735219115': [
      11.798584953465046, 48.63089104331157, 11.901111052625003, 48.685697940806136,
    ],
    '092735219163': [
      11.753677856049404, 48.677616793156844, 11.890053684712074, 48.72291385446044,
    ],
    '092735219178': [
      11.816906560921113, 48.57917890597988, 11.907427795770671, 48.63724453824298,
    ],
    '092740111111': [
      12.216864977251108, 48.50383145527382, 12.362474074519275, 48.58097634662656,
    ],
    '092740113113': [
      12.040031616577101, 48.53559636305707, 12.126425466670884, 48.58778286862476,
    ],
    '092740120120': [
      12.347814453382991, 48.34632416905683, 12.48374148604358, 48.45347452665616,
    ],
    '092740121121': [
      11.99492676705788, 48.41659677487687, 12.105709994292663, 48.47425414129987,
    ],
    '092740124124': [
      12.002217129853856, 48.45755453621185, 12.09375928657945, 48.51410503265576,
    ],
    '092740126126': [
      12.071294676504312, 48.549343718096594, 12.196489661178394, 48.62743238255534,
    ],
    '092740128128': [
      12.132472574475951, 48.56491519917975, 12.302507953970284, 48.674361492422136,
    ],
    '092740134134': [
      12.197534756345808, 48.410675722661146, 12.3417889228887, 48.51469274433407,
    ],
    '092740141141': [
      12.00822250336988, 48.61137259515981, 12.173983013288392, 48.706369420389876,
    ],
    '092740146146': [
      12.132970291756923, 48.46357300880989, 12.26863381286726, 48.53389791818257,
    ],
    '092740153153': [
      12.088660753542763, 48.69825904740301, 12.222844864084564, 48.768511325533126,
    ],
    '092740156156': [
      12.27466995993374, 48.54897948939386, 12.37350030939308, 48.63506090772499,
    ],
    '092740172172': [
      11.878680660436727, 48.61797734977919, 12.025645637933636, 48.72373724517502,
    ],
    '092740176176': [
      11.948531973451436, 48.66811411683513, 12.131977098429305, 48.77262765580028,
    ],
    '092740182182': [
      12.069979909166054, 48.46086548987722, 12.155930503345514, 48.52203588514969,
    ],
    '092740184184': [
      12.27578557394121, 48.383177407530034, 12.426330168835388, 48.493916193105285,
    ],
    '092740185185': [
      12.070660791493411, 48.4158822732039, 12.161039449199354, 48.472964716207464,
    ],
    '092740194194': [
      11.959476113303669, 48.49207117432333, 12.065761091028948, 48.5809682319473,
    ],
    '092745220119': [
      12.265239010347049, 48.67833873556289, 12.345137114312749, 48.7468623159693,
    ],
    '092745220127': [
      12.147005960131109, 48.65090295312073, 12.277839864829327, 48.72928185568557,
    ],
    '092745221132': [
      11.955544335438496, 48.57228313532658, 12.08652692565501, 48.604515208408586,
    ],
    '092745221165': [
      11.893753807282419, 48.573698432303225, 11.978817042834258, 48.62581792788148,
    ],
    '092745221187': [
      11.962458728067487, 48.59075654725401, 12.079330119476108, 48.64870979974206,
    ],
    '092745222174': [
      12.259451530467485, 48.62050346106285, 12.37023096669944, 48.693460989600226,
    ],
    '092745222188': [
      12.33277522542264, 48.64233193716913, 12.39909146788733, 48.6889399454046,
    ],
    '092745222191': [
      12.318899542393519, 48.61501235284386, 12.367414119053745, 48.63564572607039,
    ],
    '092745223112': [
      12.409696527398758, 48.4861736478929, 12.509379917206095, 48.56008237906375,
    ],
    '092745223135': [
      12.351008588009428, 48.47084525708459, 12.443709339557047, 48.52228269058811,
    ],
    '092745223145': [
      12.313020009213467, 48.49198098472205, 12.429069237789138, 48.57431475498077,
    ],
    '092745223179': [
      12.391744869419094, 48.45284458853269, 12.479348109166487, 48.501619008793675,
    ],
    '092745226114': [
      12.143528039800131, 48.423974580828194, 12.233957636446233, 48.472332117785726,
    ],
    '092745226118': [
      12.146735420259663, 48.3943179015698, 12.237504856315084, 48.43260360051512,
    ],
    '092745227154': [
      12.172116445944544, 48.363137470387024, 12.265332106501768, 48.423742031489304,
    ],
    '092745227183': [
      12.204063452140732, 48.3197552679989, 12.347814453382991, 48.420644704472814,
    ],
    '092745227193': [
      12.281710507542488, 48.317120817834045, 12.374895782465988, 48.383177407530034,
    ],
    '092750111111': [
      13.254412634053091, 48.65592197098913, 13.362925192177936, 48.70347993467135,
    ],
    '092750114114': [
      12.983917624596096, 48.55742711988573, 13.123871875089824, 48.62852188617837,
    ],
    '092750116116': [
      13.213066394708171, 48.29469946641553, 13.398886722887207, 48.38794998602266,
    ],
    '092750118118': [
      13.721655850269174, 48.660633551010356, 13.8369014860964, 48.724767430085365,
    ],
    '092750119119': [
      13.487850234744016, 48.64389479835028, 13.589792930257543, 48.71441476745027,
    ],
    '092750120120': [
      13.201270813275942, 48.68162491588954, 13.303982382499619, 48.74112980791715,
    ],
    '092750121121': [
      13.286566442660302, 48.68605151833458, 13.362802983361744, 48.74377001096366,
    ],
    '092750122122': [
      13.25525129275732, 48.45775128287657, 13.387869146642661, 48.591174740327986,
    ],
    '092750124124': [
      13.11627880772941, 48.40555754037705, 13.26884901426841, 48.53192910735902,
    ],
    '092750125125': [
      13.085050681798876, 48.469913546822355, 13.202737284817232, 48.53540188580815,
    ],
    '092750126126': [
      13.544462631538282, 48.59952840671415, 13.72148580076843, 48.692844698981375,
    ],
    '092750127127': [
      13.111079174764845, 48.651458547703974, 13.228540202169466, 48.7055254125355,
    ],
    '092750128128': [
      13.430120442663839, 48.64762959944172, 13.529859040270743, 48.72810272080096,
    ],
    '092750130130': [
      13.207310222164892, 48.32475174775896, 13.29791946712439, 48.36735838029279,
    ],
    '092750131131': [
      13.07978464460689, 48.34194153596108, 13.166832668054077, 48.39768542700158,
    ],
    '092750133133': [
      13.344973129212837, 48.478306593961655, 13.456864570380015, 48.55085791656739,
    ],
    '092750134134': [
      13.366348090645666, 48.40720192853612, 13.447122861960072, 48.49739818988955,
    ],
    '092750135135': [
      13.346505242734501, 48.66458336505859, 13.452021527021941, 48.7202898362368,
    ],
    '092750137137': [
      13.57078519545385, 48.545658608914515, 13.65506033081685, 48.5932398695491,
    ],
    '092750138138': [
      13.149286640783387, 48.50885077539358, 13.288144699992847, 48.6043229713373,
    ],
    '092750141141': [
      13.229068732396362, 48.360970668259135, 13.422992442816065, 48.438799242345425,
    ],
    '092750144144': [
      13.356442179925507, 48.643855199684744, 13.444804205293712, 48.676496311267826,
    ],
    '092750145145': [
      13.23433129733643, 48.42007750214069, 13.403733034755616, 48.51085891609645,
    ],
    '092750146146': [
      13.437593240138796, 48.59526495986625, 13.525807989628419, 48.6506888452903,
    ],
    '092750148148': [
      13.67566816068405, 48.64305070106042, 13.759557836929385, 48.68994365745848,
    ],
    '092750149149': [
      13.228026362080033, 48.40987397899691, 13.316573524169824, 48.46462616287395,
    ],
    '092750150150': [
      13.513147434112723, 48.56171222654835, 13.58443618501756, 48.65340524033508,
    ],
    '092750151151': [
      13.28974688712837, 48.60188992799054, 13.441398675286433, 48.67159169384781,
    ],
    '092750153153': [
      13.583494996744022, 48.512681055036786, 13.755204900989183, 48.63574718137668,
    ],
    '092750154154': [
      13.092600751165723, 48.57190782039049, 13.31877612197564, 48.68180599073913,
    ],
    '092750156156': [
      13.70614401024047, 48.55361030785463, 13.82521543101165, 48.67887976982582,
    ],
    '092750159159': [
      13.201684599387054, 48.60231873515646, 13.34025243624558, 48.68821444735113,
    ],
    '092755229152': [
      13.329628963755324, 48.70474610236042, 13.40785989726987, 48.7608787805591,
    ],
    '092755229160': [
      13.389883625984828, 48.69573133491846, 13.453811246694666, 48.75759989788741,
    ],
    '092755232112': [
      12.999672041459572, 48.532258410020575, 13.11161295270466, 48.57887227816764,
    ],
    '092755232117': [
      13.079423586564477, 48.5302193919924, 13.172620384452516, 48.57887227816764,
    ],
    '092755234132': [
      13.120696051235312, 48.29431879350547, 13.223754828770858, 48.35646301361196,
    ],
    '092755234143': [
      13.145207300614354, 48.343573170628005, 13.247192303368013, 48.416942485781604,
    ],
    '092760113113': [
      12.914833551346907, 49.10397000032762, 13.066037561626697, 49.166541238064795,
    ],
    '092760115115': [
      13.133346396781217, 49.0602614833031, 13.236076636892488, 49.17304261262152,
    ],
    '092760116116': [
      13.005411688656046, 48.881410477356894, 13.139517484313899, 48.95883679800642,
    ],
    '092760117117': [
      13.046926627853027, 49.03479334719658, 13.169506613915486, 49.119839731108065,
    ],
    '092760118118': [
      12.995864167322358, 49.00672648260852, 13.115947052591883, 49.0790392876513,
    ],
    '092760120120': [
      12.963708132731904, 49.06604203740877, 13.09803973518919, 49.14370609936298,
    ],
    '092760121121': [
      13.246990660978549, 48.94623151149335, 13.417333522051933, 49.01964120826256,
    ],
    '092760122122': [
      12.940372506490016, 49.01157509596252, 13.015098168354172, 49.07247166695426,
    ],
    '092760126126': [
      13.120235979049568, 48.859040209665956, 13.250584423114205, 48.93652822769548,
    ],
    '092760127127': [
      13.214720870724308, 48.873303524603465, 13.293310768221287, 48.960300829451384,
    ],
    '092760128128': [
      12.80583457482454, 48.991433105663916, 12.948666579529723, 49.076079336320134,
    ],
    '092760129129': [
      13.108021576177181, 48.99229919129664, 13.205811027547506, 49.068222051889755,
    ],
    '092760130130': [
      13.227804795539889, 49.00618800436577, 13.405582936203887, 49.12051885142322,
    ],
    '092760134134': [
      12.931984894912684, 48.97149419694061, 13.015360247601532, 49.02263094984217,
    ],
    '092760135135': [
      12.76284700947656, 49.055278510974205, 12.879032751337803, 49.13563252928614,
    ],
    '092760138138': [
      13.04750640159505, 48.92461588857552, 13.212046153228112, 49.00946340698991,
    ],
    '092760139139': [
      13.150294738100028, 48.918527195323485, 13.270929558784173, 48.980998378343486,
    ],
    '092760143143': [
      12.984674438960274, 48.98865602506513, 13.09777637646588, 49.04645215191954,
    ],
    '092760144144': [
      12.84168634189621, 49.044165946406764, 12.994905099897807, 49.13692740251808,
    ],
    '092760148148': [
      13.163572921407225, 48.97772563526509, 13.264976819329622, 49.072394467415506,
    ],
    '092765238111': [
      12.848548048162137, 48.93609278816719, 12.951851138180565, 49.009664898202246,
    ],
    '092765238123': [
      12.935271238541123, 48.92837345570427, 12.980774199358619, 48.974686482182825,
    ],
    '092765238142': [
      12.962143548549824, 48.96274995516268, 13.001835453688111, 49.00192090303231,
    ],
    '092765238146': [
      12.979585470619154, 48.94534223249262, 13.06761492777858, 49.00648951402979,
    ],
    '092770111111': [
      12.755381496079492, 48.50193678411567, 12.895768090597874, 48.60709869176082,
    ],
    '092770114114': [
      12.866489095991366, 48.46568710737379, 13.037886657006085, 48.532258410020575,
    ],
    '092770116116': [
      12.698606641341497, 48.37088291069853, 12.798937137229949, 48.444637181459186,
    ],
    '092770117117': [
      13.002872578125857, 48.48409793186869, 13.105535892242614, 48.55512318471833,
    ],
    '092770121121': [
      12.470703884666491, 48.39965613436416, 12.656956814145275, 48.52520309787467,
    ],
    '092770124124': [
      12.770494308251072, 48.37836339262025, 12.867728721011126, 48.486427797547854,
    ],
    '092770126126': [
      12.88994013958074, 48.511031800621936, 13.023125685747184, 48.58084781867107,
    ],
    '092770127127': [
      12.895499683112892, 48.23764227482306, 12.968429728225297, 48.27276090770025,
    ],
    '092770128128': [
      12.892282595048018, 48.20689465727372, 13.01280846598677, 48.280241983704215,
    ],
    '092770134134': [
      12.687591409705185, 48.32071405006049, 12.779298547220817, 48.38089183657963,
    ],
    '092770138138': [
      12.898485451577402, 48.39220243418787, 13.011275819381265, 48.48483022953726,
    ],
    '092770139139': [
      12.839092289666397, 48.37995432634914, 12.946857929644477, 48.47704184463694,
    ],
    '092770142142': [
      12.868810974029467, 48.540591647235836, 12.994277891819753, 48.6161257035157,
    ],
    '092770144144': [
      12.781114033064695, 48.45823811357199, 12.891532720636414, 48.52821222716761,
    ],
    '092770145145': [
      12.941728463772025, 48.252953635670586, 13.082103587141614, 48.31997808868595,
    ],
    '092770149149': [
      12.919061814158269, 48.34630573649128, 13.092429011292024, 48.44352222527527,
    ],
    '092770151151': [
      12.632663196463646, 48.35340859506253, 12.710871867461558, 48.43613448272973,
    ],
    '092770152152': [
      12.94968392473669, 48.309678926313644, 13.074946509550852, 48.37436135535864,
    ],
    '092770153153': [
      12.737615413551039, 48.31317036972669, 12.87658143831363, 48.389146349719894,
    ],
    '092770154154': [
      12.822469583856831, 48.26373560505133, 12.919060614908371, 48.34017960783858,
    ],
    '092775239119': [
      12.669117158209703, 48.41181892663779, 12.79321997492706, 48.52328016788235,
    ],
    '092775239131': [
      12.717641535357899, 48.502890623942854, 12.77112618319003, 48.54742505558276,
    ],
    '092775239141': [
      12.624283945378606, 48.43470595807255, 12.696498944776318, 48.50187862393808,
    ],
    '092775240122': [
      12.609736815534074, 48.331703725241894, 12.69020207701609, 48.36760672190462,
    ],
    '092775240133': [
      12.565641390068537, 48.3594753520811, 12.656956814145275, 48.44093916239536,
    ],
    '092775241112': [
      13.088388418096839, 48.39135325535608, 13.173216708779156, 48.43593129329896,
    ],
    '092775241113': [
      12.986435462346407, 48.37672390177759, 13.14293872305275, 48.489550202184326,
    ],
    '092775243140': [
      12.890578908058728, 48.25843694527204, 12.969289187037004, 48.3368006967356,
    ],
    '092775243148': [
      12.849107210090734, 48.30293138552603, 12.9529192513404, 48.39801713840205,
    ],
    '092775244118': [
      13.071761380256996, 48.278069028693125, 13.177034187535199, 48.351256578030466,
    ],
    '092775244147': [
      13.036742299086496, 48.27730679195219, 13.102314618305337, 48.36597568822095,
    ],
    '092780118118': [
      12.63070792541016, 48.871323364011474, 12.801009126510081, 48.95169868200921,
    ],
    '092780121121': [
      12.488033200522814, 48.80390360002502, 12.588686306446968, 48.85411429894103,
    ],
    '092780123123': [
      12.29278623913128, 48.75811914341304, 12.50511776420629, 48.86711879871108,
    ],
    '092780129129': [
      12.677268224580251, 48.99953095882023, 12.7799508239142, 49.05755599029211,
    ],
    '092780141141': [
      12.435880343999553, 48.90986799289201, 12.568997274238548, 48.99024929556225,
    ],
    '092780143143': [
      12.671119870971511, 49.04007953372167, 12.739611233403796, 49.112071448545784,
    ],
    '092780144144': [
      12.235034439958639, 48.72146999840278, 12.399150210311058, 48.860204487469055,
    ],
    '092780146146': [
      12.431795271771808, 48.717060473749434, 12.61075312123174, 48.820992939049894,
    ],
    '092780148148': [
      12.130349024504763, 48.72211121601257, 12.29236617647245, 48.83760074704741,
    ],
    '092780167167': [
      12.590732487563615, 48.734118209644755, 12.732611200386815, 48.824592595227486,
    ],
    '092780170170': [
      12.556069417072807, 48.897697352875824, 12.651532074939178, 48.94242931442111,
    ],
    '092780178178': [
      12.716070118418806, 49.03763751134921, 12.80583457482454, 49.11913376999152,
    ],
    '092780184184': [
      12.770632996529447, 48.962460449840336, 12.880808291571624, 49.055278510974205,
    ],
    '092780190190': [
      12.558330303594866, 48.932250676206934, 12.656003047516258, 48.98255676248508,
    ],
    '092780197197': [
      12.474831549944142, 48.98255676248508, 12.617687880689399, 49.10174380249535,
    ],
    '092785246147': [
      12.617687880689399, 49.080326268060915, 12.692856667771657, 49.109487002671486,
    ],
    '092785246179': [
      12.593400029986634, 49.006141349955534, 12.671119870971511, 49.0642497741028,
    ],
    '092785246189': [
      12.595518551297113, 49.031932512663495, 12.682321476105669, 49.09636437754186,
    ],
    '092785248116': [
      12.585573414279628, 48.959476896453424, 12.66215399103708, 49.01814169926759,
    ],
    '092785248120': [
      12.567430172985274, 48.97182485183316, 12.616861031395885, 49.028904143859265,
    ],
    '092785248134': [
      12.651647693093553, 48.97200030217356, 12.727624781259962, 49.046365765764264,
    ],
    '092785248151': [
      12.628295478063594, 48.95008009983219, 12.704874751845752, 48.99169979278803,
    ],
    '092785249139': [
      12.676047228081474, 48.91597082495644, 12.763391079120078, 48.980071143340815,
    ],
    '092785249154': [
      12.712583329888666, 48.957183639046036, 12.815321915772248, 49.007113830379765,
    ],
    '092785249198': [
      12.735967654284124, 48.93120286938822, 12.785599915079015, 48.961342266449314,
    ],
    '092785250112': [
      12.43918835365087, 48.90966956077752, 12.521554815298119, 48.96633940389489,
    ],
    '092785250117': [
      12.467647752837212, 48.86711879871108, 12.526772351150472, 48.91583048034223,
    ],
    '092785250172': [
      12.402893087197324, 48.84141674625566, 12.477566532316569, 48.88829837806152,
    ],
    '092785250177': [
      12.42420920221719, 48.86711879871108, 12.488580783358806, 48.9203495063054,
    ],
    '092785252149': [
      12.780641553703225, 48.82281721194146, 12.848395596922936, 48.87872844447857,
    ],
    '092785252159': [
      12.755588928961027, 48.82890181480095, 12.850770156578307, 48.90698068619265,
    ],
    '092785252171': [
      12.770996900712031, 48.92514013124382, 12.849340742121868, 48.979833879276505,
    ],
    '092785252187': [
      12.787976095821827, 48.888906454071474, 12.891251403374897, 48.96781558454851,
    ],
    '092785256113': [
      12.578364527485844, 48.81882715770142, 12.733636223412699, 48.90618872560856,
    ],
    '092785256182': [
      12.540202836217917, 48.77958014812353, 12.62997149173826, 48.83388706127718,
    ],
    '092785257140': [
      12.714948354808955, 48.81837869038285, 12.768752614059963, 48.88556407128105,
    ],
    '092785257192': [
      12.663039968007304, 48.79026878032338, 12.768876108253405, 48.87289714869211,
    ],
    '092790112112': [
      12.428530626377785, 48.566741439612414, 12.523759153996963, 48.66219022069635,
    ],
    '092790113113': [
      12.73948578956893, 48.59154391845219, 12.961650689134148, 48.6815905404813,
    ],
    '092790115115': [
      12.48598061611995, 48.480994366514, 12.567667201124856, 48.561047720199625,
    ],
    '092790122122': [
      12.627513942429227, 48.60240106036846, 12.78927268470877, 48.71067088955255,
    ],
    '092790124124': [
      12.39659954862722, 48.538718768125186, 12.473153614311316, 48.64772856217921,
    ],
    '092790126126': [
      12.472897294813466, 48.5172922936134, 12.609132212917224, 48.59531386891081,
    ],
    '092790127127': [
      12.325265458650312, 48.677969341775785, 12.535624581860597, 48.766426920087305,
    ],
    '092790128128': [
      12.384205709388803, 48.64483707823789, 12.57798655207163, 48.73682257330043,
    ],
    '092790130130': [
      12.346954454177542, 48.558514644613275, 12.414395665791373, 48.64483707823789,
    ],
    '092790132132': [
      12.535004964584495, 48.66241714849924, 12.714540090671125, 48.758209238929744,
    ],
    '092790134134': [
      12.52803190240302, 48.481764936426366, 12.717111489438215, 48.62307573064193,
    ],
    '092790135135': [
      12.654189337601343, 48.50869894797501, 12.778638029965352, 48.613428413096116,
    ],
    '092790137137': [
      12.673579572618008, 48.67097470019912, 12.830498761319754, 48.79920809443649,
    ],
    '092795208116': [
      12.501615932260746, 48.58336313958191, 12.57561016918952, 48.67174209009018,
    ],
    '092795208125': [
      12.55536578814825, 48.59906154670123, 12.654130013172715, 48.683204771218385,
    ],
    '093610000000': [
      11.7783430194773, 49.41201231976238, 11.914433298866545, 49.49544186263036,
    ],
    '093620000000': [
      12.028392169534403, 48.967001908791715, 12.191268155345545, 49.07547956826784,
    ],
    '093630000000': [
      12.06445609024967, 49.61735718651004, 12.264178386325298, 49.71141212097215,
    ],
    '093710111111': [
      11.742570366289852, 49.419288911691524, 11.789028507085648, 49.461433064227016,
    ],
    '093710113113': [
      11.54071053609416, 49.61970483255565, 11.669785786271117, 49.7614591682613,
    ],
    '093710118118': [
      11.920763971345613, 49.34694472040605, 12.064388098814153, 49.42236549334493,
    ],
    '093710119119': [
      11.662077962125114, 49.54983076149406, 11.77217478834512, 49.62351052163482,
    ],
    '093710120120': [
      11.836913396450356, 49.31473234368604, 12.009956362241336, 49.38717361077372,
    ],
    '093710121121': [
      11.853905558606778, 49.56230092957564, 11.98138200852287, 49.64574858544295,
    ],
    '093710122122': [
      11.876612737557767, 49.41456753497582, 12.039266172694207, 49.51217614095858,
    ],
    '093710127127': [
      11.87131376424712, 49.48980875200242, 12.009880252330941, 49.61419620944934,
    ],
    '093710129129': [
      11.739052625632459, 49.27799633302752, 11.883553318210055, 49.35049855350364,
    ],
    '093710132132': [
      11.624333128159844, 49.307448833128845, 11.749236518580854, 49.41699313707241,
    ],
    '093710136136': [
      11.810360891929129, 49.370178859072304, 11.945977274461553, 49.4640182741288,
    ],
    '093710144144': [
      11.763304314013398, 49.461433064227016, 11.846408930751574, 49.49918744570674,
    ],
    '093710146146': [
      11.858196397546306, 49.27686848185303, 11.981746784125832, 49.33838350192132,
    ],
    '093710148148': [
      11.869968403233944, 49.21527404993646, 11.983031226946917, 49.308600873344204,
    ],
    '093710150150': [
      11.976050592378042, 49.48257085020929, 12.117902243958524, 49.578716299408974,
    ],
    '093710151151': [
      11.665309331381982, 49.46212771782939, 11.81440415653973, 49.55800184043251,
    ],
    '093710154154': [
      11.703161391740037, 49.325699434546, 11.854612164593428, 49.42896813488195,
    ],
    '093710156156': [
      11.724551670844496, 49.56464131948594, 11.882195197613944, 49.65339083751334,
    ],
    '093715301123': [
      11.832653616947718, 49.52497417547142, 11.92107772232699, 49.57647914667587,
    ],
    '093715301126': [
      11.727731524187053, 49.48646262008477, 11.888488467355014, 49.5935894779797,
    ],
    '093715302128': [
      11.511072561889895, 49.542609251600055, 11.652612372577682, 49.60963141589131,
    ],
    '093715302135': [
      11.562653087398676, 49.569749570460594, 11.718106288865245, 49.64503174690954,
    ],
    '093715303140': [
      11.544018695048905, 49.511362257886645, 11.631398982287033, 49.55764767938775,
    ],
    '093715303141': [
      11.59256572262012, 49.48398046393197, 11.704075814346126, 49.5768334336168,
    ],
    '093715303157': [
      11.532354088605125, 49.48398046393197, 11.622800083295157, 49.51717407881435,
    ],
    '093715304116': [
      11.556601046785499, 49.38451942314202, 11.680506903225432, 49.48850440080135,
    ],
    '093715304131': [
      11.63334875391302, 49.41210715578701, 11.758805087225777, 49.49910600878049,
    ],
    '093720112112': [
      12.764970772448722, 49.225858969302564, 12.866103383275581, 49.300861094746,
    ],
    '093720113113': [
      12.95918392094956, 49.157449736391115, 13.026370949170632, 49.22828299595703,
    ],
    '093720115115': [
      12.780939826473569, 49.12505393736552, 12.839992276411133, 49.189070120971735,
    ],
    '093720116116': [
      12.557831923814117, 49.13581155537192, 12.752903710774847, 49.26862080593744,
    ],
    '093720117117': [
      12.71564515754671, 49.16977048653385, 12.826022278292445, 49.23374023729499,
    ],
    '093720124124': [
      12.874899686385644, 49.2443768572166, 13.01052158765534, 49.34396839479748,
    ],
    '093720126126': [
      12.745565303611988, 49.25157830292997, 12.919508286533919, 49.35030714878105,
    ],
    '093720130130': [
      12.85534806219121, 49.18490045521981, 12.909008687706363, 49.22399397418352,
    ],
    '093720135135': [
      12.90076654212393, 49.171198310302636, 12.97346758387115, 49.23130658127897,
    ],
    '093720137137': [
      12.80680894137536, 49.127263966899505, 12.970831794171238, 49.234489811295205,
    ],
    '093720138138': [
      13.010069290929462, 49.155101590398665, 13.11326616532746, 49.23191635253859,
    ],
    '093720143143': [
      12.73510749639884, 49.11223995673935, 12.825259008745647, 49.181624709151905,
    ],
    '093720144144': [
      12.928185819249137, 49.221349722734146, 13.09424172235344, 49.30649599809121,
    ],
    '093720146146': [
      12.567147569124161, 49.21808714737485, 12.651780995611068, 49.32155730357856,
    ],
    '093720151151': [
      12.83337963306695, 49.20714483894157, 12.957650931571493, 49.25803168219263,
    ],
    '093720153153': [
      12.372523756460545, 49.136108273155315, 12.569704045209864, 49.276470302160625,
    ],
    '093720154154': [
      12.477990029958757, 49.292803910647834, 12.583163925073608, 49.41375693593117,
    ],
    '093720155155': [
      12.696757311684529, 49.197010332308, 12.808339417155779, 49.249812761651356,
    ],
    '093720157157': [
      12.547082359952148, 49.30897675441642, 12.65315562295439, 49.39811198926552,
    ],
    '093720158158': [
      12.549904494169352, 49.124243094525305, 12.64877964713309, 49.20691583971043,
    ],
    '093720164164': [
      12.577132624143823, 49.09636437754186, 12.716070118418806, 49.18502826998865,
    ],
    '093720168168': [
      12.629476538051556, 49.247310882249764, 12.711768136271544, 49.32289856754187,
    ],
    '093720171171': [
      12.60985163227606, 49.291825821337795, 12.786414154442735, 49.434802555837855,
    ],
    '093720175175': [
      12.6547909304959, 49.230954208507704, 12.70973575791471, 49.27103881403964,
    ],
    '093720177177': [
      12.691226453199478, 49.112071448545784, 12.760910449408463, 49.17471183907924,
    ],
    '093720178178': [
      13.045086826341674, 49.111691248753644, 13.171210355093338, 49.206595746267176,
    ],
    '093725308163': [
      12.52606666902091, 49.39205861008811, 12.657139915527356, 49.48841884276829,
    ],
    '093725308165': [
      12.596435392239844, 49.38310810104738, 12.657139915527356, 49.453393451511765,
    ],
    '093725310147': [
      12.517155292802961, 49.22021931733491, 12.584737169668378, 49.247395309065766,
    ],
    '093725310161': [
      12.458756326633285, 49.24008279846264, 12.577056857297348, 49.30886780918327,
    ],
    '093725312128': [
      12.714696132488086, 49.29705186757284, 12.78677856675651, 49.34743664741466,
    ],
    '093725312174': [
      12.700015609448645, 49.22425730237508, 12.810447686719847, 49.30317363792706,
    ],
    '093725313149': [
      12.325779493569744, 49.15554274002908, 12.373692905275385, 49.20348500503964,
    ],
    '093725313170': [
      12.347328747968064, 49.157224032319604, 12.447139272243342, 49.23308939595701,
    ],
    '093725317167': [
      12.36828808490845, 49.099311590439726, 12.466084125917236, 49.1833342888628,
    ],
    '093725317169': [
      12.306652101512972, 49.08832193362455, 12.402995624835164, 49.175055292096495,
    ],
    '093725318125': [
      12.409763937574963, 49.05612308828953, 12.54788347376124, 49.14294747710993,
    ],
    '093725318142': [
      12.476913546390973, 49.083139455858095, 12.596056253025814, 49.15161053874997,
    ],
    '093725318150': [
      12.409493226064813, 49.02812455544023, 12.504275614656619, 49.09761297806038,
    ],
    '093730112112': [
      11.353349226025957, 49.06348004562803, 11.575002481447138, 49.18614640572561,
    ],
    '093730113113': [
      11.375287778065731, 49.307498624272434, 11.501428560812641, 49.4123424554072,
    ],
    '093730115115': [
      11.537145616872483, 49.047097148021265, 11.707399949462122, 49.13290190927288,
    ],
    '093730119119': [
      11.473416289469341, 49.15722638332688, 11.600612242401894, 49.27126039992611,
    ],
    '093730121121': [
      11.516268254036914, 48.95262623278753, 11.675607180418062, 49.08996051402091,
    ],
    '093730126126': [
      11.261754808242454, 49.11726990129789, 11.400806600028814, 49.254629313855474,
    ],
    '093730134134': [
      11.768974405321453, 49.15050869421503, 11.940993370248604, 49.297623249947,
    ],
    '093730140140': [
      11.445586996069464, 49.30789916733439, 11.663317472522666, 49.432396736443046,
    ],
    '093730143143': [
      11.708975050360815, 49.12037265996205, 11.797680059778408, 49.200444358599555,
    ],
    '093730146146': [
      11.374676563909391, 49.14632928322534, 11.488264049120184, 49.2098042548456,
    ],
    '093730147147': [
      11.374840261915663, 49.23684066432116, 11.58148253357416, 49.31977033652673,
    ],
    '093730151151': [
      11.664050887735035, 49.095532593581936, 11.790429885431605, 49.2287758227075,
    ],
    '093730155155': [
      11.316543531085332, 49.25375099719559, 11.391885366986147, 49.32781595855114,
    ],
    '093730156156': [
      11.186522604057759, 49.243567270326714, 11.341508278299864, 49.32545200515507,
    ],
    '093730160160': [
      11.538391534431154, 49.11544727396003, 11.689303276535341, 49.204924036751805,
    ],
    '093730167167': [
      11.557882794977079, 49.187705427012475, 11.788943083709503, 49.33947823995871,
    ],
    '093735321114': [
      11.34525410010912, 49.22071775713097, 11.425702686194967, 49.28637332561119,
    ],
    '093735321153': [
      11.483543522737866, 49.28226708015469, 11.610673456665921, 49.37916373405853,
    ],
    '093735321159': [
      11.39447527518137, 49.189319774004936, 11.49420722865491, 49.250154795626514,
    ],
    '093740111111': [
      12.084047798224129, 49.699015291466324, 12.169035670364563, 49.75154135916507,
    ],
    '093740118118': [
      12.453239524814286, 49.53540024526978, 12.59316519394034, 49.6287123986102,
    ],
    '093740121121': [
      12.20931747815498, 49.683294538842155, 12.335263419472035, 49.771580746155664,
    ],
    '093740122122': [
      12.313074336951454, 49.711534251930274, 12.4035236965364, 49.770775379460716,
    ],
    '093740124124': [
      11.64338958878404, 49.62259415748398, 11.998968029647179, 49.749352191904144,
    ],
    '093740133133': [
      12.0689141478787, 49.54787390186028, 12.195153293343974, 49.61753242620272,
    ],
    '093740134134': [
      11.971278594898184, 49.63731914070726, 12.08580118555679, 49.675754792478386,
    ],
    '093740137137': [
      12.352354084176985, 49.52135260877944, 12.489155293995186, 49.626074293068115,
    ],
    '093740139139': [
      12.138099393793008, 49.70273000547987, 12.194293908385267, 49.75240563003846,
    ],
    '093740162162': [
      12.239359476732693, 49.559285288190544, 12.412791845675713, 49.665118946090914,
    ],
    '093740164164': [
      12.448199153846705, 49.606790647103416, 12.529834509923809, 49.69039552175804,
    ],
    '093740165165': [
      12.255620650978516, 49.65595456937911, 12.387075198769793, 49.71592247995706,
    ],
    '093740168168': [
      12.094202920432988, 49.776647381498975, 12.212011880458453, 49.86059038801151,
    ],
    '093745323128': [
      12.044854609769073, 49.741472636977754, 12.182238376023719, 49.80147824589823,
    ],
    '093745323144': [
      12.008318615197954, 49.6810905090981, 12.11589085786708, 49.77493498594289,
    ],
    '093745323150': [
      12.161526940567724, 49.74074247805444, 12.266855164028858, 49.80275395998774,
    ],
    '093745323158': [
      12.163980063427697, 49.72082820554466, 12.23756670939739, 49.76019759264154,
    ],
    '093745323160': [
      12.17848421450284, 49.66431530060542, 12.292447953747251, 49.72665895857379,
    ],
    '093745324148': [
      11.84873055365059, 49.73826601985399, 11.944887939162356, 49.81156211099079,
    ],
    '093745324149': [
      11.908958494391566, 49.707772150952735, 12.044875927592193, 49.823889881229064,
    ],
    '093745324156': [
      11.971551381861214, 49.697916648817596, 12.039823089946813, 49.739853474789165,
    ],
    '093745325119': [
      12.064777367234264, 49.59655301948703, 12.125690106718702, 49.64852192874857,
    ],
    '093745325131': [
      11.967903876443295, 49.569333647880946, 12.089953088648398, 49.63149019895057,
    ],
    '093745325166': [
      11.90425325963399, 49.6095523579504, 12.097479837815644, 49.67879856793503,
    ],
    '093745326129': [
      11.63022348458914, 49.712425683941234, 11.801464616802587, 49.81082498296924,
    ],
    '093745326155': [
      11.69350780654822, 49.76099680116872, 11.78775746855144, 49.81821676302426,
    ],
    '093745326163': [
      11.700275817330542, 49.79508927337058, 11.796242265588221, 49.83607312345912,
    ],
    '093745327117': [
      11.765679674585945, 49.71194500827207, 11.891996998876563, 49.77218295414486,
    ],
    '093745327140': [
      11.788655824226709, 49.800639624497926, 11.886292983568836, 49.85204828679438,
    ],
    '093745327157': [
      11.775669436951054, 49.75897224952114, 11.87206118142326, 49.81724592895309,
    ],
    '093745329127': [
      12.2119749290572, 49.61215335394633, 12.244227292264835, 49.64418296377346,
    ],
    '093745329146': [
      12.136272872243794, 49.58609476513077, 12.234784524064626, 49.64142427859374,
    ],
    '093745329154': [
      12.157604180538407, 49.6399996139819, 12.199480813137257, 49.661974141247136,
    ],
    '093745329170': [
      12.192246785965038, 49.63352014599744, 12.229658220261099, 49.662571953907474,
    ],
    '093745330132': [
      12.220404039449859, 49.54764994772048, 12.305237734012726, 49.6208592139177,
    ],
    '093745330159': [
      12.25936357774938, 49.50429134645873, 12.404345410686025, 49.582528944981966,
    ],
    '093745331123': [
      12.350483759991743, 49.673988661748, 12.485011852429809, 49.74405395342526,
    ],
    '093745331147': [
      12.367920465959477, 49.60706428769426, 12.480708548785055, 49.68753563726315,
    ],
    '093750117117': [
      12.1871309152876, 48.978548790938426, 12.342197107891277, 49.02237566927768,
    ],
    '093750118118': [
      11.746579896456904, 49.07024577024765, 11.896310619983566, 49.172907081435135,
    ],
    '093750119119': [
      12.161287953565154, 49.035232670206966, 12.323837034926688, 49.166260381550764,
    ],
    '093750143143': [
      12.17256365734871, 48.86725263385653, 12.28822966761495, 48.92080735019798,
    ],
    '093750148148': [
      11.659663088884285, 48.98437667407624, 11.895747590129035, 49.10594012371737,
    ],
    '093750161161': [
      12.15282920245017, 48.926080172501294, 12.209331134025334, 48.94810188839702,
    ],
    '093750165165': [
      12.015814059390708, 49.03468451469012, 12.105051403652645, 49.110982902129074,
    ],
    '093750170170': [
      12.194116168894949, 48.902197600796924, 12.329249268061183, 48.99037165345747,
    ],
    '093750174174': [
      12.174594218883701, 48.960681674332434, 12.232731079621924, 48.997505343214044,
    ],
    '093750175175': [
      11.865035196886437, 48.989446668391814, 12.001220061603094, 49.05343153849645,
    ],
    '093750179179': [
      12.09580405812515, 48.92289671102174, 12.199169772042913, 48.97850364393621,
    ],
    '093750180180': [
      11.988176668573146, 48.921952839138925, 12.115486482941865, 49.00302054894087,
    ],
    '093750181181': [
      11.965000070163516, 49.01517980872248, 12.047880095231971, 49.075083535155755,
    ],
    '093750183183': [
      12.280327595390165, 48.93000267446296, 12.453350444445759, 48.98961771371926,
    ],
    '093750190190': [
      12.00170899322288, 49.08675775026123, 12.235142918893475, 49.22378016887698,
    ],
    '093750196196': [
      12.096642098865459, 48.76715964067191, 12.258572743032245, 48.87689961159845,
    ],
    '093750199199': [
      11.901599791333703, 48.94728893041173, 12.04648972869546, 49.02588805163869,
    ],
    '093750204204': [
      12.158831336717196, 49.00680456459322, 12.206357437913637, 49.05697535525753,
    ],
    '093750205205': [
      12.078069457781753, 48.87403259819678, 12.197175850862767, 48.94764842423091,
    ],
    '093750208208': [
      12.131034357197294, 49.048566094088905, 12.234735337083395, 49.10670416335871,
    ],
    '093750209209': [
      12.319461090899514, 49.00216270346801, 12.416012388901503, 49.05493813518431,
    ],
    '093750213213': [
      12.089048569799981, 49.06378343753353, 12.166182202903608, 49.111434827286864,
    ],
    '093755332131': [
      11.87072243046827, 49.094828147028586, 11.978815115996857, 49.156606722903604,
    ],
    '093755332153': [
      11.964495829078265, 49.11765526585008, 12.034463713953494, 49.16218204397613,
    ],
    '093755332156': [
      11.861109132410366, 49.12724465014121, 12.012007399950402, 49.19507858388792,
    ],
    '093755333122': [
      11.88099341771862, 49.05345281517778, 11.95694131247846, 49.11272774662663,
    ],
    '093755333127': [
      11.869179302666227, 49.01731838095856, 11.922928840310572, 49.043769356607235,
    ],
    '093755333162': [
      11.839493730484474, 49.04000555946558, 11.960497219332725, 49.10837856232106,
    ],
    '093755334184': [
      11.938520547482257, 49.0496535522879, 12.024943804903247, 49.095637660272075,
    ],
    '093755334211': [
      11.942424059198249, 49.083721936847375, 12.017330632083077, 49.122216996597395,
    ],
    '093755335114': [
      12.258210487009437, 49.055912913027704, 12.345468995365602, 49.12342466820438,
    ],
    '093755335116': [
      12.243977180999357, 49.00745938938403, 12.33283298527669, 49.04436804145558,
    ],
    '093755335130': [
      12.189477086464866, 49.01358997632085, 12.276688291054095, 49.043191586145134,
    ],
    '093755336120': [
      12.325258715627811, 49.04446154144038, 12.437531740432705, 49.10365013278315,
    ],
    '093755336210': [
      12.32399320563723, 48.9720187704492, 12.492892578512395, 49.0459515802348,
    ],
    '093755337113': [
      12.167982572008096, 48.896086161153114, 12.24393506513528, 48.934812583664105,
    ],
    '093755337182': [
      12.187288324277107, 48.84176642663821, 12.26196207100873, 48.88190975764322,
    ],
    '093755338115': [
      12.236330490097558, 48.84184496087765, 12.323764947157441, 48.905501326672045,
    ],
    '093755338171': [
      12.353963758896441, 48.85685913968758, 12.45505226874813, 48.938669116296715,
    ],
    '093755338191': [
      12.300458642718583, 48.887078223761975, 12.373769959695455, 48.9487696068863,
    ],
    '093755338201': [
      12.31576271423434, 48.847302599766444, 12.391549049418085, 48.89579481724444,
    ],
    '093760116116': [
      12.206253761385781, 49.26258795012848, 12.381719422181247, 49.33008997510093,
    ],
    '093760117117': [
      12.217207778098203, 49.21399864282632, 12.39498059224468, 49.27542987357305,
    ],
    '093760119119': [
      11.933858375938945, 49.161693296461706, 12.068472226722207, 49.30763713222372,
    ],
    '093760125125': [
      11.97724904088093, 49.378047755197954, 12.102551537726741, 49.43679065927885,
    ],
    '093760141141': [
      12.056388554640511, 49.14338587418122, 12.15616526828124, 49.2191969339419,
    ],
    '093760147147': [
      12.22009396887239, 49.30497000566698, 12.488876128982813, 49.3924922278029,
    ],
    '093760149149': [
      12.136617484287934, 49.152161346049816, 12.363576392807209, 49.26134204162128,
    ],
    '093760150150': [
      12.072706357328206, 49.48449014378736, 12.245355194617199, 49.59386638291048,
    ],
    '093760151151': [
      12.375853715919716, 49.432692457096735, 12.514366892212228, 49.552540547991676,
    ],
    '093760159159': [
      12.032970127558999, 49.40372810588416, 12.11062253959546, 49.49439762060141,
    ],
    '093760161161': [
      11.989878209407957, 49.24889520972867, 12.207933277896595, 49.38324735811617,
    ],
    '093760170170': [
      12.032398237810808, 49.20342445730487, 12.161157693032152, 49.26338303163859,
    ],
    '093765339131': [
      12.286310394298635, 49.48739413871797, 12.35260045617486, 49.51828094230373,
    ],
    '093765339148': [
      12.320001663147522, 49.41316366459513, 12.411574777602794, 49.47967951384792,
    ],
    '093765339171': [
      12.32841541948316, 49.46783785819883, 12.433283852894787, 49.53191885188694,
    ],
    '093765339178': [
      12.446158817930826, 49.406862765842675, 12.555437816464305, 49.474602276220956,
    ],
    '093765341112': [
      12.23364848313498, 49.38981305147381, 12.340126209511462, 49.44737046975849,
    ],
    '093765341133': [
      12.233720426714484, 49.425509016624005, 12.346007777514941, 49.49211512817577,
    ],
    '093765341144': [
      12.0925859892069, 49.41301866639586, 12.259983787234118, 49.48764315119109,
    ],
    '093765342162': [
      12.151062031174943, 49.36296464182905, 12.271376736904779, 49.42380084560421,
    ],
    '093765342163': [
      12.09294926819018, 49.33714558749059, 12.245081387651277, 49.41153002622095,
    ],
    '093765342169': [
      12.097757149959328, 49.39296152043593, 12.165936797851828, 49.44257298837862,
    ],
    '093765343153': [
      12.111083629235813, 49.47348989977289, 12.300252374781525, 49.54040480513128,
    ],
    '093765343173': [
      12.217314846434041, 49.50595905654413, 12.303772557598757, 49.55612174254305,
    ],
    '093765344160': [
      12.472778433105434, 49.46895042357985, 12.641114557994522, 49.550115722131785,
    ],
    '093765344167': [
      12.59810326417673, 49.47603171083868, 12.64405836234345, 49.526702633345515,
    ],
    '093765344176': [
      12.508445650203686, 49.45316847964295, 12.615614717937593, 49.50079369813021,
    ],
    '093765345122': [
      12.362374080376279, 49.37165570893693, 12.449686590351527, 49.44148743009031,
    ],
    '093765345146': [
      12.33195940023945, 49.26130198650415, 12.51003848849415, 49.32078083711014,
    ],
    '093765345164': [
      12.280361957423876, 49.347584080612485, 12.38602708336205, 49.417314471177086,
    ],
    '093765345172': [
      12.410957710825151, 49.36176662980627, 12.502431122692508, 49.4265077853417,
    ],
    '093765346168': [
      12.129822837752803, 49.24879069592306, 12.220770668180355, 49.29653916193651,
    ],
    '093765346175': [
      12.136204587231305, 49.28031132019612, 12.249717996902119, 49.35089910908825,
    ],
    '093770112112': [
      12.346629230638666, 49.756026028018546, 12.487141363531604, 49.85858154028674,
    ],
    '093770116116': [
      11.974942556198313, 49.7836418078165, 12.099780764740789, 49.902242501850665,
    ],
    '093770118118': [
      12.05780181449908, 49.86701687037981, 12.136758980349464, 49.9105256964406,
    ],
    '093770119119': [
      12.103050952827958, 49.893460942480175, 12.161049804869183, 49.94474964646666,
    ],
    '093770127127': [
      11.81121311359914, 49.88785063102228, 11.886618076375365, 49.96506326389612,
    ],
    '093770131131': [
      12.192018999561425, 49.978723313753825, 12.269729103820834, 50.03787994644264,
    ],
    '093770133133': [
      11.851028537286235, 49.88079346395517, 11.971237655641515, 49.96060034583669,
    ],
    '093770139139': [
      12.38964249087113, 49.837623015797064, 12.551083933200932, 49.937876907965844,
    ],
    '093770142142': [
      12.339515790305015, 49.9320647949636, 12.499119290210137, 50.00089658542652,
    ],
    '093770146146': [
      12.198957998921427, 49.756918699992944, 12.37677201434628, 49.85510635136902,
    ],
    '093770154154': [
      12.248387759975625, 49.822885480089134, 12.450917379388196, 49.954921139456985,
    ],
    '093770157157': [
      11.97050428207178, 49.8968643366388, 12.143061266506294, 49.99542848571069,
    ],
    '093770158158': [
      12.233653170469482, 49.97900073527769, 12.424269743936394, 50.05834491564574,
    ],
    '093775347137': [
      12.251781386550705, 49.89316654713077, 12.363583976697448, 49.99068108788355,
    ],
    '093775347141': [
      12.185067701028338, 49.88742232796914, 12.285910717673076, 49.99477756236382,
    ],
    '093775347145': [
      12.115350651141268, 49.94395535610831, 12.211205489673665, 49.998303444532105,
    ],
    '093775348128': [
      11.858676778305778, 49.7996464075144, 11.97269336912102, 49.85303198038973,
    ],
    '093775348129': [
      11.839304123894676, 49.814031277920485, 12.01797148245855, 49.892430771219495,
    ],
    '093775349113': [
      11.869165901147833, 49.94340317303887, 11.93226798441781, 49.978836765001304,
    ],
    '093775349115': [
      11.90539453831839, 49.934503451353685, 11.97050428207178, 49.979209756964245,
    ],
    '093775349143': [
      11.939702074134761, 49.906358052358506, 12.000588142115062, 49.979209756964245,
    ],
    '093775349148': [
      11.95466548434454, 49.86597449592036, 12.050304750779416, 49.96687368277372,
    ],
    '093775350132': [
      12.056592416271823, 49.81426302085319, 12.136415114586985, 49.884828251660096,
    ],
    '093775350149': [
      12.113979824622778, 49.82872009673884, 12.180118613232347, 49.87960507561117,
    ],
    '093775351117': [
      12.169459070668188, 49.816398452503066, 12.281566398827763, 49.89316654713077,
    ],
    '093775351159': [
      12.133448984642722, 49.868355569704754, 12.251642397547085, 49.951300192282,
    ],
    '094610000000': [
      10.826116232345777, 49.84379277378668, 10.953862383529087, 49.925743552491134,
    ],
    '094620000000': [
      11.495456987073183, 49.89170980705944, 11.67022302226065, 49.977064734384314,
    ],
    '094630000000': [
      10.887228426736748, 50.221679580139714, 11.063364083237612, 50.29656813829801,
    ],
    '094640000000': [
      11.807433186687208, 50.267498209950666, 11.971951672860216, 50.35474643080108,
    ],
    '094710111111': [
      10.970382460750171, 49.78078802700461, 11.042475276655715, 49.81400961184385,
    ],
    '094710117117': [
      10.755888967187957, 49.87932258875004, 10.842234374922398, 49.923413246909035,
    ],
    '094710119119': [
      10.864823129596576, 49.957332772921376, 10.985732241351856, 49.993832629735174,
    ],
    '094710123123': [
      11.016540838668949, 49.79308345939102, 11.105485172622842, 49.861210858515825,
    ],
    '094710131131': [
      10.812824471175613, 49.77040313846074, 10.933606416975142, 49.84724040030359,
    ],
    '094710137137': [
      10.90386964916931, 49.92383072321848, 10.936931459883066, 49.947911363684625,
    ],
    '094710140140': [
      10.833245470188317, 49.91147637230921, 10.91362807985662, 49.94946615143068,
    ],
    '094710142142': [
      11.07431674900422, 49.83236484026266, 11.243916914241735, 49.92388796882275,
    ],
    '094710145145': [
      10.906075592356625, 49.76670490026431, 11.05112122298686, 49.84944491563337,
    ],
    '094710150150': [
      10.840683780300594, 49.94020174263074, 10.894781782630206, 49.97363343946726,
    ],
    '094710155155': [
      10.973281550834026, 49.89337366617539, 11.104901285714822, 49.93547982230534,
    ],
    '094710159159': [
      10.926132303573436, 49.91759736528385, 11.037375499714852, 49.97644187923359,
    ],
    '094710165165': [
      10.723039438862834, 49.91368049910404, 10.84541835849644, 49.968449434457,
    ],
    '094710169169': [
      10.901904063234753, 49.815782371215356, 10.960519851332629, 49.848427572645086,
    ],
    '094710172172': [
      10.756603262454075, 49.73899611267755, 10.877730747496965, 49.80360684179944,
    ],
    '094710174174': [
      10.832574159537742, 49.98416442773082, 10.930518551205942, 50.095876156173006,
    ],
    '094710185185': [
      10.960768113114005, 49.92688179582086, 11.125949102285093, 50.03602905068274,
    ],
    '094710191191': [
      10.785599695898352, 49.835952115484076, 10.906433923711036, 49.887016751560246,
    ],
    '094710195195': [
      10.929977419278282, 49.82950870081025, 11.087992933123019, 49.89011470162277,
    ],
    '094710207207': [
      10.71352772981623, 49.90331338920113, 10.802301355621081, 49.94131302377933,
    ],
    '094710208208': [
      10.736872795277357, 49.85210418535643, 10.808577534925655, 49.89847202208095,
    ],
    '094710214214': [
      10.909046801367044, 49.98084598030767, 11.005662896631224, 50.04836307013661,
    ],
    '094710220220': [
      10.525025127500031, 49.721195546718214, 10.720613869816091, 49.799895189312366,
    ],
    '094715401115': [
      10.75100584323586, 49.96499858884565, 10.880204181272426, 50.02375768384837,
    ],
    '094715401133': [
      10.767460367995819, 50.017418829439535, 10.819094691018812, 50.04726001172698,
    ],
    '094715401152': [
      10.740386252933916, 49.95833791815218, 10.814572866735588, 50.00036223366168,
    ],
    '094715401175': [
      10.784348150944636, 50.00950437423269, 10.858818497741453, 50.05183678774084,
    ],
    '094715403151': [
      11.096251528060936, 49.90699050331689, 11.218882513545301, 49.97850382276571,
    ],
    '094715403189': [
      11.10896237028999, 49.95515573065236, 11.251707784840299, 50.024510250764514,
    ],
    '094715403209': [
      11.091806295621378, 49.994528328156676, 11.196174842572736, 50.05798389218086,
    ],
    '094715407122': [
      10.522456827829595, 49.79572219859435, 10.644555410195496, 49.874689099971505,
    ],
    '094715407128': [
      10.439869368817059, 49.78655763324117, 10.544744706118111, 49.87643057688169,
    ],
    '094715408120': [
      10.61728416822715, 49.77255179896583, 10.82989015657782, 49.87188920766104,
    ],
    '094715408186': [
      10.626488433017554, 49.84169684831629, 10.734775167309847, 49.89093388879707,
    ],
    '094715445154': [
      10.697257450603479, 49.86760168978273, 10.756824078294423, 49.91050221212599,
    ],
    '094715445173': [
      10.686383056241468, 49.88212708161721, 10.734904502167499, 49.92507645204988,
    ],
    '094720111111': [
      11.342746689266145, 49.80336883518698, 11.486266917886038, 49.87841091229298,
    ],
    '094720116116': [
      11.599220851625603, 50.017839981143496, 11.750308399801884, 50.086780396030015,
    ],
    '094720119119': [
      11.536014035668805, 49.96810589660378, 11.655783172208915, 50.02895519097391,
    ],
    '094720121121': [
      11.73028480702714, 50.043895190481564, 11.823747603693151, 50.066201715589045,
    ],
    '094720131131': [
      11.38403772063504, 49.92094521399572, 11.526020019462312, 49.991663338211254,
    ],
    '094720138138': [
      11.830717438580674, 49.97405070824952, 11.873007145991092, 50.01843492446374,
    ],
    '094720139139': [
      11.675664180060918, 50.05214168669317, 11.818209796545107, 50.13395822404452,
    ],
    '094720143143': [
      11.64118842835615, 49.97201366273896, 11.742334370228255, 50.02835407753737,
    ],
    '094720150150': [
      11.487423976634256, 49.95625594374485, 11.561110385821822, 50.00564679740358,
    ],
    '094720164164': [
      11.845111531733727, 49.96506326389612, 11.903225689502817, 49.99753204995795,
    ],
    '094720175175': [
      11.424390629728022, 49.713853082326374, 11.632725402243251, 49.83725027305051,
    ],
    '094720179179': [
      11.347428384696759, 49.69900892187388, 11.489472450137011, 49.8364013744194,
    ],
    '094720190190': [
      11.707476777831804, 49.83601834766045, 11.860489684445326, 49.90322464016155,
    ],
    '094720197197': [
      11.255828920066499, 49.79820117987757, 11.406130268018938, 49.88198679572297,
    ],
    '094720198198': [
      11.731882061650259, 49.965636024222654, 11.825004977318416, 50.037162919704166,
    ],
    '094725412115': [
      11.184232955169433, 49.86703960070608, 11.313196662579728, 49.92773500377363,
    ],
    '094725412154': [
      11.193953189320801, 49.88660375275208, 11.376225113010399, 50.00039004052824,
    ],
    '094725412176': [
      11.293185520649713, 49.8738164856274, 11.38433710677983, 49.91488105407395,
    ],
    '094725413141': [
      11.425622996316745, 49.87817620074154, 11.462588416343461, 49.90241885496221,
    ],
    '094725413167': [
      11.357377766501944, 49.873348328495936, 11.489934915680173, 49.93722680019554,
    ],
    '094725414140': [
      11.514815444059737, 49.87284395869848, 11.567238171452894, 49.9224608028401,
    ],
    '094725414155': [
      11.462588416343461, 49.83411023821837, 11.530539245565533, 49.90493219026904,
    ],
    '094725414166': [
      11.48232193250725, 49.89979178492596, 11.537187692831498, 49.9224608028401,
    ],
    '094725415133': [
      11.618525070426202, 49.86010258234619, 11.72345472564784, 49.924184248655884,
    ],
    '094725415156': [
      11.741804695771114, 49.88936209275536, 11.838139295568368, 49.97699472094394,
    ],
    '094725415188': [
      11.673205234344742, 49.87500773816727, 11.753109101191678, 49.92626970138059,
    ],
    '094725415199': [
      11.629588255642853, 49.899175604672905, 11.80166786093073, 49.99001671147883,
    ],
    '094725416127': [
      11.498993528862934, 49.80958163598252, 11.731252902755394, 49.904198857723784,
    ],
    '094725416146': [
      11.51857366110528, 49.85716141017085, 11.609003275163788, 49.89232983957886,
    ],
    '094725416180': [
      11.629755491996756, 49.80127240586859, 11.734122060690101, 49.846753632185106,
    ],
    '094725416184': [
      11.549631384862025, 49.77374094884762, 11.642070385180569, 49.834161499151065,
    ],
    '094725417118': [
      11.348294369577713, 49.61391464738541, 11.466288058271692, 49.72257322114787,
    ],
    '094725417177': [
      11.436030879307701, 49.63508573544469, 11.509100656892427, 49.67908280382246,
    ],
    '094730112112': [
      10.869244399356917, 50.198670306929806, 10.97589759595488, 50.24416086179738,
    ],
    '094730120120': [
      10.980572790811248, 50.27490119341225, 11.016207099102656, 50.299725397938104,
    ],
    '094730121121': [
      11.03035044260192, 50.20435146042595, 11.117960998859404, 50.267105976545885,
    ],
    '094730132132': [
      10.870198781534745, 50.150559523245064, 10.980346171151158, 50.20590288582543,
    ],
    '094730138138': [
      10.85122303171998, 50.087588342600384, 10.947257897947065, 50.17650099564854,
    ],
    '094730141141': [
      10.898985441172606, 50.28928891828088, 11.00149478898461, 50.39286805168468,
    ],
    '094730144144': [
      10.825128112223531, 50.281991076249284, 10.967184483829698, 50.396756862023395,
    ],
    '094730151151': [
      11.038320189270406, 50.25279551178119, 11.183950076392637, 50.366876313706314,
    ],
    '094730158158': [
      10.713920797151985, 50.27709047622834, 10.865051593390717, 50.392623397895285,
    ],
    '094730159159': [
      10.985817866670164, 50.26030034571514, 11.098914434421312, 50.365659250178425,
    ],
    '094730165165': [
      10.729188914792516, 50.14112616369945, 10.893992200433239, 50.25269202907339,
    ],
    '094730166166': [
      11.098429366227515, 50.204527584908526, 11.201674741251425, 50.27084909839088,
    ],
    '094730170170': [
      10.914233636065827, 50.173624600622404, 11.00959190215323, 50.226820011425644,
    ],
    '094730174174': [
      11.107500133402068, 50.1851989080057, 11.198733852364466, 50.214463397885716,
    ],
    '094730175175': [
      10.827903297768158, 50.20987363336974, 10.92084730148246, 50.29126342394823,
    ],
    '094735418134': [
      10.994619172300842, 50.2119306841301, 11.049073712003164, 50.25015197231339,
    ],
    '094735418153': [
      10.975744124506203, 50.21132177563708, 11.004436378316063, 50.23210877988848,
    ],
    '094740123123': [
      11.008907867789487, 49.741849193378215, 11.153310011822862, 49.842261291510056,
    ],
    '094740124124': [
      11.206079066839342, 49.68723256491642, 11.31330854066998, 49.7399381166399,
    ],
    '094740126126': [
      10.99977350014131, 49.6740033722117, 11.125765481040737, 49.74990160583192,
    ],
    '094740129129': [
      11.233415642738384, 49.71885879005166, 11.3862740771452, 49.818012744971696,
    ],
    '094740133133': [
      10.913196614940771, 49.71545002544271, 11.0415485522183, 49.785622400102795,
    ],
    '094740134134': [
      10.970923393472894, 49.67084061842086, 11.051314546300913, 49.72471539971879,
    ],
    '094740135135': [
      10.923243428273638, 49.68166631072632, 11.014902177491216, 49.72228881917674,
    ],
    '094740140140': [
      11.149476843029726, 49.58991559767784, 11.286109288925239, 49.66180727805291,
    ],
    '094740146146': [
      11.023166381333866, 49.624070027498995, 11.09471799658663, 49.65533242985507,
    ],
    '094740154154': [
      11.076380510761481, 49.59989991316743, 11.208266786943671, 49.65400269456786,
    ],
    '094740156156': [
      11.277001309783216, 49.6787919896054, 11.37557456555529, 49.72558169739469,
    ],
    '094740161161': [
      11.153077061437507, 49.7140550971871, 11.249153439963031, 49.76941612736279,
    ],
    '094740176176': [
      11.196952860157738, 49.777761589410794, 11.305503864375556, 49.87364364363579,
    ],
    '094745420121': [
      11.118380112841521, 49.74915589741957, 11.301641129802597, 49.818194604967815,
    ],
    '094745420168': [
      11.137118210845202, 49.8092882122642, 11.205146289021052, 49.845324335249906,
    ],
    '094745422145': [
      11.132386769799707, 49.656013625487866, 11.197510232930794, 49.693474527282966,
    ],
    '094745422158': [
      11.080389356509926, 49.67163789024868, 11.149619138024834, 49.7154462826443,
    ],
    '094745422175': [
      11.120247936096254, 49.693474527282966, 11.161916193834207, 49.72646772896799,
    ],
    '094745423143': [
      11.125765481040737, 49.718347623187064, 11.183534593547398, 49.74954162469164,
    ],
    '094745423147': [
      11.149619138024834, 49.671407048949725, 11.22364968845434, 49.726489524039984,
    ],
    '094745423171': [
      11.104788679374753, 49.72646772896799, 11.160022487733935, 49.766601440478446,
    ],
    '094745425122': [
      11.071363241618103, 49.64582315270267, 11.139201143146341, 49.6819230491576,
    ],
    '094745425160': [
      11.048518792850308, 49.65331521496897, 11.087468202814991, 49.67930639732748,
    ],
    '094745426119': [
      11.101237991567558, 49.58769635665863, 11.140053618692805, 49.61095447937893,
    ],
    '094745426137': [
      11.093162251595627, 49.62505561367545, 11.16023884840365, 49.658132000543205,
    ],
    '094745426144': [
      11.137897364783958, 49.588373393880936, 11.188202945706704, 49.616681312600804,
    ],
    '094745427132': [
      11.169547802353378, 49.62656287886085, 11.308010857505586, 49.70164012094338,
    ],
    '094745427138': [
      11.272559342077399, 49.63330175443028, 11.372962721728902, 49.689467846927386,
    ],
    '094745427173': [
      11.243143192234578, 49.617726122675215, 11.297351323259543, 49.63710049559378,
    ],
    '094750112112': [
      11.59648926037137, 50.31032419990909, 11.677930483156965, 50.39140380711397,
    ],
    '094750113113': [
      11.734482341155317, 50.33827983748139, 11.828339175695726, 50.41798798108729,
    ],
    '094750120120': [
      11.929282522501008, 50.26564827187496, 12.001316798930873, 50.31163303012532,
    ],
    '094750128128': [
      11.568100569832254, 50.31874461903161, 11.62371156002982, 50.385588227406636,
    ],
    '094750136136': [
      11.598578124026035, 50.20145325153469, 11.803151367187906, 50.276770084151714,
    ],
    '094750141141': [
      11.79212218843391, 50.314539176135725, 11.881091631767125, 50.394636288775395,
    ],
    '094750142142': [
      11.782057710895776, 50.213997999672024, 11.894343165475213, 50.29888837957512,
    ],
    '094750154154': [
      11.671039229096767, 50.14826811525633, 11.845957045101411, 50.240597005466334,
    ],
    '094750156156': [
      11.626788572515284, 50.284534524937776, 11.742323630201494, 50.37234141534202,
    ],
    '094750158158': [
      11.87880537256916, 50.23250145889963, 11.978604508117078, 50.28187574209766,
    ],
    '094750161161': [
      11.976651454665964, 50.261994526304264, 12.125682069860702, 50.33193753987319,
    ],
    '094750162162': [
      11.96038650910945, 50.19019788911577, 12.161496385301392, 50.30103260705875,
    ],
    '094750168168': [
      11.845957045101411, 50.1613156785351, 12.022790822197209, 50.244645502623065,
    ],
    '094750169169': [
      11.534576204775227, 50.254180891707676, 11.687436584498743, 50.31032419990909,
    ],
    '094750171171': [
      11.71291804904732, 50.291507185721215, 11.801842141337907, 50.35639069458109,
    ],
    '094750175175': [
      11.646079932663815, 50.11479324181919, 11.759929640347146, 50.179864176473465,
    ],
    '094750189189': [
      11.74077354636757, 50.10322198421161, 11.868842984399796, 50.167354734022,
    ],
    '094755428137': [
      11.690370686621083, 50.34534100525835, 11.754704964474872, 50.40514121777719,
    ],
    '094755428146': [
      11.63845085602913, 50.362310627265494, 11.69250955619319, 50.39352250180514,
    ],
    '094755430123': [
      11.860930530632709, 50.33882139629424, 11.953843920079104, 50.424361541952415,
    ],
    '094755430127': [
      11.950530781823877, 50.29799959731866, 12.03328758922594, 50.35413672345791,
    ],
    '094755430181': [
      11.833159111418755, 50.36349327628241, 11.921446681633133, 50.41666027669463,
    ],
    '094755430182': [
      11.9428809677739, 50.34479046565588, 11.98292722485549, 50.39975276574393,
    ],
    '094755431145': [
      11.77837838509566, 50.26807871685516, 11.828990928209468, 50.31758963043474,
    ],
    '094755431165': [
      11.678018553573452, 50.24856924775332, 11.787321416001571, 50.297981162185465,
    ],
    '094755432174': [
      11.806554798145815, 50.132599336607626, 11.885768347237144, 50.17585814789111,
    ],
    '094755432184': [
      11.817560494395927, 50.144488279196885, 11.911326272089601, 50.213997999672024,
    ],
    '094760145145': [
      11.2647404262915, 50.19643677602153, 11.418032579963144, 50.30417612802932,
    ],
    '094760146146': [
      11.22369726600408, 50.160002585594974, 11.346552303898868, 50.234283877145614,
    ],
    '094760152152': [
      11.295805974106647, 50.43851883574213, 11.43934156021095, 50.522222952014516,
    ],
    '094760159159': [
      11.462729582111308, 50.321594856925806, 11.550593216830363, 50.397709427743465,
    ],
    '094760164164': [
      11.264653905128593, 50.30417612802932, 11.373289600319827, 50.41249165399925,
    ],
    '094760175175': [
      11.28092767314631, 50.39335900204554, 11.388981299558603, 50.46767405967101,
    ],
    '094760177177': [
      11.396452896625876, 50.27839507449799, 11.540577087905794, 50.358297260682576,
    ],
    '094760178178': [
      11.253148396861034, 50.26829610477878, 11.333670112767123, 50.34037950318709,
    ],
    '094760179179': [
      11.24684697310999, 50.3949593488432, 11.318895615959164, 50.48353663284511,
    ],
    '094760183183': [
      11.348775202296483, 50.20246636299195, 11.459763552188443, 50.283956315617296,
    ],
    '094760184184': [
      11.4326705601401, 50.23298478217836, 11.56436767617911, 50.32477714583728,
    ],
    '094760185185': [
      11.294962694513249, 50.16189111721758, 11.434653138598108, 50.21966946164126,
    ],
    '094760189189': [
      11.333670112767123, 50.25899157267209, 11.434799446406867, 50.384212691122826,
    ],
    '094765433166': [
      11.396574161867264, 50.40902218064703, 11.452700419735985, 50.44216658951413,
    ],
    '094765433180': [
      11.353776145056749, 50.345282735044904, 11.440817331399025, 50.44216658951413,
    ],
    '094765433182': [
      11.43173167459544, 50.35551651339042, 11.49259764172035, 50.43168389858107,
    ],
    '094765434154': [
      11.178844332133103, 50.211779361243224, 11.279135046140526, 50.29232432220781,
    ],
    '094765434171': [
      11.16943775233554, 50.20036006929664, 11.237924927109217, 50.228581289794526,
    ],
    '094770121121': [
      11.56843386709576, 50.02909908677332, 11.652088873508958, 50.08730089651894,
    ],
    '094770128128': [
      11.36085886586301, 50.05496770746791, 11.503208170947936, 50.19050807468768,
    ],
    '094770136136': [
      11.29911771350092, 50.05555102168155, 11.408232678385621, 50.16680525572694,
    ],
    '094770139139': [
      11.618106347330507, 50.06899790947772, 11.685180732887693, 50.12451878895552,
    ],
    '094770142142': [
      11.43703284416586, 49.98702518912662, 11.570709780478124, 50.06192981490551,
    ],
    '094770143143': [
      11.527491372135636, 50.05855924222203, 11.60826342316672, 50.11823529768032,
    ],
    '094770148148': [
      11.458723542315086, 50.18700925784427, 11.628367067770823, 50.267271573859254,
    ],
    '094770157157': [
      11.329244153178077, 49.93530989807713, 11.468234322944186, 50.06494237830893,
    ],
    '094770163163': [
      11.583823962821917, 50.08540536141229, 11.647629351516548, 50.14404862351366,
    ],
    '094775435151': [
      11.41319195943516, 50.17324858294002, 11.492320215129146, 50.22553198846708,
    ],
    '094775435156': [
      11.459248461330692, 50.141835855987104, 11.574020452945991, 50.21888273212183,
    ],
    '094775436117': [
      11.568699630327593, 50.1742410744583, 11.656768354979889, 50.231436869545696,
    ],
    '094775436138': [
      11.590549401495693, 50.13538234583869, 11.687380752634441, 50.20431160201487,
    ],
    '094775437118': [
      11.54352456760012, 50.137268760483046, 11.606084509049973, 50.18556474053666,
    ],
    '094775437129': [
      11.555408646457648, 50.12247309165877, 11.618854903153537, 50.16594761761663,
    ],
    '094775437135': [
      11.540113044773213, 50.110804678835336, 11.588603966393297, 50.137268760483046,
    ],
    '094775437159': [
      11.473026802739975, 50.11358233238243, 11.555408646457648, 50.15081125683251,
    ],
    '094775438124': [
      11.275828719766551, 50.00736392445339, 11.414146532976133, 50.07389787589468,
    ],
    '094775438164': [
      11.250517578113623, 49.94423926072752, 11.370733002941751, 50.02319808586926,
    ],
    '094775439119': [
      11.540039496466758, 50.00941364998025, 11.600298391185815, 50.05631512454076,
    ],
    '094775439127': [
      11.478889261592169, 50.06954684169916, 11.543902242512623, 50.13372650677666,
    ],
    '094775439158': [
      11.486146441728764, 50.04674757602858, 11.572592283284566, 50.09171316832227,
    ],
    '094780111111': [
      11.17576849554545, 50.085551183031896, 11.317895268180912, 50.14526273020026,
    ],
    '094780116116': [
      11.201769024342287, 50.11215322223642, 11.363026822141006, 50.17472036772891,
    ],
    '094780120120': [
      10.875670219171985, 50.01601023699476, 11.061810459683253, 50.11895939280614,
    ],
    '094780139139': [
      10.975986747306717, 50.043602594119974, 11.189343635309857, 50.21826938486054,
    ],
    '094780145145': [
      11.083299505834583, 50.15433031123127, 11.178705670574423, 50.19817035230377,
    ],
    '094780165165': [
      10.919237284067487, 50.035752501002534, 11.124095956072786, 50.173624600622404,
    ],
    '094780176176': [
      11.144305466356146, 49.989653447305834, 11.317264473181789, 50.10972440331224,
    ],
    '094785441143': [
      11.172191516346334, 50.17474824151258, 11.207943987759739, 50.197889158447545,
    ],
    '094785441155': [
      11.181176137467542, 50.15233402536505, 11.251143595461528, 50.20333891613167,
    ],
    '094785446127': [
      11.13093690946469, 50.114007308755774, 11.208924666489652, 50.16182117013287,
    ],
    '094785446144': [
      11.154460403202394, 50.15156747151007, 11.212855313326797, 50.180114112177336,
    ],
    '094790112112': [
      12.123668601580968, 49.99798106147634, 12.24508227639118, 50.08040529130808,
    ],
    '094790129129': [
      11.885768347237144, 50.10720041911815, 11.999920962567632, 50.20231249857824,
    ],
    '094790135135': [
      11.944730659046755, 50.08837656645778, 12.06987183849151, 50.1603320605432,
    ],
    '094790136136': [
      12.03014300931489, 49.97661079200214, 12.174712872560281, 50.04331271177288,
    ],
    '094790145145': [
      11.93469898735712, 50.055659074238, 12.045392799283647, 50.110359189818375,
    ],
    '094790150150': [
      12.047067794350584, 50.17277506756041, 12.137319471786798, 50.228417398661286,
    ],
    '094790152152': [
      12.019661545389097, 50.116733110750594, 12.215158126217993, 50.22035024486816,
    ],
    '094790166166': [
      11.789029249770909, 50.045061980126086, 11.94721414792924, 50.144488279196885,
    ],
    '094790169169': [
      11.931263177599062, 49.99608092364087, 12.09426486376331, 50.08717248578088,
    ],
    '094795442126': [
      12.031418648028904, 50.07742147119117, 12.116040014844145, 50.117511962194094,
    ],
    '094795442158': [
      12.079776102719231, 50.04208294318565, 12.177839253475305, 50.09885801810788,
    ],
    '094795442159': [
      12.060846053324864, 50.097248445099765, 12.144012866470302, 50.14512694882581,
    ],
    '094795443127': [
      12.136323391117466, 50.08040529130808, 12.23287862064003, 50.12745083388634,
    ],
    '094795443147': [
      12.177839253475305, 50.03787994644264, 12.275524540961605, 50.09738215092426,
    ],
    '094795444111': [
      12.004216099002715, 49.99234910516148, 12.060425310541387, 50.03022814060501,
    ],
    '094795444138': [
      11.899916088395207, 49.9705846926458, 11.97050428207178, 49.996909222586595,
    ],
    '094795444161': [
      11.886758510628479, 49.99234369372737, 11.965783094438772, 50.06895531612832,
    ],
    '095610000000': [
      10.455035019806482, 49.234331314683395, 10.65640138074984, 49.34264386883483,
    ],
    '095620000000': [
      10.917186565589635, 49.534514043314964, 11.049724950875957, 49.645112878063514,
    ],
    '095630000000': [
      10.893166586336575, 49.4360664968422, 11.026918414474997, 49.54115482794817,
    ],
    '095640000000': [
      10.989744758531115, 49.334824227512954, 11.277706026884356, 49.53914637215641,
    ],
    '095650000000': [
      10.970785873473229, 49.2946760369806, 11.091931614185928, 49.37632052754639,
    ],
    '095710113113': [
      10.577187686794517, 49.10218704887161, 10.69600783274326, 49.16157870652105,
    ],
    '095710114114': [
      10.317136975153007, 49.207015999043215, 10.46450296248228, 49.2789568266399,
    ],
    '095710115115': [
      10.487345474000682, 49.125268929148916, 10.62940300087401, 49.216444379803995,
    ],
    '095710127127': [
      10.565846141909436, 49.19786669341945, 10.614690707701959, 49.24651350870811,
    ],
    '095710130130': [
      10.352367933723928, 49.32281192355306, 10.46850411725548, 49.41266126074435,
    ],
    '095710135135': [
      10.59729702967285, 49.36176565055497, 10.775993883464375, 49.436954415804465,
    ],
    '095710136136': [
      10.204943354110748, 49.02854564189262, 10.430557761950478, 49.12797869278311,
    ],
    '095710139139': [
      10.333563814765188, 49.07827680554412, 10.433259623282241, 49.13084349600892,
    ],
    '095710145145': [
      10.228718503264998, 49.10707774623176, 10.441762697750873, 49.23797864802582,
    ],
    '095710146146': [
      10.466713962164366, 49.365257331923104, 10.57295034768714, 49.45064899518993,
    ],
    '095710165165': [
      10.710878360827449, 49.30311458546673, 10.871030248416584, 49.38873720676479,
    ],
    '095710166166': [
      10.38470754089392, 49.17613068417235, 10.581882598953637, 49.28537628303885,
    ],
    '095710170170': [
      10.418286140477042, 49.07314193529887, 10.494123660908592, 49.127460033326926,
    ],
    '095710171171': [
      10.414516038504154, 49.32131876783716, 10.582226461848242, 49.39277195052996,
    ],
    '095710174174': [
      10.31019249405444, 49.243428813040744, 10.498253419918068, 49.34910494326674,
    ],
    '095710175175': [
      10.636407494961693, 49.23158649773453, 10.77120564997394, 49.29987747895712,
    ],
    '095710177177': [
      10.646194400311177, 49.16155372750662, 10.730401091077262, 49.242416298266825,
    ],
    '095710180180': [
      10.758801262721148, 49.25139889603223, 10.868206552364278, 49.32032238923439,
    ],
    '095710183183': [
      10.383015704723501, 49.38490138385859, 10.49066927062937, 49.431087995672875,
    ],
    '095710190190': [
      10.648525494846204, 49.28495240689408, 10.786664839682901, 49.366867648225686,
    ],
    '095710193193': [
      10.102925707738859, 49.32531350901308, 10.221874852597486, 49.40692684905246,
    ],
    '095710196196': [
      10.613524676738857, 49.255841517743875, 10.698239169983085, 49.31502392299851,
    ],
    '095710199199': [
      10.120279512073779, 49.15551360605395, 10.253190483446208, 49.250979110428446,
    ],
    '095710200200': [
      10.262744887443802, 49.096321616736674, 10.338765851150846, 49.1336307166736,
    ],
    '095710214214': [
      10.487530938807781, 49.006234913702194, 10.68784007961714, 49.08348820179133,
    ],
    '095710226226': [
      10.743852555796485, 49.19832130037389, 10.913155414889163, 49.31733056604794,
    ],
    '095715501111': [
      10.094559466729898, 49.4240036278721, 10.190223416522459, 49.480539412442624,
    ],
    '095715501152': [
      10.171852782303388, 49.31791313649746, 10.275049992414464, 49.36527166043164,
    ],
    '095715501155': [
      10.249520317204611, 49.330627465755505, 10.370494171894139, 49.3941510580286,
    ],
    '095715501169': [
      10.13052575466394, 49.278837185104024, 10.189706431835793, 49.35563741290329,
    ],
    '095715501181': [
      10.204570038949063, 49.35261162755532, 10.250274696744382, 49.40964435993702,
    ],
    '095715501188': [
      10.16844707321085, 49.443163590904696, 10.268968216861795, 49.49118298180254,
    ],
    '095715501205': [
      10.140404967017965, 49.40076047985927, 10.268613824930805, 49.46016283159909,
    ],
    '095715501225': [
      10.229935468593899, 49.35151359092663, 10.366003853119967, 49.43442495044988,
    ],
    '095715502125': [
      10.257226231786296, 49.29526687229578, 10.366900184782692, 49.344928293074624,
    ],
    '095715502134': [
      10.168443129806882, 49.26575138635292, 10.247581625082415, 49.325103730916865,
    ],
    '095715502137': [
      10.263781329767705, 49.23140630820679, 10.334159211072798, 49.28289096077883,
    ],
    '095715502198': [
      10.217276771482776, 49.25442059600267, 10.351036904434507, 49.33140035319365,
    ],
    '095715502222': [
      10.1102417474873, 49.23521435483416, 10.214613770341373, 49.2840067621813,
    ],
    '095715502228': [
      10.176136035112759, 49.20841023394808, 10.275634706502801, 49.27117067320091,
    ],
    '095715504122': [
      10.670313092071783, 49.333010576920046, 10.71681889834656, 49.36854480469234,
    ],
    '095715504194': [
      10.535989002497319, 49.382068130082345, 10.616746116865798, 49.446004914004,
    ],
    '095715504217': [
      10.567066903109701, 49.322122945064685, 10.677970100970647, 49.39713675230493,
    ],
    '095715506189': [
      10.612488340280107, 49.15145850110287, 10.697535864729733, 49.19560324180237,
    ],
    '095715506216': [
      10.596533477541428, 49.185896522757986, 10.666854839849197, 49.23846061818823,
    ],
    '095715507128': [
      10.429066508755557, 49.12093911135346, 10.523279103006836, 49.16153154217363,
    ],
    '095715507132': [
      10.381799927662843, 49.10565096407301, 10.458707519733503, 49.17613068417235,
    ],
    '095715507223': [
      10.430738719386541, 49.14497335224966, 10.51424186530285, 49.19776743166043,
    ],
    '095715508179': [
      10.316545001263014, 49.00313133023205, 10.389377252675818, 49.04590304649045,
    ],
    '095715508218': [
      10.412506883423333, 49.00492878513693, 10.490161687285633, 49.059302719485224,
    ],
    '095715508224': [
      10.350333543889063, 48.97667323348657, 10.437803541382939, 49.05780309176164,
    ],
    '095715509141': [
      10.483889446969252, 49.055337393973716, 10.606712577642563, 49.13265083561423,
    ],
    '095715509154': [
      10.485921483296705, 49.026314466297755, 10.540180667694298, 49.06952740844269,
    ],
    '095715509192': [
      10.530171634055293, 49.0358742245496, 10.584741754972542, 49.067328043201094,
    ],
    '095715509208': [
      10.577602361726642, 49.07058379184875, 10.660769883682034, 49.120136240637194,
    ],
    '095715509227': [
      10.394604056372154, 49.04266297161888, 10.509572305543053, 49.099280973325044,
    ],
    '095715538178': [
      10.765693044411554, 49.19745366961239, 10.83792307054386, 49.23233590401828,
    ],
    '095715538229': [
      10.686387893591677, 49.18693585561525, 10.78138397780293, 49.255133671948414,
    ],
    '095720111111': [
      10.864328080548592, 49.66755548804967, 10.960416276964237, 49.74368029514214,
    ],
    '095720115115': [
      10.993248563136389, 49.63767544184509, 11.062963423699337, 49.681795959503795,
    ],
    '095720119119': [
      10.995779216670188, 49.61100608137448, 11.031609850241912, 49.63994444762499,
    ],
    '095720121121': [
      11.145244847344676, 49.56111828142913, 11.287840249631168, 49.60942751674737,
    ],
    '095720130130': [
      10.917095334471714, 49.67452540732652, 10.972535676381476, 49.704403893364166,
    ],
    '095720131131': [
      11.133869435086138, 49.521410625106206, 11.19420439453313, 49.568232903657254,
    ],
    '095720132132': [
      10.811917017286925, 49.53458114554294, 10.937353055041363, 49.612719099128874,
    ],
    '095720135135': [
      10.744312615125871, 49.64624434247837, 10.934620967549325, 49.786147901778726,
    ],
    '095720137137': [
      11.10802669115274, 49.54270234495276, 11.158280239528342, 49.57679458600448,
    ],
    '095720142142': [
      10.96970462559455, 49.61393266999199, 11.016718227909514, 49.6627782523791,
    ],
    '095720149149': [
      10.88839757135859, 49.65144007084342, 10.94044370094848, 49.68560851273316,
    ],
    '095720160160': [
      10.670727019212553, 49.71747559048915, 10.766111503291722, 49.77998770075133,
    ],
    '095720164164': [
      10.753830920687639, 49.5898857084484, 10.874548495537649, 49.66411157275728,
    ],
    '095725510126': [
      10.825368901301616, 49.66297615452839, 10.876193005495583, 49.70480917576459,
    ],
    '095725510139': [
      10.697158953235922, 49.675469642507615, 10.785750110889778, 49.72722280003671,
    ],
    '095725510143': [
      10.715420775074602, 49.73119798726017, 10.803259639444166, 49.78827225903923,
    ],
    '095725510159': [
      10.59499162812225, 49.6777164419903, 10.727078632476065, 49.72246736845053,
    ],
    '095725512114': [
      10.781839878226618, 49.5509441414152, 10.86193346619753, 49.607458725393485,
    ],
    '095725512147': [
      10.755091524319713, 49.582028237841136, 10.7901392067532, 49.60511301682748,
    ],
    '095725514120': [
      11.038041929738307, 49.58850586302949, 11.067348128611924, 49.598475551601844,
    ],
    '095725514141': [
      11.022223831211953, 49.609111876320924, 11.080195146990366, 49.6368849033123,
    ],
    '095725514154': [
      11.038317174744018, 49.59846040486238, 11.071455415227117, 49.61727583498848,
    ],
    '095725514158': [
      11.060625962641021, 49.58494678228764, 11.116144073821484, 49.61570833425249,
    ],
    '095725539127': [
      10.854395713784792, 49.60815060600749, 10.894603466435296, 49.641623667644765,
    ],
    '095725539133': [
      10.846850429257932, 49.60174745018712, 10.932595853853693, 49.673723298982566,
    ],
    '095730111111': [
      10.822985735952706, 49.41110437736424, 10.881030375788852, 49.434967523869865,
    ],
    '095730114114': [
      10.779253284196214, 49.41925959019466, 10.914836100216775, 49.4952130101263,
    ],
    '095730115115': [
      10.736838654500362, 49.373999230441875, 10.845076840159665, 49.44682364834325,
    ],
    '095730120120': [
      10.7209403331242, 49.44673584206817, 10.84719616382026, 49.52982906720853,
    ],
    '095730122122': [
      10.941725379130359, 49.40374942182857, 10.999109581149126, 49.445494334927815,
    ],
    '095730124124': [
      10.810379007053088, 49.512882957870424, 10.842870547875634, 49.53559801565453,
    ],
    '095730125125': [
      10.824415356407131, 49.355080592408505, 10.955157630315869, 49.42190406592223,
    ],
    '095730127127': [
      10.924788888874076, 49.38144822794508, 11.026497342033409, 49.42424034021483,
    ],
    '095730133133': [
      10.680962603738527, 49.43347514434719, 10.75965579373931, 49.50422617505686,
    ],
    '095730134134': [
      10.869768058036685, 49.40400238054127, 10.985564001260613, 49.46248213816087,
    ],
    '095735517126': [
      10.857710589335767, 49.467123385178766, 10.912071570564011, 49.50054634120955,
    ],
    '095735517130': [
      10.83165667805754, 49.49206756081465, 10.919451607809577, 49.52848542025672,
    ],
    '095735540123': [
      10.88330592076218, 49.50761485977915, 10.934070532077904, 49.5490118276935,
    ],
    '095735540129': [
      10.834834186810726, 49.51961623522002, 10.884546322654794, 49.54270747347337,
    ],
    '095740112112': [
      11.311486075064165, 49.355391696649974, 11.461019262053549, 49.43294662298908,
    ],
    '095740117117': [
      11.266236664543554, 49.30272179578856, 11.389476273912605, 49.37098027939345,
    ],
    '095740123123': [
      11.154031941596513, 49.365524817159844, 11.288705781382115, 49.39728444916243,
    ],
    '095740132132': [
      11.384788819270037, 49.47104182737643, 11.461768807336865, 49.53364757508083,
    ],
    '095740135135': [
      11.379081674390504, 49.52662320176886, 11.464991936165568, 49.61822408884114,
    ],
    '095740138138': [
      11.19014394059437, 49.4655757813205, 11.349722091317863, 49.57319601837162,
    ],
    '095740139139': [
      11.273353763145355, 49.40901393952819, 11.385455656887403, 49.483246385397756,
    ],
    '095740140140': [
      11.488432937213132, 49.57607652842646, 11.598814024605275, 49.67935441741102,
    ],
    '095740141141': [
      11.302678649180562, 49.513955079882535, 11.381594571188899, 49.55434313952337,
    ],
    '095740146146': [
      11.319667438365855, 49.48083317339335, 11.370819833540592, 49.52097426513953,
    ],
    '095740147147': [
      11.453793619830334, 49.45159851075538, 11.595872407784107, 49.553072047988024,
    ],
    '095740150150': [
      11.354833343619191, 49.4998866618254, 11.392974820808607, 49.53892610031021,
    ],
    '095740152152': [
      11.211035567815973, 49.454691495979596, 11.315811408596344, 49.49795280820777,
    ],
    '095740154154': [
      11.2237297598187, 49.48489155863908, 11.267181638570966, 49.508449370267996,
    ],
    '095740155155': [
      11.26350775980796, 49.54466621413803, 11.426442545080702, 49.63256437846746,
    ],
    '095740156156': [
      11.178729361643136, 49.46600976791526, 11.229216224454351, 49.48931557072836,
    ],
    '095740157157': [
      11.203329293374878, 49.32232355634212, 11.322801774747898, 49.376922055162936,
    ],
    '095740158158': [
      11.29454393975071, 49.57560989206811, 11.391842433700612, 49.66870141200867,
    ],
    '095740164164': [
      11.284031158971473, 49.37430040580409, 11.318045728361067, 49.3990386642733,
    ],
    '095745527129': [
      11.462057105135825, 49.55989953696386, 11.561686812743572, 49.61980369568961,
    ],
    '095745527160': [
      11.430399617848806, 49.59476175029409, 11.537837699044035, 49.64450374489457,
    ],
    '095745527161': [
      11.446376728492202, 49.52396213604807, 11.5293286293661, 49.589267148905115,
    ],
    '095745528111': [
      11.485803159727503, 49.4114129975877, 11.57891115308306, 49.45585277622204,
    ],
    '095745528128': [
      11.435676825385546, 49.4229375761052, 11.554302919381493, 49.51056292139802,
    ],
    '095745529120': [
      11.359510436038809, 49.454580173554675, 11.448470509652253, 49.49227100651975,
    ],
    '095745529131': [
      11.370226217232643, 49.48262123578556, 11.420458754433234, 49.50978667359916,
    ],
    '095745529145': [
      11.374542847963934, 49.419037752754924, 11.46425595464349, 49.46557521419464,
    ],
    '095750112112': [
      10.347338837069467, 49.46193900261941, 10.52830692730067, 49.58205233872693,
    ],
    '095750116116': [
      10.478114871347762, 49.70705709436014, 10.654195538490974, 49.755979539748765,
    ],
    '095750119119': [
      10.467646474293344, 49.51765114345516, 10.610616428669834, 49.5711718686498,
    ],
    '095750121121': [
      10.64637070991968, 49.5023586594085, 10.819641969245447, 49.60322206104044,
    ],
    '095750135135': [
      10.43708532758934, 49.49255134865632, 10.583665808087623, 49.57616852474774,
    ],
    '095750145145': [
      10.511035601238289, 49.468612745470956, 10.71068294767387, 49.54234996710304,
    ],
    '095750153153': [
      10.459022535203925, 49.529355518847375, 10.682173782401202, 49.605152587643545,
    ],
    '095750156156': [
      10.420173965055106, 49.41230182251375, 10.556938037432857, 49.48658988449485,
    ],
    '095755518138': [
      10.498246237550903, 49.59645823096195, 10.536950893097783, 49.62736204177358,
    ],
    '095755518144': [
      10.338580157157917, 49.632392551694174, 10.461066786183057, 49.71153942967103,
    ],
    '095755518147': [
      10.507955807116415, 49.656365793378875, 10.5972526681381, 49.725027436430246,
    ],
    '095755518157': [
      10.369819191920786, 49.67956845218552, 10.50975789810539, 49.74878406835012,
    ],
    '095755518161': [
      10.402117507899252, 49.62796738036034, 10.52974841743482, 49.713482040784,
    ],
    '095755518165': [
      10.286044543883394, 49.56834676877852, 10.499889269311634, 49.63418493868347,
    ],
    '095755519122': [
      10.240943174387262, 49.48727816104885, 10.36545892406361, 49.54421937597643,
    ],
    '095755519127': [
      10.131781081655113, 49.5511215929297, 10.225985464193426, 49.58584138595108,
    ],
    '095755519130': [
      10.070577678960595, 49.5341462682429, 10.148220721939799, 49.601521576522295,
    ],
    '095755519134': [
      10.164461024984684, 49.57904190429123, 10.286044543883394, 49.631513836759886,
    ],
    '095755519146': [
      10.257850964868853, 49.5369085849388, 10.381141476261112, 49.61021904282579,
    ],
    '095755519155': [
      10.082445673517872, 49.57482912262348, 10.170432590181637, 49.623495272113,
    ],
    '095755519163': [
      10.076981948930909, 49.47204480614504, 10.179976002937899, 49.552871899074844,
    ],
    '095755519168': [
      10.137901902984863, 49.474490439569514, 10.294262294443177, 49.56101558874997,
    ],
    '095755519179': [
      10.217615952764584, 49.5553559323426, 10.32917565976778, 49.618068164750646,
    ],
    '095755520129': [
      10.726011303763357, 49.51001211204268, 10.78954127390296, 49.55510996690068,
    ],
    '095755520181': [
      10.713894118236038, 49.5566720913015, 10.75899821936784, 49.591586003082526,
    ],
    '095755521113': [
      10.488432813842678, 49.59645823096195, 10.584067647319165, 49.656761256678514,
    ],
    '095755521118': [
      10.548880277992573, 49.576486354901036, 10.701004149179347, 49.621548494713586,
    ],
    '095755521128': [
      10.590036677419473, 49.59435565173174, 10.675410340437132, 49.655867206636906,
    ],
    '095755521150': [
      10.549907332495096, 49.6155900058928, 10.637133778528526, 49.689943806093645,
    ],
    '095755522117': [
      10.650856768342727, 49.62711266617812, 10.783965299568917, 49.66213631576333,
    ],
    '095755522125': [
      10.657692398744706, 49.586937882734496, 10.77410131484772, 49.64061771952438,
    ],
    '095755522167': [
      10.624150687222226, 49.642152141075314, 10.788145283061914, 49.69141350346215,
    ],
    '095755524115': [
      10.275133929412695, 49.412881265180026, 10.37945592153073, 49.50900501007433,
    ],
    '095755524124': [
      10.233787778664126, 49.43182593457475, 10.30489573455998, 49.49656083704805,
    ],
    '095755524133': [
      10.35743180816089, 49.42971610737816, 10.453123242348918, 49.49512140572215,
    ],
    '095755524143': [
      10.333935050659957, 49.41033039430909, 10.405082732650005, 49.47920409391001,
    ],
    '095755525152': [
      10.596341780004865, 49.42153045701651, 10.700415834003062, 49.47823505008636,
    ],
    '095755525166': [
      10.52830692730067, 49.438266928235116, 10.62097543429674, 49.48949062572243,
    ],
    '095760111111': [
      10.854955351689314, 49.19433532897609, 11.007096758018818, 49.272819934340205,
    ],
    '095760113113': [
      11.162078747102832, 49.2049803755921, 11.319627633188697, 49.280215458788554,
    ],
    '095760117117': [
      10.970159405277496, 49.23184910680336, 11.08027241533809, 49.29707679207365,
    ],
    '095760121121': [
      10.95793920498683, 49.153251745456934, 11.098763160530071, 49.238982887250394,
    ],
    '095760122122': [
      11.249045239268138, 48.997956968554355, 11.425757284695104, 49.13340158344988,
    ],
    '095760126126': [
      11.051853600358978, 49.08058729639817, 11.17062475084596, 49.177242526451565,
    ],
    '095760127127': [
      11.118266159988647, 49.12695133151747, 11.327849553158773, 49.217623623531885,
    ],
    '095760128128': [
      10.898319282760646, 49.26311459713513, 11.015235506776891, 49.32908351912449,
    ],
    '095760132132': [
      11.086563649568685, 49.27807068955903, 11.186903354393257, 49.3335263290966,
    ],
    '095760137137': [
      11.040169758915772, 49.272104985165114, 11.094457353799012, 49.31894359738754,
    ],
    '095760141141': [
      10.962772360543624, 49.125128693467985, 11.069249707220676, 49.173503732597965,
    ],
    '095760142142': [
      10.861721106522106, 49.30288358338823, 10.996960706005995, 49.38177773825379,
    ],
    '095760143143': [
      11.03296500498776, 49.176986472796116, 11.214504511542147, 49.29784359793382,
    ],
    '095760147147': [
      10.83792307054386, 49.131301081509314, 10.985454449822129, 49.209558386450276,
    ],
    '095760148148': [
      11.159704814303486, 49.04646249596884, 11.294051473148112, 49.15683719497634,
    ],
    '095760151151': [
      11.081327400885373, 49.29784359793382, 11.251895958286841, 49.37080155299902,
    ],
    '095770114114': [
      10.69600783274326, 49.14134651112044, 10.740668546041533, 49.187468662594796,
    ],
    '095770136136': [
      10.645851908781806, 49.06671551021557, 10.819331638785329, 49.164808922171474,
    ],
    '095770148148': [
      10.853601424622648, 48.86001784130188, 10.974230779653064, 48.92480642864388,
    ],
    '095770158158': [
      10.922162152381253, 48.89652181999094, 11.077413541657561, 48.98253186843943,
    ],
    '095770161161': [
      10.876806745313905, 49.08334305871209, 11.093412784127896, 49.15552864512473,
    ],
    '095770162162': [
      10.66888497695363, 48.898638599357014, 10.798281959175105, 48.96202398939773,
    ],
    '095770168168': [
      10.966725628902516, 48.878673435836575, 11.042958615308049, 48.91386050876894,
    ],
    '095770173173': [
      10.750851251276337, 48.895828097598624, 10.984675219154907, 49.011019243383,
    ],
    '095770177177': [
      10.888445071506842, 48.95856411446986, 11.086393319350961, 49.06383795730658,
    ],
    '095775532111': [
      10.812854612977706, 49.12982361686126, 10.914767020762481, 49.189837081095845,
    ],
    '095775532138': [
      10.734163293359957, 49.119198677408185, 10.859076790777644, 49.204421719812686,
    ],
    '095775532159': [
      10.811226573164983, 49.089648350812936, 10.92247979612022, 49.135771883292875,
    ],
    '095775532172': [
      10.80094905731411, 49.04747613534878, 10.886616738988808, 49.110498827126456,
    ],
    '095775533113': [
      10.834297954320798, 49.00130669390563, 10.899600535263545, 49.0688134316673,
    ],
    '095775533122': [
      10.72901067415957, 49.0339861625279, 10.834297954320798, 49.087333460419416,
    ],
    '095775533149': [
      10.802483194027444, 48.98371516590514, 10.86895400155351, 49.03055263517304,
    ],
    '095775533150': [
      10.764223034869138, 49.00086139600533, 10.85105462721848, 49.04747613534878,
    ],
    '095775534125': [
      10.868307363194766, 49.04495709345616, 10.993693522998514, 49.0970306425126,
    ],
    '095775534127': [
      11.02897472423914, 49.043979061576934, 11.11404672635747, 49.10280857746352,
    ],
    '095775534141': [
      10.975101056545144, 49.040863333162406, 11.048146473889636, 49.09856620979478,
    ],
    '095775535115': [
      11.058764761533466, 49.043979061576934, 11.172521009231676, 49.089304252278446,
    ],
    '095775535120': [
      11.064452651231939, 48.99653114679504, 11.122357432729677, 49.06795330078208,
    ],
    '095775535151': [
      11.10736194683888, 49.01560168994986, 11.201240020026068, 49.06815094274334,
    ],
    '095775535163': [
      11.051956299245518, 48.96294600415418, 11.19000325220724, 49.031024750121986,
    ],
    '095775536133': [
      10.68097219338063, 49.0339145886711, 10.737199272158787, 49.072493981342355,
    ],
    '095775536140': [
      10.684271388109883, 48.949137672876574, 10.81515791634478, 49.04290658483635,
    ],
    '095775536179': [
      10.629044157697543, 48.959901594090034, 10.715279936165919, 49.047108687864814,
    ],
    '096610000000': [
      9.07929139298504, 49.92072133302065, 9.237396609866689, 50.0210541171651,
    ],
    '096620000000': [
      10.166106230186958, 50.00899513254796, 10.27276955120729, 50.09420005873618,
    ],
    '096630000000': [
      9.871797468973305, 49.71114096507976, 10.011205151488511, 49.8476467952885,
    ],
    '096710111111': [
      9.020941747216662, 50.04078233203719, 9.154942864437318, 50.126666652818926,
    ],
    '096710112112': [
      9.222256072375895, 49.92664402104561, 9.301888015339875, 50.00675671311899,
    ],
    '096710114114': [
      8.980116870810107, 50.02536117561873, 9.095874325747918, 50.06300526002973,
    ],
    '096710119119': [
      9.162174996394134, 50.097348928872904, 9.222839722345723, 50.146549910425044,
    ],
    '096710120120': [
      9.126359944194048, 49.99919014864222, 9.15871380670734, 50.01983775287745,
    ],
    '096710121121': [
      9.150727036916974, 49.981698775477234, 9.197057824577096, 50.03057781214792,
    ],
    '096710122122': [
      9.022116357450841, 49.86610635345427, 9.109379832836721, 49.956105599001326,
    ],
    '096710124124': [
      9.180788435424928, 49.941113260675614, 9.235212303704536, 49.97920760120852,
    ],
    '096710130130': [
      9.173804582604301, 49.966202613973046, 9.251851410917766, 50.05501181478403,
    ],
    '096710133133': [
      9.090788611164745, 50.0063557778022, 9.17661072956329, 50.046115215641265,
    ],
    '096710134134': [
      8.988566400855566, 50.06125331574207, 9.036808460441675, 50.11387123882463,
    ],
    '096710136136': [
      9.030789547851091, 49.98807822750372, 9.101817156627057, 50.03513976957104,
    ],
    '096710139139': [
      9.249142398516158, 49.99264546367845, 9.359288503559505, 50.03036636986459,
    ],
    '096710140140': [
      9.064943507363678, 49.9729206807683, 9.110226767734337, 50.02644792764844,
    ],
    '096710143143': [
      9.10250638395604, 50.03426900487088, 9.224254626834357, 50.09786550244251,
    ],
    '096710148148': [
      9.376273211815175, 49.95656967250121, 9.416205907077403, 49.981015720129626,
    ],
    '096710150150': [
      9.229090720609934, 49.99804333149529, 9.28585706204462, 50.05959860332028,
    ],
    '096710155155': [
      9.013900921971231, 49.95545003092959, 9.096392697627518, 50.00998907845596,
    ],
    '096710156156': [
      9.271702958506097, 49.955719274547704, 9.321349064808086, 49.9856433858415,
    ],
    '096710157157': [
      9.345741256998153, 49.924433020639235, 9.376156870123628, 49.941372747557324,
    ],
    '096715602126': [
      9.308135129231056, 50.00993080567653, 9.397985931137198, 50.05758096605041,
    ],
    '096715602128': [
      9.322026164120219, 50.06198370409794, 9.36135355810945, 50.08660061701922,
    ],
    '096715603127': [
      9.24646684979104, 49.85166502558465, 9.340922117056747, 49.90923058944458,
    ],
    '096715603141': [
      9.266268331966304, 49.900378692957496, 9.338683584597323, 49.943987510368714,
    ],
    '096715603160': [
      9.287227768506966, 49.832354049430904, 9.399185218190386, 49.90428648595559,
    ],
    '096715604113': [
      9.214222668241868, 50.05216327703473, 9.255343068108086, 50.07771268853152,
    ],
    '096715604135': [
      9.252118084223094, 50.088920893268266, 9.321188535135764, 50.141829564923675,
    ],
    '096715604138': [
      9.176698653539308, 50.05791805702536, 9.228795096469414, 50.103361952772886,
    ],
    '096715604152': [
      9.199494491029599, 50.076175522069306, 9.277916882170418, 50.122268949186825,
    ],
    '096715604153': [
      9.234498275722789, 50.05711074990578, 9.308270235218764, 50.07715525766247,
    ],
    '096715604159': [
      9.21331748756126, 50.09848405725333, 9.276913748809676, 50.146549910425044,
    ],
    '096715604162': [
      9.34702281675151, 50.092156332409516, 9.388276991456094, 50.12709997344735,
    ],
    '096720112112': [
      10.019189144118764, 50.23861111902495, 10.131732511376065, 50.305858169416844,
    ],
    '096720113113': [
      9.728545567415434, 50.27715664513211, 9.84830250906028, 50.335701207636426,
    ],
    '096720114114': [
      9.968334266678662, 50.143999289887645, 10.142518174244984, 50.25070013412894,
    ],
    '096720117117': [
      9.90249788429116, 50.22730755485371, 10.03847076577185, 50.33957621867054,
    ],
    '096720127127': [
      9.779517349585872, 50.02952526225807, 9.963862432027405, 50.1816469193159,
    ],
    '096720134134': [
      9.73224364499819, 50.34664320448507, 9.808464108887879, 50.42515342521675,
    ],
    '096720135135': [
      10.096548714607737, 50.2053963120836, 10.360908382721158, 50.30582686558076,
    ],
    '096720136136': [
      10.091706488869553, 50.18807059794639, 10.183755691745688, 50.250796732609665,
    ],
    '096720139139': [
      9.848618364475875, 50.163359921137726, 10.007328575348128, 50.23709689745427,
    ],
    '096720140140': [
      10.089943665548684, 50.10374550523715, 10.178853886877683, 50.18970718986946,
    ],
    '096720161161': [
      9.718844904684202, 50.126152224086454, 9.853662194979679, 50.20716951759996,
    ],
    '096720163163': [
      9.781963011806058, 50.32453260802824, 9.95334536177577, 50.4213552127424,
    ],
    '096720166166': [
      9.642125662587718, 50.21765403782015, 9.786060955521181, 50.29607650924477,
    ],
    '096725606126': [
      9.865303550517199, 50.25779744179839, 9.93471392188885, 50.31313592877944,
    ],
    '096725606138': [
      9.751986375540366, 50.24568533078933, 9.865303550517199, 50.303431003092115,
    ],
    '096725606145': [
      9.845778736391608, 50.30556615757682, 9.92780758161398, 50.33876608345791,
    ],
    '096725606149': [
      9.786060955521181, 50.22329462939859, 9.899145575770612, 50.29837154513779,
    ],
    '096725607121': [
      9.928036844710899, 50.08425246827953, 10.01952262259477, 50.179987980766725,
    ],
    '096725607124': [
      9.905600174508805, 50.07047167393105, 9.969661806542248, 50.125943349624,
    ],
    '096725608111': [
      9.982067163204139, 50.14904391918962, 10.03765414553533, 50.19673727958855,
    ],
    '096725608122': [
      9.993006452707558, 50.1370927033882, 10.086656513993237, 50.17835864477794,
    ],
    '096725608142': [
      10.052361563242957, 50.10624396631605, 10.098276168357753, 50.14882669302018,
    ],
    '096725608155': [
      10.0075468883144, 50.09879469149939, 10.07565564779654, 50.14473878836984,
    ],
    '096725609131': [
      10.181908566084607, 50.14512271007638, 10.327991056676561, 50.23674966419663,
    ],
    '096725609143': [
      10.175034867337654, 50.14659469172879, 10.235510383317017, 50.19615585597064,
    ],
    '096725609157': [
      10.284454097677518, 50.171165496989154, 10.369825421432642, 50.23279003783589,
    ],
    '096730114114': [
      10.152117584306485, 50.29073588584288, 10.273547653459275, 50.37791443803296,
    ],
    '096730117117': [
      9.92101671337288, 50.355609196828716, 10.107982837121858, 50.4469923685038,
    ],
    '096730141141': [
      10.413186264876309, 50.23018046811371, 10.551417904873539, 50.33877931728096,
    ],
    '096730149149': [
      9.986984821813245, 50.392906791487825, 10.159839613005609, 50.481761908606344,
    ],
    '096730162162': [
      9.92845850314121, 50.313269250364904, 10.045041057780127, 50.37183351504168,
    ],
    '096735633116': [
      10.116690502093563, 50.352336656196876, 10.236691118993468, 50.438617673621366,
    ],
    '096735633130': [
      10.319768270452586, 50.36390006322597, 10.438574766043605, 50.41552551089134,
    ],
    '096735633142': [
      10.20939807601546, 50.36905763968014, 10.403280218933094, 50.49450300227502,
    ],
    '096735633151': [
      10.234215541886634, 50.37285066401181, 10.326447964399616, 50.42357635894781,
    ],
    '096735633170': [
      10.246474524968644, 50.43253780131753, 10.306368405743289, 50.49815632382773,
    ],
    '096735634113': [
      10.40017426191237, 50.31722104124359, 10.473079147324249, 50.351630669275536,
    ],
    '096735634126': [
      10.331380963707804, 50.22912583876829, 10.393465832158242, 50.28825048702096,
    ],
    '096735634131': [
      10.454969621910072, 50.31585415801971, 10.560745139386457, 50.36446336169555,
    ],
    '096735634134': [
      10.396745410107227, 50.347228510016286, 10.514508988448567, 50.40218401569261,
    ],
    '096735634172': [
      10.51369672195888, 50.206042250304534, 10.611528306043427, 50.278793148866704,
    ],
    '096735634173': [
      10.37434938563521, 50.22237141858514, 10.45144388873828, 50.28943617919976,
    ],
    '096735634174': [
      10.525616935664004, 50.27180241013236, 10.60501488197209, 50.33877931728096,
    ],
    '096735635135': [
      10.11509436357048, 50.30073186243402, 10.188242453226533, 50.34600035404544,
    ],
    '096735635146': [
      10.10276746134131, 50.2804670387601, 10.201936416890781, 50.31009530905159,
    ],
    '096735635156': [
      10.262051496392019, 50.29970934006197, 10.29457211937459, 50.335999542110066,
    ],
    '096735635161': [
      10.177427931743278, 50.281616117455, 10.238719555473258, 50.31560018423085,
    ],
    '096735635163': [
      10.055617069026848, 50.34600035404544, 10.14185067995295, 50.398493964989754,
    ],
    '096735635171': [
      10.20449499019574, 50.26472078922794, 10.292679479822432, 50.30256140544078,
    ],
    '096735635186': [
      10.09411753087168, 50.261906609218165, 10.212625189232917, 50.28968342426519,
    ],
    '096735637123': [
      10.039185239762482, 50.49163184077739, 10.227004418286807, 50.56445293580102,
    ],
    '096735637129': [
      10.030829270360604, 50.47733574098155, 10.155158089599908, 50.51745456220181,
    ],
    '096735637147': [
      10.155461789185726, 50.463341180882686, 10.234883664224322, 50.516251541043104,
    ],
    '096735638133': [
      10.223919169001261, 50.334623245179344, 10.286813673291475, 50.36798190430443,
    ],
    '096735638136': [
      10.27476446219535, 50.33222582185749, 10.379115834399093, 50.38125399664057,
    ],
    '096735638175': [
      10.235301296076557, 50.36278022261247, 10.316070666967168, 50.38989898013219,
    ],
    '096735638183': [
      10.189875642209193, 50.34842758167451, 10.245127669987063, 50.37791443803296,
    ],
    '096735639153': [
      10.080403781999081, 50.422206068280495, 10.257533854900167, 50.49583915407368,
    ],
    '096735639167': [
      10.101736369757907, 50.44371469418837, 10.18777470446937, 50.50148824999122,
    ],
    '096735639182': [
      10.207874811642716, 50.48256760210945, 10.301908433883812, 50.527754182547945,
    ],
    '096735640127': [
      10.349776386530111, 50.28320873745232, 10.453009575996052, 50.33656382405332,
    ],
    '096735640160': [
      10.312066423660728, 50.286550256294575, 10.41414742583106, 50.35270691655399,
    ],
    '096735640184': [
      10.284458225515827, 50.29956775014637, 10.369276206294408, 50.34797984968629,
    ],
    '096740133133': [
      10.60453859109637, 49.92398447118664, 10.741778040988907, 49.996992019010406,
    ],
    '096740147147': [
      10.42343551332617, 50.001638536688596, 10.575313612976375, 50.08246352933773,
    ],
    '096740159159': [
      10.536954029332312, 49.882698625052704, 10.70756423237917, 49.9613029441259,
    ],
    '096740163163': [
      10.446931342077256, 49.93206290210807, 10.582029402792514, 50.02567254191764,
    ],
    '096740164164': [
      10.436322059757316, 50.03868297198237, 10.688354486155118, 50.11516363536123,
    ],
    '096740171171': [
      10.580877861929023, 50.1554207572609, 10.78000418050638, 50.23017628206382,
    ],
    '096740187187': [
      10.459953748103176, 49.85544367674471, 10.662781875922038, 49.93235439051918,
    ],
    '096740195195': [
      10.568010046064146, 49.95398209520119, 10.61583709353442, 50.00471802630949,
    ],
    '096740210210': [
      10.794852748983459, 50.07399857153691, 10.877459882982787, 50.15738381808383,
    ],
    '096740221221': [
      10.55178638025242, 49.9897929286402, 10.670518339320122, 50.05505456750608,
    ],
    '096745610118': [
      10.676169071240182, 50.0050272394505, 10.752962637042463, 50.03332160441911,
    ],
    '096745610129': [
      10.62676426250066, 49.974750198118386, 10.764820960409027, 50.01845472773852,
    ],
    '096745610160': [
      10.660351081471786, 50.01599063443165, 10.751669801584637, 50.0668934177806,
    ],
    '096745610201': [
      10.69806520838242, 49.955139862974065, 10.76092724428798, 49.991599147148506,
    ],
    '096745611130': [
      10.593174430419108, 50.04673710638469, 10.833479756473658, 50.13672508733472,
    ],
    '096745611184': [
      10.67789459337869, 50.12384894872172, 10.80385241860993, 50.174495969728056,
    ],
    '096745611190': [
      10.734448663059673, 50.020457107692465, 10.843656455543377, 50.08638040475071,
    ],
    '096745612111': [
      10.394668103707225, 50.12140956867695, 10.516139735538786, 50.19999448364261,
    ],
    '096745612120': [
      10.45080433143594, 50.16132078769751, 10.59708931455223, 50.236508488605764,
    ],
    '096745612121': [
      10.575916852776158, 50.09742308403087, 10.701564885765716, 50.165627140614795,
    ],
    '096745612149': [
      10.461437028681411, 50.092410553763855, 10.607989998502802, 50.1853038669156,
    ],
    '096745612153': [
      10.379142192308002, 50.08043876702344, 10.499992196743714, 50.13626936328724,
    ],
    '096745612223': [
      10.59055816088564, 50.20006849886487, 10.663919479080013, 50.23178690627175,
    ],
    '096745613139': [
      10.318919236757603, 50.01313879617323, 10.40020264212237, 50.045511150182975,
    ],
    '096745613180': [
      10.379368440181029, 49.99191062569071, 10.47268518163884, 50.072463305053944,
    ],
    '096745613219': [
      10.403510073148817, 49.95750740736057, 10.497600490203316, 50.022133425507576,
    ],
    '096750117117': [
      10.058329891478381, 49.775860303524155, 10.208901890468207, 49.848560247754875,
    ],
    '096750127127': [
      10.42219587243365, 49.74116811466665, 10.553978500911255, 49.82295929739845,
    ],
    '096750141141': [
      10.091040917607119, 49.70855984303196, 10.232465368994317, 49.7914076667813,
    ],
    '096750144144': [
      10.181448734633747, 49.677346170574666, 10.239246044993767, 49.724944699836044,
    ],
    '096750158158': [
      10.29809179012465, 49.78891659087421, 10.443154256813942, 49.87014656619114,
    ],
    '096750165165': [
      10.195186047338037, 49.77603528024551, 10.283735139628641, 49.83391605546448,
    ],
    '096755614111': [
      10.349219164415828, 49.75440802617371, 10.428766831545344, 49.786381657105984,
    ],
    '096755614116': [
      10.323657093380376, 49.71153942967103, 10.434334017908098, 49.76189422234382,
    ],
    '096755614162': [
      10.322380650019499, 49.74978956109049, 10.360550084969601, 49.780737941757884,
    ],
    '096755614178': [
      10.249184508656013, 49.77534654607666, 10.428766831545344, 49.82939202942776,
    ],
    '096755615131': [
      10.209858168082466, 49.73125369554311, 10.280961890092586, 49.77603528024551,
    ],
    '096755615142': [
      10.232465368994317, 49.74902521684618, 10.322791618436966, 49.79834662761164,
    ],
    '096755615177': [
      10.273262548455772, 49.72794970724246, 10.329871404423015, 49.76173510234121,
    ],
    '096755616139': [
      10.238706993509867, 49.622354870684816, 10.387415223214818, 49.734920402085834,
    ],
    '096755616148': [
      10.276472129327589, 49.66796531328293, 10.340772285441254, 49.70414691133604,
    ],
    '096755616161': [
      10.21457930945187, 49.716214436353425, 10.308426210237837, 49.74348228853005,
    ],
    '096755616179': [
      10.193695213052951, 49.618068164750646, 10.292892644302775, 49.695796023043634,
    ],
    '096755617112': [
      10.151885197003343, 49.76098516797302, 10.185103520101425, 49.78448641301453,
    ],
    '096755617113': [
      10.041287370067165, 49.71868919530669, 10.110811041800384, 49.78152905423566,
    ],
    '096755617114': [
      10.101610169479182, 49.75071922811839, 10.153675814331798, 49.76887317968753,
    ],
    '096755617146': [
      10.092207171822979, 49.76163786338243, 10.156863631425031, 49.78690283596022,
    ],
    '096755617170': [
      10.0970859553941, 49.68507870442297, 10.142779847293367, 49.72208642610726,
    ],
    '096755618147': [
      10.0829080762021, 49.62143650263982, 10.17012105752427, 49.691111253346016,
    ],
    '096755618149': [
      10.130920336037319, 49.67945156153408, 10.19337487924342, 49.713436497518636,
    ],
    '096755618150': [
      10.116392691519897, 49.59288210492348, 10.199635901073366, 49.6538233065343,
    ],
    '096755618156': [
      10.147096623725252, 49.637839671597014, 10.1916637656223, 49.68631382868081,
    ],
    '096755618166': [
      10.12503373937222, 49.668341718216716, 10.147911104733385, 49.68953799085091,
    ],
    '096755618167': [
      10.176350439461004, 49.62538703810857, 10.260531643972696, 49.67945156153408,
    ],
    '096755619155': [
      10.165582211793426, 49.83904598878608, 10.207324055176235, 49.865534338030095,
    ],
    '096755619169': [
      10.175527910811894, 49.820377018485615, 10.237855326030578, 49.84368514655378,
    ],
    '096755619174': [
      10.163830292500597, 49.819105745365725, 10.318958166750681, 49.91562081419769,
    ],
    '096760112112': [
      9.089235758652327, 49.57870585540061, 9.307141638368046, 49.69714713002777,
    ],
    '096760117117': [
      9.263154890846607, 49.7314219401116, 9.361242589998064, 49.813747312923184,
    ],
    '096760118118': [
      9.342502144293753, 49.77027703345319, 9.406093416752375, 49.81670427967804,
    ],
    '096760119119': [
      9.307141638368046, 49.64316149877002, 9.41730446509835, 49.73139357357327,
    ],
    '096760121121': [
      9.14602771800574, 49.80233686563493, 9.254327773360753, 49.86661168481569,
    ],
    '096760122122': [
      9.135947835425139, 49.78557318022183, 9.226319094667868, 49.832928729078354,
    ],
    '096760123123': [
      9.228902147122763, 49.79980890482521, 9.362432299148079, 49.86666577015627,
    ],
    '096760124124': [
      9.42780208829638, 49.76947867106783, 9.46959398855511, 49.820275831261426,
    ],
    '096760125125': [
      9.183116802458969, 49.70848014657092, 9.269090625954961, 49.760621103195966,
    ],
    '096760126126': [
      9.10450706500466, 49.85410997440082, 9.163592605703919, 49.893479989959644,
    ],
    '096760131131': [
      9.066078684894867, 49.57387921411215, 9.226357805525977, 49.660364219466196,
    ],
    '096760134134': [
      9.128174040651203, 49.741676846581754, 9.224009485634447, 49.79206119225312,
    ],
    '096760136136': [
      9.188544810387897, 49.86661168481569, 9.28122713066998, 49.921567769159246,
    ],
    '096760139139': [
      9.121039391701954, 49.65493352636285, 9.372237262878938, 49.72446607896691,
    ],
    '096760140140': [
      9.033875316416474, 49.83190941387061, 9.11762929469692, 49.881457061231195,
    ],
    '096760144144': [
      9.093016772404518, 49.87457765300686, 9.154882402546109, 49.938675583284294,
    ],
    '096760145145': [
      9.076797138646873, 49.789898352626196, 9.155820850805634, 49.85798934039974,
    ],
    '096760156156': [
      9.233717309945993, 49.581273505374696, 9.287220073386223, 49.6598321597885,
    ],
    '096760160160': [
      9.143370225630392, 49.89055212016088, 9.247912683573682, 49.93674304917581,
    ],
    '096760165165': [
      9.103711538436054, 49.650890548755775, 9.273647094093176, 49.70420070039184,
    ],
    '096760169169': [
      9.10631272750182, 49.75558269646585, 9.175977740610872, 49.81089736062207,
    ],
    '096765626116': [
      9.258582177969693, 49.70491997682382, 9.354933514023465, 49.741359732389185,
    ],
    '096765626143': [
      9.357624611861842, 49.67650356986821, 9.42080796212547, 49.730774039789,
    ],
    '096765627132': [
      9.135631540559757, 49.70761108508682, 9.228622673387003, 49.73501229731127,
    ],
    '096765627135': [
      9.141674758591202, 49.73011742459342, 9.187360611381049, 49.753683234774016,
    ],
    '096765627153': [
      9.153024443580016, 49.70130955020155, 9.197014383437388, 49.72038462675085,
    ],
    '096765630128': [
      9.1935796330194, 49.85372644805234, 9.24646684979104, 49.89055212016088,
    ],
    '096765630133': [
      9.154882402546109, 49.84143061144166, 9.232112741259911, 49.89697150752163,
    ],
    '096765631141': [
      9.205632963292501, 49.765274734335584, 9.320550038318864, 49.81373238074628,
    ],
    '096765631151': [
      9.223517425972798, 49.74337008623749, 9.295605731781714, 49.78468009255182,
    ],
    '096765632111': [
      9.356774603274479, 49.79927921422792, 9.453105756478202, 49.880538293067765,
    ],
    '096765632158': [
      9.356391859875101, 49.7771980918053, 9.433535857105221, 49.82483861982076,
    ],
    '096770114114': [
      9.864852417283174, 49.931097330123755, 10.045311787476647, 50.05590845447664,
    ],
    '096770127127': [
      9.763262411783542, 49.96036182327746, 9.92532975090587, 50.054730101581036,
    ],
    '096770129129': [
      9.383822401038703, 50.045185188878065, 9.508655323133128, 50.08573994669194,
    ],
    '096770131131': [
      9.56327550504691, 49.99454162840352, 9.786922273035714, 50.112730867095145,
    ],
    '096770148148': [
      9.619869013867847, 49.91886359672504, 9.870869821873058, 50.021130353027786,
    ],
    '096770154154': [
      9.546877958998522, 49.77872342368878, 9.65151827175236, 49.83066598323952,
    ],
    '096770155155': [
      9.479454347184966, 49.94063837145664, 9.679466570242681, 50.10563135396098,
    ],
    '096770157157': [
      9.501650766447135, 49.804478460038276, 9.632281307428647, 49.91236599885378,
    ],
    '096770177177': [
      9.58151557450657, 50.076426319095596, 9.692721533910861, 50.124270639827,
    ],
    '096775620137': [
      9.447591088313745, 49.76947867106783, 9.510810842696817, 49.820275831261426,
    ],
    '096775620151': [
      9.494776775914238, 49.74430369395235, 9.569041236007282, 49.82471355015286,
    ],
    '096775620182': [
      9.43346138332219, 49.81557448060816, 9.51473833519986, 49.8522901632577,
    ],
    '096775621119': [
      9.673190193397245, 49.83256282498243, 9.763969988904774, 49.88981841484885,
    ],
    '096775621120': [
      9.422139002115667, 49.837409926796205, 9.523930504658335, 49.92650081159726,
    ],
    '096775621125': [
      9.591270473129079, 49.8026583423869, 9.676496194059052, 49.842944207680304,
    ],
    '096775621126': [
      9.495363527363468, 49.835470512474515, 9.552225010342045, 49.893496757516495,
    ],
    '096775621135': [
      9.547780466501885, 49.85033668297451, 9.607275947634205, 49.89043500288278,
    ],
    '096775621146': [
      9.599944084059905, 49.83417232625846, 9.684454102099382, 49.89171539763192,
    ],
    '096775621178': [
      9.579699410146892, 49.885196006702905, 9.657450492548698, 49.93680824437423,
    ],
    '096775621181': [
      9.516637094004857, 49.879050909730395, 9.599944084059905, 49.936235473602764,
    ],
    '096775621193': [
      9.650853355652943, 49.875792805045016, 9.708229537813798, 49.930975375885915,
    ],
    '096775622116': [
      9.509941921073864, 50.1573901416956, 9.60015931454855, 50.194761062055065,
    ],
    '096775622122': [
      9.55633306740284, 50.10180768686679, 9.713805234683537, 50.19458922563798,
    ],
    '096775622128': [
      9.508996309144367, 50.099318552253955, 9.613996490099845, 50.17139586589011,
    ],
    '096775622159': [
      9.58544988360973, 50.17139586589011, 9.661426261937992, 50.20727510793651,
    ],
    '096775622169': [
      9.582540517039574, 50.19859868361526, 9.654038676256299, 50.23101852188346,
    ],
    '096775623132': [
      9.735399239327617, 50.000452608697096, 9.81312589775837, 50.03443227769638,
    ],
    '096775623133': [
      9.679790619024438, 50.07275720965269, 9.805730996348665, 50.172304432235684,
    ],
    '096775623149': [
      9.737797441544432, 50.02789747076015, 9.836825600917189, 50.09377159647365,
    ],
    '096775624164': [
      9.576764571873245, 50.02130538066114, 9.653728204271673, 50.04531158046933,
    ],
    '096775624166': [
      9.49992445991352, 49.91024368413474, 9.601360575544398, 49.961396260293824,
    ],
    '096775624172': [
      9.497694869426699, 49.97001773519505, 9.552213016964854, 49.99196847647206,
    ],
    '096775624186': [
      9.598954510103692, 49.92096502752191, 9.716124873849786, 49.98409504480078,
    ],
    '096775625142': [
      9.738214495949721, 49.90742724933312, 9.829588900696251, 49.94363210023453,
    ],
    '096775625175': [
      9.846231195712303, 49.88823416899905, 9.92713144906418, 49.93215479145435,
    ],
    '096775625189': [
      9.829588900696251, 49.91902965969397, 9.899704217917838, 49.963408710083236,
    ],
    '096775625203': [
      9.699419772579727, 49.870360084117515, 9.856074487130739, 49.92358035129138,
    ],
    '096775656165': [
      9.395940268200622, 49.9898115726233, 9.445744654946004, 50.01784939330439,
    ],
    '096775656170': [
      9.49432208394678, 50.023338078057755, 9.54944781649484, 50.06952169092518,
    ],
    '096775656200': [
      9.395161124890608, 50.01383138945933, 9.473471002944725, 50.04802549545928,
    ],
    '096780115115': [
      10.137635743657567, 49.96205644874876, 10.199779608779977, 50.029817736440734,
    ],
    '096780123123': [
      10.168855293350102, 50.066206910871216, 10.233833629752276, 50.14942181252281,
    ],
    '096780128128': [
      10.059567043130183, 50.043802606634095, 10.144336164362644, 50.101977484462424,
    ],
    '096780132132': [
      10.082448106156173, 50.01960002003758, 10.186459092975632, 50.062690955029474,
    ],
    '096780135135': [
      10.236135329349894, 49.99261571459588, 10.336034074610634, 50.040738594365905,
    ],
    '096780136136': [
      10.173133185389593, 49.96790302357145, 10.236720718581283, 50.01381062423246,
    ],
    '096780138138': [
      10.27272723710493, 49.953514030188956, 10.399423821387458, 50.020138506575385,
    ],
    '096780150150': [
      10.181081653961723, 49.880936137613695, 10.317111930866945, 49.979555296772425,
    ],
    '096780160160': [
      10.132991266962641, 50.05425390320483, 10.202865059332963, 50.08361978857903,
    ],
    '096780168168': [
      10.07207036868343, 50.071157514664726, 10.202865059332963, 50.15404415847088,
    ],
    '096780170170': [
      10.178964205255634, 49.933987070927664, 10.256661062575896, 49.99798496435517,
    ],
    '096780174174': [
      10.264446056386321, 50.0243550457767, 10.436322059757316, 50.13963739717934,
    ],
    '096780176176': [
      10.236135329349894, 49.97829347482687, 10.28516373118012, 50.01345441952439,
    ],
    '096780178178': [
      10.241033418720898, 50.020664250097994, 10.289718167654845, 50.053661553100774,
    ],
    '096780181181': [
      10.319466042199556, 50.1337821580138, 10.45080433143594, 50.23153319472656,
    ],
    '096780186186': [
      10.218405822063163, 50.067507431383994, 10.362970433620314, 50.162089239103885,
    ],
    '096780190190': [
      10.085974103366468, 49.93098508199205, 10.18702963802127, 49.97721148464244,
    ],
    '096780192192': [
      9.957696344306875, 50.032306877923894, 10.092519178681345, 50.10833640739939,
    ],
    '096780193193': [
      10.000895707865798, 49.92860596999281, 10.148241978775715, 50.04379446167439,
    ],
    '096785642122': [
      10.37359217415601, 49.89180219092489, 10.423691555781758, 49.932211820720944,
    ],
    '096785642124': [
      10.362424149707929, 49.93058281538238, 10.446931342077256, 49.998111282775355,
    ],
    '096785642130': [
      10.279829356961686, 49.870415246944894, 10.343648728824979, 49.925949660489664,
    ],
    '096785642134': [
      10.309412281584544, 49.880228321958725, 10.414452053070002, 49.92506695871559,
    ],
    '096785642153': [
      10.299787677561838, 49.85530599871496, 10.37654371905474, 49.886219032718884,
    ],
    '096785642157': [
      10.409488582714813, 49.89761529496638, 10.472609683642508, 49.9498093519413,
    ],
    '096785642164': [
      10.37314817078385, 49.82073494999598, 10.462095447567934, 49.88513352608758,
    ],
    '096785642183': [
      10.296837973266179, 49.920976028296636, 10.39942210616552, 49.97620545694618,
    ],
    '096785643175': [
      10.099622979112146, 49.90223291827641, 10.16355050296323, 49.939596693153106,
    ],
    '096785643196': [
      10.152591502351505, 49.90396741627663, 10.188819385593336, 49.93982099861358,
    ],
    '096790126126': [
      9.808044550031129, 49.74719239524262, 9.850221254076855, 49.77545801221439,
    ],
    '096790134134': [
      9.954272293641909, 49.59962049804153, 10.048920425458471, 49.66297323624675,
    ],
    '096790136136': [
      9.976641820324199, 49.77151503311986, 10.032535414948766, 49.790200069192245,
    ],
    '096790142142': [
      9.861693126057112, 49.8476467952885, 9.94292428818845, 49.89382466441186,
    ],
    '096790143143': [
      9.985600161711263, 49.89705806144742, 10.06997776573113, 49.953428794652,
    ],
    '096790147147': [
      9.841198546393462, 49.75713598809606, 9.908104597099719, 49.792497917777226,
    ],
    '096790155155': [
      9.823214478574165, 49.685850905058224, 9.859828720534558, 49.733280143283146,
    ],
    '096790156156': [
      10.010467850801229, 49.823634751063686, 10.086833355500984, 49.85512114819351,
    ],
    '096790164164': [
      9.627771699948992, 49.68741192927868, 9.71491920156924, 49.75398476219355,
    ],
    '096790170170': [
      9.980994042897457, 49.59315975176829, 10.108142860877743, 49.725167350793456,
    ],
    '096790175175': [
      9.953704747602057, 49.72399807137532, 10.056981596311813, 49.77603858625089,
    ],
    '096790176176': [
      9.873133544242942, 49.6806026019388, 9.992098339156831, 49.744903797907796,
    ],
    '096790180180': [
      9.918218165351814, 49.83377396205074, 9.99856948578705, 49.9427659981218,
    ],
    '096790185185': [
      10.00002432919544, 49.773778139231524, 10.06687733921636, 49.82554108509539,
    ],
    '096790193193': [
      10.00418451690149, 49.74043072285406, 10.060796641867043, 49.77684565005541,
    ],
    '096790194194': [
      9.828121891458492, 49.84786254159861, 9.8828108184499, 49.895039828447864,
    ],
    '096790200200': [
      9.744172383862965, 49.82365312523482, 9.836271700140744, 49.88087569997171,
    ],
    '096790201201': [
      9.978084136965826, 49.848080614754565, 10.082759399329587, 49.903448919859706,
    ],
    '096790202202': [
      9.864592795377497, 49.822689373893255, 9.919058758285612, 49.859752016863624,
    ],
    '096790204204': [
      9.768698482665, 49.741256749662654, 9.81074919809139, 49.77485093137378,
    ],
    '096790205205': [
      9.751148714460234, 49.76634351453871, 9.854920619792837, 49.806702224761366,
    ],
    '096790209209': [
      9.825865551473187, 49.783717560214924, 9.886946985683455, 49.82625491896249,
    ],
    '096795644114': [
      10.003266734464512, 49.52055839600693, 10.083730158808702, 49.567981791983534,
    ],
    '096795644135': [
      9.993221753850307, 49.54735539653243, 10.073772351280065, 49.597114682105435,
    ],
    '096795644188': [
      9.941687581011253, 49.567115316965165, 10.051644726592079, 49.605500066056244,
    ],
    '096795645117': [
      10.03204141671467, 49.88542016056814, 10.1521821950744, 49.9321283196585,
    ],
    '096795645169': [
      10.068153785668544, 49.85331483309174, 10.110250370743456, 49.89245936134631,
    ],
    '096795646124': [
      9.983044457777147, 49.71058780129711, 10.03678673965929, 49.736271349943024,
    ],
    '096795646131': [
      10.06158683040157, 49.6616558337829, 10.134173502464526, 49.70477094877747,
    ],
    '096795646187': [
      10.018741663237696, 49.68043820789636, 10.06045708167211, 49.71344767722764,
    ],
    '096795646206': [
      9.972793985311304, 49.68907050080706, 10.023143410600474, 49.736271349943024,
    ],
    '096795647130': [
      9.986703054822637, 49.80267399039961, 10.049444998424098, 49.87204762615678,
    ],
    '096795647167': [
      10.141292958832441, 49.85746613238708, 10.189230177314203, 49.913201474479244,
    ],
    '096795647174': [
      10.082212511031265, 49.837191207865665, 10.165582211793426, 49.89082380863499,
    ],
    '096795648122': [
      9.809725450671268, 49.54629518957419, 9.944531978358793, 49.629599670280285,
    ],
    '096795648138': [
      9.877143769774486, 49.59528128351018, 9.986621227770184, 49.69144120306491,
    ],
    '096795649144': [
      9.640444657455665, 49.739141233163316, 9.765050300370659, 49.77513236266691,
    ],
    '096795649149': [
      9.65044383929966, 49.76623769660777, 9.707532112108908, 49.792109817163684,
    ],
    '096795649177': [
      9.65044383929966, 49.78434934576734, 9.727300699422123, 49.83687912191207,
    ],
    '096795649196': [
      9.697832337730155, 49.76397741172204, 9.75469554588423, 49.81357382644024,
    ],
    '096795650137': [
      9.857526548718765, 49.6647535189908, 9.920422976647416, 49.69535420886465,
    ],
    '096795650153': [
      9.824334945002537, 49.62554389382118, 9.90475334427768, 49.681315009681306,
    ],
    '096795651154': [
      9.826245802307701, 49.73102121278503, 9.85092128291557, 49.75713598809606,
    ],
    '096795651165': [
      9.711111806403375, 49.687167194072146, 9.797197293804974, 49.749600733278655,
    ],
    '096795652128': [
      9.828458951890564, 49.84462423178819, 9.859928628207173, 49.87531039331143,
    ],
    '096795652161': [
      9.831120197798061, 49.822689373893255, 9.871797468973305, 49.85210550529613,
    ],
    '096795654118': [
      9.983533409822158, 49.48539487491737, 10.057557030693504, 49.52822114818234,
    ],
    '096795654179': [
      9.899935910569646, 49.535175132395, 10.003266734464512, 49.58267902477237,
    ],
    '096795654182': [
      9.916660749827816, 49.48409585778379, 10.018937151652809, 49.54735539653243,
    ],
    '096795654192': [
      9.913550330321225, 49.482791730077594, 9.96081546660669, 49.51605346668274,
    ],
    '096795655141': [
      9.725273188163085, 49.8033104507357, 9.80630278694971, 49.84354150914367,
    ],
    '096795655146': [
      9.787113358875711, 49.780668953019976, 9.854920619792837, 49.82526285666292,
    ],
    '097610000000': [
      10.76445101664972, 48.258181326131066, 10.958824846504495, 48.46007874697461,
    ],
    '097620000000': [
      10.552706946367737, 47.8413951029887, 10.660883386824846, 47.92178674043674,
    ],
    '097630000000': [
      10.236370992890501, 47.694866440934234, 10.377452543059041, 47.778143742379186,
    ],
    '097640000000': [
      10.088877477957581, 47.91664309108091, 10.232811912751071, 48.045189329023515,
    ],
    '097710112112': [
      10.896337305335217, 48.41418443519623, 11.030384770349672, 48.48118983133569,
    ],
    '097710113113': [
      11.012351001752007, 48.397982085680034, 11.21439889555042, 48.503309026000494,
    ],
    '097710130130': [
      10.93343975337976, 48.29774093840757, 11.080475229906977, 48.43100769332284,
    ],
    '097710140140': [
      11.020579902261742, 48.45445855436113, 11.113906293381882, 48.522974616524984,
    ],
    '097710141141': [
      11.06215200017601, 48.48690769592286, 11.145636916238486, 48.551197527733876,
    ],
    '097710142142': [
      10.944941513195326, 48.28091654459894, 11.022864134421004, 48.333213256666966,
    ],
    '097710145145': [
      10.91066446272714, 48.22378074977499, 11.058313556896213, 48.26813157098464,
    ],
    '097710158158': [
      10.872132885261307, 48.45943449066456, 10.969784584295379, 48.50951473192622,
    ],
    '097710160160': [
      11.007612915093006, 48.26002506370131, 11.126366814189707, 48.316989024570546,
    ],
    '097715701114': [
      10.937797068432221, 48.46834564356548, 11.034467145672524, 48.546461467168484,
    ],
    '097715701155': [
      10.980354741361838, 48.49593289290256, 11.05186870709915, 48.55047476456764,
    ],
    '097715701169': [
      10.866007418849593, 48.49552561332902, 10.949806965063798, 48.54075767678103,
    ],
    '097715703144': [
      11.12636160939096, 48.47203192735738, 11.248550300054719, 48.54812029828581,
    ],
    '097715703162': [
      11.193723971607087, 48.43062682333435, 11.30881206561837, 48.477465872495806,
    ],
    '097715704111': [
      11.068960435308027, 48.33651417691063, 11.17305151692965, 48.37539609769592,
    ],
    '097715704122': [
      10.996851754476886, 48.35783850890174, 11.142341631198166, 48.420010548172755,
    ],
    '097715704129': [
      11.053875516197456, 48.31104585983221, 11.174144079279365, 48.35560062903807,
    ],
    '097715704149': [
      11.014624669105624, 48.409329651422375, 11.085909438097557, 48.440268767944886,
    ],
    '097715704165': [
      11.108870877933938, 48.365921052662486, 11.198289650399031, 48.41742054284155,
    ],
    '097715705146': [
      10.940500180443351, 48.24596384272798, 11.063455426844893, 48.28879462176676,
    ],
    '097715705163': [
      10.903779875946011, 48.19891686794292, 10.982506819071538, 48.25279829747757,
    ],
    '097715705168': [
      10.980869561035872, 48.19491806500124, 11.061163178828089, 48.23023513698765,
    ],
    '097715771156': [
      10.977935134942898, 48.51981562410907, 11.1651449068167, 48.62036032962978,
    ],
    '097715771176': [
      10.924306260832076, 48.56450742463182, 11.00730695934039, 48.60100622180265,
    ],
    '097720111111': [
      10.6813418232899, 48.40826243148123, 10.752508260472373, 48.437298623608775,
    ],
    '097720115115': [
      10.528044386854846, 48.42034092851287, 10.644783863046213, 48.49880865999193,
    ],
    '097720117117': [
      10.732574026649432, 48.39214773530224, 10.797998305147255, 48.41849913421624,
    ],
    '097720121121': [
      10.710015822935391, 48.46910618412555, 10.85333661, 48.545651035151316,
    ],
    '097720125125': [
      10.672024431918993, 48.24158977992956, 10.87358047204139, 48.30693536885592,
    ],
    '097720130130': [
      10.712679306492388, 48.30403320030294, 10.80482674967914, 48.39726606114573,
    ],
    '097720131131': [
      10.496509545026713, 48.28252074438344, 10.668475798533164, 48.38373720900274,
    ],
    '097720141141': [
      10.59461680319618, 48.245936514124075, 10.69141522378081, 48.32235375559209,
    ],
    '097720145145': [
      10.751190601105996, 48.43265489459076, 10.869334385820212, 48.4793597680649,
    ],
    '097720147147': [
      10.737730687192439, 48.403321541487536, 10.889643457763455, 48.45943449066456,
    ],
    '097720149149': [
      10.797730274711943, 48.1788145152975, 10.87934495986981, 48.20687480201814,
    ],
    '097720159159': [
      10.627726020428002, 48.37681351145144, 10.743641087796487, 48.417421994156676,
    ],
    '097720163163': [
      10.855066262964343, 48.22800672838533, 10.910723187688712, 48.292944330933594,
    ],
    '097720167167': [
      10.651925738617905, 48.31827704593292, 10.743641087796487, 48.38729557584509,
    ],
    '097720171171': [
      10.770955768629127, 48.45666442416386, 10.885946344414862, 48.506915415632186,
    ],
    '097720177177': [
      10.762441630692573, 48.50622826608774, 10.87306158679187, 48.587843363794015,
    ],
    '097720184184': [
      10.758026147918942, 48.36680133502337, 10.85943857772689, 48.41849913421624,
    ],
    '097720200200': [
      10.661972272641151, 48.16052587027182, 10.803050627392444, 48.22968743157643,
    ],
    '097720202202': [
      10.797602913988369, 48.34171202486091, 10.859199698639479, 48.3782177454268,
    ],
    '097720207207': [
      10.871480655212222, 48.53225792762992, 10.989849724261795, 48.60002842033446,
    ],
    '097720215215': [
      10.760515093849271, 48.23058418593357, 10.840259328071731, 48.268970425921275,
    ],
    '097720223223': [
      10.506428524639558, 48.35804007751815, 10.696837414149723, 48.45281264825985,
    ],
    '097725706114': [
      10.779706828839926, 48.602723529055176, 10.844722353578511, 48.635394826271174,
    ],
    '097725706134': [
      10.765487432252268, 48.571957819656596, 10.817129703039807, 48.60878067235546,
    ],
    '097725706136': [
      10.842974053217432, 48.587289488415074, 10.88709707774786, 48.63811898771471,
    ],
    '097725706166': [
      10.771394599646602, 48.55386937381909, 10.827819895462834, 48.58431992109046,
    ],
    '097725706185': [
      10.807460321588012, 48.57427636698359, 10.852339991359496, 48.606732670528665,
    ],
    '097725706217': [
      10.824350529388342, 48.55386937381909, 10.856294906492401, 48.587289488415074,
    ],
    '097725707126': [
      10.678190699607377, 48.433111875357625, 10.753200692978568, 48.45305431697866,
    ],
    '097725707137': [
      10.642399482072449, 48.45226842624715, 10.70064404680297, 48.49731348851612,
    ],
    '097725707156': [
      10.692402146077297, 48.444528362728384, 10.76771657621883, 48.48317849559533,
    ],
    '097725707216': [
      10.608057232729381, 48.43088523463968, 10.688476620343181, 48.480019601626104,
    ],
    '097725708148': [
      10.668767660667713, 48.25969400145688, 10.759920963900463, 48.358193227501985,
    ],
    '097725708211': [
      10.616188678017766, 48.30063830983293, 10.665260918441811, 48.343173456057045,
    ],
    '097725709168': [
      10.571360784271768, 48.24150645121243, 10.638121857329013, 48.27865639482303,
    ],
    '097725709178': [
      10.599685935674431, 48.196006033215276, 10.665630199327678, 48.25022866321056,
    ],
    '097725709179': [
      10.544593615300217, 48.15730567275902, 10.627604530519772, 48.20738008484275,
    ],
    '097725709197': [
      10.618981693889275, 48.164829740903855, 10.668989852355818, 48.2224663703148,
    ],
    '097725709214': [
      10.560003194269692, 48.206703891905406, 10.615245948347896, 48.247267507538716,
    ],
    '097725710151': [
      10.643811480070278, 48.20569182114391, 10.831094188256392, 48.254452319803505,
    ],
    '097725710160': [
      10.81980266063446, 48.19121549364001, 10.898190497308383, 48.23058418593357,
    ],
    '097725710186': [
      10.831094188256392, 48.20823783245029, 10.899350431360698, 48.24894584649138,
    ],
    '097725711162': [
      10.825261020431945, 48.14708313380433, 10.847977703188732, 48.163200928499585,
    ],
    '097725711209': [
      10.780009145652688, 48.14996700362366, 10.874554330722633, 48.18082024196774,
    ],
    '097725712157': [
      10.68427226414768, 48.12976893911094, 10.747419246582801, 48.177674467880806,
    ],
    '097725712170': [
      10.685401337616653, 48.09212716240273, 10.802114849971595, 48.16777319852637,
    ],
    '097730117117': [
      10.496868379783676, 48.68068333615034, 10.660436694188896, 48.75739906650528,
    ],
    '097730122122': [
      10.63786036190631, 48.56945228094929, 10.78538421943247, 48.66272531765409,
    ],
    '097730125125': [
      10.441214833416739, 48.53512760350828, 10.625976789811954, 48.61992811178328,
    ],
    '097730144144': [
      10.357549714984714, 48.52082962080951, 10.494889202141762, 48.60754863332474,
    ],
    '097735713113': [
      10.303012747932359, 48.52205952226501, 10.342944811443507, 48.550730246223296,
    ],
    '097735713136': [
      10.27124411691494, 48.47862294519146, 10.408716525244419, 48.58200415682008,
    ],
    '097735713137': [
      10.322756170479082, 48.58200415682008, 10.396497241625307, 48.629048874497684,
    ],
    '097735713153': [
      10.293899038785584, 48.549418666197404, 10.364571739614822, 48.60521957633571,
    ],
    '097735714112': [
      10.29602161933567, 48.60521957633571, 10.378306120579353, 48.66016426058013,
    ],
    '097735714170': [
      10.254213505198276, 48.63374648957228, 10.328624407537323, 48.68354981273595,
    ],
    '097735714187': [
      10.268500238246542, 48.65802328294631, 10.350645701469812, 48.702371563695166,
    ],
    '097735715147': [
      10.410719968345706, 48.61113603850545, 10.49539984250179, 48.6706594258332,
    ],
    '097735715183': [
      10.381381023902838, 48.594715796566916, 10.465524769999766, 48.63489654004629,
    ],
    '097735715186': [
      10.362903857365945, 48.62409946643655, 10.4362193283271, 48.697356337601455,
    ],
    '097735716119': [
      10.576482644343127, 48.59588208278422, 10.652082109918018, 48.69371590195391,
    ],
    '097735716139': [
      10.514924308140584, 48.58803604556363, 10.630259103307305, 48.683709171780684,
    ],
    '097735716146': [
      10.496868379783676, 48.631168494833176, 10.568481310371155, 48.70531426457646,
    ],
    '097735716150': [
      10.46495720058688, 48.61004581184262, 10.531702316826628, 48.697956025748866,
    ],
    '097735716164': [
      10.621241285418945, 48.610092076900166, 10.707527557872645, 48.67809591026015,
    ],
    '097735718116': [
      10.61076868275018, 48.54277594275798, 10.663549245714224, 48.59588208278422,
    ],
    '097735718143': [
      10.658778165690817, 48.48008666563801, 10.764802611599427, 48.54236853173496,
    ],
    '097735718179': [
      10.564658098477564, 48.490616455309414, 10.638739397803276, 48.54746112532259,
    ],
    '097735718182': [
      10.627942345743088, 48.51154827444144, 10.780901553747764, 48.59893072251226,
    ],
    '097735718188': [
      10.580670447743687, 48.49010217633885, 10.671779698640652, 48.552297353191406,
    ],
    '097735719111': [
      10.426072693799128, 48.479747392002324, 10.474786792968368, 48.5350304713276,
    ],
    '097735719133': [
      10.465229596299633, 48.47529007982476, 10.513967082086676, 48.53635547739434,
    ],
    '097735719140': [
      10.486994637349605, 48.471379974965814, 10.590182763936147, 48.543257134896294,
    ],
    '097740116116': [
      10.406322794314733, 48.2069699463845, 10.477453915028093, 48.28713327659135,
    ],
    '097740119119': [
      10.164697265846282, 48.365977646144145, 10.244279522165975, 48.438851684417294,
    ],
    '097740121121': [
      10.328777843624241, 48.40430981625955, 10.432369186412283, 48.465200852281924,
    ],
    '097740122122': [
      10.387501447157046, 48.323079329750925, 10.519152797175877, 48.374187806022455,
    ],
    '097740135135': [
      10.225516918162594, 48.41788220221439, 10.337121396613147, 48.52021470924099,
    ],
    '097740144144': [
      10.391785675129533, 48.34962600010293, 10.54822733267596, 48.42942279564025,
    ],
    '097740145145': [
      10.321500294549308, 48.32095200326211, 10.410358702891703, 48.42282020094552,
    ],
    '097740150150': [
      10.336343308162716, 48.203603900076885, 10.433762701737043, 48.296202256419974,
    ],
    '097740155155': [
      10.131766984610204, 48.40658344231146, 10.242749788397365, 48.48851269962613,
    ],
    '097740162162': [
      10.323269049369436, 48.272022916897434, 10.439749374637339, 48.33467053653599,
    ],
    '097745727136': [
      10.380671968451413, 48.48232448234555, 10.428091447164288, 48.527178282850066,
    ],
    '097745727171': [
      10.313656592215377, 48.461061400333136, 10.420315408337048, 48.50035525119437,
    ],
    '097745727174': [
      10.323491735148592, 48.434164833742024, 10.387339707898818, 48.47323624214288,
    ],
    '097745728127': [
      10.386871564295026, 48.44260768334837, 10.468927639557783, 48.48454473072091,
    ],
    '097745728140': [
      10.415629015613023, 48.42880337401004, 10.514747171416003, 48.46868969491688,
    ],
    '097745728151': [
      10.478813399801817, 48.41745200691914, 10.541411469697504, 48.450528134578036,
    ],
    '097745728178': [
      10.427139917952765, 48.41750525050017, 10.498689532772545, 48.43836922753846,
    ],
    '097745728196': [
      10.459995420797997, 48.444982224757375, 10.534964651663316, 48.4877002892575,
    ],
    '097745729118': [
      10.222520272473682, 48.40849476405866, 10.280506281771865, 48.44489215363659,
    ],
    '097745729148': [
      10.234302128015955, 48.38462382756164, 10.339964135776395, 48.42483484892913,
    ],
    '097745730133': [
      10.26615216014529, 48.302783804395936, 10.343247474283576, 48.35207949107015,
    ],
    '097745730143': [
      10.207057141139241, 48.34327154228842, 10.346429897808903, 48.40093466601047,
    ],
    '097745730191': [
      10.257086020052887, 48.331400007067906, 10.327916036260893, 48.36945867070097,
    ],
    '097745731111': [
      10.361610939173108, 48.1711768626008, 10.444230653142366, 48.219337320827805,
    ],
    '097745731117': [
      10.272416437129756, 48.21881772832981, 10.33883731834742, 48.2667231856988,
    ],
    '097745731124': [
      10.294364776651907, 48.24276019741321, 10.351301657974002, 48.293753539984,
    ],
    '097745731129': [
      10.288989857261122, 48.18391290324891, 10.33883731834742, 48.23009811132516,
    ],
    '097745731189': [
      10.285861769746951, 48.2667231856988, 10.325068525926884, 48.32168468398188,
    ],
    '097745731192': [
      10.315999501439062, 48.162157790469365, 10.37875680822436, 48.20495066362203,
    ],
    '097745732115': [
      10.458275323038889, 48.21479536671075, 10.521669064872915, 48.2568170412475,
    ],
    '097745732160': [
      10.404163599847783, 48.29347172075343, 10.499452911442201, 48.32998844313746,
    ],
    '097745732185': [
      10.439393436636706, 48.249303707210515, 10.515006451218545, 48.30596542185704,
    ],
    '097745733166': [
      10.510843006483448, 48.20097066489781, 10.573641751960137, 48.26272443013785,
    ],
    '097745733198': [
      10.495716985993079, 48.235727317974245, 10.599135650585334, 48.323502653870705,
    ],
    '097750115115': [
      10.077076623623636, 48.24719151323587, 10.113771817261869, 48.270352453665794,
    ],
    '097750129129': [
      10.070581561999042, 48.188486781372205, 10.15104559551932, 48.270352453665794,
    ],
    '097750134134': [
      10.0885976398285, 48.39885778623342, 10.183393274909626, 48.44558441521007,
    ],
    '097750135135': [
      9.967494177391572, 48.33116035476288, 10.130950302617899, 48.43347828675566,
    ],
    '097750139139': [
      10.028061834204973, 48.427427645036715, 10.143044693564313, 48.47768356641822,
    ],
    '097750149149': [
      10.185626287356348, 48.2503475313613, 10.264452400809326, 48.321909290836814,
    ],
    '097750152152': [
      10.011580219331117, 48.298504060484305, 10.124386807850582, 48.342147565435916,
    ],
    '097750162162': [
      10.033606847401531, 48.26325274838105, 10.135060853432844, 48.31457977804834,
    ],
    '097750164164': [
      10.113771817261869, 48.26022842935477, 10.240293416916405, 48.34322152560302,
    ],
    '097755739126': [
      10.087250439106839, 48.3594930627223, 10.130950302617899, 48.39314751524485,
    ],
    '097755739143': [
      10.105451624820333, 48.32820534666411, 10.232905466756922, 48.4042579732245,
    ],
    '097755740111': [
      10.088537812964901, 48.1313699683187, 10.179052114211297, 48.19729439292457,
    ],
    '097755740132': [
      10.110850671802432, 48.107756113418795, 10.158146634245748, 48.14889623877117,
    ],
    '097755740142': [
      10.147188044668303, 48.117971544212395, 10.209966527131494, 48.16430629183897,
    ],
    '097755741118': [
      10.145879063175652, 48.192144439467455, 10.25689612763048, 48.26778557752152,
    ],
    '097755741141': [
      10.171616392823738, 48.145648280167016, 10.22342077317485, 48.19068781805182,
    ],
    '097755741161': [
      10.145879063175652, 48.17725552766443, 10.234709586674036, 48.21492830369352,
    ],
    '097760111111': [
      9.644925368134674, 47.562192531519074, 9.672755984488383, 47.586850116179825,
    ],
    '097760114114': [
      9.853847106902869, 47.61303301078282, 9.945813025651137, 47.662117545386984,
    ],
    '097760116116': [
      9.638811052395901, 47.53368911018729, 9.74420007703586, 47.611775153673236,
    ],
    '097760117117': [
      9.858943054936516, 47.5822722309815, 9.930115165209624, 47.620426823002006,
    ],
    '097760120120': [
      9.602092290534408, 47.57038867421416, 9.627830739358435, 47.58434360527293,
    ],
    '097760122122': [
      9.795252553540589, 47.60401813918136, 9.874255664835122, 47.65312943562728,
    ],
    '097760125125': [
      9.81585480296041, 47.52854160917791, 9.884397224367389, 47.609702779366295,
    ],
    '097760128128': [
      9.621066985536658, 47.55619062144865, 9.661738321986759, 47.592121667135146,
    ],
    '097760129129': [
      9.865800474792863, 47.53867427047019, 9.972698124553625, 47.61116400471561,
    ],
    '097760131131': [
      9.799324034499232, 47.638894415907686, 9.915319727341945, 47.6773016005621,
    ],
    '097765735115': [
      9.747853672037579, 47.5921585297531, 9.82414340841824, 47.643566785848506,
    ],
    '097765735126': [
      9.725703734578529, 47.55694760917075, 9.840003156281352, 47.618496713194325,
    ],
    '097765735130': [
      9.705893962210096, 47.571912101558745, 9.748728384101586, 47.61684414512981,
    ],
    '097765737112': [
      9.963143416595631, 47.63177261034882, 10.027409157975995, 47.68330814955933,
    ],
    '097765737113': [
      9.971191375834508, 47.60100642611609, 10.077089928372894, 47.64627191524141,
    ],
    '097765737118': [
      10.011681918410739, 47.63120665081404, 10.077089928372894, 47.686201457450366,
    ],
    '097765737124': [
      9.92076034749319, 47.60033143266699, 9.98019172343472, 47.65756739069967,
    ],
    '097765738121': [
      9.90908667467074, 47.53006275918921, 9.9707409271761, 47.57954236238691,
    ],
    '097765738127': [
      9.956701709665046, 47.56068871057871, 10.061540059667053, 47.61385306484105,
    ],
    '097770129129': [
      10.583087690085174, 47.55108750538939, 10.727312273508938, 47.620339343800104,
    ],
    '097770130130': [
      10.64016474497019, 47.90186094483661, 10.726865778961134, 47.981166562538725,
    ],
    '097770147147': [
      10.748736587777778, 47.65708445341862, 10.8299527640425, 47.72780550550267,
    ],
    '097770151151': [
      10.530134264675171, 47.691816219680796, 10.71067608908228, 47.803348966069294,
    ],
    '097770152152': [
      10.652898711170465, 47.8385516342286, 10.691561332063028, 47.90795835390107,
    ],
    '097770153153': [
      10.450222415707847, 47.5839517088841, 10.550022709415002, 47.65368357127489,
    ],
    '097770159159': [
      10.452860545360762, 47.53389798163877, 10.598209666119851, 47.61221735056866,
    ],
    '097770165165': [
      10.359779089449624, 47.8773600993076, 10.449814391370802, 47.92343027605654,
    ],
    '097770169169': [
      10.69213824685116, 47.51436712022335, 10.85327468151301, 47.644131274570725,
    ],
    '097770173173': [
      10.738829107921855, 47.534174852596514, 10.956937907857146, 47.667868110218045,
    ],
    '097775748121': [
      10.677649462270358, 48.000964719995004, 10.816699447958136, 48.059748926206815,
    ],
    '097775748140': [
      10.645840585771529, 47.96336962511432, 10.76126535535888, 48.015983157742106,
    ],
    '097775748145': [
      10.702849344748367, 48.04648001970743, 10.81534282362807, 48.11030491610421,
    ],
    '097775748177': [
      10.746779455811506, 47.9541751652733, 10.825680686826505, 48.02017860797184,
    ],
    '097775749139': [
      10.527927577045721, 47.88578049407382, 10.602561721339903, 47.92788677208982,
    ],
    '097775749158': [
      10.5698597700074, 47.90336344926459, 10.653144086619085, 47.967747076633046,
    ],
    '097775749164': [
      10.624416866707264, 47.9357974936001, 10.672244905615022, 47.97060832341808,
    ],
    '097775751141': [
      10.722815023792483, 47.8712972121038, 10.791603183554178, 47.94057400045841,
    ],
    '097775751155': [
      10.691037804574744, 47.93018729388007, 10.799601261704472, 47.96696851844377,
    ],
    '097775751157': [
      10.712154202188053, 47.83968875686013, 10.772281921561458, 47.88777477062284,
    ],
    '097775751172': [
      10.681498120212426, 47.8432771858243, 10.737796910385956, 47.91092314826034,
    ],
    '097775751182': [
      10.68357520319071, 47.901168350910076, 10.734376682965408, 47.944950718344714,
    ],
    '097775752111': [
      10.467890031702122, 47.7916957013755, 10.558904652066083, 47.85958998641376,
    ],
    '097775752112': [
      10.601792829122344, 47.7884920993125, 10.681448856578976, 47.853909929772605,
    ],
    '097775752118': [
      10.67466768068194, 47.785409786779816, 10.76722277417159, 47.85478806242317,
    ],
    '097775752167': [
      10.539879016297725, 47.78407444959975, 10.617992767459048, 47.85950035669861,
    ],
    '097775753114': [
      10.502684500354297, 47.918811380262106, 10.587230943306965, 47.98438821564016,
    ],
    '097775753124': [
      10.438476590723589, 47.88741520324614, 10.535697656590393, 47.948206935599856,
    ],
    '097775753128': [
      10.479572659390739, 47.845182242112635, 10.57236050442415, 47.895077079340126,
    ],
    '097775754138': [
      10.394408940109987, 47.79786433310891, 10.484802625230344, 47.849195780611005,
    ],
    '097775754154': [
      10.371822512417772, 47.828723014856855, 10.504111864784965, 47.899648072642535,
    ],
    '097775754176': [
      10.327114593186199, 47.8066245985254, 10.404199444404115, 47.88778143567853,
    ],
    '097775755131': [
      10.459110040115785, 47.66418230528571, 10.532863260757901, 47.725421175556775,
    ],
    '097775755144': [
      10.436303041995322, 47.73419210723861, 10.489054903822716, 47.7950255308765,
    ],
    '097775755175': [
      10.436303041995322, 47.71105266801864, 10.544420532134362, 47.81619851503361,
    ],
    '097775756125': [
      10.54854086535301, 47.589695391746986, 10.629799819135208, 47.626867235593224,
    ],
    '097775756135': [
      10.61342042266105, 47.58541115432513, 10.66730748986424, 47.629122945203875,
    ],
    '097775756149': [
      10.550484416233324, 47.662529234473055, 10.65214071540475, 47.722474547926865,
    ],
    '097775756168': [
      10.506692934449964, 47.641726649348485, 10.59092006109824, 47.68249031796436,
    ],
    '097775756170': [
      10.548190736556185, 47.61763462152807, 10.674018896103878, 47.6983871651474,
    ],
    '097775756179': [
      10.522479873647942, 47.67386490490298, 10.5854872427792, 47.7307673073952,
    ],
    '097775770163': [
      10.66601178746375, 47.60206699477589, 10.74256367842921, 47.644131274570725,
    ],
    '097775770166': [
      10.654426022753574, 47.62721616679499, 10.771234795651948, 47.69335293482104,
    ],
    '097775772171': [
      10.660606744574629, 47.68518652248888, 10.745199567787727, 47.77283104476808,
    ],
    '097775772183': [
      10.709089511904194, 47.76183730829146, 10.780392158784036, 47.79730073708426,
    ],
    '097780116116': [
      10.544990252703705, 47.95020181555585, 10.66101186703415, 48.046617617030044,
    ],
    '097780123123': [
      10.117273777883174, 47.958894380023416, 10.1561037504806, 48.01437441154148,
    ],
    '097780137137': [
      10.603561763090683, 48.083684037532336, 10.701308070662161, 48.172516258513475,
    ],
    '097780168168': [
      10.335164816218192, 47.899488091433994, 10.447513034804537, 47.996656770280616,
    ],
    '097780169169': [
      10.544593615300217, 48.11192381278138, 10.647814895985654, 48.17500589061463,
    ],
    '097780173173': [
      10.434724100577416, 48.01585200375985, 10.567043401770244, 48.09891043597247,
    ],
    '097780196196': [
      10.31357489072618, 47.966843552486225, 10.417637551045715, 48.02499656351713,
    ],
    '097780204204': [
      10.510098605455228, 48.05642561752099, 10.615086449187249, 48.14653148501485,
    ],
    '097785757119': [
      10.266856754006996, 47.85602225321905, 10.363821666712514, 47.91072030974704,
    ],
    '097785757149': [
      10.235538609729858, 47.95433564482786, 10.299085092409042, 47.99219840757317,
    ],
    '097785757186': [
      10.269546303172945, 47.88393204961906, 10.381602808972252, 47.99235269683058,
    ],
    '097785758115': [
      10.2097135225932, 48.090622152652195, 10.292173252333978, 48.16906890248954,
    ],
    '097785758130': [
      10.232709142657633, 48.064112199084526, 10.32604876503718, 48.118267871090985,
    ],
    '097785758157': [
      10.27377535072709, 48.11063596301276, 10.363373571370063, 48.197346514477445,
    ],
    '097785758184': [
      10.262498453158972, 48.08765971445018, 10.354869677619828, 48.13986940022506,
    ],
    '097785758217': [
      10.192698236060338, 48.1023474603175, 10.241619037440419, 48.13896663177278,
    ],
    '097785758221': [
      10.219106683099923, 48.16231553450595, 10.29970292024326, 48.231235680906515,
    ],
    '097785759121': [
      10.344195254203118, 48.08124243985828, 10.450012963209696, 48.17919919700652,
    ],
    '097785759183': [
      10.355709323392853, 48.07061315575925, 10.454851778001826, 48.11893041312529,
    ],
    '097785759187': [
      10.414364380532122, 48.083845730283535, 10.477376542176307, 48.15943338213208,
    ],
    '097785759190': [
      10.448244574119242, 48.094820732971414, 10.524089552876351, 48.16391240478042,
    ],
    '097785760134': [
      10.485132547780466, 48.13322406903204, 10.595026126874203, 48.22519682217596,
    ],
    '097785760158': [
      10.39109957283995, 48.15117556822743, 10.509981740243349, 48.21759305717516,
    ],
    '097785761120': [
      10.169243477564883, 48.06546601610518, 10.243143709137017, 48.11112556442494,
    ],
    '097785761139': [
      10.131348662910177, 48.05905618046193, 10.170792382376133, 48.085992682669584,
    ],
    '097785761150': [
      10.125772515637228, 48.02333370733657, 10.212476482606602, 48.06422376510774,
    ],
    '097785761177': [
      10.16227159011718, 48.044414479424894, 10.238787553658835, 48.071158735562975,
    ],
    '097785761188': [
      10.135858250469632, 48.080224446704904, 10.197902330386336, 48.1232927960833,
    ],
    '097785762136': [
      10.301002200934759, 48.01425349749423, 10.395082497739386, 48.09782755820635,
    ],
    '097785762163': [
      10.229447262886572, 48.04380372381099, 10.336258186202889, 48.09438371718263,
    ],
    '097785762180': [
      10.362180236905752, 48.01643060519316, 10.445468397149313, 48.08004722294525,
    ],
    '097785762214': [
      10.254171787932945, 47.98755760055158, 10.333158419718387, 48.05516181368112,
    ],
    '097785764111': [
      10.664701476404796, 48.04846176402966, 10.707388679490373, 48.098374303808875,
    ],
    '097785764203': [
      10.583743633368718, 48.016442502862525, 10.679021459155397, 48.09552764261648,
    ],
    '097785764209': [
      10.540519785822202, 48.04461390697713, 10.61574744959721, 48.09109712939689,
    ],
    '097785764216': [
      10.651193803036602, 48.0155436255956, 10.699070569104824, 48.05538946933891,
    ],
    '097785765118': [
      10.186615238384269, 47.94229597748399, 10.28294749100011, 47.982036040941594,
    ],
    '097785765151': [
      10.22361983717717, 48.00409019896883, 10.27462821238209, 48.045189329023515,
    ],
    '097785765162': [
      10.20591898529277, 47.9223915478659, 10.273056521620521, 47.961516382808064,
    ],
    '097785765171': [
      10.199697392756462, 47.980695146089545, 10.244378243971102, 48.00466323083926,
    ],
    '097785765202': [
      10.196946072669023, 47.99619167063306, 10.23104192026364, 48.01086475688225,
    ],
    '097785765205': [
      10.241913272019973, 47.98848283851283, 10.280942880123694, 48.01792145757607,
    ],
    '097785766113': [
      10.438443782166337, 47.95937801316992, 10.515326469916888, 48.03090153581224,
    ],
    '097785766127': [
      10.471193495980385, 47.971549310123855, 10.557375417514576, 48.01960677508383,
    ],
    '097785766199': [
      10.399133735840872, 47.98367201756691, 10.468989434241184, 48.03654675840058,
    ],
    '097785766207': [
      10.430904604828495, 47.92250258518751, 10.518398352056355, 47.97446777799174,
    ],
    '097785767161': [
      10.107786665664323, 47.869652072937285, 10.195442157525157, 47.93668687019327,
    ],
    '097785767164': [
      10.076969549067785, 47.85617081520846, 10.121587483321168, 47.9194371521354,
    ],
    '097785767165': [
      10.09321531631255, 47.82010597807297, 10.191536940722852, 47.90004096138457,
    ],
    '097785768144': [
      10.17449209539278, 47.83979243365841, 10.306527620984808, 47.91291950509764,
    ],
    '097785768218': [
      10.229248888922086, 47.868677109629196, 10.298613264801375, 47.925794080154624,
    ],
    '097785768219': [
      10.159834941154488, 47.901094189314115, 10.235193740435786, 47.95048261807557,
    ],
    '097790115115': [
      10.790267289036612, 48.66645743291194, 10.85482342878428, 48.70681997518536,
    ],
    '097790131131': [
      10.670403672567364, 48.67553839939341, 10.862956841107906, 48.76260728074561,
    ],
    '097790147147': [
      10.401705029686251, 48.940700697366324, 10.538216428035385, 49.01162695974007,
    ],
    '097790155155': [
      10.617634236313053, 48.7276829778781, 10.76750059512272, 48.83017365062505,
    ],
    '097790169169': [
      10.730514640891762, 48.724973470338284, 10.895144693882841, 48.81152850058272,
    ],
    '097790178178': [
      10.868903990353946, 48.72165575028691, 10.999926194876101, 48.80799351292533,
    ],
    '097790181181': [
      10.737168275131406, 48.618983450357696, 10.846222780340614, 48.68677268078966,
    ],
    '097790185185': [
      10.528378723203444, 48.7690766518157, 10.635592612866763, 48.8370164168049,
    ],
    '097790194194': [
      10.427793461694334, 48.7948111958662, 10.59362460742388, 48.9221626141111,
    ],
    '097790196196': [
      10.833160956577998, 48.62999240537384, 10.889233754587076, 48.69495013256337,
    ],
    '097790201201': [
      10.870983139246789, 48.61078786313293, 11.042219722258034, 48.719948532511054,
    ],
    '097790218218': [
      10.619067607490923, 48.64856288081852, 10.748752582140764, 48.72958129287898,
    ],
    '097795720176': [
      10.480338819398503, 48.90409883597214, 10.538982695224126, 48.949692402921045,
    ],
    '097795720177': [
      10.438011957347932, 48.90113569685869, 10.49085839291408, 48.95846868707491,
    ],
    '097795720224': [
      10.422001360425945, 48.86704267435388, 10.515412900530977, 48.91526969245576,
    ],
    '097795721117': [
      10.56360849240749, 48.9738271425066, 10.67486343051894, 49.02057145240417,
    ],
    '097795721138': [
      10.509092246094943, 48.93510123184992, 10.58097662236083, 48.981261634352464,
    ],
    '097795721154': [
      10.612715862415817, 48.935045751598715, 10.690939602780846, 48.98120823829409,
    ],
    '097795721180': [
      10.628131379401745, 48.920465682895745, 10.701579961684084, 48.959901594090034,
    ],
    '097795721188': [
      10.574746091289175, 48.892118498117654, 10.698519803637621, 48.93599268667732,
    ],
    '097795721197': [
      10.535144731886694, 48.90686150471362, 10.626938879070819, 48.99790515881103,
    ],
    '097795722111': [
      10.578064236250215, 48.82350213891921, 10.683483169740732, 48.868100184534384,
    ],
    '097795722112': [
      10.458879814026032, 48.69717300491545, 10.529650815182173, 48.769423480397585,
    ],
    '097795722130': [
      10.536804055869924, 48.8455604005096, 10.607401664188894, 48.88674573875928,
    ],
    '097795722136': [
      10.42174930416216, 48.773289625617316, 10.509218730891206, 48.81946012181911,
    ],
    '097795722146': [
      10.413376036999004, 48.72964065774056, 10.495752741229893, 48.78563626703412,
    ],
    '097795722162': [
      10.476471917228077, 48.7511922173929, 10.55807479307214, 48.79670723890374,
    ],
    '097795722184': [
      10.542996072233231, 48.72958129287898, 10.660436694188896, 48.79751791868231,
    ],
    '097795722203': [
      10.497425254741154, 48.81258734446547, 10.557939524001641, 48.8487273992807,
    ],
    '097795722226': [
      10.572116301444856, 48.85510293140021, 10.664573375740812, 48.9087642401867,
    ],
    '097795723148': [
      10.727768850338675, 48.81141778308754, 10.808810997700332, 48.86992423722857,
    ],
    '097795723167': [
      10.665824823372926, 48.805647196740296, 10.757674321142156, 48.86398952176805,
    ],
    '097795723198': [
      10.76048510162597, 48.85850614215806, 10.833059372697585, 48.9011411268877,
    ],
    '097795723228': [
      10.663091727732272, 48.849132832493915, 10.775972941884309, 48.908197847303484,
    ],
    '097795723231': [
      10.72226893293047, 48.876612175171005, 10.832537860590357, 48.94804904480926,
    ],
    '097795724126': [
      10.805765938224134, 48.76467125261027, 10.880201562467043, 48.805585548052115,
    ],
    '097795724129': [
      10.837196444101433, 48.761340128394, 10.93199900620998, 48.81786483378215,
    ],
    '097795724186': [
      10.796386786117946, 48.80478363124978, 10.931088777390384, 48.8960745969884,
    ],
    '097795724206': [
      10.921964268132482, 48.82598227527917, 10.97363058804394, 48.86448783918365,
    ],
    '097795724217': [
      10.911617671726985, 48.80275364277638, 11.005910216923887, 48.84261715555251,
    ],
    '097795725149': [
      10.822321482646217, 48.69157480405281, 10.901641096951678, 48.72829917111463,
    ],
    '097795725163': [
      10.914024962470734, 48.595606125914884, 11.00310340117532, 48.643227090909306,
    ],
    '097795725187': [
      10.87957022484899, 48.585162719432596, 10.932484085294176, 48.651786784070694,
    ],
    '097795725192': [
      10.871739008319357, 48.701973949778484, 10.982206959721626, 48.7416841970268,
    ],
    '097800112112': [
      10.066970585633824, 47.74684109956218, 10.290277550492476, 47.84005188928043,
    ],
    '097800114114': [
      10.357485560235018, 47.70178270235539, 10.471012148193594, 47.76133335089392,
    ],
    '097800115115': [
      10.111069367145378, 47.45334676535661, 10.265595847739291, 47.55406980496314,
    ],
    '097800117117': [
      10.110296197061498, 47.67131889584022, 10.287617245506798, 47.75227422712486,
    ],
    '097800118118': [
      10.2482607641781, 47.52404428353433, 10.35918395411976, 47.56119422589758,
    ],
    '097800119119': [
      10.185039077571833, 47.79111644354912, 10.351592994373098, 47.863505547738825,
    ],
    '097800120120': [
      10.317952997232686, 47.678956028510896, 10.449544936161582, 47.713627394090736,
    ],
    '097800122122': [
      10.313971875830152, 47.756989285790084, 10.39730727371863, 47.83261376344791,
    ],
    '097800123123': [
      10.321831044543858, 47.370269478024696, 10.475835800955153, 47.561134480753076,
    ],
    '097800124124': [
      10.119865790069156, 47.51398935066866, 10.271972527020651, 47.62777542472815,
    ],
    '097800125125': [
      10.284156617456468, 47.76746720801533, 10.33944087766746, 47.795274477426496,
    ],
    '097800128128': [
      10.331097026821427, 47.61113272181902, 10.51303338151382, 47.69145509234734,
    ],
    '097800132132': [
      9.960388898591619, 47.46569508579168, 10.164984707260347, 47.58327881050062,
    ],
    '097800133133': [
      10.083010264604377, 47.270362327323475, 10.389249339475677, 47.47121713497312,
    ],
    '097800137137': [
      10.248022793915494, 47.54782135457071, 10.389212153807888, 47.62622383434339,
    ],
    '097800139139': [
      10.257930901088056, 47.45984392433846, 10.374068060195912, 47.5513117111372,
    ],
    '097800140140': [
      10.30788977384122, 47.61719564529539, 10.4210880135409, 47.69209093696115,
    ],
    '097800143143': [
      10.176768771247653, 47.606357375851516, 10.322741683759055, 47.69876275881357,
    ],
    '097800145145': [
      10.35918395411976, 47.53336320059841, 10.472802887565958, 47.62631994278353,
    ],
    '097800146146': [
      10.139257577768678, 47.71492491285911, 10.266693928203107, 47.77541471293041,
    ],
    '097800147147': [
      10.38667425877187, 47.744384892497436, 10.445273237265624, 47.81075402536687,
    ],
    '097805742113': [
      10.057335658068116, 47.38969443856296, 10.16132105214022, 47.4805564508222,
    ],
    '097805742116': [
      10.16132105214022, 47.43664560957781, 10.2587678889096, 47.48557141289067,
    ],
    '097805742121': [
      10.244041075418505, 47.42390494012573, 10.29189554102578, 47.48097515035886,
    ],
    '097805742131': [
      10.13325088343201, 47.41439450858442, 10.258699785365065, 47.45671977863246,
    ],
    '097805742134': [
      10.195741818543475, 47.47713108935792, 10.27468452384005, 47.52204444805217,
    ],
    '097805745127': [
      10.060666346787238, 47.56970319202863, 10.167341526206219, 47.62685208335111,
    ],
    '097805745144': [
      10.068707818074587, 47.612714053049935, 10.229429715401379, 47.70391974847703,
    ],
    '100410100100': [
      6.828874436918142, 49.17242737544804, 7.135175029667008, 49.32170413294947,
    ],
    '100410511511': [
      7.05510016840417, 49.313103711931355, 7.114567440935435, 49.347041836736004,
    ],
    '100410512512': [
      6.776036135569477, 49.151999158267124, 6.861652096384666, 49.2166962728475,
    ],
    '100410513513': [
      6.862649490225862, 49.32056957991731, 7.023363842794578, 49.37735025571113,
    ],
    '100410514514': [
      7.029458683061707, 49.11383228139146, 7.129387323756364, 49.18156530825921,
    ],
    '100410515515': [
      6.855241302664655, 49.26285931526333, 6.929050713945966, 49.32705575916461,
    ],
    '100410516516': [
      6.993554850984402, 49.28533165045354, 7.062557456677089, 49.34990164014791,
    ],
    '100410517517': [
      6.901379604154592, 49.28327642405741, 6.981734129278417, 49.331178358389735,
    ],
    '100410518518': [
      7.031084964036304, 49.27157128136439, 7.116952384581124, 49.3220709241542,
    ],
    '100410519519': [
      6.71168209495033, 49.16383433113258, 6.90857813885807, 49.27475534466363,
    ],
    '100420111111': [
      6.66438991100808, 49.37301801752722, 6.802309199626047, 49.46749067863262,
    ],
    '100420112112': [
      6.632769169417468, 49.45466435852104, 6.81547750994263, 49.56136974705936,
    ],
    '100420113113': [
      6.505140525118774, 49.397921511329514, 6.724876687067326, 49.50437748934877,
    ],
    '100420114114': [
      6.447211683174241, 49.44701893436563, 6.659719481524692, 49.54581693458723,
    ],
    '100420115115': [
      6.356799197879345, 49.45189663712894, 6.500474964375639, 49.55093856183831,
    ],
    '100420116116': [
      6.799544953497184, 49.46894673897789, 6.963124536861387, 49.613229650102575,
    ],
    '100420117117': [
      6.756633285415272, 49.507751347866346, 6.851061185289663, 49.59198378812184,
    ],
    '100430111111': [
      6.917843321377092, 49.35662981524161, 7.054977658392304, 49.43793737524959,
    ],
    '100430112112': [
      6.994581546262603, 49.34990164014791, 7.124323357552063, 49.41622817186163,
    ],
    '100430113113': [
      7.020023699820948, 49.330169425926215, 7.101284871196021, 49.37943283543749,
    ],
    '100430114114': [
      7.106835123852875, 49.287726961589634, 7.265893946314716, 49.40654719627945,
    ],
    '100430115115': [
      7.090889250070999, 49.38520312682283, 7.29308389600414, 49.44157457465672,
    ],
    '100430116116': [
      7.079228911926786, 49.33672871044805, 7.152036510472919, 49.396513524565925,
    ],
    '100430117117': [
      7.107619476312614, 49.29773145264932, 7.186919327312392, 49.32538202821123,
    ],
    '100440111111': [
      6.689696491594463, 49.33564181882615, 6.778751092658067, 49.39519067279807,
    ],
    '100440112112': [
      6.84599893384102, 49.36729430141666, 6.989623150104303, 49.48623214352489,
    ],
    '100440113113': [
      6.747830045117579, 49.369460408588736, 6.853016497753495, 49.41585799082075,
    ],
    '100440114114': [
      6.538868624552264, 49.32993323034911, 6.69987930578769, 49.419234945091596,
    ],
    '100440115115': [
      6.677962524503132, 49.26171490417828, 6.815988257683701, 49.36123145751379,
    ],
    '100440116116': [
      6.763640842662053, 49.31664578885635, 6.920734085532852, 49.38465906365161,
    ],
    '100440117117': [
      6.786599305241175, 49.392677224849145, 6.9353007687257, 49.5017556104686,
    ],
    '100440118118': [
      6.782867655163647, 49.28181859499992, 6.879668457983785, 49.33352996160674,
    ],
    '100440119119': [
      6.660560109574654, 49.21573956960481, 6.762593943310379, 49.30194396237319,
    ],
    '100440120120': [
      6.721556362392985, 49.2201816832829, 6.834599732153604, 49.274368567418186,
    ],
    '100440121121': [
      6.588785940738974, 49.280199746118846, 6.731432395826023, 49.34722947392355,
    ],
    '100440122122': [
      6.774651548477314, 49.26866040920683, 6.856617401467183, 49.286066679419264,
    ],
    '100440123123': [
      6.76670152011824, 49.27767033502431, 6.804392972442096, 49.32081661000315,
    ],
    '100450111111': [
      7.219535918365444, 49.32341318455157, 7.305816391810898, 49.40761478043348,
    ],
    '100450112112': [
      7.178374360102287, 49.12985101066613, 7.363507030667579, 49.2957831455173,
    ],
    '100450113113': [
      7.160877342639792, 49.11498000213042, 7.309826300856298, 49.19459141741544,
    ],
    '100450114114': [
      7.273860457152019, 49.24823839769845, 7.403475193596232, 49.386772327904126,
    ],
    '100450115115': [
      7.182717537084122, 49.259676224344815, 7.316899696540817, 49.339905818800666,
    ],
    '100450116116': [
      7.101193456639105, 49.12092082268, 7.202088711684755, 49.25077980461006,
    ],
    '100450117117': [
      7.062305918782704, 49.23939514417423, 7.193960417298304, 49.31206855477297,
    ],
    '100460111111': [
      7.170233873435743, 49.49943205837417, 7.309828245363403, 49.58378382019695,
    ],
    '100460112112': [
      6.995143562258348, 49.40952963378957, 7.111375334372976, 49.50360582209505,
    ],
    '100460113113': [
      7.122364675315844, 49.48531265088026, 7.208472857431859, 49.54623031642414,
    ],
    '100460114114': [
      6.990442769121901, 49.523690457066685, 7.210030978955349, 49.63934672570559,
    ],
    '100460115115': [
      6.891898113099534, 49.51031319962092, 7.040596965885904, 49.63543661884996,
    ],
    '100460116116': [
      7.048528827813151, 49.49425092121199, 7.141816469320672, 49.55100043686057,
    ],
    '100460117117': [
      7.068710364855384, 49.41598919393549, 7.304819730680251, 49.511674697115616,
    ],
    '100460118118': [
      6.91039921537052, 49.43656771417863, 7.060343843563348, 49.525531218621026,
    ],
    '110000000000': [
      13.088209718280915, 52.3384980813404, 13.760610562076355, 52.674355645016874,
    ],
    '120510000000': [
      12.360854939595185, 52.312213091198615, 12.726490900741092, 52.54484166739966,
    ],
    '120520000000': [
      14.274360992959092, 51.69309521065149, 14.503785051794738, 51.86270454371821,
    ],
    '120530000000': [
      14.395894279863144, 52.252580675472224, 14.601978113161023, 52.39855048692565,
    ],
    '120540000000': [
      12.887392358884789, 52.343681186467116, 13.158068223418704, 52.516347906453476,
    ],
    '120600005005': [
      13.49643239749112, 52.54405831520821, 13.68477703885325, 52.65458728051811,
    ],
    '120600020020': [
      13.4670785045952, 52.60972931779617, 13.665880380551592, 52.75590601448581,
    ],
    '120600052052': [
      13.65794446039522, 52.78525443014554, 13.905749027348827, 52.88323877470989,
    ],
    '120600181181': [
      13.475808042656364, 52.600584728814084, 13.5796768068858, 52.6781533632388,
    ],
    '120600198198': [
      13.39831456114857, 52.79964499658379, 13.788500287737232, 52.99841189082049,
    ],
    '120600269269': [
      13.395160970634446, 52.63689837151248, 13.596137572640307, 52.87733579366581,
    ],
    '120600280280': [
      13.637856725287957, 52.57904751513075, 13.858149488141136, 52.713499779403435,
    ],
    '120605003024': [
      13.567856334679531, 52.698344686530604, 13.688779853831205, 52.83056542887124,
    ],
    '120605003034': [
      13.742391124635573, 52.74382217915382, 13.87621575218418, 52.807121338066274,
    ],
    '120605003154': [
      13.50616429035536, 52.802869703622186, 13.64871428887222, 52.88579509134512,
    ],
    '120605003161': [
      13.666992505451422, 52.75432700243907, 13.78924572305283, 52.78605835293885,
    ],
    '120605003192': [
      13.597112274789902, 52.69138439280797, 13.668526017994166, 52.74471211578748,
    ],
    '120605003250': [
      13.668526017994166, 52.69615647295849, 13.764268843211335, 52.76976101184412,
    ],
    '120605006012': [
      13.77991543893798, 52.929785523272365, 13.860820573057412, 52.9885432578457,
    ],
    '120605006068': [
      13.671867304434084, 53.00262345774227, 13.884215294500994, 53.05678532241271,
    ],
    '120605006100': [
      13.59988691917125, 52.90124251321251, 13.831307706654096, 53.025908260503456,
    ],
    '120605006296': [
      13.838635973146534, 52.935177574189, 13.947650101132655, 52.983548684679675,
    ],
    '120605011036': [
      13.756901733417427, 52.86100304483195, 13.853163916012765, 52.904203628145574,
    ],
    '120605011045': [
      13.7452673321427, 52.84599152228062, 14.027252197466325, 52.96763336035298,
    ],
    '120605011092': [
      13.839242743781517, 52.78772572168989, 13.953118142400973, 52.83752431587697,
    ],
    '120605011128': [
      13.946705414696801, 52.832765927782496, 13.999404649508588, 52.88090019577139,
    ],
    '120605011149': [
      14.070378515466377, 52.88949628111501, 14.155401800176538, 52.96453399054612,
    ],
    '120605011172': [
      13.880150586810892, 52.82503926296488, 13.977849640156464, 52.86394338587116,
    ],
    '120605011176': [
      13.975405965220398, 52.8472503160764, 14.096271731784663, 52.913468468283526,
    ],
    '120605011185': [
      14.009624402560226, 52.91173784770733, 14.0809606586369, 52.9563194448611,
    ],
    '120610020020': [
      13.588678895225108, 52.195385210241454, 13.710754079290124, 52.26125606142391,
    ],
    '120610112112': [
      13.607553574047753, 52.36458656265667, 13.64724884496459, 52.38180768174556,
    ],
    '120610217217': [
      13.669302394438963, 52.181290658366976, 13.862159771317122, 52.32456305253268,
    ],
    '120610219219': [
      13.507569092018612, 51.72692011706923, 13.763627809505417, 51.891090322630916,
    ],
    '120610260260': [
      13.569177997150978, 52.25378570254366, 13.754108880061, 52.38925559617861,
    ],
    '120610316316': [
      13.79424955284378, 51.89263289300898, 14.019201134173422, 51.99873029315105,
    ],
    '120610320320': [
      13.576510684218563, 51.73430050639936, 13.86634501612875, 51.92860945405518,
    ],
    '120610329329': [
      13.87995967506897, 51.95714891323207, 14.129899274121678, 52.13658862508482,
    ],
    '120610332332': [
      13.451250806701655, 52.14396897838384, 13.621106389632168, 52.32674567889663,
    ],
    '120610433433': [
      13.418717993738298, 52.31649304350445, 13.605135275335604, 52.42058820681447,
    ],
    '120610444444': [
      13.561154409297059, 52.3374665334289, 13.613490354385668, 52.379844991072495,
    ],
    '120610540540': [
      13.589350132427976, 52.307358468220826, 13.643463308259008, 52.340488494033714,
    ],
    '120610572572': [
      13.561154409297059, 52.31856774511407, 13.650115620282056, 52.37043046162992,
    ],
    '120615108192': [
      13.591012432958156, 52.108440624539554, 13.779508840660972, 52.20198697412387,
    ],
    '120615108216': [
      13.62305316956622, 52.02945632738618, 13.775446024198779, 52.13493783486111,
    ],
    '120615108328': [
      13.73608458386358, 52.06426349072814, 13.84757129069678, 52.141980065935115,
    ],
    '120615108344': [
      13.76207352317945, 52.08126534898676, 13.893209798514736, 52.19007048041728,
    ],
    '120615108448': [
      13.609658261743327, 52.13394497761567, 13.664457502923492, 52.15996061359569,
    ],
    '120615108492': [
      13.540794884306026, 52.07340445024956, 13.661276667776434, 52.16541028041603,
    ],
    '120615113005': [
      13.982125059847425, 51.87702939947591, 14.090122003000086, 51.944252197047554,
    ],
    '120615113061': [
      14.118910758359544, 51.857999815276465, 14.241081654494616, 51.931571763651114,
    ],
    '120615113224': [
      14.31180142304049, 51.97729182607742, 14.452889401861729, 52.07241220614568,
    ],
    '120615113308': [
      14.221707655905485, 51.93431780630045, 14.393098893284913, 52.07241220614568,
    ],
    '120615113352': [
      13.9698855318841, 51.88779305451682, 14.119116062054829, 51.98061175964939,
    ],
    '120615113450': [
      14.095226640483217, 51.904268409556906, 14.341269302561829, 52.087017224719474,
    ],
    '120615113470': [
      14.080571998980817, 51.91725465744768, 14.209871355839294, 51.98941143265175,
    ],
    '120615113476': [
      14.088675627970972, 51.87224774021906, 14.171490232281183, 51.929494328571394,
    ],
    '120615114017': [
      13.70134301178892, 51.902786541432356, 13.816749108163355, 51.98419032270935,
    ],
    '120615114097': [
      13.519286570805074, 51.89512685844411, 13.62166005124024, 51.95253180900292,
    ],
    '120615114164': [
      13.492684329506709, 51.925674846557946, 13.70134301178892, 52.010719252701165,
    ],
    '120615114244': [
      13.619216295871604, 51.90152854922037, 13.76248888947603, 51.965438643924756,
    ],
    '120615114265': [
      13.727990484829897, 51.98915067606749, 13.890964173734458, 52.07923789803425,
    ],
    '120615114405': [
      13.6322168234567, 51.987762578384846, 13.737829956672988, 52.056987818116575,
    ],
    '120615114428': [
      13.856358956339294, 51.98538563652864, 13.932081577313804, 52.05599342517445,
    ],
    '120615114435': [
      13.662465540794571, 51.958680592875005, 13.822081072235319, 52.021952029035965,
    ],
    '120615114471': [
      13.410526562802266, 51.924315916004055, 13.57388287041641, 51.97607942652891,
    ],
    '120615114510': [
      13.838038018601914, 52.05022961783187, 13.925406349566977, 52.12756836801154,
    ],
    '120620092092': [
      13.336213949000859, 51.591781745595284, 13.651410449357346, 51.70470735569198,
    ],
    '120620124124': [
      13.460793373298674, 51.426438290063444, 13.606319708669181, 51.51703630415247,
    ],
    '120620140140': [
      13.62953649297717, 51.520442667977036, 13.816102703250957, 51.651284194328895,
    ],
    '120620224224': [
      13.050732600902345, 51.59772381722628, 13.336213949000859, 51.75755201841631,
    ],
    '120620410410': [
      13.406181550944481, 51.4021559346988, 13.527977548813086, 51.506771811896094,
    ],
    '120620461461': [
      13.12294766019201, 51.71130330293653, 13.394558785136178, 51.883744081434834,
    ],
    '120620469469': [
      13.507182662280604, 51.63901019277606, 13.78989347594449, 51.75597592841635,
    ],
    '120625031024': [
      13.248483260926998, 51.42524334692146, 13.55485587723198, 51.55826192729161,
    ],
    '120625031128': [
      13.141531297601421, 51.545916998767375, 13.291621084813507, 51.653135998111146,
    ],
    '120625031341': [
      13.1753781740051, 51.385052119942344, 13.328405396948442, 51.557241934175984,
    ],
    '120625031500': [
      13.246896214998706, 51.481867008430356, 13.468050212968565, 51.65869393199357,
    ],
    '120625202219': [
      13.594251550974942, 51.56129049386766, 13.699656013731387, 51.62777045721574,
    ],
    '120625202417': [
      13.519743179176817, 51.5413884846069, 13.635589055024447, 51.5937657944834,
    ],
    '120625202440': [
      13.358759601906986, 51.591699304298515, 13.432574929611375, 51.62199830375625,
    ],
    '120625202453': [
      13.439133511899946, 51.54485181425014, 13.566542486125815, 51.61364885437678,
    ],
    '120625202492': [
      13.4096254686163, 51.57593267653016, 13.460305147639763, 51.61466514430254,
    ],
    '120625205088': [
      13.695034772101392, 51.714704300446535, 13.783260197861212, 51.759610114919305,
    ],
    '120625205293': [
      13.729706484975235, 51.54861512627239, 13.84132485934418, 51.642627664558844,
    ],
    '120625205333': [
      13.657183736159396, 51.61200033087853, 13.855307866522981, 51.73718149898247,
    ],
    '120625205425': [
      13.808802646830973, 51.55938089900471, 13.889880889267785, 51.66146296259252,
    ],
    '120625207177': [
      13.552336897514536, 51.5043660031371, 13.701319543502859, 51.55940091900042,
    ],
    '120625207240': [
      13.516925507585455, 51.46229394557579, 13.64016873152849, 51.53346200504944,
    ],
    '120625207372': [
      13.54751872414016, 51.42769738059505, 13.69371412072694, 51.503664692767124,
    ],
    '120625207464': [
      13.637925943154235, 51.41634062934146, 13.718730801060156, 51.46004476461502,
    ],
    '120625209134': [
      13.393271365264017, 51.681240016595254, 13.51704263778304, 51.77506171840209,
    ],
    '120625209237': [
      13.439641426311182, 51.716919029540286, 13.548704551837961, 51.7994769916957,
    ],
    '120625209282': [
      13.27476471023306, 51.6796402729749, 13.350835599856744, 51.7393833290515,
    ],
    '120625209289': [
      13.345034042889976, 51.75612323912286, 13.46087118275996, 51.81990025757057,
    ],
    '120625209445': [
      13.29231722951587, 51.65869393199357, 13.46105159018266, 51.79062128054405,
    ],
    '120625211196': [
      13.548234572289772, 51.384168179080774, 13.64295065986287, 51.441243690735234,
    ],
    '120625211208': [
      13.61218798525058, 51.36807796668711, 13.700999306682132, 51.43017879257981,
    ],
    '120625211232': [
      13.588281766422964, 51.36962293917657, 13.666072012237338, 51.436284097211704,
    ],
    '120625211336': [
      13.513734577359395, 51.369752111405674, 13.568594581386458, 51.42760338012811,
    ],
    '120630036036': [
      12.902464406267773, 52.55859625858204, 13.050571846868623, 52.61565788287593,
    ],
    '120630056056': [
      13.002656481444909, 52.461144367078155, 13.166553829544902, 52.55828025749013,
    ],
    '120630080080': [
      12.999568236452701, 52.544433374877464, 13.153579932589398, 52.61097596383963,
    ],
    '120630148148': [
      12.734037328528716, 52.44998787460397, 12.950173077049499, 52.55913289239602,
    ],
    '120630189189': [
      12.14259219988609, 52.440022049479396, 12.45015266538733, 52.63027911860799,
    ],
    '120630208208': [
      12.652363879725335, 52.50007623557424, 13.013172857169671, 52.72478106539079,
    ],
    '120630244244': [
      12.30481973289264, 52.502116865931605, 12.43079309385662, 52.58944741433422,
    ],
    '120630252252': [
      12.236458164506724, 52.54672282291847, 12.430792330183321, 52.67191079068119,
    ],
    '120630273273': [
      12.901277906377246, 52.58690130336044, 13.164193187680668, 52.692140742294164,
    ],
    '120630357357': [
      12.871817013117871, 52.50374588157452, 13.018341064410414, 52.57707096624313,
    ],
    '120635302088': [
      12.514114211642498, 52.697097116106576, 12.718838788542428, 52.81086435864954,
    ],
    '120635302142': [
      12.601528413013975, 52.68298154796335, 12.740426572915403, 52.75451047445624,
    ],
    '120635302202': [
      12.523617706717973, 52.62308176791529, 12.692030666252746, 52.70383896188978,
    ],
    '120635302228': [
      12.682763488368902, 52.606593463405886, 12.768119518368682, 52.70335113157326,
    ],
    '120635302240': [
      12.62063875632004, 52.61293434969408, 12.710219282042887, 52.68944108198237,
    ],
    '120635302256': [
      12.653866029959408, 52.59532074777575, 12.728278494376555, 52.66209258338014,
    ],
    '120635306165': [
      12.469100567187782, 52.619641539872376, 12.605924212163421, 52.69214947444348,
    ],
    '120635306186': [
      12.503028112527137, 52.5274364352668, 12.69514556150757, 52.620876017374414,
    ],
    '120635306212': [
      12.377837430980945, 52.5347504370711, 12.624084120947078, 52.6387808091298,
    ],
    '120635306293': [
      12.391964020199357, 52.59515175963146, 12.503179479157854, 52.712303631713034,
    ],
    '120635309094': [
      12.354279134159734, 52.7012451891463, 12.443446664500643, 52.77068948213252,
    ],
    '120635309112': [
      12.283012712093445, 52.76678220157577, 12.407222036516021, 52.805281543734054,
    ],
    '120635309134': [
      12.202268446563826, 52.6655275512834, 12.337312321411018, 52.799721381915894,
    ],
    '120635309161': [
      12.435776808587116, 52.67714646402538, 12.558770307035036, 52.761033538771585,
    ],
    '120635309260': [
      12.27285813012366, 52.71360848262036, 12.367171135326432, 52.795856181878946,
    ],
    '120635309274': [
      12.267193031963263, 52.64753617388384, 12.465912552978791, 52.71979321818448,
    ],
    '120640029029': [
      13.672735419237078, 52.54038014514457, 13.938229734321396, 52.647069432457684,
    ],
    '120640044044': [
      13.977849640156464, 52.72929972567056, 14.160559362455038, 52.903115025330095,
    ],
    '120640136136': [
      13.711744519067171, 52.487321288896936, 13.776874632732651, 52.551414146578324,
    ],
    '120640227227': [
      13.611688188318906, 52.46746863825295, 13.685084829329845, 52.56925263164197,
    ],
    '120640274274': [
      14.269369595131199, 52.589529570547974, 14.498384210115958, 52.760787216351105,
    ],
    '120640317317': [
      13.953325612426465, 52.44717801433253, 14.25804398853017, 52.60150745467209,
    ],
    '120640336336': [
      13.65678731204847, 52.49906757177483, 13.742702239762009, 52.54576318772488,
    ],
    '120640380380': [
      13.752700094640979, 52.50597427684859, 13.851349957686923, 52.55747282981884,
    ],
    '120640428428': [
      13.739591753156153, 52.43818408631623, 13.915603455120499, 52.52971478607704,
    ],
    '120640448448': [
      14.337500536733808, 52.512488801241176, 14.469835327021078, 52.59477899135687,
    ],
    '120640472472': [
      13.812704069756135, 52.514943699216325, 14.021004085489025, 52.60324268961135,
    ],
    '120640512512': [
      13.976671049523143, 52.66336670487207, 14.25064064385655, 52.78250820079479,
    ],
    '120645403053': [
      13.753914356946657, 52.66732472716355, 13.866498680584286, 52.72247712813045,
    ],
    '120645403125': [
      13.854941923351847, 52.73709497972027, 14.006763120829397, 52.832765927782496,
    ],
    '120645403205': [
      13.731740286244595, 52.70699371048262, 13.905039894583526, 52.758364055347045,
    ],
    '120645403222': [
      13.850509589862293, 52.66551147704152, 14.001508765093744, 52.75726802194412,
    ],
    '120645404009': [
      14.441777928510826, 52.498630956010516, 14.606488137432693, 52.55698324189879,
    ],
    '120645404057': [
      14.476242187126074, 52.580175032355385, 14.61146391690854, 52.64727061833359,
    ],
    '120645404172': [
      14.447690123197614, 52.55268894528977, 14.525469515501507, 52.60091477623636,
    ],
    '120645404266': [
      14.517804014676289, 52.52550610602345, 14.639080842440222, 52.61027883897186,
    ],
    '120645404538': [
      14.412653828977776, 52.57772584998677, 14.50090468888983, 52.64610498894587,
    ],
    '120645406268': [
      14.429638018786582, 52.39169610027297, 14.611596312143416, 52.48771379756662,
    ],
    '120645406388': [
      14.490582198182704, 52.44703134358748, 14.594891385401636, 52.50467122860461,
    ],
    '120645406420': [
      14.54910518052349, 52.46943590487818, 14.634763032222347, 52.52550610602345,
    ],
    '120645406480': [
      14.372945213352741, 52.374697819720026, 14.43005195125003, 52.40943751876242,
    ],
    '120645406539': [
      14.315016814937056, 52.373837700052896, 14.465651876379459, 52.457425387860134,
    ],
    '120645408084': [
      14.003735199111041, 52.546219638450594, 14.127428317327471, 52.57992933298786,
    ],
    '120645408153': [
      13.911819056558574, 52.51936166437362, 14.049707443540077, 52.56529935391884,
    ],
    '120645408303': [
      14.08795099920949, 52.57615054236042, 14.176684897927325, 52.65177203147175,
    ],
    '120645408370': [
      13.926692243528462, 52.56744722542036, 14.114920632798242, 52.63576287222999,
    ],
    '120645408408': [
      13.870040207595114, 52.473383639252944, 14.023147036254684, 52.54441209842105,
    ],
    '120645408484': [
      14.019341238897345, 52.50954784411133, 14.12726900704066, 52.56471475345577,
    ],
    '120645412128': [
      14.272623213934349, 52.40187166143983, 14.37805582458075, 52.45729585450517,
    ],
    '120645412130': [
      14.368975120720242, 52.43642920288706, 14.47386714139766, 52.485171234856224,
    ],
    '120645412190': [
      14.281959457846137, 52.547722633934605, 14.392375209639523, 52.620315893596015,
    ],
    '120645412288': [
      14.25026420213019, 52.449988208334645, 14.382369652942234, 52.498314636028006,
    ],
    '120645412290': [
      14.362307936755146, 52.460987789367486, 14.520075333952812, 52.52928349247312,
    ],
    '120645412340': [
      14.129425081243413, 52.54461778974497, 14.306998111244496, 52.663859868600426,
    ],
    '120645412482': [
      14.218041723406472, 52.47104491042636, 14.45248376751166, 52.567801494706,
    ],
    '120645414061': [
      14.112937925002807, 52.64199467142979, 14.235990068681803, 52.71446727372698,
    ],
    '120645414349': [
      14.219483814300185, 52.70536739218387, 14.331732600814126, 52.78913845507238,
    ],
    '120645414365': [
      14.178663912224554, 52.642153574666, 14.306336237991223, 52.714614327114425,
    ],
    '120645414371': [
      14.096290023487477, 52.72347730914404, 14.253028266216544, 52.83089571405234,
    ],
    '120645414393': [
      13.837197321112999, 52.60437733432271, 14.047598359834122, 52.71567303157777,
    ],
    '120645414417': [
      14.005130869817346, 52.632163050898825, 14.129425081243413, 52.67528498710697,
    ],
    '120650036036': [
      13.247009121852042, 52.68043663817544, 13.36518340580899, 52.72554536936955,
    ],
    '120650084084': [
      13.025074207648656, 53.05124998227712, 13.366280763768408, 53.25049011745322,
    ],
    '120650096096': [
      13.306211911601292, 52.62336719705085, 13.360582650845066, 52.64347084623706,
    ],
    '120650136136': [
      13.15437016706444, 52.58726753155926, 13.241300051513441, 52.67213713987962,
    ],
    '120650144144': [
      13.207743654764208, 52.62736962360917, 13.35914284469559, 52.741360578968205,
    ],
    '120650165165': [
      12.825794888796052, 52.69427512001961, 13.200757161255535, 52.89655169784611,
    ],
    '120650180180': [
      13.17275783782452, 52.703697157126975, 13.213892691241085, 52.73982280970368,
    ],
    '120650193193': [
      13.248683170899096, 52.79553595643809, 13.518031959707557, 52.93701515262313,
    ],
    '120650198198': [
      13.018162081045315, 52.797610449749584, 13.371573011484653, 52.956205935209475,
    ],
    '120650225225': [
      13.301290110731598, 52.62336719705085, 13.42336873418541, 52.745100876424914,
    ],
    '120650251251': [
      12.98161149892202, 52.605380977071476, 13.188793455944632, 52.76141992838611,
    ],
    '120650256256': [
      13.136035489247478, 52.709968912789066, 13.428726163963127, 52.84602526187873,
    ],
    '120650332332': [
      13.152447829755008, 52.65788650827019, 13.25077119747, 52.71578590898538,
    ],
    '120650356356': [
      13.210593752772995, 52.90105224335854, 13.51972579155116, 53.07998999667786,
    ],
    '120655502100': [
      13.07126159046873, 52.95028252295864, 13.24666656004958, 53.172195590211295,
    ],
    '120655502117': [
      13.034889076391895, 53.03650298580932, 13.174675723323137, 53.14468147908729,
    ],
    '120655502276': [
      13.07946350515959, 52.983983547016166, 13.140759189939445, 53.027473538685676,
    ],
    '120655502301': [
      13.006181793266537, 52.952224909437156, 13.148242045065807, 53.071206361774074,
    ],
    '120655502310': [
      12.93615450982742, 53.06240825611032, 13.130750092975527, 53.18660540968969,
    ],
    '120660052052': [
      13.796623892971091, 51.67866707974619, 14.050795250660915, 51.83915322022382,
    ],
    '120660112112': [
      13.866561980703962, 51.56011414584043, 14.112183996886952, 51.63194022536995,
    ],
    '120660176176': [
      13.633789129783494, 51.45606782921212, 13.865498997584805, 51.54861512627239,
    ],
    '120660196196': [
      13.82614083076033, 51.761622399289685, 14.088675627970972, 51.90300136540551,
    ],
    '120660285285': [
      13.816102703250957, 51.484339930442324, 13.982565879004564, 51.57689329774476,
    ],
    '120660296296': [
      13.79515442759616, 51.46133088440075, 13.924039375251125, 51.51432539712726,
    ],
    '120660304304': [
      13.920878165361552, 51.42572610605983, 14.140266612153795, 51.57538077654156,
    ],
    '120660320320': [
      13.9888601102319, 51.69469802872131, 14.145228283891283, 51.85393719969138,
    ],
    '120665601008': [
      13.943363919098557, 51.610649272176175, 14.127687658764394, 51.69968780910058,
    ],
    '120665601041': [
      13.834945402626202, 51.61383012864123, 13.968298979376335, 51.693193013449296,
    ],
    '120665601202': [
      13.925137344445542, 51.64108614404176, 14.046308455223686, 51.71382690957696,
    ],
    '120665601226': [
      14.058485097926987, 51.54072987570037, 14.163343039026884, 51.63935233959575,
    ],
    '120665601228': [
      14.13707929713793, 51.59066816553832, 14.213960842702638, 51.636814178001636,
    ],
    '120665606064': [
      13.74014531576802, 51.4006881748541, 13.80654761289084, 51.45973278454393,
    ],
    '120665606104': [
      13.682981067661409, 51.36104517019939, 13.748732478468396, 51.42524397863771,
    ],
    '120665606168': [
      13.77497068835715, 51.36931256155058, 13.836164536319636, 51.414482330708715,
    ],
    '120665606188': [
      13.712379648703449, 51.38087341242808, 13.764546629580797, 51.42394502788293,
    ],
    '120665606240': [
      13.741002887234531, 51.36066270817782, 13.781701485441872, 51.40117599401699,
    ],
    '120665606316': [
      13.714169899975635, 51.41999759824362, 13.759860610527387, 51.45973278454393,
    ],
    '120665607116': [
      13.963276151325529, 51.37260806388495, 14.036310948872284, 51.416648349906104,
    ],
    '120665607120': [
      13.885362362553513, 51.40541924115085, 13.977171078834267, 51.44049104405472,
    ],
    '120665607124': [
      13.831857404389991, 51.375520983678626, 13.963363546310548, 51.424181862141964,
    ],
    '120665607132': [
      13.96149028122965, 51.4129953070961, 14.044985890614992, 51.45031076059713,
    ],
    '120665607272': [
      13.79515442759616, 51.40360510605453, 13.907607494358057, 51.467310877575585,
    ],
    '120665607292': [
      13.898259040208927, 51.43677016080226, 13.969709670856435, 51.48239810718704,
    ],
    '120670036036': [
      14.176603567494526, 52.133084964528734, 14.377504095835386, 52.24367187270066,
    ],
    '120670120120': [
      14.565365899001462, 52.095970507975196, 14.705478104859042, 52.21441514870257,
    ],
    '120670124124': [
      13.72916271726212, 52.3831586914581, 13.793894778522134, 52.439067964921634,
    ],
    '120670137137': [
      14.18690963418984, 52.02540604961566, 14.470331243407108, 52.152195327879745,
    ],
    '120670144144': [
      13.93884688665251, 52.32338927926271, 14.149585051318136, 52.42664512764922,
    ],
    '120670201201': [
      13.785719295757977, 52.3559392644707, 14.021690224205537, 52.47721193092959,
    ],
    '120670426426': [
      14.028717417726474, 52.15596936146051, 14.343217471037768, 52.32827687529995,
    ],
    '120670440440': [
      13.666744192620468, 52.454750541643534, 13.741556752698392, 52.502006747455646,
    ],
    '120670481481': [
      13.823228678069649, 52.11657215591868, 14.065959927664816, 52.310197734116244,
    ],
    '120670493493': [
      14.005681707279956, 52.05147605076935, 14.210456324303824, 52.21090630233512,
    ],
    '120670544544': [
      13.720658779024436, 52.430493702256584, 13.805466657518332, 52.46725316303881,
    ],
    '120675701076': [
      14.504348907835174, 52.239790200438875, 14.61697747392653, 52.27731794745926,
    ],
    '120675701180': [
      14.45331384278308, 52.22045321773709, 14.559121785058082, 52.26260744892533,
    ],
    '120675701508': [
      14.637552751049666, 52.16702798938438, 14.693103348737914, 52.20052141455063,
    ],
    '120675701528': [
      14.548630034801965, 52.2076359883776, 14.693737187243332, 52.27205078959877,
    ],
    '120675701552': [
      14.606369381885182, 52.19459845792701, 14.71556296466592, 52.255449153709925,
    ],
    '120675705292': [
      14.608559334686888, 52.09821735478681, 14.66466861129272, 52.12412165106832,
    ],
    '120675705338': [
      14.642236244340097, 52.001852743349076, 14.75981557212553, 52.09889685998749,
    ],
    '120675705357': [
      14.481562181671107, 52.00168528729461, 14.703372328195577, 52.129500467351406,
    ],
    '120675706040': [
      14.137683696312957, 52.31691652309819, 14.222486207652006, 52.3841284098483,
    ],
    '120675706072': [
      14.17663768839465, 52.2766616816574, 14.407817612285164, 52.41724285289829,
    ],
    '120675706237': [
      14.301514184126269, 52.31375417370233, 14.436195530873155, 52.38667819847332,
    ],
    '120675706473': [
      13.977409927686145, 52.36285732549538, 14.283503979245094, 52.49894439392173,
    ],
    '120675707024': [
      14.007055993823544, 52.20382595030505, 14.118500145606102, 52.32987707096035,
    ],
    '120675707112': [
      14.045272754701262, 52.222363003183624, 14.103896363688238, 52.258432978075604,
    ],
    '120675707288': [
      14.077971594842538, 52.306407226841515, 14.16702759451582, 52.34885903196087,
    ],
    '120675707413': [
      13.945493917936812, 52.21884666736116, 14.029127827444409, 52.30464431542823,
    ],
    '120675707520': [
      13.934636889923874, 52.18012500541635, 14.055142590336466, 52.22943776042102,
    ],
    '120675708205': [
      14.361453227654023, 52.04857502346788, 14.485329238122098, 52.18017567638814,
    ],
    '120675708324': [
      14.370394846845803, 52.17419181056036, 14.437446988769123, 52.218603705780865,
    ],
    '120675708336': [
      14.314291350366762, 52.1934808695496, 14.529365424058618, 52.315985698294355,
    ],
    '120675708397': [
      14.264218984695884, 52.18642832225891, 14.388461286788326, 52.25459953141349,
    ],
    '120675708438': [
      14.443239302487674, 52.085424864131966, 14.598707498980167, 52.17292845978047,
    ],
    '120675708458': [
      14.42078161150348, 52.15847945778547, 14.614821748463052, 52.232474973441036,
    ],
    '120675709173': [
      13.687321671332835, 52.3505451234937, 13.792778955799248, 52.407311364663535,
    ],
    '120675709408': [
      13.99779370972034, 52.28947884081728, 14.063429284727357, 52.3564555589741,
    ],
    '120675709469': [
      13.736583868483663, 52.27707239630481, 14.002832440377098, 52.39954927936349,
    ],
    '120680117117': [
      12.647293954468205, 52.68269181205353, 12.985935630792936, 52.86741944245211,
    ],
    '120680181181': [
      12.288288999922374, 53.01494086782885, 12.515769857815181, 53.227824871330355,
    ],
    '120680264264': [
      12.190196463569219, 52.89320131224248, 12.557511520152067, 53.05723786218976,
    ],
    '120680320320': [
      12.658854466127844, 52.80312455701635, 12.983643550553694, 53.09917892231393,
    ],
    '120680353353': [
      12.641107336344811, 53.005035600974956, 13.025862394945623, 53.20959882604723,
    ],
    '120680468468': [
      12.304200617336738, 53.02645083759618, 12.757686532782783, 53.31975232562515,
    ],
    '120680477477': [
      12.426561508813624, 52.78903456579328, 12.653407316290679, 53.015202311197505,
    ],
    '120685804188': [
      12.933468514480488, 52.8755248041464, 13.031431509563559, 52.92326311624712,
    ],
    '120685804280': [
      12.910002577704512, 52.915679711360546, 13.05180087650295, 53.074648794240126,
    ],
    '120685804372': [
      12.960820414351117, 52.84456940609819, 13.042783408462698, 52.90603834094419,
    ],
    '120685804437': [
      12.983200066466857, 52.91161892467794, 13.056593925367547, 52.97025521763349,
    ],
    '120685805052': [
      12.121166745052095, 52.793661450226224, 12.283106467470983, 52.90323409782448,
    ],
    '120685805109': [
      12.379137507645934, 52.75243952011082, 12.550940871468796, 52.82360552724737,
    ],
    '120685805324': [
      12.263352148361355, 52.795856181878946, 12.50693694638231, 52.90768027377017,
    ],
    '120685805409': [
      12.325089588518612, 52.794470628920486, 12.428454233893374, 52.84282393535873,
    ],
    '120685805417': [
      12.249909720219566, 52.861768249875674, 12.33493274384938, 52.92584461776397,
    ],
    '120685805501': [
      12.258519546788147, 52.832904978562425, 12.386952674951608, 52.900083650566174,
    ],
    '120685807072': [
      12.694210747635367, 52.87637436874073, 12.764038057313718, 52.914648434796874,
    ],
    '120685807306': [
      12.615471296206014, 52.88782774787738, 12.76847907960461, 52.978376980580606,
    ],
    '120685807413': [
      12.674417218038853, 52.95034365334049, 12.791486980473097, 53.04044162018557,
    ],
    '120685807425': [
      12.53068068570417, 52.96876770151554, 12.696527343640627, 53.04711711042357,
    ],
    '120685807426': [
      12.563373563685401, 52.80619901813077, 12.718962638905108, 52.90399339253502,
    ],
    '120685807452': [
      12.573319251319779, 52.91364947952475, 12.692623893437366, 52.979547304655235,
    ],
    '120690017017': [
      12.781227891680153, 52.141128261391856, 13.102328394126426, 52.301111925338425,
    ],
    '120690020020': [
      12.434699131774416, 52.070153990634715, 12.722491235772388, 52.270077110248565,
    ],
    '120690249249': [
      12.656210850536146, 52.363576854079895, 12.86412451959045, 52.47440729402729,
    ],
    '120690304304': [
      13.158068223418704, 52.39384512919913, 13.248545291429712, 52.420926658449694,
    ],
    '120690306306': [
      12.50481593542645, 52.23855426229885, 12.82427759009283, 52.39623723433594,
    ],
    '120690397397': [
      12.968111426105285, 52.2253929580613, 13.114844228481045, 52.349869491263306,
    ],
    '120690454454': [
      13.051262909426736, 52.254561498973395, 13.176669910778788, 52.36493511723486,
    ],
    '120690590590': [
      12.852202733149403, 52.27379254421568, 13.02400373085527, 52.391697762878124,
    ],
    '120690596596': [
      12.95313896655955, 52.25495476112349, 13.065465289440917, 52.30591988717689,
    ],
    '120690604604': [
      13.13555944290086, 52.31871037553056, 13.251298830219936, 52.398417768471845,
    ],
    '120690616616': [
      13.233573794371457, 52.350480555843816, 13.310993208698724, 52.41586065506516,
    ],
    '120690632632': [
      12.69835225753043, 51.97882332964534, 13.02212227024994, 52.186791520238295,
    ],
    '120690656656': [
      12.80446311866307, 52.300172132449426, 12.969713537778407, 52.45999274196051,
    ],
    '120690665665': [
      12.26287316687964, 52.000741762151144, 12.581314094957364, 52.17881904292181,
    ],
    '120695902018': [
      12.509199645253451, 52.44779112379824, 12.59534928791543, 52.50989252028454,
    ],
    '120695902019': [
      12.562343376462378, 52.44655782327358, 12.676686519786895, 52.53794193391081,
    ],
    '120695902270': [
      12.406454541875368, 52.41967184240515, 12.583230743875891, 52.55682324372624,
    ],
    '120695902460': [
      12.645652683652434, 52.48464052222921, 12.74962813743096, 52.550023814491325,
    ],
    '120695902541': [
      12.605862250684657, 52.44513125308984, 12.759246520617188, 52.49786408519978,
    ],
    '120695904052': [
      12.84186719642885, 52.204213583374845, 12.884412147764039, 52.248004584067104,
    ],
    '120695904056': [
      12.80886240338822, 52.24649037900759, 12.850191490950627, 52.276167751339806,
    ],
    '120695904076': [
      12.640615741498511, 52.15132517201341, 12.854009708722684, 52.248004584067104,
    ],
    '120695904216': [
      12.508894806066746, 52.23660912557322, 12.649830563055712, 52.32183117228716,
    ],
    '120695904345': [
      12.747810297776303, 52.13432234183548, 12.90233820506307, 52.20864601745392,
    ],
    '120695904470': [
      12.612548185056445, 52.21002221419808, 12.813289549864072, 52.30795890694263,
    ],
    '120695910402': [
      12.718878161203433, 52.06863197350855, 12.88172504813228, 52.188493329108496,
    ],
    '120695910448': [
      12.624699629537517, 52.020644672541366, 12.779606045447656, 52.11802795325003,
    ],
    '120695910474': [
      12.580904658797909, 52.0768792500217, 12.74902927817264, 52.15262850321154,
    ],
    '120695910485': [
      12.536693008292591, 51.981684697684194, 12.702638165318827, 52.082321291192294,
    ],
    '120695917028': [
      12.274660062786513, 52.388009658602925, 12.391335337980028, 52.4539680229367,
    ],
    '120695917537': [
      12.272508049970575, 52.30340476096079, 12.422683628036898, 52.37840790580965,
    ],
    '120695917688': [
      12.292309185174934, 52.34359522370752, 12.408475444308202, 52.39718352689225,
    ],
    '120695918089': [
      12.243234161423587, 52.189006105885156, 12.39977706746743, 52.27703647479282,
    ],
    '120695918224': [
      12.216677414374436, 52.132092765638035, 12.443347453344186, 52.2066510221499,
    ],
    '120695918232': [
      12.330866742435315, 52.18455351131257, 12.474456690822668, 52.275089228380864,
    ],
    '120695918648': [
      12.387336314319517, 52.275089228380864, 12.492544371922191, 52.32573341185904,
    ],
    '120695918680': [
      12.414656761870624, 52.244836749710615, 12.526856913660346, 52.32573341185904,
    ],
    '120695918696': [
      12.244045488640289, 52.229928906387336, 12.425039227271803, 52.31084557793629,
    ],
    '120700125125': [
      11.852239865795568, 53.01762135490719, 12.340328426640337, 53.201934956403264,
    ],
    '120700149149': [
      12.055731777862384, 52.913424640066474, 12.418372234152585, 53.08176479079016,
    ],
    '120700173173': [
      11.550439017381109, 53.071510683989025, 11.854580441551084, 53.24498734571808,
    ],
    '120700296296': [
      11.692608923790967, 53.00584129166368, 11.95202165132029, 53.14544619854563,
    ],
    '120700302302': [
      11.893598184446462, 52.87624375387147, 12.205820691073203, 53.08330258683227,
    ],
    '120700316316': [
      12.082811858630562, 53.07466014068405, 12.3319653558704, 53.23126977447692,
    ],
    '120700424424': [
      11.682519871550483, 52.957118326792624, 11.847311649168393, 53.065306878927004,
    ],
    '120705001008': [
      11.830483767017002, 52.92927225833744, 12.033776112310857, 53.011920766620996,
    ],
    '120705001052': [
      11.773093469799678, 52.97665704309197, 11.870933731497686, 53.02385140596922,
    ],
    '120705001241': [
      11.915938450391314, 52.87775729935367, 12.048982504212908, 52.944217222739226,
    ],
    '120705001348': [
      11.821637984223932, 52.891307387444044, 11.941482918128697, 52.953825005545355,
    ],
    '120705001416': [
      11.749099799217497, 53.01297198088571, 11.81186866653777, 53.0649804594301,
    ],
    '120705005060': [
      11.623864476318976, 53.00131061358939, 11.726398473891738, 53.05721945100802,
    ],
    '120705005236': [
      11.529500843507813, 53.03665538513017, 11.712766049581441, 53.11664673409333,
    ],
    '120705005244': [
      11.335646829401226, 53.0467772474587, 11.622155886341323, 53.17437776425571,
    ],
    '120705005246': [
      11.26816644917272, 53.05521702841809, 11.421168380946485, 53.12104568886832,
    ],
    '120705006096': [
      12.17119194999988, 53.204596119260174, 12.270457243392356, 53.270182832565524,
    ],
    '120705006153': [
      12.221921503494771, 53.20052780983028, 12.35397848276718, 53.27315275513951,
    ],
    '120705006222': [
      12.133492661061792, 53.201557434976806, 12.19892557997871, 53.27879103603905,
    ],
    '120705006266': [
      12.0140030640587, 53.270182832565524, 12.22539485362151, 53.37329384640423,
    ],
    '120705006280': [
      12.198389284824597, 53.26082712868063, 12.32837496681773, 53.3580953129244,
    ],
    '120705009028': [
      11.798191236880223, 53.21479962042902, 11.922926388621232, 53.278597626766555,
    ],
    '120705009145': [
      11.841935952048683, 53.15550067061044, 11.99887597861136, 53.21511011865093,
    ],
    '120705009300': [
      11.831879247486976, 53.172239339380944, 11.96745140370294, 53.257997103470096,
    ],
    '120705009325': [
      11.915310678571213, 53.177327506299804, 12.132366618155869, 53.3215005269361,
    ],
    '120705009393': [
      12.055741277112872, 53.18504687517272, 12.159784677298939, 53.28117829904001,
    ],
    '120710057057': [
      14.092539065070895, 51.580733304534725, 14.339191906294378, 51.72866939239026,
    ],
    '120710076076': [
      14.503785051794738, 51.65550325487883, 14.757718448642258, 51.8210304184787,
    ],
    '120710160160': [
      14.639705196211612, 51.898116607122134, 14.720561616880607, 52.01511997328473,
    ],
    '120710244244': [
      14.101092972741908, 51.7010202646846, 14.310339479456935, 51.8087683366959,
    ],
    '120710301301': [
      14.29818449555333, 51.6213824897842, 14.536327826563731, 51.77944534634432,
    ],
    '120710337337': [
      14.370572469510854, 51.858507662256244, 14.693932253715165, 52.05684262618812,
    ],
    '120710372372': [
      14.2270509529617, 51.50568982485264, 14.547579855069781, 51.65385394379723,
    ],
    '120710408408': [
      14.14646672405655, 51.5282976640632, 14.282242299539302, 51.59140565401631,
    ],
    '120715101028': [
      14.220686602355956, 51.793607635568875, 14.274427497961058, 51.84949222615136,
    ],
    '120715101032': [
      14.075068120704497, 51.80223644283422, 14.17812350338496, 51.87702939947591,
    ],
    '120715101041': [
      14.242087308225413, 51.80335170766095, 14.312563799398532, 51.861515204669104,
    ],
    '120715101164': [
      14.198720247058311, 51.803198794552834, 14.243877745392036, 51.841971527480766,
    ],
    '120715101341': [
      14.167304661723012, 51.837740776717325, 14.28621180911442, 51.907471326763606,
    ],
    '120715101412': [
      14.137368452522743, 51.785808660478274, 14.237850388160586, 51.85022181531189,
    ],
    '120715102044': [
      14.572016899145678, 51.59017488333107, 14.643581596573686, 51.63217039789554,
    ],
    '120715102074': [
      14.469227266551226, 51.573272821424275, 14.594722868170752, 51.65065038489207,
    ],
    '120715102153': [
      14.583930029479966, 51.65638431170368, 14.691418880723292, 51.709202540204785,
    ],
    '120715102189': [
      14.598425347373931, 51.55057057948811, 14.705116160123971, 51.617696677290844,
    ],
    '120715102294': [
      14.55552270774775, 51.58192977708655, 14.764570248399538, 51.67766480502754,
    ],
    '120715102392': [
      14.571005827742653, 51.56637299016137, 14.654344275638296, 51.60063740838685,
    ],
    '120715102414': [
      14.485948851572987, 51.648012271686426, 14.598051034357397, 51.78112241684128,
    ],
    '120715107052': [
      14.250117370368098, 51.85982657137307, 14.356357686665227, 51.934466126330705,
    ],
    '120715107060': [
      14.320020510677296, 51.85031782722938, 14.372935218241974, 51.89297728844218,
    ],
    '120715107176': [
      14.472786009663395, 51.78112241684128, 14.563692702404191, 51.85160320467972,
    ],
    '120715107193': [
      14.45348154877619, 51.813117634287146, 14.624412130984442, 51.95772414452202,
    ],
    '120715107304': [
      14.379327040621275, 51.842333082537394, 14.463911719909259, 51.875916811741476,
    ],
    '120715107384': [
      14.413906447354977, 51.87156675272147, 14.501091510742688, 51.96858851029705,
    ],
    '120715107386': [
      14.371516362415726, 51.80107638241316, 14.496864651828426, 51.85203289964949,
    ],
    '120715107401': [
      14.334524316884945, 51.85386330113688, 14.442105484830643, 51.93849919432142,
    ],
    '120720002002': [
      13.297896300365043, 52.08884692019589, 13.467449361146365, 52.211815086171114,
    ],
    '120720014014': [
      13.278763372148795, 51.95670490385924, 13.652216236315384, 52.11148390254427,
    ],
    '120720017017': [
      13.345963817902337, 52.28738432201777, 13.499173495215958, 52.37783251003135,
    ],
    '120720120120': [
      13.241480337710906, 52.31741161200318, 13.38836639288193, 52.41102077757153,
    ],
    '120720169169': [
      12.958461241767083, 51.95550209800741, 13.230884580575403, 52.093164239937614,
    ],
    '120720232232': [
      13.081471537604555, 52.027211278636194, 13.212550703038024, 52.13402514748231,
    ],
    '120720240240': [
      13.137245005570438, 52.246248228336825, 13.392895238149958, 52.3396212520087,
    ],
    '120720297297': [
      12.769378856815024, 51.86801741933307, 13.126443003870458, 52.03512444598105,
    ],
    '120720312312': [
      12.95298599386, 51.98107194853062, 13.414760074982745, 52.206611572170516,
    ],
    '120720340340': [
      13.391447688134988, 52.255209779955806, 13.509970767887518, 52.320059560784046,
    ],
    '120720426426': [
      13.082694606951888, 52.151603870914634, 13.329248776618677, 52.27314631210637,
    ],
    '120720477477': [
      13.292241523786524, 52.09228150954951, 13.582211749568126, 52.28228483754297,
    ],
    '120725204053': [
      13.271297727406997, 51.79048791573348, 13.572510762923566, 51.97607942652891,
    ],
    '120725204055': [
      13.427510955355565, 51.87867446085238, 13.579943898868514, 51.93313818160602,
    ],
    '120725204157': [
      13.297155372577713, 51.815297653705905, 13.405957604965977, 51.91372071180687,
    ],
    '120725204298': [
      13.082551766032973, 51.81939570612105, 13.333553782633727, 51.99283176351585,
    ],
    '120730008008': [
      13.790561844782026, 52.93228683258244, 14.145490776644143, 53.159602785411884,
    ],
    '120730069069': [
      13.380701068361347, 53.18949490649117, 13.727981518874167, 53.35130344322239,
    ],
    '120730384384': [
      13.240490333014044, 53.11069421222792, 13.429886921226224, 53.28070778934399,
    ],
    '120730429429': [
      13.516702994300562, 53.22075562582933, 13.857657136435625, 53.413727446360234,
    ],
    '120730452452': [
      13.756718600205604, 53.241309862967086, 13.960566053501426, 53.39939889936695,
    ],
    '120730572572': [
      13.321821290558846, 52.987749332357595, 13.671640106781966, 53.2164813827176,
    ],
    '120730579579': [
      13.625697173731929, 53.386834714842834, 13.916977397879814, 53.558763387522724,
    ],
    '120735051440': [
      14.0665544435856, 53.03830377913236, 14.134525831621762, 53.081141469826,
    ],
    '120735051532': [
      14.025681151065696, 52.96258630040976, 14.38265623927158, 53.198126610751004,
    ],
    '120735303085': [
      14.050979171295175, 53.322532452988696, 14.242917604678311, 53.44172863097968,
    ],
    '120735303093': [
      13.997769943600797, 53.32510771999795, 14.113283544515184, 53.409166614573365,
    ],
    '120735303216': [
      13.863492629225572, 53.373646519970315, 13.973937913981608, 53.431812729964776,
    ],
    '120735303490': [
      13.896104453417639, 53.32661806634174, 14.042481599351722, 53.38920505281972,
    ],
    '120735303520': [
      13.959445510355437, 53.373874352999, 14.053927557324226, 53.435766199785334,
    ],
    '120735304097': [
      14.096254118351332, 53.16395431609485, 14.28260985098625, 53.26703709962316,
    ],
    '120735304189': [
      14.281424253825723, 53.1260889192721, 14.425499556322766, 53.2681405800764,
    ],
    '120735304309': [
      14.229671866411849, 53.14636303548312, 14.343961883430318, 53.233890291301314,
    ],
    '120735304393': [
      14.312551178495596, 53.23302701695739, 14.450127674924, 53.32900559997707,
    ],
    '120735304565': [
      14.262740746570918, 53.23653906856233, 14.39076158359788, 53.30187519109504,
    ],
    '120735305157': [
      13.768181546175745, 53.091862836013824, 13.912748971995102, 53.18090560245828,
    ],
    '120735305201': [
      13.654788376924998, 53.08998281050871, 13.853679315497999, 53.230978067493176,
    ],
    '120735305396': [
      13.566364537491118, 53.060664271264294, 13.782322696990938, 53.14475072615879,
    ],
    '120735305404': [
      13.622970502871553, 53.16316053411667, 13.736501635955294, 53.21420562029235,
    ],
    '120735305569': [
      13.624536657515954, 53.00170354657137, 13.81958403705112, 53.11352109757506,
    ],
    '120735306225': [
      13.922522445895046, 53.142575803128885, 14.09783809527479, 53.26450574626536,
    ],
    '120735306261': [
      13.919838989910328, 53.27857170397125, 14.034235612423366, 53.338943907040075,
    ],
    '120735306430': [
      13.789170885844607, 53.138328319484444, 13.964822210465647, 53.24913022673021,
    ],
    '120735306458': [
      13.985627941467419, 53.25582744152069, 14.174306713778662, 53.34838200682576,
    ],
    '120735306578': [
      13.906665901634318, 53.21983526699672, 14.044921169778581, 53.286072006956466,
    ],
    '120735306645': [
      14.002272748871777, 53.12074597376287, 14.10656906211994, 53.212073862608015,
    ],
    '130030000000': [
      11.996192632004485, 54.0531289492389, 12.2929479399591, 54.24535428697145,
    ],
    '130040000000': [
      11.298209861723416, 53.544595002173, 11.505493816551612, 53.68674973174738,
    ],
    '130710027027': [
      12.763541624102745, 53.83447332944719, 12.933195076614274, 54.00635412971208,
    ],
    '130710029029': [
      12.945836861960137, 53.8653414390122, 13.122228238827807, 53.97918762103346,
    ],
    '130710033033': [
      13.20508362451658, 53.24134897235405, 13.555308712019196, 53.41187929865341,
    ],
    '130710107107': [
      13.139875874814917, 53.44357395273426, 13.343108054191559, 53.61795023315821,
    ],
    '130710110110': [
      12.927323569924596, 53.260920001256814, 13.181276402917424, 53.41336826582363,
    ],
    '130710156156': [
      12.584235860667913, 53.39611018224243, 12.789024667280533, 53.58471607044578,
    ],
    '130715151008': [
      13.01682855917642, 53.79978922156021, 13.090059825395116, 53.87539583027087,
    ],
    '130715151014': [
      12.907813233829968, 53.763075665159576, 13.031369635556725, 53.8691621407984,
    ],
    '130715151064': [
      12.985430015971346, 53.7727032535735, 13.036469541702122, 53.79978922156021,
    ],
    '130715151065': [
      13.114756412471202, 53.79220080838677, 13.233778334839439, 53.84388639173202,
    ],
    '130715151072': [
      12.947007135162245, 53.731182826193375, 13.005295310600797, 53.7727032535735,
    ],
    '130715151076': [
      13.064084387110825, 53.90473460256553, 13.21328369800147, 53.94978229872855,
    ],
    '130715151089': [
      12.9915654244534, 53.73787803925833, 13.088476174129505, 53.78119319691824,
    ],
    '130715151096': [
      12.896996107798632, 53.79978724808765, 12.951762044531424, 53.83123287915525,
    ],
    '130715151112': [
      12.873846552789296, 53.944201752568254, 13.01491318255431, 54.00424942998734,
    ],
    '130715151128': [
      13.023796689358631, 53.7634438266971, 13.143422858782365, 53.83624164741538,
    ],
    '130715151131': [
      12.924525211626987, 53.8286591881278, 12.997093096778688, 53.88208041160733,
    ],
    '130715151136': [
      13.066532062336941, 53.861345512668926, 13.210808712150712, 53.91073650525573,
    ],
    '130715151139': [
      12.864650297088541, 53.76984145594127, 12.915900767576716, 53.80499840949316,
    ],
    '130715151148': [
      13.07857845228956, 53.82943208298882, 13.192453208534632, 53.88189410817059,
    ],
    '130715151150': [
      12.881161039730491, 53.82453988176404, 12.952085471358549, 53.874207659262936,
    ],
    '130715151157': [
      12.896480606405266, 53.87281929743074, 12.999974273965323, 53.957868461452875,
    ],
    '130715152028': [
      13.420327080627809, 53.587085372043745, 13.514638013810423, 53.70416625718624,
    ],
    '130715152035': [
      13.407088195678151, 53.55656899422364, 13.66142167972774, 53.75186393329161,
    ],
    '130715152037': [
      13.578118097305097, 53.58707191037178, 13.797413388109785, 53.698731724793895,
    ],
    '130715153007': [
      12.62800863834604, 53.65300870852937, 12.742514151766544, 53.74552337805094,
    ],
    '130715153032': [
      12.717898231666066, 53.585355945142204, 12.843203134262186, 53.67918765327316,
    ],
    '130715153039': [
      12.708447210780779, 53.634117599921254, 12.793654459314707, 53.71801957974053,
    ],
    '130715153084': [
      12.778458225412882, 53.721336927789764, 12.911053591754044, 53.84741120578855,
    ],
    '130715153092': [
      12.625284443069503, 53.66420939766425, 12.853717439934625, 53.80903132353658,
    ],
    '130715153109': [
      12.703695569987008, 53.77950984945358, 12.866020811571701, 53.870757408856505,
    ],
    '130715154001': [
      12.293248685962983, 53.478196847620225, 12.37679499864016, 53.57747314104057,
    ],
    '130715154036': [
      12.328991238895242, 53.37409653974013, 12.463545575017553, 53.46929440031136,
    ],
    '130715154043': [
      12.449197974006879, 53.43638235494989, 12.579070979879315, 53.51219445434576,
    ],
    '130715154093': [
      12.347213471474976, 53.43638235494989, 12.48114779108734, 53.51219445434576,
    ],
    '130715154113': [
      12.31161590662389, 53.49975237160589, 12.484770234589538, 53.59267186000285,
    ],
    '130715154138': [
      12.405422149886956, 53.50467473047816, 12.488793870308156, 53.540729938087225,
    ],
    '130715154155': [
      12.426700368774496, 53.40513156645973, 12.524365276383167, 53.450418501781,
    ],
    '130715154171': [
      12.301298880112103, 53.395576516040336, 12.36979565045779, 53.45320575938078,
    ],
    '130715155099': [
      12.753851895385871, 53.19348978297113, 12.967577380958739, 53.385254408964464,
    ],
    '130715155119': [
      13.008588233331126, 53.1943009368366, 13.110976224264311, 53.248822470411206,
    ],
    '130715155159': [
      12.876135267780342, 53.16274274142271, 13.092247609513828, 53.31066885251807,
    ],
    '130715155167': [
      12.854045331731326, 53.180164766197116, 13.003371305933243, 53.26578024591802,
    ],
    '130715156011': [
      13.170173838985471, 53.366058179155566, 13.337017588044915, 53.449989695337955,
    ],
    '130715156012': [
      13.040593343846622, 53.37730296751159, 13.194575074034752, 53.465321404120864,
    ],
    '130715156025': [
      13.1147545237579, 53.297884947097536, 13.300810009219372, 53.39876307016479,
    ],
    '130715156042': [
      13.079805020691408, 53.236231594654875, 13.18075865422492, 53.27300629139791,
    ],
    '130715156058': [
      13.264554499093652, 53.304223744175495, 13.340341891776943, 53.37998988632765,
    ],
    '130715156066': [
      13.05848463953596, 53.421213082920055, 13.15922370713231, 53.47805998483776,
    ],
    '130715156075': [
      12.96332657199229, 53.40095565277077, 13.101306055565333, 53.47437270725635,
    ],
    '130715156080': [
      12.844450459530606, 53.374358487197036, 12.98987783619719, 53.46594834535603,
    ],
    '130715156100': [
      13.276805950198808, 53.370542872014354, 13.42159245377048, 53.4370820818588,
    ],
    '130715156147': [
      12.903796914952983, 53.281643664157876, 13.044682538155767, 53.35928605466899,
    ],
    '130715156162': [
      13.153276648917803, 53.21681078305557, 13.25196739015835, 53.33440899401857,
    ],
    '130715157009': [
      13.402903089778158, 53.685453258991004, 13.486719772279978, 53.71823631240147,
    ],
    '130715157010': [
      13.090562791451353, 53.555782125051884, 13.180539801221956, 53.59759712444441,
    ],
    '130715157019': [
      13.308261162486543, 53.63591989842477, 13.466606074830924, 53.70336416526806,
    ],
    '130715157104': [
      13.25548928553286, 53.63031593536094, 13.321365421570228, 53.672483469449844,
    ],
    '130715157108': [
      13.311290518748269, 53.568833073313755, 13.421371540457981, 53.61955172309587,
    ],
    '130715157111': [
      13.307219005686225, 53.595496347118065, 13.37742260098736, 53.63860408238661,
    ],
    '130715157140': [
      13.324022238121543, 53.52844128188813, 13.46519664702904, 53.58835629873081,
    ],
    '130715157141': [
      13.343287186197685, 53.60841106866855, 13.43356799024575, 53.65286860431192,
    ],
    '130715157145': [
      13.250880063220844, 53.59087901472368, 13.326799547860496, 53.639949959226364,
    ],
    '130715157161': [
      13.193651770688088, 53.59498234807113, 13.250880063220844, 53.62074106787661,
    ],
    '130715157166': [
      13.147259827104174, 53.49608278931277, 13.222150012653534, 53.56708656831293,
    ],
    '130715157170': [
      13.163918436325865, 53.56708656831293, 13.231933699459997, 53.60293821695653,
    ],
    '130715158005': [
      12.877090458448516, 53.450876953990694, 12.988140634060132, 53.52341736103383,
    ],
    '130715158101': [
      12.860184976817163, 53.48288541940963, 12.977375071398004, 53.59615518437394,
    ],
    '130715158115': [
      12.942389722526203, 53.462247876129105, 13.18371551421133, 53.56932784820553,
    ],
    '130715158173': [
      13.054905308247328, 53.50387478412282, 13.155590026463551, 53.558498990786404,
    ],
    '130715159003': [
      12.318806526729285, 53.33154084541486, 12.413103339571736, 53.376880106216404,
    ],
    '130715159013': [
      12.513381865235942, 53.290706947832504, 12.6138761964675, 53.367365435228585,
    ],
    '130715159020': [
      12.608913348759211, 53.249367098192536, 12.69169804028354, 53.29166669369171,
    ],
    '130715159023': [
      12.459944567063832, 53.3191962346393, 12.565923956546744, 53.38011368887067,
    ],
    '130715159034': [
      12.32837496681773, 53.300336061663025, 12.474400912059373, 53.38040495572272,
    ],
    '130715159045': [
      12.567869246604761, 53.39644007119906, 12.630459265985651, 53.43214968525847,
    ],
    '130715159053': [
      12.520036339755498, 53.390678432862444, 12.57181144944917, 53.423264126393214,
    ],
    '130715159073': [
      12.539130085181313, 53.244574823771245, 12.628302080482575, 53.293254629149324,
    ],
    '130715159087': [
      12.664597618497973, 53.226725984713624, 12.777008388766383, 53.32425034331098,
    ],
    '130715159088': [
      12.430086931314676, 53.355883643841, 12.535334239506104, 53.410531914508574,
    ],
    '130715159097': [
      12.569331340972974, 53.277736548156724, 12.636679909267091, 53.344407840396656,
    ],
    '130715159118': [
      12.620473413877583, 53.27340198918772, 12.69169804028354, 53.31871960196564,
    ],
    '130715159122': [
      12.692717799590465, 53.30079702093441, 12.857405111778595, 53.43268581258559,
    ],
    '130715159124': [
      12.535282136643657, 53.32561676078612, 12.646353260834578, 53.41870748700353,
    ],
    '130715159133': [
      12.688587888690055, 53.18837452389944, 12.81557542811725, 53.251414957996715,
    ],
    '130715159137': [
      12.520036339755498, 53.412958319646656, 12.597821999935768, 53.4601427742838,
    ],
    '130715159143': [
      12.276265326181058, 53.351943319504024, 12.380841099134637, 53.40251934762369,
    ],
    '130715159175': [
      12.392449535601326, 53.25130543358645, 12.577240159720247, 53.33372551558428,
    ],
    '130715159176': [
      12.609832069510793, 53.30846786784769, 12.782573027842327, 53.41870748700353,
    ],
    '130715160047': [
      12.52811612969949, 53.540726723044465, 12.681556395804762, 53.61351992113019,
    ],
    '130715160056': [
      12.816231613589736, 53.51856061811487, 12.91009078990707, 53.60365340284226,
    ],
    '130715160063': [
      12.398361001077971, 53.55957594391259, 12.491190165493112, 53.65499515177797,
    ],
    '130715160069': [
      12.452177703469289, 53.487785124887985, 12.613370788459319, 53.60847841080976,
    ],
    '130715160071': [
      12.727487617742625, 53.40888599981933, 12.88574991961146, 53.52280190322461,
    ],
    '130715160077': [
      12.564399901499227, 53.42422407870588, 12.651028987864043, 53.50840347529944,
    ],
    '130715160078': [
      12.477594126156086, 53.59380312997889, 12.592675647874708, 53.65820167963565,
    ],
    '130715160103': [
      12.556630346984575, 53.600766621409264, 12.732748111529544, 53.66461924686258,
    ],
    '130715160144': [
      12.735635540561162, 53.51705924245729, 12.800305337915576, 53.575937450028256,
    ],
    '130715160154': [
      12.396058297448342, 53.624348044141094, 12.550327574563422, 53.69830083681376,
    ],
    '130715160172': [
      12.637222464696126, 53.55635516183784, 12.847617888437577, 53.62484060032839,
    ],
    '130715160174': [
      12.768201950550775, 53.4641739479155, 12.896573851779506, 53.557580272328266,
    ],
    '130715161021': [
      13.219397174314953, 53.42351432997525, 13.412456355928343, 53.53042946753916,
    ],
    '130715161026': [
      13.389002089550289, 53.493213271169914, 13.492537313632077, 53.55017956441011,
    ],
    '130715161055': [
      13.175969665715272, 53.43215636245711, 13.255451258490085, 53.50025722244668,
    ],
    '130715161067': [
      13.232280804618673, 53.43702558007944, 13.29132980308274, 53.50341974399084,
    ],
    '130715161090': [
      13.355170401361578, 53.437032719643724, 13.524082715760152, 53.51811871903145,
    ],
    '130715161117': [
      13.361317155274236, 53.51614899386892, 13.428369659149036, 53.56352403176545,
    ],
    '130715162015': [
      12.906100191332044, 53.59037690798401, 12.97123844838943, 53.616310884575476,
    ],
    '130715162018': [
      12.926127242686562, 53.6086842563822, 13.007774558368766, 53.6485842707673,
    ],
    '130715162048': [
      12.86639290694067, 53.73228795792562, 12.947888786174536, 53.77532946479077,
    ],
    '130715162060': [
      12.823115178107601, 53.66924352761699, 12.881097649606518, 53.70918838260088,
    ],
    '130715162068': [
      12.92490836528103, 53.6558845809457, 13.05141480452761, 53.74931836234237,
    ],
    '130715162070': [
      12.83171789389965, 53.63266714229514, 12.95315531679895, 53.67703903595336,
    ],
    '130715162074': [
      12.841835096230811, 53.59748783944592, 12.936036981446128, 53.64578622751478,
    ],
    '130715162079': [
      13.024639012708649, 53.60091324976386, 13.122501377519422, 53.67440268502959,
    ],
    '130715162102': [
      12.99319871035337, 53.546086353711914, 13.135044131444207, 53.61005054549535,
    ],
    '130715162123': [
      12.930300108147637, 53.635064563135124, 13.027282587994083, 53.687764035721834,
    ],
    '130715162127': [
      12.958624832453012, 53.568900707670714, 13.060490759787225, 53.64576157884962,
    ],
    '130715162142': [
      12.852799444755698, 53.65916578764739, 12.970230359509632, 53.744844655870665,
    ],
    '130715162169': [
      12.790116927344577, 53.60988075687065, 12.874614729014699, 53.66431596914925,
    ],
    '130715163002': [
      13.080174248965877, 53.7356802807333, 13.150499109553246, 53.785577390655426,
    ],
    '130715163004': [
      13.168695199764235, 53.6493043937245, 13.316620111624918, 53.74915789545148,
    ],
    '130715163006': [
      13.280422073116608, 53.76793532448298, 13.398689899950813, 53.8489931914703,
    ],
    '130715163016': [
      13.120151689687818, 53.588236052875864, 13.213621885077258, 53.64501627627228,
    ],
    '130715163022': [
      13.247979231720791, 53.72335223281936, 13.313074400074369, 53.78350467888703,
    ],
    '130715163041': [
      13.137367924547355, 53.76488037891803, 13.235979146492314, 53.805215201803996,
    ],
    '130715163044': [
      13.216721706758324, 53.735730965561245, 13.303388985197508, 53.81918777954496,
    ],
    '130715163049': [
      13.259343454515111, 53.702774405571766, 13.340864391683004, 53.742001481318574,
    ],
    '130715163050': [
      13.300980554500677, 53.672483469449844, 13.380963982259324, 53.70662759039526,
    ],
    '130715163057': [
      13.17897240990908, 53.61795023315821, 13.265107808359474, 53.668845336149055,
    ],
    '130715163059': [
      13.130368845876296, 53.73010625983701, 13.233360374110983, 53.78013156038399,
    ],
    '130715163081': [
      13.015640655803436, 53.70290048774455, 13.09703569962703, 53.758466837373426,
    ],
    '130715163120': [
      13.15282599252146, 53.68179339944129, 13.215631471860297, 53.74001165417608,
    ],
    '130715163125': [
      13.05992521733054, 53.69175147518273, 13.120614525582274, 53.74345699347253,
    ],
    '130715163135': [
      13.35398221093486, 53.70336416526806, 13.431366316682775, 53.76244691252996,
    ],
    '130715163146': [
      13.110450351116498, 53.688271467250765, 13.191635703512786, 53.755346130243915,
    ],
    '130715163158': [
      13.309517742400535, 53.69265529327295, 13.402903089778158, 53.786929146946655,
    ],
    '130715163160': [
      13.080587953336694, 53.6298284935823, 13.192195828553944, 53.67806279403002,
    ],
    '130715163163': [
      13.019768434439886, 53.66231070437141, 13.170321831300896, 53.70592697561251,
    ],
    '130715164054': [
      13.52735105381953, 53.50963952909634, 13.681062964627554, 53.576974557007155,
    ],
    '130715164083': [
      13.462944622531369, 53.5411860056428, 13.550821466446713, 53.576974557007155,
    ],
    '130715164105': [
      13.456421858673716, 53.514440707263255, 13.539028282481404, 53.551191269797755,
    ],
    '130715164130': [
      13.518859755768217, 53.56602469093618, 13.668361983766012, 53.60480396923406,
    ],
    '130715164132': [
      13.659270524870037, 53.53496824246683, 13.726051948815337, 53.59329712180802,
    ],
    '130715164153': [
      13.620490181595702, 53.545799691690284, 13.677695650668015, 53.5737615783894,
    ],
    '130715164164': [
      13.394307816591812, 53.38768457681561, 13.707985595582581, 53.522055167468345,
    ],
    '130720006006': [
      11.808014313047062, 54.07833114669719, 11.950166416682126, 54.146371787293724,
    ],
    '130720029029': [
      12.121545286276998, 53.95434057189206, 12.334072100586042, 54.07251452700534,
    ],
    '130720036036': [
      12.201716359734633, 54.2427917509164, 12.285572688483139, 54.275222056479436,
    ],
    '130720043043': [
      12.118972355604791, 53.75094262396803, 12.294370119632351, 53.835653239321175,
    ],
    '130720058058': [
      11.716851130583477, 54.00256869413704, 11.864241575614129, 54.12301207294806,
    ],
    '130720060060': [
      11.693351774493324, 54.11388206764809, 11.782279577355181, 54.155251469920046,
    ],
    '130720074074': [
      11.621625793753845, 53.994202053242105, 11.704735553048927, 54.0603975348958,
    ],
    '130720091091': [
      12.298407200116054, 53.99559135276005, 12.463113296855294, 54.124104615969145,
    ],
    '130720093093': [
      11.781926768881732, 53.93279628034029, 12.02201728812528, 54.069682784758136,
    ],
    '130720106106': [
      12.505622647696415, 53.74319695426058, 12.663460535421239, 53.81075826015541,
    ],
    '130725251001': [
      11.93758147446484, 54.102286878559966, 12.021053140080113, 54.14704427167735,
    ],
    '130725251007': [
      11.933975938485654, 54.061253871907056, 11.99714184604752, 54.11136123411199,
    ],
    '130725251017': [
      11.85895134865345, 54.12172110915436, 11.966722106147158, 54.16033433515924,
    ],
    '130725251047': [
      11.893943894565984, 54.0521362846143, 11.950166416682126, 54.092174222564644,
    ],
    '130725251075': [
      11.925604857194106, 54.14687023979365, 11.996192632004485, 54.17493339334562,
    ],
    '130725251083': [
      11.824393654780875, 54.07655342051817, 11.878497740673062, 54.114526030926065,
    ],
    '130725251086': [
      11.837398038899664, 54.02765241037525, 11.912046808019133, 54.097031983507904,
    ],
    '130725251099': [
      11.792702709667859, 54.086983554998596, 11.850410869707872, 54.12703530644606,
    ],
    '130725251117': [
      11.777214334082137, 54.10483684848428, 11.837275335921172, 54.15009932739448,
    ],
    '130725252009': [
      11.791730108948915, 53.78908053445594, 11.9037978635805, 53.859742656324705,
    ],
    '130725252013': [
      11.758789802351291, 53.82319317300331, 11.957699891960969, 53.94416258162911,
    ],
    '130725252020': [
      11.94119356405303, 53.8038838132449, 12.03588420404947, 53.897675138996846,
    ],
    '130725252028': [
      11.94223497875064, 53.77292591811391, 12.036524132140098, 53.81176108675937,
    ],
    '130725252050': [
      11.78984799985116, 53.883296286903814, 11.937401184132087, 53.98631948486846,
    ],
    '130725252053': [
      11.90917161547868, 53.87344265508684, 12.03635918832524, 53.968144367517176,
    ],
    '130725252078': [
      11.901857370181858, 53.898476860373144, 11.948920277455391, 53.9285092445296,
    ],
    '130725252089': [
      11.886414355607846, 53.79549676420146, 11.962808860277311, 53.84408819805865,
    ],
    '130725252101': [
      11.897490027908423, 53.835824772424466, 11.968437554697543, 53.87435049121829,
    ],
    '130725252104': [
      11.893516976712904, 53.73558969833209, 12.049189561769134, 53.81809270124976,
    ],
    '130725252114': [
      11.79213025019376, 53.73401208974866, 11.96284222481345, 53.80020863074827,
    ],
    '130725252120': [
      12.004664327952066, 53.81176108675937, 12.093699048492404, 53.88255741196152,
    ],
    '130725253019': [
      12.201882525136417, 54.0542705041697, 12.350880143254274, 54.12572422980305,
    ],
    '130725253081': [
      12.271458589413223, 54.11857609746449, 12.333734185997804, 54.1687526932854,
    ],
    '130725253087': [
      12.192039068293358, 54.05007220588727, 12.258403766653709, 54.07987210871299,
    ],
    '130725253108': [
      12.24937863835516, 54.0738721973467, 12.355097784643359, 54.102596055652036,
    ],
    '130725254004': [
      12.660650937947553, 53.86026242788618, 12.801651886690085, 53.936053584730594,
    ],
    '130725254010': [
      12.580019148670148, 53.95046068912243, 12.815776629571284, 54.04660744881196,
    ],
    '130725254031': [
      12.709153040284189, 53.92072874031242, 12.814277407082873, 53.96205213842102,
    ],
    '130725254035': [
      12.652298278333525, 53.928900818088046, 12.770611342390623, 54.00876342933202,
    ],
    '130725254111': [
      12.500215863883936, 53.90554157451463, 12.67640400274691, 54.01642536860113,
    ],
    '130725255033': [
      12.243965697765267, 53.79110364366948, 12.333492081510075, 53.83394328401858,
    ],
    '130725255039': [
      12.066983904654387, 53.8191026022412, 12.124391187083964, 53.864491437329164,
    ],
    '130725255042': [
      11.975155842774567, 53.71025682963742, 12.132259379066896, 53.82730813644938,
    ],
    '130725255044': [
      12.082343413862795, 53.72797195581906, 12.183875469459798, 53.797055745883995,
    ],
    '130725255055': [
      12.028321008731062, 53.69532278396139, 12.079744406905297, 53.7338723982695,
    ],
    '130725255061': [
      12.2146841214713, 53.83969793627009, 12.294608398045831, 53.88193516431055,
    ],
    '130725255067': [
      12.027868752705858, 53.64248420606602, 12.129354533044872, 53.74130751388369,
    ],
    '130725255069': [
      12.118689467695454, 53.816057135211004, 12.19528077175557, 53.861776060080906,
    ],
    '130725255071': [
      12.110364775729083, 53.841006066108825, 12.218287286525417, 53.89850884227727,
    ],
    '130725255073': [
      12.154621597351635, 53.71954586476914, 12.287928426789513, 53.76719134887689,
    ],
    '130725255079': [
      12.256815223415915, 53.79815353879039, 12.37359216502141, 53.87362578428165,
    ],
    '130725255084': [
      12.105448818130613, 53.63637677435816, 12.252293026480842, 53.691849859582064,
    ],
    '130725255092': [
      12.181413482789072, 53.83082795360589, 12.259724658596486, 53.877470929459385,
    ],
    '130725255119': [
      12.108231116765646, 53.67379657165359, 12.181322676751552, 53.737778969636395,
    ],
    '130725256026': [
      12.248675896558051, 53.56679793557501, 12.416423281342526, 53.665888900097535,
    ],
    '130725256048': [
      12.251285769191245, 53.68439573897718, 12.349727249679923, 53.747714494043535,
    ],
    '130725256056': [
      12.165450960533168, 53.590342889405015, 12.327651559294996, 53.729636384322184,
    ],
    '130725256059': [
      12.28782532668101, 53.64249451535201, 12.421174931781064, 53.71149051322221,
    ],
    '130725256063': [
      12.282012877198639, 53.6602891609738, 12.49331778959472, 53.83461177670128,
    ],
    '130725257027': [
      12.184808954730858, 53.91481647754166, 12.312960735208778, 53.977616032627004,
    ],
    '130725257046': [
      12.159394914994632, 53.88391563113247, 12.260635079834147, 53.94570273517839,
    ],
    '130725257062': [
      12.213156859614191, 53.82034462249346, 12.463921277618208, 53.95445619096383,
    ],
    '130725257112': [
      12.28149205579458, 53.90653132068055, 12.513003495246783, 54.00119927871228,
    ],
    '130725258003': [
      12.59164585487812, 53.770140979207, 12.703738614242434, 53.82849473893396,
    ],
    '130725258023': [
      12.470391095944485, 53.642344642934134, 12.65778306384394, 53.70220924873602,
    ],
    '130725258024': [
      12.445291571061091, 53.79135345536963, 12.553324392739576, 53.83347255034992,
    ],
    '130725258038': [
      12.429018624433287, 53.76459128559971, 12.541567866704765, 53.81221032284678,
    ],
    '130725258040': [
      12.449810899103818, 53.70151553192683, 12.528118833006136, 53.77207872155696,
    ],
    '130725258041': [
      12.489638592702885, 53.83660695502054, 12.592895802297388, 53.91574763068082,
    ],
    '130725258045': [
      12.509553564179901, 53.6897819354385, 12.589879861517366, 53.75942608125089,
    ],
    '130725258049': [
      12.559422510978838, 53.82677234245814, 12.685855176153726, 53.90073191971474,
    ],
    '130725258066': [
      12.64706471451842, 53.81264522116051, 12.75309546736894, 53.86908450079549,
    ],
    '130725258082': [
      12.42448342814555, 53.85020908184534, 12.539232659343957, 53.94245873819297,
    ],
    '130725258094': [
      12.551589577322098, 53.6708088882616, 12.639070249056283, 53.745405634477265,
    ],
    '130725258096': [
      12.539232659343957, 53.88274498712153, 12.691353480427265, 53.92649948746509,
    ],
    '130725258103': [
      12.570333898624781, 53.817972556430554, 12.647011040431302, 53.87500820686648,
    ],
    '130725258109': [
      12.519877311549706, 53.80293147480483, 12.612558644981762, 53.848223488691026,
    ],
    '130725258113': [
      12.428868063724794, 53.81939721537431, 12.543214734000294, 53.858100687216144,
    ],
    '130725259002': [
      11.576414067072427, 53.98117805908935, 11.665641683761555, 54.02644405623027,
    ],
    '130725259005': [
      11.56285977278647, 54.01820222252912, 11.635471009264917, 54.0705382932466,
    ],
    '130725259008': [
      11.64184544709404, 54.06781845830273, 11.73001867682678, 54.15451400814146,
    ],
    '130725259014': [
      11.665052054873959, 54.01789137744356, 11.774091980030123, 54.107109373476575,
    ],
    '130725259022': [
      11.651559173887117, 53.93455616909502, 11.79300265864078, 54.0266114948965,
    ],
    '130725259085': [
      11.509703380841822, 54.038441616906695, 11.685795945515126, 54.14354182908943,
    ],
    '130725260012': [
      12.172372605837406, 54.097559424960785, 12.289098310546382, 54.1677311609621,
    ],
    '130725260015': [
      12.306377486170465, 54.110282287207966, 12.388351294057292, 54.184991760628904,
    ],
    '130725260032': [
      12.255672620096643, 54.18493820932091, 12.372533307791882, 54.26212948044312,
    ],
    '130725260072': [
      12.183039640842637, 54.132758178440206, 12.25038731714449, 54.16555183619964,
    ],
    '130725260088': [
      12.172857768606766, 54.157158057814904, 12.322274022394202, 54.19771738828907,
    ],
    '130725261011': [
      12.063543873976181, 53.96161980190967, 12.129075447088708, 54.002312919929224,
    ],
    '130725261018': [
      11.998842198775353, 53.94113826647242, 12.08640593319287, 53.97665573521779,
    ],
    '130725261051': [
      12.045580828301615, 53.86353091793149, 12.122165803504288, 53.9120031575956,
    ],
    '130725261090': [
      12.111420906457544, 53.89286473324066, 12.178743104607372, 53.93111683014037,
    ],
    '130725261095': [
      11.979106732021476, 53.909323845916454, 12.139879988289499, 53.96703865829121,
    ],
    '130725261110': [
      12.016200532495235, 53.87344265508684, 12.107120538945587, 53.92535504926698,
    ],
    '130725261116': [
      12.10777388481463, 53.924735402255415, 12.188552174565649, 53.975478777258125,
    ],
    '130725262021': [
      12.339469438005885, 53.959950211309355, 12.45296440695529, 54.03318926998941,
    ],
    '130725262034': [
      12.457345677785685, 54.06039484460466, 12.550591586386984, 54.09715308831036,
    ],
    '130725262037': [
      12.579633937241285, 54.02701768026061, 12.658894258630198, 54.079181230248665,
    ],
    '130725262076': [
      12.564626698546224, 54.005490510552015, 12.631425936833786, 54.03548795876633,
    ],
    '130725262097': [
      12.40470284592025, 53.95118459445695, 12.55906483053366, 54.01867413558788,
    ],
    '130725262102': [
      12.494393534369229, 54.06597840520386, 12.580833350358459, 54.09395513926315,
    ],
    '130725262105': [
      12.423483095439561, 54.007132075071105, 12.541695653058195, 54.05711932596661,
    ],
    '130725262107': [
      12.509036768068649, 54.00712581943703, 12.598276361083315, 54.07307127975814,
    ],
    '130725262118': [
      12.446489220060988, 54.0383417703638, 12.53158748263851, 54.0812375649035,
    ],
    '130725263030': [
      11.976002591859896, 54.12635473627969, 12.038784484058372, 54.17493339334562,
    ],
    '130725263057': [
      12.014407940929072, 54.02952149102986, 12.077293543481261, 54.094041854771845,
    ],
    '130725263064': [
      11.984179239084146, 54.073775017607716, 12.049567218867459, 54.123780916268814,
    ],
    '130725263077': [
      12.062325041477232, 54.02168138504631, 12.176616242053127, 54.06822135376553,
    ],
    '130725263080': [
      12.069815773416147, 53.97960412647793, 12.133895480606524, 54.02212649987466,
    ],
    '130725263098': [
      11.970754568896176, 54.02946162946545, 12.052023913298864, 54.07452326090237,
    ],
    '130725263121': [
      12.000384336695546, 53.97208537120781, 12.078491237058868, 54.035544355546826,
    ],
    '130730011011': [
      13.524346308714382, 54.36705385363992, 13.676819884789353, 54.47725572330188,
    ],
    '130730035035': [
      12.96485451202743, 54.07280747125156, 13.11931353943046, 54.170548662136106,
    ],
    '130730055055': [
      12.353861934017814, 54.10485717139535, 12.645283298492746, 54.23103090895841,
    ],
    '130730070070': [
      13.370697622631777, 54.30057617208615, 13.591467726641634, 54.39308783894549,
    ],
    '130730080080': [
      13.52704536066706, 54.473452110544876, 13.67878438771175, 54.582288392375304,
    ],
    '130730088088': [
      12.996688297079341, 54.24665222474372, 13.18154238067903, 54.34582860117458,
    ],
    '130730089089': [
      12.961859144950765, 54.01345428376808, 13.288834668844816, 54.14852789521991,
    ],
    '130730105105': [
      12.627077257918291, 54.40926161152316, 12.923025936788463, 54.449166050255286,
    ],
    '130735351005': [
      12.879729958731566, 54.34425136154316, 12.987646378208126, 54.39827731379196,
    ],
    '130735351037': [
      12.897149282048355, 54.36400092369117, 13.058677229047303, 54.45988403005818,
    ],
    '130735351044': [
      12.989462203425873, 54.38780489185422, 13.034568950602262, 54.43689239468732,
    ],
    '130735351046': [
      13.011897787621033, 54.31419491623749, 13.09314941916367, 54.381911963940155,
    ],
    '130735351066': [
      12.94188058346023, 54.31833514529215, 13.027446604147332, 54.360628472593135,
    ],
    '130735351068': [
      12.965007723298685, 54.35495605365513, 13.076671688444822, 54.39437047069192,
    ],
    '130735352009': [
      12.587669062067398, 54.3278445389327, 12.78897489450398, 54.395766998219415,
    ],
    '130735352018': [
      12.615153830264365, 54.2881390150215, 12.72792617241819, 54.342783079953236,
    ],
    '130735352025': [
      12.534748763290738, 54.32605600145608, 12.660689529195754, 54.38089498984026,
    ],
    '130735352042': [
      12.770561419145679, 54.28173369441191, 12.841130300626524, 54.323889247119546,
    ],
    '130735352043': [
      12.718102109332188, 54.310036113955796, 12.807847244137829, 54.379254007839656,
    ],
    '130735352051': [
      12.670895905617648, 54.27276400822194, 12.788169413746688, 54.3250364191735,
    ],
    '130735352053': [
      12.586959916312809, 54.2876711875532, 12.652369503675216, 54.32950397484051,
    ],
    '130735352069': [
      12.643157433839164, 54.36848768227304, 12.713649408932941, 54.41014913258209,
    ],
    '130735352077': [
      12.468184808769152, 54.27141968242796, 12.607881007666968, 54.35725603734973,
    ],
    '130735352094': [
      12.572770215677702, 54.23513263817362, 12.726592836691513, 54.28834087864863,
    ],
    '130735353010': [
      13.32545751388382, 54.37840936747558, 13.581214482097105, 54.46348253693436,
    ],
    '130735353014': [
      13.423821808753063, 54.422402209478136, 13.512967118668405, 54.45477114577914,
    ],
    '130735353027': [
      13.295501652640157, 54.224450098134334, 13.423692748658675, 54.37916819609186,
    ],
    '130735353038': [
      13.140295167763338, 54.26835221355862, 13.25978252702327, 54.3344482959403,
    ],
    '130735353049': [
      13.500455068210371, 54.4790251932896, 13.562069067085314, 54.512617082186964,
    ],
    '130735353063': [
      13.292264312426848, 54.40106478208427, 13.413832937307447, 54.45793034438409,
    ],
    '130735353064': [
      13.346445778234298, 54.45222044687191, 13.413773026322172, 54.478290264897346,
    ],
    '130735353065': [
      13.227835712519038, 54.253595470590206, 13.34876246575679, 54.32737263790574,
    ],
    '130735353072': [
      13.40038795996838, 54.44544416825598, 13.499050237413146, 54.491256929728074,
    ],
    '130735353074': [
      13.328498081969181, 54.47393236423058, 13.417414571378556, 54.53964699169549,
    ],
    '130735353083': [
      13.337663865354719, 54.36603815828202, 13.44720817362365, 54.42186437513669,
    ],
    '130735354002': [
      12.390542271306748, 54.35702024319198, 12.445355255888852, 54.39935786104139,
    ],
    '130735354012': [
      12.444045924131979, 54.37299299298593, 12.595049012701319, 54.48263510743999,
    ],
    '130735354017': [
      12.278401459781259, 54.250193036682504, 12.393667817238951, 54.323690200308064,
    ],
    '130735354067': [
      12.546162168175213, 54.42592962063193, 12.636819704792563, 54.45495257810016,
    ],
    '130735354100': [
      12.560706583404546, 54.3833168980028, 12.645630304102323, 54.43781436499018,
    ],
    '130735354103': [
      12.363319902075897, 54.322903536694625, 12.417125385873334, 54.35850907169471,
    ],
    '130735355024': [
      12.832492253895047, 54.1607798969039, 12.915685676614798, 54.203772173510714,
    ],
    '130735355029': [
      12.872791714929816, 53.982539455935076, 13.010142420527488, 54.06494576683644,
    ],
    '130735355034': [
      12.81176805593323, 54.089072940500174, 12.968833779158151, 54.17487916704009,
    ],
    '130735355057': [
      12.791281349066569, 54.155011043797884, 12.862706697878936, 54.24360549084679,
    ],
    '130735355062': [
      12.945069436399539, 54.12967654037818, 13.044261154692324, 54.182747354191406,
    ],
    '130735355076': [
      12.852377102234765, 54.193930263363136, 12.947502281317295, 54.22299144012197,
    ],
    '130735355086': [
      12.886244085149752, 54.090020718106516, 13.035429966273885, 54.14108603647295,
    ],
    '130735355096': [
      12.70148348347454, 54.2204617643084, 12.934827776220578, 54.315612105775664,
    ],
    '130735355097': [
      12.728734994960906, 54.185268998109834, 12.80799114821, 54.24243082796094,
    ],
    '130735355098': [
      12.914934334252354, 54.057713362978326, 13.018442276401506, 54.110173922897154,
    ],
    '130735356023': [
      13.033309377252245, 54.18777841382058, 13.121498966266076, 54.24420758865584,
    ],
    '130735356090': [
      13.081513376551081, 54.11420551450356, 13.318053737123828, 54.26621026442905,
    ],
    '130735356102': [
      12.892384860899, 54.15263375877452, 13.114418666871492, 54.21418747957674,
    ],
    '130735357006': [
      13.684355183577782, 54.34884956026218, 13.726574797793193, 54.36455679594383,
    ],
    '130735357031': [
      13.684355183577782, 54.32364055031554, 13.766878184874104, 54.35571851788089,
    ],
    '130735357048': [
      13.590158845870176, 54.330373045351024, 13.659870729790503, 54.38249563360625,
    ],
    '130735357084': [
      13.646379376446296, 54.34882265864525, 13.714948467865186, 54.39859200446449,
    ],
    '130735357106': [
      13.511301128885682, 54.3590433565292, 13.614410400877139, 54.41120503261054,
    ],
    '130735357107': [
      13.620129004306385, 54.26874774563648, 13.731237582132367, 54.34884956026218,
    ],
    '130735358036': [
      12.77469018558515, 54.312784512500905, 12.865901821282964, 54.35228363934711,
    ],
    '130735358041': [
      12.892637522427307, 54.195429842560706, 12.980445360285094, 54.26322793821622,
    ],
    '130735358054': [
      12.986703892509285, 54.26111639517092, 13.050793020443459, 54.33919567326292,
    ],
    '130735358060': [
      12.828888301584888, 54.25770060443307, 12.987214254545211, 54.366704504952374,
    ],
    '130735358061': [
      12.947244921924009, 54.26871274352258, 13.00259754896093, 54.318700273957965,
    ],
    '130735358087': [
      12.931264076321375, 54.206681990718685, 13.06143780480373, 54.26874910013461,
    ],
    '130735358099': [
      13.042538342054808, 54.23675165088366, 13.132450428931367, 54.285660890491485,
    ],
    '130735358104': [
      13.057539725533978, 54.22876065495998, 13.121971363944574, 54.24392131508353,
    ],
    '130735359004': [
      13.299245347466213, 54.619960425222594, 13.386980203741276, 54.681914599941166,
    ],
    '130735359013': [
      13.29730409657882, 54.572453939556155, 13.42277726915015, 54.62663097977973,
    ],
    '130735359019': [
      13.160612150668573, 54.557973843807794, 13.323636423386322, 54.67382944417674,
    ],
    '130735359030': [
      13.407114857784245, 54.535587737537845, 13.548634068581233, 54.580027655161516,
    ],
    '130735359052': [
      13.5469501170476, 54.54643586737125, 13.6429141492833, 54.582288392375304,
    ],
    '130735359071': [
      13.364830988983979, 54.64539131057993, 13.437690835260835, 54.684671468162634,
    ],
    '130735359078': [
      13.507486320114795, 54.50454554237029, 13.621176797470163, 54.5695787478495,
    ],
    '130735359101': [
      13.242443651504633, 54.55909536741497, 13.346599798236854, 54.6610261842774,
    ],
    '130735360007': [
      12.600243919535707, 54.07445840840519, 12.71855333426104, 54.137645477473214,
    ],
    '130735360015': [
      12.435123498126375, 54.0716510681107, 12.637266977922351, 54.13410509938719,
    ],
    '130735360016': [
      12.745027710575224, 54.00635412971208, 12.85295318995178, 54.07635445172331,
    ],
    '130735360020': [
      12.763300791859304, 54.114221322778114, 12.823840967225276, 54.17777833287778,
    ],
    '130735360022': [
      12.623080764547181, 54.11296662243938, 12.7990005874888, 54.227176883394876,
    ],
    '130735360032': [
      12.805458568650028, 53.97408606938018, 12.904120784899723, 54.06020526989891,
    ],
    '130735360033': [
      12.84403522062457, 54.04388851983299, 12.939773924968673, 54.1000686551483,
    ],
    '130735360039': [
      12.72400774321595, 54.12760225099052, 12.783562790930706, 54.176261179179974,
    ],
    '130735360050': [
      12.609722565682578, 54.018889656219336, 12.749052304721594, 54.094417089155414,
    ],
    '130735360093': [
      12.697458575533668, 54.05443661637524, 12.866189960977538, 54.1341157433222,
    ],
    '130735361001': [
      12.490043708857119, 54.188361951717646, 12.65272335252487, 54.284319745687895,
    ],
    '130735361075': [
      12.300127508501784, 54.19026600329598, 12.531114491815664, 54.3038124765505,
    ],
    '130735361082': [
      12.626944868412258, 54.202360562735585, 12.733865683315935, 54.24924325266468,
    ],
    '130735361085': [
      12.566578806597205, 54.14614120966183, 12.755019384581894, 54.23405471425908,
    ],
    '130735362003': [
      13.115162691126905, 54.30905556854478, 13.208618110324757, 54.364817430256174,
    ],
    '130735362021': [
      13.229735364557712, 54.375987810892774, 13.34287305380244, 54.424665519148235,
    ],
    '130735362028': [
      13.20008233649654, 54.42206121349741, 13.299217912462364, 54.48058168546146,
    ],
    '130735362040': [
      13.059477219098417, 54.46362961917881, 13.15795918018247, 54.60475219545345,
    ],
    '130735362045': [
      13.265927160721029, 54.42278278825618, 13.370321617664189, 54.50082200629959,
    ],
    '130735362059': [
      13.29735048049551, 54.50582566956681, 13.39263397691545, 54.580997653473936,
    ],
    '130735362073': [
      13.12285590134085, 54.32465302490595, 13.269218884251208, 54.382589802859556,
    ],
    '130735362079': [
      13.24955973028506, 54.31959875107375, 13.362768382919672, 54.3874003599302,
    ],
    '130735362081': [
      13.13962389134374, 54.50131727964449, 13.23104472329029, 54.55027913795274,
    ],
    '130735362092': [
      13.210178133183742, 54.4755302407976, 13.333510836364823, 54.55483232430853,
    ],
    '130735362095': [
      13.121309001185612, 54.40410436400481, 13.271866059696897, 54.493524974645226,
    ],
    '130740026026': [
      11.123518140239863, 53.82548987449136, 11.304981429589096, 53.89881873343594,
    ],
    '130740035035': [
      11.376223818363659, 53.95725492549052, 11.499807244988478, 54.03219845927005,
    ],
    '130740087087': [
      11.390725120168613, 53.86570601013259, 11.533538913821141, 53.93883009344289,
    ],
    '130745451002': [
      11.399580418445515, 53.7500270506363, 11.49160594903606, 53.809142768925554,
    ],
    '130745451003': [
      11.341865625248758, 53.840715697629896, 11.42012353452661, 53.893737580912855,
    ],
    '130745451008': [
      11.288298859410457, 53.761254981606534, 11.430610978536524, 53.854565911123856,
    ],
    '130745451019': [
      11.41344248979259, 53.789720378533595, 11.531255082903717, 53.876537411459594,
    ],
    '130745451030': [
      11.417586285343122, 53.79987653301198, 11.473696123939984, 53.82725476878722,
    ],
    '130745451031': [
      11.465270137320026, 53.75142443909212, 11.54705574370289, 53.83725998271426,
    ],
    '130745451047': [
      11.483044303153036, 53.80117131060444, 11.601864823494406, 53.882605336030984,
    ],
    '130745451053': [
      11.386868234908691, 53.83879453508533, 11.453685281045926, 53.8712188444967,
    ],
    '130745451082': [
      11.527200928794244, 53.762611600748116, 11.59149102356738, 53.81628782879757,
    ],
    '130745452020': [
      11.166703078288274, 53.67948949669835, 11.269935317064784, 53.72540367680777,
    ],
    '130745452021': [
      11.032446498652494, 53.656820114068864, 11.181592004317443, 53.751007565877245,
    ],
    '130745452040': [
      10.918510177896115, 53.63740921837135, 11.006084886955147, 53.69453027570144,
    ],
    '130745452043': [
      10.991183210396143, 53.60239257074815, 11.116722422752316, 53.685649808931046,
    ],
    '130745452054': [
      11.19020107565955, 53.703868839089274, 11.278102587507572, 53.7760731587427,
    ],
    '130745452068': [
      10.916715643756302, 53.64841472577159, 11.038318152747461, 53.72935448980313,
    ],
    '130745452070': [
      10.999332164200398, 53.59835990040291, 11.064539145621444, 53.63568720916146,
    ],
    '130745452081': [
      11.128526963465536, 53.70982843402507, 11.233624987218152, 53.79465247863056,
    ],
    '130745453005': [
      11.06668135824884, 53.7993783635417, 11.152426030086684, 53.84516678400046,
    ],
    '130745453022': [
      11.28254657231961, 53.85017469567996, 11.392685663765516, 53.91524097891339,
    ],
    '130745453069': [
      11.029606448338999, 53.88134220873908, 11.091697466398065, 53.95416420313263,
    ],
    '130745453071': [
      11.176971987049171, 53.77087629515038, 11.2474060786928, 53.81272912420287,
    ],
    '130745453077': [
      11.231331195361202, 53.75006625554021, 11.320860323056714, 53.814643973261475,
    ],
    '130745453079': [
      11.13025549731339, 53.78235988479556, 11.316544154795318, 53.87272324471083,
    ],
    '130745453085': [
      11.18040650470117, 53.876430440285375, 11.239234240942807, 53.939692340311865,
    ],
    '130745453093': [
      10.983616415101382, 53.83409386046067, 11.146333779330451, 53.90205879695714,
    ],
    '130745454010': [
      11.146217757746877, 53.95302549389398, 11.257085864628223, 54.01491671249542,
    ],
    '130745454016': [
      11.084623621805074, 53.89034733261755, 11.208232695123844, 53.95407956173793,
    ],
    '130745454032': [
      11.229179209550246, 53.87548936477944, 11.35315906448402, 53.959426509753065,
    ],
    '130745454037': [
      10.978922996777213, 53.94087489060509, 11.134628993036955, 54.01410795612465,
    ],
    '130745454039': [
      11.07114042121858, 53.927122528122325, 11.267737981733314, 54.01130486575258,
    ],
    '130745454089': [
      11.339399476765198, 53.90545235452432, 11.406685130392095, 53.943236976266526,
    ],
    '130745455001': [
      11.292729310591671, 53.69932147217604, 11.3730077798273, 53.77154209470938,
    ],
    '130745455012': [
      11.212017148723506, 53.63436163534976, 11.335830017894699, 53.69294746801316,
    ],
    '130745455014': [
      11.264852031386326, 53.686419316778, 11.328964405581749, 53.71904334505109,
    ],
    '130745455015': [
      11.264896921843881, 53.718928572649475, 11.313452206611927, 53.76085423389246,
    ],
    '130745455024': [
      11.1749425709824, 53.60069140808611, 11.265158594099402, 53.66179667735139,
    ],
    '130745455025': [
      11.230414739682114, 53.58772436353541, 11.316829471652493, 53.64853152245416,
    ],
    '130745455038': [
      11.32776537947619, 53.668727270220806, 11.41483690169488, 53.73342295276657,
    ],
    '130745455048': [
      11.360249503137021, 53.67867853474898, 11.502019146984551, 53.76594428126518,
    ],
    '130745455050': [
      11.14144496737884, 53.626650304961714, 11.214153271439333, 53.69935141699131,
    ],
    '130745455061': [
      11.142451308469598, 53.56690015105809, 11.208634900112601, 53.60997288018504,
    ],
    '130745455062': [
      11.328964405581749, 53.67177218905318, 11.358320770107028, 53.69457362892896,
    ],
    '130745455064': [
      11.07547065874993, 53.63084498895968, 11.162733761297673, 53.6766546388207,
    ],
    '130745455072': [
      11.096308321742447, 53.58810872463915, 11.181473126485603, 53.63916193963864,
    ],
    '130745455075': [
      11.412964622708552, 53.68393737321795, 11.442221641236518, 53.71256576188451,
    ],
    '130745455088': [
      11.36468005734328, 53.74063909735166, 11.434735082752349, 53.77553599718161,
    ],
    '130745456004': [
      11.55202325782371, 53.8878275375548, 11.65040703134303, 53.937549958897,
    ],
    '130745456007': [
      11.47258884460721, 53.94425484232259, 11.579629736988425, 54.01059106229122,
    ],
    '130745456009': [
      11.508375111718015, 53.98872381354804, 11.588360402199436, 54.03358708564943,
    ],
    '130745456034': [
      11.504949919399255, 53.87493563922047, 11.565918603480522, 53.9297074288453,
    ],
    '130745456044': [
      11.479851020418794, 53.92703426111508, 11.550731218722664, 53.96712605590075,
    ],
    '130745456056': [
      11.542207478442208, 53.92569203535145, 11.676221717511396, 53.99460094445832,
    ],
    '130745457006': [
      11.570190280260507, 53.76048997869724, 11.690857783284773, 53.81235584301743,
    ],
    '130745457023': [
      11.69080389813186, 53.86887963727349, 11.80575170705372, 53.94318638139325,
    ],
    '130745457036': [
      11.559683719868897, 53.78547727850872, 11.669489326849027, 53.84311750000643,
    ],
    '130745457046': [
      11.708824275594646, 53.83651738821816, 11.778331039934487, 53.88514447113773,
    ],
    '130745457057': [
      11.599545549004088, 53.84052907686602, 11.717802775060765, 53.91266120062501,
    ],
    '130745457060': [
      11.73504562288102, 53.92740954556036, 11.804435053905836, 53.974394109884486,
    ],
    '130745457084': [
      11.678425893745112, 53.76840920529618, 11.807961557989335, 53.85249284521438,
    ],
    '130745457090': [
      11.549634238850636, 53.81185409665923, 11.71463468827077, 53.89643569624301,
    ],
    '130745457091': [
      11.631375712409005, 53.9021605489948, 11.74007265523347, 53.9561549092424,
    ],
    '130745458013': [
      10.869689254646339, 53.720405467568305, 10.967195855656628, 53.79143124294444,
    ],
    '130745458018': [
      10.84913323040558, 53.69929550870185, 10.967471002061735, 53.73074524313537,
    ],
    '130745458028': [
      10.847854805645158, 53.7175784631302, 10.89771245503749, 53.74495678263173,
    ],
    '130745458033': [
      11.014806809444615, 53.6987971757577, 11.082911808592856, 53.74547077353615,
    ],
    '130745458042': [
      10.955187541296821, 53.716620221641335, 11.051878627327481, 53.79425319490857,
    ],
    '130745458065': [
      10.967791029121733, 53.72530869471803, 11.13025549731339, 53.83996980090651,
    ],
    '130745458066': [
      10.831086217227766, 53.754090338598665, 10.910127417555895, 53.79247208950048,
    ],
    '130745458073': [
      10.806746989192934, 53.70626870036347, 10.880628672337995, 53.76598437951533,
    ],
    '130745458078': [
      10.79254990105777, 53.75532246027058, 10.849487815283794, 53.79173422585902,
    ],
    '130745458080': [
      10.761268816551032, 53.740454539171274, 10.80795524184166, 53.78968550296554,
    ],
    '130745458092': [
      11.05955539716785, 53.73150017322885, 11.170089910016905, 53.80064544180113,
    ],
    '130745459017': [
      10.894116433660475, 53.8761892543887, 11.055471594508848, 53.98648452926487,
    ],
    '130745459027': [
      11.028536644496324, 53.82299719691329, 11.081984056303819, 53.857379408256136,
    ],
    '130745459049': [
      10.748037139995006, 53.77933330993511, 10.87613151177692, 53.87984385397413,
    ],
    '130745459052': [
      10.973160761121564, 53.82813968160069, 11.044040005123264, 53.86013994202473,
    ],
    '130745459067': [
      10.958360474431377, 53.80562437473004, 11.03382574976532, 53.83310390903978,
    ],
    '130745459074': [
      10.827281299425454, 53.814060092830665, 10.999397538144473, 53.89300626702743,
    ],
    '130745459076': [
      10.807602839482783, 53.853931292268456, 10.940189413718803, 53.92343484183515,
    ],
    '130745459094': [
      10.863696210426468, 53.78404794716674, 10.977351915863567, 53.834394338802824,
    ],
    '130750005005': [
      13.633136291729594, 53.77455213545459, 13.813365024052512, 53.87538427050622,
    ],
    '130750039039': [
      13.321566267115374, 54.055093552942225, 13.504690217340162, 54.18723794181597,
    ],
    '130750049049': [
      14.079822631274999, 53.91410036754436, 14.226316992896521, 53.995555805972984,
    ],
    '130750105105': [
      13.936323289931831, 53.46785245253812, 14.078804696292766, 53.55732671668983,
    ],
    '130750130130': [
      13.669145722907585, 53.474603564182026, 13.826405300526078, 53.620301950699876,
    ],
    '130750136136': [
      13.962977575485613, 53.69953247590102, 14.138815861137662, 53.75740963527503,
    ],
    '130755551021': [
      13.80747235874649, 53.87779305313815, 13.912816750776805, 53.94463368229584,
    ],
    '130755551072': [
      13.799593379684728, 54.03089898162372, 13.88327600189675, 54.069732563859006,
    ],
    '130755551074': [
      13.74872656013677, 53.92409412716602, 13.884412266498442, 53.98036643157927,
    ],
    '130755551087': [
      13.853012363540389, 54.001589206717455, 13.93477027310398, 54.06200550541021,
    ],
    '130755551124': [
      13.76704652339013, 54.01801911910669, 13.810318643063631, 54.04994197727721,
    ],
    '130755551144': [
      13.641697086073318, 53.965844101124354, 13.827889040194544, 54.0850506475862,
    ],
    '130755551147': [
      13.701067897476413, 53.9561331494848, 13.836492441129279, 54.01148172584851,
    ],
    '130755552001': [
      14.148928111546228, 53.61758380352989, 14.242950630258273, 53.68184184980325,
    ],
    '130755552003': [
      14.216704959271135, 53.71219416561342, 14.271246546360393, 53.761906306276025,
    ],
    '130755552031': [
      14.043206782243061, 53.5965683490844, 14.240324372382924, 53.732026179300874,
    ],
    '130755552037': [
      13.987106933269, 53.7462836408912, 14.031766130876337, 53.76886894229619,
    ],
    '130755552051': [
      14.177465747212073, 53.574657191300254, 14.316576090054227, 53.664754788036795,
    ],
    '130755552075': [
      13.826823092287837, 53.747704161623886, 13.936797999711272, 53.79554119988634,
    ],
    '130755552078': [
      13.95233287603084, 53.653628000889775, 14.061990199174852, 53.72822283211668,
    ],
    '130755552084': [
      13.83503461466952, 53.66963616945413, 13.965631959403227, 53.75467121311652,
    ],
    '130755552085': [
      14.13436363272535, 53.658587208629946, 14.283501214425877, 53.71545198922331,
    ],
    '130755552089': [
      13.914086032043954, 53.68628465262853, 13.998608179889649, 53.723746903970294,
    ],
    '130755552093': [
      13.895144805040635, 53.732343358618266, 13.997053275125849, 53.788021771968424,
    ],
    '130755552139': [
      14.109176945809484, 53.68874585993417, 14.230715328685077, 53.7525751291478,
    ],
    '130755553007': [
      13.714948589578233, 53.809215640644865, 13.819577643806586, 53.866946184503064,
    ],
    '130755553013': [
      13.564648555217467, 53.80428354205123, 13.638735495208161, 53.840298906435414,
    ],
    '130755553015': [
      13.517776576937804, 53.69537328462142, 13.713165429043613, 53.75696862218793,
    ],
    '130755553020': [
      13.782618610625828, 53.764215493298884, 13.943995446010057, 53.84221512280531,
    ],
    '130755553022': [
      13.605442797609104, 53.78343656969795, 13.66954472504702, 53.84553504004396,
    ],
    '130755553029': [
      13.656032742560887, 53.69380356499401, 13.888226218426388, 53.795681769721185,
    ],
    '130755553053': [
      13.386991008453807, 53.76954983141676, 13.462861950596457, 53.81983022679218,
    ],
    '130755553068': [
      13.409435157453993, 53.79341625940258, 13.532328640266963, 53.84460740207748,
    ],
    '130755553073': [
      13.365665897416081, 53.81297245379182, 13.431727109243221, 53.86848986520236,
    ],
    '130755553088': [
      13.462911715469858, 53.791190540444056, 13.574732879136103, 53.86452055006719,
    ],
    '130755553098': [
      13.681428199802298, 53.768598292980556, 13.798223134658347, 53.82476131231244,
    ],
    '130755553101': [
      13.539143514260637, 53.76985104944296, 13.623456549712024, 53.810722234899934,
    ],
    '130755553110': [
      13.551234968851723, 53.8224944039638, 13.643914202894017, 53.869125922695545,
    ],
    '130755553116': [
      13.672164527284448, 53.747479781062566, 13.75107830929263, 53.78830881648866,
    ],
    '130755553122': [
      13.56025678134598, 53.72841905875833, 13.673383880179026, 53.78693977708521,
    ],
    '130755553127': [
      13.344119263499945, 53.73149694057489, 13.603398460559806, 53.81214881250986,
    ],
    '130755553128': [
      13.489056143165502, 53.8489807179223, 13.617557216043126, 53.88339531543011,
    ],
    '130755553155': [
      13.37195408484062, 53.838087385038165, 13.505393384204359, 53.91728675111354,
    ],
    '130755554002': [
      13.185303928453925, 53.80825003144667, 13.287107128383349, 53.85958536992523,
    ],
    '130755554009': [
      13.196166996755915, 53.90643058854015, 13.339776644097997, 53.97443680580598,
    ],
    '130755554023': [
      13.26440088804503, 53.81064961529544, 13.338061836674735, 53.85953436236879,
    ],
    '130755554054': [
      13.26492734006019, 53.85530219930268, 13.405306714863668, 53.93496364735523,
    ],
    '130755554070': [
      13.180483723682618, 53.84904100340256, 13.297786529485794, 53.91839523808778,
    ],
    '130755554134': [
      13.196166996755915, 53.90747764318544, 13.253093472424844, 53.9345458806184,
    ],
    '130755554140': [
      13.304564539560298, 53.84369294763509, 13.390458980573511, 53.90034081377119,
    ],
    '130755555008': [
      13.351218903899815, 53.965236982853725, 13.434311147565674, 54.031702022828625,
    ],
    '130755555025': [
      13.306690341442525, 53.98486305796087, 13.373281194380334, 54.035072444814574,
    ],
    '130755555027': [
      13.234177418281432, 54.005890469370385, 13.354764533198853, 54.0676920386475,
    ],
    '130755555050': [
      13.2912493271751, 54.05066905292487, 13.36086047834592, 54.08497095372335,
    ],
    '130755555076': [
      13.250381940201361, 54.05938295132283, 13.323376810417736, 54.10626464974787,
    ],
    '130755555091': [
      13.289709999117413, 54.13374965472995, 13.406932711050478, 54.19380522026035,
    ],
    '130755555102': [
      13.33299766792834, 54.10673317153123, 13.439375284044907, 54.151503893961284,
    ],
    '130755555141': [
      13.216027294621279, 54.09238805625965, 13.37026599840555, 54.141727190354615,
    ],
    '130755555142': [
      13.341801756078787, 54.02164186936426, 13.53904414238386, 54.06995316518499,
    ],
    '130755556011': [
      14.110087289551407, 53.422415144170316, 14.223460140698291, 53.46509400713828,
    ],
    '130755556012': [
      14.247820738505354, 53.48081847573843, 14.354187667673255, 53.5793994149093,
    ],
    '130755556016': [
      14.21184545929206, 53.47054647869092, 14.28065658364375, 53.5150502533749,
    ],
    '130755556035': [
      14.233393950937696, 53.35819559345678, 14.305335519212122, 53.40299336316663,
    ],
    '130755556038': [
      14.277801862059723, 53.34626934405157, 14.393895313160186, 53.438873986598935,
    ],
    '130755556067': [
      14.205553695440827, 53.315668926023044, 14.35470966967211, 53.390551383943155,
    ],
    '130755556079': [
      14.165300323836448, 53.429668334153654, 14.269669350332483, 53.49834841592375,
    ],
    '130755556095': [
      14.30809758925731, 53.310175268794204, 14.412279938967549, 53.353737216880184,
    ],
    '130755556107': [
      14.098258983154958, 53.25480549541021, 14.316270371355495, 53.343958285426496,
    ],
    '130755556108': [
      14.238418368876067, 53.44241157356019, 14.305716904630492, 53.49107719558182,
    ],
    '130755556113': [
      14.222943246958982, 53.39619306836807, 14.3716993545173, 53.48444032026931,
    ],
    '130755556117': [
      14.064654548255145, 53.45239171354442, 14.18277437267364, 53.51445405755201,
    ],
    '130755556119': [
      14.163257716253392, 53.476941077609375, 14.292803777880538, 53.59070724046005,
    ],
    '130755557018': [
      13.538498810373813, 54.08052788442853, 13.611569189654281, 54.13250032756144,
    ],
    '130755557046': [
      13.513494290862416, 54.027790663169945, 13.58085785976993, 54.06249966899981,
    ],
    '130755557059': [
      13.610652568439052, 54.01473183813842, 13.724757188991122, 54.08766596831924,
    ],
    '130755557060': [
      13.493834483440326, 54.05085826145557, 13.587179059007068, 54.09918632387676,
    ],
    '130755557069': [
      13.662543638200063, 54.08780788904105, 13.80248491451085, 54.16117309050181,
    ],
    '130755557081': [
      13.47743800097761, 54.09470794697251, 13.559030129841533, 54.130178388851526,
    ],
    '130755557083': [
      13.57773015347598, 54.1174116410826, 13.71717351583118, 54.1758062113167,
    ],
    '130755557097': [
      13.569892676794812, 54.029106837464504, 13.677549458786192, 54.08660756332073,
    ],
    '130755557120': [
      13.64696247116662, 54.068779747684424, 13.796971826766812, 54.14612167304272,
    ],
    '130755557146': [
      13.587179059007068, 54.08165198905694, 13.673992065624914, 54.127321852577474,
    ],
    '130755558036': [
      13.224218489105626, 53.95707616242503, 13.34234407183309, 54.03219860619363,
    ],
    '130755558082': [
      12.9873281372829, 53.93167724381843, 13.199257076946704, 54.039838148910334,
    ],
    '130755558123': [
      13.15083603706593, 53.95709022398907, 13.259126319984558, 54.05518826981138,
    ],
    '130755559004': [
      13.734409254998502, 53.675853736078835, 13.863303844868119, 53.72891832160874,
    ],
    '130755559033': [
      13.779705277346736, 53.64515213403556, 13.986879356709162, 53.71852650197427,
    ],
    '130755559045': [
      13.940830726954248, 53.56105062933574, 14.037621038284081, 53.6156186414581,
    ],
    '130755559048': [
      13.72793412004156, 53.595906738338016, 13.805088030956885, 53.650223405843974,
    ],
    '130755559118': [
      13.785028006185804, 53.5571342587345, 13.89906974061527, 53.62618726936791,
    ],
    '130755559131': [
      13.890034400710594, 53.583634205238745, 14.114377952116707, 53.69788088135047,
    ],
    '130755559143': [
      13.694549967044681, 53.5972535217564, 13.904374135873855, 53.679019494573105,
    ],
    '130755560017': [
      13.874115308990833, 53.456515991126864, 13.937052084958905, 53.50413335230035,
    ],
    '130755560032': [
      14.020184696195098, 53.412735832530046, 14.121161449860534, 53.47704147885776,
    ],
    '130755560042': [
      13.798184607053225, 53.51398180609994, 13.857342203316195, 53.5571342587345,
    ],
    '130755560055': [
      13.801572896916552, 53.50413335230035, 14.002258049256206, 53.61968457548138,
    ],
    '130755560063': [
      14.094848466521547, 53.50790017246609, 14.184496678063242, 53.562396356966076,
    ],
    '130755560071': [
      14.054580591727035, 53.51639239780731, 14.112370400037348, 53.55138079464667,
    ],
    '130755560103': [
      13.901461018222019, 53.42193878763038, 13.948946936594332, 53.45174156366982,
    ],
    '130755560104': [
      13.883901294180829, 53.47827952077079, 13.973641824174232, 53.51372168645471,
    ],
    '130755560109': [
      14.03615773766152, 53.468867856012615, 14.083318185069164, 53.51639239780731,
    ],
    '130755560115': [
      13.91609836200105, 53.42972683767232, 14.045447709385636, 53.49247519401674,
    ],
    '130755560126': [
      13.879509050395189, 53.49855539717414, 13.950316371038642, 53.56205549713127,
    ],
    '130755560138': [
      14.00176248262204, 53.53863289277135, 14.206402000527076, 53.60775820541189,
    ],
    '130755560149': [
      14.068583286530275, 53.47807370524785, 14.14252326498862, 53.519884886490466,
    ],
    '130755561058': [
      13.810164528364734, 54.100225231914116, 13.863276461696085, 54.12627841476744,
    ],
    '130755561092': [
      13.800308879241147, 54.06278859768029, 13.879281045165481, 54.10372735070252,
    ],
    '130755561106': [
      13.749111551955517, 54.109434298814904, 13.83793682529574, 54.17436780496498,
    ],
    '130755561133': [
      13.842009124374488, 54.07461291566332, 13.900528838653813, 54.10674742753844,
    ],
    '130755561151': [
      13.876058227195061, 54.05324436657893, 13.936406322103513, 54.08769587074895,
    ],
    '130755562010': [
      13.984704230269527, 53.90965816666319, 14.119438847500419, 53.96219661277464,
    ],
    '130755562026': [
      13.997909304805212, 53.871620218954924, 14.13478470180236, 53.91797659385818,
    ],
    '130755562034': [
      14.151234978517856, 53.871382778606, 14.213704488945233, 53.90723082220616,
    ],
    '130755562056': [
      14.187483902224765, 53.86605802976748, 14.214243659712121, 53.88946868289092,
    ],
    '130755562065': [
      14.09372601149805, 53.893326768256365, 14.204196885799675, 53.9326167371083,
    ],
    '130755562066': [
      13.969129288161163, 54.0355184338688, 14.025423138131316, 54.06989005384785,
    ],
    '130755562080': [
      13.998262363827497, 54.010944625873236, 14.04797291297292, 54.04714238742974,
    ],
    '130755562090': [
      13.958470062490072, 53.89995306650251, 14.041978302241278, 53.95899844144905,
    ],
    '130755562111': [
      14.037061526672199, 53.94428930435701, 14.105838134675935, 53.99059047230383,
    ],
    '130755562114': [
      13.895729444369199, 53.890627691527584, 13.984005159051986, 53.99445254154899,
    ],
    '130755562129': [
      13.965084496788581, 53.84918916963718, 14.038120885663155, 53.90005464850531,
    ],
    '130755562135': [
      14.0290536966325, 53.981134758227796, 14.112837239433283, 54.03184927830876,
    ],
    '130755562137': [
      13.823100571480229, 53.84057325122742, 13.992441096054229, 53.9099097021211,
    ],
    '130755562148': [
      13.924894098191327, 54.059310967805914, 13.969705384262184, 54.07559280904671,
    ],
    '130755562152': [
      14.104190728324319, 53.871382778606, 14.155120260163226, 53.906231326028035,
    ],
    '130755563006': [
      13.311759666814794, 53.94479471318813, 13.41927610458611, 53.984885892210585,
    ],
    '130755563040': [
      13.464888503820594, 53.92505317547237, 13.516914695744397, 53.95986307501373,
    ],
    '130755563041': [
      13.418705300055754, 53.95665054766347, 13.579376566432739, 54.04148625232829,
    ],
    '130755563043': [
      13.484571137287816, 53.870442748125186, 13.635487957561914, 53.91435871550183,
    ],
    '130755563044': [
      13.320737991984764, 53.88951560757673, 13.52301635323827, 53.99309227918886,
    ],
    '130755563061': [
      13.579399036847823, 53.89362731175896, 13.692861007293263, 53.96996366395369,
    ],
    '130755563094': [
      13.681328419081156, 53.85689427366115, 13.829270842991333, 53.93668658680982,
    ],
    '130755563121': [
      13.672302528954399, 53.898489712812975, 13.781914454001607, 53.98841938967867,
    ],
    '130755563125': [
      13.516299457289069, 53.903437567035496, 13.606311080241015, 53.94819264118645,
    ],
    '130755563145': [
      13.513494290862416, 54.0002662862987, 13.620020312811132, 54.03866943262458,
    ],
    '130755563150': [
      13.609345478032141, 53.86365427523257, 13.694854121116164, 53.90495248269975,
    ],
    '130755563154': [
      13.499238114274934, 53.92970481243873, 13.589432921848198, 53.99716723961907,
    ],
    '130755563156': [
      13.566873751291082, 53.943752685511434, 13.683822289269369, 54.020113585470234,
    ],
    '130760014014': [
      10.650798880580068, 53.34123364428642, 10.785942820330964, 53.426940973803404,
    ],
    '130760060060': [
      11.122620994884082, 53.3786342096252, 11.27422914090559, 53.492235626224975,
    ],
    '130760088088': [
      10.98183038326816, 53.21744518230192, 11.172488683534375, 53.36080028611355,
    ],
    '130760090090': [
      11.320210585644137, 53.259342114836684, 11.54360161278675, 53.372608915974425,
    ],
    '130760108108': [
      11.641370977295455, 53.368331427298735, 11.93780404919665, 53.50139012200788,
    ],
    '130765652009': [
      10.784261979909944, 53.38917253622689, 10.9068090982239, 53.45120372773296,
    ],
    '130765652010': [
      10.8150308758754, 53.32159274910937, 10.918326466176524, 53.3820994629902,
    ],
    '130765652016': [
      10.928268882670302, 53.33374571042889, 11.011800300727225, 53.38469813006541,
    ],
    '130765652030': [
      10.855593522433395, 53.34850576127896, 10.962470975213671, 53.398722281651224,
    ],
    '130765652054': [
      10.699716009387219, 53.40581839454855, 10.796604110826227, 53.46345884702157,
    ],
    '130765652055': [
      10.692838967824292, 53.43666197001707, 10.873504078338625, 53.50756964296622,
    ],
    '130765652102': [
      10.764404629323497, 53.35959784349752, 10.825135378405351, 53.40924542222774,
    ],
    '130765652106': [
      10.59769766425532, 53.36626548674801, 10.690128844093566, 53.41908239123111,
    ],
    '130765652122': [
      10.618553057815745, 53.407926089906425, 10.717906681863585, 53.460704114264814,
    ],
    '130765652136': [
      10.758374634742713, 53.30489328335059, 10.868634608987028, 53.36606654831585,
    ],
    '130765652138': [
      10.8150308758754, 53.356519326250734, 10.878065025382178, 53.40668641536941,
    ],
    '130765654034': [
      11.1713743119675, 53.11352332618507, 11.39547976651208, 53.19080035018586,
    ],
    '130765654053': [
      11.216143066910709, 53.19077620116787, 11.331881881945941, 53.271984602056946,
    ],
    '130765654067': [
      11.33066514742994, 53.222664521071266, 11.371784948043514, 53.25584082556627,
    ],
    '130765654093': [
      11.345390317609201, 53.15966678518008, 11.410286073036678, 53.238675895470834,
    ],
    '130765654094': [
      11.251646499228057, 53.1842932939613, 11.361980177927698, 53.23198619466362,
    ],
    '130765654103': [
      11.246705289754512, 53.13680073118019, 11.3932593217988, 53.20027928710146,
    ],
    '130765654143': [
      11.087761704134268, 53.1809971298634, 11.265510623767561, 53.29514691696763,
    ],
    '130765655040': [
      12.090861351092617, 53.48136603491415, 12.200312076313795, 53.54588784079797,
    ],
    '130765655051': [
      11.906138035315875, 53.45710699188431, 12.000271633832174, 53.526968318959305,
    ],
    '130765655075': [
      12.016214146497541, 53.37329384640423, 12.110012379377368, 53.43360827843939,
    ],
    '130765655077': [
      12.063376635163419, 53.41609930005708, 12.189239887669354, 53.46217159976121,
    ],
    '130765655089': [
      11.966694965728285, 53.38746921948634, 12.163895794230775, 53.50630672623787,
    ],
    '130765655109': [
      12.012354826386936, 53.488076057741765, 12.112611454812713, 53.54598254939294,
    ],
    '130765655125': [
      11.880597988947805, 53.33413928441173, 12.066227854226014, 53.42415169218428,
    ],
    '130765655151': [
      11.973283997329512, 53.48271236946957, 12.037902271585436, 53.5445436754043,
    ],
    '130765655165': [
      12.066227854226014, 53.34392093111396, 12.175570466544643, 53.43074758190344,
    ],
    '130765655168': [
      11.814297039445687, 53.27425523829282, 12.021698892846624, 53.38071895447651,
    ],
    '130765656032': [
      11.990594499722096, 53.597072436012034, 12.214612586047526, 53.67681915462275,
    ],
    '130765656048': [
      11.976465994207132, 53.520212439822814, 12.159195919449605, 53.62632844189076,
    ],
    '130765656096': [
      11.876587806613006, 53.55212906818454, 11.975707719238185, 53.625922858516525,
    ],
    '130765656104': [
      12.11877653208113, 53.523606211006815, 12.253581423224684, 53.607268936077865,
    ],
    '130765656135': [
      11.945396726266495, 53.53355486656357, 12.065108759201594, 53.62604260038217,
    ],
    '130765657003': [
      11.691857250598007, 53.229901496867186, 11.755727607352792, 53.28234286230919,
    ],
    '130765657021': [
      11.768189105078179, 53.226540860952845, 11.853623348072553, 53.29330978191548,
    ],
    '130765657027': [
      11.71320052589849, 53.21866854491363, 11.794500324048755, 53.27497501116714,
    ],
    '130765657037': [
      11.37520087562234, 53.185931023679515, 11.502572245787677, 53.276334497864525,
    ],
    '130765657049': [
      11.387739114584502, 53.13651565840482, 11.564795480346099, 53.243404697563534,
    ],
    '130765657050': [
      11.45999299473679, 53.125435224339896, 11.626882401143089, 53.329368821744374,
    ],
    '130765657069': [
      11.40991093155522, 53.26362682679601, 11.525829689034886, 53.30017453455481,
    ],
    '130765657076': [
      11.549624485018166, 53.21467473757532, 11.6305051897705, 53.26077296022252,
    ],
    '130765657097': [
      11.421065607568478, 53.13641627481165, 11.566586082896317, 53.2128533476709,
    ],
    '130765657098': [
      11.693946039393825, 53.26868489342576, 11.790764016144216, 53.31057774354619,
    ],
    '130765657100': [
      11.610230435962787, 53.29785112733704, 11.716999117371802, 53.339972140039215,
    ],
    '130765657115': [
      11.586519052504974, 53.23849887242638, 11.702453709534167, 53.30392752048134,
    ],
    '130765657161': [
      11.615613519901249, 53.273677422267426, 11.702453709534167, 53.315369523783474,
    ],
    '130765658002': [
      11.30902969832829, 53.47578301278326, 11.356958583185403, 53.514114313201965,
    ],
    '130765658004': [
      11.248914711129657, 53.47161084883734, 11.340300853747484, 53.52569069875295,
    ],
    '130765658008': [
      11.135395379443132, 53.28933426665651, 11.23228574241392, 53.34030986194645,
    ],
    '130765658013': [
      11.120666449327638, 53.47040407889145, 11.175686819892709, 53.49259230772537,
    ],
    '130765658019': [
      11.23886953682843, 53.33407470857229, 11.326837624416767, 53.37708920270887,
    ],
    '130765658041': [
      11.203822715552413, 53.479079790619565, 11.283987522804976, 53.528163138707036,
    ],
    '130765658057': [
      11.228672507178889, 53.31408749659044, 11.283100785260034, 53.353996192882406,
    ],
    '130765658064': [
      11.27422914090559, 53.44380758391157, 11.407099613551784, 53.499462899343804,
    ],
    '130765658065': [
      11.168127284132927, 53.49170440526646, 11.218371729118642, 53.52553811510671,
    ],
    '130765658070': [
      11.24519670453423, 53.41730196297745, 11.326559420006493, 53.47161084883734,
    ],
    '130765658079': [
      11.222170770899725, 53.3666784822036, 11.295764037597786, 53.407405836674116,
    ],
    '130765658099': [
      11.245952012654604, 53.39553185756614, 11.350988843515369, 53.43834814890089,
    ],
    '130765658110': [
      11.128121346756169, 53.38423959952375, 11.195370327499889, 53.41708013578377,
    ],
    '130765658111': [
      11.311347509546687, 53.33243342962504, 11.431734679433704, 53.42158395721743,
    ],
    '130765658116': [
      11.034365179333678, 53.34545303699743, 11.10382876926034, 53.3980527906533,
    ],
    '130765658119': [
      11.168234359455147, 53.33875978853811, 11.252110579105096, 53.378751080459864,
    ],
    '130765658131': [
      11.277198978916934, 53.37198976120963, 11.363877168895069, 53.411879839468725,
    ],
    '130765658145': [
      11.091775868544026, 53.34545303699743, 11.195370327499889, 53.39282285858331,
    ],
    '130765658169': [
      11.025845499182154, 53.38910472452698, 11.172816174350617, 53.453194552142016,
    ],
    '130765659001': [
      11.220801762018484, 53.271984602056946, 11.361136725733655, 53.344671576092026,
    ],
    '130765659018': [
      11.328020375184472, 53.23441022227145, 11.419773894842725, 53.26357548039313,
    ],
    '130765659046': [
      11.212387288680787, 53.26067933594512, 11.411255738028217, 53.31896091317921,
    ],
    '130765659058': [
      11.479718889878846, 53.309999444631934, 11.618026328546089, 53.373991365173744,
    ],
    '130765659086': [
      11.416087005863416, 53.47349224292189, 11.490914969351781, 53.55035931201387,
    ],
    '130765659087': [
      11.409261537642998, 53.36965731902885, 11.483855147926464, 53.43318035920081,
    ],
    '130765659118': [
      11.31888131733922, 53.41032727874983, 11.5179270760151, 53.47347081775105,
    ],
    '130765659134': [
      11.351375758553324, 53.49087818426687, 11.45380278004336, 53.5303231240173,
    ],
    '130765659141': [
      11.373572607835102, 53.464255373265665, 11.477266538696854, 53.50271837585662,
    ],
    '130765659146': [
      11.379640243916517, 53.32710382420434, 11.441991946685945, 53.37734543223724,
    ],
    '130765659156': [
      11.46406273303979, 53.37085880417741, 11.538637394063844, 53.4350665689881,
    ],
    '130765660012': [
      11.594926107772546, 53.32839561805313, 11.700719836125325, 53.37355705161257,
    ],
    '130765660017': [
      11.622370140172567, 53.36859071958548, 11.68994436084437, 53.41384762339522,
    ],
    '130765660105': [
      11.4961427786582, 53.32974490497358, 11.641370977295455, 53.485678101131356,
    ],
    '130765662035': [
      11.702058436387215, 53.455389515384084, 11.83569914321232, 53.51954428645954,
    ],
    '130765662056': [
      11.760875961974916, 53.34198942517968, 11.847395832565239, 53.38422157988135,
    ],
    '130765662068': [
      11.711850973635164, 53.30762328739705, 11.85036150505693, 53.35322354348589,
    ],
    '130765662085': [
      11.630010525845329, 53.429895937822025, 11.735275845199773, 53.535991284632956,
    ],
    '130765662120': [
      11.86355243075914, 53.40587932718606, 11.98671373714613, 53.497073992628586,
    ],
    '130765662126': [
      11.61936021077024, 53.36385409219819, 11.77803903572341, 53.458351509628805,
    ],
    '130765662129': [
      11.6892792624757, 53.324750119165245, 11.779504002797385, 53.37599871096087,
    ],
    '130765662160': [
      11.769954746745274, 53.24921380435077, 11.897337938690852, 53.32236142877562,
    ],
    '130765662162': [
      11.773582760300036, 53.533728207576395, 11.901580517345774, 53.61894123652879,
    ],
    '130765662164': [
      11.81384586596663, 53.490172439078464, 11.977181592647455, 53.56205367308887,
    ],
    '130765663006': [
      12.13574225129265, 53.44106770449272, 12.25120628499772, 53.53309865290269,
    ],
    '130765663114': [
      12.184238922414846, 53.395576516040336, 12.365043763092556, 53.59723123055767,
    ],
    '130765663166': [
      12.114552725293775, 53.31975232562515, 12.347206132806201, 53.42412784152042,
    ],
    '130765664011': [
      11.695958534273833, 53.74106481116259, 11.805721372763344, 53.79573133019953,
    ],
    '130765664015': [
      11.915844168352983, 53.634067494913744, 12.044758348761134, 53.69867885628319,
    ],
    '130765664020': [
      11.614979800535915, 53.694931302913304, 11.745601978411266, 53.75352719632188,
    ],
    '130765664026': [
      11.845067220821347, 53.63647418063984, 11.940961044697792, 53.6911566471145,
    ],
    '130765664062': [
      11.854828328781748, 53.61086603456086, 11.995102065139548, 53.656718520236936,
    ],
    '130765664072': [
      11.766574636440017, 53.6013910047766, 11.871939241837747, 53.69691536510394,
    ],
    '130765664078': [
      11.577178373911504, 53.64171898081059, 11.691705149594407, 53.752354624226655,
    ],
    '130765664101': [
      11.931935762742535, 53.676300923045986, 12.040223782976085, 53.727469471643914,
    ],
    '130765664128': [
      11.761431640365142, 53.66184157343386, 11.935320549237977, 53.77170762548938,
    ],
    '130765664148': [
      11.674645327328419, 53.643995720067394, 11.776130423386, 53.74322885753139,
    ],
    '130765664155': [
      11.869361159617366, 53.70761961901942, 11.994219965875587, 53.74395565999062,
    ],
    '130765664167': [
      11.596308834084205, 53.73225667317809, 11.710796471059764, 53.7930267080177,
    ],
    '130765665036': [
      11.152502784287174, 53.52476633054727, 11.287202839041075, 53.601400657191206,
    ],
    '130765665063': [
      11.320726737016642, 53.51368699812529, 11.423260104306934, 53.55668711251729,
    ],
    '130765665071': [
      11.298886488863337, 53.58310109594905, 11.366340021608192, 53.61983529666183,
    ],
    '130765665107': [
      11.31476848584582, 53.541464670829306, 11.381199280891797, 53.594538970334234,
    ],
    '130765665121': [
      11.200474235904304, 53.519735485294106, 11.283987522804976, 53.55828448134794,
    ],
    '130765665130': [
      11.277874239895688, 53.550683375156154, 11.342617876015806, 53.59302027800421,
    ],
    '130765665147': [
      11.244577147198973, 53.517658859714686, 11.322680912770904, 53.55971408811583,
    ],
    '130765665154': [
      11.280101427850465, 53.603600604360096, 11.35821059868884, 53.652872265559765,
    ],
    '130765665163': [
      11.241491592103639, 53.566980479462785, 11.287202839041075, 53.597769789451796,
    ],
    '130765666152': [
      10.994260258145646, 53.41668431969911, 11.156952724152346, 53.53273620262003,
    ],
    '130765666153': [
      10.972513055486171, 53.48035900703446, 11.188330552167272, 53.61000253418889,
    ],
    '130765667039': [
      10.784644515763441, 53.46739233478552, 10.917922256923022, 53.51456358660026,
    ],
    '130765667073': [
      10.886741789668294, 53.45559124690697, 10.981760807111703, 53.535127774989554,
    ],
    '130765667092': [
      10.817731118465781, 53.495732580984885, 10.917365227287723, 53.54604790410873,
    ],
    '130765667142': [
      10.844557181383665, 53.339757142565304, 11.062043439167029, 53.48282936781085,
    ],
    '130765667159': [
      10.822285243761725, 53.52191810341067, 11.021714511881491, 53.64805261606609,
    ],
    '130765668005': [
      11.468038808950778, 53.446486661171406, 11.577880257241908, 53.55155247924709,
    ],
    '130765668007': [
      11.665140630114083, 53.564972686529, 11.759757774497116, 53.625451597576586,
    ],
    '130765668023': [
      11.729003946948671, 53.5681305515571, 11.856845741659921, 53.61391135898627,
    ],
    '130765668024': [
      11.50157231352621, 53.662358645448954, 11.58830500654875, 53.719014076715474,
    ],
    '130765668025': [
      11.56647053961761, 53.54665399757597, 11.788460105924653, 53.65779636207022,
    ],
    '130765668029': [
      11.634683310013639, 53.60818721211459, 11.825800464250003, 53.66395141979763,
    ],
    '130765668033': [
      11.491590095187354, 53.70963836440151, 11.601691523798618, 53.778852235202365,
    ],
    '130765668038': [
      11.678743508879329, 53.49901988267512, 11.822423645428092, 53.556732302102006,
    ],
    '130765668044': [
      11.531390795203174, 53.625464842155466, 11.612111191360395, 53.65176697220302,
    ],
    '130765668080': [
      11.527170115229769, 53.64138439217305, 11.60557550155351, 53.68419517767637,
    ],
    '130765668082': [
      11.454850833020028, 53.62192906362277, 11.537643671995175, 53.71320866736511,
    ],
    '130765668112': [
      11.512909540848831, 53.57780469793795, 11.5838789591954, 53.63474997435711,
    ],
    '130765668113': [
      11.449237823153643, 53.52399257271493, 11.550515346134913, 53.58265721679425,
    ],
    '130765668117': [
      11.4871267828313, 53.56990153786015, 11.533467382823424, 53.622166263973874,
    ],
    '130765668133': [
      11.524263942351832, 53.51919588502728, 11.598349235630277, 53.58998724666747,
    ],
    '130765668140': [
      11.552178413858536, 53.46412409275563, 11.66492203446151, 53.553905849977,
    ],
    '130765668158': [
      11.641791862651337, 53.53183114513623, 11.708590431700669, 53.573966883956054,
    ],
    '145110000000': [
      12.729518480573647, 50.74180380225562, 13.05334636234537, 50.90190945190087,
    ],
    '145210010010': [
      12.9629587769376, 50.715653074307646, 13.054642896261461, 50.77881771221025,
    ],
    '145210020020': [
      12.970563433846742, 50.53816917310376, 13.054656754392608, 50.60649998887643,
    ],
    '145210035035': [
      12.630820467084256, 50.56313113332414, 12.740490089453163, 50.64007350505349,
    ],
    '145210110110': [
      12.699121332041209, 50.43018525612207, 12.897966550882112, 50.5166925028424,
    ],
    '145210130130': [
      12.881590973828956, 50.456926272498784, 12.978118739407465, 50.54895785125776,
    ],
    '145210150150': [
      12.971858741593653, 50.64352562290292, 13.072020064448209, 50.72520465685667,
    ],
    '145210160160': [
      12.900007136316852, 50.624104996796476, 13.003131711557085, 50.66902742490842,
    ],
    '145210170170': [
      12.502295378285728, 50.40586725360453, 12.703201218701112, 50.53573357074017,
    ],
    '145210200200': [
      12.889731827307743, 50.688836743504986, 13.00244190000303, 50.73293061877232,
    ],
    '145210240240': [
      13.039589541061357, 50.66278940791894, 13.122184801345869, 50.7332424211883,
    ],
    '145210250250': [
      13.058930524591021, 50.58954003795405, 13.158937017992221, 50.65207507426594,
    ],
    '145210260260': [
      12.766309290662655, 50.54543801958928, 12.846002798915379, 50.61212402790467,
    ],
    '145210290290': [
      12.650350490263525, 50.72926368247299, 12.694856870212876, 50.75474861005231,
    ],
    '145210310310': [
      12.780726867991271, 50.71530781880871, 12.870770278041189, 50.78881172058201,
    ],
    '145210320320': [
      12.645456110386146, 50.397465408869316, 12.754276374654712, 50.458350136720156,
    ],
    '145210330330': [
      13.061082697104696, 50.50096286448943, 13.200771768851178, 50.575546267816705,
    ],
    '145210355355': [
      12.689079996176869, 50.51862734027959, 12.785275707793886, 50.60294681593926,
    ],
    '145210370370': [
      12.697022789560668, 50.587964225256364, 12.792827897311119, 50.66358492421132,
    ],
    '145210390390': [
      13.117147165530492, 50.50357126778423, 13.324703717479196, 50.69893314618188,
    ],
    '145210400400': [
      13.046027630128153, 50.549770448699356, 13.149286185899959, 50.61579636001704,
    ],
    '145210410410': [
      12.816689605963795, 50.7357505244621, 12.906707753280811, 50.8013988753858,
    ],
    '145210440440': [
      12.859248604366236, 50.40445522055652, 13.023996335221014, 50.46712580901899,
    ],
    '145210450450': [
      12.639106918987189, 50.68805886218642, 12.751676089522746, 50.73908922505596,
    ],
    '145210460460': [
      13.239590326598776, 50.59959393966479, 13.446248218893789, 50.753037523027395,
    ],
    '145210495495': [
      13.119239626857999, 50.66113242550288, 13.311358149362926, 50.77600368926985,
    ],
    '145210500500': [
      12.817594534372162, 50.4609714175405, 12.910199002524266, 50.55899774566642,
    ],
    '145210530530': [
      12.575808481760683, 50.564225898404736, 12.661067112349341, 50.62039373683789,
    ],
    '145210540540': [
      12.458686877652875, 50.46460226784995, 12.58767421574997, 50.52730140334608,
    ],
    '145210550550': [
      12.694749471061938, 50.46894238326854, 12.86154686018034, 50.56532621318148,
    ],
    '145210560560': [
      12.917581978978461, 50.445795737635535, 13.034637705516142, 50.55117393720129,
    ],
    '145210600600': [
      12.478042374612567, 50.51163570017541, 12.617255564222203, 50.564225898404736,
    ],
    '145210620620': [
      12.819271684901457, 50.677106830609425, 12.87321387423065, 50.719688891800566,
    ],
    '145210630630': [
      12.947920806536711, 50.59525765598033, 13.063686181767915, 50.645533351562456,
    ],
    '145210640640': [
      12.904490452481815, 50.65296989558389, 13.000516033847715, 50.69644125096544,
    ],
    '145210670670': [
      13.010365344586173, 50.62353658239383, 13.133846134614396, 50.68801708338244,
    ],
    '145215101060': [
      13.012356595824333, 50.45330157372633, 13.04466529883403, 50.52028415980723,
    ],
    '145215101340': [
      13.018455551158793, 50.50096286448943, 13.084150041452103, 50.56548838121969,
    ],
    '145215103040': [
      12.885262152774512, 50.67026099683429, 12.938389831181636, 50.701800269195545,
    ],
    '145215103120': [
      12.85663278934385, 50.70987439850511, 12.978973800909738, 50.758584390397736,
    ],
    '145215103230': [
      12.869005326893353, 50.6952473464879, 12.904100853675429, 50.72256761999572,
    ],
    '145215110210': [
      12.861256951564252, 50.60701946912002, 12.947920806536711, 50.650397835145164,
    ],
    '145215110610': [
      12.907352563899504, 50.59729567955366, 12.980789208053702, 50.624104996796476,
    ],
    '145215115380': [
      12.712529301507324, 50.72906907941156, 12.796265097387183, 50.789486644531515,
    ],
    '145215115430': [
      12.739131623799882, 50.70922894353887, 12.784433933343411, 50.74746758671515,
    ],
    '145215130510': [
      12.885589761947543, 50.5139402778748, 12.92632262975914, 50.56658826956771,
    ],
    '145215130520': [
      12.903213432215377, 50.53969361829631, 12.983116679335826, 50.59886229373579,
    ],
    '145215132140': [
      13.42897637408748, 50.60309754560225, 13.501131185048148, 50.640982118710404,
    ],
    '145215132280': [
      13.375154892830967, 50.65208334721617, 13.432635440294812, 50.688535478518126,
    ],
    '145215132570': [
      13.421325291619247, 50.61887715395375, 13.494909893725675, 50.66474470366597,
    ],
    '145215133420': [
      12.772891262487649, 50.71298208020228, 12.841643277729688, 50.75226151941198,
    ],
    '145215133590': [
      12.696623668302095, 50.644170917108475, 12.827270781605911, 50.72110359264174,
    ],
    '145215138220': [
      13.01219631914922, 50.74680843386546, 13.096146687853102, 50.80680284417994,
    ],
    '145215138690': [
      13.035742906834203, 50.7153783774782, 13.13238719768279, 50.76317475213143,
    ],
    '145215139080': [
      12.646806357103417, 50.50269063728566, 12.716694717520882, 50.56313113332414,
    ],
    '145215139700': [
      12.60234110322008, 50.51699032713035, 12.68937122712958, 50.58361284151683,
    ],
    '145215140180': [
      12.827256276758268, 50.548048535632674, 12.950032565520484, 50.63132799089316,
    ],
    '145215140710': [
      12.762365386019805, 50.596583028354914, 12.913663700081793, 50.69952248470587,
    ],
    '145215405090': [
      13.101417741949417, 50.69302754325485, 13.158587348483227, 50.76209590193558,
    ],
    '145215405270': [
      13.085033096427575, 50.74410100152869, 13.241819159987912, 50.790249834607856,
    ],
    '145220020020': [
      13.039859660533828, 50.78337838572532, 13.13744614923062, 50.840133383948746,
    ],
    '145220035035': [
      13.379324533854042, 50.83640800604886, 13.514257575808502, 50.94807563166447,
    ],
    '145220050050': [
      13.226498211361475, 50.797469115701965, 13.35535256956605, 50.886808230397115,
    ],
    '145220070070': [
      12.822784657057088, 50.91485047096881, 12.9347852460516, 50.95885011675171,
    ],
    '145220080080': [
      13.015893144841588, 51.079912312492844, 13.253727191822835, 51.17499730316806,
    ],
    '145220110110': [
      13.19620985308367, 50.76334682565135, 13.311039824128363, 50.83466814462925,
    ],
    '145220120120': [
      12.841533465314786, 50.99323684841771, 12.984822239454145, 51.060695773314876,
    ],
    '145220140140': [
      13.036931451642287, 50.82907233338319, 13.140753553405492, 50.879748428621795,
    ],
    '145220150150': [
      12.989237426671997, 50.874228633762, 13.166349752018387, 50.96242152867079,
    ],
    '145220170170': [
      13.456737947113625, 50.74274910991651, 13.579417308669882, 50.845749858402904,
    ],
    '145220180180': [
      13.272027995934462, 50.876491138254785, 13.39910427693021, 50.95917555170459,
    ],
    '145220190190': [
      12.86295395715934, 51.04392972107352, 12.955298830877819, 51.10538880124511,
    ],
    '145220200200': [
      13.269617848165057, 50.73978359743688, 13.363741130172574, 50.8205032168333,
    ],
    '145220210210': [
      13.200821209562092, 50.94180751343901, 13.342010154964091, 51.03507712777609,
    ],
    '145220220220': [
      12.996053653752668, 51.13477326137108, 13.148858819548229, 51.20861713044227,
    ],
    '145220230230': [
      13.058155220036472, 50.91012784386208, 13.209636656498015, 51.00858101844561,
    ],
    '145220240240': [
      13.328922222284483, 50.93057088613538, 13.473921620409731, 50.9920754654523,
    ],
    '145220250250': [
      12.884902516505301, 51.07048695392494, 13.04211000551504, 51.156473136007094,
    ],
    '145220260260': [
      12.762196038051979, 50.86468810180819, 12.827663960682587, 50.900416839235056,
    ],
    '145220275275': [
      13.042793591257338, 51.14083284356028, 13.220699378834485, 51.233502968124554,
    ],
    '145220290290': [
      12.800288059863526, 50.94418104137453, 12.92222985008774, 51.00974319789267,
    ],
    '145220300300': [
      12.980517211085033, 51.008986499762344, 13.119363973813675, 51.05848202526847,
    ],
    '145220310310': [
      12.848480439288934, 51.12682349852082, 13.02439696959978, 51.22570043740533,
    ],
    '145220320320': [
      13.099164464982849, 50.76958144175878, 13.214121469571488, 50.83578826527004,
    ],
    '145220330330': [
      12.884733061022615, 50.88680914216179, 13.031903940274198, 50.951771808569795,
    ],
    '145220350350': [
      12.694313715152699, 50.93859414519294, 12.807586750492055, 50.98930787610148,
    ],
    '145220390390': [
      13.33996345426574, 50.7529250569355, 13.47710477633524, 50.825947410775484,
    ],
    '145220400400': [
      13.430920076115099, 50.63310202700649, 13.539960187081286, 50.72704699614492,
    ],
    '145220420420': [
      12.980149356376439, 50.84592117281508, 13.056941554853005, 50.890462587561046,
    ],
    '145220430430': [
      13.200821209562092, 50.87114648400288, 13.30283426161176, 50.96789980513212,
    ],
    '145220440440': [
      13.119290337796569, 50.81029730594119, 13.253960114784485, 50.932014041996126,
    ],
    '145220460460': [
      12.618487665209594, 50.90294017480789, 12.770784725902576, 51.007374669879894,
    ],
    '145220470470': [
      13.46241226386577, 50.707994343991516, 13.652834457272675, 50.77365186491089,
    ],
    '145220480480': [
      13.30997738938545, 50.983242500427636, 13.447564139783074, 51.05058455743042,
    ],
    '145220500500': [
      12.990256888951667, 50.94471657379721, 13.137154577959011, 51.04637291366971,
    ],
    '145220510510': [
      13.081230433030584, 51.049436781276, 13.259563144323321, 51.11412754975511,
    ],
    '145220540540': [
      13.11825300917926, 50.94824985853775, 13.266507443808376, 51.06873829835942,
    ],
    '145220570570': [
      12.954172584747353, 51.047092333092486, 13.107394142124628, 51.105354881508745,
    ],
    '145220580580': [
      12.727658188715969, 50.97356890776083, 12.850280813611798, 51.02380557201251,
    ],
    '145225102060': [
      12.755829251263672, 50.88785878650819, 12.852714761398115, 50.948747252029904,
    ],
    '145225102380': [
      12.739517995871422, 50.88269574115792, 12.78583483480093, 50.921208727811354,
    ],
    '145225102550': [
      12.81997049881555, 50.897854850414994, 12.897925863165582, 50.93035864668357,
    ],
    '145225113340': [
      13.327440392386436, 50.80490747076903, 13.473133737946325, 50.859732499265206,
    ],
    '145225113590': [
      13.339460427944323, 50.84763318782508, 13.440729177665665, 50.8940814852632,
    ],
    '145225119010': [
      12.911451100893105, 50.94312854763087, 12.981759679633456, 50.983630235155516,
    ],
    '145225119360': [
      12.868334094036529, 50.94612583680411, 13.035113830128504, 51.040606985712834,
    ],
    '145225126280': [
      12.715468286877812, 51.037621061366615, 12.811285648334565, 51.108966371031066,
    ],
    '145225126490': [
      12.710354908573745, 51.0100260473985, 12.815875073237777, 51.078798249809665,
    ],
    '145225126530': [
      12.775312778097513, 50.999418584986515, 12.874995858417046, 51.06909319499186,
    ],
    '145225126600': [
      12.801271567506097, 51.06362662427673, 12.888188928145786, 51.097968515056664,
    ],
    '145225129090': [
      13.364448218481813, 50.726630186473095, 13.485074994840973, 50.78390502280215,
    ],
    '145225129520': [
      13.368636957009832, 50.675761594340415, 13.47975732360284, 50.74596182308958,
    ],
    '145230010010': [
      12.17529124134322, 50.288090609385165, 12.309527321062017, 50.362997083586116,
    ],
    '145230020020': [
      12.331550770445928, 50.44112867145223, 12.494457170185667, 50.54324847277267,
    ],
    '145230030030': [
      12.239778243473245, 50.171655724390774, 12.360003059937968, 50.272024201513034,
    ],
    '145230040040': [
      12.196427749039565, 50.25853556084117, 12.29580032830347, 50.30583985694627,
    ],
    '145230090090': [
      12.370925472858577, 50.46661618247332, 12.410999983992449, 50.497105287353854,
    ],
    '145230100100': [
      12.112088271149306, 50.58028766272446, 12.222605650723, 50.63899738893913,
    ],
    '145230160160': [
      12.36284428546581, 50.333701049003, 12.517156608924292, 50.41882707911858,
    ],
    '145230170170': [
      12.289770775437459, 50.54975876672976, 12.448449110971398, 50.618941960998356,
    ],
    '145230200200': [
      12.276713875143384, 50.253086227336574, 12.438163652118487, 50.35370452227346,
    ],
    '145230245245': [
      12.393419928039755, 50.3973767686121, 12.583810628831596, 50.46850935573431,
    ],
    '145230280280': [
      12.316502577452615, 50.63332199957161, 12.399256826644532, 50.67681778447464,
    ],
    '145230310310': [
      11.873796285562639, 50.50516515160778, 12.0359505232954, 50.635629228564106,
    ],
    '145230320320': [
      12.059534667679634, 50.43061624830464, 12.227137439050033, 50.574533524462026,
    ],
    '145230330330': [
      12.137890512003295, 50.517919674058064, 12.259945705782698, 50.59000905741143,
    ],
    '145230360360': [
      12.365035538349115, 50.50470307236452, 12.468908827419133, 50.575861049382695,
    ],
    '145230365365': [
      11.944504988585598, 50.48572368650643, 12.118270789029717, 50.57995417727944,
    ],
    '145230380380': [
      12.43105631084409, 50.51596674695615, 12.528777973777176, 50.5678366944144,
    ],
    '145230450450': [
      11.89068574818818, 50.37470288606587, 12.101833227600176, 50.504116352111176,
    ],
    '145235107120': [
      12.273077937858668, 50.438158673827004, 12.407040149057908, 50.5084603903767,
    ],
    '145235107130': [
      12.34333775322916, 50.38217055474103, 12.436746270898308, 50.463416948030684,
    ],
    '145235107290': [
      12.297696258122814, 50.42629382841438, 12.354337488378405, 50.479118904117655,
    ],
    '145235120190': [
      12.201554785879981, 50.56397527882445, 12.29439800339203, 50.60296812209795,
    ],
    '145235120260': [
      12.20133250383125, 50.59405114959718, 12.276438725093772, 50.63081205387657,
    ],
    '145235122060': [
      12.019014061347773, 50.34577989331736, 12.146492122664787, 50.41686271774618,
    ],
    '145235122080': [
      12.091616638163675, 50.31618748579594, 12.22238225662668, 50.381509869924656,
    ],
    '145235122300': [
      12.074869745614674, 50.36921105877604, 12.233756327597511, 50.45085211833546,
    ],
    '145235122440': [
      11.98210449492406, 50.3254328854254, 12.15650138300803, 50.39025873772671,
    ],
    '145235125150': [
      12.313319540364832, 50.595677664751804, 12.421028722206282, 50.64874417094826,
    ],
    '145235125340': [
      12.239663037133639, 50.58070133141925, 12.35853840329706, 50.663772369455266,
    ],
    '145235131230': [
      12.198963849086708, 50.33506505785476, 12.326115203078743, 50.43427821086885,
    ],
    '145235131370': [
      12.25200123674672, 50.345240122570736, 12.411789197290256, 50.43020136738147,
    ],
    '145235134270': [
      12.189364919617455, 50.46911485222331, 12.286296604859688, 50.55050418803291,
    ],
    '145235134430': [
      12.250595047550801, 50.49913950440026, 12.36809233832535, 50.576616570709824,
    ],
    '145235402050': [
      12.253080985893517, 50.44608564251579, 12.306616491750026, 50.48152831229206,
    ],
    '145235402410': [
      12.198635827281974, 50.4495445306978, 12.272777068029953, 50.486208871637096,
    ],
    '145235402420': [
      12.17665996049841, 50.414325553590345, 12.279163013635229, 50.46530329390563,
    ],
    '145235402460': [
      12.262594194520796, 50.41529541945408, 12.332618420906552, 50.454835480499085,
    ],
    '145240020020': [
      12.610697241262208, 50.80930312495291, 12.748712334605566, 50.880610419271065,
    ],
    '145240060060': [
      12.314246220729984, 50.66365851295062, 12.393933845505288, 50.71648304561357,
    ],
    '145240070070': [
      12.682489098833372, 50.73847925938286, 12.727162554602442, 50.782305139140085,
    ],
    '145240080080': [
      12.490564879134528, 50.75655463373321, 12.619555083301405, 50.852102858401906,
    ],
    '145240090090': [
      12.631469122845097, 50.629956145620156, 12.719841472744719, 50.712739758955394,
    ],
    '145240120120': [
      12.65654880448931, 50.78912973170677, 12.771452398698825, 50.83386810198256,
    ],
    '145240140140': [
      12.227125547399671, 50.72811386876896, 12.352060866437892, 50.78821329129265,
    ],
    '145240150150': [
      12.564043730442837, 50.60931056569028, 12.652475977337053, 50.665096347876855,
    ],
    '145240170170': [
      12.377981614571514, 50.63691560708628, 12.464125618801086, 50.70841528223684,
    ],
    '145240200200': [
      12.483835446129198, 50.68699989346898, 12.65312119199146, 50.790066164361704,
    ],
    '145240210210': [
      12.335813703756378, 50.761932722934674, 12.432032140147525, 50.80729846439267,
    ],
    '145240230230': [
      12.683851139487968, 50.76995634188107, 12.778063643287496, 50.80397968315221,
    ],
    '145240250250': [
      12.518610560152656, 50.669058046802704, 12.599454535361529, 50.7184709566193,
    ],
    '145240300300': [
      12.253518662370727, 50.68573261333274, 12.44180192055936, 50.77445021572754,
    ],
    '145240310310': [
      12.535114496489099, 50.63431732907766, 12.631892532312959, 50.69434984121254,
    ],
    '145240320320': [
      12.482509965590141, 50.64412671265574, 12.562579518047375, 50.68912524593747,
    ],
    '145240330330': [
      12.40819570163354, 50.642114891974025, 12.56287775205636, 50.809792213193525,
    ],
    '145245104030': [
      12.242840085295093, 50.78135554769825, 12.45670036061768, 50.85781961686457,
    ],
    '145245104050': [
      12.444747306239911, 50.791226237878945, 12.515807346018978, 50.83182506895936,
    ],
    '145245111040': [
      12.461006940186525, 50.5463356709596, 12.548763587427366, 50.59668257556983,
    ],
    '145245111100': [
      12.505385425613165, 50.55207132092734, 12.61527751876265, 50.62621591897405,
    ],
    '145245111110': [
      12.412721773030627, 50.60574741262151, 12.508759348973436, 50.65168505755629,
    ],
    '145245111130': [
      12.428822997789291, 50.56188754010797, 12.565072876683063, 50.65259767051778,
    ],
    '145245114180': [
      12.636333711900997, 50.81979509996113, 12.805896312982425, 50.92407602520273,
    ],
    '145245114220': [
      12.699470551047181, 50.8662214649777, 12.769290678235906, 50.9052341294305,
    ],
    '145245118190': [
      12.408768252591065, 50.82075629744132, 12.518866601282394, 50.870435248461355,
    ],
    '145245118270': [
      12.45940441984109, 50.851802075346306, 12.532720787559928, 50.89413033198314,
    ],
    '145245128010': [
      12.636510336183669, 50.75402016556199, 12.696792870789459, 50.80330513142789,
    ],
    '145245128160': [
      12.600559942557284, 50.721586310336264, 12.667636247317741, 50.77744568203995,
    ],
    '145245128280': [
      12.583300850847937, 50.766904073439164, 12.67014779301379, 50.825126776135875,
    ],
    '145245135240': [
      12.50791933186033, 50.863092913067916, 12.574975952723593, 50.90710840152834,
    ],
    '145245135260': [
      12.515890019034279, 50.84074764520608, 12.60049674942834, 50.87610144668439,
    ],
    '145245135290': [
      12.566932792614562, 50.83745815944454, 12.652799520721535, 50.909264741508984,
    ],
    '146120000000': [
      13.580126283057036, 50.976677924288296, 13.96536298145244, 51.17637164542347,
    ],
    '146250010010': [
      13.927603215348991, 51.061819591664545, 14.044795551313793, 51.12631816814118,
    ],
    '146250020020': [
      14.325148330697184, 51.137718514033615, 14.492516389977995, 51.23091601423959,
    ],
    '146250030030': [
      13.99487490400022, 51.3383479187693, 14.174229039109832, 51.41866732621417,
    ],
    '146250060060': [
      14.126234291482454, 51.15756945319756, 14.267860543108863, 51.21974836746889,
    ],
    '146250090090': [
      14.471204303557505, 51.07568095115741, 14.58329838315085, 51.11898939866997,
    ],
    '146250100100': [
      14.203850792783204, 51.12784379778413, 14.28746774849488, 51.17609375892289,
    ],
    '146250110110': [
      14.273073187330343, 51.107468939041325, 14.417960854382855, 51.17078477752444,
    ],
    '146250120120': [
      14.071742204144707, 51.44345171689968, 14.34892147150386, 51.54100241020905,
    ],
    '146250130130': [
      14.088973630842233, 51.17572670565453, 14.171959815091142, 51.25178607810962,
    ],
    '146250150150': [
      14.249538942416951, 51.14708184114674, 14.370645301133695, 51.22745494909881,
    ],
    '146250160160': [
      14.402634946474357, 51.21452048481278, 14.566086193450799, 51.32628384838948,
    ],
    '146250200200': [
      13.95386872381545, 51.11759325629788, 14.112900918374603, 51.17236895268045,
    ],
    '146250220220': [
      13.93203358513771, 51.197046197831476, 14.099206239332759, 51.266766903552615,
    ],
    '146250230230': [
      14.523376918584805, 51.114464621394944, 14.639874449185635, 51.18501419259236,
    ],
    '146250240240': [
      14.069231784402906, 51.38221160042156, 14.369657963993545, 51.46623543349951,
    ],
    '146250250250': [
      13.993756942040818, 51.23047353456017, 14.174216175349851, 51.343169319694965,
    ],
    '146250280280': [
      14.26279674026307, 51.289462233600275, 14.425206544403853, 51.36084977848117,
    ],
    '146250290290': [
      14.442667276265292, 51.11885669851151, 14.554484091363541, 51.214787117813295,
    ],
    '146250310310': [
      14.03225537675475, 51.39646947169611, 14.180994492752756, 51.48663682235913,
    ],
    '146250330330': [
      14.279921860776666, 51.305564398431, 14.500684523271744, 51.45212267615015,
    ],
    '146250340340': [
      14.463754777654659, 51.19625626768473, 14.63545913527629, 51.35808263540947,
    ],
    '146250380380': [
      14.265663783004664, 51.06826687190551, 14.347683477466758, 51.11434480495759,
    ],
    '146250420420': [
      14.08459743443231, 51.304278977173055, 14.214644747764517, 51.380174340982805,
    ],
    '146250430430': [
      13.76575089390176, 51.14573374245496, 13.870418127362047, 51.20001361770692,
    ],
    '146250480480': [
      13.869974716903833, 51.059483159718376, 13.954793967300573, 51.142753264415646,
    ],
    '146250490490': [
      14.34205597246088, 51.21748143834894, 14.479796335051727, 51.34614317024836,
    ],
    '146250525525': [
      14.387028701475568, 51.060318396346354, 14.487636912055745, 51.11085146014341,
    ],
    '146250530530': [
      14.172078032382439, 51.05977087379881, 14.280491757098789, 51.136582988341395,
    ],
    '146250550550': [
      13.884378515308343, 51.307487736955395, 14.046694642859702, 51.39623522243512,
    ],
    '146250560560': [
      14.361140128672229, 51.01890158349639, 14.491793376797558, 51.072606673906016,
    ],
    '146250570570': [
      14.302965556969049, 51.40965007997448, 14.522536223270835, 51.54247100561062,
    ],
    '146250590590': [
      14.3145938477988, 51.03916763231705, 14.391184187029122, 51.08678069344335,
    ],
    '146250600600': [
      13.850860384846367, 51.1348150261706, 13.987822500179423, 51.20162886772158,
    ],
    '146250610610': [
      14.538582743305867, 51.144819812029795, 14.698088441304282, 51.23009316667097,
    ],
    '146250630630': [
      14.346675084115775, 51.076424940715576, 14.41694594964121, 51.124170660764136,
    ],
    '146250640640': [
      14.161102928233403, 51.33250703064468, 14.315966201051067, 51.42061183494402,
    ],
    '146255207040': [
      14.121178587728496, 51.066956568075994, 14.229369456869772, 51.170545114172064,
    ],
    '146255207510': [
      14.09015664836322, 51.13725234702873, 14.15644171481323, 51.1784817063217,
    ],
    '146255211140': [
      14.075900485488475, 51.11972881396585, 14.130935890185881, 51.14798940690148,
    ],
    '146255211170': [
      14.00305503396194, 51.07270698310015, 14.132767325031631, 51.12864402647114,
    ],
    '146255212190': [
      14.41694594964121, 51.103919697019464, 14.486542557375824, 51.15097263743088,
    ],
    '146255212390': [
      14.380224430875517, 51.11085146014341, 14.431456520807899, 51.151508868664486,
    ],
    '146255218270': [
      13.797113246040276, 51.23026000970305, 13.948540717962159, 51.383587695487044,
    ],
    '146255218300': [
      13.763376067847323, 51.193803291828225, 13.931177172953134, 51.282209658313654,
    ],
    '146255218370': [
      13.890082477826084, 51.26043962245127, 14.007887025074375, 51.320125117708365,
    ],
    '146255223360': [
      14.255400745341095, 51.218698209525925, 14.389870874998772, 51.3003870754822,
    ],
    '146255223460': [
      14.259453373930775, 51.22681306026395, 14.320395508618171, 51.265798630223294,
    ],
    '146255231180': [
      13.900015279746274, 51.18358764542355, 13.980176746536358, 51.23088656601602,
    ],
    '146255231320': [
      13.93098328926591, 51.154158284068146, 13.99442379377362, 51.19882959333021,
    ],
    '146255231410': [
      14.022296007163815, 51.16091738600742, 14.107781341232162, 51.197046197831476,
    ],
    '146255231450': [
      13.948540717962159, 51.166911231996764, 14.04798744439414, 51.23908047829602,
    ],
    '146255231580': [
      14.010426830653454, 51.18528444204236, 14.099206239332759, 51.22679722816934,
    ],
    '146255501080': [
      14.212432237299684, 51.218310200348526, 14.285745391237983, 51.27070889341403,
    ],
    '146255501350': [
      14.12824015680744, 51.2382440283014, 14.21413004365941, 51.31029345025797,
    ],
    '146255501440': [
      14.14858258942871, 51.18133955615607, 14.26559629091776, 51.245692702067146,
    ],
    '146255501470': [
      14.186187514901153, 51.24022465815504, 14.240999130625493, 51.27877078230593,
    ],
    '146255501500': [
      14.17695223649315, 51.264197085056516, 14.271283590194216, 51.33985630757507,
    ],
    '146260060060': [
      14.458582062235124, 51.30132285654118, 14.74750275656977, 51.477926687058435,
    ],
    '146260085085': [
      14.563422098273785, 50.95865642750748, 14.634005209796848, 51.03056563142721,
    ],
    '146260110110': [
      14.911827883932768, 51.05294767936475, 15.017601491014254, 51.22476749130879,
    ],
    '146260180180': [
      14.674255182935635, 50.967180279237084, 14.836060632682733, 51.05176956145272,
    ],
    '146260245245': [
      14.593491499117928, 50.96357081342321, 14.715824471858246, 51.07439364962275,
    ],
    '146260250250': [
      14.679885720792932, 51.412146645910774, 14.973485576998295, 51.53314217960273,
    ],
    '146260280280': [
      14.61337162027998, 50.92375200977801, 14.706432412937373, 50.97657312697615,
    ],
    '146260300300': [
      14.81427098523512, 51.07524957326665, 14.943382182150755, 51.16752441871898,
    ],
    '146260310310': [
      14.714074987745967, 50.90552542609408, 14.844396878589908, 50.96922387152171,
    ],
    '146260370370': [
      14.749100956820948, 51.258237603815815, 14.867215106844148, 51.37760878254866,
    ],
    '146260390390': [
      14.652071491565499, 50.93107834929141, 14.786923884068056, 50.995552572704135,
    ],
    '146260420420': [
      14.871607044317871, 50.972901781237276, 14.961980434133988, 51.0619006328727,
    ],
    '146260530530': [
      14.561841469308531, 50.91486989982713, 14.654630789347623, 50.962892011916566,
    ],
    '146260610610': [
      14.753696819411205, 50.822597928628014, 14.906184323769644, 50.99929504186833,
    ],
    '146265203010': [
      14.676361214928917, 51.528134318574374, 14.729934814504686, 51.596942594992306,
    ],
    '146265203100': [
      14.604974960353271, 51.5162780742174, 14.691579965223367, 51.551656050094536,
    ],
    '146265206030': [
      14.753909626353526, 50.99798388644142, 14.895303131440322, 51.09714895973527,
    ],
    '146265206500': [
      14.854518511102187, 51.01976454831746, 14.954568120294722, 51.085183657034165,
    ],
    '146265214140': [
      14.619327959803707, 50.84892388784073, 14.697729657098803, 50.92764348221231,
    ],
    '146265214170': [
      14.651646859193095, 50.88764103798341, 14.730833637930704, 50.93518538193971,
    ],
    '146265220150': [
      14.609435112224446, 51.050836765636326, 14.66571545315528, 51.07959833020337,
    ],
    '146265220270': [
      14.557805164968327, 51.064877929131725, 14.624881769978476, 51.11993253051003,
    ],
    '146265220290': [
      14.59654414145428, 51.05540739209644, 14.754534019166147, 51.18612016196046,
    ],
    '146265220470': [
      14.702993956931271, 51.05170128639094, 14.772357101596723, 51.112638270384224,
    ],
    '146265224070': [
      14.570702810413051, 51.034771552468655, 14.63648769371536, 51.06915474244372,
    ],
    '146265224350': [
      14.49889784915787, 51.00413434604503, 14.595899108843009, 51.05812231477715,
    ],
    '146265224510': [
      14.53111061602385, 51.04525042696053, 14.593506176034117, 51.07717058237673,
    ],
    '146265227050': [
      14.679171865848852, 50.85850852090769, 14.76337251109304, 50.91092885726065,
    ],
    '146265227210': [
      14.658426914125844, 50.838389449422095, 14.726929344400034, 50.868446903542655,
    ],
    '146265227400': [
      14.722350241093364, 50.84750044630005, 14.798876154705008, 50.89749292458922,
    ],
    '146265227430': [
      14.708239214562951, 50.820415177738425, 14.79362060031934, 50.86143828459484,
    ],
    '146265228020': [
      14.50711421185164, 51.05812231477715, 14.558436863403967, 51.08122420239244,
    ],
    '146265228410': [
      14.475522123901472, 51.04323850117968, 14.53111061602385, 51.079276271424675,
    ],
    '146265232240': [
      14.827048880846235, 51.160009036088205, 14.900696395689481, 51.207133922393176,
    ],
    '146265232450': [
      14.722633647470069, 51.08318603687625, 14.847181855040231, 51.1861799149142,
    ],
    '146265232570': [
      14.670380866788385, 51.171095848773845, 14.82839824828111, 51.232906346416094,
    ],
    '146265233260': [
      14.644618126583483, 51.31097544468066, 14.757702140034967, 51.37512927278382,
    ],
    '146265233460': [
      14.685796623292724, 51.36380989287276, 14.892123916736155, 51.45027723926521,
    ],
    '146265235160': [
      14.806541616311204, 51.30660906664615, 14.917132929041383, 51.40745534399189,
    ],
    '146265235480': [
      14.854762980944308, 51.28033382754876, 15.013825538104376, 51.432490859695775,
    ],
    '146265237120': [
      14.544593977012292, 51.530957521939854, 14.609447772270688, 51.580016894345604,
    ],
    '146265237490': [
      14.439510670837887, 51.49594070282992, 14.572005337271266, 51.56351164192357,
    ],
    '146265237560': [
      14.471513870868497, 51.46806992953434, 14.59396555328683, 51.53858948124787,
    ],
    '146265242590': [
      14.657023507305375, 51.42865828273613, 14.788836851936315, 51.511567014342624,
    ],
    '146265242600': [
      14.48316666670325, 51.42832737764361, 14.694373467705802, 51.53810032736608,
    ],
    '146265502190': [
      14.600614966006082, 51.21112892048693, 14.727857782910887, 51.304429542920715,
    ],
    '146265502320': [
      14.637068845733417, 51.26881872647425, 14.73557469750903, 51.33828355365062,
    ],
    '146265502440': [
      14.671426816793447, 51.25132110468528, 14.781197723016922, 51.347652017757966,
    ],
    '146265502580': [
      14.721461080930313, 51.19212333276762, 14.857456719041155, 51.285786125665474,
    ],
    '146265503200': [
      14.845865685880495, 51.256538787429, 14.977106877116976, 51.32926082230748,
    ],
    '146265503230': [
      14.83038382416392, 51.19881978122634, 14.96025529832673, 51.28544997722944,
    ],
    '146265503330': [
      14.924491941753226, 51.21993580959573, 15.041531420443423, 51.301393790436855,
    ],
    '146265503520': [
      14.88354113843904, 51.154887557249445, 14.974271085063709, 51.230841902615516,
    ],
    '146270010010': [
      13.500476485716792, 51.10492058153815, 13.655340108604989, 51.161809706822666,
    ],
    '146270020020': [
      13.34486719108865, 51.17311374585505, 13.492788028376472, 51.24533255785132,
    ],
    '146270030030': [
      13.565589367825732, 51.19787667525212, 13.7632709812807, 51.29712953308602,
    ],
    '146270050050': [
      13.338489114327425, 51.39161703834336, 13.47136852023675, 51.4551180549988,
    ],
    '146270060060': [
      13.418359506895138, 51.26167276268821, 13.622668869840359, 51.3854496265742,
    ],
    '146270070070': [
      13.262576570762844, 51.235543332988875, 13.405239372586635, 51.29381588094281,
    ],
    '146270080080': [
      13.32899854019241, 51.09758197420492, 13.454846126482893, 51.187420585342466,
    ],
    '146270100100': [
      13.373038766528158, 51.033717050824286, 13.598963200444654, 51.141175684117314,
    ],
    '146270130130': [
      13.208562783037802, 51.16270682975759, 13.38583073180444, 51.24810178036601,
    ],
    '146270140140': [
      13.42495738801633, 51.12922648105155, 13.540011689859865, 51.19271161182755,
    ],
    '146270150150': [
      13.593140729277954, 51.11164185259962, 13.729311519461326, 51.209952788480145,
    ],
    '146270170170': [
      13.47880602086367, 51.15806068466131, 13.610436418077674, 51.2249077148233,
    ],
    '146270180180': [
      13.226194653303379, 51.0067044892485, 13.409883166833135, 51.189566940139635,
    ],
    '146270200200': [
      13.429522470759343, 51.204736462156255, 13.597777786783109, 51.27523943721696,
    ],
    '146270210210': [
      13.58501321609152, 51.0901685824349, 13.701108405483238, 51.143343694598,
    ],
    '146270220220': [
      13.658749253335845, 51.133628598535424, 13.794514238389851, 51.23620230826403,
    ],
    '146270230230': [
      13.202616675376285, 51.26000324583508, 13.387926618624107, 51.33840510646045,
    ],
    '146270260260': [
      13.19390886362821, 51.20188062764305, 13.299005297293641, 51.29096361064302,
    ],
    '146270270270': [
      13.182311092299194, 51.32516629998432, 13.29430444568871, 51.40713489009043,
    ],
    '146270290290': [
      13.710334518299238, 51.224452767298814, 13.856986589172926, 51.376978319869444,
    ],
    '146270310310': [
      13.540011689859865, 51.143085080590446, 13.637663901799323, 51.18558789833176,
    ],
    '146270360360': [
      13.229780117061882, 51.30883215141418, 13.377590501582961, 51.4378275788683,
    ],
    '146275225040': [
      13.360409225363467, 51.309723956145554, 13.422466872836265, 51.34475522905131,
    ],
    '146275225190': [
      13.349223615775552, 51.22815935739263, 13.456572981547934, 51.322415304818335,
    ],
    '146275234240': [
      13.413023144665496, 51.36012485472172, 13.539239557612662, 51.412311977844396,
    ],
    '146275234340': [
      13.358784842792408, 51.33949521781657, 13.449587220985004, 51.41310250982229,
    ],
    '146275238110': [
      13.556182615173327, 51.287420168483145, 13.741002887234531, 51.37562962825944,
    ],
    '146275238250': [
      13.67023157264005, 51.267192818070534, 13.828287709022986, 51.37141952449018,
    ],
    '146280050050': [
      13.676573002791084, 50.95117181180497, 13.773611599455085, 51.009459180947445,
    ],
    '146280060060': [
      13.583470177602305, 50.7706937455502, 13.730094909865608, 50.949771740077566,
    ],
    '146280100100': [
      13.93732998475975, 50.99608398635765, 14.095715410338363, 51.07099812635697,
    ],
    '146280110110': [
      13.580515568012492, 50.95288540610189, 13.6975679012862, 51.03373272952855,
    ],
    '146280130130': [
      13.66902629657879, 50.80567585468194, 13.829209779647824, 50.93025353307757,
    ],
    '146280160160': [
      13.821303031667073, 50.94458243076548, 13.90664661673497, 50.99251057028402,
    ],
    '146280190190': [
      14.049663455116425, 50.94013949443962, 14.228482726490089, 51.02608795164626,
    ],
    '146280220220': [
      13.701149516302442, 50.91483595518384, 13.807531358032344, 50.98805749035065,
    ],
    '146280260260': [
      14.145298555544793, 50.97718583859414, 14.320093589481296, 51.087420590102866,
    ],
    '146280300300': [
      13.591735876933068, 50.912430648881724, 13.720902568481131, 50.9881748114994,
    ],
    '146280360360': [
      14.1622415837924, 50.8871456001459, 14.401198447450849, 50.99456119757207,
    ],
    '146280380380': [
      14.013005691693056, 50.996010933763955, 14.16400410841207, 51.089953846783175,
    ],
    '146280410410': [
      13.421812566081565, 50.983361872679666, 13.609407469395316, 51.066633793135374,
    ],
    '146285201010': [
      13.652141467705802, 50.71755301091501, 13.901140458873364, 50.832012529715726,
    ],
    '146285201170': [
      13.59850622753008, 50.73047699079697, 13.689660703746013, 50.786184736710155,
    ],
    '146285202020': [
      13.852772926490589, 50.78888612670031, 14.03969845297038, 50.905299287937595,
    ],
    '146285202040': [
      13.860930595414061, 50.83291247823862, 13.943831532796409, 50.930807065002305,
    ],
    '146285202230': [
      13.809003258375446, 50.80236413407662, 13.881636599232708, 50.91100969126366,
    ],
    '146285204030': [
      14.073818645756665, 50.886417926696886, 14.313712008125885, 50.961564988051975,
    ],
    '146285204320': [
      14.124983482394406, 50.92210251599449, 14.163108623699994, 50.943071605828635,
    ],
    '146285204330': [
      14.140896309813053, 50.84236935725549, 14.234849776458839, 50.90816377447041,
    ],
    '146285209080': [
      13.775271279513579, 50.91628822487918, 13.911969881568611, 50.976774244745606,
    ],
    '146285209250': [
      13.778359651952087, 50.901343267048716, 13.879373214366813, 50.94921767792742,
    ],
    '146285219140': [
      14.086318216557483, 50.83420251784491, 14.167558844128267, 50.92543113585144,
    ],
    '146285219210': [
      13.994069154232497, 50.88755178050859, 14.105036095205238, 50.94572437316113,
    ],
    '146285219310': [
      14.049997481755613, 50.94450433019756, 14.098979322090237, 50.96537617077948,
    ],
    '146285219340': [
      14.00951426166951, 50.81024760303375, 14.127257072813912, 50.898423416866116,
    ],
    '146285219390': [
      13.959232587832378, 50.91282370182268, 14.074606390231162, 50.9545483010709,
    ],
    '146285221240': [
      13.951906062295615, 50.96007189052074, 14.07993546824855, 51.00776049132961,
    ],
    '146285221370': [
      13.975656967089895, 50.94319428685176, 14.053737883632985, 50.97852186958546,
    ],
    '146285229070': [
      13.908219126076027, 50.876804552170974, 13.99344319914652, 50.932853146877065,
    ],
    '146285229270': [
      13.884057738630881, 50.902186666964, 13.999258625179039, 51.017009921890434,
    ],
    '146285230150': [
      13.520604737508329, 50.7729871100492, 13.620975011697256, 50.84784340007111,
    ],
    '146285230205': [
      13.458144132015448, 50.826946772140744, 13.62433213410903, 50.95481210361071,
    ],
    '146285240090': [
      13.530136097917492, 50.92159259734334, 13.572968609394223, 50.948475839711335,
    ],
    '146285240400': [
      13.427359957162691, 50.92286359892729, 13.612625754913303, 51.01248038256663,
    ],
    '147130000000': [
      12.23547539603741, 51.2384515774516, 12.542658345536191, 51.448077507707445,
    ],
    '147290030030': [
      12.63952871026942, 51.295244447152626, 12.757411595537139, 51.402150319776744,
    ],
    '147290040040': [
      12.3495052489033, 51.165332359509605, 12.432509102348526, 51.24443511297192,
    ],
    '147290050050': [
      12.446364931979954, 51.06233221266802, 12.56713958715176, 51.178956571312895,
    ],
    '147290060060': [
      12.500456635740386, 51.32427184144319, 12.575963795941203, 51.37501060129039,
    ],
    '147290070070': [
      12.532838301986166, 51.300194793247755, 12.693382116378787, 51.35156808222708,
    ],
    '147290080080': [
      12.675456665889296, 51.09207293780999, 12.897777405371745, 51.181128959533034,
    ],
    '147290140140': [
      12.501450759535524, 50.980934250090534, 12.718899843623973, 51.142970000489136,
    ],
    '147290150150': [
      12.62246464694716, 50.98512939163266, 12.742908864980086, 51.102660607758395,
    ],
    '147290160160': [
      12.639958950839508, 51.157253097708725, 12.927655671423386, 51.31087414677523,
    ],
    '147290170170': [
      12.22059574344932, 51.091780561053746, 12.390117779188728, 51.18317515014094,
    ],
    '147290190190': [
      12.40210933404644, 51.20709154194354, 12.54317078698098, 51.30561235362506,
    ],
    '147290220220': [
      12.510954818909568, 51.13026596010292, 12.585169589069741, 51.206085860807704,
    ],
    '147290245245': [
      12.724128286149302, 51.33211712273262, 12.939433545216062, 51.455208002137795,
    ],
    '147290250250': [
      12.55910376556224, 51.34131679257525, 12.682302674529097, 51.42064357618993,
    ],
    '147290260260': [
      12.322875389292625, 51.24190017125149, 12.448787146702442, 51.296149361750125,
    ],
    '147290270270': [
      12.148134146934483, 51.23895948499986, 12.27830748838154, 51.34966879522218,
    ],
    '147290320320': [
      12.323686721464169, 51.0980445191546, 12.490006931104155, 51.197169850757206,
    ],
    '147290360360': [
      12.353536417112267, 51.07293428355856, 12.458872425865964, 51.12765262746972,
    ],
    '147290370370': [
      12.395182646979627, 51.17357365817694, 12.562085972117575, 51.24222089743362,
    ],
    '147290380380': [
      12.643731892719767, 51.38282712176884, 12.830789739842096, 51.46771641402326,
    ],
    '147290400400': [
      12.656853077195196, 51.25940397514449, 12.804100359401394, 51.312565383074514,
    ],
    '147290410410': [
      12.711385239946653, 51.301942923943585, 12.902874601374913, 51.39244810033428,
    ],
    '147290430430': [
      12.237662890795153, 51.17653629512986, 12.37037534369362, 51.25710284093396,
    ],
    '147295301010': [
      12.567788762456964, 51.090562905704175, 12.746381425281259, 51.19207833496249,
    ],
    '147295301330': [
      12.562085972117575, 51.178234728707274, 12.664222213480421, 51.22599682217425,
    ],
    '147295307020': [
      12.515137389390656, 51.20549320096083, 12.588211604047364, 51.27272768772315,
    ],
    '147295307300': [
      12.514680488598545, 51.24769103392506, 12.674191529846919, 51.31572636469983,
    ],
    '147295307340': [
      12.566544327148147, 51.21495779078088, 12.677937757177165, 51.28963835036274,
    ],
    '147295308100': [
      12.194698441748038, 51.128133802090076, 12.258551245549722, 51.16447511646576,
    ],
    '147295308350': [
      12.174784915636586, 51.142646366662945, 12.299129061400771, 51.25863454937488,
    ],
    '147300020020': [
      12.485943520227451, 51.54295149894819, 12.641289090164403, 51.62718949983818,
    ],
    '147300045045': [
      12.83459784043216, 51.406411493524985, 13.204849592351685, 51.5233610880301,
    ],
    '147300050050': [
      13.020059610069355, 51.34648704784275, 13.206610141344525, 51.43423294241163,
    ],
    '147300060060': [
      12.903592143123944, 51.31443877436998, 13.07346726361514, 51.43202935243723,
    ],
    '147300070070': [
      12.272287385359348, 51.48062304998164, 12.452354376340777, 51.586622619126985,
    ],
    '147300080080': [
      12.613691725763594, 51.44499430012193, 12.776862755114907, 51.56287252464989,
    ],
    '147300110110': [
      12.508893936991043, 51.42393992206308, 12.683921648274119, 51.49172695755526,
    ],
    '147300160160': [
      12.574923728386887, 51.50821191201761, 12.778450977607706, 51.66237266199147,
    ],
    '147300170170': [
      13.050275052597252, 51.27036424150114, 13.214248374433, 51.378028357951194,
    ],
    '147300180180': [
      12.367645441611119, 51.54650439898644, 12.524592090899647, 51.61017593617307,
    ],
    '147300190190': [
      12.732996502839729, 51.44896587684537, 12.936381841632546, 51.56774002471808,
    ],
    '147300200200': [
      12.907751586416705, 51.2000290602457, 13.109710262426148, 51.265644599794776,
    ],
    '147300210210': [
      13.088149343200543, 51.22215408869893, 13.216153186428151, 51.27919762477864,
    ],
    '147300230230': [
      13.030300071559465, 51.24890092280165, 13.163417249605942, 51.332537261060295,
    ],
    '147300250250': [
      12.285490995616872, 51.417965112909904, 12.417653746024557, 51.495281394882426,
    ],
    '147300270270': [
      12.171973001860705, 51.33256179528368, 12.361212023279336, 51.46144391628131,
    ],
    '147300300300': [
      12.45701168501584, 51.36047769893034, 12.575975725770496, 51.42202529024254,
    ],
    '147300330330': [
      12.870735488415235, 51.24207599134114, 13.052584449293425, 51.354755421824564,
    ],
    '147300340340': [
      12.147922088755106, 51.421578974874464, 12.315249286579215, 51.567448348480106,
    ],
    '147305302010': [
      13.060322452476008, 51.47676931511098, 13.208472472722823, 51.56162777052543,
    ],
    '147305302030': [
      12.933390092421813, 51.548270962818876, 13.161540161587093, 51.669713175088994,
    ],
    '147305303090': [
      12.802768313054768, 51.616329276603096, 12.904388892973719, 51.68403868828589,
    ],
    '147305303120': [
      12.871156883009427, 51.58090180726511, 13.023620891279265, 51.6499393793538,
    ],
    '147305303320': [
      12.706532813227442, 51.5642406641484, 12.912469649680213, 51.66760023208895,
    ],
    '147305306150': [
      12.37365333735606, 51.42833928208095, 12.519483990092594, 51.499092151528345,
    ],
    '147305306280': [
      12.389552145578595, 51.47066428757754, 12.525960127493013, 51.56303979738266,
    ],
    '147305311100': [
      12.803388840310353, 51.53911714920103, 12.949400235295828, 51.59046079543498,
    ],
    '147305311310': [
      12.904506530776215, 51.47471736241516, 13.101546524869756, 51.60234328721123,
    ],
    '147305601140': [
      12.491853028119431, 51.37358547145153, 12.655604339599142, 51.45032009597233,
    ],
    '147305601360': [
      12.48193944130085, 51.46383851458319, 12.62678305317658, 51.57637179054883,
    ],
    '150010000000': [
      12.112509748901328, 51.73214926339853, 12.350979636027416, 51.9701913718956,
    ],
    '150020000000': [
      11.856177573363034, 51.40234646876496, 12.083449164257834, 51.54332986073477,
    ],
    '150030000000': [
      11.519084892430469, 52.02553637989081, 11.756657066540315, 52.22809711370097,
    ],
    '150810030030': [
      11.312662352500801, 52.73532307613646, 11.636264650832306, 52.94153848512647,
    ],
    '150810135135': [
      11.052653564919897, 52.38694029172443, 11.604966925559392, 52.632313681127116,
    ],
    '150810240240': [
      11.22202337250715, 52.60201968753002, 11.562829423085427, 52.774025319044306,
    ],
    '150810280280': [
      10.936460272961625, 52.49659358869197, 11.287321392435473, 52.697562614206156,
    ],
    '150810455455': [
      10.906669426778867, 52.76038229049437, 11.342381114988605, 52.913406250394864,
    ],
    '150815051026': [
      11.140225936758997, 52.686035461496076, 11.27370714439881, 52.78992281156334,
    ],
    '150815051045': [
      10.94326711642144, 52.620165574762176, 11.168682535300224, 52.758932053456135,
    ],
    '150815051095': [
      10.756241551204244, 52.75533555658341, 10.948017980733315, 52.85631799385065,
    ],
    '150815051105': [
      10.756241551204244, 52.702294673127945, 11.006979663358514, 52.800231278768656,
    ],
    '150815051225': [
      10.833634325946186, 52.61013688782245, 10.98438372560771, 52.727774289986016,
    ],
    '150815051290': [
      11.020441852955983, 52.7218900928689, 11.161466379862398, 52.80894572900181,
    ],
    '150815051440': [
      10.96699674761901, 52.668641473372844, 11.087016200392265, 52.754873637160614,
    ],
    '150815051545': [
      10.92170813413333, 52.74422201966677, 11.068527985350132, 52.81765843376194,
    ],
    '150820005005': [
      11.958524044343866, 51.79962624830595, 12.144049957998494, 51.879276323170224,
    ],
    '150820015015': [
      12.178583573794336, 51.583627704628256, 12.392342284548574, 51.70428467560563,
    ],
    '150820180180': [
      11.846371666977873, 51.679319986377756, 12.072349710020644, 51.79146565961579,
    ],
    '150820241241': [
      12.321587898917212, 51.58198123881251, 12.579271426399329, 51.70448063687005,
    ],
    '150820256256': [
      11.846742369214589, 51.740257557538065, 12.147889567971, 51.880339352024635,
    ],
    '150820301301': [
      12.168584874838018, 51.657435899015134, 12.387153277891368, 51.8001623684671,
    ],
    '150820340340': [
      12.158359605350983, 51.53311158591297, 12.342926549941184, 51.64378312452738,
    ],
    '150820377377': [
      11.838344188088298, 51.642535704815714, 12.196421362471762, 51.78291071962046,
    ],
    '150820430430': [
      11.885336702485528, 51.85870572375638, 12.374916190328777, 52.10432905374769,
    ],
    '150820440440': [
      12.006646273867911, 51.58054431073531, 12.224473508714473, 51.71605285762232,
    ],
    '150830040040': [
      11.53677930057399, 52.17508481738009, 11.712538109488587, 52.236529152860115,
    ],
    '150830270270': [
      11.267880507890265, 52.227400916003, 11.550548474289181, 52.386446625280314,
    ],
    '150830298298': [
      11.28859902124107, 52.11232595224453, 11.569215660421815, 52.28058787172065,
    ],
    '150830390390': [
      11.459010627094154, 52.169598191861546, 11.60481476456167, 52.295857987247125,
    ],
    '150830411411': [
      10.934018552035786, 52.25142613110154, 11.203066386619112, 52.51101199722355,
    ],
    '150830415415': [
      11.130925187626758, 51.95648623799425, 11.410540294375895, 52.11026841981441,
    ],
    '150830490490': [
      11.446178425025312, 51.962088593992156, 11.633156211375237, 52.06971391508762,
    ],
    '150830531531': [
      11.202156550909649, 52.000505755842966, 11.537944941095159, 52.150904525382046,
    ],
    '150830565565': [
      11.58638238087315, 52.203502655245124, 11.734648406273907, 52.2959999783478,
    ],
    '150835051030': [
      11.669439683365269, 52.331896855872856, 11.857471421967784, 52.4155862710444,
    ],
    '150835051120': [
      11.495556313431363, 52.35018861717955, 11.800668190691145, 52.4702217198986,
    ],
    '150835051130': [
      11.520222194178418, 52.28207229669779, 11.673986558907208, 52.39053344940746,
    ],
    '150835051361': [
      11.657301490490577, 52.25850741172307, 11.75829191966551, 52.34430670203397,
    ],
    '150835051440': [
      11.696244800254906, 52.2866672457191, 11.807495666323945, 52.34899067207114,
    ],
    '150835051557': [
      11.402898944651435, 52.26839861572692, 11.568446439333625, 52.397114643293705,
    ],
    '150835051580': [
      11.637911800079412, 52.27322678669151, 11.696288126249447, 52.33669544059541,
    ],
    '150835052020': [
      11.171257292102837, 52.21945243843976, 11.304972376898098, 52.3107043449866,
    ],
    '150835052060': [
      11.055645393934462, 52.22895063220634, 11.104511781734171, 52.26018952631475,
    ],
    '150835052115': [
      11.28599341364492, 52.29538340166705, 11.375018993439117, 52.36965360003689,
    ],
    '150835052125': [
      11.150388070582405, 52.32756588108924, 11.454447860346374, 52.43919914863037,
    ],
    '150835052205': [
      11.09876665868406, 52.1583013144344, 11.323407560739156, 52.2746362492297,
    ],
    '150835052230': [
      11.12437436864099, 52.29442187572227, 11.301564354275268, 52.37865236589204,
    ],
    '150835052323': [
      11.075528489789626, 52.18784140499452, 11.234694061439322, 52.23777266134427,
    ],
    '150835053190': [
      11.159569223720537, 52.10480195147754, 11.367103811585263, 52.1828092171316,
    ],
    '150835053275': [
      11.013699589514582, 52.17200532736312, 11.08804535005748, 52.21854962235277,
    ],
    '150835053320': [
      10.940445515153565, 52.04605632440782, 11.125633156726641, 52.14791335974117,
    ],
    '150835053485': [
      11.04822612678819, 52.14769891989074, 11.14840433143769, 52.210384822852845,
    ],
    '150835053505': [
      11.142743888127594, 52.14245175771378, 11.23423216323889, 52.18784140499452,
    ],
    '150835053515': [
      11.064467239397384, 52.123270833057916, 11.163598920524828, 52.159736237721404,
    ],
    '150835053535': [
      11.12269571268496, 52.167499062046375, 11.208031422372432, 52.204044326909916,
    ],
    '150835054025': [
      11.016134344667094, 52.00000316346148, 11.170794164679533, 52.08358394352862,
    ],
    '150835054035': [
      11.055919294193977, 52.06328656559103, 11.18791969942312, 52.12373820009424,
    ],
    '150835054245': [
      11.150318784583218, 51.89697970698554, 11.287315465243573, 51.99321713831412,
    ],
    '150835054355': [
      11.262287248861607, 51.89949769344917, 11.380626010820965, 51.971854150412284,
    ],
    '150840130130': [
      12.148028278556191, 51.00778855510833, 12.293252971407483, 51.142817928569,
    ],
    '150840235235': [
      12.01473806831148, 51.115913756587474, 12.212107876489192, 51.20520483497863,
    ],
    '150840315315': [
      11.9990923544194, 51.167210080301196, 12.20437939253695, 51.27885669843752,
    ],
    '150840355355': [
      11.64731084253989, 51.072746732667895, 11.868819335204266, 51.20220448814377,
    ],
    '150840490490': [
      11.882701760604617, 51.08209092045733, 12.106277416238298, 51.167210080301196,
    ],
    '150840550550': [
      11.866231130185696, 51.155960631401314, 12.075599310403138, 51.287973546579636,
    ],
    '150840590590': [
      12.046223771651917, 50.97148015639186, 12.282131141204136, 51.12848429421901,
    ],
    '150845051012': [
      11.456597129400283, 51.11851834169407, 11.663454497325112, 51.197921470938404,
    ],
    '150845051015': [
      11.519360667641513, 51.17446901165971, 11.64793397950239, 51.26156884300314,
    ],
    '150845051125': [
      11.463746024549337, 51.10255278787559, 11.611221274866255, 51.15628633340704,
    ],
    '150845051132': [
      11.365391776613416, 51.17963948507425, 11.504152879631457, 51.24623238586681,
    ],
    '150845051133': [
      11.453466029146503, 51.16815115360906, 11.556810024544166, 51.23727096554871,
    ],
    '150845051246': [
      11.401851771614501, 51.225714963497424, 11.536284140067302, 51.29666026026557,
    ],
    '150845051282': [
      11.603994038920677, 51.10018043168039, 11.740154940596634, 51.17825873446335,
    ],
    '150845052115': [
      11.947437127168147, 51.01291224631161, 12.049714548530753, 51.05916246280682,
    ],
    '150845052207': [
      12.072316528034623, 50.96016852928755, 12.169232064723348, 51.04395678786493,
    ],
    '150845052275': [
      12.011831831863173, 51.02604815683855, 12.113779368496939, 51.08834678315369,
    ],
    '150845052442': [
      12.143983989914346, 50.934160299415694, 12.24111967125284, 51.020277221036736,
    ],
    '150845052565': [
      11.968037222803957, 50.968090755823084, 12.10105430413021, 51.03313325241592,
    ],
    '150845053025': [
      11.611410330717407, 51.16531630863267, 11.754233729237285, 51.2153831995919,
    ],
    '150845053135': [
      11.693860369007583, 51.18091867796938, 11.857114491609307, 51.24971295418805,
    ],
    '150845053150': [
      11.667762619020532, 51.2249109835246, 11.788055969413579, 51.283055429868384,
    ],
    '150845053170': [
      11.84183067586936, 51.186078832975326, 11.889517058243213, 51.239206137030976,
    ],
    '150845053250': [
      11.59560313726812, 51.24324059408006, 11.681267946321572, 51.30586072077522,
    ],
    '150845053285': [
      11.601903268212782, 51.190351175782375, 11.716849906275444, 51.264604470735065,
    ],
    '150845053360': [
      11.520250391798934, 51.25103911482367, 11.634850113941177, 51.31973853072069,
    ],
    '150845054013': [
      11.934159151828991, 51.04746859651611, 12.026953464167839, 51.108741885080924,
    ],
    '150845054335': [
      11.8274013911925, 51.052537145486845, 11.921103450963253, 51.130719205809044,
    ],
    '150845054341': [
      11.700646276488472, 51.04215054671669, 11.849538115784709, 51.097113788441554,
    ],
    '150845054375': [
      11.873360704820339, 51.0269999851934, 11.969274765258161, 51.10045541796627,
    ],
    '150845054445': [
      11.83738425718757, 51.13738656975871, 11.916486213288737, 51.18792226600483,
    ],
    '150845054470': [
      11.906308458534573, 51.09836101205299, 11.951234801463759, 51.127948620084325,
    ],
    '150845054560': [
      11.836422870645482, 51.12452449631462, 11.912587092050527, 51.146840120035996,
    ],
    '150850040040': [
      11.139716442430144, 51.66507730906457, 11.31106940394632, 51.79940685669455,
    ],
    '150850055055': [
      10.82917264737078, 51.737312118323, 11.055805983178765, 51.9044932932064,
    ],
    '150850110110': [
      11.205359101914183, 51.63907208336087, 11.408454444195678, 51.7778159090134,
    ],
    '150850135135': [
      10.881778296341967, 51.83086203532676, 11.173549063344776, 51.95585464176029,
    ],
    '150850145145': [
      10.895146440854875, 51.5660129628006, 11.246402951521185, 51.67998080136992,
    ],
    '150850185185': [
      10.841486066557186, 51.94539843933458, 11.101478842911419, 52.05864704055177,
    ],
    '150850190190': [
      10.576389373806897, 51.78946305644842, 10.757895884394394, 51.88703430953728,
    ],
    '150850227227': [
      10.612828583444514, 51.866460117056036, 10.916928602156212, 51.95448027585943,
    ],
    '150850228228': [
      10.625983434028358, 51.61113800348027, 10.95238313212119, 51.795918689337164,
    ],
    '150850230230': [
      10.561475531998028, 51.92145373774139, 10.896292129416503, 52.050102957771,
    ],
    '150850235235': [
      11.055596825026091, 51.668705754894525, 11.253713030643505, 51.84579299105758,
    ],
    '150850330330': [
      10.886739037105444, 51.66106934296636, 11.11497335959658, 51.83843678840652,
    ],
    '150850370370': [
      10.573752958618085, 51.75254788377967, 10.899707161662157, 51.88718822537345,
    ],
    '150855051090': [
      11.148788154108612, 51.80555390137907, 11.239068007811078, 51.86082337536447,
    ],
    '150855051125': [
      11.074165209193845, 51.9130891694008, 11.159721763406585, 51.95330675788768,
    ],
    '150855051140': [
      11.057670073920741, 51.82677133621734, 11.142520019795683, 51.8949683322717,
    ],
    '150855051160': [
      11.231586227408581, 51.83965204255367, 11.30816106659637, 51.89541562014864,
    ],
    '150855051285': [
      11.045450574719474, 51.940056347250604, 11.179354380463343, 52.003361537443844,
    ],
    '150855051287': [
      11.22393858191767, 51.80691124242312, 11.343030306764101, 51.90689924245603,
    ],
    '150855051365': [
      11.122607584441631, 51.84306539455108, 11.272549805941338, 51.927090238076374,
    ],
    '150860005005': [
      11.702922640857713, 52.100642128531874, 11.814641270642426, 52.19446901978341,
    ],
    '150860015015': [
      11.72498636291827, 52.21169376908464, 11.98756651046866, 52.37278439055441,
    ],
    '150860035035': [
      11.915127726350281, 52.292363662917346, 12.098494826532928, 52.46679201310552,
    ],
    '150860040040': [
      12.028156173692285, 52.2225404685372, 12.272508049970575, 52.45960951781202,
    ],
    '150860055055': [
      11.731810600747243, 52.002289771242175, 12.039925920455964, 52.14265120351227,
    ],
    '150860080080': [
      11.95908969384043, 52.305302649242215, 12.330645965670765, 52.57541986812563,
    ],
    '150860140140': [
      11.780533112299898, 52.05913797702228, 12.291995334178832, 52.30673477333071,
    ],
    '150860145145': [
      11.687342720861398, 52.16806267475265, 11.956779129387954, 52.26129719411464,
    ],
    '150870015015': [
      11.317291818819589, 51.34336308244532, 11.504598150728526, 51.56132386696409,
    ],
    '150870031031': [
      11.306619799276396, 51.611384203679485, 11.6126907015203, 51.73010298495615,
    ],
    '150870130130': [
      11.472946577174588, 51.41533362220484, 11.670299022186414, 51.60199747821494,
    ],
    '150870165165': [
      11.511458583818701, 51.564872567614884, 11.764382275274713, 51.66361942470636,
    ],
    '150870220220': [
      11.430261584719304, 51.61682923008207, 11.57104760643594, 51.67996982079291,
    ],
    '150870275275': [
      11.203756380833388, 51.52523725454033, 11.515574215676763, 51.66028552118457,
    ],
    '150870370370': [
      11.075805798245094, 51.412565272102974, 11.385721610869679, 51.59794901684899,
    ],
    '150870386386': [
      11.557315869979332, 51.42247144744202, 11.779610570201566, 51.56885724159823,
    ],
    '150870412412': [
      10.881468820078686, 51.440085460914105, 11.199441247432784, 51.63384984627724,
    ],
    '150875051055': [
      10.96086430312022, 51.43223442845426, 11.045460441289446, 51.492285503473695,
    ],
    '150875051101': [
      11.148570813343545, 51.40562799305301, 11.224867060010698, 51.45247779006115,
    ],
    '150875051125': [
      11.2496287959833, 51.400555658518435, 11.324359043590915, 51.427290523002036,
    ],
    '150875051250': [
      10.977687390985535, 51.40269271963402, 11.17339201627513, 51.4602434523689,
    ],
    '150875051440': [
      11.14339051183165, 51.40126941048391, 11.270205023744039, 51.486650991709276,
    ],
    '150875052010': [
      11.44121581651269, 51.53839271827972, 11.474513407966011, 51.56295338719861,
    ],
    '150875052045': [
      11.444331746000596, 51.5607553590896, 11.497301364060016, 51.5823482581206,
    ],
    '150875052070': [
      11.39776222419489, 51.47991452537804, 11.465733309532187, 51.52857251371112,
    ],
    '150875052075': [
      11.45928515801729, 51.45234618608603, 11.503283152811859, 51.50475975778034,
    ],
    '150875052205': [
      11.466228370428432, 51.535573430698086, 11.523305553404894, 51.574460399536946,
    ],
    '150875052210': [
      11.430443506791493, 51.52163261809946, 11.507680921032412, 51.54376346448593,
    ],
    '150875052260': [
      11.461859441482904, 51.56049490627243, 11.531170206954778, 51.59944782324623,
    ],
    '150875052470': [
      11.446632278016768, 51.502132088975465, 11.520846839893512, 51.53026087047506,
    ],
    '150880020020': [
      12.040907143177613, 51.24839124468269, 12.169474700461413, 51.32040028672166,
    ],
    '150880025025': [
      11.713871192610538, 51.33204637268224, 11.919922758529156, 51.425968147095816,
    ],
    '150880065065': [
      11.817365664378027, 51.235816377874016, 11.977242496773844, 51.344211427067904,
    ],
    '150880150150': [
      12.025082316912298, 51.405511504478376, 12.189013220617488, 51.48461639302507,
    ],
    '150880195195': [
      11.986233765151827, 51.45756255676962, 12.20728881460359, 51.58246191172861,
    ],
    '150880205205': [
      11.970364618687325, 51.274176596242775, 12.196365060743144, 51.37882598368713,
    ],
    '150880216216': [
      11.746109144020522, 51.527733485508, 11.99826148937377, 51.675429965225916,
    ],
    '150880220220': [
      11.899617142854028, 51.29071654627541, 12.039415054198862, 51.38883158097466,
    ],
    '150880235235': [
      11.690249840256806, 51.23506701028842, 11.874297250171152, 51.37151279815407,
    ],
    '150880295295': [
      11.882974605034896, 51.52436773807865, 12.08810916470497, 51.64685222108013,
    ],
    '150880305305': [
      11.413626155685648, 51.275590265975154, 11.648637033943354, 51.416707937608,
    ],
    '150880319319': [
      11.686150980975869, 51.46648619597479, 11.879792376136523, 51.60827811966709,
    ],
    '150880330330': [
      11.904045290121982, 51.33649915904055, 12.181921995978374, 51.4391180451267,
    ],
    '150880365365': [
      11.704621113341283, 51.390027543614934, 11.93100138647933, 51.497912691119254,
    ],
    '150885051030': [
      11.59523419436265, 51.31531251584323, 11.675471350845683, 51.362063764905095,
    ],
    '150885051100': [
      11.52469563406207, 51.40686717053925, 11.64599847314239, 51.46050647066424,
    ],
    '150885051250': [
      11.637373989823628, 51.32021545672368, 11.727357579762053, 51.37772149043101,
    ],
    '150885051265': [
      11.585538952535401, 51.36588503187716, 11.720505470321863, 51.432301587395244,
    ],
    '150885051340': [
      11.61396915713384, 51.418572843935365, 11.678152927967407, 51.45353159945842,
    ],
    '150885051355': [
      11.629038941254755, 51.264896033810125, 11.756593772428786, 51.32899778309676,
    ],
    '150890015015': [
      11.376098412238875, 51.68451926539405, 11.635057743150337, 51.84996501120114,
    ],
    '150890026026': [
      11.7651650614897, 51.83739334324688, 12.017937845158373, 52.02576625395517,
    ],
    '150890030030': [
      11.646957940106365, 51.71804254278969, 11.895474408360585, 51.84684358987207,
    ],
    '150890042042': [
      11.599580666546743, 51.91269551370048, 11.797580807846456, 52.034042870618535,
    ],
    '150890055055': [
      11.706408180948827, 51.863311346274415, 11.848224728712848, 51.943179987117304,
    ],
    '150890175175': [
      11.329705265665394, 51.80998236053678, 11.573507219710168, 51.920192130938155,
    ],
    '150890195195': [
      11.604173751367163, 51.629452217964094, 11.864446177343982, 51.74449532150241,
    ],
    '150890235235': [
      11.658453208235212, 51.7875002186335, 11.883842804963923, 51.88105379514461,
    ],
    '150890305305': [
      11.660964490163432, 51.9759248560543, 11.86213686456045, 52.09315608845876,
    ],
    '150890307307': [
      11.239068007811078, 51.75808231751919, 11.413686827511746, 51.876200908732194,
    ],
    '150890310310': [
      11.496131386099455, 51.80034688709749, 11.738282215075465, 51.953233155830425,
    ],
    '150895051041': [
      11.439527086911676, 51.90661703664571, 11.570277798584032, 51.962755411085446,
    ],
    '150895051043': [
      11.341268163325276, 51.88374626786764, 11.458579857507527, 52.00676514326621,
    ],
    '150895051045': [
      11.519440927282277, 51.93034714046711, 11.60673623893655, 51.96932020512827,
    ],
    '150895051075': [
      11.367913650627226, 51.903083161169484, 11.47685268137165, 51.984536383042396,
    ],
    '150895051365': [
      11.446895760337606, 51.93247475918219, 11.517924836638748, 51.98189361180129,
    ],
    '150895052005': [
      11.617861039275297, 51.65612960329328, 11.732707978596613, 51.732351317776,
    ],
    '150895052130': [
      11.481847092454482, 51.74827501001501, 11.595775453408377, 51.81634261208184,
    ],
    '150895052165': [
      11.549185062202762, 51.74640301436918, 11.652026681650478, 51.82935091251561,
    ],
    '150895052185': [
      11.64106537585088, 51.77290568356583, 11.696755306365302, 51.83566239012833,
    ],
    '150895052245': [
      11.604244645726153, 51.72386991095344, 11.713808227138093, 51.767851792319036,
    ],
    '150900070070': [
      11.40097685333115, 52.52849518653617, 11.794540310387735, 52.7605684212054,
    ],
    '150900225225': [
      12.02278913868405, 52.727451446337845, 12.253644602287212, 52.894024200547314,
    ],
    '150900415415': [
      11.543307121123163, 52.710468977245824, 11.927201263196643, 52.85246210491484,
    ],
    '150900535535': [
      11.568639302408599, 52.484711855796505, 11.97886364391389, 52.70087199362553,
    ],
    '150900546546': [
      11.587453958679006, 52.331896855872856, 12.001390883963369, 52.54324601769554,
    ],
    '150900550550': [
      11.87486159936336, 52.44709311224466, 12.015039907791396, 52.64450565472642,
    ],
    '150905051010': [
      11.9348758511127, 52.64365873896839, 12.041309472326752, 52.74178240643942,
    ],
    '150905051135': [
      11.83753988304906, 52.64890696029402, 11.955100757014241, 52.71525502741349,
    ],
    '150905051180': [
      11.788841173196957, 52.70490373253353, 11.931454349401424, 52.751451972696366,
    ],
    '150905051220': [
      11.865086443522696, 52.62572341241485, 11.982683323380147, 52.66961843440806,
    ],
    '150905051245': [
      11.875442351402244, 52.68710967623049, 12.041309472326752, 52.791791101560854,
    ],
    '150905051270': [
      11.852608624508964, 52.759762376289004, 12.032709936917477, 52.81246178830897,
    ],
    '150905051435': [
      11.677455910963143, 52.67501090244731, 11.852145205784778, 52.73537033831529,
    ],
    '150905051610': [
      11.916175960823077, 52.78976505120569, 12.043394164221924, 52.89029601670519,
    ],
    '150905052285': [
      12.027414076710265, 52.703298151325704, 12.205159256020814, 52.78761133861747,
    ],
    '150905052310': [
      12.014421988850522, 52.6209248370279, 12.150145113041509, 52.7154852908089,
    ],
    '150905052445': [
      12.02278913868405, 52.74985631152131, 12.109312394208752, 52.81849585418464,
    ],
    '150905052485': [
      12.119505514640627, 52.61882643075639, 12.238090726677257, 52.72270448815702,
    ],
    '150905052500': [
      11.987181116358233, 52.55945346645816, 12.173449349483047, 52.63665256088694,
    ],
    '150905052631': [
      11.990471301633756, 52.50080092256025, 12.187699611987838, 52.59741893280904,
    ],
    '150905053003': [
      11.55838672973794, 52.89705022069252, 11.753267742791442, 53.04174621467,
    ],
    '150905053007': [
      11.47036732070059, 52.76918746941027, 11.722615877165213, 52.8960030818883,
    ],
    '150905053008': [
      11.751945601699362, 52.83377949953907, 11.966471190962235, 52.908268985119186,
    ],
    '150905053520': [
      11.68068046645885, 52.839199552946646, 11.87251596984201, 52.988948783760364,
    ],
    '150905053635': [
      11.491612473778261, 52.889262784454075, 11.689086550514583, 53.00702604880452,
    ],
    '150910010010': [
      12.829950346214552, 51.63742596359187, 13.186560087466585, 51.780000803336826,
    ],
    '150910020020': [
      12.610163524645625, 51.61059880146755, 12.84372806817333, 51.77413087809343,
    ],
    '150910060060': [
      12.25604666380708, 51.84711200338693, 12.602365276129637, 52.045237233972834,
    ],
    '150910110110': [
      12.327766699958826, 51.61832141667708, 12.641474605720381, 51.80002737092768,
    ],
    '150910145145': [
      12.776437817372477, 51.7080448903506, 13.1704889007031, 51.93899447262985,
    ],
    '150910160160': [
      12.424703342809918, 51.68597249641329, 12.82485192823811, 51.85540154175016,
    ],
    '150910241241': [
      12.283152073012738, 51.77469866753198, 12.531632337874155, 51.88282147214929,
    ],
    '150910375375': [
      12.486279052818523, 51.81870188166918, 12.77670721514684, 52.012692793330906,
    ],
    '150910391391': [
      12.709744888160024, 51.80938258985478, 12.909276265286266, 51.968076962422806,
    ],
    '160510000000': [
      10.856566623108028, 50.890177158866535, 11.174032813440329, 51.0797306257439,
    ],
    '160520000000': [
      11.997946194547943, 50.79953737424182, 12.172035218829057, 50.977024692948696,
    ],
    '160530000000': [
      11.501904853194981, 50.856424349494496, 11.672613224948723, 50.98897538795991,
    ],
    '160540000000': [
      10.551549793509077, 50.562686071220476, 10.844220275503556, 50.68737722288101,
    ],
    '160550000000': [
      11.236919387511385, 50.91767448031437, 11.40188750317109, 51.03597697256185,
    ],
    '160610045045': [
      10.068701862794658, 51.28512728199413, 10.2161271291461, 51.445114122913225,
    ],
    '160610074074': [
      10.3356449600564, 51.33000291168928, 10.522695980354895, 51.39317435543818,
    ],
    '160610115115': [
      10.222861217406543, 51.33801614222092, 10.420468831086527, 51.487999485279275,
    ],
    '160610116116': [
      10.416963269709344, 51.4529391137757, 10.522959579043789, 51.51710436573658,
    ],
    '160610117117': [
      10.344068781720091, 51.48029970785201, 10.534349706150232, 51.59216663661896,
    ],
    '160610118118': [
      10.224808502777128, 51.2008516115444, 10.481002670695286, 51.36977101452981,
    ],
    '160615001003': [
      10.211675946098946, 51.42530080878195, 10.26420751265676, 51.46947405576773,
    ],
    '160615001015': [
      10.335971652237872, 51.48544203603954, 10.384201575016593, 51.507697785538994,
    ],
    '160615001026': [
      10.299710318369119, 51.49378472231872, 10.359907093404873, 51.52041867551324,
    ],
    '160615001031': [
      10.279993414137865, 51.43843828431783, 10.321898504558733, 51.46411472268165,
    ],
    '160615001094': [
      10.292903007242067, 51.45916695985724, 10.327397183709254, 51.47742021981274,
    ],
    '160615001103': [
      10.274576552275393, 51.474091683359966, 10.357273891285963, 51.49831712149334,
    ],
    '160615001114': [
      10.168779833822894, 51.43713897703538, 10.300762184368985, 51.4878556064163,
    ],
    '160615006017': [
      10.406036195644717, 51.39026919370512, 10.49539624342527, 51.44611121504728,
    ],
    '160615006019': [
      10.471474818368856, 51.41413838079925, 10.52072838915938, 51.45486392889059,
    ],
    '160615006037': [
      10.367681035630627, 51.38169717897343, 10.444499027590673, 51.40278504628751,
    ],
    '160615006044': [
      10.411101159599175, 51.42815262117137, 10.489675540844834, 51.48666030170152,
    ],
    '160615006058': [
      10.367681035630627, 51.39385500178938, 10.418677059941565, 51.41851112936194,
    ],
    '160615008001': [
      9.959576898402256, 51.34213546473494, 9.992735131772806, 51.38022268483741,
    ],
    '160615008014': [
      9.924694571339765, 51.32371691883302, 9.976717661477917, 51.35996848568349,
    ],
    '160615008021': [
      10.023042777332826, 51.37284796395116, 10.078310119127025, 51.3993736252251,
    ],
    '160615008032': [
      10.041022278782727, 51.40843725326966, 10.074841305910942, 51.43577645317125,
    ],
    '160615008033': [
      9.980571018056725, 51.30760023112701, 10.033754425759502, 51.3315733188158,
    ],
    '160615008036': [
      9.955387197981013, 51.32013185402208, 10.011558921209126, 51.35039323675495,
    ],
    '160615008048': [
      9.924694571339765, 51.35149568730624, 9.968463174627457, 51.38186051129253,
    ],
    '160615008057': [
      9.947188875374081, 51.379534190218216, 9.987534968321173, 51.39838200877812,
    ],
    '160615008066': [
      9.94058855123888, 51.30504835903471, 9.974343134896843, 51.329161037375215,
    ],
    '160615008069': [
      9.982662092530825, 51.36762905456087, 10.030761213341268, 51.3893316321207,
    ],
    '160615008078': [
      10.006696736198364, 51.40181367038915, 10.041168645871057, 51.42310164412181,
    ],
    '160615008082': [
      9.985345408427479, 51.38709800935958, 10.037600446271751, 51.40965503499442,
    ],
    '160615008083': [
      10.028973675641655, 51.3970421448161, 10.0712921911265, 51.41311238173394,
    ],
    '160615008102': [
      9.959429054357551, 51.283843310239305, 10.019166181496436, 51.32525572363583,
    ],
    '160615009012': [
      10.162354360072726, 51.372752053391046, 10.243299715023745, 51.41403080644768,
    ],
    '160615009034': [
      10.169506377555223, 51.32563561319874, 10.233568149864746, 51.380411411433045,
    ],
    '160615009047': [
      10.185048156609078, 51.308848437087605, 10.246490173814204, 51.34408088914833,
    ],
    '160615009076': [
      10.171537741172616, 51.404936189606964, 10.223837935615611, 51.44196883305357,
    ],
    '160615009089': [
      10.199678868896898, 51.406452254090816, 10.25974320410557, 51.43585421134625,
    ],
    '160615009107': [
      10.218830863750707, 51.37352456376249, 10.279451577931972, 51.40884047211206,
    ],
    '160615013018': [
      10.270239600353174, 51.23870093620593, 10.319884706548985, 51.26757501904172,
    ],
    '160615013027': [
      10.217748710643265, 51.23028037954968, 10.286744521913581, 51.26062393005697,
    ],
    '160615013041': [
      10.177602804496479, 51.22648519175696, 10.235745571843685, 51.286678322531515,
    ],
    '160615013063': [
      10.247799007698296, 51.254626676690826, 10.312494754888595, 51.294815586927704,
    ],
    '160615013101': [
      10.200390012480344, 51.25408991699878, 10.275408668257425, 51.31169986730553,
    ],
    '160615014023': [
      10.084440228799139, 51.2921560539955, 10.112276767811888, 51.314537265406685,
    ],
    '160615014035': [
      10.09715954367106, 51.19249319881795, 10.207508685298524, 51.24640459174072,
    ],
    '160615014056': [
      10.06788738721094, 51.22205493169017, 10.102827921069252, 51.24401594509604,
    ],
    '160615014062': [
      10.111900672208433, 51.279615627052365, 10.151463823316586, 51.303121420163855,
    ],
    '160615014075': [
      10.075710972039808, 51.23502758996888, 10.12856327684293, 51.25607435142148,
    ],
    '160615014085': [
      10.071451124927089, 51.28211521960767, 10.101790479246853, 51.29965280060455,
    ],
    '160615014086': [
      10.108521312038214, 51.240924216601336, 10.135099572648047, 51.25926148371573,
    ],
    '160615014098': [
      10.045889532411804, 51.24401594509604, 10.118353196913795, 51.27054268077604,
    ],
    '160615014105': [
      10.057394751879096, 51.25926148371573, 10.120931978292536, 51.28422092596238,
    ],
    '160615014113': [
      10.10177676350188, 51.23269690093499, 10.202410539636144, 51.30543993393491,
    ],
    '160615051002': [
      9.984216891198306, 51.277385095766796, 10.071451124927089, 51.30753790324426,
    ],
    '160615051024': [
      9.998921852253913, 51.291820047648805, 10.04639338086132, 51.32526665298811,
    ],
    '160615051119': [
      9.990194304841605, 51.28422092596238, 10.130889412735721, 51.39077308122131,
    ],
    '160620005005': [
      10.635192422288137, 51.540902515777816, 10.777956418168081, 51.645257274438144,
    ],
    '160620041041': [
      10.676158706122424, 51.44085185363999, 10.945294424775476, 51.55171973470247,
    ],
    '160620049049': [
      10.478580700031793, 51.3657503999098, 10.556909062079722, 51.437772992521424,
    ],
    '160620062062': [
      10.472986571235682, 51.487460341409, 10.667390649424917, 51.579801803113,
    ],
    '160620063063': [
      10.59803502966011, 51.44360907226429, 10.78699596306373, 51.55084374858581,
    ],
    '160620065065': [
      10.728725537016363, 51.53316348947053, 10.937147760311444, 51.65026354172053,
    ],
    '160625053008': [
      10.898870822243786, 51.442419765375966, 10.972130514883736, 51.472011329073524,
    ],
    '160625053054': [
      10.870911180019387, 51.45856077265516, 10.97224686908544, 51.52684915767988,
    ],
    '160625053064': [
      10.792148630826292, 51.40271160718221, 10.979252479466693, 51.48213318260571,
    ],
    '160625054009': [
      10.591146364640368, 51.37830003238837, 10.689120566801103, 51.43418590144763,
    ],
    '160625054024': [
      10.566405871734592, 51.459575983282484, 10.641023597260803, 51.48976314975536,
    ],
    '160625054026': [
      10.745411648465948, 51.395850845683455, 10.81615693492749, 51.4491927056604,
    ],
    '160625054033': [
      10.522959579043789, 51.44396861387953, 10.574976986808412, 51.491513596473,
    ],
    '160625054037': [
      10.572959206746338, 51.391789064843884, 10.633824594139204, 51.4356734937228,
    ],
    '160625054066': [
      10.500309045465821, 51.390893822948705, 10.772129957233782, 51.521839523507566,
    ],
    '160630004004': [
      10.242894316918257, 50.76408658063014, 10.337572972677544, 50.81796402705379,
    ],
    '160630076076': [
      10.120322115081303, 51.048098397572936, 10.314352735867415, 51.152841795089486,
    ],
    '160630078078': [
      9.943634208388868, 50.76253329710924, 10.033064426697978, 50.83269239805352,
    ],
    '160630082082': [
      9.990585535280058, 50.755916293649506, 10.087347104741923, 50.88057634119328,
    ],
    '160630092092': [
      10.321899452835984, 50.90958852199506, 10.456685061607226, 50.96554452623597,
    ],
    '160630097097': [
      10.020243305053732, 50.86486739256621, 10.337650850533315, 51.01174840489434,
    ],
    '160630098098': [
      10.375080680236332, 50.894659775719596, 10.61488060743527, 51.084196114360594,
    ],
    '160630099099': [
      10.298433336117292, 50.7779978044463, 10.411182411780208, 50.87050167062596,
    ],
    '160630101101': [
      10.051364387578356, 50.7966470594566, 10.160652763854067, 50.860033433643174,
    ],
    '160630103103': [
      9.951414201231469, 50.876421838428804, 10.184541837495383, 50.96543594506675,
    ],
    '160630105105': [
      10.176672605036725, 50.93101534959424, 10.391232916129967, 51.051732259668626,
    ],
    '160635006006': [
      10.356829562550303, 51.02180564003498, 10.435138266571679, 51.06922823053248,
    ],
    '160635006008': [
      10.329804226036504, 51.03737458599686, 10.418315391209237, 51.07134749097306,
    ],
    '160635006046': [
      10.192405646122939, 50.996613109979045, 10.317257924625668, 51.05132654289651,
    ],
    '160635006049': [
      10.32083600256392, 51.048941870361794, 10.409529726471987, 51.0824390590805,
    ],
    '160635006058': [
      10.301279325505416, 51.092875195088894, 10.3703057174549, 51.13787142141194,
    ],
    '160635006104': [
      10.182008518174653, 51.025861239347904, 10.39377110849008, 51.11516875155161,
    ],
    '160635051003': [
      10.056974587767192, 50.74254795463614, 10.338120736240258, 50.90917991732707,
    ],
    '160635051051': [
      10.157800888291451, 50.787477618416744, 10.208389913420048, 50.824741845713774,
    ],
    '160635056011': [
      9.92125792554019, 50.73570419789216, 10.034441463327827, 50.78290304487688,
    ],
    '160635056032': [
      9.879115551228283, 50.62958268993453, 10.07889346061624, 50.7570774429732,
    ],
    '160635056033': [
      10.032228833956065, 50.68357694125424, 10.068452197185492, 50.70934610624701,
    ],
    '160635056068': [
      9.937745182612879, 50.66357502880581, 10.060312653997926, 50.70999407180222,
    ],
    '160635057066': [
      10.323786062443743, 50.862428019462726, 10.437814634342745, 50.93521859210363,
    ],
    '160635057071': [
      10.40973049319765, 50.90184023339144, 10.442548574090097, 50.92017607128652,
    ],
    '160635059015': [
      10.054390498469036, 50.644484316082874, 10.224234785159164, 50.80955298007088,
    ],
    '160635059023': [
      10.069773648487542, 50.64913683540862, 10.111705603530352, 50.670571149797276,
    ],
    '160635059062': [
      10.041554604107777, 50.71708373392449, 10.095781574458114, 50.75864585082545,
    ],
    '160635059084': [
      10.093135222345143, 50.737288266292445, 10.171585403382768, 50.77952945780243,
    ],
    '160635059086': [
      10.138780502330707, 50.67080838109535, 10.192998439265919, 50.72477739284663,
    ],
    '160640003003': [
      10.516534296845029, 51.031950878027615, 10.764446141032645, 51.184200139143,
    ],
    '160640046046': [
      10.302811335070436, 51.14724939830643, 10.573627848029867, 51.30305238729073,
    ],
    '160640071071': [
      10.310960640537866, 51.21779077666414, 10.641425712821118, 51.34366834436268,
    ],
    '160640074074': [
      10.185124386192237, 51.131060616473604, 10.34443502362661, 51.23117723323366,
    ],
    '160640076076': [
      10.383968351012653, 51.049404529525994, 10.622033712723367, 51.19429110840586,
    ],
    '160645001004': [
      10.791845378995236, 51.129032617679435, 10.879993510577759, 51.182611796507686,
    ],
    '160645001005': [
      10.864871997596325, 51.133171252925074, 10.917287333232562, 51.182611796507686,
    ],
    '160645001007': [
      10.72184928406654, 51.19294633679362, 10.769127981389554, 51.221674519296094,
    ],
    '160645001009': [
      10.749401022102857, 51.169701779128125, 10.81511630269057, 51.19774332272204,
    ],
    '160645001021': [
      10.800468803139253, 51.18021829338062, 10.851566685935833, 51.19907806297761,
    ],
    '160645001027': [
      10.8058340964064, 51.20637030240867, 10.857156647581931, 51.22251132297462,
    ],
    '160645001033': [
      10.67697268306904, 51.16197948356428, 10.757766586967861, 51.21565639894256,
    ],
    '160645001038': [
      10.841943596678545, 51.1802001622916, 10.921538032002422, 51.220321156976475,
    ],
    '160645001045': [
      10.76708253616735, 51.1867569737832, 10.84653791350692, 51.2213150772859,
    ],
    '160645001061': [
      10.685558878835739, 51.14134210233564, 10.746146760995648, 51.16789725973285,
    ],
    '160645001062': [
      10.73458196134674, 51.15522706216377, 10.772107341847528, 51.18783143571661,
    ],
    '160645001064': [
      10.746146760995648, 51.13744077840318, 10.792251691120143, 51.17316933266688,
    ],
    '160645051019': [
      10.740622421894, 51.09303349161328, 10.810145699628784, 51.13981631987528,
    ],
    '160645051022': [
      10.77949057262265, 51.094561775800386, 10.899845229382937, 51.14190427552116,
    ],
    '160645053032': [
      10.367101301018357, 51.09786930679622, 10.46994278602325, 51.13526015670756,
    ],
    '160645053053': [
      10.36056108296716, 51.11881645933224, 10.473306321320289, 51.14778908209023,
    ],
    '160645053075': [
      10.299352215980752, 51.123678114890026, 10.486646015443897, 51.18878106504193,
    ],
    '160645055037': [
      10.543142368846, 51.191514207827844, 10.632499543537543, 51.27031886397574,
    ],
    '160645055043': [
      10.666896004086015, 51.21565639894256, 10.712270992250266, 51.24455942904256,
    ],
    '160645055077': [
      10.545438464198925, 51.15948524188973, 10.712270992250266, 51.302012154344844,
    ],
    '160650003003': [
      11.054653309676537, 51.31077236254575, 11.250983752153196, 51.41399440192151,
    ],
    '160650032032': [
      10.48136023011774, 51.288505883654054, 10.706535783407935, 51.39786651374188,
    ],
    '160650067067': [
      10.620229574456351, 51.283786926668924, 10.948436646026076, 51.42182278955943,
    ],
    '160650085085': [
      10.902294239645366, 51.28979386682496, 11.115710023146027, 51.429537874455555,
    ],
    '160650087087': [
      11.301949954429162, 51.23665150757879, 11.475073045751266, 51.343818543105826,
    ],
    '160650089089': [
      10.78739598353167, 51.19975752834706, 11.007720711099672, 51.311203029036704,
    ],
    '160655002012': [
      10.89252548351588, 51.20542244356013, 10.940933387508757, 51.26188410764522,
    ],
    '160655002048': [
      10.984600683602995, 51.26119399848372, 11.017803721605182, 51.29241118165648,
    ],
    '160655002051': [
      10.98153073407056, 51.270860250204215, 11.037539885308885, 51.32506552442738,
    ],
    '160655002074': [
      10.922550319248803, 51.23878216900596, 10.99744228451135, 51.26999126453203,
    ],
    '160655002075': [
      10.956891648608979, 51.26484262299447, 10.993033681348374, 51.31127842913735,
    ],
    '160655002077': [
      10.86600836909035, 51.241140563788164, 10.923067127760953, 51.26999126453203,
    ],
    '160655002079': [
      10.868419883380286, 51.21813904334709, 10.923067127760953, 51.26188410764522,
    ],
    '160655052001': [
      10.720258254710842, 51.23691765056429, 10.795894728483422, 51.277177023656385,
    ],
    '160655052005': [
      10.772710531881335, 51.26358048159274, 10.81371128511075, 51.284576088714616,
    ],
    '160655052014': [
      10.676664025289417, 51.213447899965644, 10.84441255044138, 51.331877545091004,
    ],
    '160655052018': [
      10.750497510646307, 51.204840494952045, 10.793298272218875, 51.24892298991102,
    ],
    '160655052038': [
      10.641425712821118, 51.278236537261364, 10.716138483418202, 51.303226066996096,
    ],
    '160655052058': [
      10.743199550583924, 51.27055322082417, 10.78075127436213, 51.295697305840946,
    ],
    '160655055008': [
      11.201711224382704, 51.38886403240565, 11.2496287959833, 51.413102473605385,
    ],
    '160655055019': [
      11.282783428617032, 51.288114907677624, 11.345550852712023, 51.338334272131284,
    ],
    '160655055042': [
      11.293434436698206, 51.3247836775365, 11.392705730764717, 51.355930875346964,
    ],
    '160655055046': [
      11.33332234238099, 51.355930875346964, 11.396763569414146, 51.389575636099224,
    ],
    '160655055056': [
      11.247384928398336, 51.31047317789174, 11.300662416496667, 51.35504877043273,
    ],
    '160655055086': [
      11.23877202877981, 51.341764260279184, 11.401693675935562, 51.412565272102974,
    ],
    '160655056016': [
      11.15079188296711, 51.24452854478297, 11.208429433363946, 51.26681348117042,
    ],
    '160655056052': [
      11.215910009374777, 51.25783736670134, 11.314116991548268, 51.29706043295101,
    ],
    '160655056088': [
      11.097132473667253, 51.23468787678527, 11.327668413695063, 51.35211949435063,
    ],
    '160660023023': [
      10.444111997041707, 50.73040668433622, 10.585625770554858, 50.836776031236724,
    ],
    '160660047047': [
      10.649729494601534, 50.66433631946055, 10.753015238741616, 50.738599068192,
    ],
    '160660063063': [
      10.251340446463562, 50.67102837311839, 10.546279806766861, 50.762776713868284,
    ],
    '160660069069': [
      10.516869033379699, 50.63909955342223, 10.710880032193911, 50.737890554516895,
    ],
    '160660074074': [
      10.370221136486643, 50.75645028659314, 10.49526848896148, 50.85114132401152,
    ],
    '160660092092': [
      10.547436114030232, 50.61333265702442, 10.733946022086426, 50.689204651829435,
    ],
    '160660093093': [
      10.175080594303823, 50.4937629488742, 10.343844501847801, 50.59312224189546,
    ],
    '160660094094': [
      10.347299688873623, 50.39474040989719, 10.584226190628076, 50.51264214558915,
    ],
    '160665005012': [
      10.041400563664379, 50.51673894777787, 10.069904024193436, 50.539876677394574,
    ],
    '160665005019': [
      10.083250550828225, 50.54400342182663, 10.184153771654435, 50.59218648841645,
    ],
    '160665005024': [
      10.049391487316443, 50.52857255577297, 10.097882194011836, 50.573070615955956,
    ],
    '160665005052': [
      10.048797502997857, 50.56205353284725, 10.09108111848815, 50.601720504561115,
    ],
    '160665005095': [
      10.035477702124215, 50.54273436259223, 10.258571883457417, 50.67296685927225,
    ],
    '160665013025': [
      10.208292557924363, 50.639593834020516, 10.271291757992465, 50.6695496354016,
    ],
    '160665013041': [
      10.313403102930192, 50.62383254030058, 10.356486589794626, 50.65181954500578,
    ],
    '160665013064': [
      10.227441212565925, 50.6456448017275, 10.406335452467811, 50.71871021410265,
    ],
    '160665013086': [
      10.178601791705141, 50.588029520377056, 10.459071382772901, 50.68660154458144,
    ],
    '160665014005': [
      10.472704532804762, 50.510405775216874, 10.527620202263858, 50.56401487959111,
    ],
    '160665014015': [
      10.440922513842102, 50.637562192140706, 10.536818147972948, 50.68241723822102,
    ],
    '160665014016': [
      10.517484144634306, 50.55581725605562, 10.5824793231623, 50.608887184774645,
    ],
    '160665014017': [
      10.451223045990664, 50.511743600920994, 10.489038348612928, 50.5517401318045,
    ],
    '160665014018': [
      10.43513671323434, 50.54026741488752, 10.488998567160106, 50.5654884946577,
    ],
    '160665014038': [
      10.446997698415093, 50.58565240316604, 10.524520897138064, 50.65201195218486,
    ],
    '160665014039': [
      10.535891069272909, 50.497026089799974, 10.581140162615258, 50.536229876535074,
    ],
    '160665014045': [
      10.438567041335721, 50.48624043178988, 10.504285831022752, 50.51583051451957,
    ],
    '160665014049': [
      10.426986084148886, 50.521102851047104, 10.47245373470401, 50.54441165133749,
    ],
    '160665014057': [
      10.401370311535986, 50.4900983109921, 10.45260613974567, 50.5228744416119,
    ],
    '160665014058': [
      10.457055483408476, 50.5517401318045, 10.527437640655805, 50.59444772300379,
    ],
    '160665014065': [
      10.506538556509836, 50.58367436014839, 10.56576405783854, 50.644387472634925,
    ],
    '160665014079': [
      10.418439962015755, 50.595856889216456, 10.463913747867082, 50.63776697296631,
    ],
    '160665014081': [
      10.503402576714462, 50.50020682246524, 10.567912511833173, 50.55581725605562,
    ],
    '160665050042': [
      10.26743869301521, 50.46310525491851, 10.468608383561808, 50.64964381674268,
    ],
    '160665050056': [
      10.304788002206516, 50.58647453420468, 10.38088532494848, 50.62850086694203,
    ],
    '160665050076': [
      10.37949932865997, 50.504372025800414, 10.432695295097743, 50.54302785724119,
    ],
    '160665051013': [
      10.2030818623819, 50.733781459803645, 10.38259492140727, 50.78838145959046,
    ],
    '160665051022': [
      10.345541786571472, 50.71994854524407, 10.444403434941462, 50.769260709965884,
    ],
    '160665051059': [
      10.224234785159164, 50.70120578746978, 10.284671464869819, 50.73950365872962,
    ],
    '160665051061': [
      10.178601791705141, 50.67197128084666, 10.251189501479853, 50.73671533630466,
    ],
    '160670019019': [
      10.514166334477615, 50.80919180820126, 10.645145749134182, 50.89320208202091,
    ],
    '160670029029': [
      10.622479238607689, 50.8926784082201, 10.781782867662223, 50.991236757848235,
    ],
    '160670064064': [
      10.463928537126764, 50.832653699085206, 10.53826828038192, 50.889908576950646,
    ],
    '160670065065': [
      10.5374211654016, 50.72641399573714, 10.651365955075827, 50.809287507843116,
    ],
    '160670072072': [
      10.400392406391118, 50.84313296593024, 10.618654823928098, 50.921375091453854,
    ],
    '160670087087': [
      10.849972125387698, 50.87769190246641, 10.964647397997096, 50.96527664988593,
    ],
    '160670088088': [
      10.4826691153, 50.90034428000167, 10.648177982903805, 50.986907889319184,
    ],
    '160675007004': [
      10.802968186034347, 51.00069243799431, 10.86358155801181, 51.03614504082283,
    ],
    '160675007016': [
      10.738871331001501, 51.01108738440419, 10.802968186034347, 51.05683503063689,
    ],
    '160675007022': [
      10.75483107041519, 50.960820377898585, 10.798544967941034, 50.99794175602343,
    ],
    '160675007047': [
      10.75900317938984, 50.98536238904776, 10.821051428479231, 51.03614504082283,
    ],
    '160675007052': [
      10.821496039996354, 50.95207497665019, 10.865631824491139, 50.99213374917805,
    ],
    '160675007055': [
      10.796854801346973, 50.95207497665019, 10.837062145373134, 50.99213374917805,
    ],
    '160675007068': [
      10.78175416193974, 50.97946752126133, 10.838788753967808, 51.007334454538416,
    ],
    '160675007071': [
      10.774262220182246, 50.93590652604444, 10.821496039996354, 50.96224773078273,
    ],
    '160675007082': [
      10.837062145373134, 50.97775525064631, 10.891544192264249, 51.00126201839225,
    ],
    '160675012009': [
      10.83224713130631, 51.060840157299545, 10.890960502608461, 51.09815438990084,
    ],
    '160675012011': [
      10.771421356342092, 51.05123689901683, 10.838635660742847, 51.09788411443114,
    ],
    '160675012026': [
      10.802968186034347, 51.0273792691177, 10.872960872765706, 51.060840157299545,
    ],
    '160675012033': [
      10.78372487164269, 51.03614504082283, 10.86354118551696, 51.07343139504623,
    ],
    '160675012067': [
      10.695051608635994, 51.048875365552085, 10.781063560481492, 51.11337451957239,
    ],
    '160675050044': [
      10.658833424958305, 50.71493793736757, 10.74849991543802, 50.803218981431264,
    ],
    '160675050053': [
      10.630721540980296, 50.71603183661126, 10.858254410953728, 50.864496147944806,
    ],
    '160675052059': [
      10.707325874766704, 50.8576776740638, 10.749332848581052, 50.907783034075464,
    ],
    '160675052089': [
      10.735598473665332, 50.84189578714561, 10.877412941686003, 50.95263334837516,
    ],
    '160675053063': [
      10.549101062743544, 50.96995904932805, 10.631305365226208, 51.00819519966303,
    ],
    '160675053091': [
      10.481691763602807, 50.96705247824352, 10.766060743157166, 51.05291931071218,
    ],
    '160675054013': [
      10.659521563139036, 50.8643228154982, 10.725243295381976, 50.907783034075464,
    ],
    '160675054092': [
      10.54209042778285, 50.793060850882426, 10.744749773478398, 50.924750667472615,
    ],
    '160680034034': [
      11.188848643504858, 51.14989846607689, 11.390635106531894, 51.290449990655354,
    ],
    '160680051051': [
      11.043497359365457, 51.1222429061629, 11.237947643625613, 51.246137630643496,
    ],
    '160680058058': [
      10.974702694577303, 51.171897583877225, 11.143478320029892, 51.244739186981825,
    ],
    '160680063063': [
      11.251560896598575, 51.08941037651882, 11.484755252932466, 51.19247248227439,
    ],
    '160685002002': [
      10.887133750598588, 51.071881875883605, 10.948823458727022, 51.09717551293792,
    ],
    '160685002014': [
      10.876144329858686, 51.08459919389781, 10.954933768299897, 51.14234037288331,
    ],
    '160685002045': [
      10.948823458727022, 51.08636475507298, 10.980872125646787, 51.12625857484111,
    ],
    '160685002057': [
      10.86354118551696, 51.04872941070429, 10.975735705356579, 51.09717551293792,
    ],
    '160685005005': [
      11.13563662946982, 51.22620858661964, 11.187172403731767, 51.25404150207657,
    ],
    '160685005015': [
      11.125276657908996, 51.21716584939528, 11.172050165388615, 51.2407898895557,
    ],
    '160685005022': [
      11.04049697439192, 51.21068868496283, 11.105889672299403, 51.24666995186892,
    ],
    '160685005064': [
      10.992613639660304, 51.22046679150936, 11.162209769935945, 51.32316899143649,
    ],
    '160685006019': [
      11.226446299161346, 51.14759239849255, 11.325000539226949, 51.1788312231524,
    ],
    '160685006033': [
      11.237947643625613, 51.12897296738775, 11.30122443744612, 51.15546387959528,
    ],
    '160685006041': [
      11.300877578719087, 51.175803934650304, 11.381915194770404, 51.238924021237594,
    ],
    '160685006042': [
      11.340456850966742, 51.15566672258628, 11.452798920769071, 51.219396841566294,
    ],
    '160685009013': [
      10.90760681753786, 51.173933903054, 11.004450519026872, 51.20550727360269,
    ],
    '160685009025': [
      10.963481891582255, 51.09767476814793, 11.04605179914558, 51.137242263966414,
    ],
    '160685009044': [
      10.963111679094352, 51.065052901404854, 11.036614781504557, 51.10353327490379,
    ],
    '160685009049': [
      10.90713943300939, 51.13404197795651, 10.960255628236263, 51.1802001622916,
    ],
    '160685009053': [
      10.944640752803414, 51.124782408087796, 11.023934669433906, 51.184319577400075,
    ],
    '160685009059': [
      10.98817679642631, 51.118891687776994, 11.064152768740527, 51.15184957177856,
    ],
    '160685009062': [
      11.019528604889986, 51.141395401847, 11.062811659692628, 51.17712697129777,
    ],
    '160685012001': [
      11.030617985078536, 51.07922297126533, 11.078653945594176, 51.116251130786395,
    ],
    '160685012007': [
      11.130838802355525, 51.054794219836765, 11.175220020016582, 51.093563765511675,
    ],
    '160685012017': [
      11.134510692477935, 51.01757058482449, 11.17593112132147, 51.04002112312334,
    ],
    '160685012021': [
      11.04277713506208, 51.064665599576486, 11.132321844600073, 51.12996897063046,
    ],
    '160685012032': [
      11.107624006753934, 51.008765666080244, 11.147734350146777, 51.03758882407826,
    ],
    '160685012036': [
      11.153558864962838, 51.05405801777909, 11.201944825309479, 51.10176147133654,
    ],
    '160685012037': [
      10.990864079787455, 51.0590358332563, 11.041192162379403, 51.08435891947217,
    ],
    '160685012039': [
      11.16056832845328, 51.02421777228521, 11.217540210783337, 51.05752936558917,
    ],
    '160685012048': [
      11.092892504593136, 51.08037024787617, 11.196841844472045, 51.133135280041856,
    ],
    '160685012052': [
      11.174052759820924, 51.10176147133654, 11.215232365482123, 51.13507447269615,
    ],
    '160685012055': [
      11.087021254939676, 51.033375773238355, 11.169850202552407, 51.076451778896256,
    ],
    '160685012056': [
      11.203809840976712, 51.10377147288649, 11.257526613133807, 51.14803088994859,
    ],
    '160685050009': [
      10.909892564146498, 51.03133483263353, 10.98538023301876, 51.065052901404854,
    ],
    '160685050061': [
      10.862050169920675, 51.015133357128164, 10.93296842294647, 51.05998674214961,
    ],
    '160690012012': [
      10.830278042551887, 50.38058110648575, 11.04164544006014, 50.49389191443335,
    ],
    '160690024024': [
      10.640189207655714, 50.39445925325405, 10.82938441301621, 50.47986947288437,
    ],
    '160690042042': [
      10.814364328700853, 50.48331680074032, 10.945101235869373, 50.609323753065794,
    ],
    '160690043043': [
      10.671378223407642, 50.47265297884642, 10.861625655104238, 50.61498659064286,
    ],
    '160690053053': [
      10.751569599558946, 50.37969625662834, 10.874265598962314, 50.44002225622372,
    ],
    '160690061061': [
      10.883321094582804, 50.48381728234904, 11.001509551451603, 50.553220904309924,
    ],
    '160690062062': [
      10.45185472686466, 50.33409165421119, 10.67832169841232, 50.452862736838235,
    ],
    '160695002001': [
      10.672849379604038, 50.518888677622215, 10.696730473254657, 50.536365383061685,
    ],
    '160695002003': [
      10.569791730502544, 50.46593124293049, 10.62353828651449, 50.488077754779624,
    ],
    '160695002004': [
      10.652930810091778, 50.52982097471925, 10.700550907299165, 50.55830906959496,
    ],
    '160695002008': [
      10.57434140090964, 50.413141441958196, 10.626399585251665, 50.444999527206114,
    ],
    '160695002009': [
      10.650009939364246, 50.47624567753926, 10.66919756290684, 50.49017353037158,
    ],
    '160695002011': [
      10.636062438680186, 50.53817188526631, 10.672282762400762, 50.56371717518296,
    ],
    '160695002016': [
      10.617101467815285, 50.469339551156786, 10.654341957202309, 50.49069465394237,
    ],
    '160695002017': [
      10.618893418511764, 50.539263725554854, 10.65604873774724, 50.56459249860374,
    ],
    '160695002021': [
      10.563663891165286, 50.49536261040544, 10.615007902228328, 50.53566480308338,
    ],
    '160695002025': [
      10.635480471085371, 50.460839262165905, 10.749642343818605, 50.5222568633667,
    ],
    '160695002026': [
      10.631438026041117, 50.50777467107759, 10.676886222941034, 50.539263725554854,
    ],
    '160695002028': [
      10.527620202263858, 50.53451636681276, 10.590581129081473, 50.57611373294053,
    ],
    '160695002035': [
      10.590028355085792, 50.53098656422907, 10.65604873774724, 50.58146512703338,
    ],
    '160695002037': [
      10.61199732559571, 50.428226244656514, 10.676880288412105, 50.477949082935474,
    ],
    '160695002044': [
      10.571478476959372, 50.56411618855566, 10.611983114855455, 50.58760202901268,
    ],
    '160695002047': [
      10.569791730502544, 50.44455684895397, 10.622436234978121, 50.473997550858556,
    ],
    '160695002051': [
      10.550894566322267, 50.473997550858556, 10.653181489275834, 50.54174748160199,
    ],
    '160695004041': [
      10.594099089270767, 50.31768126500892, 10.63888836917609, 50.33586188061652,
    ],
    '160695004046': [
      10.601104873090936, 50.223232614091465, 10.663919479080013, 50.25039738822841,
    ],
    '160695004049': [
      10.580447818291182, 50.313103202538535, 10.786136711500781, 50.40855439643962,
    ],
    '160695004052': [
      10.7764318987272, 50.23782719656222, 10.851998574620998, 50.27802513398347,
    ],
    '160695004056': [
      10.613980082518086, 50.29436534828743, 10.694729227905972, 50.345145366995354,
    ],
    '160695004063': [
      10.59099833302694, 50.20423304355374, 10.817125476146828, 50.3276022464014,
    ],
    '160695051006': [
      10.821857811556255, 50.43739962813921, 10.870241078700037, 50.46139081783051,
    ],
    '160695051058': [
      10.769779324599602, 50.43508751789963, 10.906307483507037, 50.50458622035662,
    ],
    '160700004004': [
      10.87166704693418, 50.72793740952425, 11.051947135887927, 50.87580298217944,
    ],
    '160700028028': [
      10.827959028262564, 50.817403981234314, 11.113513075668987, 50.91461248478553,
    ],
    '160700029029': [
      10.82124681501353, 50.5631430058436, 11.066008738130071, 50.74933664567905,
    ],
    '160700048048': [
      10.98139492518681, 50.69460348070977, 11.223884825548188, 50.82057077872273,
    ],
    '160700057057': [
      10.743912292017939, 50.67648989203326, 10.877396022653551, 50.82340651941054,
    ],
    '160700058058': [
      10.894115525397655, 50.54724321627842, 11.087288531957501, 50.64438384023071,
    ],
    '160705002011': [
      10.807894585548535, 50.662870432762645, 10.872398119839177, 50.71528629707135,
    ],
    '160705002034': [
      10.840184232449719, 50.702328011172916, 10.911228914883392, 50.7523093136695,
    ],
    '160705002043': [
      10.857362488834683, 50.734759170366516, 10.93670128620296, 50.794552481835225,
    ],
    '160705009001': [
      11.01445691016628, 50.83394444579099, 11.07348883125721, 50.85971769953827,
    ],
    '160705009006': [
      11.038087853306894, 50.79200613157201, 11.105286735283167, 50.839841579555056,
    ],
    '160705009008': [
      10.96926970829228, 50.823737739151895, 11.017400271756886, 50.85853272827624,
    ],
    '160705009012': [
      11.067936475904832, 50.85269243480642, 11.164294231277959, 50.90399123946634,
    ],
    '160705009013': [
      11.023962286579414, 50.85282088458418, 11.079711743665898, 50.88442588728226,
    ],
    '160705009041': [
      11.07143234084902, 50.83577927406023, 11.178473251529335, 50.86886882704352,
    ],
    '160705009054': [
      11.086782048024675, 50.797794720478755, 11.166845163502355, 50.8456135260389,
    ],
    '160710001001': [
      11.434449099702942, 50.98492049889772, 11.584734822426896, 51.07429959299318,
    ],
    '160710003003': [
      11.174341130638906, 50.82926659588201, 11.328471767215282, 50.93848346116743,
    ],
    '160710008008': [
      11.249465272203487, 50.79321349891479, 11.462837932501857, 50.89788176439408,
    ],
    '160710101101': [
      11.34591025451171, 50.98542808748743, 11.527567510582712, 51.10928201636822,
    ],
    '160710103103': [
      11.132672686970519, 50.91267251028191, 11.286118270193647, 51.03254927297935,
    ],
    '160715007032': [
      11.124696768610718, 50.87177700097206, 11.186807582625313, 50.89731470187205,
    ],
    '160715007043': [
      11.105060145210576, 50.89247642074204, 11.188927315246572, 50.93017593024288,
    ],
    '160715007046': [
      11.155962020615435, 50.81776508652182, 11.23828817381411, 50.874849370028784,
    ],
    '160715007059': [
      11.16353715143181, 50.88190023908387, 11.19473861919164, 50.9037110533482,
    ],
    '160715007079': [
      11.196121575909402, 50.80525199072521, 11.25726518893399, 50.82949434815969,
    ],
    '160715007087': [
      11.177222506926686, 50.864349522763156, 11.24644999731324, 50.91335388005949,
    ],
    '160715008009': [
      11.31745547081168, 50.89224250973491, 11.358736204924364, 50.92794201994008,
    ],
    '160715008013': [
      11.454246972314833, 50.9018848899512, 11.508957558755265, 50.93216071725104,
    ],
    '160715008019': [
      11.428738617470675, 50.96118346722568, 11.464991330777815, 50.97574389358971,
    ],
    '160715008025': [
      11.463951723482614, 50.91840801415738, 11.537023942635289, 50.969381938628636,
    ],
    '160715008027': [
      11.428738617470675, 50.943737839148724, 11.468803935928204, 50.96177854117397,
    ],
    '160715008031': [
      11.290967287147183, 50.90590161009385, 11.3257194498965, 50.91950931040193,
    ],
    '160715008037': [
      11.433606902115923, 50.966018088038254, 11.484815347156582, 50.99165868104147,
    ],
    '160715008038': [
      11.355687267775565, 50.89224250973491, 11.394826407496451, 50.91813819736999,
    ],
    '160715008042': [
      11.44446206171882, 50.920129803202634, 11.47692629693439, 50.945286091963965,
    ],
    '160715008049': [
      11.415146366119005, 50.922684171589516, 11.454470103701963, 50.96275710884808,
    ],
    '160715008053': [
      11.401373421274565, 50.878296142654655, 11.497178249680944, 50.9284975010937,
    ],
    '160715008055': [
      11.373749179007818, 50.89759056485894, 11.402233907560083, 50.92241717560627,
    ],
    '160715008056': [
      11.350918266841289, 50.91738475662156, 11.424233895705502, 50.96420853981206,
    ],
    '160715008071': [
      11.341197440544247, 50.910526259004065, 11.378570962116157, 50.93217015324112,
    ],
    '160715008089': [
      11.388698204488849, 50.96118346722568, 11.436812752447254, 50.99272414710601,
    ],
    '160715008093': [
      11.326294807117701, 50.92672518683595, 11.354998382743462, 50.94306853647067,
    ],
    '160715008095': [
      11.410982476347767, 50.978247814025536, 11.455236417700654, 50.997494779111435,
    ],
    '160715051004': [
      11.47660608670019, 50.965161461460646, 11.685655508296673, 51.11789938802362,
    ],
    '160715051015': [
      11.55855577062515, 51.06915923985579, 11.602748406983283, 51.089725494466855,
    ],
    '160715051022': [
      11.645900304953997, 51.08348359721441, 11.698456340972877, 51.110828321593296,
    ],
    '160715051064': [
      11.56922735669846, 51.05193552999591, 11.628956844088002, 51.089725494466855,
    ],
    '160715051069': [
      11.555974131934024, 51.04422392792207, 11.595150678506178, 51.06915923985579,
    ],
    '160715051083': [
      11.625015106957052, 51.05255808062595, 11.686855961854668, 51.08954261012768,
    ],
    '160715053005': [
      11.197763375739228, 51.044359615387826, 11.229069626236194, 51.06517064729721,
    ],
    '160715053017': [
      11.258867099605, 51.02574516288966, 11.294292549725986, 51.04384621212784,
    ],
    '160715053061': [
      11.227799352053344, 51.07217151645689, 11.270947158002997, 51.10660271441281,
    ],
    '160715053102': [
      11.192942298869594, 51.01959773739282, 11.394747713361086, 51.104731783250585,
    ],
    '160720011011': [
      11.115217641236145, 50.451332293077186, 11.206528017033541, 50.50589423026942,
    ],
    '160720015015': [
      10.941505442477512, 50.34747895362094, 11.04305473204585, 50.444713572493065,
    ],
    '160720018018': [
      11.115747732629087, 50.32045107394968, 11.284616655056118, 50.50747770326753,
    ],
    '160720019019': [
      11.109781742671169, 50.39958181207942, 11.197118642641701, 50.47533909796184,
    ],
    '160720023023': [
      11.024961126087218, 50.34438091888132, 11.155877770835836, 50.44155156571683,
    ],
    '160720024024': [
      11.13309465225901, 50.26747881459365, 11.283672375144446, 50.45585828298435,
    ],
    '160725051006': [
      10.974525811107846, 50.4799130488557, 11.069525501502659, 50.5313850542676,
    ],
    '160725051013': [
      11.003847916088004, 50.42535806916125, 11.235417271229876, 50.568570925705735,
    ],
    '160730005005': [
      11.184337912497634, 50.6370727793424, 11.31317018045272, 50.71264263066964,
    ],
    '160730076076': [
      11.174811226481108, 50.66828417937652, 11.376434728388205, 50.834335057455064,
    ],
    '160730077077': [
      11.192779918780518, 50.52614109076576, 11.423821837873486, 50.68038784399733,
    ],
    '160730106106': [
      11.384973268876285, 50.52291744572883, 11.553629066846264, 50.602902478982614,
    ],
    '160730109109': [
      11.312950631314063, 50.6857349056526, 11.549349952223498, 50.81829408494441,
    ],
    '160730111111': [
      11.354078858165954, 50.61130610895959, 11.519355000143923, 50.71035690992098,
    ],
    '160735005028': [
      11.223119058271909, 50.48038939862121, 11.346199694450931, 50.54572955210321,
    ],
    '160735005046': [
      11.419068580988133, 50.42844667427894, 11.498273921975754, 50.51402529171335,
    ],
    '160735005067': [
      11.280724643232745, 50.495870304319006, 11.482263771596335, 50.61538549822472,
    ],
    '160735012013': [
      11.089994808854058, 50.530593882378746, 11.16135761255808, 50.58012679728683,
    ],
    '160735012014': [
      11.132732975011491, 50.55108966916941, 11.176691548890803, 50.58384942851878,
    ],
    '160735012017': [
      11.186750787315011, 50.60564992070336, 11.256317620732567, 50.624373446789285,
    ],
    '160735012037': [
      10.96698946058705, 50.51018391663455, 11.107722199067599, 50.56482375584017,
    ],
    '160735012055': [
      11.165491407403007, 50.56253038860408, 11.233405217958383, 50.597681039649494,
    ],
    '160735012074': [
      11.184478783074047, 50.59346336136276, 11.226453166730405, 50.611732176384734,
    ],
    '160735012082': [
      11.163304656423353, 50.62066659867453, 11.259624595266642, 50.66868304571567,
    ],
    '160735012084': [
      11.151233991006078, 50.62530190537215, 11.183798291779214, 50.64002753844343,
    ],
    '160735012094': [
      11.123965511782487, 50.58384942851878, 11.196043302228464, 50.63158854569285,
    ],
    '160735012113': [
      11.06315403832687, 50.55413596552275, 11.176691548890803, 50.615972341769364,
    ],
    '160735051002': [
      11.579403452092158, 50.58049306666705, 11.633675570954635, 50.61136051396961,
    ],
    '160735051035': [
      11.459470644473262, 50.594662295908854, 11.516072857659113, 50.62218089337428,
    ],
    '160735051038': [
      11.375775648323232, 50.578694751324136, 11.475357740425329, 50.643765281128545,
    ],
    '160735051107': [
      11.51250686098942, 50.547042588325816, 11.617260912450611, 50.62079419130081,
    ],
    '160735054001': [
      11.120524100199592, 50.63879027004512, 11.172588573525957, 50.67491994235497,
    ],
    '160735054006': [
      11.159158362611352, 50.65102958755988, 11.193666369023733, 50.67491994235497,
    ],
    '160735054112': [
      11.011301799110168, 50.60579473686759, 11.223878644222449, 50.73667316154423,
    ],
    '160740044044': [
      11.560677835554264, 50.78776108260793, 11.610185152424256, 50.824091438981014,
    ],
    '160745005012': [
      11.953440680780712, 50.96240150945127, 12.01739316329494, 50.991609258488836,
    ],
    '160745005038': [
      11.962589432138712, 50.949925414788716, 11.987975743166773, 50.96676181703001,
    ],
    '160745005039': [
      11.841336709115504, 50.96293429969997, 11.979876979393984, 51.03742861534804,
    ],
    '160745005072': [
      11.93148303055198, 50.94627914939191, 11.964959050913778, 50.96419123174339,
    ],
    '160745005092': [
      11.924695146450858, 50.92254201663897, 12.020848287598806, 50.968090755823084,
    ],
    '160745005106': [
      11.925800429339846, 51.00128115955296, 11.971818178648459, 51.032474505911004,
    ],
    '160745005116': [
      11.737304748045489, 50.96851369873436, 11.916205766513254, 51.0577331025286,
    ],
    '160745007007': [
      11.743047900514744, 50.78168262189576, 11.783142027808859, 50.80851597371201,
    ],
    '160745007017': [
      11.8449170005509, 50.82022960978906, 11.883769131438461, 50.85217202730265,
    ],
    '160745007022': [
      11.693236209748209, 50.806143414546845, 11.730248321619303, 50.84177935071074,
    ],
    '160745007024': [
      11.657771406551479, 50.81208919921839, 11.70385261916625, 50.84479271841926,
    ],
    '160745007029': [
      11.633063881755756, 50.834357878555124, 11.681443446967892, 50.85575707578648,
    ],
    '160745007045': [
      11.781823066911167, 50.785021390355524, 11.826252461937022, 50.806226284427076,
    ],
    '160745007046': [
      11.624422366580989, 50.830759958451324, 11.657771406551479, 50.85214853847946,
    ],
    '160745007047': [
      11.816996894470893, 50.805354436492905, 11.858951574054743, 50.823931759469254,
    ],
    '160745007053': [
      11.76004877428472, 50.815214562024785, 11.822171134697854, 50.85676178027815,
    ],
    '160745007056': [
      11.706637696917117, 50.79753363547167, 11.748856656401385, 50.82945379869778,
    ],
    '160745007064': [
      11.631419921006747, 50.785140615566725, 11.681879828273006, 50.820146571564024,
    ],
    '160745007066': [
      11.816784311980642, 50.815214562024785, 11.847068523136187, 50.84487047051671,
    ],
    '160745007071': [
      11.745017276814144, 50.80513151206173, 11.777487218204977, 50.82445007717037,
    ],
    '160745007074': [
      11.665124592871832, 50.84100786802068, 11.698968812713321, 50.864964301810325,
    ],
    '160745007077': [
      11.824165987357542, 50.78480572897813, 11.902885433321991, 50.82136901807868,
    ],
    '160745007097': [
      11.877567212975837, 50.80869188416886, 11.90978509430457, 50.85217202730265,
    ],
    '160745007101': [
      11.732097497063874, 50.839423289121285, 11.792554401646777, 50.85607026990391,
    ],
    '160745007102': [
      11.651717047069097, 50.76251574481321, 11.724414596814816, 50.81603361363416,
    ],
    '160745007103': [
      11.716402227899518, 50.826452380090686, 11.742968446177638, 50.849034807249296,
    ],
    '160745007107': [
      11.730248321619303, 50.81290759471054, 11.76482072473204, 50.83985230973336,
    ],
    '160745007108': [
      11.77461556820161, 50.7976193962446, 11.826252461937022, 50.82208173257216,
    ],
    '160745011002': [
      11.484162952995534, 50.817247539318345, 11.59025957421472, 50.856424349494496,
    ],
    '160745011004': [
      11.535591087106587, 50.79693143438897, 11.56576473275185, 50.822549589352285,
    ],
    '160745011008': [
      11.460898455194164, 50.86343840778578, 11.562447303574405, 50.90692761768959,
    ],
    '160745011016': [
      11.455945108405746, 50.77716241216075, 11.545530795894855, 50.80409569967402,
    ],
    '160745011021': [
      11.530001151172664, 50.75049715266691, 11.580514436004318, 50.775851715663975,
    ],
    '160745011031': [
      11.536398441967812, 50.775851715663975, 11.571033510950802, 50.79755143766689,
    ],
    '160745011033': [
      11.58348766256857, 50.81028748406315, 11.625248898036883, 50.82842157875348,
    ],
    '160745011034': [
      11.479403523165496, 50.79997075497875, 11.53825083434901, 50.822549589352285,
    ],
    '160745011042': [
      11.57920402583965, 50.74646307894636, 11.683802852843575, 50.79033496275426,
    ],
    '160745011048': [
      11.559498040610702, 50.76604518160596, 11.601807791644276, 50.79353042534135,
    ],
    '160745011049': [
      11.652910948775663, 50.85575707578648, 11.682602196983208, 50.88424929195493,
    ],
    '160745011052': [
      11.585197828476504, 50.782624212557465, 11.64317820517257, 50.797310676967,
    ],
    '160745011057': [
      11.438506792429497, 50.83171509172923, 11.556005407123736, 50.869701757799085,
    ],
    '160745011065': [
      11.486013098666474, 50.7657828948107, 11.559498040610702, 50.78580823275566,
    ],
    '160745011076': [
      11.423971585414028, 50.79343679778146, 11.512605254373227, 50.83577481309554,
    ],
    '160745011079': [
      11.556005407123736, 50.830759958451324, 11.633796664820723, 50.86369332925653,
    ],
    '160745011087': [
      11.586895622118414, 50.812483957152395, 11.636860871504002, 50.84350389902664,
    ],
    '160745011089': [
      11.598061571441201, 50.79529680061628, 11.636860871504002, 50.81314705905562,
    ],
    '160745011095': [
      11.61040804193981, 50.85214853847946, 11.644358904489978, 50.87678525879148,
    ],
    '160745011104': [
      11.633796664820723, 50.80934879462371, 11.67278167531535, 50.834357878555124,
    ],
    '160745011114': [
      11.629727663697736, 50.85214853847946, 11.665124592871832, 50.88323104870009,
    ],
    '160745014041': [
      11.827887995372576, 50.87114721636787, 11.884105254377216, 50.90965675099253,
    ],
    '160745014059': [
      11.785116677861776, 50.844995177717266, 11.84063804441689, 50.8775812466952,
    ],
    '160745014075': [
      11.855020413172124, 50.86011972939877, 11.897637421502676, 50.8811294480612,
    ],
    '160745014084': [
      11.81052401715216, 50.866714131868896, 11.857038601937138, 50.8976520414791,
    ],
    '160745014093': [
      11.80860822182999, 50.832576629692404, 11.920630331747581, 50.867057523542286,
    ],
    '160745015011': [
      11.622290033509904, 50.98829680017871, 11.753192559222235, 51.087610310872776,
    ],
    '160745015019': [
      11.698720615309497, 50.99629870645782, 11.762225138011562, 51.049755557377416,
    ],
    '160745015026': [
      11.646457211682781, 50.94931995701225, 11.694604222842706, 50.989602242870994,
    ],
    '160745015032': [
      11.665996142254011, 50.910034228447785, 11.706097806121033, 50.93862193395931,
    ],
    '160745015036': [
      11.576779853811841, 50.98684931793823, 11.644910334134877, 51.00815012833583,
    ],
    '160745015043': [
      11.665996142254011, 50.93364189802568, 11.70428137970909, 50.95674825646672,
    ],
    '160745015051': [
      11.547419959893888, 50.96612900160758, 11.635092084259995, 51.00023461304305,
    ],
    '160745015054': [
      11.682213435504828, 50.95449285377433, 11.728089377335003, 50.97288071435611,
    ],
    '160745015063': [
      11.617028642802742, 50.96571135225671, 11.66971961443484, 50.99299083573576,
    ],
    '160745015096': [
      11.678711496875936, 50.966205508034, 11.753649821686784, 50.99976432390254,
    ],
    '160745015099': [
      11.751664104152498, 51.022717010398786, 11.777570784585889, 51.04326414875816,
    ],
    '160745015112': [
      11.67523587194523, 51.01708201044413, 11.711495279223175, 51.04509748454003,
    ],
    '160745015113': [
      11.60176871295317, 50.98897586014159, 11.658398174058899, 51.020401557868055,
    ],
    '160745050058': [
      11.760975797529602, 50.84135852149041, 11.815194940002534, 50.8660015360923,
    ],
    '160745050081': [
      11.712773710229913, 50.87039185865481, 11.768965175890886, 50.89720439885846,
    ],
    '160745050094': [
      11.682453428265154, 50.84100786802068, 11.816460669278822, 50.88737896089801,
    ],
    '160745051009': [
      11.69171859080537, 50.90865551854969, 11.81717345923019, 50.97418369482639,
    ],
    '160745051028': [
      11.70428137970909, 50.94698840494362, 11.74019729454212, 50.97262115420544,
    ],
    '160745051061': [
      11.715924065494677, 50.9376112930819, 11.74501587882817, 50.947853749233296,
    ],
    '160745051068': [
      11.732687318050678, 50.946195812124074, 11.764044450092797, 50.972676861203944,
    ],
    '160745052018': [
      11.84773021614805, 50.93432328998538, 11.932907425846716, 50.98825307734417,
    ],
    '160745052025': [
      11.86517933456578, 50.98195577222878, 11.901995963221049, 50.999985208734785,
    ],
    '160745052037': [
      11.825570380217387, 50.936953022827005, 11.854795987320285, 50.97401377743672,
    ],
    '160745052055': [
      11.772842220139271, 50.97835587444177, 11.80475582207335, 51.00211936119581,
    ],
    '160745052067': [
      11.80658727941374, 50.96178302927611, 11.87845622370905, 50.99762857330702,
    ],
    '160745052073': [
      11.772842220139271, 50.95910957881602, 11.836415165505104, 50.99397055910162,
    ],
    '160745053001': [
      11.757427149493228, 50.89362812834979, 11.785822106558262, 50.909175446123854,
    ],
    '160745053003': [
      11.811010160233636, 50.89143731934387, 11.91862911350585, 50.928880026557266,
    ],
    '160745053005': [
      11.765480479912938, 50.885584426401756, 11.827887995372576, 50.91325414786384,
    ],
    '160745053082': [
      11.742030264959405, 50.895731250243124, 11.758512181230333, 50.91167160646903,
    ],
    '160745053085': [
      11.646496414004815, 50.87410980951639, 11.723220510138276, 50.91910928136092,
    ],
    '160745053086': [
      11.706097806121033, 50.89261731154683, 11.74445250843638, 50.92938826753598,
    ],
    '160745053091': [
      11.794373359830054, 50.928880026557266, 11.849473690972083, 50.9595084013881,
    ],
    '160745053098': [
      11.893368988714805, 50.90460844174555, 11.955352940748398, 50.95127432005024,
    ],
    '160745053105': [
      11.762128207156513, 50.906822215128166, 11.829705995425433, 50.93504401218021,
    ],
    '160745053109': [
      11.829705995425433, 50.907643121696104, 11.91135155169379, 50.942226801279716,
    ],
    '160750046046': [
      11.75126387727572, 50.389753176670936, 11.876426087604742, 50.44547234435657,
    ],
    '160750062062': [
      11.554517910135209, 50.40743117399262, 11.736635661072674, 50.49486546868019,
    ],
    '160750085085': [
      11.537911796151581, 50.67675963594687, 11.631628892315666, 50.73315662493856,
    ],
    '160750098098': [
      11.675985909609798, 50.515941642021694, 11.944821367381882, 50.60416813692573,
    ],
    '160750131131': [
      11.724555439449274, 50.41312346933932, 11.927704617458105, 50.47396803014092,
    ],
    '160750132132': [
      11.7307931011388, 50.44941779503544, 11.962907709118902, 50.542355179821755,
    ],
    '160750133133': [
      11.478943340263433, 50.37362585125618, 11.592076804637264, 50.52469908812063,
    ],
    '160750134134': [
      11.481005322286299, 50.47992735861219, 11.713992910388553, 50.598315548872876,
    ],
    '160750135135': [
      11.60758236283981, 50.445490810612405, 11.807783404480714, 50.53352209133548,
    ],
    '160750136136': [
      11.548616346563191, 50.38690131974864, 11.767555383598689, 50.45069453507784,
    ],
    '160755004014': [
      11.790087632283948, 50.62860779731353, 11.876066163240184, 50.68738778777711,
    ],
    '160755004033': [
      11.759640989682115, 50.56763299883488, 11.799415269469153, 50.60745420640099,
    ],
    '160755004034': [
      11.829741243924232, 50.61300108895601, 11.893740512021239, 50.64476032285564,
    ],
    '160755004048': [
      11.872747983020567, 50.58589719170894, 11.92222006722602, 50.616834625622616,
    ],
    '160755004063': [
      11.819064885302334, 50.58664246330946, 11.884207001694227, 50.63951596718312,
    ],
    '160755004068': [
      11.790087632283948, 50.65486003832765, 11.85745902499228, 50.68767291241646,
    ],
    '160755004072': [
      11.752723634088188, 50.58945366106556, 11.791196007540162, 50.62860779731353,
    ],
    '160755004076': [
      11.796583211078406, 50.58224955866958, 11.852206197837363, 50.62278865709511,
    ],
    '160755004083': [
      11.744841786248536, 50.622156254485034, 11.795789084352995, 50.65224114492243,
    ],
    '160755004084': [
      11.786099011001397, 50.60451375040153, 11.831677446987282, 50.63229522850262,
    ],
    '160755004109': [
      11.842847169311714, 50.63504498355581, 11.890424668696035, 50.664102547172014,
    ],
    '160755004119': [
      11.707441405646321, 50.596448089683335, 11.759097215828135, 50.633491408041216,
    ],
    '160755005006': [
      11.603844833772072, 50.66317635418024, 11.632708169711114, 50.700947520673,
    ],
    '160755005016': [
      11.631628892315666, 50.68002564257794, 11.657529261019771, 50.70408614031706,
    ],
    '160755005031': [
      11.631581213418619, 50.66317635418024, 11.663921817758506, 50.68649966016815,
    ],
    '160755005039': [
      11.657529261019771, 50.64939986412113, 11.706856493881151, 50.68002564257794,
    ],
    '160755005054': [
      11.544674651234901, 50.7167766942636, 11.691240306301669, 50.76251574481321,
    ],
    '160755005056': [
      11.647065238213772, 50.7139745209851, 11.708735250458304, 50.75330279323777,
    ],
    '160755005074': [
      11.642911065834856, 50.67690794316643, 11.672811329866743, 50.70653067962705,
    ],
    '160755005075': [
      11.670007579419599, 50.67347925047817, 11.702495032062526, 50.70931108904935,
    ],
    '160755005077': [
      11.618031881087333, 50.700947520673, 11.690596124675432, 50.74161913021313,
    ],
    '160755005087': [
      11.691496452034777, 50.66531364071424, 11.721604567875449, 50.69167567862607,
    ],
    '160755005105': [
      11.660432544349305, 50.67690794316643, 11.685679389274293, 50.70653067962705,
    ],
    '160755005121': [
      11.68304492992293, 50.66692038283908, 11.754160742191011, 50.7179992170562,
    ],
    '160755005124': [
      11.583113642998292, 50.64248698740095, 11.631581213418619, 50.683588725737344,
    ],
    '160755011019': [
      11.777892917021946, 50.73381133173536, 11.826690204791772, 50.76148350985378,
    ],
    '160755011029': [
      11.86993275935107, 50.7589460345264, 11.920405507521766, 50.78861837520235,
    ],
    '160755011057': [
      11.816159331021202, 50.69551155396987, 11.855009434917172, 50.73200285623892,
    ],
    '160755011065': [
      11.812018710719808, 50.731491537356625, 11.844555709902806, 50.75593590427038,
    ],
    '160755011066': [
      11.897529823421648, 50.74568163565653, 11.943136626758472, 50.77354227022009,
    ],
    '160755011093': [
      11.777685048103129, 50.752995842800246, 11.826323069299992, 50.78085329824078,
    ],
    '160755011099': [
      11.766243323381838, 50.69799153300247, 11.824733583035439, 50.73683070387065,
    ],
    '160755011114': [
      11.836492356234784, 50.686508172807876, 11.875842543645701, 50.72805905361147,
    ],
    '160755011116': [
      11.762143188177365, 50.72008941022532, 11.904573175441776, 50.7976193962446,
    ],
    '160755013023': [
      11.662239394552808, 50.575493990468374, 11.707522915187939, 50.60363750962641,
    ],
    '160755013035': [
      11.551065064251874, 50.59700198990322, 11.623390772114405, 50.63845232607001,
    ],
    '160755013047': [
      11.64311268306082, 50.62633874814573, 11.677001993708224, 50.64986260044162,
    ],
    '160755013069': [
      11.605772784130554, 50.63227797494958, 11.64842803094082, 50.65288199013486,
    ],
    '160755013079': [
      11.60901744192241, 50.5915452978067, 11.648087731305635, 50.63346647069007,
    ],
    '160755013081': [
      11.613331001521535, 50.64258411432654, 11.683753493540225, 50.667054791306136,
    ],
    '160755013088': [
      11.541756099966726, 50.645154247984244, 11.60037028096974, 50.682867191889486,
    ],
    '160755013101': [
      11.564388833000686, 50.61981781975561, 11.606116024261796, 50.65464877621219,
    ],
    '160755013102': [
      11.657932920544809, 50.59929112749021, 11.717439578145399, 50.638093987991354,
    ],
    '160755013103': [
      11.525291301158022, 50.634369405766506, 11.573465987229238, 50.660607274127756,
    ],
    '160755013125': [
      11.519355000143923, 50.60782031424999, 11.56487205472213, 50.64358801602828,
    ],
    '160755013127': [
      11.633725491357282, 50.589930465301435, 11.683232047606666, 50.63227797494958,
    ],
    '160755013129': [
      11.458065791811922, 50.61993936743978, 11.566384891859448, 50.743319113702114,
    ],
    '160755050051': [
      11.71548290430166, 50.695510790641116, 11.757889242268533, 50.728185122480326,
    ],
    '160755050073': [
      11.66776497381274, 50.61842626978337, 11.84662336806317, 50.79803284061428,
    ],
    '160760022022': [
      12.086450669922097, 50.56626417628588, 12.28010895082527, 50.7117213129359,
    ],
    '160760061061': [
      12.134131924842308, 50.83000468620641, 12.219071068535, 50.88031760344027,
    ],
    '160760088088': [
      11.899946253462218, 50.722906548411366, 12.058286263510299, 50.81212476548986,
    ],
    '160760089089': [
      11.873399954972095, 50.860562311509824, 12.02683971737445, 50.91681127052178,
    ],
    '160760092092': [
      11.866522554146998, 50.65968176260528, 12.034528290635429, 50.74732253376878,
    ],
    '160760093093': [
      12.15377017843684, 50.64431899368791, 12.319122023977151, 50.75640169249546,
    ],
    '160760094094': [
      12.058286263510299, 50.7117213129359, 12.210793007597664, 50.823440537432454,
    ],
    '160765004009': [
      12.205800900656294, 50.78426616342264, 12.25407719014112, 50.80918638659983,
    ],
    '160765004017': [
      12.127675524660528, 50.773217282010755, 12.174651337498126, 50.805138965756356,
    ],
    '160765004019': [
      12.181911963442877, 50.77811872168637, 12.216935197421991, 50.79723371178904,
    ],
    '160765004027': [
      12.134374800268619, 50.811864672792275, 12.189689646285647, 50.83000468620641,
    ],
    '160765004034': [
      12.126714520348472, 50.820079652135256, 12.175356171573675, 50.85820607165897,
    ],
    '160765004043': [
      12.147812026023303, 50.79553878165924, 12.218540333486906, 50.820766835933334,
    ],
    '160765004055': [
      12.1986857838907, 50.83182100540401, 12.256872418424567, 50.86114879794118,
    ],
    '160765004062': [
      12.175356171573675, 50.80435734788928, 12.251852750202536, 50.84093600352107,
    ],
    '160765004069': [
      12.190519829960264, 50.74624153494022, 12.290401681971135, 50.794129811231876,
    ],
    '160765004074': [
      12.068685114005286, 50.74686770693351, 12.10184541422396, 50.76712642754556,
    ],
    '160765006007': [
      11.951293357300584, 50.80226103737149, 11.997663941628279, 50.831820751109866,
    ],
    '160765006033': [
      11.965453328256663, 50.81622767694527, 12.020496650232719, 50.84939065832829,
    ],
    '160765006042': [
      11.892406030238941, 50.78861837520235, 11.939469353427919, 50.810095161961854,
    ],
    '160765006044': [
      11.892634123257505, 50.82642666615339, 11.951108488433213, 50.86100105677228,
    ],
    '160765006049': [
      11.902885433321991, 50.80537303444633, 11.987144913558858, 50.852579213934966,
    ],
    '160765006064': [
      11.946422883121528, 50.84448599591575, 12.015270811126793, 50.8722464965079,
    ],
    '160765006068': [
      11.85889312185831, 50.784826086091805, 11.899946253462218, 50.80361201466687,
    ],
    '160765006086': [
      11.979392278346367, 50.79154127882934, 12.079560772691995, 50.82496388323415,
    ],
    '160765008006': [
      12.172035218829057, 50.921183185398114, 12.213554168832953, 50.935911245526796,
    ],
    '160765008008': [
      12.134377661767656, 50.90954075565265, 12.185415835877718, 50.93443607214028,
    ],
    '160765008023': [
      12.159527460649842, 50.879244364609306, 12.226751785779165, 50.923612679971754,
    ],
    '160765008028': [
      12.165329629186905, 50.93443607214028, 12.201725820819707, 50.95388066866373,
    ],
    '160765008036': [
      12.15263524672129, 50.87369879990445, 12.200824656498492, 50.90066226887936,
    ],
    '160765008058': [
      12.162228851192237, 50.934160299415694, 12.214001127911455, 50.97640752952427,
    ],
    '160765008059': [
      12.2059656428754, 50.910437599517344, 12.249557295392648, 50.94250987699185,
    ],
    '160765008067': [
      12.129540851010061, 50.888636166830686, 12.165803197501042, 50.91234870379833,
    ],
    '160765051003': [
      11.95189440397624, 50.90101457818081, 12.04873408154502, 50.94806469927453,
    ],
    '160765051012': [
      11.957155282527363, 50.93690894207871, 12.006931623553353, 50.95720881115939,
    ],
    '160765053014': [
      12.031324658004593, 50.794126193298666, 12.063593627459769, 50.805316002776344,
    ],
    '160765053079': [
      11.992186374191238, 50.72161349412952, 12.109861310297022, 50.80602134856629,
    ],
    '160765054041': [
      11.91866919183291, 50.620573971326245, 11.973165152752049, 50.6482944635416,
    ],
    '160765054081': [
      11.979485317322691, 50.66499992405577, 12.014060083451808, 50.68721069882008,
    ],
    '160765054087': [
      11.881036125796804, 50.55069022373792, 12.099002593336943, 50.713047156147084,
    ],
    '160765056029': [
      12.031920041970244, 50.68697757657239, 12.07762438635642, 50.72986090240947,
    ],
    '160765056039': [
      12.029095149218115, 50.62399888360527, 12.166668166919424, 50.741846809542984,
    ],
    '160770001001': [
      12.37249817104199, 50.92350628059102, 12.495598778386372, 51.03538385055018,
    ],
    '160770028028': [
      12.280854612136638, 51.0612978502156, 12.36338455737938, 51.10367912242521,
    ],
    '160770032032': [
      12.246234038278187, 51.01576159436256, 12.432551082719657, 51.08391294384259,
    ],
    '160775004005': [
      12.457326920599982, 51.03583459180457, 12.508273834796402, 51.064671447175414,
    ],
    '160775004007': [
      12.416930851881832, 51.02368120905511, 12.454404898003228, 51.04320832335893,
    ],
    '160775004015': [
      12.410076953359843, 51.06332084699935, 12.449330246093231, 51.078057394604286,
    ],
    '160775004048': [
      12.401835792446212, 51.03289627917589, 12.46928210303011, 51.08445050901705,
    ],
    '160775004052': [
      12.447684934556806, 50.993290982214475, 12.540113281694516, 51.04168430833873,
    ],
    '160775005008': [
      12.34043749705753, 50.95407682766879, 12.39532411819836, 50.99169163888169,
    ],
    '160775005009': [
      12.29515700769137, 50.936100108167835, 12.34570062893828, 50.96075557985017,
    ],
    '160775005022': [
      12.282131141204136, 50.99322645840489, 12.353227821660257, 51.0413915958067,
    ],
    '160775005027': [
      12.358433772487052, 50.99055124102528, 12.409759338675698, 51.01092634650373,
    ],
    '160775005031': [
      12.28786566297232, 50.95521422535159, 12.330927552334517, 50.9754420855588,
    ],
    '160775005034': [
      12.324822203665764, 50.9813757282076, 12.374653394733016, 51.01092634650373,
    ],
    '160775005042': [
      12.337731499090046, 51.00114041736594, 12.417481771523967, 51.036778008312076,
    ],
    '160775005044': [
      12.233741146745002, 50.95775025683746, 12.35578179499253, 51.00823255831051,
    ],
    '160775009016': [
      12.246965957268841, 50.8270266900632, 12.287755651027984, 50.85232459799004,
    ],
    '160775009018': [
      12.25166439716826, 50.8112379912455, 12.301526638156432, 50.84472879950822,
    ],
    '160775009026': [
      12.207422128400907, 50.86814863498962, 12.282593517968715, 50.911872785434234,
    ],
    '160775009041': [
      12.217383858181329, 50.850942238609136, 12.280411634147182, 50.87417750885807,
    ],
    '160775009047': [
      12.296133507531978, 50.81893392870181, 12.347142908186106, 50.85164521910744,
    ],
    '160775009049': [
      12.263052469461668, 50.841539436048514, 12.312730948533204, 50.86517748048791,
    ],
    '160775050012': [
      12.396507427510775, 50.862312427418516, 12.485205811430557, 50.90161876465626,
    ],
    '160775050017': [
      12.33646650036971, 50.837089245662, 12.370638928478254, 50.86000202059266,
    ],
    '160775050039': [
      12.353508201801999, 50.83922875460781, 12.44626708635231, 50.8771873648987,
    ],
    '160775051011': [
      12.584377083407976, 50.90397766856578, 12.620074675627952, 50.93037942674321,
    ],
    '160775051023': [
      12.50536603921702, 50.93679122125267, 12.625753064325554, 50.998703770079885,
    ],
    '160775051036': [
      12.378624667339807, 50.884214396845366, 12.65268124416374, 51.00607398636144,
    ],
    '160775052003': [
      12.25956011611974, 50.926337739573746, 12.305114197151918, 50.96786704058774,
    ],
    '160775052043': [
      12.224225805165016, 50.846531719309525, 12.41038866111446, 50.960385540685024,
    ],
  },
  // DE-LOKALBEHOERDE-END
}
